import React, {
  useEffect,
  useState,
  useCallback,
  useMemo,
  useRef,
} from "react";
import { createPortal } from "react-dom";
import PerfectScrollbar from "react-perfect-scrollbar";
import { Link, useLocation } from "react-router-dom";
import DateRangePicker from "react-bootstrap-daterangepicker";
import Moment from "moment";
import { PDFDocument, rgb, StandardFonts } from "pdf-lib"; //new
import SignaturePad from "signature_pad"; //new
import "bootstrap-daterangepicker/daterangepicker.css";
import {
  Card,
  CardGroup,
  CardBody,
  CardHeader,
  CardHeaderBtn,
} from "./../../components/card/card.jsx";
import Swal from "sweetalert2";
import { Circles } from "react-loader-spinner";
import "moment/locale/es";
import Select from "react-select";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";
import { Modal, Button } from "bootstrap";

import * as pdfjsLib from "pdfjs-dist/build/pdf";
import pdfjsWorker from "pdfjs-dist/build/pdf.worker.entry";
import { Document, Page, pdfjs } from "react-pdf";
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";

import {
  PieChart,
  Pie,
  Cell,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  LineChart,
  Line,
  ResponsiveContainer,
} from "recharts"; //nueva

pdfjs.GlobalWorkerOptions.workerSrc = pdfjsWorker;
pdfjsLib.GlobalWorkerOptions.workerSrc = pdfjsWorker;

const PDF_DOCUMENT_OPTIONS = {
  disableRange: true,
  disableStream: true,
  disableAutoFetch: true,
};

const getPdfRenderQualityMultiplier = (pageWidth = 800) => {
  if (typeof window === "undefined") return 3;

  const isIOS =
    /iPad|iPhone|iPod/.test(window.navigator.userAgent) ||
    (window.navigator.platform === "MacIntel" &&
      window.navigator.maxTouchPoints > 1);

  // El zoom libre agranda un canvas. Para que no se vea borroso,
  // renderizamos el canvas más grande y lo mostramos reducido por CSS.
  // Desktop aguanta más resolución; iPad/Safari necesita un límite menor.
  const preferredMultiplier = isIOS ? 2.5 : 4;
  const estimatedHeight = pageWidth * 1.42;
  const maxCanvasPixels = isIOS ? 12000000 : 32000000;
  const maxByPixels = Math.sqrt(
    maxCanvasPixels / Math.max(pageWidth * estimatedHeight, 1),
  );

  return Math.max(2, Math.min(preferredMultiplier, maxByPixels));
};

const isPdfWorkerAbortError = (error) => {
  const message = String(
    error?.message ||
      error?.reason?.message ||
      error?.reason ||
      error?.target?.message ||
      error ||
      "",
  ).toLowerCase();

  return (
    message.includes("worker was terminated") ||
    message.includes("terminated") ||
    message.includes("destroyed") ||
    message.includes("cancelled") ||
    message.includes("canceled") ||
    message.includes("loading aborted")
  );
};

// Cierra TODOS los modales de Bootstrap que estén abiertos,
// limpia backdrop y quita la clase modal-open del <body>
// Cierra TODOS los modales de forma robusta (con fallback y doble pasada)
// Utilidad segura para cerrar TODOS los modales, con/ sin Bootstrap global
async function forceCloseAllModals(
  options = { dispose: true, timeoutMs: 200 },
) {
  const { dispose, timeoutMs } = options;
  const hasBs = !!(window.bootstrap && window.bootstrap.Modal);

  const hardClose = () => {
    // 1) Oculta cualquier .modal
    document.querySelectorAll(".modal").forEach((el) => {
      el.classList.remove("show");
      el.setAttribute("aria-hidden", "true");
      el.style.display = "none";
      el.removeAttribute("aria-modal");
    });
    // 2) Borra backdrops
    document.querySelectorAll(".modal-backdrop").forEach((b) => b.remove());
    // 3) Limpia body
    document.body.classList.remove("modal-open");
    document.body.style.removeProperty("padding-right");
    document.body.style.removeProperty("overflow");
  };

  if (!hasBs) {
    // No hay Bootstrap global → cierre por DOM solamente
    hardClose();
    await new Promise((r) => requestAnimationFrame(r));
    hardClose();
    return;
  }

  // --- Con Bootstrap global disponible, intenta cerrar “bonito” ---
  try {
    const modals = Array.from(document.querySelectorAll(".modal.show"));

    if (modals.length) {
      await Promise.all(
        modals.map(
          (el) =>
            new Promise((resolve) => {
              try {
                const inst = window.bootstrap.Modal.getOrCreateInstance(el);
                const onHidden = () => {
                  el.removeEventListener("hidden.bs.modal", onHidden);
                  resolve();
                };
                el.addEventListener("hidden.bs.modal", onHidden, {
                  once: true,
                });
                inst.hide();
                // safety timeout por si no dispara el evento
                setTimeout(() => {
                  try {
                    el.removeEventListener("hidden.bs.modal", onHidden);
                  } catch {}
                  resolve();
                }, timeoutMs);
              } catch {
                resolve();
              }
            }),
        ),
      );
    }
  } catch {
    // ignore
  }

  // Limpieza final de residuos
  hardClose();

  if (dispose && hasBs) {
    try {
      document.querySelectorAll(".modal").forEach((el) => {
        const inst = window.bootstrap.Modal.getInstance(el);
        if (inst?.dispose) inst.dispose();
      });
    } catch {}
  }

  await new Promise((r) => requestAnimationFrame(r));
  hardClose();
}

const PDFAllPages = ({ url }) => {
  const wrapRef = useRef(null);
  const [width, setWidth] = useState(0);
  const [numPages, setNumPages] = useState(0);

  useEffect(() => {
    const ro = new ResizeObserver((entries) => {
      if (entries[0]) setWidth(entries[0].contentRect.width);
    });
    if (wrapRef.current) ro.observe(wrapRef.current);
    return () => ro.disconnect();
  }, []);

  return (
    <div ref={wrapRef} style={{ width: "min(100%, 1200px)", margin: "0 auto" }}>
      <Document
        file={url}
        options={PDF_DOCUMENT_OPTIONS}
        onLoadSuccess={({ numPages }) => setNumPages(numPages)}
      >
        {Array.from({ length: numPages }, (_, i) => (
          <Page
            key={i}
            pageNumber={i + 1}
            width={Math.max(320, Math.min(1200, width || 800))}
          />
        ))}
      </Document>
    </div>
  );
};

const normalizePdfSectionText = (value = "") =>
  String(value || "")
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/\s+/g, " ")
    .trim();

const PDF_SECTION_RULES = [
  {
    key: "especificaciones",
    label: "Especificaciones",
    patterns: [
      /^especificaciones(\s|$)/i,
      /^especificaciones tecnicas(\s|$)/i,
      /^ficha tecnica(\s|$)/i,
    ],
  },
  {
    key: "versiones",
    label: "Versiones",
    patterns: [/^versiones(\s|$)/i, /^version(\s|$)/i],
  },
  {
    key: "equipamiento",
    label: "Equipamiento",
    patterns: [
      /^equipamiento(\s|$)/i,
      /^equipamientos(\s|$)/i,
      /^equipamiento y seguridad(\s|$)/i,
      /^equipamiento exterior(\s|$)/i,
      /^equipamiento interior(\s|$)/i,
    ],
  },
  {
    key: "seguridad",
    label: "Seguridad",
    patterns: [/^seguridad(\s|$)/i, /^nissan safety shield(\s|$)/i],
  },
  {
    key: "tecnologia",
    label: "Tecnología",
    patterns: [
      /^tecnologia(\s|$)/i,
      /^tecnologias(\s|$)/i,
      /^multimedia(\s|$)/i,
      /^conectividad(\s|$)/i,
      /^nissanconnect(\s|$)/i,
    ],
  },
  {
    key: "motor",
    label: "Motor",
    patterns: [/^motor(\s|$)/i, /^motorizacion(\s|$)/i, /^desempeno(\s|$)/i],
  },
  {
    key: "dimensiones",
    label: "Dimensiones",
    patterns: [/^dimensiones(\s|$)/i, /^capacidades(\s|$)/i],
  },
  {
    key: "interiores",
    label: "Interiores",
    patterns: [/^interiores(\s|$)/i, /^interior(\s|$)/i, /^confort(\s|$)/i],
  },
  {
    key: "exteriores",
    label: "Exteriores",
    patterns: [/^exteriores(\s|$)/i, /^exterior(\s|$)/i, /^diseno(\s|$)/i],
  },
  {
    key: "rines",
    label: "Rines",
    patterns: [/^rines?(\s|$)/i, /^rin(es)?(\s|$)/i],
  },
  {
    key: "colores",
    label: "Colores",
    patterns: [/^colores(\s|$)/i, /^gama de colores(\s|$)/i],
  },
  {
    key: "accesorios",
    label: "Accesorios",
    patterns: [/^accesorios(\s|$)/i],
  },
];

const groupPdfTextIntoLines = (items, yTolerance = 2.5) => {
  const lines = [];

  for (const item of items) {
    const y = item.y;
    let line = lines.find((current) => Math.abs(current.y - y) <= yTolerance);

    if (!line) {
      line = { y, parts: [] };
      lines.push(line);
    }

    line.parts.push(item);
  }

  lines.sort((a, b) => b.y - a.y);

  return lines.map((line) => {
    line.parts.sort((a, b) => a.x - b.x);

    const text = line.parts.map((part) => part.str).join(" ");
    const maxFont = Math.max(...line.parts.map((part) => part.fontH || 0));

    return {
      text,
      ntext: normalizePdfSectionText(text),
      maxFont,
      y: line.y,
    };
  });
};

const detectPdfSectionsFromDocument = async (pdf, totalPages = 0) => {
  if (!pdf || !totalPages) return {};

  const scores = {};
  PDF_SECTION_RULES.forEach((rule) => {
    scores[rule.key] = new Map();
  });

  const testRule = (patterns, text) =>
    patterns.some((rx) => {
      const rxNorm = new RegExp(
        rx.source
          .toLowerCase()
          .normalize("NFD")
          .replace(/[\u0300-\u036f]/g, ""),
        rx.flags,
      );

      return rxNorm.test(text);
    });

  for (let pageIndex = 0; pageIndex < totalPages; pageIndex += 1) {
    const page = await pdf.getPage(pageIndex + 1);
    const viewport = page.getViewport({ scale: 1 });
    const content = await page.getTextContent({
      normalizeWhitespace: true,
      disableCombineTextItems: false,
    });

    const items = content.items
      .map((item) => {
        const str = String(item.str || "").trim();
        if (!str) return null;

        return {
          str,
          x: item.transform?.[4] ?? 0,
          y: item.transform?.[5] ?? 0,
          fontH: Math.abs(item.transform?.[3] ?? 0),
        };
      })
      .filter(Boolean);

    if (!items.length) continue;

    const fullText = normalizePdfSectionText(
      items.map((item) => item.str).join(" "),
    );
    const topThreshold = viewport.height * 0.58;
    const headerItems = items.filter((item) => item.y >= topThreshold);

    const fontHeights = items
      .map((item) => item.fontH)
      .filter(Boolean)
      .sort((a, b) => a - b);

    const q85 = fontHeights[Math.floor(fontHeights.length * 0.85)] || 0;
    const bigFontItems = items.filter(
      (item) => item.fontH >= q85 && item.fontH > 0,
    );
    const candidateItems = [...headerItems, ...bigFontItems];
    const topLines = groupPdfTextIntoLines(candidateItems).slice(0, 12);

    for (const rule of PDF_SECTION_RULES) {
      let bestScoreOnPage = scores[rule.key].get(pageIndex) || 0;

      for (const line of topLines) {
        if (!testRule(rule.patterns, line.ntext)) continue;

        let score = 10;

        if (line.y >= viewport.height * 0.85) score += 4;
        else score += 2;

        if (line.maxFont >= q85) score += 3;

        if (score > bestScoreOnPage) {
          bestScoreOnPage = score;
          scores[rule.key].set(pageIndex, score);
        }
      }

      if (bestScoreOnPage === 0 && testRule(rule.patterns, fullText)) {
        scores[rule.key].set(pageIndex, 5);
      }
    }
  }

  const resultado = {};

  for (const rule of PDF_SECTION_RULES) {
    const pages = [...scores[rule.key].entries()]
      .filter(([, score]) => score >= 6)
      .sort((a, b) => a[0] - b[0])
      .map(([pageIndex]) => pageIndex);

    if (pages.length) {
      resultado[rule.label] = [...new Set(pages)];
    }
  }

  if (!Object.keys(resultado).length) {
    resultado.Páginas = Array.from({ length: totalPages }, (_, index) => index);
  }

  return resultado;
};

function VisorFichaTecnica({
  url,
  onClose,
  selectedMailData,
  showFotosButton = false,
  onOpenFotos,
  loadingFotos = false,
}) {
  const [numPages, setNumPages] = useState(null);
  const [paginaActual, setPaginaActual] = useState(1);
  const [secciones, setSecciones] = useState({});
  const [seccionActiva, setSeccionActiva] = useState(null);
  const [expandido, setExpandido] = useState({});
  const [viewerWidth, setViewerWidth] = useState(0);
  const [cargando, setCargando] = useState(true);
  const [pageLoading, setPageLoading] = useState(false);
  const [pdfError, setPdfError] = useState("");
  const [reloadKey, setReloadKey] = useState(0);

  const contenedorRef = useRef(null);
  const botonesRef = useRef(null);
  const transformRef = useRef(null);
  const mountedRef = useRef(false);
  const sectionRunIdRef = useRef(0);
  const pageLoadingTimerRef = useRef(null);
  const loadedDocumentKeyRef = useRef("");

  const documentKey = useMemo(
    () => `${url || "sin-url"}-${reloadKey}`,
    [url, reloadKey],
  );

  const puedeVerFotosSeminuevo = Boolean(showFotosButton && onOpenFotos);

  const pageWidth = useMemo(() => {
    const available = Number(viewerWidth || 0) - 78;
    if (!Number.isFinite(available) || available <= 0) return 800;
    return Math.max(320, Math.min(1120, available));
  }, [viewerWidth]);

  const pdfRenderQuality = useMemo(() => {
    return getPdfRenderQualityMultiplier(pageWidth);
  }, [pageWidth]);

  const pdfRenderWidth = useMemo(() => {
    return Math.round(pageWidth * pdfRenderQuality);
  }, [pageWidth, pdfRenderQuality]);

  const clearPageLoadingTimer = useCallback(() => {
    if (pageLoadingTimerRef.current) {
      clearTimeout(pageLoadingTimerRef.current);
      pageLoadingTimerRef.current = null;
    }
  }, []);

  const finishPageLoading = useCallback(() => {
    if (!mountedRef.current) return;
    clearPageLoadingTimer();
    setPageLoading(false);
  }, [clearPageLoadingTimer]);

  const startPageLoading = useCallback(() => {
    if (!mountedRef.current) return;

    clearPageLoadingTimer();
    setPageLoading(true);

    // Fallback: algunas páginas ya vienen cacheadas y react-pdf a veces no
    // dispara onRenderSuccess. Esto evita que el loader se quede pegado.
    pageLoadingTimerRef.current = setTimeout(() => {
      if (mountedRef.current) {
        setPageLoading(false);
      }
      pageLoadingTimerRef.current = null;
    }, 1600);
  }, [clearPageLoadingTimer]);

  const resetFreeZoom = useCallback((delayMs = 0) => {
    const runReset = () => {
      try {
        transformRef.current?.resetTransform?.();
      } catch {}
    };

    if (delayMs > 0) {
      setTimeout(runReset, delayMs);
    } else {
      requestAnimationFrame(runReset);
    }
  }, []);

  useEffect(() => {
    mountedRef.current = true;

    return () => {
      mountedRef.current = false;
      sectionRunIdRef.current += 1;
      clearPageLoadingTimer();
    };
  }, [clearPageLoadingTimer]);

  useEffect(() => {
    sectionRunIdRef.current += 1;
    loadedDocumentKeyRef.current = "";
    setNumPages(null);
    setPaginaActual(1);
    setSecciones({});
    setSeccionActiva(null);
    setExpandido({});
    setPdfError("");
    setCargando(Boolean(url));
    setPageLoading(false);
    resetFreeZoom(80);
  }, [url, resetFreeZoom]);

  useEffect(() => {
    if (!contenedorRef.current) return;

    const resizeObserver = new ResizeObserver((entries) => {
      const entry = entries?.[0];
      if (!entry) return;
      const width = entry.contentRect?.width || 0;
      setViewerWidth(width);
    });

    resizeObserver.observe(contenedorRef.current);

    return () => resizeObserver.disconnect();
  }, []);

  useEffect(() => {
    if (!pageLoading) return undefined;

    const fallbackTimer = setTimeout(() => {
      if (mountedRef.current) {
        setPageLoading(false);
      }
    }, 1800);

    return () => clearTimeout(fallbackTimer);
  }, [pageLoading, paginaActual, documentKey]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (botonesRef.current && !botonesRef.current.contains(event.target)) {
        setExpandido({});
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleDocumentLoadSuccess = useCallback(
    (pdf) => {
      if (!mountedRef.current) return;

      const totalPages = Number(pdf?.numPages || 0);
      const isFirstLoadForDocument =
        loadedDocumentKeyRef.current !== documentKey;
      loadedDocumentKeyRef.current = documentKey;
      const runId = ++sectionRunIdRef.current;

      setNumPages(totalPages);

      if (isFirstLoadForDocument) {
        setPaginaActual(1);
        resetFreeZoom(80);
      }

      setCargando(false);
      setPageLoading(false);
      setPdfError("");
      setSecciones((prev) =>
        Object.keys(prev || {}).length
          ? prev
          : {
              Páginas: Array.from({ length: totalPages }, (_, index) => index),
            },
      );

      (async () => {
        try {
          const detectedSections = await detectPdfSectionsFromDocument(
            pdf,
            totalPages,
          );

          if (!mountedRef.current || sectionRunIdRef.current !== runId) return;

          setSecciones(detectedSections);
        } catch (error) {
          if (isPdfWorkerAbortError(error)) return;
          console.warn("No se pudieron detectar secciones del PDF:", error);
        }
      })();
    },
    [documentKey, resetFreeZoom],
  );

  const handleDocumentLoadError = useCallback(
    (error) => {
      if (!mountedRef.current) return;

      if (isPdfWorkerAbortError(error)) {
        finishPageLoading();
        return;
      }

      console.error("Error cargando ficha técnica:", error);
      setCargando(false);
      setPageLoading(false);
      setPdfError(
        "No se pudo cargar la ficha técnica. Intenta abrirla nuevamente o revisa que el PDF exista.",
      );
    },
    [finishPageLoading],
  );

  const handlePageLoadSuccess = useCallback(() => {
    finishPageLoading();
  }, [finishPageLoading]);

  const handlePageRenderSuccess = useCallback(() => {
    finishPageLoading();
  }, [finishPageLoading]);

  const handlePageLoadError = useCallback(
    (error) => {
      if (isPdfWorkerAbortError(error)) {
        finishPageLoading();
        return;
      }
      handleDocumentLoadError(error);
    },
    [finishPageLoading, handleDocumentLoadError],
  );

  const handleClose = useCallback(
    (event) => {
      event?.preventDefault?.();
      event?.stopPropagation?.();
      mountedRef.current = false;
      sectionRunIdRef.current += 1;
      clearPageLoadingTimer();
      onClose?.();
    },
    [clearPageLoadingTimer, onClose],
  );

  const retryLoadPdf = () => {
    mountedRef.current = true;
    sectionRunIdRef.current += 1;
    loadedDocumentKeyRef.current = "";
    clearPageLoadingTimer();
    setPdfError("");
    setCargando(true);
    setPageLoading(false);
    setNumPages(null);
    setPaginaActual(1);
    setReloadKey((prev) => prev + 1);
  };

  const irAPaginaDirecta = useCallback(
    (pagina) => {
      const nextPage = Math.min(Math.max(Number(pagina), 1), numPages || 1);

      if (nextPage === paginaActual) {
        finishPageLoading();
        resetFreeZoom();
        return;
      }

      startPageLoading();
      setPaginaActual(nextPage);
      resetFreeZoom(80);
    },
    [
      finishPageLoading,
      numPages,
      paginaActual,
      resetFreeZoom,
      startPageLoading,
    ],
  );

  const irAPagina = useCallback(
    (pagina) => {
      irAPaginaDirecta(Number(pagina) + 1);
    },
    [irAPaginaDirecta],
  );

  const toggleExpandido = (seccion) => {
    setExpandido((prev) => {
      const nuevoEstado = {};

      Object.keys(prev).forEach((key) => {
        nuevoEstado[key] = false;
      });

      nuevoEstado[seccion] = !prev[seccion];

      return nuevoEstado;
    });
  };

  return (
    <>
      <style>{`
        .ficha-tecnica-modal .pdf-page-hd-wrap {
          max-width: 100% !important;
        }

        .ficha-tecnica-modal .pdf-page-hd-wrap .react-pdf__Page {
          width: 100% !important;
          max-width: 100% !important;
          background: transparent !important;
        }

        .ficha-tecnica-modal .pdf-page-hd-wrap .react-pdf__Page__canvas {
          width: 100% !important;
          height: auto !important;
          max-width: 100% !important;
          display: block !important;
          image-rendering: auto !important;
          transform: translateZ(0);
        }

        .ficha-tecnica-modal .react-pdf__Page {
          background: transparent !important;
        }
      `}</style>

      <div className="modal-backdrop fade show" style={{ zIndex: 1040 }} />

      <div
        className="modal fade show d-block ficha-tecnica-modal"
        tabIndex="-1"
        style={{ zIndex: 1050 }}
      >
        <div className="modal-dialog modal-fullscreen">
          <div className="modal-content">
            <div
              className="modal-header position-relative d-flex align-items-center justify-content-between flex-wrap gap-2"
              style={{ minHeight: 58 }}
            >
              <div
                className="d-flex align-items-center gap-2 flex-wrap"
                style={{ minWidth: 0, zIndex: 2 }}
              >
                <h4 className="modal-title mb-0">Ficha Técnica</h4>

                {puedeVerFotosSeminuevo && (
                  <button
                    type="button"
                    className="btn btn-sm btn-dark d-flex align-items-center gap-1 shadow-sm"
                    onClick={onOpenFotos}
                    disabled={loadingFotos}
                    title="Ver fotos del seminuevo"
                    style={{
                      whiteSpace: "nowrap",
                      fontSize: 12,
                      padding: "4px 10px",
                      lineHeight: 1.2,
                    }}
                  >
                    <span>
                      {loadingFotos ? "Cargando fotos..." : "Ver fotos"}
                    </span>
                  </button>
                )}
              </div>

              <div
                className="d-flex gap-2 flex-wrap ms-auto align-items-center"
                ref={botonesRef}
                style={{ zIndex: 2 }}
              >
                {!pdfError &&
                  Object.entries(secciones).map(([seccion, paginas]) => (
                    <div key={seccion} style={{ position: "relative" }}>
                      <button
                        type="button"
                        className={`tab-button btn btn-sm btn-ficha ${
                          seccionActiva === seccion
                            ? "active"
                            : "btn-outline-primary"
                        }`}
                        onClick={() => {
                          toggleExpandido(seccion);
                          setSeccionActiva(seccion);
                        }}
                      >
                        {seccion}
                      </button>

                      {expandido[seccion] && (
                        <div className="secction-ext">
                          {paginas.map((pagina) => (
                            <button
                              key={`${seccion}-${pagina}`}
                              type="button"
                              className="btn btn-pg btn-outline-secondary btn-sm"
                              onClick={() => {
                                irAPagina(pagina);
                                setExpandido((prev) => ({
                                  ...prev,
                                  [seccion]: false,
                                }));
                              }}
                            >
                              {`pág. ${pagina + 1}`}
                            </button>
                          ))}
                        </div>
                      )}
                    </div>
                  ))}
              </div>

              <button
                type="button"
                className="btn-close"
                onClick={handleClose}
                style={{ pointerEvents: "auto", zIndex: 5 }}
              />
            </div>

            <div className="flex-grow-1 d-flex" style={{ minHeight: 0 }}>
              <div className="flex-grow-1 d-flex" style={{ minWidth: 0 }}>
                <div
                  ref={contenedorRef}
                  style={{
                    position: "relative",
                    width: "100%",
                    height: "100%",
                    overflow: "hidden",
                    background: "#f8f9fa",
                    touchAction: "none",
                  }}
                >
                  {(cargando || pageLoading) && !pdfError && (
                    <div
                      style={{
                        position: "fixed",
                        inset: 0,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        background: "rgba(255,255,255,.65)",
                        zIndex: 1065,
                        pointerEvents: "none",
                      }}
                    >
                      <Circles height="80" width="80" color="#4fa94d" />
                    </div>
                  )}

                  {pdfError ? (
                    <div
                      className="alert alert-warning text-center mx-auto mt-4"
                      style={{ maxWidth: 620 }}
                    >
                      <h5 className="mb-2">No se pudo abrir el PDF</h5>
                      <p className="mb-3">{pdfError}</p>

                      <div className="d-flex justify-content-center gap-2 flex-wrap">
                        <button
                          type="button"
                          className="btn btn-primary"
                          onClick={retryLoadPdf}
                        >
                          Reintentar
                        </button>
                        <button
                          type="button"
                          className="btn btn-primary"
                          onClick={handleClose}
                        >
                          Cerrar
                        </button>
                      </div>
                    </div>
                  ) : (
                    <TransformWrapper
                      key={`transform-${documentKey}`}
                      ref={transformRef}
                      initialScale={1}
                      minScale={0.7}
                      maxScale={4}
                      centerOnInit
                      centerZoomedOut
                      limitToBounds={false}
                      wheel={{ disabled: false, step: 0.12, smoothStep: 0.003 }}
                      pinch={{ disabled: false, step: 5 }}
                      panning={{ disabled: false, velocityDisabled: true }}
                      doubleClick={{ disabled: false, mode: "reset" }}
                    >
                      <TransformComponent
                        wrapperStyle={{
                          width: "100%",
                          height: "100%",
                          overflow: "hidden",
                          touchAction: "none",
                        }}
                        contentStyle={{
                          width: "100%",
                          minHeight: "100%",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "flex-start",
                          padding: 18,
                          touchAction: "none",
                        }}
                      >
                        <Document
                          key={documentKey}
                          file={url}
                          options={PDF_DOCUMENT_OPTIONS}
                          loading={null}
                          error={null}
                          onLoadSuccess={handleDocumentLoadSuccess}
                          onLoadError={handleDocumentLoadError}
                          onSourceError={handleDocumentLoadError}
                        >
                          {numPages && (
                            <div
                              className="pdf-page-hd-wrap"
                              style={{ width: pageWidth, maxWidth: "100%" }}
                            >
                              <Page
                                key={`${documentKey}-${paginaActual}-${pdfRenderWidth}`}
                                pageNumber={paginaActual}
                                width={pdfRenderWidth}
                                devicePixelRatio={1}
                                renderAnnotationLayer={false}
                                renderTextLayer={false}
                                loading={null}
                                error={null}
                                className="pdf-page-hd"
                                onLoadSuccess={handlePageLoadSuccess}
                                onRenderSuccess={handlePageRenderSuccess}
                                onLoadError={handlePageLoadError}
                                onRenderError={handlePageLoadError}
                              />
                            </div>
                          )}
                        </Document>
                      </TransformComponent>
                    </TransformWrapper>
                  )}
                </div>
              </div>

              {!pdfError && (
                <div className="d-none d-md-block" style={{ height: "100%" }}>
                  <PDFThumbsReel
                    url={url}
                    numPages={numPages}
                    paginaActual={paginaActual}
                    documentKey={documentKey}
                    onGoToPage={irAPaginaDirecta}
                    onLoadError={handleDocumentLoadError}
                  />
                </div>
              )}
            </div>

            {!pdfError && (
              <div className="d-flex flex-row justify-content-center justify-content-sm-between align-items-center py-2 border-top flex-wrap">
                <button
                  type="button"
                  className="btn-prev btn btn-sm btn-outline-secondary me-3"
                  onClick={() =>
                    irAPaginaDirecta(Math.max(paginaActual - 1, 1))
                  }
                  disabled={paginaActual <= 1 || cargando}
                >
                  ← Anterior
                </button>

                <span className="pag-section mx-3">
                  {paginaActual} / {numPages || "..."}
                </span>

                <button
                  type="button"
                  className="btn-prev btn btn-sm btn-outline-secondary ms-3"
                  onClick={() =>
                    irAPaginaDirecta(
                      Math.min(paginaActual + 1, numPages || paginaActual),
                    )
                  }
                  disabled={!numPages || paginaActual >= numPages || cargando}
                >
                  Siguiente →
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
}

function usePDFSecciones() {
  return {
    secciones: {},
    buscarSecciones: () => {},
  };
}

function PDFThumbsReel({
  url,
  numPages,
  paginaActual,
  documentKey,
  onGoToPage,
  onLoadError,
}) {
  const wrapRef = useRef(null);
  const itemRefs = useRef({});
  const [thumbError, setThumbError] = useState(false);

  useEffect(() => {
    setThumbError(false);
  }, [url]);

  useEffect(() => {
    const wrap = wrapRef.current;
    const el = itemRefs.current[paginaActual];

    if (wrap && el) {
      const nextTop =
        el.offsetTop - wrap.clientHeight / 2 + el.clientHeight / 2;
      wrap.scrollTo({ top: Math.max(nextTop, 0), behavior: "smooth" });
    }
  }, [paginaActual]);

  if (!url || !numPages || thumbError) return null;

  const handleThumbError = (error) => {
    if (isPdfWorkerAbortError(error)) return;
    console.warn("No se pudo cargar una miniatura del PDF:", error);
    setThumbError(true);
    onLoadError?.(error);
  };

  return (
    <div
      ref={wrapRef}
      style={{
        width: 185,
        minWidth: 185,
        borderLeft: "1px solid rgba(0,0,0,.08)",
        height: "100%",
        overflowY: "auto",
        padding: 10,
        background: "#fff",
      }}
    >
      <Document
        key={`thumbs-${documentKey}`}
        file={url}
        options={PDF_DOCUMENT_OPTIONS}
        loading={null}
        error={null}
        onLoadError={handleThumbError}
        onSourceError={handleThumbError}
      >
        {Array.from({ length: numPages }, (_, i) => {
          const pageNum = i + 1;
          const active = pageNum === paginaActual;

          return (
            <button
              key={pageNum}
              type="button"
              ref={(node) => (itemRefs.current[pageNum] = node)}
              onClick={() => onGoToPage(pageNum)}
              style={{
                width: "100%",
                cursor: "pointer",
                marginBottom: 12,
                padding: 7,
                borderRadius: 12,
                position: "relative",
                border: active
                  ? "2px solid #0d6efd"
                  : "1px solid rgba(0,0,0,.12)",
                boxShadow: active
                  ? "0 0 0 3px rgba(13,110,253,.12)"
                  : "0 2px 8px rgba(0,0,0,.06)",
                background: active ? "rgba(13,110,253,.04)" : "#fff",
                display: "block",
                color: active ? "#0d6efd" : "#555",
              }}
            >
              <div
                style={{
                  position: "absolute",
                  top: 8,
                  left: 8,
                  zIndex: 2,
                  width: 28,
                  height: 28,
                  borderRadius: "50%",
                  background: active ? "#0d6efd" : "#212529",
                  color: "#fff",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize: 12,
                  fontWeight: 700,
                  boxShadow: "0 2px 6px rgba(0,0,0,.25)",
                }}
              >
                {pageNum}
              </div>

              <div style={{ pointerEvents: "none" }}>
                <Page
                  pageNumber={pageNum}
                  width={145}
                  devicePixelRatio={1.5}
                  renderAnnotationLayer={false}
                  renderTextLayer={false}
                  loading={null}
                  error={null}
                  onLoadError={handleThumbError}
                  onRenderError={handleThumbError}
                />
              </div>

              <div
                style={{
                  marginTop: 7,
                  fontSize: 12,
                  textAlign: "center",
                  fontWeight: active ? 700 : 500,
                  color: active ? "#0d6efd" : "#555",
                }}
              >
                Página {pageNum} de {numPages}
              </div>
            </button>
          );
        })}
      </Document>
    </div>
  );
}

function GaleriaFotosSeminuevo({
  images = [],
  title = "Fotos del seminuevo",
  initialIndex = 0,
  onClose,
}) {
  const safeImages = useMemo(() => {
    const normalizeImage = (item) => {
      if (!item) return "";
      if (typeof item === "string") return item;
      return item.url || item.src || item.large || item.thumb || "";
    };

    const cleaned = images
      .map(normalizeImage)
      .map((url) => String(url || "").trim())
      .filter(Boolean);

    return cleaned.length ? cleaned : ["/assets/img/product/noimage.png"];
  }, [images]);

  const galleryTransformRef = useRef(null);
  const thumbsRef = useRef(null);

  const [activeIndex, setActiveIndex] = useState(() =>
    Math.min(Math.max(Number(initialIndex) || 0, 0), safeImages.length - 1),
  );

  useEffect(() => {
    setActiveIndex(
      Math.min(Math.max(Number(initialIndex) || 0, 0), safeImages.length - 1),
    );
  }, [initialIndex, safeImages.length]);

  useEffect(() => {
    const html = document.documentElement;
    const previousBodyOverflow = document.body.style.overflow;
    const previousHtmlOverflow = html.style.overflow;

    document.body.style.overflow = "hidden";
    html.style.overflow = "hidden";

    const handleKeyDown = (event) => {
      if (event.key === "Escape") {
        onClose?.();
      }

      if (event.key === "ArrowLeft") {
        setActiveIndex((prev) =>
          prev <= 0 ? safeImages.length - 1 : prev - 1,
        );
      }

      if (event.key === "ArrowRight") {
        setActiveIndex((prev) =>
          prev >= safeImages.length - 1 ? 0 : prev + 1,
        );
      }
    };

    document.addEventListener("keydown", handleKeyDown);

    return () => {
      document.removeEventListener("keydown", handleKeyDown);
      document.body.style.overflow = previousBodyOverflow;
      html.style.overflow = previousHtmlOverflow;
    };
  }, [onClose, safeImages.length]);

  const activeImage = safeImages[activeIndex] || safeImages[0];
  const hasMultipleImages = safeImages.length > 1;

  useEffect(() => {
    requestAnimationFrame(() => {
      try {
        galleryTransformRef.current?.resetTransform?.();
      } catch {}
    });
  }, [activeImage]);

  useEffect(() => {
    const strip = thumbsRef.current;
    if (!strip) return;

    const activeThumb = strip.querySelector(
      `[data-gallery-thumb="${activeIndex}"]`,
    );

    if (activeThumb?.scrollIntoView) {
      activeThumb.scrollIntoView({
        behavior: "smooth",
        inline: "center",
        block: "nearest",
      });
    }
  }, [activeIndex]);

  const goPrev = () => {
    setActiveIndex((prev) => (prev <= 0 ? safeImages.length - 1 : prev - 1));
  };

  const goNext = () => {
    setActiveIndex((prev) => (prev >= safeImages.length - 1 ? 0 : prev + 1));
  };

  const zoomIn = () => {
    try {
      galleryTransformRef.current?.zoomIn?.(0.35);
    } catch {}
  };

  const zoomOut = () => {
    try {
      galleryTransformRef.current?.zoomOut?.(0.35);
    } catch {}
  };

  const resetZoom = () => {
    try {
      galleryTransformRef.current?.resetTransform?.();
    } catch {}
  };

  const galleryTitle = String(title || "").trim() || "Fotos del seminuevo";
  const galleryButtonStyle = {
    minWidth: 40,
    height: 34,
    border: "1px solid rgba(15,23,42,.25)",
    borderRadius: 9,
    background: "#ffffff",
    color: "#111827",
    fontSize: 14,
    fontWeight: 800,
    lineHeight: 1,
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    boxShadow: "0 1px 3px rgba(0,0,0,.12)",
  };
  const galleryCloseButtonStyle = {
    height: 34,
    border: "0",
    borderRadius: 9,
    background: "#0b3b75",
    color: "#ffffff",
    fontSize: 13,
    fontWeight: 800,
    padding: "0 12px",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    gap: 7,
    boxShadow: "0 2px 6px rgba(0,0,0,.22)",
  };

  const galleryMarkup = (
    <>
      <div
        className="babilonia-used-gallery-backdrop"
        style={{
          position: "fixed",
          inset: 0,
          zIndex: 1000400,
          background: "rgba(0,0,0,.72)",
          backdropFilter: "none",
          WebkitBackdropFilter: "none",
        }}
      />

      <div
        className="babilonia-used-gallery-modal"
        role="dialog"
        aria-modal="true"
        tabIndex="-1"
        style={{
          zIndex: 1000500,
          position: "fixed",
          inset: 0,
          width: "100vw",
          height: "100dvh",
          overflow: "hidden",
          display: "flex",
          flexDirection: "column",
          background: "#111",
        }}
      >
        <div
          style={{
            flex: "0 0 auto",
            background: "#ffffff",
            borderBottom: "1px solid rgba(0,0,0,.12)",
            minHeight: 66,
            padding: "8px 14px",
            display: "grid",
            gridTemplateColumns: "minmax(0, 1fr) auto minmax(0, 1fr)",
            alignItems: "center",
            gap: 12,
            position: "relative",
            zIndex: 1000600,
          }}
        >
          <div style={{ minWidth: 0, overflow: "hidden" }}>
            <div
              style={{
                color: "#111827",
                fontSize: 17,
                fontWeight: 800,
                lineHeight: 1.15,
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
              title={galleryTitle}
            >
              {galleryTitle}
            </div>
            <div
              style={{
                color: "#4b5563",
                fontSize: 12,
                fontWeight: 700,
                marginTop: 3,
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            >
              {safeImages.length} foto{safeImages.length === 1 ? "" : "s"}
              {" · Zoom con rueda, pellizco o doble clic"}
            </div>
          </div>

          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: 8,
              flexWrap: "nowrap",
            }}
          >
            <button
              type="button"
              onClick={zoomOut}
              title="Alejar"
              style={galleryButtonStyle}
            >
              −
            </button>
            <button
              type="button"
              onClick={resetZoom}
              title="Restablecer zoom"
              style={{ ...galleryButtonStyle, minWidth: 58 }}
            >
              100%
            </button>
            <button
              type="button"
              onClick={zoomIn}
              title="Acercar"
              style={galleryButtonStyle}
            >
              +
            </button>
          </div>

          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "center",
              minWidth: 0,
            }}
          >
            <button
              type="button"
              aria-label="Cerrar galería y regresar a ficha técnica"
              onClick={onClose}
              style={galleryCloseButtonStyle}
            >
              <span>Cerrar</span>
              <span style={{ fontSize: 18, lineHeight: 1 }}>×</span>
            </button>
          </div>
        </div>
        <div
          className="p-2"
          style={{
            flex: "1 1 auto",
            minHeight: 0,
            overflow: "hidden",
            display: "flex",
            flexDirection: "column",
            background: "#2f424a",
          }}
        >
          <div
            className="position-relative d-flex align-items-center justify-content-center bg-dark rounded"
            style={{
              flex: "1 1 auto",
              minHeight: 0,
              overflow: "hidden",
            }}
          >
            {hasMultipleImages && (
              <button
                type="button"
                className="btn btn-light position-absolute top-50 start-0 translate-middle-y ms-3 rounded-circle"
                onClick={goPrev}
                aria-label="Foto anterior"
                style={{ zIndex: 6, width: 44, height: 44 }}
              >
                ‹
              </button>
            )}

            <TransformWrapper
              key={`gallery-${activeIndex}-${activeImage}`}
              ref={galleryTransformRef}
              initialScale={1}
              minScale={0.5}
              maxScale={5}
              centerOnInit
              centerZoomedOut
              limitToBounds={false}
              wheel={{ disabled: false, step: 0.16, smoothStep: 0.004 }}
              pinch={{ disabled: false, step: 5 }}
              panning={{ disabled: false, velocityDisabled: true }}
              doubleClick={{ disabled: false, mode: "toggle" }}
            >
              <TransformComponent
                wrapperStyle={{
                  width: "100%",
                  height: "100%",
                  overflow: "hidden",
                  touchAction: "none",
                }}
                contentStyle={{
                  width: "100%",
                  height: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  touchAction: "none",
                }}
              >
                <div
                  style={{
                    width: "100%",
                    height: "100%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    padding: "10px 64px",
                    boxSizing: "border-box",
                  }}
                >
                  <img
                    src={activeImage}
                    alt={`Foto ${activeIndex + 1}`}
                    draggable={false}
                    style={{
                      width: "auto",
                      height: "auto",
                      maxWidth: "100%",
                      maxHeight: "100%",
                      objectFit: "contain",
                      background: "#111",
                      userSelect: "none",
                      WebkitUserSelect: "none",
                      WebkitTouchCallout: "none",
                      display: "block",
                    }}
                    onError={(event) => {
                      event.currentTarget.src =
                        "/assets/img/product/noimage.png";
                    }}
                  />
                </div>
              </TransformComponent>
            </TransformWrapper>

            {hasMultipleImages && (
              <button
                type="button"
                className="btn btn-light position-absolute top-50 end-0 translate-middle-y me-3 rounded-circle"
                onClick={goNext}
                aria-label="Siguiente foto"
                style={{ zIndex: 6, width: 44, height: 44 }}
              >
                ›
              </button>
            )}

            <span
              className="badge bg-dark position-absolute bottom-0 end-0 m-3 px-3 py-2"
              style={{ background: "rgba(0,0,0,.65)", zIndex: 7 }}
            >
              {activeIndex + 1} / {safeImages.length}
            </span>
          </div>

          {safeImages.length > 1 && (
            <div
              ref={thumbsRef}
              className="d-flex gap-2 pt-2 pb-1"
              style={{
                flex: "0 0 auto",
                overflowX: "auto",
                overflowY: "hidden",
                minHeight: 82,
                maxHeight: 92,
              }}
            >
              {safeImages.map((url, index) => (
                <button
                  key={`${url}-${index}`}
                  type="button"
                  data-gallery-thumb={index}
                  className={`border rounded p-1 bg-white ${
                    index === activeIndex ? "border-primary" : "border-light"
                  }`}
                  onClick={() => setActiveIndex(index)}
                  style={{
                    minWidth: 90,
                    height: 74,
                    boxShadow:
                      index === activeIndex
                        ? "0 0 0 3px rgba(13,110,253,.18)"
                        : "none",
                  }}
                >
                  <img
                    src={url}
                    alt={`Miniatura ${index + 1}`}
                    style={{
                      width: 78,
                      height: 60,
                      objectFit: "cover",
                      borderRadius: 6,
                    }}
                    onError={(event) => {
                      event.currentTarget.src =
                        "/assets/img/product/noimage.png";
                    }}
                  />
                </button>
              ))}
            </div>
          )}
        </div>
      </div>
    </>
  );

  if (typeof document === "undefined") return galleryMarkup;

  return createPortal(galleryMarkup, document.body);
}

const formatterPeso = new Intl.NumberFormat("es-MX", {
  style: "currency",
  currency: "MXN",
  minimumFractionDigits: 0,
});

// Función para formatear moneda
const formatCurrency = (value) => {
  return isNaN(Number(value)) ? "$0" : `$${Number(value).toLocaleString()}`;
};

function toTitleCase(str) {
  return str
    .toLowerCase()
    .replace(/(?:^|\s|\/|-)\S/g, (match) => match.toUpperCase());
}

// Helpers para filtros de accesorios/garantías por agencia, marca y modelo/versión
const normalizarTexto = (texto = "") =>
  String(texto || "")
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/\s+/g, " ")
    .trim();

const limpiarModeloVersion = (texto = "") =>
  normalizarTexto(texto)
    .replace(/\b(2025|2026|2027|2028|2029|25|26|27|28|29)\b/g, "")
    .replace(/\s+/g, " ")
    .trim();

// ==========================================================
// Calculadora de RFC (persona física) — nombre, apellido paterno,
// apellido materno, fecha de nacimiento.
// ----------------------------------------------------------
// El PREFIJO de 10 caracteres (4 letras + AAMMDD) sigue el algoritmo
// estándar publicado por el SAT y es confiable.
// La HOMOCLAVE de 3 caracteres usa el algoritmo público (diccionario
// de valores + suma de productos) que replican la mayoría de las
// calculadoras de RFC — pero el SAT es la única fuente 100% oficial
// (puede además reasignar homoclave si ya existe un RFC idéntico).
// Antes de usarla en un trámite real, valida el resultado contra la
// herramienta oficial del SAT o el RFC que traiga el cliente en su
// identificación.
const RFC_TEXTO_LIMPIO = (texto = "") =>
  String(texto || "")
    .toUpperCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[^A-ZÑ ]/g, " ")
    .replace(/\s+/g, " ")
    .trim();

const RFC_PALABRAS_A_OMITIR = [
  "DE",
  "DEL",
  "LA",
  "LAS",
  "LOS",
  "Y",
  "MC",
  "MAC",
  "VON",
  "VAN",
  "MI",
];

// Lista corta de palabras que el SAT considera inconvenientes como
// inicio de RFC (se sustituye la 2a letra por X). No es exhaustiva —
// referencia: Anexo del SAT. Se cubren los casos más comunes.
const RFC_PALABRAS_INCONVENIENTES = [
  "BUEI",
  "BUEY",
  "CACA",
  "CACO",
  "CAGA",
  "CAGO",
  "CAKA",
  "CAKO",
  "COGE",
  "COJA",
  "COJE",
  "COJI",
  "COJO",
  "CULO",
  "FETO",
  "GUEY",
  "JOTO",
  "KACA",
  "KACO",
  "KAGA",
  "KAGO",
  "KOGE",
  "KOJO",
  "KAKA",
  "KULO",
  "MAME",
  "MAMO",
  "MEAR",
  "MEAS",
  "MEON",
  "MION",
  "MOCO",
  "MULA",
  "PEDA",
  "PEDO",
  "PENE",
  "PUTA",
  "PUTO",
  "QULO",
  "RATA",
  "RUIN",
];

const rfcPrimerElementoUtil = (texto = "") => {
  const palabras = RFC_TEXTO_LIMPIO(texto)
    .split(" ")
    .filter(Boolean);
  const idx = palabras.findIndex(
    (p) => !RFC_PALABRAS_A_OMITIR.includes(p),
  );
  return palabras[idx >= 0 ? idx : 0] || "";
};

// Prefijo de 10 caracteres: 4 letras (nombre/apellidos) + AAMMDD.
function calcularRfcPrefijo({
  nombre = "",
  apellidoPaterno = "",
  apellidoMaterno = "",
  fechaNacimiento = "",
} = {}) {
  const nombresPalabras = RFC_TEXTO_LIMPIO(nombre)
    .split(" ")
    .filter(Boolean);
  // Regla SAT: si el primer nombre es "MARIA"/"JOSE" y hay más de un
  // nombre, se usa el segundo nombre para evitar RFCs repetidos.
  const primerNombre =
    ["MARIA", "JOSE"].includes(nombresPalabras[0]) &&
    nombresPalabras.length > 1
      ? nombresPalabras[1]
      : nombresPalabras[0] || "";

  const apPat = rfcPrimerElementoUtil(apellidoPaterno);
  const apMat = rfcPrimerElementoUtil(apellidoMaterno);

  let letras = "";
  if (apPat) {
    const vocalInterna = apPat.slice(1).match(/[AEIOU]/);
    letras =
      apPat[0] +
      (vocalInterna ? vocalInterna[0] : "X") +
      (apMat ? apMat[0] : apPat[1] || "X") +
      (primerNombre ? primerNombre[0] : "X");
  } else if (apMat) {
    const vocalInterna = apMat.slice(1).match(/[AEIOU]/);
    letras =
      apMat[0] +
      (vocalInterna ? vocalInterna[0] : "X") +
      (primerNombre ? primerNombre[0] : "X") +
      (primerNombre ? primerNombre[1] || "X" : "X");
  } else {
    letras = `${primerNombre}XXXX`.slice(0, 4);
  }

  if (RFC_PALABRAS_INCONVENIENTES.includes(letras)) {
    letras = `${letras[0]}X${letras.slice(2)}`;
  }

  const fecha = String(fechaNacimiento || "").slice(0, 10);
  const [anio = "", mes = "", dia = ""] = fecha.split("-");
  const aammdd = `${(anio || "").slice(-2).padStart(2, "0")}${(
    mes || ""
  ).padStart(2, "0")}${(dia || "").padStart(2, "0")}`;

  return { letras: letras.padEnd(4, "X"), aammdd, valido: Boolean(anio && mes && dia) };
}

// Diccionario de valores para el cálculo de homoclave (ver nota arriba:
// verificar contra el SAT antes de un trámite real).
const RFC_DICCIONARIO_HOMOCLAVE = {
  " ": "00",
  "0": "00",
  "1": "01",
  "2": "02",
  "3": "03",
  "4": "04",
  "5": "05",
  "6": "06",
  "7": "07",
  "8": "08",
  "9": "09",
  A: "10",
  B: "11",
  C: "12",
  D: "13",
  E: "14",
  F: "15",
  G: "16",
  H: "17",
  I: "18",
  J: "19",
  K: "20",
  L: "21",
  M: "22",
  N: "23",
  Ñ: "24",
  O: "25",
  P: "26",
  Q: "27",
  R: "28",
  S: "29",
  T: "30",
  U: "31",
  V: "32",
  W: "33",
  X: "34",
  Y: "35",
  Z: "36",
};
const RFC_TABLA_HOMOCLAVE = "123456789ABCDEFGHIJKLMNPQRSTUVWXYZ";

function calcularRfcHomoclave(nombreCompleto = "") {
  const cadena = ` ${RFC_TEXTO_LIMPIO(nombreCompleto)}`;
  const valores = cadena
    .split("")
    .map((c) => RFC_DICCIONARIO_HOMOCLAVE[c] ?? "00");

  let suma = 0;
  for (let i = 0; i < valores.length - 1; i += 1) {
    const par = `${valores[i]}${valores[i + 1]}`;
    suma += parseInt(par, 10) || 0;
  }

  const residuo = suma % 1000;
  const digito1 = RFC_TABLA_HOMOCLAVE[Math.floor(residuo / 34) % 34] || "0";
  const digito2 = RFC_TABLA_HOMOCLAVE[residuo % 34] || "0";

  return `${digito1}${digito2}`;
}

// Tercer carácter de homoclave (dígito verificador), usando el mismo
// alfabeto-valor que el resto del RFC.
const RFC_ALFABETO_VERIFICADOR = "0123456789ABCDEFGHIJKLMN&OPQRSTUVWXYZ Ñ";
function calcularRfcDigitoVerificador(rfc10 = "") {
  const cadena = rfc10.padStart(11, " ").toUpperCase();
  let suma = 0;
  for (let i = 0; i < cadena.length; i += 1) {
    const valor = RFC_ALFABETO_VERIFICADOR.indexOf(cadena[i]);
    suma += (valor < 0 ? 0 : valor) * (13 - i);
  }
  const residuo = suma % 11;
  if (residuo === 0) return "0";
  if (residuo === 10) return "A";
  return String(11 - residuo);
}

function calcularRfcYHomoclave({
  nombre = "",
  apellidoPaterno = "",
  apellidoMaterno = "",
  fechaNacimiento = "",
} = {}) {
  const { letras, aammdd, valido } = calcularRfcPrefijo({
    nombre,
    apellidoPaterno,
    apellidoMaterno,
    fechaNacimiento,
  });

  if (!valido || !letras || letras.includes("X".repeat(4))) {
    return { rfc: "", homoclave: "", rfcCompleto: "", valido: false };
  }

  const rfc10 = `${letras}${aammdd}`;
  const nombreCompleto = `${apellidoPaterno} ${apellidoMaterno} ${nombre}`.trim();
  const homoclave2 = calcularRfcHomoclave(nombreCompleto);
  const digitoVerificador = calcularRfcDigitoVerificador(rfc10);
  const homoclave = `${homoclave2}${digitoVerificador}`;

  return {
    rfc: rfc10,
    homoclave,
    rfcCompleto: `${rfc10}${homoclave}`,
    valido: true,
  };
}

const escapeRegExp = (texto = "") =>
  String(texto).replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

const incluyePalabra = (texto = "", palabra = "") => {
  const textoLimpio = normalizarTexto(texto);
  const palabraLimpia = normalizarTexto(palabra);

  if (!textoLimpio || !palabraLimpia) return false;

  return new RegExp(`\\b${escapeRegExp(palabraLimpia)}\\b`, "i").test(
    textoLimpio,
  );
};

const estaDisponible = (item) =>
  item?.available === true ||
  item?.available === "true" ||
  item?.available === 1 ||
  item?.available === "1";

const coincideAgenciaItem = (item, agIdActivo = "") => {
  const itemAgId = String(item?.ag_id || "")
    .trim()
    .toLowerCase();
  const agId = String(agIdActivo || "")
    .trim()
    .toLowerCase();

  // Productos globales
  if (!itemAgId || itemAgId === "all") return true;

  // Si no tengo agencia activa, NO dejo pasar productos de agencias específicas
  if (!agId) return false;

  return itemAgId === agId;
};

const coincideMarcaItem = (item, marcaActiva = "") => {
  const itemBrand = normalizarTexto(item?.brand || "");
  const marca = normalizarTexto(marcaActiva || "");

  if (!itemBrand || itemBrand === "all") return true;
  if (!marca) return false;

  return itemBrand === marca;
};

const renderBarLabel = ({ x, y, width, height, value }) => {
  const cx = x + width / 2;
  const cy = y + height / 2;

  return (
    <text
      x={cx}
      y={cy}
      fill="#fff"
      fontSize={11}
      textAnchor="middle"
      dominantBaseline="middle"
    >
      {formatCurrency(value)}
    </text>
  );
};

const renderBarLabel2 = ({ x, y, width, value }) => {
  const cx = x + width / 2;
  const cy = y - 8;

  //variable modo claro/oscuro
  const labelColor =
    getComputedStyle(document.documentElement)
      .getPropertyValue("--label-color")
      .trim() || "#000";

  return (
    <text
      x={cx}
      y={cy}
      fill={labelColor}
      fontSize={11}
      textAnchor="middle"
      dominantBaseline="central"
    >
      {formatCurrency(value)}
    </text>
  );
};

const renderLineLabel = ({ x, y, value }) => {
  return (
    <text
      x={x}
      y={y + 35}
      fontSize={11}
      fill="var(--label-color)"
      textAnchor="middle"
    >
      {`${value}%`}
    </text>
  );
};

const GraficasEstadisticas = () => {
  const siniestralidadData = [
    { name: "Sin siniestro", value: 27.4 },
    { name: "Con siniestro", value: 72.6 },
  ];

  const reparacionData = [
    { name: "Choque menor", costo: 7500 },
    { name: "Lesión menor", costo: 25000 },
    { name: "Lesión grave", costo: 350000 },
    { name: "Catastrofe", costo: 1500000 },
  ];

  const roboAutosData = [
    { name: "Total", vehiculos: 136993 },
    { name: "Asegurados robados", vehiculos: 61222 },
    { name: "Sin seguro", vehiculos: 75871 },
    { name: "Robo con violencia", vehiculos: 78087 },
  ];

  const distribucionSiniestrosData = [
    { name: "Robos", value: 20 },
    { name: "Responsabilidad civil", value: 30 },
    { name: "Daños materiales", value: 50 },
  ];

  return (
    <div className="container-fluid">
      <br></br>
      <h6 className="text-center text-light mb-3">
        🚘 Datos clave sobre riesgos y costos en el sector asegurador.
      </h6>
      <br></br>
      <div className="row">
        {/* Siniestralidad */}
        <div className="col-md-6 mb-4">
          <div
            className="p-3 rounded modal-grafic"
            style={{ backgroundColor: "#1f2e35" }}
          >
            <h6 className="text-warning text-center mb-2">
              📊 Siniestralidad en el sector asegurador
            </h6>
            <ResponsiveContainer width="100%" height={300}>
              <PieChart>
                <Pie
                  data={siniestralidadData}
                  dataKey="value"
                  nameKey="name"
                  cx="50%"
                  cy="50%"
                  outerRadius={80}
                  label={({ value }) => `${value}%`}
                >
                  <Cell fill="#66bb6a" />
                  <Cell fill="#f44336" />
                </Pie>
                <Tooltip formatter={(value) => `${value}%`} />
              </PieChart>
            </ResponsiveContainer>
            <p className="text-light text-center mt-2 text-base">
              El 72.6% de los autos asegurados presentan algún siniestro.
            </p>
          </div>
        </div>

        {/* Costos de reparación */}
        <div className="col-md-6 mb-4">
          <div
            className="p-3 rounded modal-grafic"
            style={{ backgroundColor: "#1f2e35" }}
          >
            <h6 className="text-warning text-center mb-2">
              💰 Costos de reparación por accidente
            </h6>
            <ResponsiveContainer width="100%" height={300}>
              <BarChart data={reparacionData} margin={{ top: 20, left: 15 }}>
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="name" stroke="var(--axis-stroke)" />
                <YAxis
                  stroke="var(--axis-stroke)"
                  tickFormatter={formatCurrency}
                />
                <Tooltip formatter={(value) => value.toLocaleString()} />
                <Legend />
                <Bar dataKey="costo" fill="#f44336" label={renderBarLabel2} />
              </BarChart>
            </ResponsiveContainer>
            <p className="text-light text-center mt-2 text-base">
              Los costos de reparación pueden ser extremadamente elevados sin
              seguro.
            </p>
          </div>
        </div>

        {/* Robo de autos */}
        <div className="col-md-6 mb-4">
          <div
            className="p-3 rounded modal-grafic"
            style={{ backgroundColor: "#1f2e35" }}
          >
            <h6 className="text-warning text-center mb-2">
              🚗 Robo de autos en México
            </h6>
            <ResponsiveContainer width="100%" height={300}>
              <BarChart data={roboAutosData} margin={{ top: 20, left: 10 }}>
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="name" stroke="var(--axis-stroke)" />
                <YAxis
                  stroke="var(--axis-stroke)"
                  tickFormatter={formatCurrency}
                />
                <Tooltip formatter={(value) => value.toLocaleString()} />
                <Legend />
                <Bar
                  dataKey="vehiculos"
                  fill="#ff9800"
                  label={renderBarLabel2}
                />
              </BarChart>
            </ResponsiveContainer>
            <p className="text-light text-center mt-2 text-base">
              Casi 137,000 autos fueron robados en 2023, más de la mitad sin
              seguro.
            </p>
          </div>
        </div>

        {/* Distribución de tipos de siniestro */}
        <div className="col-md-6 mb-4">
          <div
            className="p-3 rounded modal-grafic"
            style={{ backgroundColor: "#1f2e35" }}
          >
            <h6 className="text-warning text-center mb-2 ">
              📌 Tipos de siniestros más comunes
            </h6>
            <ResponsiveContainer width="100%" height={300}>
              <PieChart>
                <Pie
                  data={distribucionSiniestrosData}
                  dataKey="value"
                  nameKey="name"
                  cx="50%"
                  cy="50%"
                  outerRadius={80}
                  label={({ name, value }) => `${name}: ${value}%`}
                >
                  <Cell fill="#ffca28" />
                  <Cell fill="#ab47bc" />
                  <Cell fill="#26c6da" />
                </Pie>
                <Tooltip formatter={(value) => `${value}%`} />
              </PieChart>
            </ResponsiveContainer>
            <p className="text-light text-center mt-2 text-base">
              Los daños materiales y responsabilidad civil representan el 80% de
              los siniestros.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

const llantasData = [
  { year: "2022", siniestralidad: 66.2, costo: 3251.74 },
  { year: "2023", siniestralidad: 49.7, costo: 3319.51 },
  { year: "2024", siniestralidad: 57.5, costo: 3342.78 },
  { year: "2025", siniestralidad: 52.2, costo: 3170.82 },
];

const mecanicaData = [
  { year: "2020", siniestralidad: 22.8, costo: 16273.15 },
  { year: "2021", siniestralidad: 22.9, costo: 22332.09 },
  { year: "2022", siniestralidad: 33.1, costo: 27656.05 },
  { year: "2023", siniestralidad: 38.1, costo: 38517.54 },
  { year: "2024", siniestralidad: 39.5, costo: 38751.5 },
];

const reparacionesData = [
  { year: "2022", costo: 34637, color: "#20c997" },
  { year: "2023", costo: 37357, color: "#0d6efd" },
  { year: "2024", costo: 38575, color: "#002752" },
];

const siniestralidadData = [
  { name: "2022-2023", value: 42.99, color: "#007bff" },
  { name: "2023-2024", value: 48.24, color: "#dc3545" },
];
const customStyles = {
  control: (base) => ({
    ...base,
    borderColor: "transparent",
    backgroundColor: "rgba(255, 255, 255, 0.15)",
    borderRadius: "0",
    color: "white",
    boxShadow: "none",
    "&:hover": {
      borderColor: "#fff",
    },
  }),
  menu: (base) => ({
    ...base,
    zIndex: 9999,
  }),
  option: (base, state) => ({
    ...base,
    color: "black", // Text color for options
    backgroundColor: state.isFocused ? "transparent" : "transparent",
    "&:active": {
      backgroundColor: "transparent",
    },
  }),
  singleValue: (base) => ({
    ...base,
    color: "white", // Color of the selected value
  }),
  input: (base) => ({
    ...base,
    color: "white", // Color of the input text
  }),
  dropdownIndicator: (base) => ({
    ...base,
    color: "white", // Change the color of the dropdown indicator to white
  }),
  clearIndicator: (base) => ({
    ...base,
    color: "white", // Change the color of the clear indicator to white
  }),
};

const TASA_ANUAL_FINANCIAMIENTO = 0.25;
const TASA_FINANCIAMIENTO_PORCENTAJE = 25;
const CASH_MONTHS_BASE = [3, 6, 9];
const CREDIT_MONTHS_BASE = [12, 24, 36, 48, 60, 72];

const PERSONAL_DATA_FIELDS = new Set([
  "nombre",
  "apellido_paterno",
  "apellido_materno",
  "fecha_nacimiento",
  "rfc",
  "homoclave",
  "telefono",
  "correo_electronico",
]);

// ==========================================================
// NR / Procotiza - integración natural dentro del flujo del asesor
// Estos endpoints apuntan a los proxies internos de Babilonia.
// ==========================================================

const nrToNumber = (value) => {
  if (value === null || value === undefined || value === "") return 0;
  if (typeof value === "number") return Number.isFinite(value) ? value : 0;

  const normalized = String(value)
    .replace(/[$,\s]/g, "")
    .replace(/[^0-9.-]/g, "");
  const parsed = Number(normalized);

  return Number.isFinite(parsed) ? parsed : 0;
};

const NR_BABILONIA_API_BASE =
  process.env.REACT_APP_API_BASE_URL ||
  process.env.REACT_APP_API_URL ||
  "https://api.checkmark.mx/";

const NR_DEFAULT_AGENCIA_CLAVE =
  process.env.REACT_APP_NR_AGENCIA_CLAVE || "NRFM";
const NR_DEFAULT_AGENCIA_ID = Number(
  process.env.REACT_APP_NR_AGENCIA_ID || 101,
);
// AnzenId no tiene un catálogo/documento que permita deducirlo.
// Debe venir de configuración real; no se inventa un valor de respaldo.
const NR_CONFIG_ANZEN_ID = String(
  process.env.REACT_APP_NR_ANZEN_ID || "AZ001",
).trim();
const NR_INCLUDE_ANZEN_DATA_ON_SAVE =
  String(
    process.env.REACT_APP_NR_INCLUDE_ANZEN_DATA_ON_SAVE || "false",
  ).toLowerCase() === "true";

// listaAccesorios de /quotations: por el ejemplo real que compartió NR,
// no se manda un idAccesorio por cada accesorio real ni tipo:1/2
// financiado-contado — se agrupa TODO en 2 renglones genéricos con
// tipo:160 fijo.
//
// CONFIRMADO CON PRUEBA REAL (cotización NR 12471842, 31/07/26) + ejemplo
// original de NR: idAccesorio 47548 -> el PDF lo imprime bajo la etiqueta
// "ACCESORIO GENERICO SERVICIO"; 47547 -> "ACCESORIO GENERICO FISICO".
// SOLO sabemos el TEXTO de la etiqueta que imprime cada id, NO a qué eje
// corresponde realmente (¿tipo de accesorio [garantía/físico], o
// financiado/contado, o algo más?). Se decidió usarlos como
// financiado/contado (ver más abajo en listaAccesorios) porque es el
// único eje que ya tenemos 100% confiable (MontoAccesorios/
// MontoAccesoriosContado, ya validados en /cotiza) — evita tener que
// filtrar accesorio por accesorio otra vez (que fue la causa de la fuga
// de dinero anterior). La asignación de CUÁL id es financiado y cuál es
// contado sigue siendo un supuesto sin confirmar; falta una prueba con
// solo financiado (sin contado) o viceversa para saber cuál id le
// corresponde a cada uno — si sale al revés, basta con intercambiar estos
// dos valores.
const NR_ID_ACCESORIO_FINANCIADO = Number(
  process.env.REACT_APP_NR_ID_ACCESORIO_FINANCIADO || 47547,
);
const NR_ID_ACCESORIO_CONTADO = Number(
  process.env.REACT_APP_NR_ID_ACCESORIO_CONTADO || 47548,
);
const NR_TIPO_ACCESORIO_GENERICO = 160;

const NR_ENDPOINTS = {
  token: "financiamiento/nr/token",
  cotiza: "financiamiento/nr/cotiza",
  guardarCotizacion: "financiamiento/nr/guardar-cotizacion",
  generarPdf: "financiamiento/nr/generar-pdf",
  monthlyPricing: "financiamiento/nr/monthly-pricing",
  paquetes: "financiamiento/nr/paquetes",
  productoFiltrado: "financiamiento/nr/producto-filtrado",
  consultarSegurosAnzen: "financiamiento/nr/consultar-seguros-anzen",
  marcas: "financiamiento/nr/catalogos/marcas",
  modelos: "financiamiento/nr/catalogos/modelos",
  versiones: "financiamiento/nr/catalogos/versiones",
  estrategias: "financiamiento/nr/catalogos/estrategias",
  clasificaciones: "financiamiento/nr/catalogos/clasificaciones",
  anios: "financiamiento/nr/catalogos/anios",
  productos: "financiamiento/nr/catalogos/productos",
  planes: "financiamiento/nr/catalogos/planes",
  planDetalle: "financiamiento/nr/catalogos/plan-detalle",
  plazos: "financiamiento/nr/catalogos/plazos",
  plazoDetalle: "financiamiento/nr/catalogos/plazo-detalle",
  subsidios: "financiamiento/nr/catalogos/subsidios",
  tiposSeguro: "financiamiento/nr/catalogos/tipos-seguro",
  segurosVida: "financiamiento/nr/catalogos/seguros-vida",
  estados: "financiamiento/nr/catalogos/estados",
  anzenCatalogs: "financiamiento/nr/catalogos/anzen",
};

const nrGetPackageId = (item = {}) => Number(item?.idPaquete ?? 0);

const nrGetPackageExternalId = (item = {}) =>
  String(item?.idExterno ?? "").trim();

const nrGetPackageCebipName = (item = {}) =>
  String(item?.nombreCebip ?? "").trim();

// Obtiene la tasa exclusivamente del paquete NR y del plazo seleccionado.
// El catálogo /catalogos/plazos usa "valor" para los meses e "id" como
// identificador interno; paquete.plazos[] relaciona ese identificador mediante
// idPlazo. Si NR no proporciona una tasa válida, devuelve null: no se inventa
// ni se aplica una tasa por defecto.
const nrResolvePackageRate = ({
  paquetes = [],
  catalogoPlazos = [],
  paqueteId = 0,
  plazoMeses = 0,
} = {}) => {
  const paquete = Array.isArray(paquetes)
    ? paquetes.find(
        (item) => Number(item?.idPaquete || 0) === Number(paqueteId || 0),
      )
    : null;

  if (!paquete) return null;

  const plazoCatalogo = Array.isArray(catalogoPlazos)
    ? catalogoPlazos.find(
        (item) => Number(item?.valor || 0) === Number(plazoMeses || 0),
      )
    : null;

  const idPlazo = Number(plazoCatalogo?.id || 0);
  if (!idPlazo) return null;

  const plazoPaquete = Array.isArray(paquete?.plazos)
    ? paquete.plazos.find(
        (item) => Number(item?.idPlazo || 0) === idPlazo,
      )
    : null;

  const tasa = Number(plazoPaquete?.tasaNominal);
  return Number.isFinite(tasa) && tasa > 0 ? tasa : null;
};

const nrGetOfficialDefaultItem = (items = [], field = "isDefault") => {
  if (!Array.isArray(items)) return null;

  return (
    items.find(
      (item) =>
        item?.[field] === true ||
        Number(item?.[field]) === 1,
    ) || null
  );
};

const nrGetAnzenResponseObject = (value) =>
  value && typeof value === "object" && !Array.isArray(value)
    ? value
    : {};

const nrNormalizeAnzenInsuranceOptions = (value) => {
  const response = nrGetAnzenResponseObject(value);
  const options = [];

  const pushOption = (item, kind, index) => {
    if (!item || typeof item !== "object") return;

    const insuranceId = String(item.insuranceId ?? "").trim();
    const campaignId = String(item.campaignId ?? "").trim();
    const amount = nrToNumber(item.amount);
    const totalAmount = nrToNumber(item.totalAmount);
    const surcharges = nrToNumber(item.surcharges);
    const promoAmount = nrToNumber(item.promoAmount);
    const effectiveAmount = totalAmount || amount || promoAmount;

    // Una opción real de Anzen debe tener InsuranceId.
    if (!insuranceId) return;

    const kindLabel =
      kind === "free"
        ? "Seguro gratis"
        : kind === "promotional"
          ? "Seguro promocional"
          : "Seguro Anzen";

    options.push({
      ...item,
      __key: `${kind}-${insuranceId}-${campaignId || "sin-campania"}-${index}`,
      __kind: kind,
      __label: `${kindLabel} ${insuranceId} · ${formatterPeso.format(effectiveAmount)}`,
      __insuranceId: insuranceId,
      __campaignId: campaignId,
      __amount: amount,
      __totalAmount: totalAmount || amount,
      __surcharges: surcharges,
    });
  };

  (Array.isArray(response.insurances) ? response.insurances : []).forEach(
    (item, index) => pushOption(item, "standard", index),
  );
  pushOption(response.insuranceFree, "free", 0);
  pushOption(response.insurancePromotional, "promotional", 0);

  return options;
};

const nrGetAnzenOperationId = (tipoOperacion = "") => {
  const value = String(tipoOperacion || "").trim();
  if (!value) return "";
  if (/^OP\d+$/i.test(value)) return value.toUpperCase();

  const map = {
    "1": "OP001",
    "2": "OP002",
    "3": "OP003",
  };

  return map[value] || "";
};

const nrNormalizeText = (value = "") =>
  normalizarTexto(value)
    .replace(/\b(19|20)\d{2}\b/g, " ")
    .replace(/\b\d{2}\b/g, " ")
    .replace(/[^a-z0-9]+/g, " ")
    .replace(/\s+/g, " ")
    .trim();

const nrScoreTextMatch = (catalogText = "", targetText = "") => {
  const catalog = nrNormalizeText(catalogText);
  const target = nrNormalizeText(targetText);

  if (!catalog || !target) return 0;
  if (catalog === target) return 1000;

  const catalogTokens = new Set(catalog.split(" ").filter(Boolean));
  const targetTokens = target.split(" ").filter(Boolean);

  let score = 0;

  targetTokens.forEach((token) => {
    if (catalogTokens.has(token)) score += 10;
    else if (catalog.includes(token)) score += 4;
  });

  if (catalog.includes(target) || target.includes(catalog)) score += 100;

  return score;
};

const nrFindBestNamedMatch = (items = [], targetText = "", minScore = 10) => {
  const source = Array.isArray(items) ? items : [];
  const candidates = source
    .map((item) => ({
      item,
      score: nrScoreTextMatch(String(item?.nombre ?? ""), targetText),
    }))
    .filter((candidate) => candidate.score >= minScore)
    .sort((a, b) => b.score - a.score);

  return {
    best: candidates[0]?.item || null,
    candidates: candidates.map((candidate) => candidate.item),
    scored: candidates,
  };
};

const nrNormalizePdfBase64 = (pdfBase64 = "") => {
  let clean = String(pdfBase64 || "").trim();
  if (!clean) return "";

  const commaIndex = clean.indexOf(",");
  if (clean.startsWith("data:") && commaIndex >= 0) {
    clean = clean.slice(commaIndex + 1);
  }

  clean = clean
    .replace(/\s+/g, "")
    .replace(/-/g, "+")
    .replace(/_/g, "/");

  const missingPadding = clean.length % 4;
  if (missingPadding) clean += "=".repeat(4 - missingPadding);

  return clean;
};

const nrCreatePdfBlob = (pdfBase64 = "") => {
  const clean = nrNormalizePdfBase64(pdfBase64);
  if (!clean || typeof window === "undefined") return null;

  try {
    const binary = window.atob(clean);
    const chunks = [];
    const chunkSize = 1024;

    for (let offset = 0; offset < binary.length; offset += chunkSize) {
      const slice = binary.slice(offset, offset + chunkSize);
      const bytes = new Uint8Array(slice.length);

      for (let index = 0; index < slice.length; index += 1) {
        bytes[index] = slice.charCodeAt(index);
      }

      chunks.push(bytes);
    }

    return new Blob(chunks, { type: "application/pdf" });
  } catch (error) {
    console.error("No se pudo convertir el PDF NR a Blob:", error);
    return null;
  }
};

const nrGetMonthlyPayment = (cotizacion) =>
  nrToNumber(cotizacion?.pagoMensualTotal);

const nrGetInitialPayment = (cotizacion) =>
  nrToNumber(cotizacion?.pagoInicial);

const nrGetReportedDownPayment = (cotizacion) =>
  nrToNumber(cotizacion?.montoEnganche);

const nrGetFinancedAmount = (cotizacion) =>
  nrToNumber(cotizacion?.montoFinanciarTotal);

const nrGetRate = (cotizacion) =>
  nrToNumber(cotizacion?.tasa);

const nrGetUnitPayment = (cotizacion) =>
  nrToNumber(cotizacion?.pagoUnidad);

const nrGetVehicleInsurancePayment = (cotizacion) =>
  nrToNumber(cotizacion?.pagoSeguro);

const nrGetLifeInsurancePayment = (cotizacion) =>
  nrToNumber(cotizacion?.seguroVidaConMargen);

const nrGetOpeningCommission = (cotizacion) =>
  nrToNumber(cotizacion?.montoCxa);

const nrGetOpeningCommissionPayment = (cotizacion) =>
  nrToNumber(cotizacion?.pagoCxa);

const nrGetAnnualInsurance = (cotizacion) =>
  nrToNumber(cotizacion?.seguroAnual);


const nrGetPagoContadoFromEntrevista = (form = {}, venta = {}) =>
  String(
    form?.pago_contado ||
      form?.depende_auto ||
      venta?.depende_auto ||
      ""
  ).trim();

const nrGetTipoOperacionFromEntrevista = (form = {}, venta = {}) => {
  const pagoContado = nrGetPagoContadoFromEntrevista(form, venta);

  // Babilonia ya define si la compra es crédito o contado.
  // Procotiza se integra únicamente al flujo de crédito actual.
  if (pagoContado === "No") return "1";

  return "";
};

const nrGetTipoOperacionLabelFromEntrevista = (form = {}, venta = {}) => {
  const pagoContado = nrGetPagoContadoFromEntrevista(form, venta);

  if (pagoContado === "No") return "Crédito";
  if (pagoContado === "Si") return "Contado";

  return "Pendiente";
};


function CreateVenta() {
  // Obtener los módulos desde localStorage
  const modules = JSON.parse(localStorage.getItem("modulos")) || [];

  // Obtener la ubicación actual
  const location = useLocation();

  // Definir los tabs con su nombre, URL y módulo correspondiente
  const tabs = [
    { name: "Crear Venta", to: "/form/crear-venta", module: "form-wizards" },
    { name: "Ventas", to: "/form/ventas", module: "form-wizards" },
  ];

  const [mailData, setMailData] = useState([]);
  const [loading, setLoading] = useState(false); // Estado para el loader
  const [selectedMailData, setSelectedMailData] = useState(null);
  const [plans, setPlans] = useState([]); // Estado para los accesorios
  const [agencias, setAgencias] = useState([]);
  const [selectedAgencia, setSelectedAgencia] = useState("");
  const [garantia_extendida, setGarantiaExtendida] = useState("");
  const [pago_contado, setContado] = useState("");
  const [mostrarModalInfo, setMostrarModalInfo] = useState(false);
  const datosPersonalesYaCargados = useRef(false);
  const debounceTimer = useRef(null);
  const [precioVehiculo, setPrecioVehiculo] = useState(0);
  const [eliminatedAccessories, setEliminatedAccessories] = useState([]);
  const [swapOptionsOpen, setSwapOptionsOpen] = useState({});

  // Datos base del formulario.
  // Importante: formData debe inicializarse antes de cualquier hook/callback que lo use.
  const buildEmptyFormData = () => ({
    // --- Datos originales ---
    nombre: "",
    apellido_paterno: "",
    apellido_materno: "",
    fecha_nacimiento: "",
    rfc: "",
    homoclave: "",
    telefono: "",
    correo_electronico: "",
    asesor: "",
    user_id: "",
    venta_id: "",
    enganche: "",
    engancheEditable: "",

    // --- Entrevista consultiva ---
    pago_contado: "", // "Si" = Contado, "No" = Crédito

    // --- Procotiza / NR ---
    nr_personalidad_juridica: "", // Selección real del asesor: 1=PF, 2=PM
    nr_tipo_operacion: "", // Se deriva de pago_contado/depende_auto
    nr_agencia_clave: NR_DEFAULT_AGENCIA_CLAVE,
    nr_agencia_id: String(NR_DEFAULT_AGENCIA_ID),
    nr_estado_id: "",
    nr_estado_nombre: "",
    nr_municipio_id: "",
    nr_municipio_nombre: "",
    nr_tipo_seguro_id: "",
    nr_tipo_seguro_nombre: "",
    nr_seguro_vida_id: "",
    nr_anzen_id: NR_CONFIG_ANZEN_ID,
    nr_aseguradora_id: "",
    nr_aseguradora_nombre: "",
    nr_cobertura_id: "",
    nr_cobertura_nombre: "",
    nr_udi_id: "",
    nr_udi_nombre: "",
    nr_uso_id: "",
    nr_uso_nombre: "",
    nr_producto_id: "",
    nr_producto_descripcion: "",
    nr_producto_tipo_precio_id: "",
    nr_anzen_producto_id: "",
    nr_tipo_producto_id: "",
    nr_broker_id: "",
    nr_marca_id: "",
    nr_marca_nombre: "",
    nr_modelo_id: "",
    nr_modelo_nombre: "",
    nr_version_id: "",
    nr_version_nombre: "",
    nr_estrategia_id: "",
    nr_estrategia_nombre: "",
    nr_plan_id: "",
    nr_plan_nombre: "",
    nr_paquete_externo_id: "",
    nr_plazo: "",
    nr_seguro_anzen_key: "",
    nr_seguro_anzen_id: "",
    nr_seguro_anzen_campania_id: "",
    nr_seguro_anzen_amount: "0",
    nr_seguro_anzen_total_amount: "0",
    nr_seguro_anzen_surcharges: "0",
    nr_seguro_anzen_tipo: "",
    nr_cotizacion_id: "",
    nr_cotizacion_portal_id: "",
    presupuesto_definido: "",
    interes_proteccion: "",

    // Crédito (base)
    historial_credito: "",
    inversion_inicial: "",
    mensualidad_buscada: "",
    plazo_meses: "",
    acepta_seguro_auto: "",
    comprueba_ingresos: "",

    // Crédito SI comprueba
    tipo_actividad: "",
    actividad_empresa: "",
    fecha_inicio_actividades: "",
    nombre_empresa_negocio: "",
    ingreso_mensual: "",

    // Crédito NO comprueba
    actividad_no_comprobable: "",
    fecha_inicio_actividades_no_comprobable: "",
    ingreso_mensual_no_comprobable: "",

    // --- Garantías ---
    condiciones_calle_extra: "",
    interes_llaves: "",
    ha_dejado_taller: "",
    garantia_seminuevo: "",
    desea_polarizado: "",
    desea_kit_emergencia: "",
    tiempo_real: "",
    respaldo_auto: "",

    // extras si quieres conservarlos
    importancia_auto_sustituto: "",
    usa_en_lodo: "",
    importancia_tapiceria: "",

    entrevista_nissan: {
      tiene_vehiculo_actual: "",
      deja_a_cuenta: "",
      busca_en_vehiculo: "",
      quien_manejara: "",
      uso_vehiculo: "",
      factor_importante_compra: "",
      viaja_carretera: "",
      cuando_compra: "",
      toma_decision_compra: "",
      motivantes_compra: [],
    },
  });

  const formDataRef = useRef(null);
  const [formData, setFormData] = useState(buildEmptyFormData);

  if (!formDataRef.current) {
    formDataRef.current = formData;
  }

  const userId = localStorage.getItem("userId");
  const [modalOpen, setModalOpen] = useState(false);
  const [accessoryModalPlanIndex, setAccessoryModalPlanIndex] = useState(null);
  const [accessoryModalPlanKey, setAccessoryModalPlanKey] = useState("");
  const [accessoryModalPlanSnapshot, setAccessoryModalPlanSnapshot] =
    useState(null);
  const accessoryModalPlanTargetRef = useRef({ index: null, key: "" });
  const accessoryModalOpenRunIdRef = useRef(0);
  const [selectedPlanIndex, setSelectedPlanIndex] = useState(null);
  const isUserEditing = useRef(false);
  const [manualMonthlyOverride, setManualMonthlyOverride] = useState(false);
  /* estados para modal resumen de venta */
  const [mensualidadC, setMensualidadC] = useState(""); // Estados para los inputs
  const [engancheC, setEngancheC] = useState("");
  const [tasaC, setTasaC] = useState("");
  const [aseguradora, setAseguradora] = useState("");
  const [montoSeguro, setMontoSeguro] = useState("");
  // Blinda "Monto del seguro" contra cualquier reseteo automático
  // (efectos, reintentos de Anzen, polling) mientras el usuario lo está
  // editando activamente. Mismo patrón ya usado en isEditingFinancingModalRef.
  const isEditingMontoSeguroRef = useRef(false);

  // Estados para mostrar con formato
  const [mensualidadDisplay, setMensualidadDisplay] = useState("");
  const [engancheDisplay, setEngancheDisplay] = useState("");
  const [tasaDisplay, setTasaDisplay] = useState("");
  const [montoSeguroDisplay, setMontoSeguroDisplay] = useState("");

  // Estados independientes para el modal de financiamiento.
  // El modal es captura manual: no calcula, no valida mínimo y no se sincroniza
  // con los cálculos automáticos mientras el usuario está escribiendo.
  const [modalMensualidadInput, setModalMensualidadInput] = useState("");
  const [modalEngancheInput, setModalEngancheInput] = useState("");
  const [modalTasaInput, setModalTasaInput] = useState("");
  const [modalFinancingMonths, setModalFinancingMonths] = useState("");
  const modalFinancingMonthsRef = useRef("");
  const modalFinancingMonthsDirtyRef = useRef(false);
  const isCotizadorModalOpenRef = useRef(false);

  const isCotizadorModalOpen = useCallback(() => {
    if (isCotizadorModalOpenRef.current) return true;
    if (typeof document === "undefined") return false;

    const modalElement = document.getElementById("cotizadorModal");
    return Boolean(modalElement?.classList?.contains("show"));
  }, []);

  const setModalFinancingMonthsManual = useCallback(
    (value = "", options = {}) => {
      const nextMonths = String(value ?? "").replace(/\D/g, "");
      const opts = options || {};
      const isDirtyPatch = Object.prototype.hasOwnProperty.call(opts, "dirty");
      const isManualPatch = isDirtyPatch && Boolean(opts.dirty);
      const forcePatch = Boolean(opts.force);
      const allowDirtyOverride = Boolean(opts.allowDirtyOverride);

      const modalOpen =
        isCotizadorModalOpenRef.current ||
        (typeof document !== "undefined" &&
          Boolean(
            document
              .getElementById("cotizadorModal")
              ?.classList?.contains("show"),
          ));

      const currentManualMonths = String(
        modalFinancingMonthsRef.current || "",
      ).replace(/\D/g, "");

      // Mientras el modal está abierto y el asesor ya cambió manualmente los meses,
      // ningún efecto/polling/rehidratación debe volver a pintar el valor de la BD.
      // Incluso si viene con force:true, sólo se deja pasar si es otro cambio manual,
      // si trae exactamente el mismo valor ya capturado o si se habilita override explícito.
      if (
        !isManualPatch &&
        modalOpen &&
        modalFinancingMonthsDirtyRef.current &&
        currentManualMonths &&
        nextMonths !== currentManualMonths &&
        !allowDirtyOverride
      ) {
        return;
      }

      modalFinancingMonthsRef.current = nextMonths;

      if (isDirtyPatch) {
        modalFinancingMonthsDirtyRef.current = Boolean(opts.dirty);
      }

      setModalFinancingMonths(nextMonths);
    },
    [],
  );

  const getModalFinancingMonthsManualValue = useCallback(() => {
    const refValue = String(modalFinancingMonthsRef.current || "").replace(
      /\D/g,
      "",
    );
    const stateValue = String(modalFinancingMonths || "").replace(/\D/g, "");

    if (modalFinancingMonthsDirtyRef.current && refValue) {
      return refValue;
    }

    return stateValue || refValue;
  }, [modalFinancingMonths]);
  const isEditingFinancingModalRef = useRef(false);
  const isSavingFinancingModalRef = useRef(false);
  const manualFinancingModalGuardRef = useRef({ ventaId: "", until: 0 });
  // Cuando el asesor guarda datos desde el modal de financiamiento, esos valores
  // son manuales y no deben ser pisados por efectos automáticos de planes.
  // Se libera únicamente cuando el asesor cambia explícitamente meses, enganche,
  // mensualidad, porcentaje o plan desde entrevista/barra/tarjetas.
  const manualFinancingModalSavedRef = useRef({ ventaId: "", active: false });

  useEffect(() => {
    const modalElement = document.getElementById("cotizadorModal");
    if (!modalElement) return undefined;

    const handleShown = () => {
      isCotizadorModalOpenRef.current = true;
    };

    const handleHidden = () => {
      isCotizadorModalOpenRef.current = false;
      modalFinancingMonthsDirtyRef.current = false;
      isEditingFinancingModalRef.current = false;
      isUserEditing.current = false;
    };

    modalElement.addEventListener("shown.bs.modal", handleShown);
    modalElement.addEventListener("hidden.bs.modal", handleHidden);

    return () => {
      modalElement.removeEventListener("shown.bs.modal", handleShown);
      modalElement.removeEventListener("hidden.bs.modal", handleHidden);
    };
  }, []);
  // --- Estados para la sección de Cotización ---
  const [tipoCompraSeguro, setTipoCompraSeguro] = useState("");
  const [tipoComision, setTipoComision] = useState("");
  const [incluyePlacas, setIncluyePlacas] = useState("");
  const [montoComision, setMontoComision] = useState("");
  const [montoComisionDisplay, setMontoComisionDisplay] = useState("");
  const [montoAdicionales, setMontoAdicionales] = useState("0");
  const [montoAdicionalesDisplay, setMontoAdicionalesDisplay] = useState("");
  const [montoPlacas, setMontoPlacas] = useState("");
  //-- para modal de adicionales de contado
  const [showModalAdicionales, setShowModalAdicionales] = useState(false);
  const [adicionalesContado, setAdicionalesContado] = useState([]);

  // --- Estados Procotiza / NR ---
  const [nrCatalogos, setNrCatalogos] = useState({
    clasificaciones: [],
    estados: [],
    marcas: [],
    modelos: [],
    anios: [],
    versiones: [],
    estrategias: [],
    productos: [],
    productoFiltrado: [],
    planes: [],
    paquetes: [],
    plazos: [],
    subsidios: [],
    tiposSeguro: [],
    segurosVida: [],
    anzen: {},
  });
  const [nrCatalogosLoading, setNrCatalogosLoading] = useState(false);
  const [nrCotizacionLoading, setNrCotizacionLoading] = useState(false);
  const [nrGuardarLoading, setNrGuardarLoading] = useState(false);
  const [nrPdfLoading, setNrPdfLoading] = useState(false);
  const [nrHomologacion, setNrHomologacion] = useState(null);
  const [nrSelectedProduct, setNrSelectedProduct] = useState(null);
  const [nrProductCandidates, setNrProductCandidates] = useState([]);
  const [showNrProductModal, setShowNrProductModal] = useState(false);
  const [nrCotizacion, setNrCotizacion] = useState(null);
  const [nrAnzenCotizacion, setNrAnzenCotizacion] = useState(null);
  const [nrAnzenError, setNrAnzenError] = useState(null);
  const [nrAnzenLoading, setNrAnzenLoading] = useState(false);
  const [nrCotizacionGuardadaId, setNrCotizacionGuardadaId] = useState("");
  const [nrCotizacionPortalId, setNrCotizacionPortalId] = useState("");
  const [nrPdfBase64, setNrPdfBase64] = useState("");
  const [showNrPdfViewer, setShowNrPdfViewer] = useState(false);
  const [nrLastError, setNrLastError] = useState("");
  const [nrLastCotizaRequest, setNrLastCotizaRequest] = useState(null);
  const [nrLastCotizaSignature, setNrLastCotizaSignature] = useState("");
  const [nrLastSavedSignature, setNrLastSavedSignature] = useState("");
  const nrAnzenRequestKeyRef = useRef("");
  // Guarda el último valor de catálogos Anzen para poder devolverlo desde
  // la caché sin depender del objeto memoizado nrCatalogosAnzen (que cambia
  // de referencia en cada setNrCatalogos y por eso no debe ir en las
  // dependencias de cargarCatalogosAnzenNR).
  const nrCatalogosAnzenRef = useRef({});


  //--- estados para manejar el precio del vehiculo
  const [isEditingPrice, setIsEditingPrice] = useState(false);
  const [tempPrice, setTempPrice] = useState("");
  const [originalPrice, setOriginalPrice] = useState("");

  // --- Manejadores de eventos (Handlers) ---
  const handleTipoCompraSeguroChange = (e) => {
    setTipoCompraSeguro(e.target.value);
  };

  const handleTipoComisionChange = (e) => {
    setTipoComision(e.target.value);
  };

  const handleAbrirModalAdicionales = () => {
    setShowModalAdicionales(true);
  };

  //botones de paso 5
  const [selectedPlanFinal, setSelectedPlanFinal] = useState(null);

  const [filters, setFilters] = useState({
    activo: "",
  });

  const [filterOptions, setFilterOptions] = useState({
    activo: [],
    startDate: "",
    endDate: "",
  });

  const [userModules, setUserModules] = useState(
    JSON.parse(localStorage.getItem("modulos")) || [],
  );

  const [agenciaActual, setAgenciaActual] = useState({
    ag_id: null,
    nombre: "",
  });

  // Configurador de cotizador por agencia (NR vs flujo propio de
  // Babilonia): "agencias" ya trae usa_cotizador_nr por agencia (viene de
  // /financiamiento/usuario/agencias, ver cargarAgencias). Se declara aquí
  // arriba, temprano, para poder usarla como candado en los useEffect/
  // useCallback de NR más abajo sin problemas de orden de declaración.
  // Agencia sin match en el listado = NO usa NR (default seguro).
  const agenciaUsaCotizadorNR = useMemo(() => {
    const agId = String(
      selectedMailData?.ag_id ||
        selectedMailData?.agencia_id ||
        agenciaActual?.ag_id ||
        "",
    ).trim();

    if (!agId) return false;

    const match = (Array.isArray(agencias) ? agencias : []).find(
      (ag) => String(ag?.ag_id || "").trim() === agId,
    );

    return Boolean(match?.usa_cotizador_nr);
  }, [selectedMailData, agenciaActual?.ag_id, agencias]);

  const [isDeletingLead, setIsDeletingLead] = useState(false);
  const [isSendingClientAction, setIsSendingClientAction] = useState(false);
  const [showFloatingActions, setShowFloatingActions] = useState(false);
  const floatingActionsRef = useRef(null);
  const isPollingSelectedVentaRef = useRef(false);
  const selectedMailDataRef = useRef(null);
  const notifiedClientPruebaResponsesRef = useRef({});
  const inventarioRequestIdRef = useRef(0);
  const inventarioCacheRef = useRef({});

  // ===== Persistencia local por venta (asesor) =====
  // Regla actual: la BD es la fuente de verdad para planes, meses,
  // enganche, mensualidad y entrevistas. LocalStorage sólo conserva la
  // imagen de licencia, porque ese archivo no se guarda en BD.
  const ASESOR_DRAFT_PREFIX = "babilonia_asesor_draft_v4_";
  const LAST_ASESOR_VENTA_KEY = "babilonia_asesor_last_venta_id";

  const getAsesorDraftKey = useCallback(
    (ventaId = "") => `${ASESOR_DRAFT_PREFIX}${String(ventaId || "")}`,
    [],
  );

  const loadAsesorDraft = useCallback(
    (ventaId = "") => {
      if (!ventaId || typeof window === "undefined") return null;

      try {
        const raw = localStorage.getItem(getAsesorDraftKey(ventaId));
        if (!raw) return null;

        const parsed = JSON.parse(raw);
        if (!parsed || typeof parsed !== "object") return null;

        return {
          venta_id: String(ventaId),
          licenciaManejoFrente: parsed.licenciaManejoFrente || null,
        };
      } catch (error) {
        console.warn("No se pudo leer la licencia local de asesor:", error);
        return null;
      }
    },
    [getAsesorDraftKey],
  );

  const mergeAsesorDraft = useCallback(
    (ventaId = "", patch = {}) => {
      if (!ventaId || typeof window === "undefined") return;

      try {
        const previous = loadAsesorDraft(ventaId) || {};
        const hasLicenciaPatch = Object.prototype.hasOwnProperty.call(
          patch || {},
          "licenciaManejoFrente",
        );

        const nextLicencia = hasLicenciaPatch
          ? patch.licenciaManejoFrente || null
          : previous.licenciaManejoFrente || null;

        if (!nextLicencia) {
          localStorage.removeItem(getAsesorDraftKey(ventaId));
          return;
        }

        const next = {
          venta_id: String(ventaId),
          updated_at: new Date().toISOString(),
          licenciaManejoFrente: nextLicencia,
        };

        localStorage.setItem(getAsesorDraftKey(ventaId), JSON.stringify(next));
      } catch (error) {
        // Si localStorage se llena por una imagen muy pesada, no rompemos la venta.
        console.warn("No se pudo guardar la licencia local de asesor:", error);
      }
    },
    [getAsesorDraftKey, loadAsesorDraft],
  );

  const rememberSelectedVenta = useCallback(() => {
    // Ya no persistimos la venta seleccionada localmente.
  }, []);

  const getRememberedSelectedVentaId = useCallback(() => "", []);

  const forgetSelectedVenta = useCallback(() => {
    if (typeof window === "undefined") return;

    try {
      localStorage.removeItem(LAST_ASESOR_VENTA_KEY);
    } catch {}
  }, []);

  const clearAsesorDraft = useCallback(
    (ventaId = "") => {
      if (!ventaId || typeof window === "undefined") return;

      try {
        localStorage.removeItem(getAsesorDraftKey(ventaId));
      } catch {}
    },
    [getAsesorDraftKey],
  );

  const fileToPersistibleDataURL = useCallback((file) => {
    return new Promise((resolve, reject) => {
      if (!file) {
        resolve(null);
        return;
      }

      const reader = new FileReader();

      reader.onerror = () => reject(reader.error);

      // Para fotos tomadas desde iPad/celular, se comprime antes de guardar
      // para no llenar localStorage y poder reconstruir el archivo al recargar.
      if (String(file.type || "").startsWith("image/")) {
        reader.onload = () => {
          const img = new Image();
          img.onload = () => {
            try {
              const maxSide = 1600;
              const ratio = Math.min(
                maxSide / Math.max(img.width, img.height),
                1,
              );
              const width = Math.max(1, Math.round(img.width * ratio));
              const height = Math.max(1, Math.round(img.height * ratio));
              const canvas = document.createElement("canvas");
              canvas.width = width;
              canvas.height = height;
              const ctx = canvas.getContext("2d");
              ctx.drawImage(img, 0, 0, width, height);

              resolve({
                dataUrl: canvas.toDataURL("image/jpeg", 0.82),
                type: "image/jpeg",
                name: file.name || "licencia-manejo.jpg",
                size: file.size || 0,
                lastModified: file.lastModified || Date.now(),
              });
            } catch (error) {
              reject(error);
            }
          };
          img.onerror = () =>
            reject(new Error("No se pudo procesar la imagen de licencia."));
          img.src = reader.result;
        };

        reader.readAsDataURL(file);
        return;
      }

      reader.onload = () => {
        resolve({
          dataUrl: reader.result,
          type: file.type || "application/octet-stream",
          name: file.name || "licencia-manejo",
          size: file.size || 0,
          lastModified: file.lastModified || Date.now(),
        });
      };

      reader.readAsDataURL(file);
    });
  }, []);

  const dataURLToFile = useCallback(
    async (dataUrl, fileName, mimeType = "") => {
      if (!dataUrl) return null;

      const response = await fetch(dataUrl);
      const blob = await response.blob();
      const type = mimeType || blob.type || "application/octet-stream";

      return new File([blob], fileName || "licencia-manejo", { type });
    },
    [],
  );

  const hydrateLicenciaFromDraft = useCallback(
    async (ventaId = "") => {
      const draft = loadAsesorDraft(ventaId);
      const licencia = draft?.licenciaManejoFrente;

      if (!licencia?.dataUrl) return null;

      try {
        return await dataURLToFile(
          licencia.dataUrl,
          licencia.name || "licencia-manejo.jpg",
          licencia.type || "image/jpeg",
        );
      } catch (error) {
        console.warn("No se pudo restaurar la licencia local:", error);
        return null;
      }
    },
    [dataURLToFile, loadAsesorDraft],
  );

  useEffect(() => {
    selectedMailDataRef.current = selectedMailData;
  }, [selectedMailData]);

  useEffect(() => {
    const handleClickOutsideFloatingActions = (event) => {
      if (
        floatingActionsRef.current &&
        !floatingActionsRef.current.contains(event.target)
      ) {
        setShowFloatingActions(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutsideFloatingActions);
    document.addEventListener("touchstart", handleClickOutsideFloatingActions, {
      passive: true,
    });

    return () => {
      document.removeEventListener(
        "mousedown",
        handleClickOutsideFloatingActions,
      );
      document.removeEventListener(
        "touchstart",
        handleClickOutsideFloatingActions,
      );
    };
  }, []);

  // Tomar correo desde localStorage
  const correoAsesor = (localStorage.getItem("userEmail") ?? "")
    .trim()
    .toLowerCase();

  // Correos permitidos para eliminar lead
  const allowedDeleteEmails = [
    "alombera@gocar.auto",
    "roberto.martinez@gocar.auto",
    "wtorres@gocar.auto",
    "rmaldonado@gocar.auto",
    "336.fi@nissantexcoco.com.mx",
    "jaime.reyesr22@gmail.com",
  ].map((email) => email.toLowerCase());

  // Validación por correo
  const canDeleteLead = allowedDeleteEmails.includes(correoAsesor);

  /*useEffect(() => {
    if (selectedMailData?.accesorios_seleccionados) {
      let accesoriosCliente = [];

      try {
        accesoriosCliente = JSON.parse(
          selectedMailData.accesorios_seleccionados
        );
      } catch (error) {
        console.error("Error al parsear accesorios_seleccionados:", error);
        accesoriosCliente = [];
      }

      if (!Array.isArray(accesoriosCliente)) {
        accesoriosCliente = [];
      }

      const processedAccessories = accesoriosCliente.map((acc) => ({
        title: acc.title,
        status: "Disponible",
        price: `$${acc.price}`,
        descripcion: acc.description,
        imagen: acc.image,
      }));

      setPlans(processedAccessories);
    }
  }, [selectedMailData]);*/

  // Función para convertir una imagen URL a base64 (DataURL)
  function loadImageAsDataURL(url) {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.crossOrigin = "Anonymous"; // Importante para imágenes externas
      img.onload = function () {
        const canvas = document.createElement("canvas");
        canvas.width = img.width;
        canvas.height = img.height;
        const ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0);

        // Detecta el tipo automáticamente (según la URL)
        const isJPG =
          url.toLowerCase().endsWith(".jpg") ||
          url.toLowerCase().endsWith(".jpeg");
        const mimeType = isJPG ? "image/jpeg" : "image/png";

        resolve(canvas.toDataURL(mimeType));
      };
      img.onerror = function () {
        alert("Error: No se pudo cargar la imagen\n" + url);
        reject(new Error("No se pudo cargar la imagen: " + url));
      };
      img.src = url;
    });
  }

  const cargarAgencias = async () => {
    const agenciasStorage = JSON.parse(localStorage.getItem("agencias")); // Recuperar agencias del localStorage
    const accessToken =
      "1MhYphhrGUbgbdRy7cyYFGQlXS7tAi6ooUoptkHQbOm9GcsKiZM7uMF1MERxwMWq30I7Y3"; // El token de acceso

    if (!agenciasStorage || !accessToken) {
      console.error("No hay agencias o access token disponibles.");
      return;
    }

    try {
      const response = await fetch(
        "https://api.checkmark.mx/financiamiento/usuario/agencias",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            access_token: accessToken,
            agencias: agenciasStorage, // Array de agencias enviado al backend
          }),
        },
      );

      const data = await response.json();
      if (response.ok && data.data) {
        setAgencias(data.data); // Guardar agencias en el estado
      } else {
        console.error("Error al cargar las agencias:", data.message);
      }
    } catch (error) {
      console.error("Error en la solicitud:", error);
    }
  };

  const handleMarkLeadAsIncomplete = async () => {
    const ventaId = selectedMailData?.id || formData?.venta_id || "";

    if (!ventaId) {
      Swal.fire({
        icon: "warning",
        title: "Sin registro",
        text: "No se encontró el ID de la venta.",
      });
      return;
    }

    const result = await Swal.fire({
      title: "¿Marcar lead como incompleto?",
      text: 'Esto cambiará el estatus del lead a "Incompleto".',
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Sí, continuar",
      cancelButtonText: "Cancelar",
      confirmButtonColor: "#d33",
    });

    if (!result.isConfirmed) return;

    try {
      setIsDeletingLead(true);

      const resp = await fetch(
        "https://api.checkmark.mx/ventas/marcar-incompleto",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            venta_id: ventaId,
            activo: "Incompleto",
          }),
        },
      );

      const data = await resp.json();

      if (!resp.ok || data.status !== "success") {
        throw new Error(data.message || "No se pudo actualizar el lead");
      }

      Swal.fire({
        icon: "success",
        title: "Lead actualizado",
        text: 'El lead se marcó como "Incompleto".',
        timer: 1800,
        showConfirmButton: false,
      });

      setMailData((prev) =>
        prev.map((item) =>
          String(item.id) === String(ventaId)
            ? { ...item, activo: "Incompleto" }
            : item,
        ),
      );

      setSelectedMailData((prev) =>
        prev ? { ...prev, activo: "Incompleto" } : prev,
      );
    } catch (error) {
      console.error("Error al marcar lead como incompleto:", error);

      Swal.fire({
        icon: "error",
        title: "Error",
        text: error.message || "Ocurrió un error al actualizar el lead.",
      });
    } finally {
      setIsDeletingLead(false);
    }
  };

  const getVentaIdForClientActions = () => {
    return selectedMailData?.id || formData?.venta_id || "";
  };

  const updateSelectedVentaClientFlags = (ventaId, updates = {}) => {
    setMailData((prev) =>
      prev.map((item) =>
        String(item.id) === String(ventaId) ? { ...item, ...updates } : item,
      ),
    );

    setSelectedMailData((prev) =>
      prev && String(prev.id) === String(ventaId)
        ? { ...prev, ...updates }
        : prev,
    );
  };

  const handleSimularVolverInventarioCliente = async () => {
    const ventaId = getVentaIdForClientActions();

    if (!ventaId) {
      Swal.fire({
        icon: "warning",
        title: "Sin venta seleccionada",
        text: "Selecciona una venta para enviar la instrucción al cliente.",
      });
      return;
    }

    const result = await Swal.fire({
      title: "¿Simular volver a inventario?",
      text: "Esto hará que el cliente regrese al inventario en cuanto su pantalla detecte la instrucción.",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Sí, enviar",
      cancelButtonText: "Cancelar",
      confirmButtonColor: "#0d6efd",
    });

    if (!result.isConfirmed) return;

    try {
      setIsSendingClientAction(true);

      const resp = await fetch(
        "https://api.checkmark.mx/ventas/cliente/volver-inventario",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            access_token: accessToken,
            venta_id: ventaId,
          }),
        },
      );

      const data = await resp.json();

      if (!resp.ok || data.status !== "success") {
        throw new Error(
          data.message || "No se pudo enviar la instrucción al cliente.",
        );
      }

      updateSelectedVentaClientFlags(ventaId, {
        cliente_volver_inventario: 1,
        cliente_volver_inventario_fecha: new Date().toISOString(),
      });

      Swal.fire({
        icon: "success",
        title: "Instrucción enviada",
        text: "El cliente será regresado al inventario cuando su pantalla detecte el cambio.",
        timer: 1800,
        showConfirmButton: false,
      });
    } catch (error) {
      console.error("Error al simular volver a inventario:", error);

      Swal.fire({
        icon: "error",
        title: "Error",
        text: error.message || "Ocurrió un error al enviar la instrucción.",
      });
    } finally {
      setIsSendingClientAction(false);
    }
  };

  const handleSolicitarPruebaManejoCliente = async () => {
    const ventaId = getVentaIdForClientActions();

    if (!ventaId) {
      Swal.fire({
        icon: "warning",
        title: "Sin venta seleccionada",
        text: "Selecciona una venta para solicitar la prueba de manejo al cliente.",
      });
      return;
    }

    const result = await Swal.fire({
      title: "¿Solicitar prueba de manejo?",
      text: "Al cliente se le abrirá una alerta para aceptar o rechazar la prueba de manejo. Si acepta, contestará la encuesta.",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Sí, solicitar",
      cancelButtonText: "Cancelar",
      confirmButtonColor: "#ffc107",
    });

    if (!result.isConfirmed) return;

    try {
      setIsSendingClientAction(true);

      const resp = await fetch(
        "https://api.checkmark.mx/ventas/cliente/solicitar-prueba-manejo",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            access_token: accessToken,
            venta_id: ventaId,
          }),
        },
      );

      const data = await resp.json();

      if (!resp.ok || data.status !== "success") {
        throw new Error(
          data.message || "No se pudo solicitar la prueba de manejo.",
        );
      }

      updateSelectedVentaClientFlags(ventaId, {
        solicitar_prueba_manejo_cliente: 1,
        solicitar_prueba_manejo_fecha: new Date().toISOString(),
        respuesta_prueba_manejo_cliente: null,
        respuesta_prueba_manejo_fecha: null,
        prueba_manejo: "",
      });

      setPruebaManejoData({ ...pruebaManejoInicial });
      setLicenciaManejoFrente(null);
      mergeAsesorDraft(ventaId, {
        pruebaManejoData: { ...pruebaManejoInicial },
        licenciaManejoFrente: null,
      });

      Swal.fire({
        icon: "success",
        title: "Solicitud enviada",
        text: "El cliente recibirá la alerta para responder la prueba de manejo.",
        timer: 1800,
        showConfirmButton: false,
      });
    } catch (error) {
      console.error("Error al solicitar prueba de manejo al cliente:", error);

      Swal.fire({
        icon: "error",
        title: "Error",
        text: error.message || "Ocurrió un error al solicitar la prueba.",
      });
    } finally {
      setIsSendingClientAction(false);
    }
  };

  const finalizarVentaClienteDesdeGuardar = async (ventaIdParam = null) => {
    const ventaId =
      ventaIdParam || selectedMailData?.id || formData?.venta_id || "";

    if (!ventaId) {
      return {
        ok: false,
        message: "No se encontró el ID de la venta para finalizar al cliente.",
      };
    }

    try {
      const resp = await fetch(
        "https://api.checkmark.mx/ventas/cliente/finalizar",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            access_token: accessToken,
            venta_id: ventaId,
            usuario_id:
              localStorage.getItem("userId") || formData?.user_id || "",
            nombre_asesor:
              localStorage.getItem("userName") || formData?.asesor || "",
          }),
        },
      );

      const data = await resp.json();

      if (!resp.ok || data.status !== "success") {
        throw new Error(
          data.message || "No se pudo finalizar la venta del cliente.",
        );
      }

      updateSelectedVentaClientFlags(ventaId, {
        venta_finalizada_cliente: 1,
        venta_finalizada_cliente_fecha:
          data?.data?.venta_finalizada_cliente_fecha ||
          new Date().toISOString(),
        venta_finalizada_cliente_usuario_id:
          data?.data?.venta_finalizada_cliente_usuario_id ||
          localStorage.getItem("userId") ||
          formData?.user_id ||
          null,
        venta_finalizada_cliente_nombre:
          data?.data?.venta_finalizada_cliente_nombre ||
          localStorage.getItem("userName") ||
          formData?.asesor ||
          "",
      });

      return {
        ok: true,
        message: data.message || "Venta del cliente finalizada correctamente.",
      };
    } catch (error) {
      console.error("Error al finalizar venta del cliente:", error);
      return {
        ok: false,
        message: error.message || "No se pudo finalizar la venta del cliente.",
      };
    }
  };

  // Efecto para cargar agencias al montar el componente
  useEffect(() => {
    cargarAgencias();
  }, []);

  // Manejar cambios en el select
  const handleChange = (e) => {
    setSelectedAgencia(e.target.value);
  };

  const accessToken =
    "1MhYphhrGUbgbdRy7cyYFGQlXS7tAi6ooUoptkHQbOm9GcsKiZM7uMF1MERxwMWq30I7Y3"; // El token de acceso
  const apiUrl = "https://api.checkmark.mx/ventas/telefono/consultar"; // La URL de la API

  /************* VISOR DE FICHA TÉCNICA *************/
  const [openFicha, setOpenFicha] = useState(false);
  const [fichaURL, setFichaURL] = useState("");
  const isOpeningFichaRef = useRef(false);
  const [openGaleriaSeminuevo, setOpenGaleriaSeminuevo] = useState(false);
  const [galeriaSeminuevoImages, setGaleriaSeminuevoImages] = useState([]);
  const [galeriaSeminuevoIndex, setGaleriaSeminuevoIndex] = useState(0);
  const [loadingGaleriaSeminuevo, setLoadingGaleriaSeminuevo] = useState(false);

  const proxyFichaTecnicaNuevoUrl =
    "https://api.checkmark.mx/proxy/ficha-tecnica-nuevo";
  const babiloniaSeminuevoImagenesUrl =
    "https://api.checkmark.mx/babilonia/seminuevos/imagenes";

  const cleanPdfPath = (value = "") =>
    String(value || "")
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .replace(/[^\w\s-]/g, "")
      .replace(/\s+/g, "-")
      .toLowerCase();

  const normalizePossibleJsonString = useCallback(
    (value = "") =>
      String(value || "")
        .trim()
        .replace(/^\uFEFF/, "")
        .replace(/&quot;/g, '"')
        .replace(/&#34;/g, '"')
        .replace(/\\u002F/gi, "/")
        .replace(/\\\//g, "/"),
    [],
  );

  const parseJsonSafe = useCallback(
    (value) => {
      if (!value) return null;

      if (typeof value === "object") return value;

      let parsed = normalizePossibleJsonString(value);

      for (let i = 0; i < 5; i += 1) {
        if (parsed && typeof parsed === "object") return parsed;
        if (typeof parsed !== "string") break;

        let cleanValue = normalizePossibleJsonString(parsed);
        if (!cleanValue) return null;

        try {
          parsed = JSON.parse(cleanValue);
          continue;
        } catch {}

        // A veces selected_car llega como texto JSON escapado, pero sin poder
        // parsearse directamente por comillas extra o por doble escape.
        try {
          const unescaped = cleanValue
            .replace(/^"+|"+$/g, "")
            .replace(/\\"/g, '"')
            .replace(/\\\\/g, "\\")
            .replace(/\\\//g, "/");

          parsed = JSON.parse(unescaped);
          continue;
        } catch {}

        // Fallback: intenta rescatar el objeto si el backend lo manda envuelto
        // en texto adicional.
        const firstBrace = cleanValue.indexOf("{");
        const lastBrace = cleanValue.lastIndexOf("}");

        if (firstBrace >= 0 && lastBrace > firstBrace) {
          try {
            parsed = JSON.parse(cleanValue.slice(firstBrace, lastBrace + 1));
            continue;
          } catch {}
        }

        return null;
      }

      return parsed && typeof parsed === "object" ? parsed : null;
    },
    [normalizePossibleJsonString],
  );

  const getValueByKeys = (source = {}, keys = []) => {
    if (!source || typeof source !== "object") return "";

    const entries = Object.entries(source);
    const normalizedMap = entries.reduce((acc, [key, value]) => {
      acc[
        String(key || "")
          .toLowerCase()
          .replace(/[\s_-]/g, "")
      ] = value;
      return acc;
    }, {});

    for (const key of keys) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        return source[key];
      }

      const normalizedKey = String(key || "")
        .toLowerCase()
        .replace(/[\s_-]/g, "");

      if (Object.prototype.hasOwnProperty.call(normalizedMap, normalizedKey)) {
        return normalizedMap[normalizedKey];
      }
    }

    return "";
  };

  const getFirstFilledValue = (...values) =>
    values.find((value) => {
      if (value === null || value === undefined) return false;
      return String(value).trim() !== "";
    }) || "";

  const getSelectedCarFromVenta = (venta = selectedMailData) => {
    if (!venta) return null;

    return (
      parseJsonSafe(venta.selected_car) ||
      parseJsonSafe(venta.selectedCar) ||
      parseJsonSafe(venta.selected_car_json) ||
      parseJsonSafe(venta.selectedCarJson) ||
      parseJsonSafe(venta.vehiculo_seleccionado) ||
      parseJsonSafe(venta.vehiculoSeleccionado) ||
      null
    );
  };

  const normalizeFichaTecnicaUrl = (url = "") => {
    let raw = normalizePossibleJsonString(url);

    if (!raw) return "";

    // Si llega como string JSON, por ejemplo:
    // "\"https:\/\/www.nissan.com.mx\/...\/catalogo.pdf\""
    try {
      const parsed = JSON.parse(raw);
      if (typeof parsed === "string") {
        raw = normalizePossibleJsonString(parsed);
      }
    } catch {}

    raw = raw.replace(/^"+|"+$/g, "").trim();

    if (!raw) return "";

    if (raw.startsWith("//")) {
      return `https:${raw}`;
    }

    if (raw.startsWith("/content/") || raw.startsWith("/etc/")) {
      return `https://www.nissan.com.mx${raw}`;
    }

    return raw;
  };

  const isValidPdfCandidateUrl = (url = "") => {
    const normalized = normalizeFichaTecnicaUrl(url);
    if (!normalized) return false;

    return (
      /^(blob:|data:|https?:\/\/|\/\/|\/)/i.test(normalized) ||
      /\.pdf($|[?#])/i.test(normalized)
    );
  };

  const shouldUseNuevoPdfProxy = (url = "") => {
    const raw = normalizeFichaTecnicaUrl(url);

    if (!/^https?:\/\//i.test(raw)) return false;

    try {
      const parsed = new URL(raw);
      const hostname = parsed.hostname.toLowerCase();
      const currentHostname =
        typeof window !== "undefined"
          ? window.location.hostname.toLowerCase()
          : "";

      if (
        raw.startsWith(proxyFichaTecnicaNuevoUrl) ||
        hostname === "local.apicheckmark.mx" ||
        hostname === "localhost" ||
        hostname === currentHostname
      ) {
        return false;
      }

      return true;
    } catch {
      return false;
    }
  };

  const buildFichaTecnicaUrl = (url = "") => {
    const normalized = normalizeFichaTecnicaUrl(url);

    if (!normalized) return "";

    if (normalized.startsWith(proxyFichaTecnicaNuevoUrl)) {
      return normalized;
    }

    if (shouldUseNuevoPdfProxy(normalized)) {
      return `${proxyFichaTecnicaNuevoUrl}?url=${encodeURIComponent(
        normalized,
      )}`;
    }

    return normalized;
  };

  const getDirectPdfUrl = (venta = {}) => {
    const selectedCar = getSelectedCarFromVenta(venta);

    const pdfKeys = [
      "ficha_tecnica_vehiculo",
      "fichaTecnicaVehiculo",
      "url_ficha_tecnica",
      "urlFichaTecnica",
      "ficha_tecnica",
      "fichaTecnica",
      "ficha_tecnica_url",
      "fichaTecnicaUrl",
      "url_ficha",
      "urlFicha",
      "folleto_pdf",
      "folletoPdf",
      "pdf_ficha",
      "pdfFicha",
      "catalogo_pdf",
      "catalogoPdf",
      "pdf",
    ];

    const candidates = [
      getValueByKeys(selectedCar, pdfKeys),
      selectedCar?.ficha_tecnica_vehiculo,
      selectedCar?.url_ficha_tecnica,
      selectedCar?.ficha_tecnica,
      selectedCar?.fichaTecnica,
      selectedCar?.ficha_tecnica_url,
      selectedCar?.url_ficha,
      selectedCar?.folleto_pdf,
      selectedCar?.pdf_ficha,
      selectedCar?.catalogo_pdf,
      selectedCar?.pdf,

      getValueByKeys(venta, pdfKeys),
      venta.ficha_tecnica_vehiculo,
      venta.ficha_tecnica_url,
      venta.url_ficha_tecnica,
      venta.ficha_tecnica,
      venta.fichaTecnica,
      venta.url_ficha,
      venta.folleto_pdf,
      venta.pdf_ficha,
      venta.catalogo_pdf,
      venta.pdf,
    ];

    const directPdf = candidates
      .map(normalizeFichaTecnicaUrl)
      .find((candidate) => isValidPdfCandidateUrl(candidate));

    if (directPdf) {
    } else {
      console.warn("No se detectó URL de PDF en la venta:", {
        selectedCar,
        venta,
      });
    }

    return directPdf || "";
  };

  const getUsedIdFromUrlImg = (urlImg = "") => {
    try {
      const cleanUrl = String(urlImg || "").trim();
      if (!cleanUrl) return "";

      // Ejemplo:
      // https://carplanet.mx//view/img/jpgs/63e3bc1ddb3e6/63f8e996b7fd1/big/KIA-Sorento-2016-1.jpg
      // El used_id es el segmento antes de /big/: 63f8e996b7fd1
      const match = cleanUrl.match(/\/([^/]+)\/big\//i);
      if (match?.[1]) return match[1];

      // Fallback por si cambia la estructura pero conserva /jpgs/{grupo}/{used_id}/...
      const parts = cleanUrl.split("/").filter(Boolean);
      const jpgsIndex = parts.findIndex(
        (part) => part.toLowerCase() === "jpgs",
      );
      if (jpgsIndex >= 0 && parts[jpgsIndex + 2]) {
        return parts[jpgsIndex + 2];
      }

      return "";
    } catch (error) {
      console.warn("No se pudo obtener used_id desde url_img:", error);
      return "";
    }
  };

  const getTipoAutoFromVenta = (venta = {}) => {
    const selectedCar = getSelectedCarFromVenta(venta);

    return String(
      getFirstFilledValue(
        selectedCar?.type,
        selectedCar?.tipo,
        selectedCar?.tipo_auto,
        venta?.type,
        venta?.tipo_auto,
        venta?.tipo_vehiculo,
      ),
    )
      .toLowerCase()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "");
  };

  const getUsedIdSeminuevoFromVenta = (venta = selectedMailData) => {
    const selectedCar = getSelectedCarFromVenta(venta);

    return String(
      getFirstFilledValue(
        selectedCar?.used_id,
        selectedCar?.usedId,
        selectedCar?.imgs_id,
        selectedCar?.imgsId,
        selectedCar?.id_publicacion,
        venta?.used_id,
        venta?.usedId,
        venta?.imgs_id,
        venta?.imgsId,
        venta?.id_publicacion,
        getUsedIdFromUrlImg(
          selectedCar?.url_img ||
            selectedCar?.urlImg ||
            selectedCar?.img ||
            selectedCar?.image ||
            venta?.url_img ||
            venta?.urlImg ||
            venta?.img ||
            venta?.image,
        ),
        selectedCar?.id_vehiculo,
        selectedCar?.vehiculo_id,
        venta?.id_vehiculo,
        venta?.vehiculo_id,
      ),
    ).trim();
  };

  const normalizarImagenesSeminuevo = (payload = {}) => {
    const data = payload?.data || payload || {};
    const baseImages = Array.isArray(data.images)
      ? data.images
      : Array.isArray(data.thumb)
        ? data.thumb
        : [];

    const images = baseImages
      .map((item) => {
        if (!item) return "";
        if (typeof item === "string") return item;
        return item.url || item.src || item.large || item.thumb || "";
      })
      .map((url) => String(url || "").trim())
      .filter(Boolean);

    return images.length ? images : ["/assets/img/product/noimage.png"];
  };

  const abrirGaleriaFotosSeminuevo = useCallback(async () => {
    if (loadingGaleriaSeminuevo) return;

    if (!selectedMailData) {
      Swal.fire(
        "Sin venta seleccionada",
        "Selecciona una venta para ver las fotos del seminuevo.",
        "info",
      );
      return;
    }

    const tipoAuto = getTipoAutoFromVenta(selectedMailData);
    const esSeminuevo = tipoAuto.includes("seminuevo");

    if (!esSeminuevo) {
      Swal.fire(
        "No disponible",
        "La galería de fotos sólo aplica para seminuevos.",
        "info",
      );
      return;
    }

    const usedId = getUsedIdSeminuevoFromVenta(selectedMailData);

    if (!usedId) {
      Swal.fire(
        "Sin used_id",
        "No se encontró el used_id del seminuevo seleccionado.",
        "warning",
      );
      return;
    }

    try {
      setLoadingGaleriaSeminuevo(true);

      const response = await fetch(babiloniaSeminuevoImagenesUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          used_id: usedId,
        }),
      });

      const data = await response.json();

      if (!response.ok || data?.status !== "success") {
        throw new Error(
          data?.message || "No se pudieron obtener las fotos del seminuevo.",
        );
      }

      setGaleriaSeminuevoImages(normalizarImagenesSeminuevo(data));
      setGaleriaSeminuevoIndex(0);
      setOpenGaleriaSeminuevo(true);
    } catch (error) {
      console.error("Error al obtener fotos del seminuevo:", error);

      Swal.fire(
        "No se pudieron cargar las fotos",
        error.message || "Ocurrió un error al consultar las imágenes.",
        "error",
      );
    } finally {
      setLoadingGaleriaSeminuevo(false);
    }
  }, [
    babiloniaSeminuevoImagenesUrl,
    loadingGaleriaSeminuevo,
    selectedMailData,
  ]);

  const abrirFichaTecnica = useCallback(() => {
    if (isOpeningFichaRef.current) return;
    isOpeningFichaRef.current = true;

    try {
      if (!selectedMailData) {
        Swal.fire(
          "Sin venta seleccionada",
          "Selecciona una venta para abrir la ficha técnica.",
          "info",
        );
        return;
      }

      const selectedCarVenta = getSelectedCarFromVenta(selectedMailData);
      const tipoAuto = getTipoAutoFromVenta(selectedMailData);
      const esSeminuevo = tipoAuto.includes("seminuevo");

      // Para autos nuevos, primero intenta abrir la URL directa guardada en
      // selected_car. Tu ejemplo trae ficha_tecnica_vehiculo/pdf/url_ficha_tecnica.
      const directPdf = getDirectPdfUrl(selectedMailData);

      if (directPdf && !esSeminuevo) {
        const finalUrl = buildFichaTecnicaUrl(directPdf);
        setFichaURL(finalUrl);
        setOpenFicha(true);
        return;
      }

      if (esSeminuevo) {
        const agId = getFirstFilledValue(
          selectedCarVenta?.ag_id,
          selectedMailData?.ag_id,
          selectedMailData?.agencia_id,
        );

        const usedId = getFirstFilledValue(
          selectedCarVenta?.used_id,
          selectedMailData?.used_id,
          selectedMailData?.id_publicacion,
          selectedMailData?.id_vehiculo,
          selectedMailData?.vehiculo_id,
          selectedMailData?.auto_id,
          getUsedIdFromUrlImg(
            selectedCarVenta?.url_img ||
              selectedCarVenta?.image ||
              selectedMailData?.url_img,
          ),
        );

        if (!agId || !usedId) {
          // Si el seminuevo trae un PDF directo, úsalo como fallback.
          if (directPdf) {
            const finalUrl = buildFichaTecnicaUrl(directPdf);
            setFichaURL(finalUrl);
            setOpenFicha(true);
            return;
          }

          Swal.fire(
            "Ficha no disponible",
            "Este seminuevo no trae ag_id o used_id, y tampoco se pudo obtener desde url_img.",
            "warning",
          );
          return;
        }

        setFichaURL(
          `https://api.checkmark.mx/proxy/folleto?access_token=${accessToken}&ag_id=${encodeURIComponent(
            agId,
          )}&used_id=${encodeURIComponent(cleanPdfPath(usedId))}`,
        );
        setOpenFicha(true);
        return;
      }

      // Si no se detectó como nuevo ni seminuevo, de todos modos intenta abrir
      // cualquier PDF directo que exista.
      if (directPdf) {
        const finalUrl = buildFichaTecnicaUrl(directPdf);
        setFichaURL(finalUrl);
        setOpenFicha(true);
        return;
      }

      Swal.fire(
        "Ficha no disponible",
        "Esta venta no trae una URL de ficha técnica válida en selected_car.",
        "warning",
      );
    } finally {
      setTimeout(() => {
        isOpeningFichaRef.current = false;
      }, 600);
    }
  }, [accessToken, selectedMailData]);
  // ===== Protección temporal contra polling viejo de financiamiento =====
  // Cuando el asesor cambia meses, enganche o mensualidad, la API puede tardar
  // unos segundos en regresar el valor nuevo. Este parche conserva el valor
  // recién enviado sólo de forma temporal para evitar parpadeos/intermitencia.
  const localFinancingPatchRef = useRef({
    ventaId: "",
    expiresAt: 0,
    patch: {},
  });
  const markLocalFinancingPatch = useCallback((ventaId = "", patch = {}) => {
    const safeVentaId = String(ventaId || "");
    if (!safeVentaId) return;

    localFinancingPatchRef.current = {
      ventaId: safeVentaId,
      expiresAt: Date.now() + 30000,
      patch: {
        ...(localFinancingPatchRef.current?.ventaId === safeVentaId
          ? localFinancingPatchRef.current?.patch || {}
          : {}),
        ...patch,
      },
    };
  }, []);

  const mergeLocalFinancingPatch = useCallback((venta = {}) => {
    const current = localFinancingPatchRef.current || {};
    const ventaId = String(venta?.id || "");

    if (!ventaId || String(current.ventaId || "") !== ventaId) {
      return venta;
    }

    if (Date.now() > Number(current.expiresAt || 0)) {
      localFinancingPatchRef.current = { ventaId: "", expiresAt: 0, patch: {} };
      return venta;
    }

    return {
      ...venta,
      ...(current.patch || {}),
    };
  }, []);

  const clearLocalFinancingPatchIfConfirmed = useCallback((venta = {}) => {
    const current = localFinancingPatchRef.current || {};
    const ventaId = String(venta?.id || "");

    if (!ventaId || String(current.ventaId || "") !== ventaId) return;

    const patch = current.patch || {};
    const keys = Object.keys(patch);
    if (!keys.length) return;

    const confirmed = keys.every((key) => {
      const expected = patch[key];
      const received = venta?.[key];

      if (expected === undefined || expected === null || expected === "") {
        return true;
      }

      if (typeof expected === "number" || !Number.isNaN(Number(expected))) {
        return toNumber(expected) === toNumber(received);
      }

      return String(expected ?? "") === String(received ?? "");
    });

    if (confirmed) {
      localFinancingPatchRef.current = { ventaId: "", expiresAt: 0, patch: {} };
    }
  }, []);

  // ===== Protección temporal de entrevista contra polling viejo =====
  // Cuando el asesor responde Sabone o Consulta, el backend puede tardar en
  // regresar el JSON actualizado. Guardamos un parche local por venta para que
  // el polling no vuelva a pintar respuestas anteriores mientras confirma BD.
  const localInterviewPatchRef = useRef({
    ventaId: "",
    expiresAt: 0,
    entrevista: null,
    entrevista_nissan: null,
  });

  const getActiveLocalInterviewPatch = useCallback((ventaId = "") => {
    const current = localInterviewPatchRef.current || {};
    const safeVentaId = String(ventaId || "");

    if (!safeVentaId || String(current.ventaId || "") !== safeVentaId) {
      return null;
    }

    if (Date.now() > Number(current.expiresAt || 0)) {
      localInterviewPatchRef.current = {
        ventaId: "",
        expiresAt: 0,
        entrevista: null,
        entrevista_nissan: null,
      };
      return null;
    }

    return current;
  }, []);

  const mergeLocalInterviewPatch = useCallback(
    (venta = {}) => {
      const ventaId = String(venta?.id || "");
      const patch = getActiveLocalInterviewPatch(ventaId);
      if (!patch) return venta;

      let next = { ...venta };

      if (patch.entrevista && typeof patch.entrevista === "object") {
        const currentEntrevista = parseJsonSafe(next.entrevista) || {};
        next.entrevista = JSON.stringify({
          ...currentEntrevista,
          ...patch.entrevista,
        });
      }

      if (
        patch.entrevista_nissan &&
        typeof patch.entrevista_nissan === "object"
      ) {
        const currentNissan = parseJsonSafe(next.entrevista_nissan) || {};
        next.entrevista_nissan = JSON.stringify({
          ...currentNissan,
          ...patch.entrevista_nissan,
        });
      }

      return next;
    },
    [getActiveLocalInterviewPatch, parseJsonSafe],
  );

  const markLocalInterviewPatch = useCallback((ventaId = "", patch = {}) => {
    const safeVentaId = String(ventaId || "");
    if (!safeVentaId) return;

    const current =
      String(localInterviewPatchRef.current?.ventaId || "") === safeVentaId
        ? localInterviewPatchRef.current || {}
        : {};

    const nextPatch = {
      ventaId: safeVentaId,
      expiresAt: Date.now() + 10 * 60 * 1000,
      entrevista: patch.entrevista
        ? {
            ...(current.entrevista || {}),
            ...(patch.entrevista || {}),
          }
        : current.entrevista || null,
      entrevista_nissan: patch.entrevista_nissan
        ? {
            ...(current.entrevista_nissan || {}),
            ...(patch.entrevista_nissan || {}),
          }
        : current.entrevista_nissan || null,
    };

    localInterviewPatchRef.current = nextPatch;
  }, []);

  const patchSelectedVentaInterviewLocal = useCallback(
    (ventaId = "", patch = {}) => {
      const safeVentaId = String(ventaId || "");
      if (!safeVentaId) return;

      const applyPatch = (venta = {}) => {
        if (!venta || String(venta?.id || "") !== safeVentaId) return venta;

        let next = { ...venta };

        if (patch.entrevista && typeof patch.entrevista === "object") {
          const currentEntrevista = parseJsonSafe(next.entrevista) || {};
          next.entrevista = JSON.stringify({
            ...currentEntrevista,
            ...patch.entrevista,
          });
        }

        if (
          patch.entrevista_nissan &&
          typeof patch.entrevista_nissan === "object"
        ) {
          const currentNissan = parseJsonSafe(next.entrevista_nissan) || {};
          next.entrevista_nissan = JSON.stringify({
            ...currentNissan,
            ...patch.entrevista_nissan,
          });
        }

        return next;
      };

      markLocalInterviewPatch(safeVentaId, patch);

      selectedMailDataRef.current = applyPatch(
        selectedMailDataRef.current || {},
      );

      setSelectedMailData((prev) => applyPatch(prev));
      setMailData((prev) =>
        Array.isArray(prev)
          ? prev.map((item) =>
              String(item?.id || "") === safeVentaId ? applyPatch(item) : item,
            )
          : prev,
      );
    },
    [markLocalInterviewPatch, parseJsonSafe],
  );

  // ===== Protección temporal de datos personales contra polling viejo =====
  // Cuando el asesor edita nombre, teléfono o correo en el paso 1, la API puede
  // tardar unos segundos en regresar las columnas actualizadas. Este parche local
  // evita que el polling vuelva a pintar el valor anterior mientras se confirma.
  const localPersonalDataPatchRef = useRef({
    ventaId: "",
    expiresAt: 0,
    patch: {},
  });

  const getActiveLocalPersonalDataPatch = useCallback((ventaId = "") => {
    const current = localPersonalDataPatchRef.current || {};
    const safeVentaId = String(ventaId || "");

    if (!safeVentaId || String(current.ventaId || "") !== safeVentaId) {
      return null;
    }

    if (Date.now() > Number(current.expiresAt || 0)) {
      localPersonalDataPatchRef.current = {
        ventaId: "",
        expiresAt: 0,
        patch: {},
      };
      return null;
    }

    return current.patch || {};
  }, []);

  const markLocalPersonalDataPatch = useCallback((ventaId = "", patch = {}) => {
    const safeVentaId = String(ventaId || "");
    if (!safeVentaId) return;

    const current =
      String(localPersonalDataPatchRef.current?.ventaId || "") === safeVentaId
        ? localPersonalDataPatchRef.current || {}
        : {};

    localPersonalDataPatchRef.current = {
      ventaId: safeVentaId,
      expiresAt: Date.now() + 10 * 60 * 1000,
      patch: {
        ...(current.patch || {}),
        ...(patch || {}),
      },
    };
  }, []);

  const clearLocalPersonalDataPatchIfConfirmed = useCallback((venta = {}) => {
    const current = localPersonalDataPatchRef.current || {};
    const ventaId = String(venta?.id || "");

    if (!ventaId || String(current.ventaId || "") !== ventaId) return;

    const patch = current.patch || {};
    const confirmed = Object.keys(patch).every((key) => {
      return String(venta?.[key] ?? "") === String(patch?.[key] ?? "");
    });

    if (confirmed) {
      localPersonalDataPatchRef.current = {
        ventaId: "",
        expiresAt: 0,
        patch: {},
      };
    }
  }, []);

  const mergeLocalPersonalDataPatch = useCallback(
    (venta = {}) => {
      const ventaId = String(venta?.id || "");
      const patch = getActiveLocalPersonalDataPatch(ventaId);
      if (!patch) return venta;

      return {
        ...venta,
        ...patch,
      };
    },
    [getActiveLocalPersonalDataPatch],
  );

  const patchSelectedVentaPersonalLocal = useCallback(
    (ventaId = "", patch = {}) => {
      const safeVentaId = String(ventaId || "");
      if (!safeVentaId || !patch || !Object.keys(patch).length) return;

      markLocalPersonalDataPatch(safeVentaId, patch);

      const applyPatch = (venta = {}) => {
        if (!venta || String(venta?.id || "") !== safeVentaId) return venta;

        return {
          ...venta,
          ...patch,
        };
      };

      selectedMailDataRef.current = applyPatch(selectedMailDataRef.current || {});

      setSelectedMailData((prev) => applyPatch(prev));
      setMailData((prev) =>
        Array.isArray(prev)
          ? prev.map((item) =>
              String(item?.id || "") === safeVentaId ? applyPatch(item) : item,
            )
          : prev,
      );
    },
    [markLocalPersonalDataPatch],
  );

  // Función para obtener los datos desde la API
  const fetchData = async (currentFilters = filters) => {
    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          access_token: accessToken,
          ...currentFilters,
        }),
      });

      const data = await response.json();

      if (data.statusCode === 200) {
        // Verifica si hay resultados y asigna correctamente a mailData
        if (
          Array.isArray(data.data.resultados) &&
          data.data.resultados.length > 0
        ) {
          // Procesar los datos
          const processedData = data.data.resultados.map((cliente) => {
            const mergedCliente = mergeLocalPersonalDataPatch(
              mergeLocalInterviewPatch(
                mergeLocalFinancingPatch({
                  ...cliente,
                }),
              ),
            );

            clearLocalFinancingPatchIfConfirmed(cliente);
            clearLocalPersonalDataPatchIfConfirmed(cliente);

            return mergedCliente;
          });

          setMailData(processedData);

          // Escucha activa: solo sincronizamos una venta si el asesor YA seleccionó una.
          // Importante: NO recuperamos automáticamente la última venta de localStorage,
          // porque eso hacía que al abrir la pantalla se seleccionara sola una venta
          // y se disparara el aviso de prueba de manejo sin interacción del asesor.
          const ventaSeleccionadaActual = selectedMailDataRef.current;
          const ventaIdObjetivo = ventaSeleccionadaActual?.id || "";

          if (ventaIdObjetivo) {
            const ventaActualizada = processedData.find(
              (cliente) => String(cliente.id) === String(ventaIdObjetivo),
            );

            if (ventaActualizada) {
              const normalizarRespuestaPolling = (value = "") => {
                const limpio = normalizarTexto(value);
                if (
                  ["si", "s", "1", "true", "acepto", "aceptado"].includes(
                    limpio,
                  )
                )
                  return "Si";
                if (
                  ["no", "n", "0", "false", "rechazo", "rechazado"].includes(
                    limpio,
                  )
                )
                  return "No";
                if (limpio.includes("acept")) return "Si";
                if (limpio.includes("rechaz") || limpio.includes("declin"))
                  return "No";
                return "";
              };

              const respuestaAnterior = normalizarRespuestaPolling(
                ventaSeleccionadaActual?.respuesta_prueba_manejo_cliente || "",
              );
              const respuestaNueva = normalizarRespuestaPolling(
                ventaActualizada?.respuesta_prueba_manejo_cliente || "",
              );

              const notificationKey = [
                ventaActualizada?.id || "",
                respuestaNueva || "sin-respuesta",
                ventaActualizada?.respuesta_prueba_manejo_fecha ||
                  ventaActualizada?.solicitar_prueba_manejo_fecha ||
                  "sin-fecha",
              ].join("|");

              const shouldPreserveInterviewWhileEditing =
                isUserEditing.current ||
                Boolean(activeFinancingEditRef.current) ||
                isEditingFinancingModalRef.current ||
                Boolean(getActiveLocalInterviewPatch(ventaIdObjetivo));

              const personalPatchActivo =
                getActiveLocalPersonalDataPatch(ventaIdObjetivo) || {};

              const shouldPreservePersonalWhileEditing =
                isUserEditing.current ||
                Boolean(Object.keys(personalPatchActivo || {}).length);

              const ventaParaEstado = shouldPreserveInterviewWhileEditing
                ? {
                    ...ventaActualizada,
                    ...(shouldPreservePersonalWhileEditing
                      ? {
                          nombre:
                            ventaSeleccionadaActual?.nombre ??
                            ventaActualizada?.nombre,
                          telefono:
                            ventaSeleccionadaActual?.telefono ??
                            ventaActualizada?.telefono,
                          correo_electronico:
                            ventaSeleccionadaActual?.correo_electronico ??
                            ventaActualizada?.correo_electronico,
                          ...personalPatchActivo,
                        }
                      : {}),
                    entrevista: ventaSeleccionadaActual?.entrevista,
                    entrevista_nissan:
                      ventaSeleccionadaActual?.entrevista_nissan,
                  }
                : {
                    ...ventaActualizada,
                    ...personalPatchActivo,
                  };

              setSelectedMailData(ventaParaEstado);
              selectedMailDataRef.current = ventaParaEstado;

              if (
                respuestaNueva &&
                respuestaNueva !== respuestaAnterior &&
                !notifiedClientPruebaResponsesRef.current[notificationKey]
              ) {
                notifiedClientPruebaResponsesRef.current[notificationKey] =
                  true;

                Swal.fire({
                  toast: true,
                  position: "top-end",
                  icon: "success",
                  title:
                    respuestaNueva === "Si"
                      ? "El cliente aceptó la prueba de manejo"
                      : "El cliente rechazó la prueba de manejo",
                  showConfirmButton: false,
                  timer: 2500,
                  timerProgressBar: true,
                });
              }
            }
          }
        } else {
          console.error("No hay registros disponibles.");
          // No limpiamos la venta activa en un refresh/polling para evitar pantalla en blanco
          // si la API responde vacío de forma temporal.
          if (!selectedMailDataRef.current?.id) {
            setMailData([]);
            setPlans([]);
          }
        }
      } else if (data.statusCode === 404) {
        // No limpiamos la venta activa en un refresh/polling para evitar pantalla en blanco
        // si la API responde 404 de forma temporal.
        if (!selectedMailDataRef.current?.id) {
          setMailData([]);
          setPlans([]);
        }
      } else {
        // No limpiamos la venta activa en un refresh/polling para evitar pantalla en blanco.
        if (!selectedMailDataRef.current?.id) {
          setMailData([]);
          setPlans([]);
        }
        console.error(
          "Error al obtener los datos:",
          data.message || "Sin mensaje de error.",
        );
      }
    } catch (error) {
      // Error transitorio: conservamos la venta y los datos actuales para no dejar la pantalla en blanco.
      if (!selectedMailDataRef.current?.id) {
        setMailData([]);
        setPlans([]);
      }
      console.error("Error en la solicitud:", error);
    } finally {
      setLoading(false); // Desactivar el loader una vez que se termine la solicitud
    }
  };

  const fetchFilterOptions = async () => {
    setLoading(true); // Activar el loader

    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          access_token: accessToken,
        }),
      });

      const data = await response.json();

      if (data.statusCode === 200) {
        const { opciones } = data.data;
        if (opciones && Object.keys(opciones).length > 0) {
          setFilterOptions(opciones);
        } else {
          // Si no hay opciones disponibles, mostrar alerta
          Swal.fire({
            icon: "warning",
            title: "Sin opciones",
            text: "No se encontraron opciones para los filtros.",
          });
        }
      } else if (data.statusCode === 404) {
        // Si el statusCode es 404, mostrar alerta de "sin resultados"
        Swal.fire({
          icon: "warning",
          title: "Sin resultados",
          text: "No se encontraron opciones para los filtros.",
        });
      } else {
        console.error(
          "Error al obtener las opciones de filtro:",
          data.message || "Sin mensaje de error.",
        );
      }
    } catch (error) {
      console.error("Error al obtener las opciones de filtro:", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Ocurrió un error al obtener las opciones de filtro.",
      });
    } finally {
      setLoading(false); // Desactivar el loader una vez que termine la solicitud
    }
  };

  // Llama a `fetchData` y `fetchFilterOptions` cuando se monte el componente
  useEffect(() => {
    fetchData();
    fetchFilterOptions();
  }, [filters]); // Llamar a fetchData cuando los filtros cambian

  // Escucha activa del listado:
  // consulta cada pocos segundos para reflejar cambios hechos desde la pantalla del cliente,
  // incluso cuando ya no hay una venta seleccionada después de finalizar una venta.
  useEffect(() => {
    const intervalId = setInterval(async () => {
      if (document.hidden) return;
      if (isPollingSelectedVentaRef.current) return;

      try {
        isPollingSelectedVentaRef.current = true;
        await fetchData(filters);
      } catch (error) {
        console.warn("No se pudo sincronizar el listado de ventas:", error);
      } finally {
        isPollingSelectedVentaRef.current = false;
      }
    }, 4000);

    return () => clearInterval(intervalId);
  }, [
    selectedMailData?.id,
    filters?.activo,
    filters?.startDate,
    filters?.endDate,
  ]);

  useEffect(() => {
    const syncSelectedVentaWhenVisible = () => {
      if (document.hidden) return;
      if (isPollingSelectedVentaRef.current) return;

      isPollingSelectedVentaRef.current = true;
      Promise.resolve(fetchData(filters))
        .catch((error) =>
          console.warn(
            "No se pudo sincronizar el listado al volver a la pestaña:",
            error,
          ),
        )
        .finally(() => {
          isPollingSelectedVentaRef.current = false;
        });
    };

    const handleVisibilityChange = () => {
      if (!document.hidden) {
        syncSelectedVentaWhenVisible();
      }
    };

    document.addEventListener("visibilitychange", handleVisibilityChange);
    window.addEventListener("focus", syncSelectedVentaWhenVisible);

    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange);
      window.removeEventListener("focus", syncSelectedVentaWhenVisible);
    };
  }, [
    selectedMailData?.id,
    filters?.activo,
    filters?.startDate,
    filters?.endDate,
  ]);

  const handleDateApplyEvent = (event, picker) => {
    setFilters((prevFilters) => ({
      ...prevFilters,
      startDate: picker.startDate.format("YYYY-MM-DD"),
      endDate: picker.endDate.format("YYYY-MM-DD"),
    }));
  };

  useEffect(() => {
    const observer = new MutationObserver(() => {
      const cancelButton = document.querySelector(".cancelBtn");
      const applyButton = document.querySelector(".applyBtn");

      // Solo cambiar el texto si no es el valor correcto
      if (cancelButton && cancelButton.textContent !== "Cancelar") {
        cancelButton.textContent = "Cancelar";
      }
      if (applyButton && applyButton.textContent !== "Aplicar") {
        applyButton.textContent = "Aplicar";
      }
    });

    const targetNode = document.body;
    observer.observe(targetNode, { childList: true, subtree: true });

    return () => observer.disconnect(); // Limpiar observador al desmontar
  }, []);

  // Efecto para actualizar selectedMailData cuando cambia mailData
  useEffect(() => {
    if (!mailData.length) return;

    const ventaSeleccionadaActual =
      selectedMailDataRef.current || selectedMailData;
    const ventaSeleccionadaId = ventaSeleccionadaActual?.id;

    if (!ventaSeleccionadaId) return;

    const updatedClient = mailData.find(
      (cliente) => String(cliente.id) === String(ventaSeleccionadaId),
    );

    // Si una respuesta temporal no trae la venta seleccionada, no la limpiamos.
    if (!updatedClient) return;

    const mergedClient = mergeLocalPersonalDataPatch(
      mergeLocalInterviewPatch(
        mergeLocalFinancingPatch(updatedClient),
      ),
    );

    // Evita el loop de render:
    // si la venta ya está igual en estado, no vuelvas a disparar setSelectedMailData.
    try {
      if (
        JSON.stringify(ventaSeleccionadaActual || {}) ===
        JSON.stringify(mergedClient || {})
      ) {
        return;
      }
    } catch {
      // Si por alguna razón no se puede comparar, seguimos con la actualización segura.
    }

    selectedMailDataRef.current = mergedClient;
    setSelectedMailData(mergedClient);
  }, [mailData, mergeLocalFinancingPatch, mergeLocalInterviewPatch, mergeLocalPersonalDataPatch]); // Este efecto sigue funcionando cuando mailData cambia

  // Este efecto previne una ruptura en caso de venta finalizada por cliente
  useEffect(() => {
    if (!selectedMailData?.id) return; // si no hay venta seleccionada, no hacemos nada

    if (!mailData.length) return;

    const stillExists = mailData.some(
      (cliente) => String(cliente.id) === String(selectedMailData.id),
    );

    if (!stillExists) {
      console.warn(
        "La venta seleccionada no llegó en la última consulta; se conserva la pantalla actual.",
      );
    }
  }, [mailData, selectedMailData]);

  const [step, setStep] = useState(1);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    setShowFloatingActions(false);
  }, [step, selectedMailData?.id, openFicha]);

  // Confirmar aviso y datos por venta
  const [isConfirming, setIsConfirming] = useState(false);
  const [confirmedVentas, setConfirmedVentas] = useState({});
  const ventaActualId = selectedMailData?.id || null;
  const isConfirmed = ventaActualId
    ? confirmedVentas[ventaActualId] === true ||
      Number(selectedMailData?.terminos_modal || 0) === 1
    : false;

  // ====== Prueba de manejo ======

  const preguntasPruebaManejo = [
    {
      key: "imagen_marca",
      escala: 5,
      pregunta: "¿Hizo que la imagen que tengo de Nissan como marca mejorara?",
    },
    {
      key: "emocion_manejar",
      escala: 5,
      pregunta: "¿Me permitió probar la emoción de tener y manejar el auto?",
    },
    {
      key: "sencillo_solicitar",
      escala: 5,
      pregunta: "¿Fue sencillo de solicitar y utilizar?",
    },
    {
      key: "tecnologias_asistencias",
      escala: 5,
      pregunta:
        "¿Me permitió probar el funcionamiento de tecnologías y asistencias del auto?",
    },
    {
      key: "comodidad_manejo",
      escala: 5,
      pregunta: "¿Me permitió probar la comodidad del manejo?",
    },
    {
      key: "satisfaccion_prueba",
      escala: 10,
      pregunta: "¿Qué tan satisfecho está con la prueba de manejo de Nissan?",
    },
  ];

  const pruebaManejoInicial = {
    realizo_prueba_manejo: "",
    licencia_manejo_frente_nombre: "",
    respuestas: {
      imagen_marca: "",
      emocion_manejar: "",
      sencillo_solicitar: "",
      tecnologias_asistencias: "",
      comodidad_manejo: "",
      satisfaccion_prueba: "",
    },
  };

  const [pruebaManejoData, setPruebaManejoData] = useState(pruebaManejoInicial);
  const [licenciaManejoFrente, setLicenciaManejoFrente] = useState(null);

  // Estos refs amarran la prueba/licencia a la venta actual.
  // Evitan que una licencia cargada en otra venta permita avanzar por error.
  const pruebaManejoVentaIdRef = useRef("");
  const licenciaManejoVentaIdRef = useRef("");
  const lastPruebaManejoVentaIdRef = useRef("");

  const resetLicenciaInput = useCallback(() => {
    const inputLicencia = document.getElementById("licenciaManejoFrente");
    if (inputLicencia) inputLicencia.value = "";
  }, []);

  const getVentaActualId = () => selectedMailData?.id || "";

  const normalizeRespuestaPruebaManejo = useCallback((value = "") => {
    if (value === null || value === undefined) return "";

    if (value === true || value === 1) return "Si";
    if (value === false || value === 0) return "No";

    const normalized = normalizarTexto(value)
      .replace(/[^a-z0-9]+/g, " ")
      .trim();

    if (!normalized) return "";

    const respuestasSi = [
      "si",
      "s",
      "yes",
      "y",
      "true",
      "1",
      "acepto",
      "aceptado",
      "aceptada",
      "realizada",
      "realizo",
      "realizada si",
    ];

    const respuestasNo = [
      "no",
      "n",
      "false",
      "0",
      "rechazo",
      "rechazado",
      "rechazada",
      "declino",
      "declinado",
      "declinada",
      "no realizada",
    ];

    if (respuestasSi.includes(normalized)) return "Si";
    if (respuestasNo.includes(normalized)) return "No";

    if (normalized.includes("acept")) return "Si";
    if (normalized.includes("rechaz") || normalized.includes("declin")) {
      return "No";
    }

    return "";
  }, []);

  const parsePruebaManejoSafe = useCallback(
    (value) => {
      if (value === null || value === undefined || value === "") return null;

      if (typeof value === "object") return value;

      const normalizedRespuesta = normalizeRespuestaPruebaManejo(value);
      const raw = String(value || "").trim();

      // El backend a veces puede devolver solo "Si"/"No" en prueba_manejo.
      // Si intentamos JSON.parse("Si") truena y se limpiaba la vista del asesor.
      if (normalizedRespuesta && !raw.startsWith("{") && !raw.startsWith("[")) {
        return { realizo_prueba_manejo: normalizedRespuesta };
      }

      const candidates = [
        raw,
        raw.replace(/&quot;/g, '"').replace(/&#34;/g, '"'),
        raw
          .replace(/^"+|"+$/g, "")
          .replace(/\\"/g, '"')
          .replace(/\\\\/g, "\\"),
      ];

      for (const candidate of candidates) {
        if (!candidate) continue;

        try {
          const parsed = JSON.parse(candidate);

          if (typeof parsed === "string") {
            const respuestaParsed = normalizeRespuestaPruebaManejo(parsed);
            return respuestaParsed
              ? { realizo_prueba_manejo: respuestaParsed }
              : null;
          }

          if (parsed && typeof parsed === "object") return parsed;
        } catch {}
      }

      return normalizedRespuesta
        ? { realizo_prueba_manejo: normalizedRespuesta }
        : null;
    },
    [normalizeRespuestaPruebaManejo],
  );

  const getPruebaManejoFromVenta = useCallback(
    (venta = {}) => {
      if (!venta || typeof venta !== "object") return null;

      const posiblesCampos = [
        venta.prueba_manejo,
        venta.encuesta_prueba_manejo,
        venta.encuesta_prueba_manejo_cliente,
        venta.respuestas_prueba_manejo,
        venta.respuestas_prueba_manejo_cliente,
        venta.prueba_manejo_data,
        venta.prueba_manejo_encuesta,
        venta.encuesta_prueba,
        venta.encuesta_cliente,
        venta.respuesta_encuesta_prueba_manejo,
      ];

      let merged = null;

      for (const campo of posiblesCampos) {
        const parsed = parsePruebaManejoSafe(campo);
        if (!parsed) continue;

        merged = {
          ...(merged || {}),
          ...parsed,
          respuestas: {
            ...((merged && merged.respuestas) || {}),
            ...(parsed.respuestas || {}),
          },
        };
      }

      return merged;
    },
    [parsePruebaManejoSafe],
  );

  const extractRespuestasPruebaManejo = useCallback((...sources) => {
    const respuestas = {};

    const addFromObject = (source) => {
      if (!source || typeof source !== "object") return;

      const nestedSources = [
        source.respuestas,
        source.encuesta,
        source.encuesta?.respuestas,
        source.data,
        source.data?.respuestas,
      ];

      nestedSources.forEach(addFromObject);

      const preguntaKeys = [
        "imagen_marca",
        "emocion_manejar",
        "sencillo_solicitar",
        "tecnologias_asistencias",
        "comodidad_manejo",
        "satisfaccion_prueba",
      ];

      preguntaKeys.forEach((questionKey) => {
        const posiblesKeys = [
          questionKey,
          `respuesta_${questionKey}`,
          `pregunta_${questionKey}`,
        ];

        for (const key of posiblesKeys) {
          const rawValue = source[key];

          if (rawValue !== null && rawValue !== undefined) {
            const value = String(rawValue).trim();

            // No dejamos que valores vacíos de drafts viejos borren respuestas
            // que ya llegaron desde cliente/backend.
            if (value !== "") {
              respuestas[questionKey] = value;
              break;
            }
          }
        }
      });
    };

    sources.forEach(addFromObject);
    return respuestas;
  }, []);

  const savePruebaManejo = async (dataOverride = pruebaManejoData) => {
    try {
      const ventaId = getVentaActualId();

      if (!ventaId || !accessToken) return;

      pruebaManejoVentaIdRef.current = String(ventaId);

      const payload = {
        access_token: accessToken,
        venta_id: ventaId,
        prueba_manejo: dataOverride,
      };

      const resp = await fetch(
        "https://api.checkmark.mx/ventas/financiamiento/prueba-manejo",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        },
      );

      const json = await resp.json();
    } catch (error) {
      console.error("Error guardando prueba de manejo:", error);
    }
  };

  const updatePruebaManejoField = (field, value) => {
    const ventaIdActual = getVentaActualId();
    if (ventaIdActual) {
      pruebaManejoVentaIdRef.current = String(ventaIdActual);
    }

    setPruebaManejoData((prev) => {
      const nuevo = {
        ...prev,
        [field]: value,
      };

      if (field === "realizo_prueba_manejo" && value === "No") {
        nuevo.licencia_manejo_frente_nombre = "";
        nuevo.respuestas = {
          imagen_marca: "",
          emocion_manejar: "",
          sencillo_solicitar: "",
          tecnologias_asistencias: "",
          comodidad_manejo: "",
          satisfaccion_prueba: "",
        };

        licenciaManejoVentaIdRef.current = "";
        setLicenciaManejoFrente(null);

        const ventaId = getVentaActualId();
        if (ventaId) {
          mergeAsesorDraft(ventaId, {
            pruebaManejoData: nuevo,
            licenciaManejoFrente: null,
          });
        }

        resetLicenciaInput();

        Swal.fire({
          icon: "info",
          title: "Prueba de manejo no realizada",
          text: "Se confirmó que no se realizó prueba de manejo. Puedes avanzar a Consulta.",
          confirmButtonText: "Aceptar",
          willOpen: () => {
            const container = document.querySelector(".swal2-container");
            if (container) container.style.zIndex = "1000000";
          },
        });
      }

      savePruebaManejo(nuevo);
      return nuevo;
    });
  };

  const updateRespuestaPruebaManejo = (key, value) => {
    setPruebaManejoData((prev) => {
      const nuevo = {
        ...prev,
        respuestas: {
          ...(prev.respuestas || {}),
          [key]: value,
        },
      };

      savePruebaManejo(nuevo);
      return nuevo;
    });
  };

  const handleLicenciaManejoChange = (e) => {
    const file = e.target.files?.[0] || null;
    const ventaId = getVentaActualId();

    if (ventaId) {
      pruebaManejoVentaIdRef.current = String(ventaId);
    }

    licenciaManejoVentaIdRef.current = file && ventaId ? String(ventaId) : "";
    setLicenciaManejoFrente(file);

    setPruebaManejoData((prev) => {
      const nuevo = {
        ...prev,
        licencia_manejo_frente_nombre: file?.name || "",
      };

      savePruebaManejo(nuevo);

      if (ventaId) {
        const patchDraft = { pruebaManejoData: nuevo };
        if (!file) patchDraft.licenciaManejoFrente = null;
        mergeAsesorDraft(ventaId, patchDraft);
      }

      return nuevo;
    });

    if (file && ventaId) {
      fileToPersistibleDataURL(file)
        .then((persistedFile) => {
          if (!persistedFile) return;

          mergeAsesorDraft(ventaId, {
            licenciaManejoFrente: persistedFile,
          });
        })
        .catch((error) => {
          console.warn("No se pudo persistir la licencia localmente:", error);
        });
    }
  };

  useEffect(() => {
    if (!selectedMailData) return;

    const ventaId = selectedMailData.id;
    const ventaIdStr = String(ventaId || "");
    const cambioVentaPrueba = lastPruebaManejoVentaIdRef.current !== ventaIdStr;

    if (cambioVentaPrueba) {
      lastPruebaManejoVentaIdRef.current = ventaIdStr;
      pruebaManejoVentaIdRef.current = "";
      licenciaManejoVentaIdRef.current = "";
      setLicenciaManejoFrente(null);
      resetLicenciaInput();
    }

    try {
      const respuestaCliente = normalizeRespuestaPruebaManejo(
        selectedMailData?.respuesta_prueba_manejo_cliente ??
          selectedMailData?.respuesta_prueba_manejo ??
          selectedMailData?.prueba_manejo_respuesta ??
          "",
      );

      const pruebaPendienteCliente =
        Number(selectedMailData?.solicitar_prueba_manejo_cliente || 0) === 1 &&
        !respuestaCliente;

      // Si se volvió a solicitar prueba de manejo y el cliente aún no responde,
      // limpiamos la vista del asesor para no mostrar respuestas antiguas.
      if (pruebaPendienteCliente) {
        pruebaManejoVentaIdRef.current = ventaIdStr;
        licenciaManejoVentaIdRef.current = "";
        setPruebaManejoData({ ...pruebaManejoInicial });
        setLicenciaManejoFrente(null);
        resetLicenciaInput();
        return;
      }

      const draft = loadAsesorDraft(ventaId) || {};
      const pruebaGuardada = getPruebaManejoFromVenta(selectedMailData);
      const pruebaLocal = draft.pruebaManejoData || null;

      const respuestaGuardada = normalizeRespuestaPruebaManejo(
        pruebaGuardada?.realizo_prueba_manejo ||
          pruebaGuardada?.prueba_manejo ||
          pruebaGuardada?.respuesta ||
          pruebaGuardada?.respuesta_prueba_manejo_cliente ||
          "",
      );

      const respuestaLocal = normalizeRespuestaPruebaManejo(
        pruebaLocal?.realizo_prueba_manejo || pruebaLocal?.prueba_manejo || "",
      );

      const realizoPruebaManejo =
        respuestaCliente || respuestaGuardada || respuestaLocal || "";

      const respuestasMergeadas = {
        ...pruebaManejoInicial.respuestas,
        ...extractRespuestasPruebaManejo(
          pruebaLocal,
          pruebaGuardada,
          selectedMailData,
        ),
      };

      const tieneDatosPrueba =
        !!realizoPruebaManejo ||
        Object.values(respuestasMergeadas).some(
          (value) => String(value || "").trim() !== "",
        ) ||
        !!pruebaLocal?.licencia_manejo_frente_nombre ||
        !!pruebaGuardada?.licencia_manejo_frente_nombre ||
        !!draft?.licenciaManejoFrente?.name;

      if (tieneDatosPrueba) {
        const mergedPrueba = {
          ...pruebaManejoInicial,
          ...(pruebaGuardada || {}),
          ...(pruebaLocal || {}),
          realizo_prueba_manejo: realizoPruebaManejo,
          respuestas: respuestasMergeadas,
          licencia_manejo_frente_nombre:
            pruebaLocal?.licencia_manejo_frente_nombre ||
            pruebaGuardada?.licencia_manejo_frente_nombre ||
            draft?.licenciaManejoFrente?.name ||
            "",
        };

        pruebaManejoVentaIdRef.current = ventaIdStr;
        setPruebaManejoData(mergedPrueba);

        // Guardamos localmente el estado aceptado/rechazado que llegó del cliente
        // para que al refrescar no se vuelva a quedar como pendiente.
        if (realizoPruebaManejo) {
          mergeAsesorDraft(ventaId, {
            pruebaManejoData: mergedPrueba,
          });
        }

        hydrateLicenciaFromDraft(ventaId).then((file) => {
          const ventaActual = selectedMailDataRef.current || selectedMailData;
          if (String(ventaActual?.id || "") !== String(ventaId)) return;

          if (file) {
            licenciaManejoVentaIdRef.current = ventaIdStr;
            setLicenciaManejoFrente(file);
          } else {
            licenciaManejoVentaIdRef.current = "";
            setLicenciaManejoFrente(null);
            resetLicenciaInput();
          }
        });
      } else {
        pruebaManejoVentaIdRef.current = ventaIdStr;
        licenciaManejoVentaIdRef.current = "";
        setPruebaManejoData({ ...pruebaManejoInicial });
        setLicenciaManejoFrente(null);
        resetLicenciaInput();
      }
    } catch (error) {
      console.error("Error cargando prueba de manejo:", error);

      // Fallback importante: si el backend sí trae Si/No pero falló algún parseo,
      // no dejamos la pantalla como pendiente porque el asesor ya necesita subir licencia.
      const respuestaCliente = normalizeRespuestaPruebaManejo(
        selectedMailData?.respuesta_prueba_manejo_cliente || "",
      );

      pruebaManejoVentaIdRef.current = ventaIdStr;

      setPruebaManejoData({
        ...pruebaManejoInicial,
        realizo_prueba_manejo: respuestaCliente,
      });

      if (respuestaCliente !== "Si") {
        licenciaManejoVentaIdRef.current = "";
        setLicenciaManejoFrente(null);
        resetLicenciaInput();
      }
    }
  }, [
    selectedMailData?.id,
    selectedMailData?.prueba_manejo,
    selectedMailData?.encuesta_prueba_manejo,
    selectedMailData?.encuesta_prueba_manejo_cliente,
    selectedMailData?.respuestas_prueba_manejo,
    selectedMailData?.respuestas_prueba_manejo_cliente,
    selectedMailData?.solicitar_prueba_manejo_cliente,
    selectedMailData?.respuesta_prueba_manejo_cliente,
    selectedMailData?.respuesta_prueba_manejo_fecha,
    loadAsesorDraft,
    hydrateLicenciaFromDraft,
    normalizeRespuestaPruebaManejo,
    getPruebaManejoFromVenta,
    extractRespuestasPruebaManejo,
    mergeAsesorDraft,
    resetLicenciaInput,
  ]);

  const datosPersonalesConfirmados = useMemo(() => {
    return isConfirmed;
  }, [isConfirmed, selectedMailData]);

  const isPruebaManejoCompleta = useMemo(() => {
    const ventaIdActual = String(
      selectedMailData?.id || getVentaActualId() || "",
    );

    // Si la prueba que está en estado no pertenece a la venta actual,
    // no se permite avanzar. Esto evita que una licencia de otra venta
    // se use como válida al regresar a una venta sin licencia.
    if (
      ventaIdActual &&
      pruebaManejoVentaIdRef.current &&
      String(pruebaManejoVentaIdRef.current) !== ventaIdActual
    ) {
      return false;
    }

    if (pruebaManejoData.realizo_prueba_manejo === "No") return true;
    if (pruebaManejoData.realizo_prueba_manejo !== "Si") return false;

    const respuestas = pruebaManejoData.respuestas || {};

    const encuestaCompleta = preguntasPruebaManejo.every(
      (item) => String(respuestas[item.key] || "").trim() !== "",
    );

    const licenciaFileEsDeVentaActual =
      !!licenciaManejoFrente &&
      !!ventaIdActual &&
      String(licenciaManejoVentaIdRef.current || "") === ventaIdActual;

    const licenciaNombreEnEstadoActual =
      !!ventaIdActual &&
      (!pruebaManejoVentaIdRef.current ||
        String(pruebaManejoVentaIdRef.current) === ventaIdActual) &&
      !!String(pruebaManejoData.licencia_manejo_frente_nombre || "").trim();

    return (
      encuestaCompleta &&
      (licenciaFileEsDeVentaActual || licenciaNombreEnEstadoActual)
    );
  }, [pruebaManejoData, licenciaManejoFrente, selectedMailData?.id]);

  // ACCESORIOS_MAP actualizado en base a planInicial
  const ACCESORIOS_MAP = {
    "PROTECCIÓN DE LLANTAS POR $4,000.00 1 AÑO": {
      title: "PROTECCIÓN DE LLANTAS POR $4,000.00 1 AÑO",
      description: "Cobertura para daños en llantas por caminos en mal estado.",
      price: 5374,
      price_promo: 5374,
      price_base: 5374,
      type: "garantias",
    },

    "Garantía de Movilidad": {
      title: "GARANTÍA DE MOVILIDAD",
      description:
        "Asegura tu movilidad en caso de reparación por siniestro de tu vehículo, hasta por $400.00 diarios en plataformas de transporte.",
      price: 4813,
      price_promo: 4813,
      price_base: 4813,
      type: "garantias",
    },

    "Garantía Mecánica 1 Año": {
      title: "GARANTÍA MECÁNICA 1 AÑO",
      description:
        "Garantía mecánica para seminuevos con cobertura de tren motriz por 1 año.",
      price: 7593,
      price_promo: 7593,
      price_base: 7593,
      type: "garantias",
    },

    "Garantía Mecánica 2 Años": {
      title: "GARANTÍA MECÁNICA 2 AÑOS",
      description:
        "Garantía mecánica para seminuevos con cobertura de tren motriz por 2 años.",
      price: 10546,
      price_promo: 10546,
      price_base: 10546,
      type: "garantias",
    },

    "Garantía Mecánica 3 Años": {
      title: "GARANTÍA MECÁNICA 3 AÑOS",
      description:
        "Garantía mecánica para seminuevos con cobertura de tren motriz por 3 años.",
      price: 13329,
      price_promo: 13329,
      price_base: 13329,
      type: "garantias",
    },

    "Localizador 2 Años": {
      title: "LOCALIZADOR 2 AÑOS",
      description:
        "Servicio de localización y conectividad para monitoreo y recuperación del vehículo por 2 años.",
      price: 15000,
      price_promo: 15000,
      price_base: 15000,
      type: "garantias",
    },

    "Caja de Herramientas": {
      title: "CAJA DE HERRAMIENTAS",
      description:
        "Caja de herramientas para mantener accesorios básicos de apoyo en el vehículo.",
      price: 3190,
      price_promo: 3190,
      price_base: 3190,
      type: "accesorios",
    },

    Pelicula: {
      title: "PELÍCULA POLARIZADO",
      description:
        "Lámina de control solar o seguridad para cristales. Reduce el calor, protege contra rayos UV y aumenta la privacidad.",
      price: 2899,
      price_promo: 2899,
      price_base: 2899,
      type: "accesorios",
    },

    Tatuado: {
      title: "TATUADO AUTOPARTES",
      description:
        "Grabado de seguridad o decorativo en cristales o espejos para prevenir robos o personalizar el diseño.",
      price: 2899,
      price_promo: 2899,
      price_base: 2899,
      type: "accesorios",
    },

    "Tapetes Uso Rudo": {
      title: "TAPETES USO RUDO",
      description:
        "Tapetes de uso rudo para proteger el interior del vehículo.",
      price: 3899,
      price_promo: 3899,
      price_base: 3899,
      type: "accesorios",
    },

    "Cobertura de Llaves": {
      title: "COBERTURA DE LLAVES",
      description: "Cobertura ante extravío o robo de llaves de tu auto.",
      price: 3152,
      price_promo: 3152,
      price_base: 3152,
      type: "garantias",
    },
  };

  const DEFAULT_CURRENT_GOLD_ACCESSORIES = [
    {
      title: "PROTECCIÓN DE LLANTAS POR $4,000.00 1 AÑO",
      description: "Cobertura para daños en llantas por caminos en mal estado.",
      price: 5279,
      price_promo: 5279,
      price_base: 5279,
      type: "garantias",
    },
    {
      title: "Pelicula Polarizado - Todos",
      description:
        "Lámina de control solar o seguridad para cristales. Reduce el calor, protege contra rayos UV y aumenta la privacidad.",
      price: 2899,
      price_promo: 2899,
      price_base: 2899,
      type: "accesorios",
    },
    {
      title: "Tatuado Autopartes - Todos",
      description:
        "Grabado de seguridad o decorativo en cristales o espejos para prevenir robos o personalizar el diseño.",
      price: 2899,
      price_promo: 2899,
      price_base: 2899,
      type: "accesorios",
    },
    {
      title: "Cobertura de Llaves",
      description:
        "Cobertura de llaves por 1 año para proteger contra pérdida o daño.",
      price: 3019,
      price_promo: 3019,
      price_base: 3019,
      type: "garantias",
    },
  ];

  const NISSAN_TECAMAC_PRECARGADO_AG_ID = "ag5912_5c33d9c0c10df";

  const GOLD_TECAMAC_PACKAGES = {
    1: [
      {
        title: "CAJA DE HERRAMIENTAS",
        description:
          "Caja de herramientas para mantener accesorios básicos de apoyo en el vehículo.",
        price: 3190,
        price_promo: 3190,
        price_base: 3190,
        type: "accesorios",
      },
      {
        title: "PELÍCULA POLARIZADO",
        description:
          "Lámina de control solar o seguridad para cristales. Reduce el calor, protege contra rayos UV y aumenta la privacidad.",
        price: 1300,
        price_promo: 1300,
        price_base: 1300,
        type: "accesorios",
      },
      {
        title: "PROTECCIÓN DE LLANTAS POR $4,000.00 1 AÑO",
        description:
          "Cobertura para daños en llantas por caminos en mal estado.",
        price: 5374,
        price_promo: 5374,
        price_base: 5374,
        type: "garantias",
      },
      {
        title: "PORTAPLACAS",
        description:
          "Marco decorativo para las placas que brinda un acabado más limpio y profesional al vehículo.",
        price: 2190,
        price_promo: 2190,
        price_base: 2190,
        type: "accesorios",
      },
    ],
    2: [
      {
        title: "LOCALIZADOR 1 AÑO",
        description:
          "Servicio de localización y conectividad para monitoreo y recuperación del vehículo por 1 año.",
        price: 5490,
        price_promo: 5490,
        price_base: 5490,
        type: "garantias",
      },
      {
        title: "PROTECCIÓN DE LLANTAS POR $4,000.00 1 AÑO",
        description:
          "Cobertura para daños en llantas por caminos en mal estado.",
        price: 4836.6,
        price_promo: 4836.6,
        price_base: 4836.6,
        type: "garantias",
      },
      {
        title: "TAPETES USO RUDO",
        description:
          "Tapetes de uso rudo para proteger el interior del vehículo.",
        price: 2585.7,
        price_promo: 2585.7,
        price_base: 2585.7,
        type: "accesorios",
      },
      {
        title: "PELÍCULA POLARIZADO",
        description:
          "Lámina de control solar o seguridad para cristales. Reduce el calor, protege contra rayos UV y aumenta la privacidad.",
        price: 1170,
        price_promo: 1170,
        price_base: 1170,
        type: "accesorios",
      },
    ],
    3: [
      {
        title: "LOCALIZADOR 1 AÑO",
        description:
          "Servicio de localización y conectividad para monitoreo y recuperación del vehículo por 1 año.",
        price: 5490,
        price_promo: 5490,
        price_base: 5490,
        type: "garantias",
      },
      {
        title: "PROTECCIÓN DE LLANTAS POR $4,000.00 1 AÑO",
        description:
          "Cobertura para daños en llantas por caminos en mal estado.",
        price: 4836.6,
        price_promo: 4836.6,
        price_base: 4836.6,
        type: "garantias",
      },
      {
        title: "TAPETES USO RUDO",
        description:
          "Tapetes de uso rudo para proteger el interior del vehículo.",
        price: 2585.7,
        price_promo: 2585.7,
        price_base: 2585.7,
        type: "accesorios",
      },
      {
        title: "PELÍCULA POLARIZADO",
        description:
          "Lámina de control solar o seguridad para cristales. Reduce el calor, protege contra rayos UV y aumenta la privacidad.",
        price: 1170,
        price_promo: 1170,
        price_base: 1170,
        type: "accesorios",
      },
      {
        title: "COBERTURA DE LLAVES",
        description:
          "Cobertura de llaves por 1 año para proteger contra pérdida o daño.",
        price: 2836.8,
        price_promo: 2836.8,
        price_base: 2836.8,
        type: "garantias",
      },
    ],
    4: [
      {
        title: "LOCALIZADOR 2 AÑOS",
        description:
          "Servicio de localización y conectividad para monitoreo y recuperación del vehículo por 2 años.",
        price: 10440,
        price_promo: 10440,
        price_base: 10440,
        type: "garantias",
      },
      {
        title: "PROTECCIÓN DE LLANTAS POR $4,000.00 1 AÑO",
        description:
          "Cobertura para daños en llantas por caminos en mal estado.",
        price: 4836.6,
        price_promo: 4836.6,
        price_base: 4836.6,
        type: "garantias",
      },
      {
        title: "TAPETES USO RUDO",
        description:
          "Tapetes de uso rudo para proteger el interior del vehículo.",
        price: 2585.7,
        price_promo: 2585.7,
        price_base: 2585.7,
        type: "accesorios",
      },
      {
        title: "PELÍCULA POLARIZADO",
        description:
          "Lámina de control solar o seguridad para cristales. Reduce el calor, protege contra rayos UV y aumenta la privacidad.",
        price: 1170,
        price_promo: 1170,
        price_base: 1170,
        type: "accesorios",
      },
    ],
    5: [
      {
        title: "CAJA DE HERRAMIENTAS",
        description:
          "Caja de herramientas para mantener accesorios básicos de apoyo en el vehículo.",
        price: 2871,
        price_promo: 2871,
        price_base: 2871,
        type: "accesorios",
      },
      {
        title: "PELÍCULA POLARIZADO",
        description:
          "Lámina de control solar o seguridad para cristales. Reduce el calor, protege contra rayos UV y aumenta la privacidad.",
        price: 2601,
        price_promo: 2601,
        price_base: 2601,
        type: "accesorios",
      },
      {
        title: "PROTECCIÓN DE LLANTAS POR $4,000.00 1 AÑO",
        description:
          "Cobertura para daños en llantas por caminos en mal estado.",
        price: 4836.6,
        price_promo: 4836.6,
        price_base: 4836.6,
        type: "garantias",
      },
      {
        title: "PORTAPLACAS",
        description:
          "Marco decorativo para las placas que brinda un acabado más limpio y profesional al vehículo.",
        price: 1971,
        price_promo: 1971,
        price_base: 1971,
        type: "accesorios",
      },
      {
        title: "PERCHERO",
        description:
          "Accesorio porta sacos para mantener prendas ordenadas dentro del vehículo.",
        price: 1230.3,
        price_promo: 1230.3,
        price_base: 1230.3,
        type: "accesorios",
      },
    ],
    6: [
      {
        title: "LOCALIZADOR 2 AÑOS",
        description:
          "Servicio de localización y conectividad para monitoreo y recuperación del vehículo por 2 años.",
        price: 15000,
        price_promo: 15000,
        price_base: 15000,
        type: "garantias",
      },
      {
        title: "GARANTÍA MECÁNICA 1 AÑO",
        description:
          "Garantía mecánica para seminuevos con cobertura de tren motriz por 1 año.",
        price: 7593,
        price_promo: 7593,
        price_base: 7593,
        type: "garantias",
      },
    ],
  };

  const GOLD_TECAMAC_PACKAGE_RULES = [
    { modelo: "V-Drive", anio: "2026", version: "V-Drive Base TM", paquete: 1 },
    { modelo: "V-Drive", anio: "2026", version: "V-Drive MT", paquete: 1 },

    { modelo: "X-Trail", anio: "2027", version: "Platinum 2 Row", paquete: 4 },
    { modelo: "X-Trail", anio: "2027", version: "Advance 2 Row", paquete: 4 },
    { modelo: "X-Trail", anio: "2027", version: "Exclusive 2 Row", paquete: 5 },
    {
      modelo: "X-Trail",
      anio: "2027",
      version: "Platinum Plus 2 Row",
      paquete: 4,
    },

    {
      modelo: "X-Trail e-POWER",
      anio: "2026",
      version: "Exclusive",
      paquete: 4,
    },
    {
      modelo: "X-Trail e-POWER",
      anio: "2026",
      version: "Platinum",
      paquete: 4,
    },

    {
      modelo: "Frontier V6 Pro-4X",
      anio: "2026",
      version: "Frontier V6 Pro-4X",
      paquete: 5,
    },

    { modelo: "Kicks", anio: "2026", version: "Exclusive CVT", paquete: 4 },
    { modelo: "Kicks", anio: "2026", version: "Platinum CVT", paquete: 4 },
    { modelo: "Kicks", anio: "2026", version: "Advance CVT", paquete: 4 },

    { modelo: "Magnite", anio: "2026", version: "Advance MT", paquete: 2 },
    { modelo: "Magnite", anio: "2026", version: "Exclusive CVT", paquete: 3 },
    { modelo: "Magnite", anio: "2026", version: "Exclusive MT", paquete: 3 },
    {
      modelo: "Magnite",
      anio: "2026",
      version: "Advance MT Dark Armour",
      paquete: 2,
    },
    {
      modelo: "Magnite",
      anio: "2026",
      version: "Advance CVT Dark Armour",
      paquete: 3,
    },
    { modelo: "Magnite", anio: "2026", version: "Advance CVT", paquete: 3 },

    {
      modelo: "Kicks Play e-POWER",
      anio: "2026",
      version: "Play Platinum",
      paquete: 4,
    },
    {
      modelo: "Kicks Play e-POWER",
      anio: "2026",
      version: "Play Advance",
      paquete: 4,
    },
    {
      modelo: "Kicks Play e-POWER",
      anio: "2026",
      version: "Play Exclusive",
      paquete: 4,
    },

    { modelo: "Versa", anio: "2026", version: "Sense Base TM", paquete: 2 },
    { modelo: "Versa", anio: "2026", version: "Advance CVT", paquete: 3 },
    { modelo: "Versa", anio: "2026", version: "Sense TM", paquete: 2 },
    { modelo: "Versa", anio: "2026", version: "Sense CVT", paquete: 3 },
    { modelo: "Versa", anio: "2026", version: "Exclusive CVT", paquete: 3 },
    { modelo: "Versa", anio: "2026", version: "Advance TM", paquete: 3 },

    { modelo: "Sentra", anio: "2026", version: "Advance CVT", paquete: 3 },
    { modelo: "Sentra", anio: "2026", version: "Sr Platinum CVT", paquete: 4 },
    { modelo: "Sentra", anio: "2026", version: "Sense CVT", paquete: 3 },
    { modelo: "Sentra", anio: "2026", version: "Sr CVT", paquete: 4 },

    { modelo: "Kait", anio: "2027", version: "Advance CVT", paquete: 3 },
    { modelo: "Kait", anio: "2027", version: "Platinum CVT", paquete: 4 },
    { modelo: "Kait", anio: "2027", version: "Exclusive CVT", paquete: 3 },

    { modelo: "Z", anio: "2025", version: "Touring At", paquete: 4 },
    { modelo: "Z", anio: "2025", version: "Touring MT", paquete: 4 },

    { modelo: "March", anio: "2026", version: "Sense TM", paquete: 1 },
    { modelo: "March", anio: "2026", version: "Advance TM", paquete: 1 },

    { modelo: "Pathfinder", anio: "2026", version: "Platinum", paquete: 4 },

    {
      modelo: "NP300",
      anio: "2026",
      version: "Np300 Pick Up TM Ac",
      paquete: 5,
    },
    {
      modelo: "NP300",
      anio: "2026",
      version: "Np300 Chasis Diesel TM Ac Vdc",
      paquete: 5,
    },
    {
      modelo: "NP300",
      anio: "2026",
      version: "Np300 Chasis TM Ac Vdc",
      paquete: 5,
    },

    {
      modelo: "Frontier",
      anio: "2026",
      version: "Frontier Pro-4X 4X4 Ta",
      paquete: 5,
    },
    { modelo: "Frontier", anio: "2026", version: "Frontier Se TM", paquete: 5 },
    { modelo: "Frontier", anio: "2026", version: "Frontier Xe TM", paquete: 5 },
    { modelo: "Frontier", anio: "2026", version: "Frontier Le TM", paquete: 4 },
    {
      modelo: "Frontier",
      anio: "2026",
      version: "Frontier Platinum Le Ta",
      paquete: 5,
    },
    {
      modelo: "Frontier",
      anio: "2026",
      version: "Frontier Dc Diesel 4X4 TM",
      paquete: 5,
    },
    {
      modelo: "Frontier",
      anio: "2026",
      version: "Frontier Platinum Le Diesel 4X4 Ta",
      paquete: 5,
    },
    { modelo: "Frontier", anio: "2026", version: "Frontier Le Ta", paquete: 4 },

    { modelo: "Urvan", anio: "2026", version: "11 Pasajeros Aa", paquete: 5 },
    {
      modelo: "Urvan",
      anio: "2026",
      version: "Panel Ventanas Amplia",
      paquete: 5,
    },
    { modelo: "Urvan", anio: "2026", version: "Panel Amplia Aa", paquete: 5 },
    {
      modelo: "Urvan",
      anio: "2026",
      version: "14 Pasajeros Amplia Aa",
      paquete: 5,
    },

    { modelo: "X-Trail", anio: "2026", version: "Advance 2 Row", paquete: 4 },
    { modelo: "X-Trail", anio: "2026", version: "Exclusive 2 Row", paquete: 4 },
    { modelo: "X-Trail", anio: "2026", version: "Platinum 2 Row", paquete: 4 },
    { modelo: "X-Trail", anio: "2026", version: "Platinum 3 Row", paquete: 4 },
    {
      modelo: "X-Trail",
      anio: "2026",
      version: "Platinum Plus 2 Row",
      paquete: 4,
    },
  ];

  const planInicial = [
    //TODOS LOS MODELOS
    {
      title: "Elite",
      accessories: [
        {
          title: "PROTECCIÓN DE LLANTAS POR $4,000.00 1 AÑO",
          description:
            "Cobertura para daños en llantas por caminos en mal estado.",
          price: 5374,
          price_promo: 5374, // Precio con promo
          price_base: 5374, // Precio base
          type: "garantias",
        },
        {
          title: "Pelicula Polarizado - Todos",
          description:
            "Lámina de control solar o seguridad para cristales. Reduce el calor, protege contra rayos UV y aumenta la privacidad.",
          price: 1200,
          price_promo: 1200, // Precio con promo
          price_base: 1200, // Precio base
          type: "accesorios",
        },
        {
          title: "Portasaco - Todos",
          description:
            "Portasacos para Nissan. Mantén el orden en tu maletero.",
          price: 1300,
          price_promo: 1300, // Precio con promo
          price_base: 1300, // Precio base
          type: "accesorios",
        },
        {
          title:
            "Tapetes Uso Rudo - Z, VERSA, SENTRA, MARCH, V-DRIVE, X-TRAIL, PATHFINDER, KICKS PLAY, NP300, URVAN, FRONTIER, KICKS, MAGNITE",
          description:
            "Tapetes Uso Rudo original para Nissan, calidad garantizada.",
          price: 2873,
          price_promo: 2873, // Precio con promo
          price_base: 2873, // Precio base
          type: "accesorios",
        },
        {
          title: "Cobertura de Llaves",
          description:
            "Cobertura de llaves por 1 año para proteger contra pérdida o daño.",
          price: 3152,
          price_promo: 3152, // Precio con promo
          price_base: 3152, // Precio base
          type: "garantias",
        },
      ],
      totalPrice: 13899,
      totalPrice_promo: 13899, // Total con promo 22%
      totalPrice_base: 13899,
      isSelected: false,
    },
    {
      title: "Gold",
      accessories: [
        {
          title: "PROTECCIÓN DE LLANTAS POR $4,000.00 1 AÑO",
          description:
            "Cobertura para daños en llantas por caminos en mal estado.",
          price: 5279,
          price_promo: 5279, // Precio con promo
          price_base: 5279, // Precio base
          type: "garantias",
        },
        {
          title: "Pelicula Polarizado - Todos",
          description:
            "Lámina de control solar o seguridad para cristales. Reduce el calor, protege contra rayos UV y aumenta la privacidad.",
          price: 2899,
          price_promo: 2899, // Precio con promo
          price_base: 2899, // Precio base
          type: "accesorios",
        },
        {
          title: "Tatuado Autopartes - Todos",
          description:
            "Grabado de seguridad o decorativo en cristales o espejos para prevenir robos o personalizar el diseño.",
          price: 2899,
          price_promo: 2899, // Precio con promo
          price_base: 2899, // Precio base
          type: "accesorios",
        },
        {
          title: "Cobertura de Llaves",
          description:
            "Cobertura de llaves por 1 año para proteger contra pérdida o daño.",
          price: 3019,
          price_promo: 3019, // Precio con promo
          price_base: 3019, // Precio base
          type: "garantias",
        },
      ],
      totalPrice: 14096,
      totalPrice_promo: 14096, // Total con promo 15%
      totalPrice_base: 14096,
      isSelected: false,
    },
    {
      title: "Platinum",
      accessories: [
        {
          title: "PROTECCIÓN DE LLANTAS POR $4,000.00 1 AÑO",
          description:
            "Cobertura para daños en llantas por caminos en mal estado.",
          price: 5279,
          price_promo: 5279, // Precio con promo
          price_base: 5279, // Precio base
          type: "garantias",
        },
        {
          title: "Pelicula Polarizado - Todos",
          description:
            "Lámina de control solar o seguridad para cristales. Reduce el calor, protege contra rayos UV y aumenta la privacidad.",
          price: 2899,
          price_promo: 2899, // Precio con promo
          price_base: 2899, // Precio base
          type: "accesorios",
        },
        {
          title: "Cobertura de Llaves",
          description:
            "Cobertura de llaves por 1 año para proteger contra pérdida o daño.",
          price: 3019,
          price_promo: 3019, // Precio con promo
          price_base: 3019, // Precio base
          type: "garantias",
        },
      ],
      totalPrice: 11197,
      totalPrice_promo: 11197, // Total con promo 11%
      totalPrice_base: 11197,
      isSelected: false,
    },
    {
      title: "Plan cliente",
      accessories: [], // Sin accesorios
      totalPrice: 0,
      totalPrice_promo: 0, // Total con promo
      totalPrice_base: 0,
      isSelected: false,
    },
  ];

  // Se eliminan paquetes precargados anteriores por marca; se usa planInicial como base.
  // El único precargado especial queda en Gold Tecámac.

  // Helpers (arriba del componente una sola vez)
  const toNumber = (v) => {
    if (v == null) return 0;
    if (typeof v === "number" && Number.isFinite(v)) return v;
    const n = Number(String(v).replace(/[^\d.-]/g, ""));
    return Number.isFinite(n) ? n : 0;
  };
  const norm = (s) =>
    (s || "")
      .toLowerCase()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .replace(/\s+/g, " ")
      .trim();

  const homologarTipoAuto = (tipo = "") => {
    const value = String(tipo).trim().toLowerCase();

    if (value === "nuevos") return "Nuevo";
    if (value === "seminuevos") return "Seminuevo";

    return tipo || "Sin condición";
  };

  const normalizarNombrePlan = (planOrTitle = "") => {
    const title =
      typeof planOrTitle === "string" ? planOrTitle : planOrTitle?.title || "";

    return norm(title)
      .replace(/paquete/g, "")
      .replace(/plan/g, "")
      .replace(/\s+/g, " ")
      .trim();
  };

  // Llave estable por nombre de plan.
  // Evita intermitencia cuando React/efectos reconstruyen o reordenan plansState
  // mientras se abre el modal o se agregan/quitan accesorios.
  const selectedPlanKeyRef = useRef("");

  const getPlanKey = useCallback((planOrTitle = "") => {
    return normalizarNombrePlan(planOrTitle);
  }, []);

  // Evita que una rehidratación/polling con datos viejos reconstruya los planes
  // justo después de agregar o quitar accesorios. Ese era el "rebote" visual.
  const planMutationGuardRef = useRef({ ventaId: "", until: 0 });

  const getActiveVentaIdForPlans = useCallback(
    (ventaId = "") => {
      return String(
        ventaId ||
          selectedMailDataRef.current?.id ||
          selectedMailData?.id ||
          "",
      );
    },
    [selectedMailData?.id],
  );

  const activatePlanMutationGuard = useCallback(
    (ventaId = "", durationMs = 9000) => {
      const ventaIdActual = getActiveVentaIdForPlans(ventaId);
      if (!ventaIdActual) return;

      planMutationGuardRef.current = {
        ventaId: ventaIdActual,
        until: Date.now() + durationMs,
      };
    },
    [getActiveVentaIdForPlans],
  );

  const isPlanMutationGuardActive = useCallback(
    (ventaId = "") => {
      const ventaIdActual = getActiveVentaIdForPlans(ventaId);
      const guard = planMutationGuardRef.current || {};

      if (!guard.ventaId || !guard.until) return false;

      if (Date.now() > Number(guard.until || 0)) {
        planMutationGuardRef.current = { ventaId: "", until: 0 };
        return false;
      }

      return !ventaIdActual || String(guard.ventaId) === String(ventaIdActual);
    },
    [getActiveVentaIdForPlans],
  );

  const closeAccessoryModal = useCallback(() => {
    accessoryModalOpenRunIdRef.current += 1;
    accessoryModalPlanTargetRef.current = { index: null, key: "" };
    setModalOpen(false);
    setAccessoryModalPlanIndex(null);
    setAccessoryModalPlanKey("");
    setAccessoryModalPlanSnapshot(null);
  }, []);

  useEffect(() => {
    if (!modalOpen || typeof document === "undefined") return undefined;

    const previousBodyOverflow = document.body.style.overflow;
    const previousBodyPaddingRight = document.body.style.paddingRight;

    document.body.classList.add("modal-open");
    document.body.style.overflow = "hidden";

    return () => {
      document.body.classList.remove("modal-open");
      document.body.style.overflow = previousBodyOverflow;
      document.body.style.paddingRight = previousBodyPaddingRight;
    };
  }, [modalOpen]);

  const esPlanGold = (planOrTitle = "") =>
    normalizarNombrePlan(planOrTitle).includes("gold");

  const esPlanCliente = (planOrTitle = "") =>
    normalizarNombrePlan(planOrTitle).includes("cliente");

  const esPlanNoEditable = (planOrTitle = "") =>
    esPlanGold(planOrTitle) || esPlanCliente(planOrTitle);

  const getOrdenPlanFinanciamiento = (planOrTitle = "") => {
    const nombre = normalizarNombrePlan(planOrTitle);

    if (nombre.includes("elite")) return 1;
    if (nombre.includes("gold")) return 2;
    if (nombre.includes("platinum")) return 3;
    if (nombre.includes("cliente")) return 4;

    return 99;
  };

  const ordenarPlanesPorOrdenFijo = (planes = []) => {
    if (!Array.isArray(planes)) return [];

    return [...planes].sort((a, b) => {
      const ordenA = getOrdenPlanFinanciamiento(a);
      const ordenB = getOrdenPlanFinanciamiento(b);

      if (ordenA !== ordenB) return ordenA - ordenB;

      return String(a?.title || "").localeCompare(String(b?.title || ""));
    });
  };

  const getAnioVehiculoFromVenta = useCallback(
    (venta = selectedMailData) => {
      const selectedCar = getSelectedCarFromVenta(venta);
      const rawYear = getFirstFilledValue(
        venta?.ano_vehiculo,
        venta?.anio_vehiculo,
        venta?.año_vehiculo,
        venta?.year,
        selectedCar?.year,
        selectedCar?.ano,
        selectedCar?.anio,
        selectedCar?.año,
      );

      const match = String(rawYear || "").match(/20\d{2}/);
      return match ? Number(match[0]) : 0;
    },
    [selectedMailData],
  );

  const getCondicionesFinanciamientoCredito = useCallback(
    (venta = selectedMailData) => {
      const tipoAuto = getTipoAutoFromVenta(venta);
      const anio = getAnioVehiculoFromVenta(venta);
      const esSeminuevo = tipoAuto.includes("seminuevo");
      const esNuevo = tipoAuto.includes("nuevo") && !esSeminuevo;

      if (esNuevo && anio >= 2026 && anio <= 2027) {
        return {
          tipoAuto: "NUEVOS",
          anio,
          minMonths: 12,
          maxMonths: 72,
          minDownPaymentPercentage: 15,
        };
      }

      if (esSeminuevo && anio >= 2019 && anio <= 2026) {
        return {
          tipoAuto: "SEMINUEVOS",
          anio,
          minMonths: 12,
          maxMonths: 60,
          minDownPaymentPercentage: 15,
        };
      }

      if (esSeminuevo && anio === 2018) {
        return {
          tipoAuto: "SEMINUEVOS",
          anio,
          minMonths: 12,
          maxMonths: 36,
          minDownPaymentPercentage: 35,
        };
      }

      if (esSeminuevo && anio <= 2017 && anio > 0) {
        return {
          tipoAuto: "SEMINUEVOS",
          anio,
          minMonths: 12,
          maxMonths: 12,
          minDownPaymentPercentage: 35,
        };
      }

      return {
        tipoAuto: esSeminuevo ? "SEMINUEVOS" : esNuevo ? "NUEVOS" : "",
        anio,
        minMonths: 12,
        maxMonths: esSeminuevo ? 60 : 72,
        minDownPaymentPercentage: 15,
      };
    },
    [selectedMailData, getAnioVehiculoFromVenta],
  );

  const condicionesFinanciamientoCredito = useMemo(
    () => getCondicionesFinanciamientoCredito(selectedMailData),
    [selectedMailData, getCondicionesFinanciamientoCredito],
  );

  const getAllowedCreditMonths = useCallback(
    (conditions = condicionesFinanciamientoCredito) => {
      const minMonths = Number(conditions?.minMonths || 12);
      const maxMonths = Number(conditions?.maxMonths || 72);

      return CREDIT_MONTHS_BASE.filter(
        (month) => month >= minMonths && month <= maxMonths,
      );
    },
    [condicionesFinanciamientoCredito],
  );

  const normalizeFinancingMonths = useCallback(
    (months, cashMode = false) => {
      const allowed = cashMode
        ? CASH_MONTHS_BASE
        : getAllowedCreditMonths(condicionesFinanciamientoCredito);
      const numericMonths = Number(months || 0);

      if (allowed.includes(numericMonths)) return numericMonths;

      // Si no hay meses guardados o el valor no es válido, usamos siempre
      // el plazo más alto disponible para la venta actual.
      // Nuevo normalmente queda en 72; seminuevo queda según sus reglas.
      return allowed[allowed.length - 1] || allowed[0] || 12;
    },
    [condicionesFinanciamientoCredito, getAllowedCreditMonths],
  );

  const getMinDownPaymentPercentage = useCallback(
    (venta = selectedMailData) =>
      Number(
        getCondicionesFinanciamientoCredito(venta)?.minDownPaymentPercentage ||
          15,
      ),
    [selectedMailData, getCondicionesFinanciamientoCredito],
  );

  const getMinDownPaymentAmount = useCallback(
    (baseFallback = 0, venta = selectedMailData) => {
      const ventaActual =
        venta || selectedMailDataRef.current || selectedMailData;
      const selectedCar = getSelectedCarFromVenta(ventaActual);
      const vehiclePrice = toNumber(
        getFirstFilledValue(
          ventaActual?.precio_vehiculo,
          selectedCar?.price,
          selectedCar?.precio,
          selectedCar?.precio_vehiculo,
        ),
      );
      const baseForMin = vehiclePrice || toNumber(baseFallback) || 0;

      return Math.round(
        (baseForMin * getMinDownPaymentPercentage(ventaActual)) / 100,
      );
    },
    [selectedMailData, getMinDownPaymentPercentage],
  );

  const ACC_INDEX = Object.fromEntries(
    Object.keys(ACCESORIOS_MAP).map((k) => [norm(k), ACCESORIOS_MAP[k]]),
  );
  const getUnitPrice = (acc) =>
    toNumber(
      acc.price ??
        acc.price_promo ??
        acc.price_base ??
        ACC_INDEX[norm(acc.title)]?.price,
    );

  // Fuente única para totales de paquetes.
  // Evita diferencias entre tarjetas y panel lateral cuando plan.totalPrice
  // queda desfasado contra la lista real de accesorios del paquete.
  const getPlanAccessoriesTotalForFinancing = (plan = {}) => {
    const hasAccessoriesArray = Array.isArray(plan?.accessories);
    const accessories = hasAccessoriesArray ? plan.accessories : [];

    // Si el plan trae accessories como arreglo, ese arreglo es la fuente real.
    // Aunque venga vacío, el paquete vale 0. Esto evita usar totalPrice viejo
    // de otro paquete cuando el plan seleccionado no tiene elementos.
    if (hasAccessoriesArray) {
      const total = accessories.reduce((sum, acc) => {
        const unit = toNumber(
          acc?.price ??
            acc?.price_promo ??
            acc?.price_base ??
            getUnitPrice(acc) ??
            0,
        );
        const qty = toNumber(acc?.qty ?? 1) || 1;

        return sum + unit * qty;
      }, 0);

      return Math.round(total);
    }

    // Fallback sólo para datos viejos de BD donde no venga accessories.
    return Math.round(toNumber(plan?.totalPrice || 0));
  };

  const getPlanAccessoriesTotalExactForDisplay = (plan = {}) => {
    const hasAccessoriesArray = Array.isArray(plan?.accessories);
    const accessories = hasAccessoriesArray ? plan.accessories : [];

    if (hasAccessoriesArray) {
      return accessories.reduce((sum, acc) => {
        const unit = toNumber(
          acc?.price ??
            acc?.price_promo ??
            acc?.price_base ??
            getUnitPrice(acc) ??
            0,
        );
        const qty = toNumber(acc?.qty ?? 1) || 1;

        return sum + unit * qty;
      }, 0);
    }

    // Fallback sólo para datos viejos de BD donde no venga accessories.
    return toNumber(plan?.totalPrice ?? 0);
  };

  const formatCurrencyExact = (value) => {
    const numericValue = toNumber(value);
    if (!Number.isFinite(numericValue)) return "$0.00";

    return `$${numericValue.toLocaleString("es-MX", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })}`;
  };

  const getPlanTotalPriceForFinancing = (
    plan = {},
    vehiclePriceFallback = 0,
  ) => {
    const vehiclePrice = toNumber(
      vehiclePriceFallback ||
        precioVehiculo ||
        selectedMailDataRef.current?.precio_vehiculo ||
        selectedMailData?.precio_vehiculo ||
        0,
    );

    return Math.round(vehiclePrice + getPlanAccessoriesTotalForFinancing(plan));
  };

  // por si cambia el orden, obtenemos el índice de Gold por título
  const getGoldIndex = (plans) =>
    Math.max(
      0,
      plans.findIndex((p) => (p.title || "").toLowerCase() === "gold"),
    );

  // Precio del vehículo normalizado (evita parseFloat directo con "275,900")
  const getVehiclePrice = (selectedMailData) =>
    toNumber(selectedMailData?.precio_vehiculo);

  const getFixedDownPaymentAmount = (
    venta = selectedMailData,
    vehiclePrice = 0,
  ) => {
    const ventaActual =
      venta || selectedMailDataRef.current || selectedMailData || {};
    const precioVehiculoBase =
      toNumber(vehiclePrice) || toNumber(ventaActual?.precio_vehiculo) || 0;

    const engancheDirecto = toNumber(
      formDataRef.current?.engancheEditable ||
        formDataRef.current?.enganche ||
        engancheC ||
        ventaActual?.enganche ||
        ventaActual?.engancheEditable ||
        0,
    );

    if (engancheDirecto > 0) {
      return Math.round(engancheDirecto);
    }

    const minPct = getMinDownPaymentPercentage(ventaActual);
    const porcentaje = toNumber(
      downPaymentPercentage || ventaActual?.porcentaje_enganche || minPct,
    );
    const porcentajeSeguro = porcentaje > 0 ? porcentaje : minPct;

    return Math.round((precioVehiculoBase * porcentajeSeguro) / 100);
  };

  const calculateMonthlyPaymentBabilonia = ({
    total = 0,
    months = 60,
    downPaymentAmount = 0,
    isCashMSI = false,
    annualRate = TASA_ANUAL_FINANCIAMIENTO,
  }) => {
    const baseTotal = toNumber(total);
    const n = Number(months || 0);

    if (!n || n <= 0) return 0;

    if (isCashMSI) {
      return Math.round(baseTotal / n);
    }

    const principal = Math.max(baseTotal - toNumber(downPaymentAmount), 0);
    const monthlyRate =
      (Number(annualRate) > 1 ? Number(annualRate) / 100 : Number(annualRate)) /
      12;

    if (monthlyRate <= 0) {
      return Math.round(principal / n);
    }

    const factor = Math.pow(1 + monthlyRate, n);

    return Math.round((principal * monthlyRate * factor) / (factor - 1));
  };

  const [financingMonths, setFinancingMonths] = useState(60);
  //const [downPaymentPercentage, setDownPaymentPercentage] = useState(100);//yomi
  const [downPaymentPercentage, setDownPaymentPercentage] = useState(() => {
    if (selectedMailData?.entrevista) {
      const data = JSON.parse(selectedMailData.entrevista);
      return data.pago_contado === "Si" ? 100 : 15;
    }
    return 15; // valor por defecto si no hay datos
  });
  useEffect(() => {
    if (!selectedMailData) return;

    try {
      const data = selectedMailData.entrevista
        ? JSON.parse(selectedMailData.entrevista)
        : {};

      const baseInicial = toNumber(
        selectedMailData.precio_total || selectedMailData.precio_vehiculo || 0,
      );
      const engancheInicial = toNumber(
        selectedMailData.engancheEditable ||
          selectedMailData.enganche ||
          data.engancheEditable ||
          data.enganche ||
          0,
      );

      const minPct = getMinDownPaymentPercentage(selectedMailData);

      if (data.pago_contado === "Si") {
        setDownPaymentPercentage(100);
      } else if (baseInicial > 0 && engancheInicial > 0) {
        setDownPaymentPercentage(
          Math.max(
            minPct,
            Math.round((engancheInicial / baseInicial) * 100 * 100) / 100,
          ),
        );
      } else {
        setDownPaymentPercentage(minPct);
      }
    } catch (error) {
      console.warn(
        "No se pudo calcular porcentaje inicial de enganche:",
        error,
      );
      setDownPaymentPercentage(getMinDownPaymentPercentage(selectedMailData));
    }
  }, [selectedMailData?.id, getMinDownPaymentPercentage]);

  const [monthlyPayment, setMonthlyPayment] = useState(0);
  const [selectedPlan, setSelectedPlan] = useState(null); // Estado para el plan seleccionado
  const [precioTotal, setPrecioTotal] = useState(0); // Estado para el precio total
  const [selectedVersion, setSelectedVersion] = useState(""); //almacenar la versión
  const [monthlyPaymentDraft, setMonthlyPaymentDraft] = useState("");
  const [isEditingMonthly, setIsEditingMonthly] = useState(false); //modificar mensualidad
  const monthlyTimeoutRef = useRef(null);
  const engancheTimeoutRef = useRef(null);
  const financingUpdateTimeoutRef = useRef(null);
  const downPaymentCommitTimeoutRef = useRef(null);
  const downPaymentPercentageDraftRef = useRef(null);
  const isDownPaymentDraggingRef = useRef(false);
  const [downPaymentPercentageDraftValue, setDownPaymentPercentageDraftValue] =
    useState(null);
  const activeFinancingEditRef = useRef("");
  const [activeFinancingEdit, setActiveFinancingEdit] = useState("");
  const [engancheDraftInput, setEngancheDraftInput] = useState("");
  const [mensualidadDraftInput, setMensualidadDraftInput] = useState("");
  const engancheDraftOriginalRawRef = useRef("");
  const mensualidadDraftOriginalRawRef = useRef("");
  const userEditingReleaseTimerRef = useRef(null);
  const autoGuardarFnRef = useRef(null);
  const personalDataFlatSaveTimerRef = useRef(null);

  const keepUserEditingBriefly = useCallback((durationMs = 3200) => {
    isUserEditing.current = true;

    if (userEditingReleaseTimerRef.current) {
      clearTimeout(userEditingReleaseTimerRef.current);
    }

    userEditingReleaseTimerRef.current = setTimeout(() => {
      if (
        !activeFinancingEditRef.current &&
        !isEditingFinancingModalRef.current
      ) {
        isUserEditing.current = false;
      }

      userEditingReleaseTimerRef.current = null;
    }, durationMs);
  }, []);

  const queueAutoGuardarEntrevista = useCallback(
    (nextFormData, delayMs = 700) => {
      const snapshot = {
        ...(nextFormData || formDataRef.current || {}),
      };

      formDataRef.current = snapshot;

      if (autoGuardarTimeout.current) {
        clearTimeout(autoGuardarTimeout.current);
      }

      autoGuardarTimeout.current = setTimeout(() => {
        autoGuardarFnRef.current?.(formDataRef.current);
      }, delayMs);
    },
    [],
  );

  const startFinancingEdit = useCallback((field = "") => {
    activeFinancingEditRef.current = field;
    setActiveFinancingEdit(field);
    isUserEditing.current = true;
  }, []);

  const finishFinancingEdit = useCallback((field = "", options = {}) => {
    if (!field || activeFinancingEditRef.current === field) {
      activeFinancingEditRef.current = "";
      setActiveFinancingEdit("");
    }

    // No liberamos la edición inmediatamente al hacer blur/commit.
    // El backend y el polling pueden tardar unos segundos en regresar el valor nuevo;
    // si soltamos el guard al instante, algún efecto puede repintar el enganche o la
    // mensualidad con el valor anterior y se percibe como "rebote".
    const releaseDelayMs = Number(options?.releaseDelayMs ?? 9000);

    if (userEditingReleaseTimerRef.current) {
      clearTimeout(userEditingReleaseTimerRef.current);
    }

    userEditingReleaseTimerRef.current = setTimeout(
      () => {
        if (
          !activeFinancingEditRef.current &&
          !isEditingFinancingModalRef.current
        ) {
          isUserEditing.current = false;
        }

        userEditingReleaseTimerRef.current = null;
      },
      Math.max(0, releaseDelayMs),
    );
  }, []);
  const cotizadorMensualidadTimerRef = useRef(null);
  const cotizadorEngancheTimerRef = useRef(null);
  const selectedPlanVentaIdRef = useRef("");
  const engancheCVentaIdRef = useRef("");
  const manualEngancheVentaIdRef = useRef("");
  const manualEngancheValueRef = useRef("");
  const plansLoadedVentaIdRef = useRef("");
  const plansPersistTimeoutRef = useRef(null);
  const financingSyncRunIdRef = useRef(0);
  const lastFinancingDataSignatureRef = useRef("");
  const updateFinancingDataRef = useRef(null);
  const autoAppliedSingleMonthsRef = useRef("");
  const autoSelectedSingleVersionRef = useRef("");

  // Evita saturar la API cuando varios efectos recalculan el plan en cadena.
  // Sólo se envía el último snapshot real de planes_financiamiento y se ignoran
  // firmas repetidas.
  const planSnapshotSaveTimeoutRef = useRef(null);
  const lastPlanSnapshotSignatureRef = useRef("");
  const pendingPlanSnapshotSignatureRef = useRef("");
  const pendingPlanSnapshotPayloadRef = useRef(null);
  const lastAutoPlanVisualSyncSignatureRef = useRef("");

  const VENTA_FINANCIAMIENTO_DB_FIELDS = useMemo(
    () =>
      new Set([
        "folio_venta",
        "nombre",
        "telefono",
        "correo_electronico",
        "acepta_aviso_privacidad",
        "depende_auto",
        "condiciones_calle",
        "perdio_llaves",
        "tipo_auto",
        "preocupacion_fallas",
        "preocupacion_robo",
        "ingreso_mensual",
        "edad",
        "enganche",
        "historial_crediticio",
        "tipo_trabajo",
        "accesorios_seleccionados",
        "planes_seleccionados",
        "planes_financiamiento",
        "marca_vehiculo",
        "modelo_vehiculo",
        "ano_vehiculo",
        "version_vehiculo",
        "url_img",
        "agencia",
        "ag_id",
        "precio_vehiculo",
        "precio_total",
        "qr_venta",
        "meses_financiamiento",
        "porcentaje_enganche",
        "mensualidad_estimacion",
        "asesor",
        "id_usuario",
        "activo",
        "fecha_actualizacion",
        "versiones",
        "terminos_modal",
        "accesorios_modal",
        "financiamiento_modal",
        "firma_modal",
        "contenido",
        "financiera",
        "status",
        "sub_status",
        "nr_finance",
        "banorte",
        "scotiabank",
        "santander",
        "cibanco",
        "sicrea",
        "bbva",
        "hey_banco",
        "hsbc",
        "cetelem",
        "vwfs",
        "seat_sf",
        "cupra_sf",
        "kuna",
        "mstar",
        "credito_go",
        "finanmadrid",
        "nexu",
        "historial_cambios",
        "entrevista",
        "selected_car",
        "order_cart",
        "entrevista_nissan",
        "historial_cambios_status",
        "comentarios",
        "fuente",
        "venta_babilonia",
        "prueba_manejo",
        "adicionales_contado",
        "fuente_origen",
        "aseguradora",
        "monto_seguro",
        "tipo_compra_seguro",
        "monto_comision_apertura",
        "tipo_comision",
        "monto_placas",
        "cliente_volver_inventario",
        "cliente_volver_inventario_fecha",
        "solicitar_prueba_manejo_cliente",
        "solicitar_prueba_manejo_fecha",
        "respuesta_prueba_manejo_cliente",
        "respuesta_prueba_manejo_fecha",
        "venta_finalizada_cliente",
        "venta_finalizada_cliente_fecha",
        "venta_finalizada_cliente_usuario_id",
        "venta_finalizada_cliente_nombre",
      ]),
    [],
  );

  const normalizeVentaFinanciamientoPayload = useCallback(
    (rawPayload = {}) => {
      const payload = {};

      Object.entries(rawPayload || {}).forEach(([campo, valor]) => {
        if (
          campo === "access_token" ||
          campo === "venta_id" ||
          valor === undefined ||
          !VENTA_FINANCIAMIENTO_DB_FIELDS.has(campo)
        ) {
          return;
        }

        payload[campo] = valor;
      });

      const mesesRaw =
        rawPayload?.meses_financiamiento ??
        rawPayload?.plazo_meses ??
        rawPayload?.meses ??
        rawPayload?.financingMonths;

      if (mesesRaw !== undefined && mesesRaw !== null && mesesRaw !== "") {
        payload.meses_financiamiento =
          Number(String(mesesRaw).replace(/\D/g, "")) || null;
      }

      const mensualidadRaw =
        rawPayload?.mensualidad_estimacion ??
        rawPayload?.mensualidad_buscada ??
        rawPayload?.mensualidad;

      if (
        mensualidadRaw !== undefined &&
        mensualidadRaw !== null &&
        mensualidadRaw !== ""
      ) {
        payload.mensualidad_estimacion = toNumber(mensualidadRaw);
      }

      const engancheRaw = rawPayload?.enganche ?? rawPayload?.engancheEditable;

      if (
        engancheRaw !== undefined &&
        engancheRaw !== null &&
        engancheRaw !== ""
      ) {
        payload.enganche = toNumber(engancheRaw);
      }

      const tasaRaw =
        rawPayload?.perdio_llaves ??
        rawPayload?.tasa ??
        rawPayload?.tasa_financiamiento ??
        rawPayload?.tasaC;

      if (tasaRaw !== undefined && tasaRaw !== null && tasaRaw !== "") {
        payload.perdio_llaves = String(tasaRaw).replace(/[^0-9.]/g, "");
      }

      return payload;
    },
    [VENTA_FINANCIAMIENTO_DB_FIELDS],
  );

  async function guardarFinanciamientoSnapshotBD(rawPayload = {}) {
    const ventaActual = selectedMailDataRef.current || selectedMailData || {};
    const ventaId = String(
      rawPayload?.venta_id ||
        ventaActual?.id ||
        formDataRef.current?.venta_id ||
        "",
    );

    if (!ventaId) {
      console.warn("No se pudo guardar financiamiento: venta_id vacío.");
      return null;
    }

    const payloadDb = normalizeVentaFinanciamientoPayload(rawPayload);

    if (!Object.keys(payloadDb).length) {
      console.warn(
        "No se pudo guardar financiamiento: no hay campos válidos para venta_financiamiento.",
        rawPayload,
      );
      return null;
    }

    const payload = {
      access_token: accessToken,
      venta_id: ventaId,
      ...payloadDb,
    };

    const response = await fetch(apiUpdateEstadoUrl, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    });

    let data = null;

    try {
      data = await response.json();
    } catch {
      data = null;
    }

    if (!response.ok || Number(data?.statusCode || 200) >= 400) {
      throw new Error(
        data?.message || data?.error || `Error HTTP ${response.status}`,
      );
    }

    return data;
  }

  const isManualFinancingModalGuardActive = useCallback((ventaIdArg = "") => {
    const guard = manualFinancingModalGuardRef.current || {};
    const ventaId = String(
      ventaIdArg ||
        selectedMailDataRef.current?.id ||
        formDataRef.current?.venta_id ||
        "",
    );

    if (isSavingFinancingModalRef.current) return true;
    if (isEditingFinancingModalRef.current) return true;

    if (guard.until && Date.now() <= Number(guard.until || 0)) {
      return !guard.ventaId || String(guard.ventaId) === ventaId;
    }

    return false;
  }, []);

  const isManualFinancingModalSavedActive = useCallback((ventaIdArg = "") => {
    const guard = manualFinancingModalSavedRef.current || {};
    const ventaId = String(
      ventaIdArg ||
        selectedMailDataRef.current?.id ||
        formDataRef.current?.venta_id ||
        "",
    );

    return Boolean(
      guard.active && (!guard.ventaId || String(guard.ventaId) === ventaId),
    );
  }, []);

  const markManualFinancingModalSaved = useCallback((ventaIdArg = "") => {
    const ventaId = String(
      ventaIdArg ||
        selectedMailDataRef.current?.id ||
        formDataRef.current?.venta_id ||
        "",
    );
    manualFinancingModalSavedRef.current = {
      ventaId,
      active: Boolean(ventaId),
    };
  }, []);

  const releaseManualFinancingModalSaved = useCallback((ventaIdArg = "") => {
    const ventaId = String(
      ventaIdArg ||
        selectedMailDataRef.current?.id ||
        formDataRef.current?.venta_id ||
        "",
    );
    const guard = manualFinancingModalSavedRef.current || {};

    if (!guard.active) return;
    if (!guard.ventaId || !ventaId || String(guard.ventaId) === ventaId) {
      manualFinancingModalSavedRef.current = { ventaId: "", active: false };
    }
  }, []);

  const getMesesFromVentaBD = useCallback((venta = {}) => {
    const parseMonths = (value) => {
      const numberValue = Number(String(value ?? "").replace(/\D/g, ""));
      return Number.isFinite(numberValue) && numberValue > 0 ? numberValue : 0;
    };

    const mesesDirectos = parseMonths(
      venta?.meses_financiamiento ?? venta?.plazo_meses,
    );

    if (mesesDirectos > 0) return mesesDirectos;

    try {
      const entrevistaParsed =
        typeof venta?.entrevista === "string"
          ? JSON.parse(venta.entrevista || "{}")
          : venta?.entrevista || {};

      return parseMonths(
        entrevistaParsed?.meses_financiamiento ?? entrevistaParsed?.plazo_meses,
      );
    } catch {
      return 0;
    }
  }, []);

  const plansTouchStartYRef = useRef(0);
  const [selectedVehicleName, setSelectedVehicleName] = useState("");

  const shouldContainNestedScroll = useCallback((element, deltaY = 0) => {
    if (!element) return false;

    const canScroll = element.scrollHeight > element.clientHeight + 2;
    if (!canScroll) return false;

    const atTop = element.scrollTop <= 0;
    const atBottom =
      element.scrollTop + element.clientHeight >= element.scrollHeight - 2;

    // Si todavía hay espacio para desplazarse dentro del contenedor,
    // detenemos el scroll del padre para que se muevan los paquetes.
    return !((deltaY < 0 && atTop) || (deltaY > 0 && atBottom));
  }, []);

  const handleNestedScrollWheel = useCallback(
    (event) => {
      if (shouldContainNestedScroll(event.currentTarget, event.deltaY || 0)) {
        event.stopPropagation();
      }
    },
    [shouldContainNestedScroll],
  );

  const handleNestedScrollTouchStart = useCallback((event) => {
    plansTouchStartYRef.current = event.touches?.[0]?.clientY || 0;
  }, []);

  const handleNestedScrollTouchMove = useCallback(
    (event) => {
      const currentY = event.touches?.[0]?.clientY || 0;
      const deltaY = plansTouchStartYRef.current - currentY;

      if (shouldContainNestedScroll(event.currentTarget, deltaY)) {
        event.stopPropagation();
      }
    },
    [shouldContainNestedScroll],
  );

  let initialPlans = ordenarPlanesPorOrdenFijo(planInicial); // referencia global
  const [plansState, setPlansState] = useState(initialPlans);
  const [basePlansState, setBasePlansState] = useState(initialPlans);

  // Modal de accesorios: se declara después de plansState para evitar
  // ReferenceError: Cannot access 'plansState' before initialization.
  const openAccessoryModalForPlan = useCallback(
    (plan, planIndex) => {
      const index = Number(planIndex);
      const safeIndex = Number.isInteger(index) && index >= 0 ? index : null;

      const latestPlanFromState =
        safeIndex !== null && Array.isArray(plansState) && plansState[safeIndex]
          ? plansState[safeIndex]
          : null;

      const planToOpen = latestPlanFromState || plan || null;
      const planKey = getPlanKey(planToOpen || plan);

      if (!planToOpen && !planKey && safeIndex === null) return;

      const target = {
        index: safeIndex,
        key: planKey,
      };

      const safePlanSnapshot = planToOpen
        ? {
            ...planToOpen,
            accessories: Array.isArray(planToOpen?.accessories)
              ? planToOpen.accessories.map((accessory) =>
                  accessory && typeof accessory === "object"
                    ? { ...accessory }
                    : accessory,
                )
              : [],
          }
        : null;

      accessoryModalOpenRunIdRef.current += 1;
      accessoryModalPlanTargetRef.current = target;

      // Apertura directa: evitar cerrar/abrir en dos frames, porque en el plan
      // seleccionado el re-render podía dejar modalOpen en falso o con target viejo.
      setAccessoryModalPlanIndex(safeIndex);
      setAccessoryModalPlanKey(planKey);
      setAccessoryModalPlanSnapshot(safePlanSnapshot);
      setModalOpen(true);
    },
    [getPlanKey, plansState],
  );

  // Controla qué planes editables ya fueron modificados manualmente por el asesor.
  // Esto evita que los efectos que rehidratan datos de cliente/BD vuelvan a
  // reconstruir Elite/Platinum y “reboten” lo que el asesor agregó o quitó.
  const manuallyEditedPlanNamesRef = useRef(new Set());

  const getPlanManualEditKey = useCallback((planOrTitle = "") => {
    const key = normalizarNombrePlan(planOrTitle);
    return (
      key ||
      String(
        typeof planOrTitle === "string"
          ? planOrTitle
          : planOrTitle?.title || "",
      )
        .trim()
        .toLowerCase()
    );
  }, []);

  const isEditablePlanManuallyEdited = useCallback(
    (planOrTitle = "") => {
      const key = getPlanManualEditKey(planOrTitle);
      return Boolean(key && manuallyEditedPlanNamesRef.current?.has(key));
    },
    [getPlanManualEditKey],
  );

  const markPlanAsManuallyEdited = useCallback(
    (planOrTitle = "") => {
      if (esPlanNoEditable(planOrTitle)) return;

      const key = getPlanManualEditKey(planOrTitle);
      if (!key) return;

      manuallyEditedPlanNamesRef.current.add(key);
    },
    [getPlanManualEditKey],
  );

  const getAccessoryStableSignature = useCallback((accessories = []) => {
    if (!Array.isArray(accessories)) return "[]";

    const normalized = accessories
      .map((acc) => {
        const title = norm(
          typeof acc === "object" ? acc?.title || acc?.nombre || "" : acc,
        );
        if (!title) return null;

        const type = norm(acc?.type || acc?.tipo || "");
        const priceBase = toNumber(acc?.price_base ?? acc?.price ?? 0);
        const pricePromo = toNumber(
          acc?.price_promo ?? acc?.promoPrice ?? acc?.price ?? priceBase,
        );
        const qty = toNumber(acc?.qty ?? 1) || 1;

        return [title, type, priceBase, pricePromo, qty].join("|");
      })
      .filter(Boolean)
      .sort();

    return JSON.stringify(normalized);
  }, []);

  const isPlanPersistedAsManual = useCallback((plan = {}) => {
    return Boolean(
      plan?.manual_edit === true ||
      plan?.manual_edit === 1 ||
      plan?.manual_edit === "1" ||
      plan?.manual_edit === "true" ||
      plan?.manuallyEdited === true ||
      plan?.manuallyEdited === 1 ||
      plan?.manuallyEdited === "1" ||
      plan?.manuallyEdited === "true" ||
      plan?.manualEdited === true ||
      plan?.manualEdited === 1 ||
      plan?.manualEdited === "1" ||
      plan?.manualEdited === "true" ||
      plan?.edited_by_advisor === true ||
      plan?.edited_by_advisor === 1 ||
      plan?.edited_by_advisor === "1" ||
      plan?.edited_by_advisor === "true" ||
      plan?.editedByAdvisor === true ||
      plan?.editedByAdvisor === 1 ||
      plan?.editedByAdvisor === "1" ||
      plan?.editedByAdvisor === "true",
    );
  }, []);

  const markPlanObjectAsManual = useCallback((plan = {}) => {
    return {
      ...plan,
      manual_edit: true,
      manuallyEdited: true,
      edited_by_advisor: true,
      editedByAdvisor: true,
    };
  }, []);

  useEffect(() => {
    manuallyEditedPlanNamesRef.current = new Set();
    selectedPlanKeyRef.current = "";
    accessoryModalOpenRunIdRef.current += 1;
    accessoryModalPlanTargetRef.current = { index: null, key: "" };
    setAccessoryModalPlanIndex(null);
    setAccessoryModalPlanKey("");
    setAccessoryModalPlanSnapshot(null);
    setModalOpen(false);
    lastAutoPlanVisualSyncSignatureRef.current = "";
    autoAppliedSingleMonthsRef.current = "";
    autoSelectedSingleVersionRef.current = "";

    // Al cambiar de venta, no arrastramos guards de edición de la venta anterior.
    // Si se quedaban activos, podían impedir aplicar el mes default de la nueva venta.
    isUserEditing.current = false;
    activeFinancingEditRef.current = "";
    setActiveFinancingEdit("");
    isEditingFinancingModalRef.current = false;
    modalFinancingMonthsDirtyRef.current = false;
    if (userEditingReleaseTimerRef.current) {
      clearTimeout(userEditingReleaseTimerRef.current);
      userEditingReleaseTimerRef.current = null;
    }
    pendingPlanSnapshotSignatureRef.current = "";
    pendingPlanSnapshotPayloadRef.current = null;
    if (planSnapshotSaveTimeoutRef.current) {
      clearTimeout(planSnapshotSaveTimeoutRef.current);
      planSnapshotSaveTimeoutRef.current = null;
    }
  }, [selectedMailData?.id]);

  const selectedPlanForFinancing = useMemo(() => {
    const ventaIdActual = String(
      selectedMailData?.id || selectedMailDataRef.current?.id || "",
    );
    const plansStatePerteneceVentaActual =
      Boolean(ventaIdActual) &&
      String(plansLoadedVentaIdRef.current || "") === ventaIdActual;
    const seleccionPerteneceVentaActual =
      Boolean(ventaIdActual) &&
      String(selectedPlanVentaIdRef.current || "") === ventaIdActual;

    // Fuente principal: planes_financiamiento desde BD ya viene reflejado en
    // plansState con isSelected. Buscarlo por bandera evita que el panel derecho
    // dependa de selectedPlanFinal/selectedPlanIndex, que pueden limpiarse al
    // cambiar de venta antes de que React termine de restaurar el estado.
    // Importante: si plansState todavía pertenece a la venta anterior, se ignora
    // para no mostrar "plan seleccionado" en una venta nueva sin selección.
    const selectedFromPlansState =
      plansStatePerteneceVentaActual && Array.isArray(plansState)
        ? plansState.find((plan) => plan?.isSelected && !esPlanCliente(plan))
        : null;

    if (selectedFromPlansState) return selectedFromPlansState;

    if (!seleccionPerteneceVentaActual) return null;

    const selectedIndex = Number.isInteger(selectedPlanFinal)
      ? selectedPlanFinal
      : Number.isInteger(selectedPlanIndex)
        ? selectedPlanIndex
        : -1;

    if (
      selectedIndex >= 0 &&
      Array.isArray(plansState) &&
      plansState[selectedIndex]
    ) {
      return plansState[selectedIndex];
    }

    return selectedPlan;
  }, [
    plansState,
    selectedPlanFinal,
    selectedPlanIndex,
    selectedPlan,
    selectedMailData?.id,
  ]);

  // Total calculado en vivo para el panel derecho.
  // Esto evita que el panel se quede con el precio del vehículo cuando
  // el plan seleccionado ya viene guardado desde BD en planes_financiamiento.
  const precioTotalConPlanActual = useMemo(() => {
    const vehiclePrice = toNumber(
      precioVehiculo ||
        selectedMailDataRef.current?.precio_vehiculo ||
        selectedMailData?.precio_vehiculo ||
        0,
    );

    if (selectedPlanForFinancing) {
      return getPlanTotalPriceForFinancing(
        selectedPlanForFinancing,
        vehiclePrice,
      );
    }

    return Math.round(toNumber(precioTotal || vehiclePrice || 0));
  }, [
    precioTotal,
    precioVehiculo,
    selectedMailData?.precio_vehiculo,
    selectedPlanForFinancing,
  ]);

  const precioTotalPanelDerecho = selectedPlanForFinancing
    ? precioTotalConPlanActual
    : toNumber(precioTotal || selectedMailData?.precio_vehiculo || 0);

  const nrPdfBlob = useMemo(() => nrCreatePdfBlob(nrPdfBase64), [nrPdfBase64]);
  const nrPdfDataUrl = useMemo(
    () => (nrPdfBlob ? URL.createObjectURL(nrPdfBlob) : ""),
    [nrPdfBlob],
  );

  useEffect(
    () => () => {
      if (nrPdfDataUrl) URL.revokeObjectURL(nrPdfDataUrl);
    },
    [nrPdfDataUrl],
  );

  const nrMensualidadOficial = useMemo(
    () => nrGetMonthlyPayment(nrCotizacion),
    [nrCotizacion],
  );
  const nrPagoInicialOficial = useMemo(
    () => nrGetInitialPayment(nrCotizacion),
    [nrCotizacion],
  );
  const nrEngancheReportado = useMemo(
    () => nrGetReportedDownPayment(nrCotizacion),
    [nrCotizacion],
  );
  const nrMontoFinanciarOficial = useMemo(
    () => nrGetFinancedAmount(nrCotizacion),
    [nrCotizacion],
  );
  const nrTasaOficial = useMemo(() => nrGetRate(nrCotizacion), [nrCotizacion]);
  const nrPagoUnidadOficial = useMemo(
    () => nrGetUnitPayment(nrCotizacion),
    [nrCotizacion],
  );
  const nrPagoSeguroVehiculo = useMemo(
    () => nrGetVehicleInsurancePayment(nrCotizacion),
    [nrCotizacion],
  );
  const nrPagoSeguroVida = useMemo(
    () => nrGetLifeInsurancePayment(nrCotizacion),
    [nrCotizacion],
  );
  const nrMontoComisionApertura = useMemo(
    () => nrGetOpeningCommission(nrCotizacion),
    [nrCotizacion],
  );
  const nrPagoComisionApertura = useMemo(
    () => nrGetOpeningCommissionPayment(nrCotizacion),
    [nrCotizacion],
  );
  const nrSeguroAnual = useMemo(
    () => nrGetAnnualInsurance(nrCotizacion),
    [nrCotizacion],
  );

  const nrCatalogosAnzen = useMemo(
    () => nrCatalogos?.anzen || {},
    [nrCatalogos?.anzen],
  );

  const nrMunicipiosOptions = useMemo(
    () =>
      Array.isArray(nrCatalogosAnzen?.Municipalities)
        ? nrCatalogosAnzen.Municipalities
        : [],
    [nrCatalogosAnzen],
  );

  const nrAseguradorasOptions = useMemo(
    () =>
      Array.isArray(nrCatalogosAnzen?.Insurances)
        ? nrCatalogosAnzen.Insurances
        : [],
    [nrCatalogosAnzen],
  );

  const nrCoberturasOptions = useMemo(
    () =>
      Array.isArray(nrCatalogosAnzen?.TypeOfCoverages)
        ? nrCatalogosAnzen.TypeOfCoverages
        : [],
    [nrCatalogosAnzen],
  );

  const nrUsosOptions = useMemo(
    () =>
      Array.isArray(nrCatalogosAnzen?.TypeOfUses)
        ? nrCatalogosAnzen.TypeOfUses
        : [],
    [nrCatalogosAnzen],
  );

  const nrUdiOptions = useMemo(
    () =>
      Array.isArray(nrCatalogosAnzen?.UdiLevels)
        ? nrCatalogosAnzen.UdiLevels
        : [],
    [nrCatalogosAnzen],
  );

  const nrInsuranceOptions = useMemo(
    () => nrNormalizeAnzenInsuranceOptions(nrAnzenCotizacion),
    [nrAnzenCotizacion],
  );

  const nrSelectedInsurance = useMemo(
    () =>
      nrInsuranceOptions.find(
        (item) =>
          String(item.__key || "") ===
          String(formData.nr_seguro_anzen_key || ""),
      ) || null,
    [formData.nr_seguro_anzen_key, nrInsuranceOptions],
  );

  const getNrClasificacionFromVenta = useCallback(
    (
      venta = selectedMailDataRef.current || selectedMailData,
      clasificacionesParam = nrCatalogos.clasificaciones,
    ) => {
      const tipo = normalizarTexto(
        venta?.tipo_auto ||
          venta?.condicion ||
          getSelectedCarFromVenta(venta)?.type ||
          getSelectedCarFromVenta(venta)?.tipo ||
          "",
      );
      const target = tipo.includes("semi") ? "seminuevo" : "nuevo";
      const items = Array.isArray(clasificacionesParam)
        ? clasificacionesParam
        : [];

      return (
        items.find((item) => {
          const nombre = normalizarTexto(item?.nombre || "");
          return nombre === target || nombre === `${target}s`;
        }) || null
      );
    },
    // OJO: selectedMailData NO va aquí a propósito (mismo criterio que en
    // patchNrFormData/resolveNrHomologacion). El default del parámetro ya
    // prioriza selectedMailDataRef.current; dejar selectedMailData en las
    // dependencias recreaba esta función en cada ciclo del polling de 4s,
    // alimentando el mismo bucle de recarga de municipios.
    [nrCatalogos.clasificaciones],
  );

  const getNrVehicleContext = useCallback(() => {
    const venta = selectedMailDataRef.current || selectedMailData || {};
    const selectedCar = getSelectedCarFromVenta(venta) || {};
    const marca = getFirstFilledValue(
      venta.marca_vehiculo,
      selectedCar.brand,
      selectedCar.marca,
    );
    const modelo = getFirstFilledValue(
      venta.modelo_vehiculo,
      selectedCar.modelo,
      selectedCar.model,
      selectedCar.description,
    );
    const version = getFirstFilledValue(
      venta.version_vehiculo,
      selectedVersion,
      selectedCar.version,
      selectedCar.version_name,
    );
    const anio =
      Number(
        String(
          getFirstFilledValue(
            venta.ano_vehiculo,
            venta.anio_vehiculo,
            selectedCar.year,
            selectedCar.anio,
            selectedCar.ano,
          ),
        ).replace(/\D/g, ""),
      ) || "";

    return {
      venta,
      selectedCar,
      marca: String(marca || "").trim(),
      modelo: String(modelo || "").trim(),
      version: String(version || "").trim(),
      anio,
      searchText: [marca, modelo, version, anio].filter(Boolean).join(" "),
    };
  }, [
    // OJO: selectedMailData NO va aquí, mismo criterio que arriba: adentro ya
    // se usa selectedMailDataRef.current como fuente primaria.
    selectedVersion,
  ]);

  const nrApiPost = useCallback(async (endpoint, payload = {}) => {
    const response = await fetch(`${NR_BABILONIA_API_BASE}${endpoint}`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload || {}),
    });

    let json = {};

    try {
      json = await response.json();
    } catch (error) {
      throw new Error("NR respondió sin JSON válido.");
    }

    const responseData = json?.data ?? json;
    const statusCode = Number(json?.statusCode || response.status || 0);
    const problemStatus = Number(responseData?.status || 0);
    const problemType = String(responseData?.type || "").trim();
    const problemCode = String(
      responseData?.extensions?.code || "",
    ).trim();

    const isError =
      !response.ok ||
      statusCode >= 400 ||
      problemStatus >= 400 ||
      problemType.toLowerCase().includes("/errors/");

    if (isError) {
      const apiError = new Error(
        json?.message ||
          responseData?.detail ||
          responseData?.title ||
          `Error consultando NR (${endpoint})`,
      );

      apiError.code = problemCode;
      apiError.status = problemStatus || statusCode;
      apiError.payload = responseData;
      throw apiError;
    }

    return responseData;
  }, []);

  const nrApiPostSafe = useCallback(
    async (endpoint, payload = {}, fallback = null) => {
      try {
        return await nrApiPost(endpoint, payload);
      } catch (error) {
        console.warn(`No se pudo consultar ${endpoint}:`, error);
        return fallback;
      }
    },
    [nrApiPost],
  );

  const patchNrFormData = useCallback(
    (patch = {}) => {
      const ventaId =
        selectedMailDataRef.current?.id ||
        selectedMailData?.id ||
        formDataRef.current?.venta_id ||
        "";

      const next = {
        ...(formDataRef.current || formData || {}),
        ...patch,
      };

      formDataRef.current = next;
      setFormData(next);

      if (ventaId) {
        patchSelectedVentaInterviewLocal(ventaId, { entrevista: next });
      }

      queueAutoGuardarEntrevista(next, 500);
    },
    // OJO: formData y selectedMailData NO van aquí a propósito (mismo criterio
    // ya aplicado en resolveNrHomologacion/cargarCatalogosAnzenNR, ver sus
    // comentarios). La función ya lee formDataRef.current/
    // selectedMailDataRef.current como fuente real; dejar los objetos de
    // estado en las dependencias hacía que patchNrFormData se regenerara en
    // cada cambio de formData Y en cada ciclo del polling de 4s que refresca
    // selectedMailData (aunque no cambiara nada), lo que a su vez recreaba
    // resolveNrHomologacion/cargarCatalogosAnzenNR y volvía a disparar el
    // efecto de municipios sin parar: el bucle reportado.
    [patchSelectedVentaInterviewLocal, queueAutoGuardarEntrevista],
  );

  const handleNrSimpleInputChange = useCallback(
    (event) => {
      const { name, value } = event.target;
      const patch = { [name]: value };
      const affectsCalculation = new Set([
        "nr_personalidad_juridica",
        "nr_estado_id",
        "nr_municipio_id",
        "nr_tipo_seguro_id",
        "nr_seguro_vida_id",
        "nr_aseguradora_id",
        "nr_cobertura_id",
        "nr_udi_id",
        "nr_uso_id",
      ]);

      if (name === "nr_personalidad_juridica") {
        nrAnzenRequestKeyRef.current = "";
        // La personalidad puede cambiar los paquetes disponibles en NR.
        // Conservamos estrategia/producto, pero obligamos a volver a resolver
        // el plan/paquete antes de habilitar Estado y Municipio.
        patch.nr_plan_id = "";
        patch.nr_plan_nombre = "";
        patch.nr_paquete_externo_id = "";
        patch.nr_plazo = "";
        patch.nr_municipio_id = "";
        patch.nr_municipio_nombre = "";
        patch.nr_aseguradora_id = "";
        patch.nr_aseguradora_nombre = "";
        patch.nr_cobertura_id = "";
        patch.nr_cobertura_nombre = "";
        patch.nr_udi_id = "";
        patch.nr_udi_nombre = "";
        patch.nr_uso_id = "";
        patch.nr_uso_nombre = "";
      }

      if (name === "nr_estado_id") {
        const estado = nrCatalogos.estados.find(
          (item) => String(item?.id ?? "") === String(value),
        );

        nrAnzenRequestKeyRef.current = "";
        patch.nr_estado_nombre = String(estado?.nombre ?? "").trim();
        patch.nr_municipio_id = "";
        patch.nr_municipio_nombre = "";
        patch.nr_aseguradora_id = "";
        patch.nr_aseguradora_nombre = "";
        patch.nr_cobertura_id = "";
        patch.nr_cobertura_nombre = "";
        patch.nr_udi_id = "";
        patch.nr_udi_nombre = "";
        patch.nr_uso_id = "";
        patch.nr_uso_nombre = "";

        setNrCatalogos((prev) => ({ ...prev, anzen: {} }));
      }

      if (name === "nr_municipio_id") {
        const municipio = nrMunicipiosOptions.find(
          (item) => String(item?.MunicipalityId ?? "") === String(value),
        );
        patch.nr_municipio_nombre = String(
          municipio?.Description ?? "",
        ).trim();
      }

      if (name === "nr_tipo_seguro_id") {
        const tipoSeguro = nrCatalogos.tiposSeguro.find(
          (item) => String(item?.id ?? "") === String(value),
        );
        patch.nr_tipo_seguro_nombre = String(tipoSeguro?.nombre ?? "").trim();
      }

      if (name === "nr_aseguradora_id") {
        const aseguradoraItem = nrAseguradorasOptions.find(
          (item) => String(item?.InsuranceId ?? "") === String(value),
        );
        patch.nr_aseguradora_nombre = String(
          aseguradoraItem?.Description ?? "",
        ).trim();
      }

      if (name === "nr_cobertura_id") {
        const cobertura = nrCoberturasOptions.find(
          (item) => String(item?.TypeOfCoverageId ?? "") === String(value),
        );
        patch.nr_cobertura_nombre = String(
          cobertura?.Description ?? "",
        ).trim();
      }

      if (name === "nr_uso_id") {
        const uso = nrUsosOptions.find(
          (item) => String(item?.TypeOfUsesId ?? "") === String(value),
        );
        patch.nr_uso_nombre = String(uso?.Description ?? "").trim();
      }

      if (name === "nr_udi_id") {
        const udi = nrUdiOptions.find(
          (item) => String(item?.UdiLevelId ?? "") === String(value),
        );
        patch.nr_udi_nombre = String(udi?.Description ?? "").trim();
      }

      if (affectsCalculation.has(name)) {
        Object.assign(patch, {
          nr_seguro_anzen_key: "",
          nr_seguro_anzen_id: "",
          nr_seguro_anzen_campania_id: "",
          nr_seguro_anzen_amount: "0",
          nr_seguro_anzen_total_amount: "0",
          nr_seguro_anzen_surcharges: "0",
          nr_seguro_anzen_tipo: "",
        });

        setNrAnzenCotizacion(null);
        setNrAnzenError(null);
        setNrCotizacion(null);
        setNrPdfBase64("");
        setShowNrPdfViewer(false);
        // OJO: montoSeguro (Babilonia) ya NO se toca aquí — ver comentario
        // en applyNrInsuranceOption sobre por qué se desacoplaron.
      }

      patchNrFormData(patch);
    },
    [
      patchNrFormData,
      nrCatalogos.estados,
      nrCatalogos.tiposSeguro,
      nrMunicipiosOptions,
      nrAseguradorasOptions,
      nrCoberturasOptions,
      nrUsosOptions,
      nrUdiOptions,
    ],
  );

  const preloadNrBaseCatalogs = useCallback(async () => {
    if (!selectedMailData?.id) return;

    try {
      setNrCatalogosLoading(true);

      // El año ya viene del vehículo seleccionado en Babilonia. Para el flujo
      // del asesor sólo necesitamos clasificación y estados antes de homologar.
      const [clasificaciones, estados] = await Promise.all([
        nrApiPostSafe(NR_ENDPOINTS.clasificaciones, {}, []),
        nrApiPostSafe(NR_ENDPOINTS.estados, {}, []),
      ]);

      setNrCatalogos((prev) => ({
        ...prev,
        clasificaciones: Array.isArray(clasificaciones)
          ? clasificaciones
          : [],
        estados: Array.isArray(estados) ? estados : [],
        anios: [],
      }));
    } finally {
      setNrCatalogosLoading(false);
    }
  }, [selectedMailData?.id, nrApiPostSafe]);

  useEffect(() => {
    const venta = selectedMailDataRef.current || selectedMailData || {};

    setNrLastError("");
    setNrCotizacion(null);
    setNrAnzenCotizacion(null);
    setNrAnzenError(null);
    setNrAnzenLoading(false);
    setNrLastCotizaRequest(null);
    setNrLastCotizaSignature("");
    setNrLastSavedSignature("");
    setNrCotizacionGuardadaId(
      String(venta?.procotiza_id_cotizacion || venta?.idCotizacionNR || ""),
    );
    setNrPdfBase64(venta?.procotiza_pdf_base64 || "");
    setShowNrPdfViewer(false);
    setNrSelectedProduct(null);
    setNrHomologacion(null);
    setNrProductCandidates([]);
    setShowNrProductModal(false);
    nrAnzenRequestKeyRef.current = "";

    if (selectedMailData?.id && agenciaUsaCotizadorNR) {
      preloadNrBaseCatalogs();
    }
  }, [selectedMailData?.id, preloadNrBaseCatalogs, agenciaUsaCotizadorNR]);

  const resolveNrHomologacion = useCallback(
    async ({ openProductModal = true } = {}) => {
      const { venta, marca, modelo, version, anio } =
        getNrVehicleContext();
      const formActual = formDataRef.current || formData || {};
      const agenciaId =
        Number(formActual.nr_agencia_id || NR_DEFAULT_AGENCIA_ID) ||
        NR_DEFAULT_AGENCIA_ID;
      const agenciaClave =
        String(formActual.nr_agencia_clave || NR_DEFAULT_AGENCIA_CLAVE).trim() ||
        NR_DEFAULT_AGENCIA_CLAVE;
      const tipoOperacionRaw = nrGetTipoOperacionFromEntrevista(
        formActual,
        venta,
      );
      const tipoOperacionId = Number(tipoOperacionRaw || 0);
      const personalidad = String(
        formActual.nr_personalidad_juridica || "",
      ).trim();

      if (!marca || !modelo || !anio) {
        throw new Error(
          "Selecciona un vehículo con marca, modelo y año antes de cotizar con NR.",
        );
      }

      if (!tipoOperacionId) {
        if (nrGetPagoContadoFromEntrevista(formActual, venta) === "Si") {
          throw new Error(
            "Procotiza NR está integrado al flujo de crédito; esta venta está marcada como contado.",
          );
        }

        throw new Error(
          "Primero define la forma de compra como crédito para preparar Procotiza NR.",
        );
      }

      if (!["1", "2"].includes(personalidad)) {
        throw new Error(
          "Selecciona la personalidad jurídica antes de preparar Procotiza NR.",
        );
      }

      const idPerJuridica = personalidad === "2" ? 15 : 14;

      const chooseCatalogItem = async ({
        items,
        currentId = "",
        idField = "id",
        labelField = "nombre",
        defaultField = "",
        title,
      }) => {
        const list = Array.isArray(items) ? items : [];

        const current = list.find(
          (item) => String(item?.[idField] ?? "") === String(currentId || ""),
        );
        if (current) return current;

        if (defaultField) {
          const officialDefault = nrGetOfficialDefaultItem(
            list,
            defaultField,
          );
          if (officialDefault) return officialDefault;
        }

        if (list.length === 1) return list[0];
        if (!list.length) return null;

        if (!openProductModal) return null;

        const options = {};
        list.forEach((item) => {
          const id = String(item?.[idField] ?? "");
          if (!id) return;
          options[id] =
            String(item?.[labelField] ?? "").trim() ||
            `ID ${id}`;
        });

        if (!Object.keys(options).length) return null;

        const result = await Swal.fire({
          icon: "question",
          title,
          input: "select",
          inputOptions: options,
          inputPlaceholder: "Seleccione una opción",
          showCancelButton: true,
          confirmButtonText: "Continuar",
          cancelButtonText: "Cancelar",
          inputValidator: (value) =>
            value ? undefined : "Selecciona una opción para continuar.",
        });

        if (!result.isConfirmed || !result.value) return null;

        return (
          list.find(
            (item) =>
              String(item?.[idField] ?? "") === String(result.value),
          ) || null
        );
      };

      setNrCatalogosLoading(true);
      setNrLastError("");

      try {
        // 1. Clasificación: se toma el ID real del catálogo NR.
        let clasificaciones = Array.isArray(nrCatalogos.clasificaciones)
          ? nrCatalogos.clasificaciones
          : [];

        if (!clasificaciones.length) {
          const clasificacionesRaw = await nrApiPost(
            NR_ENDPOINTS.clasificaciones,
            {},
          );
          clasificaciones = Array.isArray(clasificacionesRaw)
            ? clasificacionesRaw
            : [];
        }

        const clasificacion = getNrClasificacionFromVenta(
          venta,
          clasificaciones,
        );

        if (!clasificacion?.id) {
          throw new Error(
            "No se encontró la clasificación real de NR para el vehículo seleccionado.",
          );
        }

        const clasifId = Number(clasificacion.id);

        // 2. Marca: coincidencia únicamente contra el campo documentado nombre.
        const marcasRaw = await nrApiPost(NR_ENDPOINTS.marcas, {
          clasifId,
          agenciaId,
        });
        const marcas = Array.isArray(marcasRaw) ? marcasRaw : [];
        const marcaMatch = nrFindBestNamedMatch(marcas, marca, 8).best;

        if (!marcaMatch?.id) {
          throw new Error(
            `No se encontró una coincidencia de marca NR para “${marca}”.`,
          );
        }

        const marcaId = Number(marcaMatch.id);

        // 3. Modelo/submarca: coincidencia únicamente contra nombre.
        const modelosRaw = await nrApiPost(NR_ENDPOINTS.modelos, {
          marcaId,
          clasifId,
          agenciaId,
        });
        const modelos = Array.isArray(modelosRaw) ? modelosRaw : [];
        const modeloMatch = nrFindBestNamedMatch(modelos, modelo, 8).best;

        if (!modeloMatch?.id) {
          throw new Error(
            `No se encontró una coincidencia de modelo NR para “${modelo}”.`,
          );
        }

        const submarcaId = Number(modeloMatch.id);

        // 4. Año: se conserva el año real que ya trae Babilonia.
        const versionesRaw = await nrApiPost(NR_ENDPOINTS.versiones, {
          clasifId,
          marcaId,
          submarcaId,
          anio: Number(anio),
        });
        const versiones = Array.isArray(versionesRaw) ? versionesRaw : [];
        const versionTarget = String(version || modelo || "").trim();
        const versionMatch = nrFindBestNamedMatch(
          versiones,
          versionTarget,
          5,
        ).best;

        if (!versionMatch?.id) {
          throw new Error(
            `No se encontró una coincidencia de versión NR para “${version || modelo}” del año ${anio}.`,
          );
        }

        const versionId = Number(versionMatch.id);

        // 5. Estrategia: selección guardada > IsDefault oficial > opción única.
        const estrategiasRaw = await nrApiPost(
          NR_ENDPOINTS.estrategias,
          {
            clasifId,
            submarcaId,
            anio: Number(anio),
            versionId,
          },
        );
        const estrategias = Array.isArray(estrategiasRaw)
          ? estrategiasRaw
          : [];

        // Publicamos las estrategias en la UI inmediatamente. Antes se
        // guardaban hasta terminar toda la homologación y, si fallaban los
        // planes, el selector quedaba bloqueado.
        setNrCatalogos((prev) => ({
          ...prev,
          clasificaciones,
          marcas,
          modelos,
          versiones,
          estrategias,
        }));

        const estrategiaActual = estrategias.find(
          (item) =>
            String(item?.id ?? "") ===
            String(formActual.nr_estrategia_id || ""),
        );

        // Una sola estrategia puede autoseleccionarse. Si NR devuelve varias,
        // la selección debe hacerse desde el combo visible de Estrategia NR.
        const estrategiaMatch =
          estrategiaActual ||
          (estrategias.length === 1 ? estrategias[0] : null);

        if (!estrategiaMatch?.id) {
          if (estrategias.length > 1) {
            patchNrFormData({
              nr_marca_id: String(marcaId),
              nr_marca_nombre: String(marcaMatch.nombre || "").trim(),
              nr_modelo_id: String(submarcaId),
              nr_modelo_nombre: String(modeloMatch.nombre || "").trim(),
              nr_version_id: String(versionId),
              nr_version_nombre: String(versionMatch.nombre || "").trim(),
              nr_estrategia_id: "",
              nr_estrategia_nombre: "",
              nr_producto_id: "",
              nr_producto_descripcion: "",
              nr_producto_tipo_precio_id: "",
              nr_anzen_producto_id: "",
              nr_tipo_producto_id: "",
              nr_broker_id: "",
              nr_plan_id: "",
              nr_plan_nombre: "",
              nr_paquete_externo_id: "",
              nr_plazo: "",
              nr_estado_id: "",
              nr_estado_nombre: "",
              nr_municipio_id: "",
              nr_municipio_nombre: "",
            });

            setNrHomologacion(null);

            return {
              ok: false,
              needsStrategySelection: true,
              message:
                "Selecciona la estrategia NR para continuar con Producto y Plan / paquete.",
            };
          }

          throw new Error(
            "NR no regresó una estrategia válida para el vehículo seleccionado.",
          );
        }

        const estrategiaId = Number(estrategiaMatch.id);

        // 6. Producto: /catalogs/productos es la fuente principal y regresa
        // un ProductoDto. producto-filtrado sólo enriquece con idExterno/Anzen.
        const [productoRaw, productoFiltradoRaw] = await Promise.all([
          nrApiPostSafe(
            NR_ENDPOINTS.productos,
            {
              clasifId,
              marcaId,
              submarcaId,
              versionId,
              anioId: Number(anio),
              estrategiaId,
              agenciaId,
            },
            null,
          ),
          nrApiPostSafe(
            NR_ENDPOINTS.productoFiltrado,
            { idMarca: marcaId, destino: 1 },
            [],
          ),
        ]);

        const productoServicio =
          productoRaw &&
          !Array.isArray(productoRaw) &&
          typeof productoRaw === "object" &&
          Number(productoRaw.id || 0) > 0
            ? productoRaw
            : null;

        const productosFiltrados = Array.isArray(productoFiltradoRaw)
          ? productoFiltradoRaw
          : [];

        const filtradosCoincidentes = productosFiltrados.filter((item) => {
          const sameMarca = Number(item?.idMarca || 0) === marcaId;
          const sameModelo = Number(item?.idSubmarca || 0) === submarcaId;
          const sameVersion = Number(item?.idVersion || 0) === versionId;
          const sameYear =
            Number(item?.anioCatalogo || item?.anioModelo || 0) ===
            Number(anio);
          const sameClasificacion =
            !item?.idClasificacion ||
            Number(item.idClasificacion) === clasifId;
          const sameEstrategia =
            !item?.idEstrategia ||
            Number(item.idEstrategia) === estrategiaId;

          return (
            sameMarca &&
            sameModelo &&
            sameVersion &&
            sameYear &&
            sameClasificacion &&
            sameEstrategia
          );
        });

        let productoFiltrado = null;

        if (productoServicio) {
          productoFiltrado =
            filtradosCoincidentes.find(
              (item) =>
                Number(item?.idProducto || 0) ===
                Number(productoServicio.id),
            ) || null;
        } else {
          productoFiltrado = await chooseCatalogItem({
            items: filtradosCoincidentes,
            currentId: formActual.nr_producto_id,
            idField: "idProducto",
            labelField: "descripcion",
            defaultField: "regDefault",
            title: "Selecciona el producto NR",
          });
        }

        if (!productoServicio && !productoFiltrado) {
          if (filtradosCoincidentes.length > 1 && openProductModal) {
            setNrCatalogos((prev) => ({
              ...prev,
              clasificaciones,
              marcas,
              modelos,
              versiones,
              estrategias,
              productoFiltrado: productosFiltrados,
            }));
            setNrProductCandidates(filtradosCoincidentes);
            setShowNrProductModal(true);

            return {
              ok: false,
              needsProductSelection: true,
              message: "Selecciona el producto NR correcto para continuar.",
            };
          }

          throw new Error(
            "No se encontró un producto NR válido para esta combinación de vehículo.",
          );
        }

        const productoId = Number(
          productoServicio?.id ?? productoFiltrado?.idProducto ?? 0,
        );

        if (!productoId) {
          throw new Error("NR regresó un producto sin ID válido.");
        }

        // Normalizamos una sola vez las dos respuestas documentadas:
        // ProductoDto usa `id` y ProductoFiltradoDto usa `idProducto`.
        // A partir de aquí el flujo trabaja con una estructura canónica.
        const producto = {
          ...(productoFiltrado || {}),
          ...(productoServicio || {}),
          id: productoId,
          idExterno: String(productoFiltrado?.idExterno ?? "").trim(),
          idTipoProducto:
            productoServicio?.idTipoProducto ??
            productoFiltrado?.idTipoProducto ??
            null,
          idBroker:
            productoServicio?.idBroker ??
            productoFiltrado?.idBroker ??
            null,
          tipoCxa:
            productoServicio?.tipoCxa ??
            productoFiltrado?.tipoCxa ??
            null,
          moneda:
            productoServicio?.moneda ??
            productoFiltrado?.moneda ??
            null,
        };

        const anzenProductoId = String(producto.idExterno || "").trim();
        const tipoProductoId = String(
          producto.idTipoProducto ?? "",
        ).trim();
        const brokerId = String(producto.idBroker ?? "").trim();

        // BUG corregido: este patch se ejecuta CADA VEZ que resolveNrHomologacion
        // corre — incluyendo cuando handleNrPlanChange lo llama justo después
        // de que el asesor elige manualmente un Plan/paquete NR del combo. Antes
        // se reseteaba nr_plan_id (y estado/municipio) sin condición alguna, así
        // que la selección que el asesor acababa de hacer se borraba de
        // inmediato, y currentPlanId (abajo) siempre leía "" — por eso "lo
        // selecciono y regresa como si no hubiera seleccionado nada". Ahora solo
        // se resetea lo de aguas abajo si el producto (marca/modelo/versión/
        // estrategia/producto) realmente cambió respecto a lo que ya había.
        const productoIdPrevio = String(formActual.nr_producto_id || "");
        const productoIdCambio = productoIdPrevio !== String(productoId);

        setNrCatalogos((prev) => ({
          ...prev,
          clasificaciones,
          marcas,
          modelos,
          versiones,
          estrategias,
          productos: producto ? [producto] : [],
          productoFiltrado: productosFiltrados,
        }));

        patchNrFormData({
          nr_marca_id: String(marcaId),
          nr_marca_nombre: String(marcaMatch.nombre || "").trim(),
          nr_modelo_id: String(submarcaId),
          nr_modelo_nombre: String(modeloMatch.nombre || "").trim(),
          nr_version_id: String(versionId),
          nr_version_nombre: String(versionMatch.nombre || "").trim(),
          nr_estrategia_id: String(estrategiaId),
          nr_estrategia_nombre: String(estrategiaMatch.nombre || "").trim(),
          nr_producto_id: String(productoId),
          nr_producto_descripcion: String(
            producto.descripcion ||
              productoFiltrado?.descripcion ||
              "",
          ).trim(),
          nr_producto_tipo_precio_id: String(producto.tipoCxa ?? ""),
          nr_anzen_producto_id: anzenProductoId,
          nr_tipo_producto_id: tipoProductoId,
          nr_broker_id: brokerId,
          ...(productoIdCambio
            ? {
                nr_plan_id: "",
                nr_plan_nombre: "",
                nr_paquete_externo_id: "",
                nr_plazo: "",
                nr_estado_id: "",
                nr_estado_nombre: "",
                nr_municipio_id: "",
                nr_municipio_nombre: "",
              }
            : {}),
        });

        // 7. Plan/paquete: el paquete enriquecido es la fuente de los datos
        // financieros; regDefault es el único default oficial.
        const [planesRaw, paquetesRaw] = await Promise.all([
          nrApiPostSafe(
            NR_ENDPOINTS.planes,
            {
              clasifId,
              agenciaId,
              estrategiaId,
              tipoOperacionId,
            },
            [],
          ),
          nrApiPostSafe(
            NR_ENDPOINTS.paquetes,
            { idMarca: marcaId, destino: 1 },
            [],
          ),
        ]);

        const planesNr = Array.isArray(planesRaw) ? planesRaw : [];
        const paquetesNrBase = Array.isArray(paquetesRaw) ? paquetesRaw : [];

        // BUG corregido: /catalogs/planes viene vacío de forma consistente en
        // este ambiente (planes=0/0 siempre), y el idEstrategia que trae cada
        // paquete de /catalogs/paquetes pertenece a la configuración CEBIP del
        // paquete — no es el mismo id que /catalogs/estrategias (que se
        // consulta con marca/submarca/año/versión, no con el paquete). Exigir
        // que ambos coincidieran dejaba SIEMPRE la lista en 0, aunque sí
        // hubiera paquetes válidos para la marca/clasificación/operación. La
        // fuente real de "Plan / paquete NR" es /catalogs/paquetes filtrado
        // sólo por clasificación, tipo de operación y personalidad jurídica.
        const paquetesNr = paquetesNrBase.filter((item) => {
          const paqueteId = Number(item?.idPaquete || 0);
          if (!paqueteId) return false;
          // BUG corregido: la doc de Procotiza dice "estatus: 1=activo" para
          // el paquete, pero en la práctica NR regresa estatus=2 para
          // paquetes activos (igual que el estatus de cada plazo, que
          // también usa 2=activo). Exigir === 1 rechazaba TODOS los paquetes
          // reales. Solo se descartan estatus vacíos/0/negativos.
          if (!(Number(item?.estatus || 0) > 0)) return false;
          if (
            item?.idClasificacionProd != null &&
            Number(item.idClasificacionProd) !== clasifId
          ) {
            return false;
          }
          if (
            item?.idTipoOperacion != null &&
            Number(item.idTipoOperacion) !== tipoOperacionId
          ) {
            return false;
          }

          const perJuridica = Number(item?.idPerJuridica || 0);
          if (
            perJuridica &&
            ![Number(personalidad), idPerJuridica].includes(perJuridica)
          ) {
            return false;
          }

          return true;
        });

        // Publicamos Plan/Paquete antes de validar la selección. Esto permite
        // escogerlo manualmente y evita que un resultado vacío deje el combo
        // bloqueado.
        setNrCatalogos((prev) => ({
          ...prev,
          clasificaciones,
          marcas,
          modelos,
          versiones,
          estrategias,
          productos: producto ? [producto] : [],
          productoFiltrado: productosFiltrados,
          planes: planesNr,
          paquetes: paquetesNr,
        }));

        const currentPlanId = String(
          (formDataRef.current || formActual).nr_plan_id || "",
        );

        let paqueteMatch =
          paquetesNr.find(
            (item) => String(item?.idPaquete ?? "") === currentPlanId,
          ) || null;

        let planSimple =
          planesNr.find(
            (item) => String(item?.id ?? "") === currentPlanId,
          ) || null;

        if (!paqueteMatch && !planSimple) {
          if (paquetesNr.length === 1) {
            paqueteMatch = paquetesNr[0];
          } else if (!paquetesNr.length && planesNr.length === 1) {
            planSimple = planesNr[0];
          } else if (paquetesNr.length > 1 || planesNr.length > 1) {
            patchNrFormData({
              nr_plan_id: "",
              nr_plan_nombre: "",
              nr_paquete_externo_id: "",
              nr_plazo: "",
              nr_estado_id: "",
              nr_estado_nombre: "",
              nr_municipio_id: "",
              nr_municipio_nombre: "",
            });

            setNrHomologacion(null);

            return {
              ok: false,
              needsPlanSelection: true,
              message:
                "Selecciona el Plan / paquete NR para continuar con Estado y Municipio.",
            };
          }
        }

        if (!paqueteMatch && planSimple?.id) {
          const detailRaw = await nrApiPostSafe(
            NR_ENDPOINTS.planDetalle,
            { id: Number(planSimple.id) },
            null,
          );

          paqueteMatch =
            detailRaw &&
            typeof detailRaw === "object" &&
            !Array.isArray(detailRaw)
              ? {
                  ...detailRaw,
                  idPaquete: Number(detailRaw.id || planSimple.id),
                  nombre: detailRaw.nombre || planSimple.nombre,
                }
              : {
                  ...planSimple,
                  idPaquete: Number(planSimple.id),
                };
        }

        if (!paqueteMatch) {
          const detalle =
            `(clasifId=${clasifId}, agenciaId=${agenciaId}, ` +
            `estrategiaId=${estrategiaId}, tipoOperacionId=${tipoOperacionId}, ` +
            `personalidad=${personalidad}, marcaId=${marcaId}, ` +
            `productoId=${productoId}, ` +
            `planes=${planesNr.length}/${Array.isArray(planesRaw) ? planesRaw.length : 0}, ` +
            `paquetes=${paquetesNr.length}/${paquetesNrBase.length})`;

          throw new Error(
            "NR no regresó planes/paquetes para la estrategia seleccionada. " +
              "Selecciona otra Estrategia NR y vuelve a intentar. " +
              detalle,
          );
        }

        const paqueteId = nrGetPackageId(paqueteMatch);
        if (!paqueteId) {
          throw new Error("El paquete NR seleccionado no tiene un ID válido.");
        }

        const planDetalleRaw = await nrApiPostSafe(
          NR_ENDPOINTS.planDetalle,
          { id: paqueteId },
          null,
        );
        const planDetalle =
          planDetalleRaw &&
          typeof planDetalleRaw === "object" &&
          !Array.isArray(planDetalleRaw)
            ? planDetalleRaw
            : {};

        const paquete = {
          ...planDetalle,
          ...paqueteMatch,
          idPaquete: paqueteId,
        };
        const paqueteExternoId = nrGetPackageExternalId(paqueteMatch);

        // 8. Datos dependientes del paquete.
        const [plazosRaw, subsidiosRaw, tiposSeguroRaw, segurosVidaRaw] =
          await Promise.all([
            nrApiPostSafe(
              NR_ENDPOINTS.plazos,
              { paqueteId, productoId },
              [],
            ),
            nrApiPostSafe(NR_ENDPOINTS.subsidios, { paqueteId }, []),
            nrApiPostSafe(NR_ENDPOINTS.tiposSeguro, { paqueteId }, []),
            nrApiPostSafe(
              NR_ENDPOINTS.segurosVida,
              {
                paqueteId,
                perJuridId: Number(personalidad),
              },
              [],
            ),
          ]);

        const plazos = Array.isArray(plazosRaw) ? plazosRaw : [];
        const subsidios = Array.isArray(subsidiosRaw) ? subsidiosRaw : [];
        const tiposSeguro = Array.isArray(tiposSeguroRaw)
          ? tiposSeguroRaw
          : [];
        const segurosVida = Array.isArray(segurosVidaRaw)
          ? segurosVidaRaw
          : [];

        const mesesBabilonia =
          Number(
            String(
              modalFinancingMonthsRef.current ||
                formActual.meses_financiamiento ||
                formActual.plazo_meses ||
                financingMonths ||
                "",
            ).replace(/\D/g, ""),
          ) || 0;

        const plazoPorBabilonia = plazos.find(
          (item) => Number(item?.valor || 0) === mesesBabilonia,
        );
        const plazoPersistido = plazos.find(
          (item) =>
            Number(item?.valor || 0) === Number(formActual.nr_plazo || 0),
        );
        const plazoItem =
          plazoPorBabilonia ||
          plazoPersistido ||
          (plazos.length === 1 ? plazos[0] : null);
        const plazoNr = Number(plazoItem?.valor || 0);

        if (!plazoNr) {
          throw new Error(
            mesesBabilonia
              ? `El plazo de ${mesesBabilonia} meses de Babilonia no está disponible en NR.`
              : "Selecciona un plazo de financiamiento válido antes de cotizar con NR.",
          );
        }

        const tipoSeguroActual = tiposSeguro.find(
          (item) =>
            String(item?.id ?? "") ===
            String(formActual.nr_tipo_seguro_id || ""),
        );
        const tipoSeguro =
          tipoSeguroActual ||
          (tiposSeguro.length === 1 ? tiposSeguro[0] : null);

        const seguroVidaActual = segurosVida.find(
          (item) =>
            String(item?.id ?? "") ===
            String(formActual.nr_seguro_vida_id || ""),
        );
        const seguroVida =
          seguroVidaActual ||
          nrGetOfficialDefaultItem(segurosVida, "isDefault") ||
          (segurosVida.length === 1 ? segurosVida[0] : null);

        const moneda =
          paquete?.idMoneda ??
          producto?.moneda ??
          "";
        const tipoCxa =
          producto?.tipoCxa ??
          productoFiltrado?.tipoCxa ??
          "";
        const tipoProductoReal =
          paquete?.idTipoProducto ??
          tipoProductoId ??
          "";

        const homologacion = {
          clasifId,
          clasificacion,
          agenciaId,
          agenciaClave,
          marca: marcaMatch,
          modelo: modeloMatch,
          version: versionMatch,
          estrategia: estrategiaMatch,
          producto,
          productoFiltrado,
          plan: planesNr.find((item) => Number(item?.id || 0) === paqueteId) || null,
          paquete,
          paqueteId,
          paqueteExternoId,
          productoId,
          anzenProductoId,
          marcaId,
          submarcaId,
          versionId,
          anio: Number(anio),
          tipoOperacionId,
          personalidadJuridica: personalidad,
          idPerJuridica,
          plazo: plazoNr,
          moneda: moneda === "" ? "" : Number(moneda),
          tipoCxa: tipoCxa === "" ? "" : Number(tipoCxa),
          tipoProductoId: String(tipoProductoReal || ""),
          brokerId,
        };

        setNrCatalogos((prev) => ({
          ...prev,
          clasificaciones,
          marcas,
          modelos,
          versiones,
          estrategias,
          productos: producto ? [producto] : [],
          productoFiltrado: productosFiltrados,
          planes: planesNr,
          // La UI sólo debe ofrecer paquetes compatibles con estrategia,
          // operación, clasificación y personalidad actuales.
          paquetes: paquetesNr,
          plazos,
          subsidios,
          tiposSeguro,
          segurosVida,
        }));

        setNrHomologacion(homologacion);
        setNrSelectedProduct(producto);

        patchNrFormData({
          nr_marca_id: String(marcaId),
          nr_marca_nombre: String(marcaMatch.nombre || "").trim(),
          nr_modelo_id: String(submarcaId),
          nr_modelo_nombre: String(modeloMatch.nombre || "").trim(),
          nr_version_id: String(versionId),
          nr_version_nombre: String(versionMatch.nombre || "").trim(),
          nr_estrategia_id: String(estrategiaId),
          nr_estrategia_nombre: String(
            estrategiaMatch.nombre || "",
          ).trim(),
          nr_producto_id: String(productoId),
          nr_producto_descripcion: String(
            producto.descripcion ||
              productoFiltrado?.descripcion ||
              "",
          ).trim(),
          // En el flujo UAT validado, guardar.tipoDePrecio se alimenta del
          // valor real tipoCxa regresado por ProductoDto.
          nr_producto_tipo_precio_id: String(
            producto?.tipoCxa ?? productoFiltrado?.tipoCxa ?? "",
          ),
          nr_anzen_producto_id: anzenProductoId,
          nr_tipo_producto_id: String(tipoProductoReal || ""),
          nr_broker_id: brokerId,
          nr_plan_id: String(paqueteId),
          nr_plan_nombre: String(paquete.nombre || "").trim(),
          nr_paquete_externo_id: paqueteExternoId,
          nr_plazo: String(plazoNr),
          nr_tipo_seguro_id: tipoSeguro
            ? String(tipoSeguro.id)
            : "",
          nr_tipo_seguro_nombre: tipoSeguro
            ? String(tipoSeguro.nombre || "").trim()
            : "",
          nr_seguro_vida_id: seguroVida
            ? String(seguroVida.id)
            : "",
          nr_agencia_id: String(agenciaId),
          nr_agencia_clave: agenciaClave,
          nr_tipo_operacion: String(tipoOperacionId),
        });

        return { ok: true, homologacion };
      } finally {
        setNrCatalogosLoading(false);
      }
    },
    [
      financingMonths,
      // OJO: formData NO va aquí a propósito. La función ya lee el valor
      // más reciente con formDataRef.current (línea de arriba), así que
      // incluir formData en las dependencias solo provoca que esta función
      // se regenere en CADA cambio del formulario completo (no solo los
      // campos NR), lo que a su vez dispara de nuevo cualquier efecto que
      // dependa de ella. Esto era la causa del bucle al seleccionar
      // estado/municipio.
      getNrClasificacionFromVenta,
      getNrVehicleContext,
      nrApiPost,
      nrApiPostSafe,
      nrCatalogos.clasificaciones,
      patchNrFormData,
    ],
  );

  const cargarCatalogosAnzenNR = useCallback(
    async (homologacionParam = nrHomologacion) => {
      const homologacionActual = homologacionParam || nrHomologacion;
      const formActual = formDataRef.current || formData || {};
      const stateId = Number(formActual.nr_estado_id || 0);
      const personalidad = String(
        formActual.nr_personalidad_juridica || "",
      ).trim();
      const operationId = nrGetAnzenOperationId(
        homologacionActual?.tipoOperacionId ||
          nrGetTipoOperacionFromEntrevista(
            formActual,
            selectedMailDataRef.current || {},
          ),
      );
      const fiscalPersonalityId =
        personalidad === "1"
          ? "PF001"
          : personalidad === "2"
            ? "PM001"
            : "";
      const anzenId = String(formActual.nr_anzen_id || NR_CONFIG_ANZEN_ID).trim();
      // BUG corregido: GetCatalogsAnzen (a diferencia de consultar-seguros-anzen
      // / GetQuotes) funciona con el id INTERNO del paquete como PlanId, no
      // con paqueteExternoId (idExterno). paqueteExternoId no siempre está
      // resuelto de forma confiable (ver nota en buildNrAnzenQuotePayload /
      // consultarSegurosAnzen), así que usarlo aquí dejaba planId vacío y
      // cargarCatalogosAnzenNR tiraba el error "Falta: Id externo del
      // paquete" antes de siquiera llamar al endpoint — por eso nunca
      // cargaban los municipios.
      const planId = String(
        homologacionActual?.paqueteId ||
          formActual.nr_plan_id ||
          "",
      ).trim();

      if (!homologacionActual?.marcaId || !stateId) {
        return null;
      }

      const missing = [
        ["operación Anzen", operationId],
        ["personalidad fiscal", fiscalPersonalityId],
        ["AnzenId", anzenId],
        ["Id del paquete", planId],
      ]
        .filter(([, value]) => !String(value || "").trim())
        .map(([label]) => label);

      if (missing.length) {
        throw new Error(
          `No se pueden consultar municipios/seguros Anzen. Falta: ${missing.join(", ")}.`,
        );
      }

      // Orden correcto:
      // 1) Estado desde /catalogs/estados.
      // 2) GetCatalogsAnzen con el StateId seleccionado.
      // 3) Municipios y catálogos de seguro salen de esa respuesta.
      const payload = {
        BrandId: Number(homologacionActual.marcaId),
        OperationId: operationId,
        FiscalPersonalityId: fiscalPersonalityId,
        AnzenId: anzenId,
        PlanId: planId,
        StateId: stateId,
      };

      const requestKey = JSON.stringify(payload);
      // OJO: antes este candado también exigía nrMunicipiosOptions.length,
      // pero si Anzen respondía sin municipios (Municipalities vacío o con
      // otro nombre) esa condición nunca se cumplía. Al no "cachear" ese
      // caso, cada re-render disparaba un nuevo fetch, lo que generaba un
      // objeto nuevo en nrCatalogos.anzen, recreaba esta función (por su
      // dependencia de nrCatalogosAnzen) y volvía a disparar el efecto que
      // la llama: un bucle infinito de carga. Con solo comparar requestKey
      // (que ya se marca antes de hacer el fetch, ver abajo) basta para
      // frenar reintentos redundantes, tenga o no municipios la respuesta.
      if (nrAnzenRequestKeyRef.current === requestKey) {
        return nrCatalogosAnzenRef.current;
      }

      nrAnzenRequestKeyRef.current = requestKey;
      setNrCatalogosLoading(true);

      try {
        const anzenRaw = await nrApiPost(NR_ENDPOINTS.anzenCatalogs, payload);
        const anzenValue =
          anzenRaw &&
          typeof anzenRaw === "object" &&
          !Array.isArray(anzenRaw)
            ? anzenRaw
            : {};

        const acceso = String(anzenValue.Accesso ?? "").toLowerCase();
        const valido = String(anzenValue.Valido ?? "").toLowerCase();

        if (
          (acceso && acceso !== "true" && acceso !== "1") ||
          (valido && valido !== "true" && valido !== "1")
        ) {
          throw new Error(
            "Anzen respondió sin acceso o sin datos válidos para la combinación seleccionada.",
          );
        }

        const municipios = Array.isArray(anzenValue.Municipalities)
          ? anzenValue.Municipalities
          : [];
        const aseguradoras = Array.isArray(anzenValue.Insurances)
          ? anzenValue.Insurances
          : [];
        const coberturas = Array.isArray(anzenValue.TypeOfCoverages)
          ? anzenValue.TypeOfCoverages
          : [];
        const usos = Array.isArray(anzenValue.TypeOfUses)
          ? anzenValue.TypeOfUses
          : [];
        const udis = Array.isArray(anzenValue.UdiLevels)
          ? anzenValue.UdiLevels
          : [];

        nrCatalogosAnzenRef.current = anzenValue;
        setNrCatalogos((prev) => ({
          ...prev,
          anzen: anzenValue,
        }));

        const currentMunicipio = municipios.find(
          (item) =>
            String(item?.MunicipalityId ?? "") ===
            String(formActual.nr_municipio_id || ""),
        );
        const currentAseguradora = aseguradoras.find(
          (item) =>
            String(item?.InsuranceId ?? "") ===
            String(formActual.nr_aseguradora_id || ""),
        );
        const currentCobertura = coberturas.find(
          (item) =>
            String(item?.TypeOfCoverageId ?? "") ===
            String(formActual.nr_cobertura_id || ""),
        );
        const currentUso = usos.find(
          (item) =>
            String(item?.TypeOfUsesId ?? "") ===
            String(formActual.nr_uso_id || ""),
        );
        const currentUdi = udis.find(
          (item) =>
            String(item?.UdiLevelId ?? "") ===
            String(formActual.nr_udi_id || ""),
        );

        // GetCatalogsAnzen no documenta un marcador IsDefault. Por eso sólo
        // conservamos una selección válida o usamos la opción cuando es única.
        const municipioSeleccion =
          currentMunicipio ||
          (municipios.length === 1 ? municipios[0] : null);
        const aseguradoraSeleccion =
          currentAseguradora ||
          (aseguradoras.length === 1 ? aseguradoras[0] : null);
        const coberturaSeleccion =
          currentCobertura ||
          (coberturas.length === 1 ? coberturas[0] : null);
        const usoSeleccion =
          currentUso ||
          (usos.length === 1 ? usos[0] : null);
        const udiSeleccion =
          currentUdi ||
          (udis.length === 1 ? udis[0] : null);

        patchNrFormData({
          nr_municipio_id: municipioSeleccion
            ? String(municipioSeleccion.MunicipalityId)
            : "",
          nr_municipio_nombre: municipioSeleccion
            ? String(municipioSeleccion.Description || "").trim()
            : "",
          nr_aseguradora_id: aseguradoraSeleccion
            ? String(aseguradoraSeleccion.InsuranceId)
            : "",
          nr_aseguradora_nombre: aseguradoraSeleccion
            ? String(aseguradoraSeleccion.Description || "").trim()
            : "",
          nr_cobertura_id: coberturaSeleccion
            ? String(coberturaSeleccion.TypeOfCoverageId)
            : "",
          nr_cobertura_nombre: coberturaSeleccion
            ? String(coberturaSeleccion.Description || "").trim()
            : "",
          nr_uso_id: usoSeleccion
            ? String(usoSeleccion.TypeOfUsesId)
            : "",
          nr_uso_nombre: usoSeleccion
            ? String(usoSeleccion.Description || "").trim()
            : "",
          nr_udi_id: udiSeleccion
            ? String(udiSeleccion.UdiLevelId)
            : "",
          nr_udi_nombre: udiSeleccion
            ? String(udiSeleccion.Description || "").trim()
            : "",
        });

        return anzenValue;
      } catch (error) {
        nrAnzenRequestKeyRef.current = "";
        nrCatalogosAnzenRef.current = {};
        setNrCatalogos((prev) => ({ ...prev, anzen: {} }));
        setNrLastError(
          error?.message ||
            "No fue posible cargar municipios y catálogos de seguro NR.",
        );
        throw error;
      } finally {
        setNrCatalogosLoading(false);
      }
    },
    [
      // Mismo caso que en resolveNrHomologacion: se lee formDataRef.current
      // adentro, no hace falta (ni conviene) formData aquí.
      // OJO: nrCatalogosAnzen (el objeto memoizado) YA NO va aquí a
      // propósito. setNrCatalogos genera una referencia nueva en cada
      // fetch exitoso, así que incluirlo recreaba esta función cada vez,
      // lo que a su vez volvía a disparar el useEffect que la llama y
      // causaba el bucle al seleccionar estado/municipio. El valor
      // cacheado ahora se lee de nrCatalogosAnzenRef.current.
      nrApiPost,
      nrHomologacion,
      patchNrFormData,
    ],
  );

  useEffect(() => {
    if (
      !agenciaUsaCotizadorNR ||
      !selectedMailData?.id ||
      !formData.nr_estado_id ||
      !formData.nr_estrategia_id ||
      !formData.nr_producto_id ||
      !formData.nr_plan_id
    ) {
      return undefined;
    }

    const timer = setTimeout(async () => {
      try {
        const personalidadActual = String(
          (formDataRef.current || formData || {})
            .nr_personalidad_juridica || "",
        );
        let homologacionActual = nrHomologacion;

        // Sólo se vuelve a homologar cuando todavía no existe una
        // homologación o cambió la personalidad jurídica, porque el
        // catálogo de seguro de vida depende de ese dato.
        if (
          !homologacionActual?.paqueteId ||
          String(homologacionActual.personalidadJuridica || "") !==
            personalidadActual
        ) {
          const prep = await resolveNrHomologacion({
            openProductModal: false,
          });

          if (!prep?.ok) return;

          homologacionActual = prep.homologacion;
        }

        await cargarCatalogosAnzenNR(homologacionActual);
      } catch (error) {
        console.warn(
          "No se pudieron cargar municipios/catálogos Anzen NR:",
          error,
        );
      }
    }, 320);

    return () => clearTimeout(timer);
  }, [
    agenciaUsaCotizadorNR,
    selectedMailData?.id,
    formData.nr_estado_id,
    formData.nr_personalidad_juridica,
    formData.nr_estrategia_id,
    formData.nr_producto_id,
    formData.nr_plan_id,
    resolveNrHomologacion,
    cargarCatalogosAnzenNR,
  ]);

  const getNrAccesoriosResumen = useCallback(() => {
    const plan = selectedPlanForFinancing || selectedPlan || {};
    const accesorios = Array.isArray(plan?.accessories) ? plan.accessories : [];
    const adicionalesContadoTotal = adicionalesContado.reduce(
      (sum, item) => sum + toNumber(item?.price || item?.precio || 0),
      0,
    );

    // Placas: si el asesor las incluyó, siempre se pagan de contado (nunca
    // se financian), así que se suman al total de accesorios de contado que
    // se manda a NR (MontoAccesoriosContado en /quotations/cotiza). Antes
    // montoPlacas solo se guardaba en el snapshot interno (monto_placas) y
    // nunca llegaba al payload de Procotiza.
    const montoPlacasNr =
      incluyePlacas === "Si" ? toNumber(montoPlacas) || 0 : 0;

    const garantiaFinanciada = accesorios.reduce((sum, acc) => {
      const title = normalizarTexto(acc?.title || acc?.titulo || acc?.description || "");
      const isGarantia =
        title.includes("garantia") ||
        title.includes("garantia extendida") ||
        title.includes("gex");

      if (!isGarantia) return sum;

      const qty = toNumber(acc?.qty ?? 1) || 1;
      return sum + getUnitPrice(acc) * qty;
    }, 0);

    const accesoriosTotal = getPlanAccessoriesTotalForFinancing(plan);
    const accesoriosFinanciados = Math.max(accesoriosTotal - garantiaFinanciada, 0);

    return {
      accesorios,
      accesoriosFinanciados: Math.round(accesoriosFinanciados),
      accesoriosContado: Math.round(adicionalesContadoTotal + montoPlacasNr),
      garantiaExtendida: Math.round(garantiaFinanciada),
      totalPaquete: Math.round(accesoriosTotal),
    };
  }, [
    selectedPlanForFinancing,
    selectedPlan,
    adicionalesContado,
    incluyePlacas,
    montoPlacas,
  ]);

  const getNrCurrentFinancialValues = useCallback(() => {
    const formActual = formDataRef.current || formData || {};
    const venta = selectedMailDataRef.current || selectedMailData || {};
    const precio = toNumber(
      venta?.precio_vehiculo || precioVehiculo || venta?.precio_total || 0,
    );
    const engancheCapturado = toNumber(
      modalEngancheInput ||
        engancheC ||
        formActual.engancheEditable ||
        formActual.enganche ||
        0,
    );
    const enganche =
      formActual.pago_contado === "Si" ? precio : engancheCapturado;
    const porcentajeEnganche =
      precio > 0 ? Math.round((enganche / precio) * 10000) / 100 : 0;
    const plazoBabilonia =
      Number(
        String(
          modalFinancingMonthsRef.current ||
            formActual.meses_financiamiento ||
            formActual.plazo_meses ||
            financingMonths ||
            "",
        ).replace(/\D/g, ""),
      ) || 0;

    const plazos = Array.isArray(nrCatalogos.plazos)
      ? nrCatalogos.plazos
      : [];
    const plazoBabiloniaValido = plazos.find(
      (item) => Number(item?.valor || 0) === plazoBabilonia,
    );
    const plazoPersistidoValor = Number(formActual.nr_plazo || 0);
    const plazoPersistido = plazos.find(
      (item) =>
        Number(item?.valor || 0) === plazoPersistidoValor,
    );
    const plazo =
      Number(
        plazoBabiloniaValido?.valor ??
          plazoPersistido?.valor ??
          plazoPersistidoValor ??
          0,
      ) || 0;

    return {
      precio,
      enganche,
      porcentajeEnganche,
      plazo,
      tipoCompraSeguro: String(tipoCompraSeguro || "").trim(),
    };
  }, [
    engancheC,
    financingMonths,
    // OJO: formData/selectedMailData NO van aquí a propósito (mismo criterio
    // que patchNrFormData/getNrClasificacionFromVenta). El cuerpo ya lee
    // formDataRef.current/selectedMailDataRef.current como fuente real;
    // dejarlos en las dependencias hacía que esta función se regenerara en
    // cada ciclo del polling de 4s, lo que en cascada regeneraba
    // buildNrAnzenQuotePayload y handleConsultarSegurosAnzenNR, disparando
    // la consulta a Anzen sin parar y reseteando "Monto del seguro" a 0
    // cada vez que fallaba (el bug reportado de "se me bota a 0").
    modalEngancheInput,
    nrCatalogos.plazos,
    precioVehiculo,
    tipoCompraSeguro,
  ]);

  // Tasa oficial obtenida exclusivamente desde el paquete NR y el plazo.
  // No usa constantes, valores visuales ni una tasa de respaldo.
  const nrTasaPaqueteReal = useMemo(() => {
    const plazoMeses =
      Number(formData.nr_plazo || 0) ||
      Number(String(formData.meses_financiamiento || "").replace(/\D/g, "")) ||
      Number(String(formData.plazo_meses || "").replace(/\D/g, "")) ||
      0;

    return nrResolvePackageRate({
      paquetes: nrCatalogos.paquetes,
      catalogoPlazos: nrCatalogos.plazos,
      paqueteId: formData.nr_plan_id,
      plazoMeses,
    });
  }, [
    nrCatalogos.paquetes,
    nrCatalogos.plazos,
    formData.nr_plan_id,
    formData.nr_plazo,
    formData.meses_financiamiento,
    formData.plazo_meses,
  ]);

  const buildNrCurrentCalculationSignature = useCallback(
    (homologacionParam = nrHomologacion) => {
      const homologacionActual = homologacionParam || nrHomologacion || {};
      const financial = getNrCurrentFinancialValues();
      const accesorios = getNrAccesoriosResumen();
      const formActual = formDataRef.current || formData || {};

      return JSON.stringify({
      ventaId:
        selectedMailDataRef.current?.id ||
        selectedMailData?.id ||
        formActual.venta_id ||
        "",
      clasificacionId: homologacionActual?.clasifId || "",
      marcaId: homologacionActual?.marcaId || formActual.nr_marca_id || "",
      modeloId: homologacionActual?.submarcaId || formActual.nr_modelo_id || "",
      versionId: homologacionActual?.versionId || formActual.nr_version_id || "",
      productoId: homologacionActual?.productoId || formActual.nr_producto_id || "",
      paqueteId: homologacionActual?.paqueteId || formActual.nr_plan_id || "",
      precio: financial.precio,
      enganche: financial.enganche,
      plazo: financial.plazo,
      personalidad: formActual.nr_personalidad_juridica || "",
      estado: formActual.nr_estado_id || "",
      municipio: formActual.nr_municipio_id || "",
      tipoSeguro: formActual.nr_tipo_seguro_id || "",
      seguroVida:
        formActual.nr_seguro_vida_id || "",
      aseguradora: formActual.nr_aseguradora_id || "",
      cobertura: formActual.nr_cobertura_id || "",
      uso: formActual.nr_uso_id || "",
      udi: formActual.nr_udi_id || "",
      tipoCompraSeguro: financial.tipoCompraSeguro || "",
      seguroAnzen: formActual.nr_seguro_anzen_key || "",
      montoSeguro: toNumber(montoSeguro || 0),
      accesoriosFinanciados: accesorios.accesoriosFinanciados,
      accesoriosContado: accesorios.accesoriosContado,
      garantiaExtendida: accesorios.garantiaExtendida,
      });
    },
    [
      formData,
      getNrAccesoriosResumen,
      getNrCurrentFinancialValues,
      montoSeguro,
      nrHomologacion,
      selectedMailData?.id,
    ],
  );

  const nrCurrentCalculationSignature = useMemo(
    () => buildNrCurrentCalculationSignature(),
    [buildNrCurrentCalculationSignature],
  );

  const isNrCurrentQuoteSaved = Boolean(
    nrCotizacionGuardadaId &&
      nrLastSavedSignature &&
      nrLastSavedSignature === nrCurrentCalculationSignature,
  );

  const nrFinancialValues = useMemo(
    () => getNrCurrentFinancialValues(),
    [getNrCurrentFinancialValues],
  );

  const nrHasDownPaymentMismatch = Boolean(
    nrCotizacion &&
      nrEngancheReportado > 0 &&
      Math.abs(
        nrEngancheReportado - toNumber(nrFinancialValues.enganche),
      ) > 0.01,
  );

  useEffect(() => {
    const persistedId = String(formData.nr_cotizacion_id || "").trim();

    if (persistedId && !nrCotizacionGuardadaId) {
      setNrCotizacionGuardadaId(persistedId);
    }
  }, [formData.nr_cotizacion_id, nrCotizacionGuardadaId]);

  useEffect(() => {
    if (
      nrLastCotizaSignature &&
      nrLastCotizaSignature !== nrCurrentCalculationSignature
    ) {
      setNrCotizacion(null);
      setNrPdfBase64("");
      setShowNrPdfViewer(false);
    }
  }, [nrCurrentCalculationSignature, nrLastCotizaSignature]);

  const applyNrInsuranceOption = useCallback(
    (option, responseValue = nrAnzenCotizacion) => {
      const response = nrGetAnzenResponseObject(responseValue);

      // OJO: esta función SOLO debe tocar los campos nr_seguro_anzen_* de
      // formData (el "monto de Anzen"). NO debe tocar montoSeguro/
      // montoSeguroDisplay — ese es el campo manual de Babilonia
      // (tipoCompraSeguro/montoSeguro), independiente de NR, que el asesor
      // captura a mano y que las agencias sin NR también usan. Antes se
      // sincronizaban ambos en la misma variable, así que en cuanto Anzen
      // terminaba de responder (éxito o fallo) pisaba lo que el asesor
      // hubiera escrito a mano. El payload real hacia NR ya prioriza
      // nr_seguro_anzen_total_amount sobre montoSeguro (ver
      // selectedTotalAmount en buildNrCotizaPayload/
      // buildNrGuardarCotizacionPayload), así que separarlos no rompe nada.
      if (!option) {
        patchNrFormData({
          nr_seguro_anzen_key: "",
          nr_seguro_anzen_id: "",
          nr_seguro_anzen_campania_id: "",
          nr_seguro_anzen_amount: "0",
          nr_seguro_anzen_total_amount: "0",
          nr_seguro_anzen_surcharges: "0",
          nr_seguro_anzen_tipo: "",
        });
        return;
      }

      const amount =
        toNumber(option.__totalAmount) ||
        toNumber(option.__amount) ||
        toNumber(response?.totalAmountSg);

      patchNrFormData({
        nr_seguro_anzen_key: String(option.__key || ""),
        nr_seguro_anzen_id: String(option.__insuranceId || ""),
        nr_seguro_anzen_campania_id: String(option.__campaignId || ""),
        nr_seguro_anzen_amount: String(option.__amount || amount || 0),
        nr_seguro_anzen_total_amount: String(
          option.__totalAmount || amount || 0,
        ),
        nr_seguro_anzen_surcharges: String(option.__surcharges || 0),
        nr_seguro_anzen_tipo: String(option.__kind || ""),
      });
    },
    [nrAnzenCotizacion, patchNrFormData],
  );

  const handleNrInsuranceOptionChange = useCallback(
    (event) => {
      const option = nrInsuranceOptions.find(
        (item) => String(item.__key || "") === String(event.target.value || ""),
      );
      applyNrInsuranceOption(option || null);
    },
    [applyNrInsuranceOption, nrInsuranceOptions],
  );

  const buildNrAnzenQuotePayload = useCallback(
    (homologacionParam = nrHomologacion) => {
      const homologacionActual = homologacionParam || nrHomologacion;
      const formActual = formDataRef.current || formData || {};
      const financial = getNrCurrentFinancialValues();
      const accesorios = getNrAccesoriosResumen();
      const dynamicCatalogs = Array.isArray(nrCatalogosAnzen?.DynamicCatalogs)
        ? nrCatalogosAnzen.DynamicCatalogs
        : [];

      const packageExternal = String(
        homologacionActual?.paqueteExternoId ||
          formActual.nr_paquete_externo_id ||
          "",
      ).trim();
      const anzenProduct = String(
        homologacionActual?.anzenProductoId ||
          formActual.nr_anzen_producto_id ||
          "",
      ).trim();
      const tipoProductoId = String(
        homologacionActual?.tipoProductoId ||
          formActual.nr_tipo_producto_id ||
          "",
      ).trim();
      const estrategiaCebip = nrGetPackageCebipName(
        homologacionActual?.paquete || {},
      );

      const required = [
        ["marca", homologacionActual?.marcaId],
        ["agencia", formActual.nr_agencia_clave || NR_DEFAULT_AGENCIA_CLAVE],
        ["producto Anzen (idExterno)", anzenProduct],
        ["paquete externo (idExterno)", packageExternal],
        ["plazo", financial.plazo],
        ["estado", formActual.nr_estado_id],
        ["municipio", formActual.nr_municipio_id],
        ["precio", financial.precio],
        ["tipo de seguro", formActual.nr_tipo_seguro_id],
        ["cobertura", formActual.nr_cobertura_id],
        ["UDI", formActual.nr_udi_id],
        ["uso", formActual.nr_uso_id],
        ["tipo de producto", tipoProductoId],
        ["nombre CEBIP del paquete", estrategiaCebip],
      ];
      const missing = required
        .filter(([, value]) => String(value ?? "").trim() === "")
        .map(([label]) => label);

      if (missing.length) {
        throw new Error(
          `Faltan datos reales para consultar seguros Anzen: ${missing.join(", ")}.`,
        );
      }

      const externalPackageNumber = Number(packageExternal);
      if (!Number.isFinite(externalPackageNumber) || externalPackageNumber <= 0) {
        throw new Error(
          `El idExterno del paquete (“${packageExternal}”) no es numérico y consultar-seguros-anzen requiere IdPaqueteExterno entero.`,
        );
      }

      return {
        venta_id:
          selectedMailDataRef.current?.id ||
          selectedMailData?.id ||
          formActual.venta_id ||
          "",
        IdCotReconsideracion: 0,
        IdMarca: Number(homologacionActual.marcaId),
        IdAgenciaExterno: String(
          formActual.nr_agencia_clave || NR_DEFAULT_AGENCIA_CLAVE,
        ).trim(),
        IdTipoOperacion: Number(homologacionActual.tipoOperacionId),
        PersonalidadJuridica: Number(formActual.nr_personalidad_juridica),
        AnzenProductoId: anzenProduct,
        IdPaqueteExterno: externalPackageNumber,
        Plazo: Number(financial.plazo),
        IdEstado: Number(formActual.nr_estado_id),
        IdMunicipio: Number(formActual.nr_municipio_id),
        Precio: financial.precio,
        TotalAccesorios: accesorios.accesoriosFinanciados,
        TipoSeguro: Number(formActual.nr_tipo_seguro_id),
        TypeOfCoverageId: Number(formActual.nr_cobertura_id),
        UdiLevelId: Number(formActual.nr_udi_id),
        GpsId: 0,
        TipoUso: Number(formActual.nr_uso_id),
        IdTipoProducto: Number(tipoProductoId),
        Estrategia: estrategiaCebip,
        ParametrosDinamicos: dynamicCatalogs
          .map((item) => ({
            IdTypeCat: Number(item?.IdTypeCat || 0),
            TypeCat: String(item?.TypeCat || "").trim(),
            IdValue: String(item?.IdValue || "").trim(),
          }))
          .filter((item) => item.IdTypeCat && item.IdValue),
      };
    },
    [
      // OJO: formData/selectedMailData NO van aquí a propósito, mismo
      // motivo que getNrCurrentFinancialValues (ver su comentario arriba).
      getNrAccesoriosResumen,
      getNrCurrentFinancialValues,
      nrCatalogosAnzen,
      nrHomologacion,
    ],
  );

  const handleConsultarSegurosAnzenNR = useCallback(
    async ({ silent = false, homologacion: homologacionParam = null } = {}) => {
      try {
        setNrAnzenLoading(true);
        setNrAnzenError(null);

        const payload = buildNrAnzenQuotePayload(
          homologacionParam || nrHomologacion,
        );
        const data = await nrApiPost(
          NR_ENDPOINTS.consultarSegurosAnzen,
          payload,
        );
        const response =
          data && typeof data === "object" && !Array.isArray(data)
            ? data
            : {};

        if (response.accesso !== true) {
          throw new Error(
            "Anzen respondió sin acceso válido para obtener cotizaciones de seguro.",
          );
        }

        const options = nrNormalizeAnzenInsuranceOptions(response);
        setNrAnzenCotizacion(response);
        setNrAnzenError(null);

        const currentKey = String(
          (formDataRef.current || formData || {}).nr_seguro_anzen_key || "",
        );
        const currentOption =
          options.find(
            (item) => String(item.__key || "") === currentKey,
          ) || null;
        const optionToApply =
          currentOption ||
          (options.length === 1 ? options[0] : null);

        applyNrInsuranceOption(optionToApply, response);

        if (!silent) {
          Swal.fire({
            icon: options.length ? "success" : "info",
            title: options.length
              ? "Seguros Anzen actualizados"
              : "Sin seguros disponibles",
            text: options.length
              ? options.length === 1
                ? "Se encontró una opción de seguro y quedó seleccionada."
                : `Se encontraron ${options.length} opciones. Selecciona la que corresponda.`
              : "Anzen respondió correctamente, pero no regresó opciones para esta combinación.",
            timer: 2000,
            showConfirmButton: false,
          });
        }

        return { ok: true, data: response, options };
      } catch (error) {
        const errorInfo = {
          message: error?.message || "No se pudieron consultar seguros Anzen.",
          code: String(error?.code || ""),
          status: Number(error?.status || 0),
        };

        setNrAnzenCotizacion(null);
        setNrAnzenError(errorInfo);
        applyNrInsuranceOption(null, null);

        if (!silent) {
          Swal.fire({
            icon: "warning",
            title: "Seguro Anzen no disponible",
            text: errorInfo.code
              ? `${errorInfo.message} (${errorInfo.code})`
              : errorInfo.message,
            confirmButtonText: "Aceptar",
          });
        } else {
          console.warn("No se pudieron consultar seguros Anzen:", error);
        }

        return { ok: false, message: errorInfo.message, error: errorInfo };
      } finally {
        setNrAnzenLoading(false);
      }
    },
    [
      // OJO: formData NO va aquí a propósito, mismo motivo de arriba —
      // esta era la última función de la cadena (getNrCurrentFinancialValues
      // -> buildNrAnzenQuotePayload -> handleConsultarSegurosAnzenNR) que le
      // faltaba este fix; con las 3 corregidas, la consulta a Anzen ya no se
      // re-dispara en cada ciclo del polling de 4s.
      applyNrInsuranceOption,
      buildNrAnzenQuotePayload,
      nrApiPost,
      nrHomologacion,
    ],
  );

  const nrAnzenQuoteSignature = useMemo(() => {
    const formActual = formDataRef.current || formData || {};
    const financial = getNrCurrentFinancialValues();

    return JSON.stringify({
      marcaId: nrHomologacion?.marcaId || "",
      productoAnzen: formActual.nr_anzen_producto_id || "",
      paqueteExterno:
        nrHomologacion?.paqueteExternoId ||
        formActual.nr_paquete_externo_id ||
        "",
      plazo: financial.plazo,
      estado: formActual.nr_estado_id || "",
      municipio: formActual.nr_municipio_id || "",
      precio: financial.precio,
      tipoSeguro: formActual.nr_tipo_seguro_id || "",
      cobertura: formActual.nr_cobertura_id || "",
      udi: formActual.nr_udi_id || "",
      uso: formActual.nr_uso_id || "",
    });
  }, [
    // OJO: formData NO va aquí a propósito, mismo criterio que las funciones
    // de arriba (usa formDataRef.current dentro del cuerpo).
    getNrCurrentFinancialValues,
    nrHomologacion,
  ]);

  useEffect(() => {
    if (!agenciaUsaCotizadorNR) return undefined;

    const formActual = formDataRef.current || formData || {};
    const canQuery = Boolean(
      nrHomologacion?.marcaId &&
        nrHomologacion?.paqueteId &&
        formActual.nr_estado_id &&
        formActual.nr_municipio_id &&
        formActual.nr_tipo_seguro_id &&
        formActual.nr_cobertura_id &&
        formActual.nr_udi_id !== "" &&
        formActual.nr_uso_id,
    );

    if (!canQuery) return undefined;

    const timer = setTimeout(() => {
      handleConsultarSegurosAnzenNR({ silent: true });
    }, 550);

    return () => clearTimeout(timer);
  }, [
    agenciaUsaCotizadorNR,
    nrAnzenQuoteSignature,
    handleConsultarSegurosAnzenNR,
    nrHomologacion?.marcaId,
    nrHomologacion?.paqueteId,
  ]);

  const buildNrCotizaPayload = useCallback(
    (homologacionParam = nrHomologacion) => {
      const homologacionActual = homologacionParam || nrHomologacion;

      if (!homologacionActual?.productoId || !homologacionActual?.paqueteId) {
        throw new Error("Primero homologa el producto y el plan NR.");
      }

      const formActual = formDataRef.current || formData || {};
      const venta = selectedMailDataRef.current || selectedMailData || {};
      const financial = getNrCurrentFinancialValues();
      const accesorios = getNrAccesoriosResumen();
      const anzenResponse =
        nrAnzenCotizacion &&
        typeof nrAnzenCotizacion === "object" &&
        !Array.isArray(nrAnzenCotizacion)
          ? nrAnzenCotizacion
          : {};
      const selectedInsurance = nrSelectedInsurance || null;

      const selectedTotalAmount =
        toNumber(selectedInsurance?.__totalAmount) ||
        toNumber(formActual.nr_seguro_anzen_total_amount) ||
        toNumber(montoSeguro || 0);
      const montoSeguroNr = selectedTotalAmount || toNumber(montoSeguro || 0);
      const insuranceFree = anzenResponse.insuranceFree || null;
      const insurancePromotional =
        anzenResponse.insurancePromotional || null;
      const seguroPromocion = toNumber(anzenResponse.seguroPromocion);
      const permiteSeguroPromocion = Number(
        anzenResponse.permiteSeguroPromocion || 0,
      );
      const seguroGratis =
        selectedInsurance?.__kind === "free" || Boolean(insuranceFree) ? 1 : 0;
      const tipoOperacionNr = Number(
        nrGetTipoOperacionFromEntrevista(formActual, venta) || 0,
      );
      const tipoCompraSeguroActual = String(
        financial.tipoCompraSeguro || tipoCompraSeguro || "",
      ).trim();
      const selectedProduct =
        homologacionActual?.producto || nrSelectedProduct || {};
      const brokerId = Number(
        homologacionActual?.brokerId ??
          selectedProduct?.idBroker ??
          0,
      );

      const required = [
        ["personalidad jurídica", formActual.nr_personalidad_juridica],
        ["tipo de operación", tipoOperacionNr],
        ["clasificación", homologacionActual.clasifId],
        ["versión", homologacionActual.versionId],
        ["producto", homologacionActual.productoId],
        ["paquete", homologacionActual.paqueteId],
        ["plazo", financial.plazo],
        ["precio", financial.precio],
        ["tipo de compra del seguro", tipoCompraSeguroActual],
        ["uso", formActual.nr_uso_id],
        ["tipo de seguro", formActual.nr_tipo_seguro_id],
        ["cobertura", formActual.nr_cobertura_id],
        ["aseguradora", formActual.nr_aseguradora_id],
        ["estado", formActual.nr_estado_id],
        ["seguro de vida", formActual.nr_seguro_vida_id],
      ];
      const missing = required
        .filter(([, value]) => String(value ?? "").trim() === "" || value === 0)
        .map(([label]) => label);

      if (missing.length) {
        throw new Error(
          `Faltan datos reales de NR para cotizar: ${missing.join(", ")}.`,
        );
      }

      const tasaPaquete = nrResolvePackageRate({
        paquetes: nrCatalogos.paquetes,
        catalogoPlazos: nrCatalogos.plazos,
        paqueteId: homologacionActual.paqueteId,
        plazoMeses: financial.plazo,
      });

      if (tasaPaquete == null) {
        throw new Error(
          `NR no regresó una tasa nominal válida para el paquete ${homologacionActual.paqueteId} y el plazo de ${financial.plazo} meses.`,
        );
      }

      const payload = {
        venta_id: venta?.id || formActual.venta_id || "",
        IdPaquete: Number(homologacionActual.paqueteId),
        IdPerJuridica:
          String(formActual.nr_personalidad_juridica) === "2" ? 15 : 14,
        IdTipoOperacion: tipoOperacionNr,
        Plazo: Number(financial.plazo),
        IdClasificacion: Number(homologacionActual.clasifId),
        IdVersion: Number(homologacionActual.versionId),
        IdProducto: Number(homologacionActual.productoId),

        // Valores de contrato Procotiza; no son defaults de catálogo.
        IdTipoUnidad: 0,
        Unidades: 1,
        IdTasaIva: 2,

        // BUG corregido (mismo encontrado en la sesión de crearventa.js):
        // nr_uso_id es el TypeOfUsesId del catálogo dinámico de Anzen
        // (GetCatalogsAnzen -> TypeOfUses, ej. 4=Particular), NO el valor
        // que espera este campo. La doc de /cotiza solo documenta
        // "Uso: 0=particular" y no expone catálogo propio para esto, así
        // que es una constante fija de protocolo, no un dato de Anzen.
        Uso: 0,
        Precio: Number(financial.precio),
        Enganche: Number(financial.enganche),
        PorcentajeEnganche: Number(financial.porcentajeEnganche),
        Bandera: tipoOperacionNr === 3 ? 1 : 0,
        MontoAccesorios: accesorios.accesoriosFinanciados,
        MontoAccesoriosContado: accesorios.accesoriosContado,
        MontoAccesoriosISAN: 0,
        MontoAccesoriosNoISAN: accesorios.accesoriosFinanciados,
        IdTipoSeguro: Number(formActual.nr_tipo_seguro_id),
        Cobertura: Number(formActual.nr_cobertura_id),
        IdAseguradora: Number(formActual.nr_aseguradora_id),
        IdEstado: Number(formActual.nr_estado_id),
        MontoSeguroProducto:
          tipoCompraSeguroActual === "Financiado" ? montoSeguroNr : 0,
        MontoSeguroGAP: 0,
        MontoSeguroVida: 0,
        Derecho: 0,
        ParamsBroker: "",
        // Mejora defensiva (no un bug confirmado aquí): se deriva 227/0 de
        // si hay selección en vez de reenviar nr_seguro_vida_id tal cual.
        // En este ambiente el catálogo /catalogs/seguros-vida solo trae un
        // id=227, así que hoy coincide con el flag que espera este campo
        // (0=ninguno, 227=solo vida) — pero no hay garantía de que siempre
        // sea así si el catálogo llega a traer más opciones.
        TipoSeguroVida: String(formActual.nr_seguro_vida_id || "").trim()
          ? 227
          : 0,
        DestinoSubsidio: 2,
        SubsidioAdicional: 0,
        DescuentoAdicional: 0,
        SubsidioMarca: toNumber(selectedProduct?.subsidioMarca),
        SubsidioAgencia: toNumber(selectedProduct?.subsidioConcesionario),
        SubsidioFinanciera: toNumber(selectedProduct?.subsidioFinanciera),
        SubsidioAdicionalExtra: 0,
        TipoSubsidioAdicional: 327,
        ServiciosFinanciados: 0,
        ServiciosNoFinanciados: 0,
        Apparel: 0,
        TotalProductosAdicionales: 0,
        TotalGarantiaExtendida: accesorios.garantiaExtendida,
        SeguroGratis: seguroGratis,
        MontoAnualAnzen: selectedTotalAmount || montoSeguroNr,
        ComisionApertura: 0,
        // Valor estándar definido por el contrato /cotiza.
        TipoCxA: 331,
        // Tasa nominal real obtenida de /paquetes para el idPlazo elegido.
        // Se manda también a /guardar-cotizacion para que el PDF conserve la
        // misma tasa usada en la operación.
        ValorTasaEdit: tasaPaquete,
        DiaPago: 1,
        MtoGarantia: 1,
        PagoFinalManual: 0,
        TabuladorSeguro: "",
        DatosTabulador: "",
        TabuladorAccesorio: "",
        RentasDeposito: 0,
        PlazoModificador: "",
        IdCotizacion: 0,
        IdCotReconsideracion: 0,
        PermiteSeguroPromocion: permiteSeguroPromocion,
        SeguroPromocion: seguroPromocion,
      };

      // IdBroker es opcional en el contrato. Sólo se envía cuando el producto
      // realmente lo regresa.
      if (brokerId > 0) {
        payload.IdBroker = brokerId;
      }

      return payload;
    },
    [
      formData,
      getNrAccesoriosResumen,
      getNrCurrentFinancialValues,
      montoSeguro,
      nrAnzenCotizacion,
      nrCatalogos.paquetes,
      nrCatalogos.plazos,
      nrHomologacion,
      nrSelectedInsurance,
      nrSelectedProduct,
      selectedMailData,
      tipoCompraSeguro,
    ],
  );

  const buildNrGuardarCotizacionPayload = useCallback(
    (
      homologacionParam = nrHomologacion,
      cotizacionOverride = null,
    ) => {
      const homologacionActual = homologacionParam || nrHomologacion;
      const formActual = formDataRef.current || formData || {};
      const cotizaPayload = buildNrCotizaPayload(homologacionActual);
      const accesorios = getNrAccesoriosResumen();
      const cotizacionParaGuardar = cotizacionOverride || nrCotizacion;
      const venta = selectedMailDataRef.current || selectedMailData || {};
      const anzenResponse =
        nrAnzenCotizacion &&
        typeof nrAnzenCotizacion === "object" &&
        !Array.isArray(nrAnzenCotizacion)
          ? nrAnzenCotizacion
          : {};
      const selectedInsurance = nrSelectedInsurance || null;

      if (!cotizacionParaGuardar) {
        throw new Error(
          "Primero calcula la cotización con NR antes de guardarla.",
        );
      }

      const selectedInsuranceId = Number(
        selectedInsurance?.__insuranceId ||
          formActual.nr_seguro_anzen_id ||
          0,
      );
      const selectedCampaignId = Number(
        selectedInsurance?.__campaignId ||
          formActual.nr_seguro_anzen_campania_id ||
          0,
      );
      const selectedAmount =
        toNumber(selectedInsurance?.__amount) ||
        toNumber(formActual.nr_seguro_anzen_amount) ||
        toNumber(montoSeguro || 0);
      const selectedTotalAmount =
        toNumber(selectedInsurance?.__totalAmount) ||
        toNumber(formActual.nr_seguro_anzen_total_amount) ||
        toNumber(montoSeguro || 0);
      const selectedSurcharges =
        toNumber(selectedInsurance?.__surcharges) ||
        toNumber(formActual.nr_seguro_anzen_surcharges);

      const insuranceFree = anzenResponse.insuranceFree || null;
      const insurancePromotional =
        anzenResponse.insurancePromotional || null;
      const extendedWarranty = Array.isArray(anzenResponse.extendedWarranty)
        ? anzenResponse.extendedWarranty
        : [];
      const additionalProducts = Array.isArray(anzenResponse.additionalProducts)
        ? anzenResponse.additionalProducts
        : [];

      const normalizeInsuranceObject = (item, promotional = false) => {
        if (!item || typeof item !== "object") return null;

        return {
          insuranceId: Number(item.insuranceId || 0),
          campaignId: Number(item.campaignId || 0),
          amount: toNumber(item.amount),
          totalAmount: toNumber(item.totalAmount),
          ...(promotional
            ? { promoAmount: toNumber(item.promoAmount) }
            : {}),
          surcharges: toNumber(item.surcharges),
        };
      };

      // La tasa de guardado debe ser exactamente la misma que se envió a
      // /cotiza. En este ejercicio NR responde cotizacion.tasa=0 aunque el
      // paquete trae 16.99; tomar la respuesta provocaba que guardar y el PDF
      // quedaran en cero.
      const tasaGuardar = Number(cotizaPayload.ValorTasaEdit);

      if (!Number.isFinite(tasaGuardar) || tasaGuardar <= 0) {
        throw new Error(
          "No se encontró una tasa nominal válida del paquete/plazo para guardar la cotización NR.",
        );
      }
      const selectedProduct =
        homologacionActual?.producto || nrSelectedProduct || {};
      const selectedPackage =
        homologacionActual?.paquete || {};
      const moneda = Number(
        homologacionActual?.moneda ??
          selectedPackage?.idMoneda ??
          selectedProduct?.moneda ??
          0,
      );
      const tipoDePrecio = Number(
        formActual.nr_producto_tipo_precio_id ||
          selectedProduct?.tipoCxa ||
          0,
      );

      const estado = (Array.isArray(nrCatalogos.estados)
        ? nrCatalogos.estados
        : []
      ).find(
        (item) =>
          String(item?.id ?? "") ===
          String(formActual.nr_estado_id || ""),
      );
      const aseguradoraItem = nrAseguradorasOptions.find(
        (item) =>
          String(item?.InsuranceId ?? "") ===
          String(formActual.nr_aseguradora_id || ""),
      );
      const coberturaItem = nrCoberturasOptions.find(
        (item) =>
          String(item?.TypeOfCoverageId ?? "") ===
          String(formActual.nr_cobertura_id || ""),
      );
      const usoItem = nrUsosOptions.find(
        (item) =>
          String(item?.TypeOfUsesId ?? "") ===
          String(formActual.nr_uso_id || ""),
      );

      const estadoNombre = String(
        formActual.nr_estado_nombre || estado?.nombre || "",
      ).trim();
      const aseguradoraNombre = String(
        formActual.nr_aseguradora_nombre ||
          aseguradoraItem?.Description ||
          "",
      ).trim();
      const coberturaNombre = String(
        formActual.nr_cobertura_nombre ||
          coberturaItem?.Description ||
          "",
      ).trim();
      const usoNombre = String(
        formActual.nr_uso_nombre ||
          usoItem?.Description ||
          "",
      ).trim();

      const required = [
        ["moneda", moneda],
        ["tipoDePrecio/estrategia", tipoDePrecio],
        ["estado", estadoNombre],
        ["municipio", formActual.nr_municipio_nombre],
        ["tipo de uso", formActual.nr_uso_id],
        ["tipo de seguro", formActual.nr_tipo_seguro_id],
        ["seguro de vida", formActual.nr_seguro_vida_id],
        ["aseguradora", formActual.nr_aseguradora_id],
        ["cobertura", formActual.nr_cobertura_id],
      ];
      const missing = required
        .filter(([, value]) => String(value ?? "").trim() === "" || value === 0)
        .map(([label]) => label);

      if (missing.length) {
        throw new Error(
          `Faltan datos reales de NR para guardar: ${missing.join(", ")}.`,
        );
      }

      const tieneDatosAnzen =
        selectedInsuranceId > 0 ||
        Boolean(insuranceFree) ||
        Boolean(insurancePromotional) ||
        extendedWarranty.length > 0 ||
        additionalProducts.length > 0;

      const anzenDataPayload =
        NR_INCLUDE_ANZEN_DATA_ON_SAVE && tieneDatosAnzen
          ? {
              idMarca: Number(homologacionActual?.marcaId || 0),
              anzenProductoId: String(
                homologacionActual?.anzenProductoId ||
                  formActual.nr_anzen_producto_id ||
                  "",
              ).trim(),
              estrategia: nrGetPackageCebipName(selectedPackage),
              usuarioRegistro: Number(
                localStorage.getItem("userId") ||
                  formActual.user_id ||
                  0,
              ),
              idCotReconsideracion: 0,
              insurances:
                selectedInsuranceId > 0 &&
                selectedInsurance?.__kind === "standard"
                  ? [
                      {
                        insuranceId: selectedInsuranceId,
                        campaignId: selectedCampaignId,
                        amount: selectedAmount,
                        surcharges: selectedSurcharges,
                      },
                    ]
                  : [],
              insuranceFree: normalizeInsuranceObject(insuranceFree),
              insurancePromotional: normalizeInsuranceObject(
                insurancePromotional,
                true,
              ),
              extendedWarranty: extendedWarranty
                .filter((item) => Number(item?.subProductId || 0) > 0)
                .map((item) => ({
                  subProductId: Number(item.subProductId),
                  baseAmount: toNumber(item.baseAmount),
                  finalAmount: toNumber(item.finalAmount),
                  type: String(item.type || "").trim(),
                })),
              additionalProducts: additionalProducts
                .filter(
                  (item) =>
                    String(item?.subProductId || "").trim() &&
                    String(item?.subBranchId || "").trim(),
                )
                .map((item) => ({
                  subBranchId: String(item.subBranchId).trim(),
                  subProductId: String(item.subProductId).trim(),
                  amount: toNumber(item.amount),
                  type: String(item.type || "").trim(),
                })),
            }
          : null;

      return {
        venta_id: venta?.id || formActual.venta_id || "",
        idPaquete: String(homologacionActual.paqueteId),
        idProducto: Number(homologacionActual.productoId),
        plazo: Number(cotizaPayload.Plazo),
        enganche: Number(cotizaPayload.Enganche),
        tasa: tasaGuardar,
        moneda,
        diaPago: Number(cotizaPayload.DiaPago),
        agencia: String(
          formActual.nr_agencia_clave || NR_DEFAULT_AGENCIA_CLAVE,
        ).trim(),
        // Mismo fix que en /cotiza: constante fija, no nr_uso_id (catálogo Anzen).
        tipoUso: 0,
        unidadesProducto: Number(cotizaPayload.Unidades),

        // Se conserva el contrato validado en UAT: 14=PF, 15=PM.
        personalidadJuridica:
          String(formActual.nr_personalidad_juridica) === "2"
            ? 15
            : 14,

        // Se usa el valor real del producto que ya fue validado en UAT.
        tipoDePrecio,
        seguro: {
          tipoSeguro: Number(formActual.nr_tipo_seguro_id),
          estado: estadoNombre,
          municipio: String(formActual.nr_municipio_nombre || "").trim(),
          seguroVida: String(formActual.nr_seguro_vida_id || "").trim()
            ? 227
            : 0,
          monto: selectedTotalAmount || toNumber(montoSeguro || 0),
          idAseguradora: Number(formActual.nr_aseguradora_id),
          aseguradora: aseguradoraNombre,
          seguroGratis:
            selectedInsurance?.__kind === "free" || insuranceFree ? 1 : 0,
          tipoUso: usoNombre,
          cobertura: coberturaNombre,
          nivelUdi: String(formActual.nr_udi_id || ""),
          exclusivoPickup: "0",
          montoTotal: selectedTotalAmount,
          idCapania: selectedCampaignId,
          idInsurance:
            selectedInsuranceId > 0 ? selectedInsuranceId : 0,
          idCampaing: selectedCampaignId,
          descripcionSG: "",
          campaingDesc: "",
          campainDescSG: "",
          termSG: 0,
          descCobertura: coberturaNombre,
          descUso: usoNombre,
          surcharges: selectedSurcharges,
          policy: selectedAmount,
          policyFree: insuranceFree
            ? toNumber(insuranceFree.amount || insuranceFree.totalAmount)
            : 0,
          subproducto: 0,
          subproductoSG: 0,
          insuranceProg: 0,
          insuranceVers: 0,
          insuranceProgSG: 0,
          insuranceVersSG: 0,
          coberturaGen: coberturaNombre,
          coberturaGenFree: "",
          totalAmountSG: toNumber(anzenResponse.totalAmountSg),
        },

        // Detalle de accesorios para el PDF/guardado. Antes se mandaba [].
        //
        // Por el ejemplo real que compartió NR, el contrato NO es "un
        // renglón por cada accesorio real con tipo 1=financiado/2=contado"
        // como dice la doc v1.2 — ahí ambos renglones traían tipo:160 fijo
        // y solo 2 ids fijos (47547 y 47548) para agrupar TODO.
        //
        // Se decidió usar esos 2 ids como financiado/contado (ver
        // NR_ID_ACCESORIO_FINANCIADO/CONTADO arriba) en vez de separar por
        // tipo de accesorio (garantía/físico): así el bucket "financiado"
        // es exactamente accesorios.accesoriosFinanciados (== MontoAccesorios
        // en /cotiza) y el bucket "contado" es exactamente
        // accesorios.accesoriosContado (== MontoAccesoriosContado en
        // /cotiza, que ya incluye adicionalesContado + placas) — sin volver
        // a filtrar accesorio por accesorio. Eso fue justo lo que causó la
        // fuga de $8,298 detectada en la prueba real 12471842 (un filtro
        // por acc.type distinto al que ya usa getNrAccesoriosResumen para
        // TotalGarantiaExtendida/gEX dejaba dinero fuera de ambos lados).
        // Con este enfoque no hay forma de que se pierda dinero: los dos
        // buckets siempre sumados dan exactamente MontoAccesorios +
        // MontoAccesoriosContado.
        listaAccesorios: (() => {
          const financiadoTotal = Math.round(
            toNumber(accesorios.accesoriosFinanciados),
          );
          const contadoTotal = Math.round(
            toNumber(accesorios.accesoriosContado),
          );

          const items = [];
          if (financiadoTotal > 0) {
            items.push({
              idAccesorio: NR_ID_ACCESORIO_FINANCIADO,
              tipo: NR_TIPO_ACCESORIO_GENERICO,
              monto: financiadoTotal,
            });
          }
          if (contadoTotal > 0) {
            items.push({
              idAccesorio: NR_ID_ACCESORIO_CONTADO,
              tipo: NR_TIPO_ACCESORIO_GENERICO,
              monto: contadoTotal,
            });
          }
          return items;
        })(),
        gEX:
          toNumber(cotizaPayload.TotalGarantiaExtendida) > 0
            ? {
                montoBase: toNumber(cotizaPayload.TotalGarantiaExtendida),
                overPricing: 0,
                plazo: Number(cotizaPayload.Plazo),
                subproductoId: 0,
                tipo: "Garantía Extendida",
                insuranceIdEW: 0,
              }
            : null,
        productosAdicionales: [],
        pagosEspeciales: null,
        anzenData: anzenDataPayload,
      };
    },
    [
      buildNrCotizaPayload,
      getNrAccesoriosResumen,
      adicionalesContado,
      incluyePlacas,
      montoPlacas,
      formData,
      montoSeguro,
      nrAnzenCotizacion,
      nrAseguradorasOptions,
      nrCatalogos.estados,
      nrCoberturasOptions,
      nrCotizacion,
      nrHomologacion,
      nrSelectedInsurance,
      nrSelectedProduct,
      nrUsosOptions,
      selectedMailData,
    ],
  );

  const handleSelectNrProductCandidate = useCallback(
    (producto) => {
      if (!producto) return;

      const productoId = Number(producto?.idProducto || producto?.id || 0);

      if (!productoId) {
        Swal.fire({
          icon: "error",
          title: "Producto NR inválido",
          text: "El producto seleccionado no contiene un ID real.",
        });
        return;
      }

      setNrSelectedProduct(producto);
      setShowNrProductModal(false);
      setNrCotizacion(null);
      setNrCotizacionGuardadaId("");
      setNrLastCotizaRequest(null);
      setNrLastCotizaSignature("");
      setNrLastSavedSignature("");
      setNrPdfBase64("");
      setShowNrPdfViewer(false);

      patchNrFormData({
        nr_producto_id: String(productoId),
        nr_producto_descripcion: String(
          producto?.descripcion || "",
        ).trim(),
        nr_anzen_producto_id: String(
          producto?.idExterno || "",
        ).trim(),
        nr_tipo_producto_id: String(
          producto?.idTipoProducto ?? "",
        ).trim(),
        nr_broker_id: String(producto?.idBroker ?? "").trim(),
        nr_seguro_anzen_key: "",
        nr_seguro_anzen_id: "",
        nr_seguro_anzen_campania_id: "",
        nr_seguro_anzen_amount: "0",
        nr_seguro_anzen_total_amount: "0",
        nr_seguro_anzen_surcharges: "0",
        nr_seguro_anzen_tipo: "",
        nr_cotizacion_id: "",
      });

      setNrAnzenCotizacion(null);
      setNrAnzenError(null);
      setMontoSeguro("0");
      setMontoSeguroDisplay(formatInputCurrency(0));

      Swal.fire({
        icon: "success",
        title: "Producto NR seleccionado",
        text: "Se guardó la selección real del catálogo. Continúa para completar plan y seguro.",
        timer: 1800,
        showConfirmButton: false,
      });
    },
    [patchNrFormData],
  );

  const resetNrDownstreamSelection = useCallback(
    (patch = {}) => {
      nrAnzenRequestKeyRef.current = "";
      nrCatalogosAnzenRef.current = {};
      setNrCatalogos((prev) => ({
        ...prev,
        anzen: {},
      }));
      setNrHomologacion(null);
      setNrAnzenCotizacion(null);
      setNrAnzenError(null);
      setNrCotizacion(null);
      setNrCotizacionGuardadaId("");
      setNrPdfBase64("");
      setShowNrPdfViewer(false);
      setMontoSeguro("0");
      setMontoSeguroDisplay(formatInputCurrency(0));

      patchNrFormData({
        nr_estado_id: "",
        nr_estado_nombre: "",
        nr_municipio_id: "",
        nr_municipio_nombre: "",
        nr_aseguradora_id: "",
        nr_aseguradora_nombre: "",
        nr_cobertura_id: "",
        nr_cobertura_nombre: "",
        nr_udi_id: "",
        nr_udi_nombre: "",
        nr_uso_id: "",
        nr_uso_nombre: "",
        nr_seguro_anzen_key: "",
        nr_seguro_anzen_id: "",
        nr_seguro_anzen_campania_id: "",
        nr_seguro_anzen_amount: "0",
        nr_seguro_anzen_total_amount: "0",
        nr_seguro_anzen_surcharges: "0",
        nr_seguro_anzen_tipo: "",
        nr_cotizacion_id: "",
        ...patch,
      });
    },
    [patchNrFormData],
  );

  const handleNrEstrategiaChange = useCallback(
    async (event) => {
      const estrategiaId = String(event.target.value || "");
      const estrategia = (Array.isArray(nrCatalogos.estrategias)
        ? nrCatalogos.estrategias
        : []
      ).find((item) => String(item?.id ?? "") === estrategiaId);

      resetNrDownstreamSelection({
        nr_estrategia_id: estrategiaId,
        nr_estrategia_nombre: String(estrategia?.nombre || "").trim(),
        nr_producto_id: "",
        nr_producto_descripcion: "",
        nr_producto_tipo_precio_id: "",
        nr_anzen_producto_id: "",
        nr_tipo_producto_id: "",
        nr_broker_id: "",
        nr_plan_id: "",
        nr_plan_nombre: "",
        nr_paquete_externo_id: "",
        nr_plazo: "",
      });

      if (!estrategiaId) return;

      // La selección queda primero en formDataRef; resolveNrHomologacion la
      // respeta como currentId y reconstruye producto + plan a partir de ella.
      try {
        await resolveNrHomologacion({ openProductModal: false });
      } catch (error) {
        const message = error?.message || "No se pudo actualizar la estrategia NR.";
        setNrLastError(message);
        Swal.fire({ icon: "error", title: "Estrategia NR", text: message });
      }
    },
    [nrCatalogos.estrategias, resetNrDownstreamSelection, resolveNrHomologacion],
  );

  const handleNrPlanChange = useCallback(
    async (event) => {
      const planId = String(event.target.value || "");
      const paquetes = Array.isArray(nrCatalogos.paquetes)
        ? nrCatalogos.paquetes
        : [];
      const planes = Array.isArray(nrCatalogos.planes)
        ? nrCatalogos.planes
        : [];
      const paquete = paquetes.find(
        (item) => String(item?.idPaquete ?? "") === planId,
      );
      const plan = planes.find((item) => String(item?.id ?? "") === planId);

      resetNrDownstreamSelection({
        nr_plan_id: planId,
        nr_plan_nombre: String(paquete?.nombre || plan?.nombre || "").trim(),
        nr_paquete_externo_id: String(paquete?.idExterno || "").trim(),
        nr_plazo: "",
      });

      if (!planId) return;

      try {
        await resolveNrHomologacion({ openProductModal: false });
      } catch (error) {
        const message = error?.message || "No se pudo actualizar el plan/paquete NR.";
        setNrLastError(message);
        Swal.fire({ icon: "error", title: "Plan / paquete NR", text: message });
      }
    },
    [
      nrCatalogos.paquetes,
      nrCatalogos.planes,
      resetNrDownstreamSelection,
      resolveNrHomologacion,
    ],
  );

  const handlePrepararDatosNR = useCallback(async ({ silent = false } = {}) => {
    try {
      setNrLastError("");

      const prep = await resolveNrHomologacion({ openProductModal: !silent });

      if (!prep?.ok) {
        if (prep?.message && !silent) {
          Swal.fire({
            icon: "info",
            title: prep?.needsStrategySelection
              ? "Selecciona la estrategia NR"
              : prep?.needsPlanSelection
                ? "Selecciona el Plan / paquete NR"
                : "Homologación NR",
            text: prep.message,
            confirmButtonText: "Aceptar",
          });
        }

        return prep;
      }

      // Estado/Municipio van DESPUÉS de Estrategia + Producto + Plan/Paquete.
      // Por eso preparar NR ya no intenta llamar GetCatalogsAnzen si todavía
      // no hay estado seleccionado. En cuanto el asesor elija Estado, el
      // useEffect de abajo cargará los municipios con la homologación lista.
      let catalogWarning = "";
      const estadoActual = String(
        (formDataRef.current || {}).nr_estado_id || "",
      ).trim();

      if (estadoActual) {
        try {
          await cargarCatalogosAnzenNR(prep.homologacion);
        } catch (error) {
          catalogWarning =
            error?.message ||
            "Los catálogos de seguro no están disponibles temporalmente.";
          console.warn(
            "La homologación quedó lista, pero faltan catálogos Anzen:",
            error,
          );
        }
      }

      if (!silent) {
        Swal.fire({
          icon: catalogWarning ? "warning" : "success",
          title: catalogWarning
            ? "Homologación NR preparada"
            : "Datos NR preparados",
          text: catalogWarning
            ? `Estrategia, producto y plan/paquete quedaron listos. ${catalogWarning}`
            : estadoActual
              ? "Estrategia, producto, plan/paquete y catálogos NR quedaron preparados."
              : "Estrategia, producto y plan/paquete NR quedaron preparados. Ya puedes seleccionar el estado para cargar los municipios.",
          confirmButtonText: catalogWarning ? "Aceptar" : undefined,
          timer: catalogWarning ? undefined : 2200,
          showConfirmButton: Boolean(catalogWarning),
        });
      }

      return {
        ...prep,
        catalogWarning,
      };
    } catch (error) {
      const message =
        error?.message || "No se pudieron preparar los datos de NR.";
      setNrLastError(message);

      if (!silent) {
        Swal.fire({
          icon: "error",
          title: "Error preparando NR",
          text: message,
          confirmButtonText: "Aceptar",
        });
      }

      return { ok: false, message };
    }
  }, [resolveNrHomologacion, cargarCatalogosAnzenNR]);

  // Dispara "Preparar datos NR" solo (sin que el asesor tenga que dar clic)
  // en cuanto ya se puede: personalidad jurídica elegida + operación resuelta
  // a Crédito (Procotiza sólo aplica a crédito, ver nrGetTipoOperacionFromEntrevista).
  // Candado por venta+personalidad+operación para intentarlo UNA sola vez por
  // esa combinación: si NR no tiene plan/paquete para ella (como el caso de
  // "planes=0/0" reportado), no reintenta en bucle solo — el asesor puede
  // seguir usando el botón para reintentar manualmente tras cambiar la
  // Estrategia NR u otro dato.
  const nrAutoPrepararKeyRef = useRef("");

  useEffect(() => {
    // Candado principal del configurador por agencia: si esta agencia no
    // usa el cotizador NR, no se dispara nada de NR automáticamente (ni
    // catálogos, ni homologación, ni Anzen). El asesor tampoco puede
    // hacerlo a mano porque las tarjetas de NR están ocultas para esta
    // agencia (ver agenciaUsaCotizadorNR).
    if (!agenciaUsaCotizadorNR) return;

    const ventaId = String(selectedMailData?.id || "");
    const personalidad = String(formData.nr_personalidad_juridica || "");
    const tipoOperacionId = nrGetTipoOperacionFromEntrevista(
      formData,
      selectedMailData,
    );

    if (!ventaId || !personalidad || !tipoOperacionId) return;
    if (formData.nr_plan_id) return;
    if (nrCatalogosLoading) return;

    const key = `${ventaId}|${personalidad}|${tipoOperacionId}`;

    if (nrAutoPrepararKeyRef.current === key) return;
    nrAutoPrepararKeyRef.current = key;

    handlePrepararDatosNR({ silent: true }).catch((error) => {
      console.warn("No se pudo preparar NR automáticamente:", error);
    });
  }, [
    agenciaUsaCotizadorNR,
    selectedMailData?.id,
    formData.nr_personalidad_juridica,
    formData.pago_contado,
    formData.nr_plan_id,
    nrCatalogosLoading,
    handlePrepararDatosNR,
  ]);

  const handleCotizarConNR = useCallback(
    async ({ silent = false, openProductModal = true } = {}) => {
      try {
        setNrCotizacionLoading(true);
        setNrLastError("");

        const prep = await resolveNrHomologacion({ openProductModal });

        if (!prep?.ok) {
          if (!silent && prep?.message) {
            Swal.fire({
              icon: "info",
              title: "Homologación NR",
              text: prep.message,
              confirmButtonText: "Aceptar",
            });
          }

          return prep;
        }

        // Estado -> GetCatalogsAnzen -> municipio/seguro. Sin esos valores
        // reales no se fabrican reemplazos para completar /cotiza.
        try {
          await cargarCatalogosAnzenNR(prep.homologacion);
        } catch (error) {
          console.warn(
            "La cotización continuará sin actualizar catálogos Anzen:",
            error,
          );
        }

        const payload = buildNrCotizaPayload(prep.homologacion);
        const signatureActual = buildNrCurrentCalculationSignature(prep.homologacion);
        const data = await nrApiPost(NR_ENDPOINTS.cotiza, payload);
        const cotizacion = data;

        setNrLastCotizaRequest(payload);
        setNrLastCotizaSignature(signatureActual);
        setNrLastSavedSignature("");
        setNrCotizacion(cotizacion);
        setNrPdfBase64("");
        setShowNrPdfViewer(false);

        const comisionCalculada = nrGetOpeningCommission(cotizacion);
        setMontoComision(String(comisionCalculada || 0));
        setMontoComisionDisplay(
          formatInputCurrency(comisionCalculada || 0),
        );

        if (!silent) {
          Swal.fire({
            icon: "success",
            title: "Cotización NR calculada",
            text: "Ya puedes revisar la mensualidad oficial de NR.",
            timer: 1800,
            showConfirmButton: false,
          });
        }

        return {
          ok: true,
          data: cotizacion,
          homologacion: prep.homologacion,
          signature: signatureActual,
          request: payload,
        };
      } catch (error) {
        const message = error?.message || "No se pudo cotizar con NR.";
        setNrLastError(message);

        if (!silent) {
          Swal.fire({
            icon: "error",
            title: "Error en cotización NR",
            text: message,
            confirmButtonText: "Aceptar",
          });
        }

        return { ok: false, message };
      } finally {
        setNrCotizacionLoading(false);
      }
    },
    [
      buildNrCotizaPayload,
      buildNrCurrentCalculationSignature,
      cargarCatalogosAnzenNR,
      nrApiPost,
      resolveNrHomologacion,
    ],
  );

  const handleGuardarCotizacionNR = useCallback(
    async ({
      silent = false,
      homologacion: homologacionParam = null,
      cotizacionOverride = null,
      signature: signatureParam = "",
    } = {}) => {
      try {
        setNrGuardarLoading(true);
        setNrLastError("");

        let homologacionActual = homologacionParam || nrHomologacion;
        let cotizacionParaGuardar = cotizacionOverride;

        if (!homologacionActual?.productoId || !homologacionActual?.paqueteId) {
          const prep = await resolveNrHomologacion({
            openProductModal: !silent,
          });

          if (!prep?.ok) return prep;

          homologacionActual = prep.homologacion;
        }

        const signatureActual =
          signatureParam ||
          buildNrCurrentCalculationSignature(homologacionActual);
        const cotizaPayload = buildNrCotizaPayload(homologacionActual);

        if (
          !cotizacionParaGuardar &&
          nrCotizacion &&
          nrLastCotizaSignature === signatureActual
        ) {
          cotizacionParaGuardar = nrCotizacion;
        }

        if (!cotizacionParaGuardar) {
          const cotizaData = await nrApiPost(
            NR_ENDPOINTS.cotiza,
            cotizaPayload,
          );

          cotizacionParaGuardar = cotizaData;
          setNrLastCotizaRequest(cotizaPayload);
          setNrLastCotizaSignature(signatureActual);
          setNrCotizacion(cotizacionParaGuardar);

          const comisionCalculada = nrGetOpeningCommission(
            cotizacionParaGuardar,
          );
          setMontoComision(String(comisionCalculada || 0));
          setMontoComisionDisplay(
            formatInputCurrency(comisionCalculada || 0),
          );
        }

        const payload = buildNrGuardarCotizacionPayload(
          homologacionActual,
          cotizacionParaGuardar,
        );
        const data = await nrApiPost(
          NR_ENDPOINTS.guardarCotizacion,
          payload,
        );
        const idCotizacion = data?.idCotizacion || "";
        // Nuevo campo de la respuesta de POST /api/v1/quotations: el
        // identificador que debe usarse en la pantalla de búsqueda de
        // cotizaciones (sustituye al idCotizacion interno de Procotiza).
        const idCotizacionPortal = String(
          data?.idCotizacionPortal || data?.IdCotizacionPortal || "",
        ).trim();
        const saveMessage = String(
          data?.log?.respuesta || "",
        ).trim();

        if (!idCotizacion || Number(idCotizacion) <= 0) {
          throw new Error(
            saveMessage ||
              "NR no regresó un idCotizacion válido al guardar.",
          );
        }

        setNrCotizacionGuardadaId(String(idCotizacion));
        setNrCotizacionPortalId(idCotizacionPortal);
        setNrLastSavedSignature(signatureActual);
        setNrPdfBase64("");
        setShowNrPdfViewer(false);
        patchNrFormData({
          nr_cotizacion_id: String(idCotizacion),
          nr_cotizacion_portal_id: idCotizacionPortal,
        });

        // Estos campos también se guardan como columnas planas (no sólo
        // dentro del JSON de entrevista): idCotizacion, idCotizacionPortal
        // (para la pantalla de búsqueda de cotizaciones) y la fecha de
        // guardado (tomada del log de NR si viene, si no la fecha local).
        if (selectedMailDataRef.current?.id) {
          const fechaGuardado =
            data?.log?.fechaRegistro || new Date().toISOString();
          fetch(apiUpdateEstadoUrl, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              access_token: accessToken,
              venta_id: selectedMailDataRef.current.id,
              procotiza_id_cotizacion: String(idCotizacion),
              procotiza_id_cotizacion_portal: idCotizacionPortal,
              procotiza_guardado_fecha: fechaGuardado,
            }),
          }).catch((error) => {
            console.error(
              "No se pudo persistir los datos de guardado NR:",
              error,
            );
          });
        }

        if (!silent) {
          Swal.fire({
            icon: "success",
            title: "Cotización NR guardada",
            text: `ID de cotización: ${idCotizacion}`,
            timer: 1800,
            showConfirmButton: false,
          });
        }

        return {
          ok: true,
          idCotizacion: String(idCotizacion),
          data,
          cotizacion: cotizacionParaGuardar,
          homologacion: homologacionActual,
          signature: signatureActual,
          request: payload,
        };
      } catch (error) {
        const message =
          error?.message || "No se pudo guardar la cotización NR.";
        setNrLastError(message);

        if (!silent) {
          Swal.fire({
            icon: "error",
            title: "Error guardando NR",
            text: message,
            confirmButtonText: "Aceptar",
          });
        }

        return { ok: false, message };
      } finally {
        setNrGuardarLoading(false);
      }
    },
    [
      accessToken,
      buildNrCotizaPayload,
      buildNrCurrentCalculationSignature,
      buildNrGuardarCotizacionPayload,
      nrApiPost,
      nrCotizacion,
      nrHomologacion,
      nrLastCotizaSignature,
      patchNrFormData,
      resolveNrHomologacion,
    ],
  );

  const handleGenerarPdfNR = useCallback(
    async ({ silent = false, idCotizacion: idCotizacionParam = "" } = {}) => {
      try {
        setNrPdfLoading(true);
        setNrLastError("");

        const signatureActual = buildNrCurrentCalculationSignature();
        let idCotizacion = idCotizacionParam || nrCotizacionGuardadaId;

        if (
          !idCotizacion ||
          nrLastSavedSignature !== signatureActual
        ) {
          const guardarResult = await handleGuardarCotizacionNR({
            silent: true,
          });

          if (!guardarResult?.ok) return guardarResult;

          idCotizacion = guardarResult.idCotizacion;
        }

        const ventaId =
          selectedMailDataRef.current?.id ||
          selectedMailData?.id ||
          formDataRef.current?.venta_id ||
          "";

        const data = await nrApiPost(NR_ENDPOINTS.generarPdf, {
          venta_id: ventaId,
          IdCotizacion: Number(idCotizacion),
        });

        const pdfBase64 = data?.pdfBase64 || "";

        if (!pdfBase64) {
          throw new Error(
            "NR generó respuesta, pero no regresó el PDF en Base64.",
          );
        }

        setNrPdfBase64(pdfBase64);

        // El PDF (base64) y su fecha también se guardan como columnas
        // planas de la venta, para poder recuperarlos después sin tener
        // que volver a pedírselo a NR.
        if (ventaId) {
          fetch(apiUpdateEstadoUrl, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              access_token: accessToken,
              venta_id: ventaId,
              procotiza_pdf_base64: pdfBase64,
              procotiza_pdf_fecha: new Date().toISOString(),
            }),
          }).catch((error) => {
            console.error("No se pudo persistir el PDF NR:", error);
          });
        }

        if (!silent) {
          Swal.fire({
            icon: "success",
            title: "PDF NR generado",
            text: "Ya puedes verlo o descargarlo.",
            timer: 1800,
            showConfirmButton: false,
          });
        }

        return {
          ok: true,
          idCotizacion: String(idCotizacion),
          pdfBase64,
          data,
        };
      } catch (error) {
        const message = error?.message || "No se pudo generar el PDF de NR.";
        setNrLastError(message);

        if (!silent) {
          Swal.fire({
            icon: "error",
            title: "Error generando PDF NR",
            text: message,
            confirmButtonText: "Aceptar",
          });
        }

        return { ok: false, message };
      } finally {
        setNrPdfLoading(false);
      }
    },
    [
      buildNrCurrentCalculationSignature,
      handleGuardarCotizacionNR,
      nrApiPost,
      nrCotizacionGuardadaId,
      nrLastSavedSignature,
      selectedMailData,
    ],
  );

  const handleCotizarGuardarYGenerarPdfNR = useCallback(
    async ({ silent = false } = {}) => {
      const cotizaResult = await handleCotizarConNR({
        silent,
        openProductModal: !silent,
      });

      if (!cotizaResult?.ok) return cotizaResult;

      const guardarResult = await handleGuardarCotizacionNR({
        silent,
        homologacion: cotizaResult.homologacion,
        cotizacionOverride: cotizaResult.data,
        signature: cotizaResult.signature,
      });

      if (!guardarResult?.ok) return guardarResult;

      return handleGenerarPdfNR({
        silent,
        idCotizacion: guardarResult.idCotizacion,
      });
    },
    [
      handleCotizarConNR,
      handleGenerarPdfNR,
      handleGuardarCotizacionNR,
    ],
  );

  const handleOpenPdfNR = useCallback(() => {
    if (!nrPdfDataUrl) {
      Swal.fire({
        icon: "info",
        title: "PDF NR pendiente",
        text: "Primero genera el PDF de NR.",
        confirmButtonText: "Aceptar",
      });
      return;
    }

    setShowNrPdfViewer(true);
  }, [nrPdfDataUrl]);

  const handleDownloadPdfNR = useCallback(() => {
    if (!nrPdfDataUrl) {
      Swal.fire({
        icon: "info",
        title: "PDF NR pendiente",
        text: "Primero genera el PDF de NR.",
        confirmButtonText: "Aceptar",
      });
      return;
    }

    const folio =
      selectedMailDataRef.current?.folio_venta ||
      selectedMailData?.folio_venta ||
      nrCotizacionGuardadaId ||
      formDataRef.current?.venta_id ||
      "cotizacion";

    const link = document.createElement("a");
    link.href = nrPdfDataUrl;
    link.download = `Cotizacion_NR_${folio}.pdf`;
    link.rel = "noopener";
    document.body.appendChild(link);
    link.click();
    link.remove();
  }, [
    nrCotizacionGuardadaId,
    nrPdfDataUrl,
    selectedMailData,
  ]);


  const asignarPlanPorVehiculo = (vehicleTitle) => {
    const normalizedTitle = vehicleTitle?.toLowerCase();
    setSelectedVehicleName(normalizedTitle);

    // Ya no hay paquetes por modelo/marca fuera de Gold Tecámac.
    initialPlans = ordenarPlanesPorOrdenFijo(planInicial);
    return initialPlans;
  };

  const parsePlanesFinanciamiento = useCallback((planesFinanciamiento) => {
    if (!planesFinanciamiento) return [];

    if (Array.isArray(planesFinanciamiento)) {
      return planesFinanciamiento;
    }

    if (typeof planesFinanciamiento === "string") {
      try {
        const parsed = JSON.parse(planesFinanciamiento);
        return Array.isArray(parsed) ? parsed : [];
      } catch (error) {
        console.error("Error parseando planes_financiamiento:", error);
        return [];
      }
    }

    return [];
  }, []);

  const normalizarSeleccionPlanes = useCallback((planes = [], options = {}) => {
    const orderedPlans = ordenarPlanesPorOrdenFijo(
      Array.isArray(planes) ? planes : [],
    );

    // Por defecto se respeta la selección guardada en BD o hecha en la venta actual.
    // Cuando se carga una venta NUEVA sin planes_financiamiento, se puede mandar
    // preserveSelection:false para no heredar el isSelected de la venta anterior.
    const preserveSelection = options?.preserveSelection !== false;

    const preferredSelectedKey = preserveSelection
      ? normalizarNombrePlan(
          options?.preferredSelectedPlan ||
            options?.preferredSelectedKey ||
            selectedPlanKeyRef.current ||
            "",
        )
      : "";

    let selectedIndex = preserveSelection
      ? orderedPlans.findIndex(
          (plan) => plan?.isSelected && !esPlanCliente(plan),
        )
      : -1;

    // Cuando cambia la versión, el contenido de Gold se reconstruye.
    // Si por timing/polling se pierde la bandera isSelected, conservamos
    // la selección anterior por nombre de plan, pero sólo si pertenece a
    // la venta actual o viene desde BD.
    if (selectedIndex < 0 && preferredSelectedKey) {
      selectedIndex = orderedPlans.findIndex(
        (plan) =>
          normalizarNombrePlan(plan) === preferredSelectedKey &&
          !esPlanCliente(plan),
      );
    }

    if (selectedIndex >= 0 && orderedPlans[selectedIndex]) {
      selectedPlanKeyRef.current = normalizarNombrePlan(
        orderedPlans[selectedIndex],
      );
    }

    return orderedPlans.map((plan, index) => ({
      ...plan,
      isSelected: selectedIndex >= 0 ? index === selectedIndex : false,
    }));
  }, []);

  const parseAccesoriosClienteFromVenta = useCallback((venta = {}) => {
    const raw = venta?.accesorios_seleccionados;
    if (!raw) return [];

    try {
      const parsed = typeof raw === "string" ? JSON.parse(raw) : raw;
      if (!Array.isArray(parsed)) return [];

      return parsed
        .map((acc) => {
          const price = toNumber(
            acc?.price ?? acc?.price_promo ?? acc?.price_base ?? 0,
          );

          return {
            ...acc,
            title: acc?.title || acc?.nombre || "",
            description: acc?.description || acc?.descripcion || "",
            price,
            price_base: toNumber(acc?.price_base ?? price),
            price_promo: toNumber(acc?.price_promo ?? price),
            type: acc?.type || acc?.tipo || "accesorios",
            qty: toNumber(acc?.qty ?? 1) || 1,
            source: acc?.source || "cliente",
          };
        })
        .filter((acc) => String(acc.title || "").trim());
    } catch (error) {
      console.error("Error al parsear accesorios_seleccionados:", error);
      return [];
    }
  }, []);

  const getEntrevistaSourceForPlans = useCallback(
    (venta = {}, formDataSource = formDataRef.current || {}) => {
      let entrevistaParsed = {};

      try {
        entrevistaParsed =
          typeof venta?.entrevista === "string"
            ? JSON.parse(venta.entrevista || "{}")
            : venta?.entrevista || {};
      } catch {
        entrevistaParsed = {};
      }

      const cleanedFormData = Object.fromEntries(
        Object.entries(formDataSource || {}).filter(
          ([, value]) => value !== undefined && value !== null && value !== "",
        ),
      );
      const ventaId = String(venta?.id || venta?.venta_id || "");
      const formVentaId = String(cleanedFormData?.venta_id || "");
      const puedeUsarFormData =
        !ventaId || !formVentaId || ventaId === formVentaId;

      return puedeUsarFormData
        ? {
            ...entrevistaParsed,
            ...cleanedFormData,
          }
        : entrevistaParsed;
    },
    [],
  );

  const normalizePlanAccessoryForState = useCallback((acc = {}) => {
    const price = toNumber(
      acc?.price ??
        acc?.price_promo ??
        acc?.price_base ??
        getUnitPrice(acc) ??
        0,
    );
    const priceBase = toNumber(acc?.price_base ?? price);
    const pricePromo = toNumber(acc?.price_promo ?? priceBase ?? price);

    return {
      ...acc,
      title: acc?.title || "",
      description: acc?.description || acc?.descripcion || "",
      price,
      price_base: priceBase,
      price_promo: pricePromo,
      type: acc?.type || "accesorios",
      qty: toNumber(acc?.qty ?? 1) || 1,
    };
  }, []);

  const buildPlanWithAccessories = useCallback(
    (plan = {}, accessories = []) => {
      const uniqueAccessories = [];
      const seen = new Set();

      accessories.forEach((acc) => {
        const normalizedAcc = normalizePlanAccessoryForState(acc);
        const key = norm(normalizedAcc.title || "");
        if (!key || seen.has(key)) return;
        seen.add(key);
        uniqueAccessories.push(normalizedAcc);
      });

      const totalPrice = uniqueAccessories.reduce(
        (sum, acc) =>
          sum +
          toNumber(acc.price ?? acc.price_base ?? 0) *
            (toNumber(acc.qty ?? 1) || 1),
        0,
      );
      const totalPriceBase = uniqueAccessories.reduce(
        (sum, acc) =>
          sum +
          toNumber(acc.price_base ?? acc.price ?? 0) *
            (toNumber(acc.qty ?? 1) || 1),
        0,
      );
      const totalPricePromo = uniqueAccessories.reduce(
        (sum, acc) =>
          sum +
          toNumber(acc.price_promo ?? acc.price ?? 0) *
            (toNumber(acc.qty ?? 1) || 1),
        0,
      );

      return {
        ...plan,
        accessories: uniqueAccessories,
        totalPrice,
        totalPrice_base: totalPriceBase,
        totalPrice_promo: totalPricePromo,
      };
    },
    [normalizePlanAccessoryForState],
  );

  const normalizarTextoPaquetePrecargado = useCallback((value = "") => {
    return normalizarTexto(value)
      .replace(/[-–—_/]+/g, " ")
      .replace(/\bnew\b/g, "")
      .replace(/\bnuevo\b/g, "")
      .replace(/\s+/g, " ")
      .trim();
  }, []);

  const compactarTextoPaquetePrecargado = useCallback(
    (value = "") =>
      normalizarTextoPaquetePrecargado(value)
        .replace(/\s+/g, "")
        .replace(/epower/g, "epower")
        .trim(),
    [normalizarTextoPaquetePrecargado],
  );

  const obtenerDatosVehiculoParaPaquete = useCallback(
    (venta = {}) => {
      const selectedCarVenta = getSelectedCarFromVenta(venta) || {};

      return {
        agId: String(
          getFirstFilledValue(
            venta?.ag_id,
            venta?.agencia_id,
            selectedCarVenta?.ag_id,
            selectedCarVenta?.agencia_id,
            selectedAgencia,
            agenciaActual?.ag_id,
          ),
        ).trim(),
        tipoAuto: normalizarTexto(
          getFirstFilledValue(
            venta?.tipo_auto,
            venta?.tipo_vehiculo,
            venta?.type,
            selectedCarVenta?.tipo_auto,
            selectedCarVenta?.tipo,
            selectedCarVenta?.type,
          ),
        ),
        modelo: getFirstFilledValue(
          venta?.modelo_vehiculo,
          selectedCarVenta?.modelo,
          selectedCarVenta?.model,
          selectedCarVenta?.name,
          selectedCarVenta?.title,
        ),
        version: getFirstFilledValue(
          venta?.version_vehiculo,
          selectedCarVenta?.version,
          selectedCarVenta?.version_vehiculo,
          selectedCarVenta?.trim,
        ),
        anio: String(
          getFirstFilledValue(
            venta?.ano_vehiculo,
            venta?.["año_vehiculo"],
            venta?.anio_vehiculo,
            venta?.anio,
            venta?.["año"],
            venta?.year,
            selectedCarVenta?.ano,
            selectedCarVenta?.["año"],
            selectedCarVenta?.["año_vehiculo"],
            selectedCarVenta?.anio,
            selectedCarVenta?.year,
          ),
        ).replace(/\D/g, ""),
        precioVehiculo: toNumber(
          getFirstFilledValue(
            venta?.precio_vehiculo,
            venta?.precio_contado,
            selectedCarVenta?.precio,
            selectedCarVenta?.price,
          ),
        ),
      };
    },
    [agenciaActual?.ag_id, selectedAgencia],
  );

  const esVentaTecamacPaquetePrecargado = useCallback(
    (venta = {}) => {
      const { agId } = obtenerDatosVehiculoParaPaquete(venta);
      return (
        agId.toLowerCase() === NISSAN_TECAMAC_PRECARGADO_AG_ID.toLowerCase()
      );
    },
    [obtenerDatosVehiculoParaPaquete],
  );

  const coincideTextoPaquete = useCallback(
    (valorActual = "", valorRegla = "") => {
      const actual = compactarTextoPaquetePrecargado(valorActual);
      const regla = compactarTextoPaquetePrecargado(valorRegla);

      if (!actual || !regla) return false;

      return actual === regla;
    },
    [compactarTextoPaquetePrecargado],
  );

  const getNumeroPaquetePrecargadoTecamac = useCallback(
    (venta = {}) => {
      if (!esVentaTecamacPaquetePrecargado(venta)) return null;

      const datosVehiculo = obtenerDatosVehiculoParaPaquete(venta);

      if (datosVehiculo.tipoAuto.includes("seminuevo")) {
        return 6;
      }

      const modeloActual = datosVehiculo.modelo || "";
      const versionActual = datosVehiculo.version || "";
      const anioActual = datosVehiculo.anio || "";

      const regla = GOLD_TECAMAC_PACKAGE_RULES.find((item) => {
        const mismoAnio =
          Boolean(anioActual) &&
          String(item.anio || "").replace(/\D/g, "") === String(anioActual);

        const mismoModelo = coincideTextoPaquete(modeloActual, item.modelo);
        const mismaVersion = coincideTextoPaquete(versionActual, item.version);

        return mismoAnio && mismoModelo && mismaVersion;
      });

      return regla?.paquete || null;
    },
    [
      esVentaTecamacPaquetePrecargado,
      obtenerDatosVehiculoParaPaquete,
      coincideTextoPaquete,
    ],
  );

  const getGoldPreloadedAccessoriesForVenta = useCallback(
    (venta = {}, plan = {}) => {
      const numeroPaquete = getNumeroPaquetePrecargadoTecamac(venta);
      const paqueteTecamac = numeroPaquete
        ? GOLD_TECAMAC_PACKAGES[numeroPaquete]
        : null;

      const esTecamac = esVentaTecamacPaquetePrecargado(venta);
      const accesoriosBase =
        Array.isArray(paqueteTecamac) && paqueteTecamac.length
          ? paqueteTecamac
          : esTecamac
            ? DEFAULT_CURRENT_GOLD_ACCESSORIES
            : Array.isArray(plan?.accessories) && plan.accessories.length
              ? plan.accessories
              : DEFAULT_CURRENT_GOLD_ACCESSORIES;

      return accesoriosBase.map((acc) => {
        const price = toNumber(
          acc?.price ?? acc?.price_promo ?? acc?.price_base,
        );
        const priceBase = toNumber(acc?.price_base ?? price);
        const pricePromo = toNumber(acc?.price_promo ?? price);

        return {
          ...acc,
          price,
          price_base: priceBase,
          price_promo: pricePromo,
          qty: toNumber(acc?.qty ?? 1) || 1,
          source: numeroPaquete
            ? "gold-tecamac"
            : acc?.source || "gold-default",
          paquete_precargado: numeroPaquete || "default",
          ag_id: numeroPaquete
            ? NISSAN_TECAMAC_PRECARGADO_AG_ID
            : acc?.ag_id || "",
        };
      });
    },
    [getNumeroPaquetePrecargadoTecamac, esVentaTecamacPaquetePrecargado],
  );

  const aplicarReglasPlanesCliente = useCallback(
    (
      planes = [],
      venta = selectedMailData,
      formDataSource = formDataRef.current || {},
      options = {},
    ) => {
      const orderedPlans = ordenarPlanesPorOrdenFijo(
        Array.isArray(planes) ? planes : [],
      );
      const preserveEditablePlans = Boolean(options?.preserveEditablePlans);

      const accesoriosCliente = parseAccesoriosClienteFromVenta(venta);
      const respuestas = getEntrevistaSourceForPlans(venta, formDataSource);
      const accesoriosPorRespuestas = getAccesoriosFromAnswers(respuestas).map(
        (acc) => ({
          ...acc,
          source: "answers",
        }),
      );
      const answersSignature = getAccessoryStableSignature(
        accesoriosPorRespuestas,
      );

      return orderedPlans.map((plan) => {
        if (esPlanGold(plan)) {
          const numeroPaqueteGold = getNumeroPaquetePrecargadoTecamac(venta);
          const accesoriosGold = getGoldPreloadedAccessoriesForVenta(
            venta,
            plan,
          );

          return buildPlanWithAccessories(
            {
              ...plan,
              source: numeroPaqueteGold ? "gold-tecamac" : "gold-default",
              paquete_precargado: numeroPaqueteGold || "default",
              ag_id: numeroPaqueteGold
                ? NISSAN_TECAMAC_PRECARGADO_AG_ID
                : plan?.ag_id || "",
            },
            accesoriosGold,
          );
        }

        if (esPlanCliente(plan)) {
          // Plan cliente es sólo visual y se llena con lo que eligió el cliente.
          return buildPlanWithAccessories(plan, accesoriosCliente);
        }

        const planManuallyEdited = isEditablePlanManuallyEdited(plan);
        const persistedManualEdit = isPlanPersistedAsManual(plan);
        const preserveThisEditablePlan =
          preserveEditablePlans || planManuallyEdited || persistedManualEdit;

        if (normalizarNombrePlan(plan).includes("elite")) {
          const currentPlanAccessories = Array.isArray(plan?.accessories)
            ? plan.accessories
            : [];
          const currentPlanSignature = getAccessoryStableSignature(
            currentPlanAccessories,
          );
          const savedAnswersSignature = String(
            plan?.answers_signature ||
              plan?.answersSignature ||
              plan?.elite_answers_signature ||
              "",
          ).trim();

          // Elite se arma desde respuestas sólo mientras sigue siendo automático.
          // Si el asesor ya agregó/quitó algo, se marca en planes_financiamiento
          // y desde ese momento se respeta BD, incluso después de refrescar.
          // Para snapshots viejos sin bandera, si el contenido guardado ya no
          // coincide con las respuestas actuales, lo tratamos como edición manual
          // para no volver a meter lo que el asesor quitó.
          const legacyManualSnapshot =
            preserveEditablePlans &&
            currentPlanAccessories.length > 0 &&
            !savedAnswersSignature &&
            currentPlanSignature !== answersSignature;

          const preserveEliteFromBD =
            planManuallyEdited || persistedManualEdit || legacyManualSnapshot;

          const elitePlanBase = {
            ...plan,
            source: preserveEliteFromBD ? plan?.source || "manual" : "answers",
            answers_signature: answersSignature,
            answersSignature,
            manual_edit: preserveEliteFromBD,
            manuallyEdited: preserveEliteFromBD,
            edited_by_advisor: preserveEliteFromBD,
            editedByAdvisor: preserveEliteFromBD,
          };

          return buildPlanWithAccessories(
            elitePlanBase,
            preserveEliteFromBD
              ? currentPlanAccessories
              : accesoriosPorRespuestas,
          );
        }

        if (normalizarNombrePlan(plan).includes("platinum")) {
          // Platinum inicia vacío, pero después de modificarlo no se reinicia.
          return buildPlanWithAccessories(
            plan,
            preserveThisEditablePlan ? plan?.accessories || [] : [],
          );
        }

        return plan;
      });
    },
    [
      selectedMailData,
      parseAccesoriosClienteFromVenta,
      getEntrevistaSourceForPlans,
      buildPlanWithAccessories,
      isEditablePlanManuallyEdited,
      isPlanPersistedAsManual,
      getAccessoryStableSignature,
      getGoldPreloadedAccessoriesForVenta,
      getNumeroPaquetePrecargadoTecamac,
    ],
  );

  // Efecto para manejar los accesorios seleccionados por el cliente.
  // El Plan cliente es únicamente visual: se llena con accesorios_seleccionados,
  // pero no se modifica con add/remove ni se puede seleccionar como plan financiero.
  useEffect(() => {
    const accesoriosCliente = parseAccesoriosClienteFromVenta(selectedMailData);

    const processedAccessories = accesoriosCliente.map((acc) => ({
      title: acc.title,
      status: "Disponible",
      price: `$${toNumber(acc.price ?? acc.price_base ?? 0).toLocaleString("es-MX")}`,
      description: acc.description,
      type: acc.type,
    }));

    setPlans(processedAccessories);

    const planMutationGuardActive = isPlanMutationGuardActive(
      selectedMailData?.id,
    );

    setPlansState((prevPlans) => {
      if (planMutationGuardActive) {
        return prevPlans;
      }

      const planesDesdeBD = parsePlanesFinanciamiento(
        selectedMailData?.planes_financiamiento,
      );
      const basePlansForRules = planesDesdeBD.length
        ? planesDesdeBD
        : prevPlans;

      const ventaIdActual = String(selectedMailData?.id || "");
      const seleccionPerteneceVentaActual =
        Boolean(selectedPlanVentaIdRef.current) &&
        String(selectedPlanVentaIdRef.current) === ventaIdActual;
      const selectedPlanKeyFromBD = normalizarNombrePlan(
        planesDesdeBD.find(
          (plan) => plan?.isSelected && !esPlanCliente(plan),
        ) || "",
      );
      const selectedPlanKeyBefore = seleccionPerteneceVentaActual
        ? normalizarNombrePlan(
            Array.isArray(prevPlans)
              ? prevPlans.find(
                  (plan) => plan?.isSelected && !esPlanCliente(plan),
                )
              : "",
          )
        : "";
      const preserveSelection =
        planesDesdeBD.length > 0 || seleccionPerteneceVentaActual;

      return normalizarSeleccionPlanes(
        aplicarReglasPlanesCliente(
          basePlansForRules,
          selectedMailData,
          formDataRef.current || {},
          {
            preserveEditablePlans: planesDesdeBD.length > 0,
          },
        ),
        {
          preferredSelectedKey: selectedPlanKeyFromBD || selectedPlanKeyBefore,
          preserveSelection,
        },
      );
    });
  }, [
    selectedMailData?.id,
    selectedMailData?.accesorios_seleccionados,
    selectedMailData?.entrevista,
    selectedMailData?.entrevista_nissan,
    selectedMailData?.modelo_vehiculo,
    selectedMailData?.version_vehiculo,
    selectedMailData?.ano_vehiculo,
    selectedMailData?.precio_vehiculo,
    selectedMailData?.tipo_auto,
    selectedMailData?.ag_id,
    parseAccesoriosClienteFromVenta,
    aplicarReglasPlanesCliente,
    normalizarSeleccionPlanes,
    parsePlanesFinanciamiento,
    isPlanMutationGuardActive,
  ]);

  const [plansLoaded, setPlansLoaded] = useState(false);

  useEffect(() => {
    if (!selectedMailData?.modelo_vehiculo) return;
    if (isPlanMutationGuardActive(selectedMailData?.id)) return;

    const planesDesdeBD = parsePlanesFinanciamiento(
      selectedMailData?.planes_financiamiento,
    );

    // Si la venta ya trae planes desde BD, preparePlansState es quien manda.
    // No usamos el draft local para no pisar isSelected guardado en planes_financiamiento.
    if (planesDesdeBD.length) return;

    if (
      plansLoaded &&
      String(plansLoadedVentaIdRef.current || "") ===
        String(selectedMailData?.id || "")
    ) {
      return;
    }

    const nuevoPlan = asignarPlanPorVehiculo(selectedMailData.modelo_vehiculo);
    const normalizedPlan = normalizarSeleccionPlanes(
      aplicarReglasPlanesCliente(nuevoPlan, selectedMailData),
      {
        preserveSelection:
          Boolean(selectedPlanVentaIdRef.current) &&
          String(selectedPlanVentaIdRef.current) ===
            String(selectedMailData?.id || ""),
      },
    );

    setPlansState(normalizedPlan);
    setBasePlansState(JSON.parse(JSON.stringify(normalizedPlan)));
  }, [
    selectedMailData?.id,
    selectedMailData?.modelo_vehiculo,
    selectedMailData?.planes_financiamiento,
    plansLoaded,
    parsePlanesFinanciamiento,
    normalizarSeleccionPlanes,
    aplicarReglasPlanesCliente,
    isPlanMutationGuardActive,
  ]);

  const preparePlansState = useCallback(
    (venta = {}) => {
      const planesDesdeBD = parsePlanesFinanciamiento(
        venta?.planes_financiamiento,
      );

      if (planesDesdeBD.length) {
        return normalizarSeleccionPlanes(
          aplicarReglasPlanesCliente(
            planesDesdeBD,
            venta,
            formDataRef.current || {},
            {
              preserveEditablePlans: true,
            },
          ),
        );
      }

      const planesPorModelo = venta?.modelo_vehiculo
        ? asignarPlanPorVehiculo(venta.modelo_vehiculo)
        : initialPlans;

      return normalizarSeleccionPlanes(
        aplicarReglasPlanesCliente(planesPorModelo, venta),
        { preserveSelection: false },
      );
    },
    [
      parsePlanesFinanciamiento,
      normalizarSeleccionPlanes,
      aplicarReglasPlanesCliente,
    ],
  );

  useEffect(() => {
    if (!selectedMailData?.id || plansLoaded) return;
    if (isPlanMutationGuardActive(selectedMailData?.id)) return;

    const normalizedPlans = preparePlansState(selectedMailData);
    const selectedIndex = normalizedPlans.findIndex(
      (plan) => plan?.isSelected && !esPlanCliente(plan),
    );

    setPlansState(normalizedPlans);
    setBasePlansState(JSON.parse(JSON.stringify(normalizedPlans)));
    plansLoadedVentaIdRef.current = String(selectedMailData.id || "");
    setPlansLoaded(true);

    if (selectedIndex >= 0 && normalizedPlans[selectedIndex]) {
      const selectedPlanFromBD = normalizedPlans[selectedIndex];
      selectedPlanVentaIdRef.current = String(selectedMailData.id || "");

      setSelectedPlan(selectedPlanFromBD);
      setSelectedPlanFinal(selectedIndex);
      setSelectedPlanIndex(selectedIndex);

      const precioVeh = toNumber(selectedMailData?.precio_vehiculo || 0);
      const planTotal = getPlanAccessoriesTotalForFinancing(selectedPlanFromBD);

      setPrecioTotal(Math.round(precioVeh + planTotal));
    } else {
      setSelectedPlan(null);
      setSelectedPlanFinal(null);
      setSelectedPlanIndex(null);
      setPrecioTotal(toNumber(selectedMailData?.precio_vehiculo || 0));
    }
  }, [
    selectedMailData?.id,
    selectedMailData?.planes_financiamiento,
    selectedMailData?.modelo_vehiculo,
    plansLoaded,
    preparePlansState,
    isPlanMutationGuardActive,
  ]);

  /* useEffect(() => {
     const plans = preparePlansState(selectedMailData);
     setPlansState(plans);
   }, [selectedMailData]);*/

  const handleNextStep = () => {
    handleStepChange(step + 1);
  };

  const handlePreviousStep = () => {
    handleStepChange(step - 1);
  };

  // Clona para no reusar la misma referencia del MAP
  const cloneAcc = (acc) => ({
    ...acc,
    price: toNumber(acc.price ?? acc.price_promo ?? acc.price_base),
    qty: toNumber(acc.qty ?? 1),
  });

  function getAccesoriosFromAnswers(formData = {}) {
    const accs = [];
    const addAcc = (key) => {
      const acc = ACCESORIOS_MAP[key];
      if (acc) accs.push(cloneAcc(acc));
    };

    const calle = normalizarTexto(formData.condiciones_calle_extra || "");
    const garantiaSeminuevo = normalizarTexto(
      formData.garantia_seminuevo || "",
    );

    if (
      ["mala", "malas", "regular", "regulares"].includes(calle) ||
      formData.interes_llantas_danadas === "Si"
    ) {
      addAcc("PROTECCIÓN DE LLANTAS POR $4,000.00 1 AÑO");
    }

    if (formData.interes_llaves === "Si") {
      addAcc("Cobertura de Llaves");
    }

    if (formData.ha_dejado_taller === "Si") {
      addAcc("Garantía de Movilidad");
    }

    if (garantiaSeminuevo.includes("1")) {
      addAcc("Garantía Mecánica 1 Año");
    } else if (garantiaSeminuevo.includes("2")) {
      addAcc("Garantía Mecánica 2 Años");
    } else if (garantiaSeminuevo.includes("3")) {
      addAcc("Garantía Mecánica 3 Años");
    }

    if (formData.desea_polarizado === "Si") {
      addAcc("Pelicula");
    }

    if (formData.desea_kit_emergencia === "Si") {
      addAcc("Caja de Herramientas");
    }

    if (formData.tiempo_real === "Si" || formData.respaldo_auto === "Si") {
      addAcc("Localizador 2 Años");
    }

    if (formData.usa_en_lodo === "Si") {
      addAcc("Tapetes Uso Rudo");
    }

    return accs;
  }

  // Función centralizada para calcular todos los valores financieros con interés del 21%
  const calculateFinancingValues = useCallback(
    (params) => {
      const {
        basePrice,
        downPaymentAmount = null,
        downPaymentPercentage = null,
        monthlyPayment = null,
        financingMonths: monthsParam = financingMonths,
        origin = "",
      } = params;

      const months = Number(monthsParam) || 0;
      const isCashMSI =
        typeof origin === "string" &&
        origin.toLowerCase().includes("pago contado");

      // base inválida -> objeto completo y seguro
      if (!basePrice || Number(basePrice) <= 0) {
        return {
          downPaymentAmount: 0,
          downPaymentPercentage: 0,
          monthlyPayment: 0,
          financedAmount: 0,
          tasa: isCashMSI ? 0 : TASA_FINANCIAMIENTO_PORCENTAJE,
          months,
        };
      }

      // ✅ CONTADO (MSI): sin tasa, sin interés.
      // basePrice = (vehículo + accesorios)
      // downPaymentAmount = vehículo (100% pagado)
      // financedAmount = accesorios (a MSI)
      if (isCashMSI) {
        const dp = Math.round(Number(downPaymentAmount ?? basePrice) || 0);
        const financed = Math.max(Math.round(Number(basePrice) - dp), 0);

        const monthly = months > 0 ? Math.round(financed / months) : 0;
        const pct =
          basePrice > 0 ? Math.round((dp / basePrice) * 100 * 100) / 100 : 0;

        return {
          downPaymentAmount: dp,
          downPaymentPercentage: pct, // % real del total (vehículo vs total)
          monthlyPayment: monthly,
          financedAmount: financed,
          tasa: 0, // 👈 contado = 0%
          months,
        };
      }

      // ✅ CRÉDITO: cálculo normal con interés
      const annualInterestRate = TASA_ANUAL_FINANCIAMIENTO;
      const monthlyInterestRate = annualInterestRate / 12;
      const ventaActual = selectedMailDataRef.current || selectedMailData || {};
      const selectedCar = getSelectedCarFromVenta(ventaActual);
      const vehicleBasePrice =
        toNumber(ventaActual?.precio_vehiculo) ||
        toNumber(selectedCar?.price) ||
        toNumber(selectedCar?.precio) ||
        toNumber(precioVehiculo) ||
        Number(basePrice);
      const minDownPaymentPct = getMinDownPaymentPercentage(ventaActual);
      const minDownPaymentAmount = Math.round(
        (vehicleBasePrice * minDownPaymentPct) / 100,
      );

      const calculateMonthlyPaymentWithInterest = (principal, n) => {
        if (n <= 0 || monthlyInterestRate <= 0) return 0;
        const numerator =
          monthlyInterestRate * Math.pow(1 + monthlyInterestRate, n);
        const denominator = Math.pow(1 + monthlyInterestRate, n) - 1;
        return principal * (numerator / denominator);
      };

      const calculatePrincipalFromPayment = (pay, n) => {
        if (n <= 0 || monthlyInterestRate <= 0) return 0;
        const numerator = Math.pow(1 + monthlyInterestRate, n) - 1;
        const denominator =
          monthlyInterestRate * Math.pow(1 + monthlyInterestRate, n);
        return pay * (numerator / denominator);
      };

      let calculatedDownPayment = downPaymentAmount;
      let calculatedPercentage = downPaymentPercentage;
      let calculatedMonthly = monthlyPayment;

      // Escenario 1: porcentaje -> enganche y mensualidad.
      // El porcentaje se toma sobre el vehículo, no sobre el total con accesorios,
      // para que al seleccionar un paquete no cambie el enganche en el último segundo.
      if (calculatedPercentage !== null && calculatedDownPayment === null) {
        calculatedPercentage = Math.max(
          minDownPaymentPct,
          Math.min(Number(calculatedPercentage) || minDownPaymentPct, 100),
        );
        calculatedDownPayment = (calculatedPercentage / 100) * vehicleBasePrice;
        const financedAmount = basePrice - calculatedDownPayment;
        calculatedMonthly = calculateMonthlyPaymentWithInterest(
          financedAmount,
          months,
        );
      }
      // Escenario 2: enganche -> porcentaje y mensualidad
      else if (
        calculatedDownPayment !== null &&
        calculatedPercentage === null
      ) {
        calculatedPercentage =
          vehicleBasePrice > 0
            ? (calculatedDownPayment / vehicleBasePrice) * 100
            : (calculatedDownPayment / basePrice) * 100;
        const financedAmount = basePrice - calculatedDownPayment;
        calculatedMonthly = calculateMonthlyPaymentWithInterest(
          financedAmount,
          months,
        );
      }
      // Escenario 3: mensualidad -> enganche y porcentaje
      else if (calculatedMonthly !== null && calculatedDownPayment === null) {
        const maxFinancedAmount = calculatePrincipalFromPayment(
          calculatedMonthly,
          months,
        );
        calculatedDownPayment = Math.max(basePrice - maxFinancedAmount, 0);
        calculatedPercentage =
          vehicleBasePrice > 0
            ? (calculatedDownPayment / vehicleBasePrice) * 100
            : (calculatedDownPayment / basePrice) * 100;
      }
      // Escenario 4: nada -> usar % actual
      else if (
        calculatedDownPayment === null &&
        calculatedPercentage === null &&
        calculatedMonthly === null
      ) {
        calculatedPercentage = Math.max(
          minDownPaymentPct,
          Math.min(Number(downPaymentPercentage) || minDownPaymentPct, 100),
        );
        calculatedDownPayment = (calculatedPercentage / 100) * vehicleBasePrice;
        const financedAmount = basePrice - calculatedDownPayment;
        calculatedMonthly = calculateMonthlyPaymentWithInterest(
          financedAmount,
          months,
        );
      }

      const requestedMonthlyPayment =
        monthlyPayment !== null && monthlyPayment !== undefined
          ? Number(monthlyPayment)
          : null;

      const rawCalculatedDownPayment = Number(calculatedDownPayment) || 0;
      const hasRequestedMonthlyPayment =
        requestedMonthlyPayment !== null &&
        Number.isFinite(requestedMonthlyPayment) &&
        requestedMonthlyPayment > 0;

      // Cuando la mensualidad capturada no es posible con las reglas actuales
      // (por ejemplo, requeriría enganche menor al mínimo o mayor al total),
      // NO dejamos pegada esa mensualidad. Se ajusta el enganche al límite
      // permitido y se recalcula la mensualidad real para ese plazo.
      const requestedMonthlyIsFeasible =
        hasRequestedMonthlyPayment &&
        rawCalculatedDownPayment >= minDownPaymentAmount &&
        rawCalculatedDownPayment <= basePrice;

      calculatedDownPayment = Math.min(
        basePrice,
        Math.max(rawCalculatedDownPayment, minDownPaymentAmount),
      );

      calculatedPercentage =
        vehicleBasePrice > 0
          ? (calculatedDownPayment / vehicleBasePrice) * 100
          : (calculatedDownPayment / basePrice) * 100;

      const financedAfterMin = Math.max(basePrice - calculatedDownPayment, 0);

      if (requestedMonthlyIsFeasible) {
        calculatedMonthly = requestedMonthlyPayment;
      } else {
        calculatedMonthly = calculateMonthlyPaymentWithInterest(
          financedAfterMin,
          months,
        );
      }

      // Redondeos
      calculatedDownPayment = Math.round(Number(calculatedDownPayment) || 0);
      calculatedPercentage =
        Math.round((Number(calculatedPercentage) || 0) * 100) / 100;
      calculatedMonthly = Math.round(Number(calculatedMonthly) || 0);

      const financedAmountFinal = Math.max(
        basePrice - calculatedDownPayment,
        0,
      );

      return {
        downPaymentAmount: calculatedDownPayment,
        downPaymentPercentage: calculatedPercentage,
        monthlyPayment: calculatedMonthly,
        financedAmount: financedAmountFinal,
        tasa: TASA_FINANCIAMIENTO_PORCENTAJE, // 👈 crédito = 21%
        months,
      };
    },
    [
      downPaymentPercentage,
      financingMonths,
      precioVehiculo,
      selectedMailData,
      getMinDownPaymentPercentage,
    ],
  );

  // Función para actualizar todos los estados de forma sincronizada
  const updateAllFinancingStates = useCallback((values, options = {}) => {
    const { force = false, skipFormData = false } = options || {};
    const activeField = activeFinancingEditRef.current;

    // Si el usuario está capturando enganche, mensualidad o moviendo la barra,
    // no se pisan los inputs con cálculos externos hasta que haga blur o termine el cambio.
    if (activeField && !force) {
      return;
    }

    const {
      downPaymentAmount,
      downPaymentPercentage: newPercentage,
      monthlyPayment: newMonthly,
    } = values;

    setDownPaymentPercentage(newPercentage);
    setMonthlyPayment(newMonthly);

    const formattedDownPayment = formatNumber(String(downPaymentAmount || 0));
    const formattedMonthly = formatNumber(String(newMonthly || 0));

    if (!skipFormData) {
      setFormData((prev) => {
        const next = {
          ...prev,
          enganche: formattedDownPayment,
          engancheEditable: formattedDownPayment,
          mensualidad_buscada: formattedMonthly,
        };

        formDataRef.current = next;
        return next;
      });
    }

    setMonthlyPaymentDraft(formattedMonthly);
  }, []);

  // Función para obtener el precio base (vehículo o total según disponibilidad)
  const getBasePrice = useCallback(() => {
    const vehiclePrice = toNumber(
      precioVehiculo ||
        selectedMailDataRef.current?.precio_vehiculo ||
        selectedMailData?.precio_vehiculo ||
        0,
    );

    if (selectedPlanForFinancing) {
      return precioTotalConPlanActual;
    }

    if (precioTotal) {
      return toNumber(precioTotal);
    }

    return vehiclePrice;
  }, [
    precioTotal,
    precioTotalConPlanActual,
    precioVehiculo,
    selectedMailData?.precio_vehiculo,
    selectedPlanForFinancing,
  ]);

  const getEngancheActual = useCallback(
    (baseFallback = 0) => {
      const fd = formDataRef.current || {};
      const venta = selectedMailDataRef.current || selectedMailData || {};
      const ventaId = String(venta?.id || fd?.venta_id || "");
      const engancheCValido =
        String(engancheCVentaIdRef.current || "") === ventaId ? engancheC : "";

      const manualEngancheValido =
        String(manualEngancheVentaIdRef.current || "") === ventaId
          ? manualEngancheValueRef.current
          : "";

      const candidatos = [
        manualEngancheValido,
        engancheCValido,
        fd.engancheEditable,
        fd.enganche,
        venta.enganche,
        venta.engancheEditable,
      ];

      for (const value of candidatos) {
        const numberValue = toNumber(value);

        if (numberValue > 0) {
          return Math.round(numberValue);
        }
      }

      const base = toNumber(baseFallback || getBasePrice() || 0);

      return getMinDownPaymentAmount(base);
    },
    [engancheC, selectedMailData, getBasePrice, getMinDownPaymentAmount],
  );

  const handleFinancingMonthsChange = async (e) => {
    const next = Number(e?.target?.value);
    const allowed = isCash
      ? CASH_MONTHS_BASE
      : getAllowedCreditMonths(condicionesFinanciamientoCredito);
    const safeMonths = allowed.includes(next)
      ? next
      : normalizeFinancingMonths(next, isCash);

    startFinancingEdit("plazo_meses");

    const ventaActual = selectedMailDataRef.current || selectedMailData;
    const ventaId = String(
      ventaActual?.id || formDataRef.current?.venta_id || "",
    );
    releaseManualFinancingModalSaved(ventaId);

    // Se marca desde el primer momento para que el polling no regrese el select
    // al valor anterior mientras la API confirma el cambio.
    if (ventaId) {
      markLocalFinancingPatch(ventaId, {
        meses_financiamiento: safeMonths,
        plazo_meses: String(safeMonths),
      });
    }

    setFinancingMonths(safeMonths);
    setFormData((prev) => {
      const nextFormData = {
        ...prev,
        plazo_meses: String(safeMonths),
        meses_financiamiento: String(safeMonths),
      };

      formDataRef.current = nextFormData;
      return nextFormData;
    });

    setSelectedMailData((prev) =>
      prev && String(prev.id || "") === String(ventaId || "")
        ? {
            ...prev,
            meses_financiamiento: safeMonths,
            plazo_meses: String(safeMonths),
          }
        : prev,
    );

    if (
      selectedMailDataRef.current &&
      String(selectedMailDataRef.current.id || "") === String(ventaId || "")
    ) {
      selectedMailDataRef.current = {
        ...selectedMailDataRef.current,
        meses_financiamiento: safeMonths,
        plazo_meses: String(safeMonths),
      };
    }

    const basePrice = getBasePrice();
    if (!basePrice || basePrice <= 0) {
      if (ventaId) {
        try {
          await guardarFinanciamientoSnapshotBD({
            venta_id: ventaId,
            meses_financiamiento: safeMonths,
            plazo_meses: String(safeMonths),
          });
        } catch (error) {
          console.error("Error guardando meses de financiamiento:", error);
        }
      }

      finishFinancingEdit("plazo_meses");
      return;
    }

    if (isCash) {
      const planForExtras =
        selectedPlanIndex !== null && plansState?.[selectedPlanIndex]
          ? plansState[selectedPlanIndex]
          : selectedPlanForFinancing || selectedPlan;

      const accesoriosTotal = Math.round(
        (planForExtras?.accessories ?? []).reduce((sum, acc) => {
          const price = toNumber(getUnitPrice(acc) ?? 0);
          const qty = toNumber(acc?.qty ?? 1);
          return sum + price * qty;
        }, 0),
      );

      const mensualidadMSI = safeMonths
        ? Math.round(accesoriosTotal / safeMonths)
        : 0;

      setMensualidadC(String(mensualidadMSI));
      setMensualidadDisplay(formatInputCurrency(mensualidadMSI));

      await updateFinancingData({
        financingMonths: safeMonths,
        meses_financiamiento: safeMonths,
        mensualidad: mensualidadMSI,
      });

      finishFinancingEdit("plazo_meses");
      return;
    }

    // Al cambiar meses, la base debe ser el enganche ACTUAL.
    // No mantenemos pegada la mensualidad que el usuario capturó antes, porque
    // si cambia el plazo, naturalmente cambia la mensualidad para ese mismo enganche.
    const engancheActual = getEngancheActual(basePrice);
    const values = calculateFinancingValues({
      basePrice,
      downPaymentAmount: engancheActual,
      financingMonths: safeMonths,
      origin: "handleFinancingMonthsChange",
    });

    const mensualidadFinal = values.monthlyPayment;

    updateAllFinancingStates(values, { force: true });

    engancheCVentaIdRef.current = ventaId;
    manualEngancheVentaIdRef.current = ventaId;
    manualEngancheValueRef.current = String(values.downPaymentAmount);

    setEngancheC(String(values.downPaymentAmount));
    setEngancheDisplay(formatInputCurrency(values.downPaymentAmount));
    setMensualidadC(String(mensualidadFinal));
    setMensualidadDisplay(formatInputCurrency(mensualidadFinal));
    setManualMonthlyOverride(false);

    await updateFinancingData({
      financingMonths: safeMonths,
      meses_financiamiento: safeMonths,
      enganche: values.downPaymentAmount,
      porcentajeEnganche: values.downPaymentPercentage,
      mensualidad: mensualidadFinal,
    });

    finishFinancingEdit("plazo_meses");
  };

  const handleFinancingMonthsChangeC = (e) => {
    // Modal de cotización: manual puro.
    // No mueve el select general, no recalcula y no manda a BD hasta Guardar.
    const nextMonths = String(e?.target?.value || "");
    const ventaId = String(
      selectedMailDataRef.current?.id || formDataRef.current?.venta_id || "",
    );

    isEditingFinancingModalRef.current = true;
    isUserEditing.current = true;
    setManualMonthlyOverride(true);

    // Evita que un polling o efecto automático vuelva a pintar el mes anterior
    // mientras el asesor sigue capturando manualmente el modal.
    if (ventaId) {
      manualFinancingModalGuardRef.current = {
        ventaId,
        until: Date.now() + 60000,
      };
    }

    setModalFinancingMonthsManual(nextMonths, { dirty: true });
  };

  const commitDownPaymentPercentage = (percentageValue) => {
    const minPct = getMinDownPaymentPercentage();
    const percentage = Math.max(
      minPct,
      Math.min(Number(percentageValue) || minPct, 100),
    );
    const basePrice = getBasePrice();

    if (basePrice <= 0) {
      finishFinancingEdit("porcentaje_enganche");
      return;
    }

    setUserEditedEnganche(true);
    setManualMonthlyOverride(false);

    const values = calculateFinancingValues({
      basePrice,
      downPaymentPercentage: percentage,
      financingMonths,
      origin: "commitDownPaymentPercentage",
    });

    updateAllFinancingStates(values, { force: true });

    const ventaActual = selectedMailDataRef.current || selectedMailData;
    const ventaId = String(ventaActual?.id || "");
    engancheCVentaIdRef.current = ventaId;
    manualEngancheVentaIdRef.current = ventaId;
    manualEngancheValueRef.current = String(values.downPaymentAmount);

    if (ventaId) {
      markLocalFinancingPatch(ventaId, {
        enganche: values.downPaymentAmount,
        engancheEditable: values.downPaymentAmount,
        porcentaje_enganche: values.downPaymentPercentage,
        mensualidad_estimacion: values.monthlyPayment,
        meses_financiamiento: financingMonths,
        plazo_meses: String(financingMonths),
      });
    }

    setEngancheC(String(values.downPaymentAmount));
    setEngancheDisplay(formatInputCurrency(values.downPaymentAmount));
    setMensualidadC(String(values.monthlyPayment));
    setMensualidadDisplay(formatInputCurrency(values.monthlyPayment));

    if (ventaActual?.id) {
      mergeAsesorDraft(ventaActual.id, {
        formData: {
          ...(loadAsesorDraft(ventaActual.id)?.formData || {}),
          ...(formDataRef.current || {}),
          enganche: formatNumber(String(values.downPaymentAmount)),
          engancheEditable: formatNumber(String(values.downPaymentAmount)),
          mensualidad_buscada: formatNumber(String(values.monthlyPayment)),
          plazo_meses: String(financingMonths),
        },
        engancheC: String(values.downPaymentAmount),
        engancheDisplay: formatInputCurrency(values.downPaymentAmount),
        downPaymentPercentage: values.downPaymentPercentage,
        mensualidadC: String(values.monthlyPayment),
        mensualidadDisplay: formatInputCurrency(values.monthlyPayment),
        financingMonths,
        manualMonthlyOverride: false,
      });

      if (financingUpdateTimeoutRef.current) {
        clearTimeout(financingUpdateTimeoutRef.current);
      }

      financingUpdateTimeoutRef.current = setTimeout(() => {
        updateFinancingData({
          enganche: values.downPaymentAmount,
          porcentajeEnganche: values.downPaymentPercentage,
          mensualidad: values.monthlyPayment,
        });
      }, 450);
    }

    downPaymentPercentageDraftRef.current = null;
    isDownPaymentDraggingRef.current = false;
    setDownPaymentPercentageDraftValue(null);
    finishFinancingEdit("porcentaje_enganche");
  };

  // Manejador para la barra de porcentaje de enganche.
  // Mientras se arrastra, sólo actualiza un draft visual local.
  // No recalcula ni guarda hasta que el usuario suelta la barra; así se evita
  // el rebote visual causado por polling, efectos o commits intermedios.
  const handleDownPaymentChange = (e) => {
    const minPct = getMinDownPaymentPercentage();
    const percentage = Math.max(
      minPct,
      Math.min(Number(e.target.value) || minPct, 100),
    );

    startFinancingEdit("porcentaje_enganche");
    keepUserEditingBriefly(12000);
    setUserEditedEnganche(true);
    setManualMonthlyOverride(false);

    isDownPaymentDraggingRef.current = true;
    downPaymentPercentageDraftRef.current = percentage;
    setDownPaymentPercentageDraftValue(percentage);

    if (downPaymentCommitTimeoutRef.current) {
      clearTimeout(downPaymentCommitTimeoutRef.current);
      downPaymentCommitTimeoutRef.current = null;
    }
  };

  const handleDownPaymentCommit = () => {
    if (downPaymentCommitTimeoutRef.current) {
      clearTimeout(downPaymentCommitTimeoutRef.current);
      downPaymentCommitTimeoutRef.current = null;
    }

    const hasDraft = downPaymentPercentageDraftRef.current !== null;
    const percentageToCommit = hasDraft
      ? downPaymentPercentageDraftRef.current
      : downPaymentPercentage;

    downPaymentPercentageDraftRef.current = null;
    isDownPaymentDraggingRef.current = false;
    setDownPaymentPercentageDraftValue(null);

    if (!hasDraft && activeFinancingEditRef.current !== "porcentaje_enganche") {
      return;
    }

    commitDownPaymentPercentage(percentageToCommit);
  };

  const getVisibleDownPaymentPercentage = () => {
    const minPct = getMinDownPaymentPercentage();
    const rawValue =
      downPaymentPercentageDraftValue !== null &&
      downPaymentPercentageDraftValue !== undefined
        ? downPaymentPercentageDraftValue
        : downPaymentPercentage;

    return Math.max(minPct, Math.min(100, Number(rawValue) || minPct));
  };

  // Función mejorada para commit de edición de mensualidad
  const commitMonthlyEdit = () => {
    setIsEditingMonthly(false);

    const cleaned = monthlyPaymentDraft.replace(/,/g, "");
    const draftNumber = Number(cleaned);

    if (Number.isNaN(draftNumber) || draftNumber <= 0) return;

    applyMonthlyPayment(draftNumber);
  };

  // Función mejorada para aplicar mensualidad
  const applyMonthlyPayment = (monthly) => {
    const basePrice = getBasePrice();
    const monthlyNumber = toNumber(monthly);

    if (basePrice <= 0 || monthlyNumber <= 0) return;

    const values = calculateFinancingValues({
      basePrice,
      monthlyPayment: monthlyNumber,
      financingMonths,
      origin: "applyMonthlyPayment",
    });

    setManualMonthlyOverride(false);
    setUserEditedEnganche(true);
    updateAllFinancingStates(values, { force: true });

    const ventaActual = selectedMailDataRef.current || selectedMailData;
    const ventaId = String(
      ventaActual?.id || formDataRef.current?.venta_id || "",
    );

    engancheCVentaIdRef.current = ventaId;
    manualEngancheVentaIdRef.current = ventaId;
    manualEngancheValueRef.current = String(values.downPaymentAmount);

    setEngancheC(String(values.downPaymentAmount));
    setEngancheDisplay(formatInputCurrency(values.downPaymentAmount));
    setMensualidadC(String(values.monthlyPayment));
    setMensualidadDisplay(formatInputCurrency(values.monthlyPayment));
    setMonthlyPaymentDraft(formatNumber(String(values.monthlyPayment)));

    setFormData((prev) => {
      const next = {
        ...prev,
        enganche: formatNumber(String(values.downPaymentAmount)),
        engancheEditable: formatNumber(String(values.downPaymentAmount)),
        mensualidad_buscada: formatNumber(String(values.monthlyPayment)),
        plazo_meses: String(financingMonths),
      };
      formDataRef.current = next;
      return next;
    });

    if (ventaId) {
      markLocalFinancingPatch(ventaId, {
        mensualidad_estimacion: values.monthlyPayment,
        enganche: values.downPaymentAmount,
        engancheEditable: values.downPaymentAmount,
        porcentaje_enganche: values.downPaymentPercentage,
        meses_financiamiento: financingMonths,
        plazo_meses: String(financingMonths),
      });

      mergeAsesorDraft(ventaId, {
        formData: {
          ...(loadAsesorDraft(ventaId)?.formData || {}),
          ...(formDataRef.current || {}),
          enganche: String(values.downPaymentAmount),
          engancheEditable: String(values.downPaymentAmount),
          mensualidad_buscada: formatNumber(String(values.monthlyPayment)),
          plazo_meses: String(financingMonths),
        },
        engancheC: String(values.downPaymentAmount),
        engancheDisplay: formatInputCurrency(values.downPaymentAmount),
        downPaymentPercentage: values.downPaymentPercentage,
        mensualidadC: String(values.monthlyPayment),
        mensualidadDisplay: formatInputCurrency(values.monthlyPayment),
        financingMonths,
        manualMonthlyOverride: false,
      });

      if (financingUpdateTimeoutRef.current) {
        clearTimeout(financingUpdateTimeoutRef.current);
      }

      financingUpdateTimeoutRef.current = setTimeout(() => {
        updateFinancingData({
          enganche: values.downPaymentAmount,
          porcentajeEnganche: values.downPaymentPercentage,
          mensualidad: values.monthlyPayment,
        });
      }, 450);
    }
  };

  const persistPlanesFinanciamientoSnapshot = useCallback(
    (updatedPlans = [], precioTotalSnapshot = null) => {
      const ventaActual = selectedMailDataRef.current || selectedMailData;
      const ventaId = String(
        ventaActual?.id || formDataRef.current?.venta_id || "",
      );

      if (!ventaId || !Array.isArray(updatedPlans)) return Promise.resolve();

      activatePlanMutationGuard(ventaId);

      const precioVeh = toNumber(
        precioVehiculo || ventaActual?.precio_vehiculo || 0,
      );
      const selectedPlanSnapshot = updatedPlans.find(
        (plan) => plan?.isSelected && !esPlanCliente(plan),
      );
      const precioTotalFinal =
        precioTotalSnapshot !== null && precioTotalSnapshot !== undefined
          ? toNumber(precioTotalSnapshot)
          : selectedPlanSnapshot
            ? getPlanTotalPriceForFinancing(selectedPlanSnapshot, precioVeh)
            : precioVeh;

      const payload = {
        access_token: accessToken,
        venta_id: ventaId,
        planes_financiamiento: updatedPlans,
        precio_total: precioTotalFinal,
      };

      const patchVentaConPlanes = (venta = {}) => {
        if (!venta || String(venta?.id || "") !== ventaId) return venta;

        return {
          ...venta,
          planes_financiamiento: updatedPlans,
          precio_total: precioTotalFinal,
        };
      };

      selectedMailDataRef.current = patchVentaConPlanes(
        selectedMailDataRef.current || ventaActual || {},
      );
      setSelectedMailData((prev) => patchVentaConPlanes(prev));
      setMailData((prev) =>
        Array.isArray(prev)
          ? prev.map((item) => patchVentaConPlanes(item))
          : prev,
      );

      const payloadSignature = JSON.stringify({
        venta_id: payload.venta_id,
        precio_total: payload.precio_total,
        planes_financiamiento: payload.planes_financiamiento,
      });

      if (
        payloadSignature === lastPlanSnapshotSignatureRef.current ||
        payloadSignature === pendingPlanSnapshotSignatureRef.current
      ) {
        return Promise.resolve();
      }

      pendingPlanSnapshotSignatureRef.current = payloadSignature;
      pendingPlanSnapshotPayloadRef.current = payload;

      if (planSnapshotSaveTimeoutRef.current) {
        clearTimeout(planSnapshotSaveTimeoutRef.current);
      }

      planSnapshotSaveTimeoutRef.current = setTimeout(async () => {
        const payloadToSend = pendingPlanSnapshotPayloadRef.current;
        const signatureToSend = pendingPlanSnapshotSignatureRef.current;

        if (!payloadToSend || !signatureToSend) return;

        planSnapshotSaveTimeoutRef.current = null;
        pendingPlanSnapshotPayloadRef.current = null;
        pendingPlanSnapshotSignatureRef.current = "";

        if (signatureToSend === lastPlanSnapshotSignatureRef.current) return;

        try {
          await fetch(
            "https://api.checkmark.mx/actualizar/planes/financiamiento",
            {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify(payloadToSend),
            },
          );

          lastPlanSnapshotSignatureRef.current = signatureToSend;
        } catch (error) {
          console.error("Error guardando planes_financiamiento:", error);
        }
      }, 650);

      return Promise.resolve();
    },
    [accessToken, selectedMailData, precioVehiculo, activatePlanMutationGuard],
  );

  const lastGoldVehicleSyncSignatureRef = useRef("");

  useEffect(() => {
    if (!selectedMailData?.id) return;
    if (isPlanMutationGuardActive(selectedMailData?.id)) return;

    const ventaActual = selectedMailDataRef.current || selectedMailData;
    const vehicleSignature = [
      ventaActual?.id || "",
      ventaActual?.ag_id || "",
      ventaActual?.tipo_auto || "",
      ventaActual?.modelo_vehiculo || "",
      ventaActual?.version_vehiculo || "",
      ventaActual?.ano_vehiculo || ventaActual?.anio || ventaActual?.año || "",
      ventaActual?.precio_vehiculo || "",
      ventaActual?.accesorios_seleccionados || "",
    ].join("|");

    if (!ventaActual?.version_vehiculo && !ventaActual?.modelo_vehiculo) return;
    if (lastGoldVehicleSyncSignatureRef.current === vehicleSignature) return;

    lastGoldVehicleSyncSignatureRef.current = vehicleSignature;

    const ventaIdActual = String(ventaActual?.id || "");
    const planesDesdeBD = parsePlanesFinanciamiento(
      ventaActual?.planes_financiamiento,
    );
    const plansStatePerteneceVentaActual =
      plansLoaded &&
      String(plansLoadedVentaIdRef.current || "") === ventaIdActual;

    const basePlans =
      planesDesdeBD.length && !plansStatePerteneceVentaActual
        ? preparePlansState(ventaActual)
        : Array.isArray(plansState) && plansState.length
          ? plansState
          : preparePlansState(ventaActual);

    const seleccionPerteneceVentaActual =
      Boolean(selectedPlanVentaIdRef.current) &&
      String(selectedPlanVentaIdRef.current) === ventaIdActual;
    const preserveSelection =
      planesDesdeBD.length > 0 || seleccionPerteneceVentaActual;
    const selectedPlanKeyBefore = preserveSelection
      ? normalizarNombrePlan(
          (Array.isArray(basePlans)
            ? basePlans.find((plan) => plan?.isSelected && !esPlanCliente(plan))
            : null) ||
            selectedPlanForFinancing ||
            selectedPlan ||
            "",
        )
      : "";

    const updatedPlans = normalizarSeleccionPlanes(
      aplicarReglasPlanesCliente(
        basePlans,
        ventaActual,
        formDataRef.current || {},
        { preserveEditablePlans: true },
      ),
      { preferredSelectedKey: selectedPlanKeyBefore, preserveSelection },
    );

    const selectedIndex = updatedPlans.findIndex(
      (plan) => plan?.isSelected && !esPlanCliente(plan),
    );
    const selectedPlanSnapshot =
      selectedIndex >= 0 ? updatedPlans[selectedIndex] : null;
    const precioVeh = toNumber(
      ventaActual?.precio_vehiculo || precioVehiculo || 0,
    );
    const totalSnapshot = selectedPlanSnapshot
      ? getPlanTotalPriceForFinancing(selectedPlanSnapshot, precioVeh)
      : precioVeh;

    setPlansState(updatedPlans);

    if (selectedPlanSnapshot) {
      selectedPlanVentaIdRef.current = String(ventaActual?.id || "");
      setSelectedPlan(selectedPlanSnapshot);
      setSelectedPlanFinal(selectedIndex);
      setSelectedPlanIndex(selectedIndex);
      selectedPlanKeyRef.current = getPlanKey(selectedPlanSnapshot);
      setPrecioTotal(totalSnapshot);
    }

    persistPlanesFinanciamientoSnapshot(updatedPlans, totalSnapshot);
  }, [
    selectedMailData?.id,
    selectedMailData?.ag_id,
    selectedMailData?.tipo_auto,
    selectedMailData?.modelo_vehiculo,
    selectedMailData?.version_vehiculo,
    selectedMailData?.ano_vehiculo,
    selectedMailData?.precio_vehiculo,
    selectedMailData?.accesorios_seleccionados,
    plansState,
    selectedPlanForFinancing,
    selectedPlan,
    precioVehiculo,
    plansLoaded,
    preparePlansState,
    parsePlanesFinanciamiento,
    normalizarSeleccionPlanes,
    aplicarReglasPlanesCliente,
    getPlanTotalPriceForFinancing,
    getPlanKey,
    persistPlanesFinanciamientoSnapshot,
    isPlanMutationGuardActive,
  ]);

  const syncFinancingAfterPlanMutation = useCallback(
    (updatedPlans = [], source = "syncFinancingAfterPlanMutation") => {
      const ventaActual = selectedMailDataRef.current || selectedMailData;
      const ventaId = String(
        ventaActual?.id || formDataRef.current?.venta_id || "",
      );

      if (!ventaId || !Array.isArray(updatedPlans)) return;

      const selectedIndex = updatedPlans.findIndex(
        (plan) => plan?.isSelected && !esPlanCliente(plan),
      );
      const selectedPlanSnapshot =
        selectedIndex >= 0 ? updatedPlans[selectedIndex] : null;
      const precioVeh = toNumber(
        precioVehiculo || ventaActual?.precio_vehiculo || 0,
      );
      const precioTotalSnapshot = selectedPlanSnapshot
        ? getPlanTotalPriceForFinancing(selectedPlanSnapshot, precioVeh)
        : precioVeh;

      persistPlanesFinanciamientoSnapshot(updatedPlans, precioTotalSnapshot);

      if (!selectedPlanSnapshot) {
        setSelectedPlan(null);
        setSelectedPlanFinal(null);
        setSelectedPlanIndex(null);
        setPrecioTotal(precioTotalSnapshot);
        return;
      }

      const cashMode =
        String(formDataRef.current?.pago_contado || "").trim() === "Si" ||
        String(ventaActual?.depende_auto || "").trim() === "Si";
      const mesesDesdeBD = getMesesFromVentaBD(ventaActual);
      const monthsForCalc = normalizeFinancingMonths(
        mesesDesdeBD ||
          formDataRef.current?.meses_financiamiento ||
          formDataRef.current?.plazo_meses ||
          financingMonths,
        cashMode,
      );
      const values = calculateFinancingValues({
        basePrice: precioTotalSnapshot,
        downPaymentAmount: getEngancheActual(precioTotalSnapshot),
        financingMonths: monthsForCalc,
        origin: source,
      });
      const mensualidadFinal = values.monthlyPayment;

      selectedPlanVentaIdRef.current = ventaId;
      engancheCVentaIdRef.current = ventaId;
      manualEngancheVentaIdRef.current = ventaId;
      manualEngancheValueRef.current = String(values.downPaymentAmount);

      setSelectedPlan(selectedPlanSnapshot);
      setSelectedPlanFinal(selectedIndex);
      setSelectedPlanIndex(selectedIndex);
      selectedPlanKeyRef.current = getPlanKey(selectedPlanSnapshot);
      setPrecioTotal(precioTotalSnapshot);
      setFinancingMonths(monthsForCalc);
      setEngancheC(String(values.downPaymentAmount));
      setEngancheDisplay(formatInputCurrency(values.downPaymentAmount));
      setMensualidadC(String(mensualidadFinal));
      setMensualidadDisplay(formatInputCurrency(mensualidadFinal));
      setManualMonthlyOverride(false);
      updateAllFinancingStates(values, { force: true });

      updateFinancingDataRef.current?.({
        precioTotal: precioTotalSnapshot,
        planTotalPrice:
          getPlanAccessoriesTotalForFinancing(selectedPlanSnapshot),
        financingMonths: monthsForCalc,
        meses_financiamiento: monthsForCalc,
        enganche: values.downPaymentAmount,
        porcentajeEnganche: values.downPaymentPercentage,
        mensualidad: mensualidadFinal,
      });
    },
    [
      selectedMailData,
      precioVehiculo,
      financingMonths,
      mensualidadC,
      manualMonthlyOverride,
      persistPlanesFinanciamientoSnapshot,
      getPlanKey,
      getMesesFromVentaBD,
      normalizeFinancingMonths,
      calculateFinancingValues,
      getEngancheActual,
      updateAllFinancingStates,
    ],
  );

  const assignAccessoryToPlan = (accessoryIndex, planIndex) => {
    // El paquete Gold es el precargado y no debe modificarse desde accesorios.
    if (esPlanNoEditable(plansState?.[planIndex])) {
      return;
    }

    setPlansState((prevPlans) => {
      //copia del array de planes
      const updatedPlans = [...prevPlans];
      if (esPlanNoEditable(updatedPlans?.[planIndex])) return prevPlans;
      //copia profunda del plan específico para forzar el re-render
      let updatedPlan = {
        ...updatedPlans[planIndex],
        accessories: [...updatedPlans[planIndex].accessories],
      };

      markPlanAsManuallyEdited(updatedPlan);

      const accessory = plans[accessoryIndex];
      const accessoryPrice =
        parseFloat(
          accessory.price?.toString().replace("$", "").replace(",", "").trim(),
        ) || 0;

      const accessoryData = {
        title: accessory.title.trim(), // Guardamos limpio
        description: accessory.description || "",
        price: accessoryPrice,
        price_base: accessoryPrice,
        price_promo: accessoryPrice,
      };

      // Verificar si ya está
      const isAccessoryInPlan = updatedPlan.accessories.some(
        (acc) => acc.title.toLowerCase() === accessoryData.title.toLowerCase(),
      );

      if (isAccessoryInPlan) {
        // Remover
        updatedPlan.accessories = updatedPlan.accessories.filter(
          (acc) =>
            acc.title.toLowerCase() !== accessoryData.title.toLowerCase(),
        );
        updatedPlan.totalPrice -= accessoryPrice;
        updatedPlan.totalPrice_base -= accessoryPrice;
        updatedPlan.totalPrice_promo -= accessoryPrice;
      } else {
        // Agregar
        updatedPlan.accessories.push(accessoryData);
        updatedPlan.totalPrice += accessoryPrice;
        updatedPlan.totalPrice_base += accessoryPrice;
        updatedPlan.totalPrice_promo += accessoryPrice;
      }

      updatedPlan.totalPrice = Math.max(0, updatedPlan.totalPrice);
      updatedPlan = markPlanObjectAsManual(updatedPlan);

      try {
        const promo = obtenerPromocion(updatedPlan, selectedVehicleName);
        actualizarCampoPlan(updatedPlan.title.toLowerCase(), promo);
      } catch (error) {
        console.error("Error recalculando promoción:", error);
      }

      // asignamos el plan modificado al array
      updatedPlans[planIndex] = updatedPlan;

      setTimeout(() => {
        syncFinancingAfterPlanMutation(updatedPlans, "assignAccessoryToPlan");
      }, 0);

      return updatedPlans;
    });
  };

  /*useEffect(() => {
  }, [plansState]);*/

  const updateFinancingData = useCallback(
    async (overrides = {}) => {
      const ventaActual = selectedMailDataRef.current || selectedMailData;

      if (!ventaActual?.id) {
        console.error("No se encontró un ID de venta válido.");
        return;
      }

      if (!overrides?.preserveManualModalGuard) {
        releaseManualFinancingModalSaved(ventaActual.id);
      }

      const planesDesdeBD = parsePlanesFinanciamiento(
        ventaActual?.planes_financiamiento,
      );

      const debeConservarPrecioTotalBD = planesDesdeBD.length && !plansLoaded;

      const planBelongsToVenta =
        !selectedPlanVentaIdRef.current ||
        String(selectedPlanVentaIdRef.current) === String(ventaActual.id);
      const selectedPlanTotal = planBelongsToVenta
        ? getPlanAccessoriesTotalForFinancing(selectedPlanForFinancing)
        : 0;
      const planTotal = toNumber(
        overrides.planTotalPrice ?? selectedPlanTotal ?? 0,
      );

      const precioVeh = toNumber(
        precioVehiculo || ventaActual?.precio_vehiculo || 0,
      );

      const precioTotalBD = toNumber(
        ventaActual?.precio_total || formDataRef.current?.precio_total || 0,
      );
      const precioTotalFinal = Math.round(
        toNumber(overrides.precioTotal) ||
          (debeConservarPrecioTotalBD && precioTotalBD > 0
            ? precioTotalBD
            : precioVeh + planTotal),
      );
      let engancheFinal = Math.round(
        toNumber(overrides.enganche ?? getEngancheActual(precioTotalFinal)),
      );
      const cashMode =
        String(formDataRef.current?.pago_contado || "").trim() === "Si" ||
        String(ventaActual?.depende_auto || "").trim() === "Si";
      const mesesDesdeBD = getMesesFromVentaBD(ventaActual);
      const mesesFinanciamientoFinal = normalizeFinancingMonths(
        overrides.meses_financiamiento ??
          overrides.financingMonths ??
          (mesesDesdeBD > 0 ? mesesDesdeBD : undefined) ??
          formDataRef.current?.meses_financiamiento ??
          formDataRef.current?.plazo_meses ??
          financingMonths,
        cashMode,
      );

      const mensualidadOverride = toNumber(overrides.mensualidad);
      const debeCalcularDesdeMensualidad =
        mensualidadOverride > 0 &&
        (overrides.enganche === undefined || overrides.enganche === null);

      let values = calculateFinancingValues({
        basePrice: precioTotalFinal,
        ...(debeCalcularDesdeMensualidad
          ? { monthlyPayment: mensualidadOverride }
          : { downPaymentAmount: engancheFinal }),
        financingMonths: mesesFinanciamientoFinal,
        origin: "updateFinancingData",
      });

      if (debeCalcularDesdeMensualidad) {
        engancheFinal = Math.round(toNumber(values.downPaymentAmount));
      }

      const mensualidadFinal = values.monthlyPayment;

      const financingData = {
        access_token: accessToken,
        venta_id: ventaActual.id,
        meses_financiamiento: mesesFinanciamientoFinal,
        plazo_meses: String(mesesFinanciamientoFinal),
        enganche: engancheFinal,
        porcentaje_enganche:
          overrides.porcentajeEnganche ?? values.downPaymentPercentage,
        mensualidad_estimacion: mensualidadFinal,
        precio_total: precioTotalFinal,
      };

      markLocalFinancingPatch(ventaActual.id, {
        meses_financiamiento: mesesFinanciamientoFinal,
        plazo_meses: String(mesesFinanciamientoFinal),
        enganche: engancheFinal,
        engancheEditable: engancheFinal,
        porcentaje_enganche:
          overrides.porcentajeEnganche ?? values.downPaymentPercentage,
        mensualidad_estimacion: mensualidadFinal,
        precio_total: precioTotalFinal,
      });

      const financingSignature = JSON.stringify(financingData);
      if (lastFinancingDataSignatureRef.current === financingSignature) {
        return;
      }

      lastFinancingDataSignatureRef.current = financingSignature;
      const syncRunId = ++financingSyncRunIdRef.current;

      try {
        const result = await guardarFinanciamientoSnapshotBD(financingData);

        if (syncRunId !== financingSyncRunIdRef.current) {
          return;
        }

        setFinancingMonths(mesesFinanciamientoFinal);
        setPrecioTotal(precioTotalFinal);

        const nextFinancialFormData = {
          ...(formDataRef.current || {}),
          plazo_meses: String(mesesFinanciamientoFinal),
          meses_financiamiento: String(mesesFinanciamientoFinal),
          inversion_inicial: String(engancheFinal),
          enganche: formatNumber(String(engancheFinal)),
          engancheEditable: formatNumber(String(engancheFinal)),
          mensualidad_buscada: formatNumber(String(mensualidadFinal)),
          precio_total: precioTotalFinal,
        };

        setFormData(nextFinancialFormData);
        formDataRef.current = nextFinancialFormData;
        lastSavedRef.current = null;
        autoGuardar(nextFinancialFormData);

        setSelectedMailData((prev) =>
          prev && String(prev.id || "") === String(ventaActual.id || "")
            ? {
                ...prev,
                meses_financiamiento: mesesFinanciamientoFinal,
                plazo_meses: String(mesesFinanciamientoFinal),
                enganche: engancheFinal,
                porcentaje_enganche:
                  overrides.porcentajeEnganche ?? values.downPaymentPercentage,
                mensualidad_estimacion: mensualidadFinal,
                precio_total: precioTotalFinal,
              }
            : prev,
        );
      } catch (err) {
        lastFinancingDataSignatureRef.current = "";
        console.error("❌ Error al actualizar financiamiento:", err);
      }
    },
    [
      accessToken,
      selectedMailData,
      financingMonths,
      selectedPlanForFinancing,
      precioVehiculo,
      manualMonthlyOverride,
      mensualidadC,
      getEngancheActual,
      calculateFinancingValues,
      normalizeFinancingMonths,
      getMesesFromVentaBD,
      parsePlanesFinanciamiento,
      plansLoaded,
      markLocalFinancingPatch,
      releaseManualFinancingModalSaved,
    ],
  );

  updateFinancingDataRef.current = updateFinancingData;

  // Actualizar el manejador de selección de plan
  const handlePlanSelect = useCallback(
    (plan, planIndex) => {
      if (esPlanCliente(plan)) {
        Swal.fire({
          icon: "info",
          title: "Plan cliente",
          text: "El Plan cliente sólo es informativo y no se puede seleccionar.",
          timer: 1800,
          showConfirmButton: false,
          willOpen: () => {
            const container = document.querySelector(".swal2-container");
            if (container) container.style.zIndex = "1000000";
          },
        });
        return;
      }

      const ventaActual = selectedMailDataRef.current || selectedMailData;
      const ventaId = String(
        ventaActual?.id || formDataRef.current?.venta_id || "",
      );
      releaseManualFinancingModalSaved(ventaId);
      const precioVeh = toNumber(
        precioVehiculo || ventaActual?.precio_vehiculo || 0,
      );
      const planTotal = getPlanAccessoriesTotalForFinancing(plan);
      const nuevoPrecioTotal = Math.round(precioVeh + planTotal);
      const engancheRespetado = getEngancheActual(nuevoPrecioTotal);

      const values = calculateFinancingValues({
        basePrice: nuevoPrecioTotal,
        downPaymentAmount: engancheRespetado,
        financingMonths,
        origin: "handlePlanSelect",
      });

      const mensualidadFinal = values.monthlyPayment;

      const updatedPlansSnapshot = plansState.map((p, idx) => ({
        ...p,
        isSelected: idx === planIndex && !esPlanCliente(p),
      }));
      const selectedPlanSnapshot = {
        ...(updatedPlansSnapshot[planIndex] || plan),
        totalPrice: planTotal,
        isSelected: true,
      };
      updatedPlansSnapshot[planIndex] = selectedPlanSnapshot;

      setPlansState(updatedPlansSnapshot);

      selectedPlanVentaIdRef.current = ventaId;
      engancheCVentaIdRef.current = ventaId;
      manualEngancheVentaIdRef.current = ventaId;
      manualEngancheValueRef.current = String(values.downPaymentAmount);

      setPrecioTotal(nuevoPrecioTotal);
      setSelectedPlan(selectedPlanSnapshot);
      setSelectedPlanFinal(planIndex);
      setSelectedPlanIndex(planIndex);
      selectedPlanKeyRef.current = getPlanKey(selectedPlanSnapshot);
      setUserEditedEnganche(true);

      updateAllFinancingStates(values, { force: true });

      setEngancheC(String(values.downPaymentAmount));
      setEngancheDisplay(formatInputCurrency(values.downPaymentAmount));
      setMensualidadC(String(mensualidadFinal));
      setMensualidadDisplay(formatInputCurrency(mensualidadFinal));
      setManualMonthlyOverride(false);

      if (ventaId) {
        mergeAsesorDraft(ventaId, {
          formData: {
            ...(loadAsesorDraft(ventaId)?.formData || {}),
            ...(formDataRef.current || {}),
            precio_total: nuevoPrecioTotal,
            enganche: formatNumber(String(values.downPaymentAmount)),
            engancheEditable: formatNumber(String(values.downPaymentAmount)),
            mensualidad_buscada: formatNumber(String(mensualidadFinal)),
            plazo_meses: String(financingMonths),
          },
          precioTotal: nuevoPrecioTotal,
          financingMonths,
          downPaymentPercentage: values.downPaymentPercentage,
          mensualidadC: String(mensualidadFinal),
          mensualidadDisplay: formatInputCurrency(mensualidadFinal),
          engancheC: String(values.downPaymentAmount),
          engancheDisplay: formatInputCurrency(values.downPaymentAmount),
          manualMonthlyOverride: false,
        });
      }

      if (ventaId) {
        persistPlanesFinanciamientoSnapshot(
          updatedPlansSnapshot,
          nuevoPrecioTotal,
        );
      }

      updateFinancingData({
        planTotalPrice: planTotal,
        enganche: values.downPaymentAmount,
        porcentajeEnganche: values.downPaymentPercentage,
        mensualidad: mensualidadFinal,
      });
    },
    [
      accessToken,
      selectedMailData,
      precioVehiculo,
      financingMonths,
      mensualidadC,
      manualMonthlyOverride,
      plansState,
      getPlanKey,
      getEngancheActual,
      calculateFinancingValues,
      updateAllFinancingStates,
      updateFinancingData,
      persistPlanesFinanciamientoSnapshot,
      mergeAsesorDraft,
      loadAsesorDraft,
      releaseManualFinancingModalSaved,
    ],
  );

  useEffect(() => {
    // La sincronización del plan seleccionado se hace en el efecto central de
    // precio total + mensualidades para evitar envíos duplicados o carreras.
  }, [
    selectedPlanForFinancing?.title,
    selectedPlanForFinancing?.accessories,
    selectedMailData?.id,
  ]);

  // Sincroniza el precio total del panel cuando el plan ya viene seleccionado desde BD
  // o cuando cambia el paquete actual. Así no hace falta volver a presionar
  // "Seleccionar Plan" sobre el mismo paquete para que sume accesorios/garantías.
  useEffect(() => {
    if (!selectedMailData?.id || !plansLoaded) return;

    if (activeFinancingEditRef.current) {
      return;
    }

    const ventaIdActual = String(selectedMailData.id || "");

    // No recalcular visualmente sobre una cotización manual recién guardada
    // o cargada desde BD, pero sí dejamos que se restaure el plan seleccionado
    // y el precio total del paquete.
    const financiamientoManualActivo =
      Number(
        selectedMailDataRef.current?.financiamiento_modal ??
          selectedMailData?.financiamiento_modal ??
          0,
      ) === 1 || isManualFinancingModalSavedActive(ventaIdActual);

    if (
      selectedPlanVentaIdRef.current &&
      String(selectedPlanVentaIdRef.current) !== ventaIdActual
    ) {
      return;
    }

    const selectedFromState = Array.isArray(plansState)
      ? plansState.find((plan) => plan?.isSelected && !esPlanCliente(plan))
      : null;
    const planParaCalculo =
      selectedFromState || selectedPlanForFinancing || null;

    if (planParaCalculo && !selectedPlan) {
      setSelectedPlan(planParaCalculo);
    }

    if (planParaCalculo) {
      const planIndex = Array.isArray(plansState)
        ? plansState.findIndex(
            (plan) =>
              normalizarNombrePlan(plan) ===
              normalizarNombrePlan(planParaCalculo),
          )
        : -1;

      if (planIndex >= 0) {
        setSelectedPlanFinal(planIndex);
        setSelectedPlanIndex(planIndex);
      }

      selectedPlanVentaIdRef.current = ventaIdActual;
    }

    const vehiclePrice = toNumber(
      precioVehiculo || selectedMailData?.precio_vehiculo || 0,
    );
    const total = planParaCalculo
      ? getPlanTotalPriceForFinancing(planParaCalculo, vehiclePrice)
      : vehiclePrice;

    setPrecioTotal(total);
    setFormData((prevFormData) => {
      const next = {
        ...prevFormData,
        precio_total: total,
      };

      formDataRef.current = next;
      return next;
    });

    // También actualizamos mensualidad/enganche visual al restaurar el plan desde BD.
    // Si no se hace aquí, el precio total ya suma el plan pero la mensualidad puede
    // quedarse calculada sólo con el precio del vehículo hasta volver a seleccionar.
    if (
      total > 0 &&
      !financiamientoManualActivo &&
      !activeFinancingEditRef.current &&
      !isUserEditing.current
    ) {
      const cashMode =
        String(formDataRef.current?.pago_contado || "").trim() === "Si" ||
        String(selectedMailData?.depende_auto || "").trim() === "Si";
      const mesesDesdeBD = getMesesFromVentaBD(selectedMailData);
      const monthsForCalc = normalizeFinancingMonths(
        mesesDesdeBD ||
          formDataRef.current?.meses_financiamiento ||
          formDataRef.current?.plazo_meses ||
          financingMonths,
        cashMode,
      );
      const values = calculateFinancingValues({
        basePrice: total,
        downPaymentAmount: getEngancheActual(total),
        financingMonths: monthsForCalc,
        origin: "syncSelectedPlanFromBD",
      });

      const mensualidadFinal = values.monthlyPayment;

      updateAllFinancingStates(values, { force: true });

      engancheCVentaIdRef.current = ventaIdActual;
      manualEngancheVentaIdRef.current = ventaIdActual;
      manualEngancheValueRef.current = String(values.downPaymentAmount);
      setFinancingMonths(monthsForCalc);
      setEngancheC(String(values.downPaymentAmount));
      setEngancheDisplay(formatInputCurrency(values.downPaymentAmount));
      setMensualidadC(String(mensualidadFinal));
      setMensualidadDisplay(formatInputCurrency(mensualidadFinal));

      // No guardamos aquí. Este efecto sólo restaura/sincroniza UI desde BD.
      // Guardar aquí provocaba carreras con polling y rebotes de meses/mensualidad.
      // Los guardados suceden únicamente en acciones explícitas:
      // cambio de meses, blur de mensualidad/enganche, slider o selección de plan.
    }
  }, [
    selectedMailData?.id,
    selectedMailData?.precio_vehiculo,
    precioVehiculo,
    selectedPlanForFinancing,
    selectedPlan,
    plansState,
    plansLoaded,
    financingMonths,
    manualMonthlyOverride,
    normalizeFinancingMonths,
    calculateFinancingValues,
    getEngancheActual,
    updateAllFinancingStates,
    updateFinancingData,
    getMesesFromVentaBD,
    isManualFinancingModalSavedActive,
  ]);

  const [tableData, setTableData] = useState([]);
  const apiUpdatePlanUrl =
    "https://api.checkmark.mx/actualizar/plan/financiamiento";
  const apiUpdatePlanesUrl =
    "https://api.checkmark.mx/actualizar/planes/financiamiento";
  const apiUpdateVehicleUrl =
    "https://api.checkmark.mx/actualizar/vehiculo/financiamiento";
  const apiUrlInventario = "https://api.checkmark.mx/financiamiento/vehiculos"; //nueva url para los accesorios
  const apiUpdateVersionUrl =
    "https://api.checkmark.mx/actualizar/version/vehiculo/financiamiento"; //actualizar version
  const apiUpdateEstadoUrl =
    "https://api.checkmark.mx/actualizar/estado/financiamiento";
  const apiUrlEntrevista =
    "https://api.checkmark.mx/solicitudes/actualizar/entrevista"; //Actualizar entrevista

  const apiNrTokenUrl = `${NR_BABILONIA_API_BASE}${NR_ENDPOINTS.token}`;
  const apiNrCotizaUrl = `${NR_BABILONIA_API_BASE}${NR_ENDPOINTS.cotiza}`;
  const apiNrGuardarCotizacionUrl = `${NR_BABILONIA_API_BASE}${NR_ENDPOINTS.guardarCotizacion}`;
  const apiNrGenerarPdfUrl = `${NR_BABILONIA_API_BASE}${NR_ENDPOINTS.generarPdf}`;


  const agIdSeleccionado = useMemo(() => {
    const selectedCarVenta = getSelectedCarFromVenta(selectedMailData);

    return (
      selectedMailData?.ag_id ||
      selectedMailData?.agencia_id ||
      selectedCarVenta?.ag_id ||
      agenciaActual?.ag_id ||
      ""
    );
  }, [selectedMailData, agenciaActual?.ag_id]);

  const marcaInventarioSeleccionada = useMemo(() => {
    const selectedCarVenta = getSelectedCarFromVenta(selectedMailData);

    return (
      selectedMailData?.marca_vehiculo ||
      selectedCarVenta?.brand ||
      selectedCarVenta?.marca ||
      selectedCarVenta?.title ||
      ""
    );
  }, [selectedMailData]);

  useEffect(() => {
    if (!accessToken) return;

    const agId = String(agIdSeleccionado || "").trim();
    const marca = String(marcaInventarioSeleccionada || "").trim();

    // Importante:
    // No limpiamos tableData cuando todavía no hay venta/vehículo seleccionado.
    // Al finalizar una venta se resetea selectedMailData; si aquí vaciamos tableData,
    // se pierde el catálogo de accesorios y garantías disponibles hasta refrescar.
    if (!agId || !marca) {
      return;
    }

    const cacheKey = `${agId}__${normalizarTexto(marca)}`;

    if (inventarioCacheRef.current?.[cacheKey]) {
      setTableData(inventarioCacheRef.current[cacheKey]);
    }

    const requestId = ++inventarioRequestIdRef.current;
    const controller = new AbortController();

    const requestData = {
      access_token: accessToken,
      ag_id: agId,
      marca,
    };

    // No vaciamos tableData antes de consultar.
    // Así evitamos que la UI se quede sin accesorios/garantías entre cambios de venta.
    fetch(apiUrlInventario, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(requestData),
      signal: controller.signal,
    })
      .then((res) => res.json())
      .then((data) => {
        // Si llegó una respuesta vieja de otra agencia, se ignora.
        if (requestId !== inventarioRequestIdRef.current) return;

        const foodOriginal = Array.isArray(data?.food) ? data.food : [];

        // Blindaje extra del asesor: aunque el backend mande algo de otra agencia,
        // aquí se descarta antes de pintar accesorios/garantías.
        const foodFiltrado = foodOriginal.filter((item) => {
          const itemType = normalizarTexto(item?.type || "");

          if (itemType === "accesorios" || itemType === "garantias") {
            return (
              !item?.hide &&
              estaDisponible(item) &&
              coincideMarcaItem(item, marca) &&
              coincideAgenciaItem(item, agId)
            );
          }

          return true;
        });

        const dataLimpia = {
          ...data,
          food: foodFiltrado,
        };

        inventarioCacheRef.current[cacheKey] = dataLimpia;
        setTableData(dataLimpia);
      })
      .catch((error) => {
        if (error?.name === "AbortError") return;

        // Si falla una consulta temporal, conservamos el último catálogo válido.
        console.error("Error al consumir la API:", error);
      });

    return () => {
      controller.abort();
    };
  }, [
    accessToken,
    apiUrlInventario,
    agIdSeleccionado,
    marcaInventarioSeleccionada,
  ]);

  const marcaSeleccionada = useMemo(
    //actualizar la marca
    () => normalizarTexto(marcaInventarioSeleccionada || ""),
    [marcaInventarioSeleccionada],
  );

  const filteredAccessoriesAndWarranties = useMemo(() => {
    const tipoAuto = normalizarTexto(selectedMailData?.tipo_auto || "");
    const modeloAuto = normalizarTexto(selectedMailData?.modelo_vehiculo || "");
    const versionAuto = normalizarTexto(
      selectedMailData?.version_vehiculo || "",
    );
    const marcaActual = marcaSeleccionada || "";
    const agIdActual = agIdSeleccionado || "";

    // Estos SOLO deben mostrarse en NUEVOS (se ocultan en seminuevos)
    const soloParaNuevos = [
      "Garantía Extendida",
      "Cobertura de Llaves",
      "Canastilla de techo",
      "Rejilla Separadora",
      "Tapete uso rudo area de carga",
      "Organizador de Cajuela",
      "Seguro LLantas",
    ];
    const soloParaNuevosNorm = soloParaNuevos.map(normalizarTexto);

    // Estos SOLO deben mostrarse en SEMINUEVOS (se ocultan en nuevos)
    const soloParaSeminuevos = ["Kit de seguridad", "Localizador Gocar"];
    const soloParaSeminuevosNorm = soloParaSeminuevos.map(normalizarTexto);

    const esNuevo = tipoAuto === "nuevos" || tipoAuto === "nuevo";
    const esSeminuevo = tipoAuto === "seminuevos" || tipoAuto === "seminuevo";

    const filtered = Array.isArray(tableData?.food)
      ? tableData.food
          .filter((item) => {
            if (!item || item.hide) return null;
            if (!estaDisponible(item)) return null;
            if (!coincideMarcaItem(item, marcaActual)) return null;
            if (!coincideAgenciaItem(item, agIdActual)) return null;

            const itemType = normalizarTexto(item.type || "");
            const esGarantia = itemType === "garantias";
            const esAccesorio = itemType === "accesorios";
            const itemTitle = item.title || "";
            const tituloNorm = normalizarTexto(itemTitle);

            const isAccessoryOrWarranty = esAccesorio || esGarantia;

            if (!isAccessoryOrWarranty) {
              return null;
            }

            // Reglas especiales para protección llanta-rin
            const esProteccion5000 =
              esGarantia &&
              tituloNorm.includes("proteccion de llanta-rin") &&
              tituloNorm.includes("5,000");

            const esProteccion12000 =
              esGarantia &&
              tituloNorm.includes("proteccion de llanta-rin") &&
              tituloNorm.includes("12,000");

            // 5000 y 12000 solo para nuevos
            if (esSeminuevo && (esProteccion5000 || esProteccion12000)) {
              return null;
            }

            // Ocultar garantías mecánicas cuando es NUEVO
            const esGarantiaMecanica =
              tituloNorm.includes("garantia mecanica") ||
              tituloNorm.includes("garantía mecánica") ||
              tituloNorm.includes("mecanica amplia");

            if (esNuevo && esGarantiaMecanica) return null;

            // Ocultar items "solo seminuevos" cuando es NUEVO
            const esSoloSeminuevos = soloParaSeminuevosNorm.some((palabra) =>
              tituloNorm.includes(palabra),
            );
            if (esNuevo && esSoloSeminuevos) return null;

            // Ocultar items "solo nuevos" cuando es SEMINUEVO
            const esSoloParaNuevos = soloParaNuevosNorm.some((palabra) =>
              tituloNorm.includes(palabra),
            );
            if (esSeminuevo && esSoloParaNuevos) return null;

            let finalTitle = itemTitle;

            if (itemTitle.includes(" - ")) {
              const [baseTitle, rawModelos = ""] = itemTitle.split(" - ");

              const modelosLista = rawModelos
                .split(",")
                .map((m) => limpiarModeloVersion(m))
                .filter(Boolean);

              const incluyeTodos = modelosLista.includes("todos");

              const modeloLimpio = limpiarModeloVersion(modeloAuto);
              const versionLimpia = limpiarModeloVersion(versionAuto);
              const modeloVersion = limpiarModeloVersion(
                `${modeloLimpio} ${versionLimpia}`,
              );

              // Accesorios: por modelo. Ejemplo: "Portaplacas - Versa, Sentra"
              const coincideModelo =
                !!modeloLimpio && modelosLista.includes(modeloLimpio);

              // Garantías/localizadores: por modelo + versión. Ejemplo:
              // "LOCALIZADOR 1 AÑO - Versa Sense Base TM"
              const coincideModeloVersion =
                !!modeloVersion && modelosLista.includes(modeloVersion);

              const coincide = esGarantia
                ? incluyeTodos || coincideModelo || coincideModeloVersion
                : incluyeTodos || coincideModelo;

              if (coincide) {
                finalTitle = baseTitle;
              } else {
                return null;
              }
            }

            return {
              ...item,
              title: finalTitle,
            };
          })
          .filter(Boolean)
      : [];

    return filtered;
  }, [
    tableData?.food,
    marcaSeleccionada,
    agIdSeleccionado,
    selectedMailData?.tipo_auto,
    selectedMailData?.modelo_vehiculo,
    selectedMailData?.version_vehiculo,
  ]);

  // Función mejorada para handleSubmitPlanUpdate
  const handleSubmitPlanUpdate = (selectedPlan) => {
    const selectedAccessories = selectedPlan.accessories.map((accessory) => {
      const accessoryTitle =
        typeof accessory === "object" ? accessory.title : accessory;

      const fullAccessory =
        plans.find((plan) => plan.title === accessoryTitle) ||
        filteredAccessoriesAndWarranties.find(
          (item) => item.title === accessoryTitle,
        );

      return {
        title: accessoryTitle,
        description: typeof accessory === "object" ? accessory.description : "",
        price: fullAccessory ? fullAccessory.price?.replace("$", "") : "0",
      };
    });

    const requestData = {
      access_token: accessToken,
      venta_id: selectedMailData.id,
      planes_seleccionados: JSON.stringify(selectedAccessories),
      precio_total: getPlanTotalPriceForFinancing(
        selectedPlanForFinancing,
        selectedMailData?.precio_vehiculo,
      ),
      mensualidad_estimacion: getCurrentMonthlyPayment(), // Usar función actualizada
    };

    fetch(apiUpdatePlanUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(requestData),
    })
      .then((response) => response.json())
      .then((data) => {})
      .catch((error) => {
        console.error("Error al actualizar el plan", error);
      });
  };

  // useEffect para sincronizar cuando llegan cambios del cliente
  useEffect(() => {
    if (isUserEditing.current) return;

    const planesDesdeBD = parsePlanesFinanciamiento(
      selectedMailData?.planes_financiamiento,
    );

    // Si la venta trae un plan seleccionado desde BD, esperamos a restaurarlo
    // antes de recalcular precio_total. Si no, este efecto puede pisar el total
    // con sólo el precio del vehículo.
    if (planesDesdeBD.length && !plansLoaded) return;

    if (selectedMailData?.version_vehiculo) {
      let versionTextoSincronizado = selectedMailData.version_vehiculo;

      try {
        const versionesParsed = selectedMailData?.versiones
          ? JSON.parse(selectedMailData.versiones)?.size || []
          : [];

        const versionMatched = versionesParsed.find((version) =>
          coincideTextoPaquete(
            selectedMailData.version_vehiculo,
            version?.text,
          ),
        );

        if (versionMatched?.text) {
          versionTextoSincronizado = versionMatched.text;
        }
      } catch (error) {
        versionTextoSincronizado = selectedMailData.version_vehiculo;
      }

      // Solo actualizar si la versión cambió (evita bucles infinitos)
      if (
        !coincideTextoPaquete(selectedVersion, versionTextoSincronizado) ||
        toNumber(precioVehiculo) !== toNumber(selectedMailData.precio_vehiculo)
      ) {
        setSelectedVersion(versionTextoSincronizado);
        setPrecioVehiculo(Number(selectedMailData.precio_vehiculo) || 0);

        // Ejecutar la lógica de recálculo que tienes en handleVersionSelect
        const versionPrice = Number(selectedMailData.precio_vehiculo) || 0;
        const planPrice = getPlanAccessoriesTotalForFinancing(
          selectedPlanForFinancing,
        );
        const total = Math.round(versionPrice + planPrice);

        setPrecioTotal(total);

        // Recalcular sólo visualmente al sincronizar una venta desde BD.
        // No mandamos nada al backend aquí, porque este efecto se ejecuta al
        // seleccionar/pollear ventas y podía pisar meses o valores manuales
        // guardados desde el modal de financiamiento.
        const ventaIdSync = String(selectedMailData?.id || "");
        const financiamientoManualActivo =
          Number(
            selectedMailDataRef.current?.financiamiento_modal ??
              selectedMailData?.financiamiento_modal ??
              0,
          ) === 1 ||
          isManualFinancingModalSavedActive(ventaIdSync) ||
          isManualFinancingModalGuardActive(ventaIdSync);

        if (!financiamientoManualActivo) {
          const monthsForVersionSync =
            getMesesFromVentaBD(selectedMailData) || financingMonths;

          const values = calculateFinancingValues({
            basePrice: total,
            downPaymentAmount:
              formData.pago_contado === "Si"
                ? versionPrice
                : getEngancheActual(total),
            financingMonths: monthsForVersionSync,
            origin: "syncVersionFromSelectedMailData",
          });

          updateAllFinancingStates(values);
          setFinancingMonths(monthsForVersionSync);
        }
      }
    }
  }, [
    selectedMailData?.version_vehiculo,
    selectedMailData?.precio_vehiculo,
    selectedMailData?.planes_financiamiento,
    selectedVersion,
    precioVehiculo,
    coincideTextoPaquete,
    selectedPlanForFinancing,
    plansLoaded,
    parsePlanesFinanciamiento,
    getMesesFromVentaBD,
    isManualFinancingModalSavedActive,
    isManualFinancingModalGuardActive,
  ]);

  // Función mejorada para handleVersionSelect
  const handleVersionSelect = (version) => {
    setManualMonthlyOverride(false);
    setMensualidadC("");
    setMensualidadDisplay("");

    const versionPrice = parseFloat(version.price || 0);
    const ventaBase = selectedMailDataRef.current || selectedMailData || {};
    const ventaConVersion = {
      ...ventaBase,
      version_vehiculo: version.text,
      precio_vehiculo: Math.round(versionPrice),
    };

    selectedMailDataRef.current = ventaConVersion;
    setSelectedMailData((prev) =>
      prev && String(prev.id || "") === String(ventaConVersion.id || "")
        ? {
            ...prev,
            version_vehiculo: version.text,
            precio_vehiculo: Math.round(versionPrice),
          }
        : prev,
    );

    const basePlansForVersion =
      Array.isArray(plansState) && plansState.length
        ? plansState
        : initialPlans;
    const seleccionPerteneceVentaActual =
      Boolean(selectedPlanVentaIdRef.current) &&
      String(selectedPlanVentaIdRef.current) ===
        String(ventaConVersion?.id || "");
    const selectedPlanKeyBefore = seleccionPerteneceVentaActual
      ? normalizarNombrePlan(
          (Array.isArray(basePlansForVersion)
            ? basePlansForVersion.find(
                (plan) => plan?.isSelected && !esPlanCliente(plan),
              )
            : null) ||
            selectedPlanForFinancing ||
            selectedPlan ||
            "",
        )
      : "";

    const updatedPlans = normalizarSeleccionPlanes(
      aplicarReglasPlanesCliente(
        basePlansForVersion,
        ventaConVersion,
        formDataRef.current || {},
        { preserveEditablePlans: true },
      ),
      {
        preferredSelectedKey: selectedPlanKeyBefore,
        preserveSelection: seleccionPerteneceVentaActual,
      },
    );

    const selectedIndexFromUpdated = updatedPlans.findIndex(
      (plan) => plan?.isSelected && !esPlanCliente(plan),
    );
    const selectedPlanSnapshot =
      selectedIndexFromUpdated >= 0
        ? updatedPlans[selectedIndexFromUpdated]
        : selectedPlanForFinancing;

    const planPrice = getPlanAccessoriesTotalForFinancing(selectedPlanSnapshot);
    const total = Math.round(versionPrice + planPrice);

    setPlansState(updatedPlans);
    setBasePlansState((prev) =>
      Array.isArray(prev) && prev.length ? prev : updatedPlans,
    );

    if (selectedPlanSnapshot) {
      selectedPlanVentaIdRef.current = String(ventaConVersion?.id || "");
      setSelectedPlan(selectedPlanSnapshot);
      setSelectedPlanFinal(
        selectedIndexFromUpdated >= 0 ? selectedIndexFromUpdated : null,
      );
      setSelectedPlanIndex(
        selectedIndexFromUpdated >= 0 ? selectedIndexFromUpdated : null,
      );
    }

    setSelectedVersion(version.text);
    setPrecioVehiculo(versionPrice);
    setPrecioTotal(total);

    const ventaConVersionYPlanes = {
      ...ventaConVersion,
      precio_total: total,
      planes_financiamiento: updatedPlans,
    };

    markLocalFinancingPatch(ventaConVersion.id, {
      version_vehiculo: version.text,
      precio_vehiculo: Math.round(versionPrice),
      precio_total: total,
    });

    selectedMailDataRef.current = ventaConVersionYPlanes;
    setSelectedMailData((prev) =>
      prev && String(prev.id || "") === String(ventaConVersion.id || "")
        ? {
            ...prev,
            version_vehiculo: version.text,
            precio_vehiculo: Math.round(versionPrice),
            precio_total: total,
            planes_financiamiento: updatedPlans,
          }
        : prev,
    );
    setMailData((prev) =>
      Array.isArray(prev)
        ? prev.map((item) =>
            String(item?.id || "") === String(ventaConVersion.id || "")
              ? {
                  ...item,
                  version_vehiculo: version.text,
                  precio_vehiculo: Math.round(versionPrice),
                  precio_total: total,
                  planes_financiamiento: updatedPlans,
                }
              : item,
          )
        : prev,
    );

    persistPlanesFinanciamientoSnapshot(updatedPlans, total);

    // Recalcular valores financieros con el nuevo precio y el paquete ya recalculado.
    const parseMonthsForVersionSelect = (value) => {
      const parsed = Number(String(value ?? "").replace(/\D/g, ""));
      return Number.isFinite(parsed) && parsed > 0 ? parsed : 0;
    };

    const allowedMonthsForVersion =
      formData.pago_contado === "Si"
        ? CASH_MONTHS_BASE
        : getAllowedCreditMonths(
            getCondicionesFinanciamientoCredito(ventaConVersion),
          );
    const defaultMonthsForVersion =
      allowedMonthsForVersion[allowedMonthsForVersion.length - 1] || 12;
    const monthsForVersionUpdate = normalizeFinancingMonths(
      getMesesFromVentaBD(
        selectedMailDataRef.current || ventaConVersionYPlanes,
      ) ||
        parseMonthsForVersionSelect(
          formDataRef.current?.meses_financiamiento ||
            formDataRef.current?.plazo_meses,
        ) ||
        financingMonths ||
        defaultMonthsForVersion,
      formData.pago_contado === "Si",
    );

    let values;

    if (formData.pago_contado === "Si") {
      values = calculateFinancingValues({
        basePrice: total,
        downPaymentAmount: versionPrice,
        financingMonths: monthsForVersionUpdate,
        origin: "handleVersionSelect",
      });
    } else {
      values = calculateFinancingValues({
        basePrice: total,
        downPaymentAmount: getEngancheActual(total),
        financingMonths: monthsForVersionUpdate,
        origin: "handleVersionSelect",
      });
    }

    setFinancingMonths(monthsForVersionUpdate);
    setFormData((prev) => {
      const nextFormData = {
        ...prev,
        plazo_meses: String(monthsForVersionUpdate),
        meses_financiamiento: String(monthsForVersionUpdate),
      };

      formDataRef.current = nextFormData;
      return nextFormData;
    });

    updateAllFinancingStates(values);

    // Enviar actualización de versión al backend
    const versionRequestData = {
      access_token: accessToken,
      venta_id: ventaConVersion.id,
      version_vehiculo: version.text,
      precio_vehiculo: Math.round(versionPrice),
      precio_total: total,
    };

    fetch(apiUpdateVersionUrl, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(versionRequestData),
    });

    // Enviar actualización de financiamiento por el flujo centralizado.
    updateFinancingData({
      precioTotal: total,
      planTotalPrice: planPrice,
      financingMonths: monthsForVersionUpdate,
      meses_financiamiento: monthsForVersionUpdate,
      plazo_meses: String(monthsForVersionUpdate),
      enganche: values.downPaymentAmount,
      porcentajeEnganche: values.downPaymentPercentage,
      mensualidad: values.monthlyPayment,
    });
  };


  const pickAsesorFinancialDraftFormData = useCallback((draftFormData = {}) => {
    const allowedKeys = [
      "enganche",
      "engancheEditable",
      "mensualidad_buscada",
      "plazo_meses",
      "meses_financiamiento",
    ];

    return allowedKeys.reduce((acc, key) => {
      const value = draftFormData?.[key];

      if (
        value !== undefined &&
        value !== null &&
        String(value).trim() !== ""
      ) {
        acc[key] = value;
      }

      return acc;
    }, {});
  }, []);


  const isSaboneCompleto = useMemo(() => {
    const e = formData?.entrevista_nissan || {};

    const requeridos = [
      e.tiene_vehiculo_actual,
      e.busca_en_vehiculo,
      e.quien_manejara,
      e.uso_vehiculo,
      e.factor_importante_compra,
      e.viaja_carretera,
      e.cuando_compra,
      e.toma_decision_compra,
    ];

    if (e.tiene_vehiculo_actual === "Si") {
      requeridos.push(e.deja_a_cuenta);
    }

    return (
      requeridos.every((v) => String(v || "").trim() !== "") &&
      Array.isArray(e.motivantes_compra) &&
      e.motivantes_compra.length > 0
    );
  }, [formData?.entrevista_nissan]);

  const lastSavedRef = useRef(null);
  const nissanEntrevistaSaveTimeoutRef = useRef(null);
  const hasInitializedRef = useRef(false);

  useEffect(() => {
    // La carga de entrevista se hace en el efecto principal de selectedMailData?.id,
    // donde los campos financieros de BD tienen prioridad sobre el JSON entrevista.
    // Evitamos este merge parcial para que una entrevista vieja no pise meses,
    // mensualidad o enganche recién guardados.
  }, [selectedMailData?.entrevista]);

  const toISODate = (dateStr) => {
    if (!dateStr) return "";
    // si ya viene ISO
    if (/^\d{4}-\d{2}-\d{2}$/.test(dateStr)) return dateStr;

    // si viene DD/MM/YYYY
    if (/^\d{2}\/\d{2}\/\d{4}$/.test(dateStr)) {
      const [dd, mm, yyyy] = dateStr.split("/");
      return `${yyyy}-${mm}-${dd}`;
    }

    return ""; // cualquier otro formato raro
  };

  useEffect(() => {
    if (!selectedMailData) return;

    try {
      const data = selectedMailData.entrevista
        ? JSON.parse(selectedMailData.entrevista)
        : {};

      const entrevistaNissan = selectedMailData.entrevista_nissan
        ? typeof selectedMailData.entrevista_nissan === "string"
          ? JSON.parse(selectedMailData.entrevista_nissan)
          : selectedMailData.entrevista_nissan
        : {};

      const engancheInicial =
        selectedMailData.engancheEditable ||
        selectedMailData.enganche ||
        data.engancheEditable ||
        data.enganche ||
        "";

      const firstNonEmpty = (...values) => {
        const found = values.find(
          (value) =>
            value !== undefined &&
            value !== null &&
            String(value).trim() !== "",
        );

        return found !== undefined && found !== null ? String(found) : "";
      };

      const selectedVentaId = String(selectedMailData.id || "");
      const currentFormBeforeLoad = formDataRef.current || {};
      const currentVentaIdBeforeLoad = String(
        currentFormBeforeLoad.venta_id || selectedMailDataRef.current?.id || "",
      );
      const personalPatchActivo =
        getActiveLocalPersonalDataPatch(selectedVentaId) || {};
      const shouldPreservePersonalData =
        selectedVentaId &&
        currentVentaIdBeforeLoad === selectedVentaId &&
        (isUserEditing.current ||
          Boolean(Object.keys(personalPatchActivo || {}).length));

      const newFormData = {
        // Información personal: normalmente se toma de columnas principales de BD.
        // Mientras el asesor escribe, se conserva el draft local para evitar que
        // el polling o una rehidratación vuelva a pintar el valor anterior.
        nombre: shouldPreservePersonalData
          ? String(
              personalPatchActivo.nombre ??
                currentFormBeforeLoad.nombre ??
                selectedMailData.nombre ??
                "",
            )
          : String(selectedMailData.nombre || ""),
        apellido_paterno: shouldPreservePersonalData
          ? String(
              personalPatchActivo.apellido_paterno ??
                currentFormBeforeLoad.apellido_paterno ??
                selectedMailData.apellido_paterno ??
                "",
            )
          : String(selectedMailData.apellido_paterno || ""),
        apellido_materno: shouldPreservePersonalData
          ? String(
              personalPatchActivo.apellido_materno ??
                currentFormBeforeLoad.apellido_materno ??
                selectedMailData.apellido_materno ??
                "",
            )
          : String(selectedMailData.apellido_materno || ""),
        fecha_nacimiento: shouldPreservePersonalData
          ? String(
              personalPatchActivo.fecha_nacimiento ??
                currentFormBeforeLoad.fecha_nacimiento ??
                selectedMailData.fecha_nacimiento ??
                "",
            )
          : String(selectedMailData.fecha_nacimiento || ""),
        rfc: shouldPreservePersonalData
          ? String(
              personalPatchActivo.rfc ??
                currentFormBeforeLoad.rfc ??
                selectedMailData.rfc ??
                "",
            )
          : String(selectedMailData.rfc || ""),
        homoclave: shouldPreservePersonalData
          ? String(
              personalPatchActivo.homoclave ??
                currentFormBeforeLoad.homoclave ??
                selectedMailData.homoclave ??
                "",
            )
          : String(selectedMailData.homoclave || ""),
        telefono: shouldPreservePersonalData
          ? String(
              personalPatchActivo.telefono ??
                currentFormBeforeLoad.telefono ??
                selectedMailData.telefono ??
                "",
            )
          : String(selectedMailData.telefono || ""),
        correo_electronico: shouldPreservePersonalData
          ? String(
              personalPatchActivo.correo_electronico ??
                currentFormBeforeLoad.correo_electronico ??
                selectedMailData.correo_electronico ??
                "",
            )
          : String(selectedMailData.correo_electronico || ""),
        asesor: data.asesor || "",
        user_id: data.user_id || "",
        venta_id: data.venta_id || selectedMailData.id || "",
        enganche: engancheInicial,
        engancheEditable: engancheInicial,

        entrevista_nissan: {
          tiene_vehiculo_actual: entrevistaNissan.tiene_vehiculo_actual || "",
          deja_a_cuenta: entrevistaNissan.deja_a_cuenta || "",
          busca_en_vehiculo: entrevistaNissan.busca_en_vehiculo || "",
          quien_manejara: entrevistaNissan.quien_manejara || "",
          uso_vehiculo: entrevistaNissan.uso_vehiculo || "",
          factor_importante_compra:
            entrevistaNissan.factor_importante_compra || "",
          viaja_carretera: entrevistaNissan.viaja_carretera || "",
          cuando_compra: entrevistaNissan.cuando_compra || "",
          toma_decision_compra: entrevistaNissan.toma_decision_compra || "",
          motivantes_compra: Array.isArray(entrevistaNissan.motivantes_compra)
            ? entrevistaNissan.motivantes_compra
            : [],
        },

        pago_contado: data.pago_contado || "",

        nr_personalidad_juridica: data.nr_personalidad_juridica || "",
        nr_tipo_operacion: nrGetTipoOperacionFromEntrevista(
          { ...data, pago_contado: data.pago_contado || selectedMailData.depende_auto || "" },
          selectedMailData,
        ),
        nr_agencia_clave: data.nr_agencia_clave || NR_DEFAULT_AGENCIA_CLAVE,
        nr_agencia_id: data.nr_agencia_id || String(NR_DEFAULT_AGENCIA_ID),
        nr_estado_id: data.nr_estado_id || "",
        nr_estado_nombre: data.nr_estado_nombre || "",
        nr_municipio_id: data.nr_municipio_id || "",
        nr_municipio_nombre: data.nr_municipio_nombre || "",
        nr_tipo_seguro_id: data.nr_tipo_seguro_id || "",
        nr_tipo_seguro_nombre: data.nr_tipo_seguro_nombre || "",
        nr_seguro_vida_id: data.nr_seguro_vida_id || "",
        nr_anzen_id: data.nr_anzen_id || NR_CONFIG_ANZEN_ID,
        nr_aseguradora_id: data.nr_aseguradora_id || "",
        nr_aseguradora_nombre: data.nr_aseguradora_nombre || "",
        nr_cobertura_id: data.nr_cobertura_id || "",
        nr_cobertura_nombre: data.nr_cobertura_nombre || "",
        nr_udi_id: data.nr_udi_id || "",
        nr_udi_nombre: data.nr_udi_nombre || "",
        nr_uso_id: data.nr_uso_id || "",
        nr_uso_nombre: data.nr_uso_nombre || "",
        nr_producto_id: data.nr_producto_id || "",
        nr_producto_descripcion: data.nr_producto_descripcion || "",
        nr_producto_tipo_precio_id:
          data.nr_producto_tipo_precio_id || "",
        nr_anzen_producto_id: data.nr_anzen_producto_id || "",
        nr_tipo_producto_id: data.nr_tipo_producto_id || "",
        nr_broker_id: data.nr_broker_id || "",
        nr_marca_id: data.nr_marca_id || "",
        nr_marca_nombre: data.nr_marca_nombre || "",
        nr_modelo_id: data.nr_modelo_id || "",
        nr_modelo_nombre: data.nr_modelo_nombre || "",
        nr_version_id: data.nr_version_id || "",
        nr_version_nombre: data.nr_version_nombre || "",
        nr_estrategia_id: data.nr_estrategia_id || "",
        nr_estrategia_nombre: data.nr_estrategia_nombre || "",
        nr_plan_id: data.nr_plan_id || "",
        nr_plan_nombre: data.nr_plan_nombre || "",
        nr_paquete_externo_id: data.nr_paquete_externo_id || "",
        nr_plazo: data.nr_plazo || "",
        nr_seguro_anzen_key: data.nr_seguro_anzen_key || "",
        nr_seguro_anzen_id: data.nr_seguro_anzen_id || "",
        nr_seguro_anzen_campania_id:
          data.nr_seguro_anzen_campania_id || "",
        nr_seguro_anzen_amount: data.nr_seguro_anzen_amount || "0",
        nr_seguro_anzen_total_amount:
          data.nr_seguro_anzen_total_amount || "0",
        nr_seguro_anzen_surcharges:
          data.nr_seguro_anzen_surcharges || "0",
        nr_seguro_anzen_tipo: data.nr_seguro_anzen_tipo || "",
        nr_cotizacion_id:
          data.nr_cotizacion_id ||
          selectedMailData.procotiza_id_cotizacion ||
          selectedMailData.idCotizacionNR ||
          "",
        nr_cotizacion_portal_id:
          data.nr_cotizacion_portal_id ||
          selectedMailData.procotiza_id_cotizacion_portal ||
          "",

        // Contado
        presupuesto_definido: data.presupuesto_definido || "",
        interes_proteccion: data.interes_proteccion || "",

        // Crédito (base)
        historial_credito: data.historial_credito || "",
        inversion_inicial:
          selectedMailData.enganche ||
          selectedMailData.engancheEditable ||
          data.inversion_inicial ||
          "",
        mensualidad_buscada:
          selectedMailData.mensualidad_estimacion ||
          data.mensualidad_buscada ||
          "",
        plazo_meses:
          selectedMailData.meses_financiamiento ||
          data.meses_financiamiento ||
          data.plazo_meses ||
          "",
        meses_financiamiento:
          selectedMailData.meses_financiamiento ||
          data.meses_financiamiento ||
          data.plazo_meses ||
          "",
        acepta_seguro_auto: data.acepta_seguro_auto || "",
        comprueba_ingresos: data.comprueba_ingresos || "",

        // Crédito SI comprueba
        tipo_actividad: data.tipo_actividad || "",
        actividad_empresa: data.actividad_empresa || "",
        fecha_inicio_actividades: toISODate(
          data.fecha_inicio_actividades || "",
        ),
        nombre_empresa_negocio: data.nombre_empresa_negocio || "",
        ingreso_mensual: data.ingreso_mensual || "",

        // Crédito NO comprueba
        actividad_no_comprobable: data.actividad_no_comprobable || "",
        fecha_inicio_actividades_no_comprobable: toISODate(
          data.fecha_inicio_actividades_no_comprobable || "",
        ),
        ingreso_mensual_no_comprobable:
          data.ingreso_mensual_no_comprobable || "",

        // Garantías
        condiciones_calle_extra: data.condiciones_calle_extra || "",
        interes_llaves: data.interes_llaves || "",
        ha_dejado_taller: data.ha_dejado_taller || "",
        garantia_seminuevo: data.garantia_seminuevo || "",
        desea_polarizado: data.desea_polarizado || "",
        desea_kit_emergencia: data.desea_kit_emergencia || "",
        tiempo_real: data.tiempo_real || "",
        respaldo_auto: data.respaldo_auto || "",

        // extras si los usas
        importancia_auto_sustituto: data.importancia_auto_sustituto || "",
        usa_en_lodo: data.usa_en_lodo || "",
        importancia_tapiceria: data.importancia_tapiceria || "",
      };

      const parseMesesInicialesVenta = (value) => {
        const parsed = Number(String(value ?? "").replace(/\D/g, ""));
        return Number.isFinite(parsed) && parsed > 0 ? parsed : 0;
      };

      const mesesIniciales =
        selectedMailData.meses_financiamiento ||
        selectedMailData.plazo_meses ||
        data.meses_financiamiento ||
        data.plazo_meses ||
        "";

      const mesesInicialesNumero = parseMesesInicialesVenta(mesesIniciales);
      const mesesDefaultSeleccionVenta = normalizeFinancingMonths(
        "",
        String(
          data.pago_contado || selectedMailData.depende_auto || "",
        ).trim() === "Si",
      );
      const mesesInicialesFinal =
        mesesInicialesNumero > 0
          ? mesesInicialesNumero
          : mesesDefaultSeleccionVenta;

      const mergedFormData = {
        ...newFormData,
        venta_id: selectedMailData.id || newFormData.venta_id || "",
        enganche: engancheInicial ? formatNumberEnganche(engancheInicial) : "",
        engancheEditable: engancheInicial
          ? formatNumberEnganche(engancheInicial)
          : "",
        mensualidad_buscada: newFormData.mensualidad_buscada
          ? formatNumber(newFormData.mensualidad_buscada)
          : "",
        plazo_meses: mesesInicialesFinal ? String(mesesInicialesFinal) : "",
        meses_financiamiento: mesesInicialesFinal
          ? String(mesesInicialesFinal)
          : "",
      };

      setFormData(mergedFormData);
      formDataRef.current = mergedFormData;

      if (mesesInicialesFinal > 0) {
        setFinancingMonths(mesesInicialesFinal);
        setModalFinancingMonthsManual(mesesInicialesFinal, {
          dirty: false,
          force: true,
        });
      }

      // Si la venta no traía meses, los guardamos de inmediato con el plazo más alto
      // permitido para que el select y la BD nazcan sincronizados.
      if (
        !mesesInicialesNumero &&
        selectedMailData.id &&
        mesesInicialesFinal > 0
      ) {
        const ventaIdDefault = String(selectedMailData.id || "");

        markLocalFinancingPatch(ventaIdDefault, {
          plazo_meses: String(mesesInicialesFinal),
          meses_financiamiento: mesesInicialesFinal,
        });

        patchSelectedVentaInterviewLocal(ventaIdDefault, {
          entrevista: mergedFormData,
        });

        queueAutoGuardarEntrevista(mergedFormData, 250);

        guardarFinanciamientoSnapshotBD({
          venta_id: ventaIdDefault,
          plazo_meses: String(mesesInicialesFinal),
          meses_financiamiento: mesesInicialesFinal,
        }).catch((error) => {
          console.error(
            "Error guardando meses por defecto al seleccionar venta:",
            error,
          );
        });
      }

      if (engancheInicial) {
        engancheCVentaIdRef.current = String(selectedMailData.id || "");
        setEngancheC(String(toNumber(engancheInicial) || ""));
        setEngancheDisplay(formatInputCurrency(engancheInicial));
      } else {
        engancheCVentaIdRef.current = "";
        setEngancheC("");
        setEngancheDisplay("");
      }

      const mensualidadInicial =
        selectedMailData.mensualidad_estimacion ||
        data.mensualidad_buscada ||
        "";

      if (mensualidadInicial) {
        setMensualidadC(String(toNumber(mensualidadInicial) || ""));
        setMensualidadDisplay(formatInputCurrency(mensualidadInicial));
      } else {
        setMensualidadC("");
        setMensualidadDisplay("");
      }

      if (selectedMailData.perdio_llaves) {
        setTasaC(String(selectedMailData.perdio_llaves));
      }

      const baseInicial = toNumber(
        selectedMailData.precio_total || selectedMailData.precio_vehiculo || 0,
      );
      const engancheNumber = toNumber(engancheInicial);

      const minPct = getMinDownPaymentPercentage(selectedMailData);

      if (data.pago_contado === "Si") {
        setDownPaymentPercentage(100);
      } else if (baseInicial > 0 && engancheNumber > 0) {
        const porcentajeInicial =
          Math.round((engancheNumber / baseInicial) * 100 * 100) / 100;

        setDownPaymentPercentage(Math.max(minPct, porcentajeInicial));
      } else {
        setDownPaymentPercentage(minPct);
      }
    } catch (err) {
      console.error("Error al parsear entrevista:", err);
    }
  }, [
    selectedMailData?.id,
    getActiveLocalPersonalDataPatch,
    normalizeFinancingMonths,
    getMinDownPaymentPercentage,
    setModalFinancingMonthsManual,
    markLocalFinancingPatch,
    patchSelectedVentaInterviewLocal,
    queueAutoGuardarEntrevista,
  ]);

  // Auto-guardado
  const autoGuardar = (dataToSave) => {
    const ventaActual = selectedMailDataRef.current || selectedMailData || {};
    const ventaId = String(
      dataToSave?.venta_id || ventaActual?.id || selectedMailData?.id || "",
    );

    if (!ventaId) return;

    const parseMesesForEntrevista = (value) => {
      const parsed = Number(String(value ?? "").replace(/\D/g, ""));
      return Number.isFinite(parsed) && parsed > 0 ? parsed : 0;
    };

    const mesesDesdeVenta = getMesesFromVentaBD(ventaActual);
    const mesesDesdeData = parseMesesForEntrevista(
      dataToSave?.meses_financiamiento || dataToSave?.plazo_meses,
    );
    const mesesFinales = mesesDesdeData || mesesDesdeVenta;

    const entrevistaToSave = {
      ...(dataToSave || {}),
      venta_id: ventaId,
      ...(mesesFinales > 0
        ? {
            plazo_meses: String(mesesFinales),
            meses_financiamiento: String(mesesFinales),
          }
        : {}),
    };

    patchSelectedVentaInterviewLocal(ventaId, {
      entrevista: entrevistaToSave,
    });

    const saveSignature = JSON.stringify({
      venta_id: ventaId,
      entrevista: entrevistaToSave,
    });

    // Evita guardar si no ha cambiado, pero tomando en cuenta la venta.
    // Antes la comparación era sólo por entrevista y podía bloquear una venta nueva.
    if (saveSignature === lastSavedRef.current) return;

    fetch(apiUrlEntrevista, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        access_token: accessToken,
        id: ventaId,
        entrevista: entrevistaToSave,
      }),
    })
      .then((res) => res.json())
      .then((data) => {
        const saveOk =
          data?.success === true ||
          data?.statusCode === 200 ||
          String(data?.type || "").toUpperCase() === "OK" ||
          String(data?.data?.type || "").toUpperCase() === "OK";

        if (saveOk) {
          lastSavedRef.current = saveSignature;
        } else {
          console.error("Error al guardar:", data);
        }
      })
      .catch((err) => console.error("Error de conexión:", err));
  };

  autoGuardarFnRef.current = autoGuardar;

  // Función para agregar las comas al número.
  // Importante: si llega un decimal como 11033.00, NO se debe convertir en 1,103,300.
  const formatNumber = (value) => {
    const rawValue = String(value ?? "").trim();
    if (!rawValue) return "";

    const numberValue = toNumber(rawValue);
    if (!Number.isFinite(numberValue)) return "";

    return Math.round(numberValue).toLocaleString("es-MX");
  };

  function formatNumberEnganche(value) {
    //Ya
    const number = toNumber(value);
    if (!number) return "";
    return Math.round(number).toLocaleString("es-MX");
  }
  const [validationMessage, setValidationMessage] = useState("");

  const syncManualEnganche = useCallback(
    async ({
      rawValue,
      basePrice: basePriceParam = null,
      clampMin = false,
      source = "syncManualEnganche",
      fromModal = false,
      updateBackend = true,
    }) => {
      const ventaActual = selectedMailDataRef.current || selectedMailData;
      const ventaId = String(
        ventaActual?.id ||
          formDataRef.current?.venta_id ||
          formData?.venta_id ||
          "",
      );

      if (updateBackend && !fromModal) {
        releaseManualFinancingModalSaved(ventaId);
      }

      const cleanValue = String(rawValue ?? "")
        .replace(/[$,]/g, "")
        .replace(/[^0-9.]/g, "");

      if (cleanValue === "" || cleanValue === ".") {
        manualEngancheVentaIdRef.current = ventaId;
        manualEngancheValueRef.current = "";
        setValidationMessage("");
        setValidationMessageC("");
        return null;
      }

      const numericValue = Number(cleanValue);
      if (!Number.isFinite(numericValue)) return null;

      const basePrice = toNumber(basePriceParam ?? getBasePrice());
      if (basePrice <= 0) return null;

      const minPct = getMinDownPaymentPercentage(ventaActual);
      const minEnganche = getMinDownPaymentAmount(basePrice, ventaActual);
      const isBelowMin = numericValue < minEnganche;
      const minMessage = `El porcentaje mínimo de enganche es del ${minPct}% (${new Intl.NumberFormat(
        "es-MX",
      ).format(minEnganche)})`;

      manualEngancheVentaIdRef.current = ventaId;
      manualEngancheValueRef.current = String(numericValue);
      engancheCVentaIdRef.current = ventaId;
      setUserEditedEnganche(true);
      setManualMonthlyOverride(false);

      if (isBelowMin && !clampMin) {
        if (fromModal) setValidationMessageC(minMessage);
        else setValidationMessage(minMessage);

        // Mientras el asesor está escribiendo, NO forzamos el mínimo.
        // Esto evita que al capturar 100,000 se rebote antes de terminar de escribir.
        const formattedCleanValue = cleanValue ? formatNumber(cleanValue) : "";

        setFormData((prev) => {
          const next = {
            ...prev,
            enganche: formattedCleanValue,
            engancheEditable: formattedCleanValue,
            inversion_inicial: formattedCleanValue,
          };

          formDataRef.current = next;
          return next;
        });
        setEngancheC(cleanValue);
        setEngancheDisplay(formatInputCurrency(cleanValue));

        if (ventaId) {
          mergeAsesorDraft(ventaId, {
            formData: {
              ...(loadAsesorDraft(ventaId)?.formData || {}),
              ...(formDataRef.current || {}),
              enganche: formattedCleanValue,
              engancheEditable: formattedCleanValue,
            },
            engancheC: cleanValue,
            engancheDisplay: formatInputCurrency(cleanValue),
          });
        }

        return null;
      }

      const engancheFinal = Math.round(
        isBelowMin && clampMin ? minEnganche : numericValue,
      );

      if (fromModal) setValidationMessageC("");
      else setValidationMessage("");

      const values = calculateFinancingValues({
        basePrice,
        downPaymentAmount: engancheFinal,
        financingMonths,
        origin: source,
      });

      if (ventaId) {
        markLocalFinancingPatch(ventaId, {
          enganche: values.downPaymentAmount,
          engancheEditable: values.downPaymentAmount,
          porcentaje_enganche: values.downPaymentPercentage,
          mensualidad_estimacion: values.monthlyPayment,
          meses_financiamiento: financingMonths,
          plazo_meses: String(financingMonths),
        });
      }

      updateAllFinancingStates(values, { force: true });

      manualEngancheValueRef.current = String(values.downPaymentAmount);
      setEngancheC(String(values.downPaymentAmount));
      setEngancheDisplay(formatInputCurrency(values.downPaymentAmount));
      setMensualidadC(String(values.monthlyPayment));
      setMensualidadDisplay(formatInputCurrency(values.monthlyPayment));

      if (ventaId) {
        mergeAsesorDraft(ventaId, {
          formData: {
            ...(loadAsesorDraft(ventaId)?.formData || {}),
            ...(formDataRef.current || {}),
            enganche: formatNumber(String(values.downPaymentAmount)),
            engancheEditable: formatNumber(String(values.downPaymentAmount)),
            mensualidad_buscada: formatNumber(String(values.monthlyPayment)),
          },
          engancheC: String(values.downPaymentAmount),
          engancheDisplay: formatInputCurrency(values.downPaymentAmount),
          downPaymentPercentage: values.downPaymentPercentage,
          mensualidadC: String(values.monthlyPayment),
          mensualidadDisplay: formatInputCurrency(values.monthlyPayment),
          financingMonths,
        });
      }

      if (updateBackend && ventaId) {
        try {
          const requestData = {
            access_token: accessToken,
            venta_id: ventaId,
            enganche: values.downPaymentAmount,
            porcentaje_enganche: values.downPaymentPercentage,
            mensualidad_estimacion: values.monthlyPayment,
          };

          await fetch(apiUpdateEstadoUrl, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(requestData),
          });
        } catch (error) {
          console.error("Error actualizando enganche manual:", error);
        }
      }

      return values;
    },
    [
      selectedMailData,
      formData?.venta_id,
      getBasePrice,
      calculateFinancingValues,
      financingMonths,
      updateAllFinancingStates,
      mergeAsesorDraft,
      loadAsesorDraft,
      accessToken,
      apiUpdateEstadoUrl,
      getMinDownPaymentPercentage,
      getMinDownPaymentAmount,
      markLocalFinancingPatch,
      releaseManualFinancingModalSaved,
    ],
  );

  const handleEngancheFocus = (e) => {
    const currentValue =
      e?.target?.value ||
      formDataRef.current?.engancheEditable ||
      formDataRef.current?.enganche ||
      "";
    const cleanValue = String(currentValue || "").replace(/[^0-9]/g, "");

    engancheDraftOriginalRawRef.current = cleanValue;
    isUserEditing.current = true;
    startFinancingEdit("enganche");
    setEngancheDraftInput(cleanValue ? formatNumber(cleanValue) : "");

    requestAnimationFrame(() => {
      try {
        e?.target?.select?.();
      } catch {}
    });
  };

  // Manejador mejorado para cambio de enganche.
  // Sólo permite escribir. La validación/cálculo se hace en blur para no rebotar el input.
  const handleEngancheChange = (e) => {
    const { value } = e.target;
    const cleanValue = value.replace(/[^0-9]/g, "");
    const formattedValue = cleanValue ? formatNumber(cleanValue) : "";
    const ventaActual = selectedMailDataRef.current || selectedMailData;
    const ventaId = String(
      ventaActual?.id || formDataRef.current?.venta_id || "",
    );

    // Igual que mensualidad: mientras se escribe sólo actualizamos el draft.
    // También reflejamos el valor en formDataRef/formData para que ningún render
    // lateral pinte el enganche anterior mientras el asesor sigue capturando.
    startFinancingEdit("enganche");
    setEngancheDraftInput(formattedValue);
    setUserEditedEnganche(true);
    setManualMonthlyOverride(false);
    manualEngancheVentaIdRef.current = ventaId;
    manualEngancheValueRef.current = cleanValue;
    engancheCVentaIdRef.current = ventaId;

    setFormData((prev) => {
      const next = {
        ...(prev || {}),
        enganche: formattedValue,
        engancheEditable: formattedValue,
        inversion_inicial: formattedValue,
      };

      formDataRef.current = next;
      return next;
    });

    if (ventaId) {
      markLocalFinancingPatch(ventaId, {
        enganche: cleanValue,
        engancheEditable: cleanValue,
      });
    }

    if (engancheTimeoutRef.current) {
      clearTimeout(engancheTimeoutRef.current);
    }

    setValidationMessage("");
  };

  const handleEngancheBlur = async () => {
    if (engancheTimeoutRef.current) {
      clearTimeout(engancheTimeoutRef.current);
    }

    const value =
      activeFinancingEditRef.current === "enganche"
        ? engancheDraftInput
        : formDataRef.current?.engancheEditable ||
          formDataRef.current?.enganche ||
          "";

    const rawValue = String(value || "").replace(/\D/g, "");

    if (rawValue === engancheDraftOriginalRawRef.current) {
      engancheDraftOriginalRawRef.current = "";
      finishFinancingEdit("enganche");
      return;
    }

    await syncManualEnganche({
      rawValue,
      clampMin: true,
      source: "handleEngancheBlur",
      fromModal: false,
    });

    engancheDraftOriginalRawRef.current = "";
    finishFinancingEdit("enganche");
  };

  const handleMensualidadBuscadaFocus = (e) => {
    const currentValue =
      e?.target?.value || formDataRef.current?.mensualidad_buscada || "";
    const cleanValue = String(currentValue || "").replace(/\D/g, "");

    mensualidadDraftOriginalRawRef.current = cleanValue;
    isUserEditing.current = true;
    startFinancingEdit("mensualidad_buscada");
    setMensualidadDraftInput(cleanValue ? formatNumber(cleanValue) : "");

    // Evita que al intentar escribir 8,000 sobre un valor existente
    // se termine anexando al final y se convierta en 800,000.
    requestAnimationFrame(() => {
      try {
        e?.target?.select?.();
      } catch {}
    });
  };

  // Manejador para cambio de mensualidad.
  // Importante: aquí sólo se escribe el valor. El cálculo se hace en onBlur,
  // para evitar que el campo se rebote mientras el usuario borra o captura dígitos.
  const handleFormattedInputChange = (e) => {
    const { name, value } = e.target;
    const raw = String(value || "").replace(/\D/g, "");
    const formattedValue = raw ? formatNumber(raw) : "";

    if (name === "mensualidad_buscada") {
      // Captura suave: mientras se escribe NO se actualiza formData,
      // NO se manda a BD y NO se recalcula. Sólo se pinta el draft.
      // Esto evita casos como 8,000 -> 800,000 por carreras con polling/efectos.
      isUserEditing.current = true;
      startFinancingEdit("mensualidad_buscada");
      setMensualidadDraftInput(formattedValue);
      setMonthlyPaymentDraft(formattedValue);

      setFormData((prev) => {
        const next = {
          ...(prev || {}),
          mensualidad_buscada: formattedValue,
        };

        formDataRef.current = next;
        return next;
      });

      if (monthlyTimeoutRef.current) {
        clearTimeout(monthlyTimeoutRef.current);
      }

      return;
    }

    keepUserEditingBriefly(10000);

    const next = {
      ...(formDataRef.current || formData || {}),
      [name]: formattedValue,
    };

    formDataRef.current = next;
    setFormData(next);
    patchSelectedVentaInterviewLocal(
      selectedMailDataRef.current?.id || selectedMailData?.id || next.venta_id,
      { entrevista: next },
    );
    queueAutoGuardarEntrevista(next);
  };

  const handleMensualidadBuscadaBlur = () => {
    const rawSource =
      activeFinancingEditRef.current === "mensualidad_buscada"
        ? mensualidadDraftInput
        : formDataRef.current?.mensualidad_buscada || "";
    const raw = String(rawSource || "").replace(/\D/g, "");
    const monthlyNumber = Number(raw);

    // Aunque el valor sea igual al original, recalculamos al salir del campo.
    // Esto corrige casos donde cambia el plan/precio/meses y se vuelve a pedir
    // la misma mensualidad objetivo, pero el enganche aún estaba viejo.
    if (Number.isFinite(monthlyNumber) && monthlyNumber > 0) {
      applyMonthlyPayment(monthlyNumber);
    }

    mensualidadDraftOriginalRawRef.current = "";
    finishFinancingEdit("mensualidad_buscada");
  };
  const autoGuardarTimeout = useRef(null);

  //actualizar el ref cada vez que formData cambie
  useEffect(() => {
    formDataRef.current = formData;
  }, [formData]);

  const [pdfAdjunto, setPdfAdjunto] = useState(null);

  // Función mejorada para handleInputChange
  const handleInputChange = (e) => {
    const { name, value } = e.target;

    keepUserEditingBriefly(10000);

    const currentFormData = formDataRef.current || formData || {};
    let updatedFormData = {
      ...currentFormData,
      [name]: value,
    };

    if (PERSONAL_DATA_FIELDS.has(name)) {
      const ventaId =
        selectedMailDataRef.current?.id ||
        selectedMailData?.id ||
        updatedFormData.venta_id ||
        "";

      formDataRef.current = updatedFormData;
      setFormData(updatedFormData);

      if (ventaId) {
        patchSelectedVentaPersonalLocal(ventaId, { [name]: value });
        patchSelectedVentaInterviewLocal(ventaId, {
          entrevista: updatedFormData,
        });

        // Además del JSON de entrevista, estos campos también son
        // columnas planas de venta_financiamiento (nombre, apellido_paterno,
        // apellido_materno, fecha_nacimiento, rfc, homoclave, telefono,
        // correo_electronico) — se guardan aparte (debounced) para que
        // queden persistidos como columna real, no solo dentro del JSON.
        if (personalDataFlatSaveTimerRef.current) {
          clearTimeout(personalDataFlatSaveTimerRef.current);
        }
        personalDataFlatSaveTimerRef.current = setTimeout(() => {
          fetch(apiUpdateEstadoUrl, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              access_token: accessToken,
              venta_id: ventaId,
              [name]: value,
            }),
          }).catch((error) => {
            console.error(
              `No se pudo persistir ${name} como columna plana:`,
              error,
            );
          });
        }, 800);
      }

      queueAutoGuardarEntrevista(updatedFormData, 700);
      return;
    }

    if (name === "pago_contado") {
      updatedFormData = {
        ...updatedFormData,
        nr_tipo_operacion: nrGetTipoOperacionFromEntrevista(
          { ...updatedFormData, pago_contado: value },
          selectedMailDataRef.current || selectedMailData || {},
        ),
      };
    }

    formDataRef.current = updatedFormData;
    setFormData(updatedFormData);

    patchSelectedVentaInterviewLocal(
      selectedMailDataRef.current?.id ||
        selectedMailData?.id ||
        updatedFormData.venta_id,
      { entrevista: updatedFormData },
    );

    // Actualizar planes derivados de respuestas:
    // Elite = respuestas del cliente, Plan cliente = accesorios elegidos por cliente,
    // Gold = precargado, Platinum = vacío.
    setPlansState((prevPlans) => {
      const selectedPlanKeyBefore = normalizarNombrePlan(
        Array.isArray(prevPlans)
          ? prevPlans.find((plan) => plan?.isSelected && !esPlanCliente(plan))
          : "",
      );

      return normalizarSeleccionPlanes(
        aplicarReglasPlanesCliente(
          prevPlans,
          selectedMailDataRef.current || selectedMailData,
          updatedFormData,
          {
            preserveEditablePlans: true,
          },
        ),
        { preferredSelectedKey: selectedPlanKeyBefore },
      );
    });

    // 3. Lógica especial para pago de contado
    if (name === "pago_contado") {
      actualizarPagoContado(value);

      const basePrice = getBasePrice();
      const vehiclePrice = parseFloat(selectedMailData?.precio_vehiculo || 0);

      if (value === "Si") {
        // Contado: enganche = precio del vehículo
        const values = calculateFinancingValues({
          basePrice,
          downPaymentAmount: vehiclePrice,
          origin: "handleInputChange",
        });
        updateAllFinancingStates(values);
      } else if (value === "No") {
        // Crédito: resetear enganche al mínimo permitido por tipo/año
        const minDownPayment = getMinDownPaymentPercentage();
        const safeMonths = normalizeFinancingMonths(financingMonths, false);
        setDownPaymentPercentage(minDownPayment);
        setFinancingMonths(safeMonths);
        setManualMonthlyOverride(false);

        const values = calculateFinancingValues({
          basePrice,
          downPaymentPercentage: minDownPayment,
          financingMonths: safeMonths,
          origin: "handleInputChange",
        });
        updateAllFinancingStates(values);

        updatedFormData = {
          ...(formDataRef.current || updatedFormData),
          plazo_meses: String(safeMonths),
          meses_financiamiento: String(safeMonths),
        };
        formDataRef.current = updatedFormData;
        setFormData(updatedFormData);
        patchSelectedVentaInterviewLocal(
          selectedMailDataRef.current?.id ||
            selectedMailData?.id ||
            updatedFormData.venta_id,
          { entrevista: updatedFormData },
        );
      }
    }

    // Auto-guardado usando el objeto que acabamos de construir, no un ref viejo.
    queueAutoGuardarEntrevista(formDataRef.current || updatedFormData, 700);
  };

  const handleCheckboxChange = (e) => {
    const { name, checked } = e.target;
    keepUserEditingBriefly(10000);

    const next = {
      ...(formDataRef.current || formData || {}),
      [name]: checked,
    };

    formDataRef.current = next;
    setFormData(next);
    patchSelectedVentaInterviewLocal(
      selectedMailDataRef.current?.id || selectedMailData?.id || next.venta_id,
      { entrevista: next },
    );
    queueAutoGuardarEntrevista(next);
  };

  // La carga completa de datos personales, entrevista consultiva y Sabone
  // se hace en el useEffect principal de selectedMailData?.id.
  // Evitamos una carga parcial con bandera para que un draft local viejo
  // no pise información que sí existe en la BD.
  useEffect(() => {
    if (selectedMailData?.id) {
      datosPersonalesYaCargados.current = false;
      hasInitializedRef.current = false;
      lastSavedRef.current = null;
      lastPlanSnapshotSignatureRef.current = "";
      pendingPlanSnapshotSignatureRef.current = "";
      pendingPlanSnapshotPayloadRef.current = null;
    }
  }, [selectedMailData?.id]);

  // Cargar el 'userName' desde localStorage al montar el componente
  useEffect(() => {
    const storedUserName = localStorage.getItem("userName");
    if (storedUserName) {
      setFormData((prevState) => ({
        ...prevState,
        asesor: storedUserName, // Establecer el nombre del usuario como el asesor
      }));
    }
  }, []);

  // Cargar el 'userId' desde localStorage al montar el componente
  useEffect(() => {
    const storedUserId = localStorage.getItem("userId");
    if (storedUserId) {
      setFormData((prevState) => ({
        ...prevState,
        user_id: storedUserId, // Establecer el id del usuario como el user_id
      }));
    }
  }, []);

  const saveNissanEntrevista = async (entrevistaActualizada) => {
    try {
      const ventaId =
        selectedMailDataRef.current?.id ||
        formDataRef.current?.venta_id ||
        formData.venta_id ||
        "";

      if (!ventaId) return;
      if (!accessToken) return;

      patchSelectedVentaInterviewLocal(ventaId, {
        entrevista_nissan: entrevistaActualizada,
      });

      const payload = {
        access_token: accessToken,
        venta_id: ventaId,
        entrevista_nissan: entrevistaActualizada,
      };

      const resp = await fetch(
        "https://api.checkmark.mx/ventas/financiamiento/nissan-entrevista",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        },
      );

      const json = await resp.json();
    } catch (error) {
      console.error("Error guardando entrevista Nissan:", error);
    }
  };

  const queueSaveNissanEntrevista = (entrevistaActualizada) => {
    keepUserEditingBriefly();

    const snapshot = JSON.parse(JSON.stringify(entrevistaActualizada || {}));

    if (nissanEntrevistaSaveTimeoutRef.current) {
      clearTimeout(nissanEntrevistaSaveTimeoutRef.current);
    }

    nissanEntrevistaSaveTimeoutRef.current = setTimeout(() => {
      saveNissanEntrevista(snapshot);
      nissanEntrevistaSaveTimeoutRef.current = null;
    }, 450);
  };

  const updateNissanEntrevistaField = (field, value) => {
    keepUserEditingBriefly(10000);

    const currentFormData = formDataRef.current || formData || {};
    const base = currentFormData.entrevista_nissan || {};

    let nuevoEntrevista = {
      ...base,
      [field]: value,
    };

    // lógica especial
    if (field === "tiene_vehiculo_actual" && value === "No") {
      nuevoEntrevista.deja_a_cuenta = "";
    }

    const next = {
      ...currentFormData,
      entrevista_nissan: nuevoEntrevista,
    };

    formDataRef.current = next;
    setFormData(next);

    patchSelectedVentaInterviewLocal(
      selectedMailDataRef.current?.id || selectedMailData?.id || next.venta_id,
      { entrevista_nissan: nuevoEntrevista },
    );
    queueSaveNissanEntrevista(nuevoEntrevista);
  };

  const toggleNissanMotivante = (item, checked) => {
    keepUserEditingBriefly(10000);

    const currentFormData = formDataRef.current || formData || {};
    const actual = currentFormData.entrevista_nissan?.motivantes_compra || [];
    const nuevo = checked
      ? [...actual, item]
      : actual.filter((x) => x !== item);

    const nuevoEntrevista = {
      ...(currentFormData.entrevista_nissan || {}),
      motivantes_compra: nuevo,
    };

    const next = {
      ...currentFormData,
      entrevista_nissan: nuevoEntrevista,
    };

    formDataRef.current = next;
    setFormData(next);

    patchSelectedVentaInterviewLocal(
      selectedMailDataRef.current?.id || selectedMailData?.id || next.venta_id,
      { entrevista_nissan: nuevoEntrevista },
    );
    queueSaveNissanEntrevista(nuevoEntrevista);
  };

  const handleSubmit = async () => {
    const resultConfirm = await Swal.fire({
      title: "¿Estás seguro?",
      text: "¿Deseas finalizar la venta?",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Sí, finalizar",
      cancelButtonText: "Cancelar",
      willOpen: () => {
        const container = document.querySelector(".swal2-container");
        if (container) container.style.zIndex = "1000000";
      },
    });

    if (!resultConfirm.isConfirmed) return;

    setIsSubmitting(true);

    const selectedAgency = agencias.find(
      (agency) => agency.ag_id === selectedAgencia,
    );
    const agencyName = selectedAgency ? selectedAgency.nombre : "";

    const sanitizeMoney = (v) => String(v ?? "").replace(/,/g, "");

    const sanitizedFormData = {
      ...formData,
      enganche: sanitizeMoney(
        engancheC !== null && engancheC !== "" ? engancheC : formData.enganche,
      ),
      ingreso_mensual: sanitizeMoney(formData.ingreso_mensual),
      mensualidad_buscada: sanitizeMoney(
        mensualidadC !== null && mensualidadC !== ""
          ? mensualidadC
          : formData.mensualidad_buscada,
      ),
      engancheEditable: sanitizeMoney(
        engancheC !== null && engancheC !== ""
          ? engancheC
          : formData.engancheEditable,
      ),
    };

    const porcentajeEngancheFinal =
      engancheC !== null && engancheC !== "" && Number(getBasePrice()) > 0
        ? Math.round((Number(engancheC) / Number(getBasePrice())) * 100)
        : downPaymentPercentage;

    const dataToSend = {
      ...sanitizedFormData,
      access_token:
        "1MhYphhrGUbgbdRy7cyYFGQlXS7tAi6ooUoptkHQbOm9GcsKiZM7uMF1MERxwMWq30I7Y3",
      marca_vehiculo: selectedMailData?.marca_vehiculo || "",
      modelo_vehiculo: selectedMailData?.modelo_vehiculo || "",
      meses_financiamiento: financingMonths,
      plazo_meses: financingMonths,
      porcentaje_enganche: porcentajeEngancheFinal,
      mensualidad_estimacion:
        mensualidadC !== null && mensualidadC !== ""
          ? Number(mensualidadC)
          : getCurrentMonthlyPayment(),
      agencia: agencyName,
      ag_id: selectedAgencia,
      prueba_manejo: pruebaManejoData,
    };

    try {
      const response = await fetch(
        "https://api.checkmark.mx/ventas/financiamiento",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(dataToSend),
        },
      );

      const result = await response.json();

      if (result.statusCode === 200) {
        // La finalización de Babilonia no debe recalcular ni reemplazar la
        // operación NR. La cotización y el PDF quedan exactamente como fueron
        // guardados explícitamente por el asesor durante el flujo.
        const finalizacionCliente = await finalizarVentaClienteDesdeGuardar(
          selectedMailData?.id || formData?.venta_id || dataToSend?.venta_id,
        );

        const envioCorreo = await enviarSaboneYPdf();

        if (envioCorreo?.ok && finalizacionCliente?.ok) {
          await Swal.fire({
            icon: "success",
            title: "Éxito",
            text: "Venta registrada, cliente finalizado y correos enviados correctamente.",
            confirmButtonText: "Aceptar",
            willOpen: () => {
              const container = document.querySelector(".swal2-container");
              if (container) container.style.zIndex = "1000000";
            },
          });
        } else {
          const mensajesPendientes = [];

          if (!finalizacionCliente?.ok) {
            mensajesPendientes.push(
              finalizacionCliente?.message ||
                "No se pudo finalizar la venta del cliente.",
            );
          }

          if (!envioCorreo?.ok) {
            mensajesPendientes.push(
              envioCorreo?.message || "No se pudieron enviar los correos.",
            );
          }

          await Swal.fire({
            icon: "warning",
            title: "Venta registrada",
            text: mensajesPendientes.join(" "),
            confirmButtonText: "Aceptar",
            willOpen: () => {
              const container = document.querySelector(".swal2-container");
              if (container) container.style.zIndex = "1000000";
            },
          });
        }

        // Cerrar modal de accesorios
        const modalElement = document.getElementById("accessoryModal");
        if (modalElement) {
          const modalInstance = Modal.getInstance(modalElement);
          if (modalInstance) {
            modalInstance.hide();
          }
        }

        // Cerrar modal cotizador
        const cotizadorModalElement = document.getElementById("cotizadorModal");
        if (cotizadorModalElement) {
          const cotizadorModalInstance = Modal.getInstance(
            cotizadorModalElement,
          );
          if (cotizadorModalInstance) {
            cotizadorModalInstance.hide();
          }
        }

        // Limpiar input file del PDF
        const pdfInput = document.getElementById("pdfSaboneAdjunto");
        if (pdfInput) {
          pdfInput.value = "";
        }

        // Limpiar timers
        if (debounceTimer.current) {
          clearTimeout(debounceTimer.current);
          debounceTimer.current = null;
        }

        if (monthlyTimeoutRef.current) {
          clearTimeout(monthlyTimeoutRef.current);
          monthlyTimeoutRef.current = null;
        }

        if (engancheTimeoutRef.current) {
          clearTimeout(engancheTimeoutRef.current);
          engancheTimeoutRef.current = null;
        }

        if (autoGuardarTimeout.current) {
          clearTimeout(autoGuardarTimeout.current);
          autoGuardarTimeout.current = null;
        }

        if (cotizadorMensualidadTimerRef.current) {
          clearTimeout(cotizadorMensualidadTimerRef.current);
          cotizadorMensualidadTimerRef.current = null;
        }

        if (cotizadorEngancheTimerRef.current) {
          clearTimeout(cotizadorEngancheTimerRef.current);
          cotizadorEngancheTimerRef.current = null;
        }

        const ventaFinalizadaId =
          selectedMailDataRef.current?.id ||
          selectedMailData?.id ||
          formDataRef.current?.venta_id ||
          formData?.venta_id ||
          "";

        if (ventaFinalizadaId) {
          clearAsesorDraft(ventaFinalizadaId);
        }

        forgetSelectedVenta();

        // Resetear estados principales
        setFormData({
          nombre: "",
          telefono: "",
          correo_electronico: "",
          asesor: "",
          user_id: "",
          venta_id: "",
          enganche: "",
          engancheEditable: "",

          pago_contado: "",

          presupuesto_definido: "",
          interes_proteccion: "",

          historial_credito: "",
          inversion_inicial: "",
          mensualidad_buscada: "",
          acepta_seguro_auto: "",
          comprueba_ingresos: "",

          tipo_actividad: "",
          actividad_empresa: "",
          fecha_inicio_actividades: "",
          nombre_empresa_negocio: "",
          ingreso_mensual: "",

          actividad_no_comprobable: "",
          fecha_inicio_actividades_no_comprobable: "",
          ingreso_mensual_no_comprobable: "",

          condiciones_calle_extra: "",
          interes_llaves: "",
          ha_dejado_taller: "",
          garantia_seminuevo: "",
          desea_polarizado: "",
          desea_kit_emergencia: "",
          tiempo_real: "",
          respaldo_auto: "",

          importancia_auto_sustituto: "",
          usa_en_lodo: "",
          importancia_tapiceria: "",

          entrevista_nissan: {
            tiene_vehiculo_actual: "",
            deja_a_cuenta: "",
            busca_en_vehiculo: "",
            quien_manejara: "",
            uso_vehiculo: "",
            factor_importante_compra: "",
            viaja_carretera: "",
            cuando_compra: "",
            toma_decision_compra: "",
            motivantes_compra: [],
          },
        });

        // Resetear estados de financiamiento general
        setMonthlyPayment(0);
        setDownPaymentPercentage(15);
        setFinancingMonths(60);
        setIsSubmitted(false);
        setIsEditingMonthly(false);
        setMonthlyPaymentDraft("");
        setUserEditedEnganche(false);
        setManualMonthlyOverride(false);

        // Resetear estados del modal cotizador
        setMensualidadC("");
        setEngancheC("");
        setTasaC("");
        setAseguradora("");
        setMontoSeguro("");

        setMensualidadDisplay("");
        setEngancheDisplay("");
        setTasaDisplay("");
        setMontoSeguroDisplay("");

        setTipoCompraSeguro("");
        setTipoComision("");
        setIncluyePlacas("");
        setMontoComision("");
        setMontoComisionDisplay("");
        setMontoAdicionales("0");
        setMontoAdicionalesDisplay("");
        setMontoPlacas("");
        setShowModalAdicionales(false);
        setAdicionalesContado([]);

        setIsEditingPrice(false);
        setTempPrice("");
        setOriginalPrice("");
        setEngancheDraft("");
        setRegistroCambiado(false);
        setOpenFicha(false);
        setOpenGaleriaSeminuevo(false);
        setGaleriaSeminuevoImages([]);
        setGaleriaSeminuevoIndex(0);
        setFichaURL("");
        setPlansLoaded(false);
        // No limpiamos tableData: contiene el catálogo disponible de accesorios/garantías.
        setShowFloatingActions(false);

        setPdfAdjunto(null);

        // Resetear selección y planes
        setSelectedPlan(null);
        setSelectedPlanFinal(null);
        setSelectedPlanIndex(null);
        setSelectedAgencia("");
        setSelectedMailData(null);
        selectedMailDataRef.current = null;
        setPlansState(initialPlans);
        setBasePlansState(initialPlans);
        setPrecioTotal(0);
        setSelectedVersion(0);
        setPrecioVehiculo(0);
        setSelectedVersion("");
        setSelectedVehicleName("");

        // Resetear estados UI/modales
        // No vaciamos mailData ni agencias al finalizar la venta.
        // Si se limpia mailData aquí, el asesor ya no puede ver/seleccionar
        // las otras ventas hasta recargar la página. Solo quitamos de la lista
        // la venta que se acaba de finalizar.
        setMailData((prev) =>
          Array.isArray(prev)
            ? prev.filter(
                (item) =>
                  String(item?.id || "") !== String(ventaFinalizadaId || ""),
              )
            : prev,
        );
        setLoading(false);
        setPlans([]);
        // Conservamos agencias para que la siguiente venta pueda continuar el flujo.
        setGarantiaExtendida("");
        setContado("");
        setMostrarModalInfo(false);
        datosPersonalesYaCargados.current = false;
        clearTimeout(debounceTimer.current);
        debounceTimer.current = null;
        setPrecioVehiculo(0);
        setVerAccesorios(false);
        setTieneGarantiaExtendida(false);
        setModalOpen(false);
        setAccessoryModalPlanIndex(null);
        setAccessoryModalPlanKey("");
        setSwapOptionsOpen({});

        // Resetear validaciones / flags
        setValidationMessage("");
        setValidationMessageC("");
        setEliminatedAccessories([]);
        setStep(1);
        setIsConfirming(false);
        setIsSubmitting(false);
        setConfirmedVentas({});

        // Resetear refs
        datosPersonalesYaCargados.current = false;
        isUserEditing.current = false;
        lastSavedRef.current = null;
        hasInitializedRef.current = false;
        selectedPlanVentaIdRef.current = "";
        engancheCVentaIdRef.current = "";
        manualEngancheVentaIdRef.current = "";
        manualEngancheValueRef.current = "";
        plansLoadedVentaIdRef.current = "";
        formDataRef.current = {
          nombre: "",
          telefono: "",
          correo_electronico: "",
          asesor: "",
          user_id: "",
          venta_id: "",
          enganche: "",
          engancheEditable: "",
          pago_contado: "",
          presupuesto_definido: "",
          interes_proteccion: "",
          historial_credito: "",
          inversion_inicial: "",
          mensualidad_buscada: "",
          acepta_seguro_auto: "",
          comprueba_ingresos: "",
          tipo_actividad: "",
          actividad_empresa: "",
          fecha_inicio_actividades: "",
          nombre_empresa_negocio: "",
          ingreso_mensual: "",
          actividad_no_comprobable: "",
          fecha_inicio_actividades_no_comprobable: "",
          ingreso_mensual_no_comprobable: "",
          condiciones_calle_extra: "",
          interes_llaves: "",
          ha_dejado_taller: "",
          garantia_seminuevo: "",
          desea_polarizado: "",
          desea_kit_emergencia: "",
          tiempo_real: "",
          respaldo_auto: "",
          importancia_auto_sustituto: "",
          usa_en_lodo: "",
          importancia_tapiceria: "",
          entrevista_nissan: {
            tiene_vehiculo_actual: "",
            deja_a_cuenta: "",
            busca_en_vehiculo: "",
            quien_manejara: "",
            uso_vehiculo: "",
            factor_importante_compra: "",
            viaja_carretera: "",
            cuando_compra: "",
            toma_decision_compra: "",
            motivantes_compra: [],
          },
        };

        // Después de finalizar una venta ya no queda venta seleccionada,
        // por eso reactivamos la carga del listado sin esperar F5.
        Promise.resolve(fetchData(filters)).catch((error) =>
          console.warn(
            "No se pudo refrescar el listado después de finalizar:",
            error,
          ),
        );
      } else {
        await Swal.fire({
          icon: "error",
          title: "Error",
          text:
            result.message ||
            "Por favor, complete todos los campos requeridos.",
          confirmButtonText: "Aceptar",
          willOpen: () => {
            const container = document.querySelector(".swal2-container");
            if (container) container.style.zIndex = "1000000";
          },
        });
      }
    } catch (error) {
      console.error("Error al enviar la solicitud:", error);
      await Swal.fire({
        icon: "error",
        title: "Error",
        text: "Hubo un error al enviar los datos.",
        confirmButtonText: "Aceptar",
        willOpen: () => {
          const container = document.querySelector(".swal2-container");
          if (container) container.style.zIndex = "1000000";
        },
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  const actualizarPagoContado = async (pagoContado) => {
    const requestData = {
      access_token: accessToken,
      venta_id: selectedMailData.id,
      depende_auto: pagoContado, // "Si" o "No"
    };

    try {
      const response = await fetch(apiUpdateEstadoUrl, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(requestData),
      });

      const data = await response.json();
    } catch (error) {
      console.error("Error al actualizar pago_contado:", error);
    }
  };

  const actualizarFinanciamientoModal = async () => {
    const requestData = {
      access_token: accessToken,
      venta_id: selectedMailData.id,
      financiamiento_modal: 1,
    };

    try {
      const response = await fetch(apiUpdateEstadoUrl, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(requestData),
      });

      const data = await response.json();
    } catch (error) {
      console.error("Error al actualizar financiamiento_modal:", error);
    }
  };

  const handleShowModal = async () => {
    await actualizarFinanciamientoModal(); // Espera la actualización
    const modalElement = document.getElementById("accessoryModal");
    const modal = new Modal(modalElement);
    modal.show();
  };

  const handleShowModalCotizador = async () => {
    if (cotizadorEngancheTimerRef.current) {
      clearTimeout(cotizadorEngancheTimerRef.current);
      cotizadorEngancheTimerRef.current = null;
    }

    if (cotizadorMensualidadTimerRef.current) {
      clearTimeout(cotizadorMensualidadTimerRef.current);
      cotizadorMensualidadTimerRef.current = null;
    }

    const ventaActual = selectedMailDataRef.current || selectedMailData || {};

    // El modal conserva el flujo original de Babilonia:
    // el asesor edita mensualidad, meses, enganche y paquete,
    // y NR se usa desde aquí para calcular la mensualidad oficial/PDF.
    isCotizadorModalOpenRef.current = false;
    modalFinancingMonthsDirtyRef.current = false;
    isEditingFinancingModalRef.current = false;
    isUserEditing.current = false;

    const snapshot = getCurrentCotizadorSnapshot();

    setModalMensualidadInput(formatModalMoneyValue(snapshot.mensualidad));
    setModalEngancheInput(formatModalMoneyValue(snapshot.enganche));
    setModalTasaInput(String(snapshot.tasa || ""));
    setModalFinancingMonthsManual(snapshot.meses || "", {
      dirty: false,
      force: true,
    });
    setValidationMessageC("");

    if (selectedMailDataRef.current?.id || selectedMailData?.id) {
      preloadNrBaseCatalogs();
    }

    // También dejamos estos estados como referencia visual actual.
    // No calcula nada; sólo prepara el modal con lo vigente en la vista/BD.
    setMensualidadC(snapshot.mensualidad ? String(snapshot.mensualidad) : "");
    setMensualidadDisplay(formatInputCurrency(snapshot.mensualidad || ""));
    setEngancheC(snapshot.enganche ? String(snapshot.enganche) : "");
    setEngancheDisplay(formatInputCurrency(snapshot.enganche || ""));
    setTasaC(String(snapshot.tasa || ""));

    const modalElement = document.getElementById("cotizadorModal");
    const modal = new Modal(modalElement);
    isCotizadorModalOpenRef.current = true;
    modal.show();
  };

  useEffect(() => {
    // Evitamos un auto-guardado global porque generaba carreras entre valores
    // nuevos y valores anteriores de la BD (por ejemplo 36 -> 48 -> 36 meses).
    // Cada acción financiera relevante guarda explícitamente con sus overrides.
  }, [financingMonths, downPaymentPercentage, selectedAgencia]);

  const [userEditedEnganche, setUserEditedEnganche] = useState(false); //ingresar manualmente

  useEffect(() => {
    if (!selectedMailData?.id) return;

    if (cotizadorEngancheTimerRef.current) {
      clearTimeout(cotizadorEngancheTimerRef.current);
      cotizadorEngancheTimerRef.current = null;
    }

    if (cotizadorMensualidadTimerRef.current) {
      clearTimeout(cotizadorMensualidadTimerRef.current);
      cotizadorMensualidadTimerRef.current = null;
    }

    if (debounceTimer.current) {
      clearTimeout(debounceTimer.current);
      debounceTimer.current = null;
    }

    if (monthlyTimeoutRef.current) {
      clearTimeout(monthlyTimeoutRef.current);
      monthlyTimeoutRef.current = null;
    }

    if (engancheTimeoutRef.current) {
      clearTimeout(engancheTimeoutRef.current);
      engancheTimeoutRef.current = null;
    }

    if (downPaymentCommitTimeoutRef.current) {
      clearTimeout(downPaymentCommitTimeoutRef.current);
      downPaymentCommitTimeoutRef.current = null;
    }

    downPaymentPercentageDraftRef.current = null;
    activeFinancingEditRef.current = "";
    setActiveFinancingEdit("");

    selectedPlanVentaIdRef.current = "";
    selectedPlanKeyRef.current = "";
    engancheCVentaIdRef.current = "";
    manualEngancheVentaIdRef.current = "";
    manualEngancheValueRef.current = "";
    plansLoadedVentaIdRef.current = "";

    const ventaIdActual = String(selectedMailData?.id || "");
    const engancheDesdeBD =
      selectedMailData?.engancheEditable || selectedMailData?.enganche || "";
    const mensualidadDesdeBD = selectedMailData?.mensualidad_estimacion || "";
    const mesesDesdeBD = getMesesFromVentaBD(selectedMailData);

    manualFinancingModalSavedRef.current = { ventaId: "", active: false };

    if (mesesDesdeBD > 0) {
      setFinancingMonths(mesesDesdeBD);
      setModalFinancingMonthsManual(mesesDesdeBD, { dirty: false });
      setFormData((prev) => {
        const next = {
          ...prev,
          plazo_meses: String(mesesDesdeBD),
          meses_financiamiento: String(mesesDesdeBD),
        };
        formDataRef.current = next;
        return next;
      });
    }

    setManualMonthlyOverride(false);
    setMensualidadC(
      mensualidadDesdeBD ? String(toNumber(mensualidadDesdeBD) || "") : "",
    );
    setMensualidadDisplay(
      mensualidadDesdeBD ? formatInputCurrency(mensualidadDesdeBD) : "",
    );

    manualEngancheVentaIdRef.current = String(selectedMailData.id || "");
    manualEngancheValueRef.current = String(toNumber(engancheDesdeBD) || "");
    engancheCVentaIdRef.current = String(selectedMailData.id || "");
    setEngancheC(
      engancheDesdeBD ? String(toNumber(engancheDesdeBD) || "") : "",
    );
    setEngancheDisplay(
      engancheDesdeBD ? formatInputCurrency(engancheDesdeBD) : "",
    );
    setTasaC("");
    setValidationMessageC("");
    setSelectedPlan(null);
    setSelectedPlanFinal(null);
    setSelectedPlanIndex(null);
    setPrecioTotal(toNumber(selectedMailData?.precio_vehiculo || 0));
    setUserEditedEnganche(Boolean(engancheDesdeBD));
    isUserEditing.current = false;
    setPlansLoaded(false);
  }, [selectedMailData?.id, loadAsesorDraft, getMesesFromVentaBD]);

  useEffect(() => {
    // La BD es la fuente de verdad para financiamiento.
    // No se persisten estados financieros en localStorage; sólo la licencia se
    // conserva localmente cuando se carga el archivo.
  }, [selectedMailData?.id, plansLoaded]);

  // UseEffect mejorado para cambios de precio
  useEffect(() => {
    if (isUserEditing.current) return;
    if (manualMonthlyOverride) return;

    const basePrice = getBasePrice();

    if (basePrice > 0) {
      // Solo recalcular si el precio cambió significativamente
      if (!userEditedEnganche) {
        const values = calculateFinancingValues({
          basePrice,
          downPaymentPercentage: downPaymentPercentage,
          origin: "UseEffect mejorado para cambios de precio",
        });
        updateAllFinancingStates(values);
      }
    }
  }, [
    precioTotal,
    selectedMailData?.precio_vehiculo,
    calculateFinancingValues,
    updateAllFinancingStates,
  ]);

  // Función auxiliar para obtener mensualidad actual (reemplaza calculateMonthlyPayment)
  const getCurrentMonthlyPayment = useCallback(() => {
    return monthlyPayment || 0;
  }, [monthlyPayment]);

  // Envia actualización a API con debounce
  useEffect(() => {
    //Ya
    // No mandar enganches parciales mientras el usuario está escribiendo.
    if (activeFinancingEditRef.current === "enganche") return;
    if (formData.engancheEditable === "") return;

    const ventaActualEnganche =
      selectedMailDataRef.current || selectedMailData || {};
    if (isManualFinancingModalGuardActive(ventaActualEnganche?.id)) return;
    if (isManualFinancingModalSavedActive(ventaActualEnganche?.id)) return;

    // Limpiamos timer anterior si existe
    if (debounceTimer.current) {
      clearTimeout(debounceTimer.current);
    }

    debounceTimer.current = setTimeout(() => {
      sendEngancheUpdate();
    }, 1500);

    return () => {
      if (debounceTimer.current) {
        clearTimeout(debounceTimer.current);
      }
    };
  }, [formData.engancheEditable]);

  // Función para mandar la actualización del enganche a la API
  const sendEngancheUpdate = async () => {
    //Ya
    // Validar que engancheEditable sea una cadena antes de usar replace
    let engancheValue = formData.engancheEditable;

    // Si es null, undefined, o no es string, convertir a string vacío
    if (!engancheValue || typeof engancheValue !== "string") {
      engancheValue = "0";
    }

    // Ahora sí puedes usar replace de forma segura
    const numericValue = engancheValue.replace(/,/g, "");

    const formattedEnganche = numericValue.toLocaleString("es-MX", {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    });

    // setFormData((prev) => ({
    //   ...prev,
    //   enganche: formattedEnganche,
    // }));

    try {
      const ventaActual = selectedMailDataRef.current || selectedMailData;
      const ventaId =
        ventaActual?.id || formDataRef.current?.venta_id || formData.venta_id;

      if (isManualFinancingModalGuardActive(ventaId)) {
        return;
      }

      const requestData = {
        access_token: accessToken,
        venta_id: ventaId,
        enganche: numericValue,
        // añade otros campos que necesites enviar aquí
      };

      const response = await fetch(apiUpdateEstadoUrl, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(requestData),
      });

      const data = await response.json();
    } catch (error) {
      console.error("Error actualizando enganche:", error);
    }
  };

  // Función principal para intercambiar completamente dos planes
  const handleSwapPlans = useCallback(
    (planIndex1, planIndex2) => {
      setPlansState((prevPlans) => {
        const updatedPlans = [...prevPlans];

        // Crear copias profundas de los planes
        const plan1Copy = {
          ...updatedPlans[planIndex1],
          accessories: [...updatedPlans[planIndex1].accessories],
        };
        const plan2Copy = {
          ...updatedPlans[planIndex2],
          accessories: [...updatedPlans[planIndex2].accessories],
        };

        // Intercambiar completamente los planes manteniendo solo el estado de selección
        updatedPlans[planIndex1] = {
          title: plan2Copy.title,
          accessories: plan2Copy.accessories,
          totalPrice: plan2Copy.totalPrice,
          totalPrice_promo: plan2Copy.totalPrice_promo,
          totalPrice_base: plan2Copy.totalPrice_base,
          isSelected: plan1Copy.isSelected, // Mantener estado de selección original
        };

        updatedPlans[planIndex2] = {
          title: plan1Copy.title,
          accessories: plan1Copy.accessories,
          totalPrice: plan1Copy.totalPrice,
          totalPrice_promo: plan1Copy.totalPrice_promo,
          totalPrice_base: plan1Copy.totalPrice_base,
          isSelected: plan2Copy.isSelected, // Mantener estado de selección original
        };

        // Actualizar selectedPlan si alguno de los planes intercambiados estaba seleccionado
        const selectedPlanIndex = updatedPlans.findIndex((p) => p.isSelected);
        if (selectedPlanIndex !== -1) {
          setSelectedPlan(updatedPlans[selectedPlanIndex]);
        }

        return updatedPlans;
      });

      // NO cerramos las opciones automáticamente
      // Eliminamos cualquier setShowSwapOptions(false) que pueda existir
    },
    [setPlansState, setSelectedPlan],
  ); // Dependencias explícitas

  // Función para intercambiar solo los accesorios entre planes
  const handleSwapAccessories = useCallback((planIndex1, planIndex2) => {
    setPlansState((prevPlans) => {
      const updatedPlans = [...prevPlans];

      // Intercambiar solo accesorios y precio total
      const accessories1 = [...updatedPlans[planIndex1].accessories];
      const accessories2 = [...updatedPlans[planIndex2].accessories];
      const totalPrice1 = updatedPlans[planIndex1].totalPrice;
      const totalPrice2 = updatedPlans[planIndex2].totalPrice;
      const totalPrice1_promo = updatedPlans[planIndex1].totalPrice_promo;
      const totalPrice2_promo = updatedPlans[planIndex2].totalPrice_promo;
      const totalPrice1_base = updatedPlans[planIndex1].totalPrice_base;
      const totalPrice2_base = updatedPlans[planIndex2].totalPrice_base;

      updatedPlans[planIndex1] = {
        ...updatedPlans[planIndex1],
        accessories: accessories2,
        totalPrice: totalPrice2,
        totalPrice_promo: totalPrice2_promo,
        totalPrice_base: totalPrice2_base,
      };

      updatedPlans[planIndex2] = {
        ...updatedPlans[planIndex2],
        accessories: accessories1,
        totalPrice: totalPrice1,
        totalPrice_promo: totalPrice1_promo,
        totalPrice_base: totalPrice1_base,
      };

      // Actualizar selectedPlan si es necesario
      const selectedPlanIndex = updatedPlans.findIndex((p) => p.isSelected);
      if (selectedPlanIndex !== -1) {
        setSelectedPlan(updatedPlans[selectedPlanIndex]);
      }

      return updatedPlans;
    });
  }, []);

  // Función para intercambiar solo los nombres entre planes
  const handleSwapNames = useCallback((planIndex1, planIndex2) => {
    setPlansState((prevPlans) => {
      const updatedPlans = [...prevPlans];

      // Intercambiar solo los nombres
      const title1 = updatedPlans[planIndex1].title;
      const title2 = updatedPlans[planIndex2].title;

      updatedPlans[planIndex1] = {
        ...updatedPlans[planIndex1],
        title: title2,
      };

      updatedPlans[planIndex2] = {
        ...updatedPlans[planIndex2],
        title: title1,
      };

      // Actualizar selectedPlan si es necesario
      const selectedPlanIndex = updatedPlans.findIndex((p) => p.isSelected);
      if (selectedPlanIndex !== -1) {
        setSelectedPlan(updatedPlans[selectedPlanIndex]);
      }

      return updatedPlans;
    });
  }, []);

  // Encabezado de cada plan.
  // Se quitó la opción de "Intercambiar"; sólo queda la consulta de accesorios.
  const PlanSwapButtons = ({ currentPlan, planIndex, isLocked = false }) => {
    const handleOpenAccessories = (event) => {
      event?.preventDefault?.();
      event?.stopPropagation?.();
      openAccessoryModalForPlan(currentPlan, planIndex);
    };

    return (
      <div className="plan-swap-container mb-3">
        <div className="d-flex justify-content-between align-items-center mb-2">
          <h6 className="new-font mb-0 fw-bold black-text">
            {currentPlan.title}
          </h6>
          <div className="btn-group btn-group-sm new-font-14" role="group">
            <button
              type="button"
              className="btn btn-sm btn-outline-primary new-font-14"
              onMouseDown={handleOpenAccessories}
              onPointerDown={handleOpenAccessories}
              onTouchStart={handleOpenAccessories}
              onClick={handleOpenAccessories}
              disabled={currentPlan.isSubmitted}
              title={isLocked ? "Sólo consulta, no editable" : "Ver accesorios"}
            >
              Ver accesorios
            </button>
          </div>
        </div>
      </div>
    );
  };

  // Función para ordenar planes por precio
  const handleSortPlansByPrice = useCallback((ascending = true) => {
    setPlansState((prevPlans) => {
      const sortedPlans = [...prevPlans].sort((a, b) => {
        const priceA = parseFloat(a.totalPrice || 0);
        const priceB = parseFloat(b.totalPrice || 0);
        return ascending ? priceA - priceB : priceB - priceA;
      });

      // Mantener el plan seleccionado
      const selectedPlanIndex = sortedPlans.findIndex((p) => p.isSelected);
      if (selectedPlanIndex !== -1) {
        setSelectedPlan(sortedPlans[selectedPlanIndex]);
      }

      return sortedPlans;
    });
  }, []);

  // Función para resetear planes a configuración inicial
  const handleResetPlans = useCallback(() => {
    setPlansState((prevPlans) => {
      const resetPlans = basePlansState.map((originalPlan, index) => ({
        ...originalPlan,
        accessories: [...originalPlan.accessories],
        isSelected: prevPlans[index]?.isSelected || false,
      }));

      // Mantener el plan seleccionado
      const selectedPlanIndex = resetPlans.findIndex((p) => p.isSelected);
      if (selectedPlanIndex !== -1) {
        setSelectedPlan(resetPlans[selectedPlanIndex]);
      }

      return resetPlans;
    });
  }, [basePlansState]);

  // Componente para los controles generales.
  // Se deja sin UI para quitar el control de ordenar por precio.
  const PlanControlsSection = () => null;

  // La sincronización automática ya se hace arriba solo cuando existe una venta seleccionada.
  // Se elimina el polling global cada 3 segundos para evitar seleccionar registros o disparar avisos
  // apenas carga la pantalla de asesor.

  const onDragError = useCallback((error) => {
    console.error("Drag error occurred:", error);
    // Resetear cursor
    document.body.style.cursor = "default";
    // Opcional: mostrar mensaje de error al usuario
  }, []);

  useEffect(() => {
    return () => {
      // Limpiar cursor al desmontar el componente
      document.body.style.cursor = "default";
    };
  }, []);

  const resolveSelectedPlanMutationIndex = useCallback(
    (planIndexCandidate = null, plansSnapshot = plansState) => {
      const plansArray = Array.isArray(plansSnapshot) ? plansSnapshot : [];

      const getEditableIndex = (value) => {
        const index = Number(value);
        if (!Number.isInteger(index)) return -1;

        if (
          index >= 0 &&
          index < plansArray.length &&
          plansArray[index] &&
          !esPlanNoEditable(plansArray[index])
        ) {
          return index;
        }

        return -1;
      };

      // Si se pasó un índice explícito desde el modal o desde la tarjeta,
      // NO hacemos fallback a otro plan. Esto evita que abrir Plan cliente/Gold
      // termine afectando el plan seleccionado por error.
      if (planIndexCandidate !== null && planIndexCandidate !== undefined) {
        const index = Number(planIndexCandidate);

        if (Number.isInteger(index)) {
          return getEditableIndex(index);
        }
      }

      const selectedFromStateIndex = plansArray.findIndex(
        (plan) => plan?.isSelected && !esPlanNoEditable(plan),
      );
      if (selectedFromStateIndex >= 0) return selectedFromStateIndex;

      const selectedFinalIndex = getEditableIndex(selectedPlanFinal);
      if (selectedFinalIndex >= 0) return selectedFinalIndex;

      const selectedIndex = getEditableIndex(selectedPlanIndex);
      if (selectedIndex >= 0) return selectedIndex;

      const referencePlan = selectedPlanForFinancing || selectedPlan;
      const referenceName = normalizarNombrePlan(referencePlan);

      if (referenceName) {
        const byNameIndex = plansArray.findIndex(
          (plan) =>
            normalizarNombrePlan(plan) === referenceName &&
            !esPlanNoEditable(plan),
        );

        if (byNameIndex >= 0) return byNameIndex;
      }

      return -1;
    },
    [
      plansState,
      selectedPlanFinal,
      selectedPlanIndex,
      selectedPlanForFinancing,
      selectedPlan,
    ],
  );

  // Quitar accesorio de un plan
  function removeAccessoryFromPlan(accessoryTitle, planIndex) {
    const titleToRemove =
      typeof accessoryTitle === "object"
        ? accessoryTitle?.title || ""
        : String(accessoryTitle || "");

    const initialPlanIndex = resolveSelectedPlanMutationIndex(planIndex);

    activatePlanMutationGuard();

    if (!titleToRemove || initialPlanIndex < 0) {
      console.warn("No se pudo resolver el plan/accesorio a eliminar", {
        accessoryTitle,
        planIndex,
        initialPlanIndex,
      });
      return;
    }

    if (esPlanNoEditable(plansState?.[initialPlanIndex])) {
      return;
    }

    setPlansState((prevPlans) => {
      const targetPlanIndex = resolveSelectedPlanMutationIndex(
        initialPlanIndex,
        prevPlans,
      );

      if (
        targetPlanIndex < 0 ||
        esPlanNoEditable(prevPlans?.[targetPlanIndex])
      ) {
        return prevPlans;
      }

      markPlanAsManuallyEdited(prevPlans?.[targetPlanIndex]);

      let didRemove = false;
      let removedAccessory = null;

      const updatedPlans = prevPlans.map((plan, idx) => {
        if (idx !== targetPlanIndex) return plan;

        const accessories = Array.isArray(plan?.accessories)
          ? [...plan.accessories]
          : [];
        const accessoryIndex = accessories.findIndex((acc) => {
          const currentTitle =
            typeof acc === "object" ? acc?.title || "" : String(acc || "");

          return currentTitle === titleToRemove;
        });

        if (accessoryIndex === -1) {
          console.warn("Accesorio no encontrado en el plan", titleToRemove);
          return plan;
        }

        const accessory = accessories[accessoryIndex];
        removedAccessory = accessory;
        didRemove = true;

        const accessoryPrice = toNumber(
          accessory?.price_base ?? accessory?.price ?? 0,
        );
        const accessoryPromoPrice = toNumber(
          accessory?.price_promo ?? accessory?.promoPrice ?? accessoryPrice,
        );

        const nextAccessories = accessories.filter(
          (_, index) => index !== accessoryIndex,
        );

        const updatedPlan = markPlanObjectAsManual({
          ...plan,
          accessories: nextAccessories,
          totalPrice_base: Math.max(
            0,
            toNumber(plan?.totalPrice_base ?? plan?.totalPrice ?? 0) -
              accessoryPrice,
          ),
          totalPrice_promo: Math.max(
            0,
            toNumber(plan?.totalPrice_promo ?? plan?.totalPrice ?? 0) -
              accessoryPromoPrice,
          ),
          totalPrice: Math.max(
            0,
            toNumber(plan?.totalPrice || 0) - accessoryPrice,
          ),
        });

        try {
          const promo = obtenerPromocion(updatedPlan, selectedVehicleName);
          actualizarCampoPlan(updatedPlan.title.toLowerCase(), promo);
        } catch (error) {
          console.error("Error recalculando promoción:", error);
        }

        return updatedPlan;
      });

      if (!didRemove) return prevPlans;

      if (removedAccessory) {
        setEliminatedAccessories((prev) => {
          if (!prev.some((acc) => acc.title === titleToRemove)) {
            return [
              ...prev,
              {
                title: titleToRemove,
                price: toNumber(
                  removedAccessory?.price_base ?? removedAccessory?.price ?? 0,
                ),
                type: removedAccessory?.type || "accesorios",
              },
            ];
          }

          return prev;
        });
      }

      const selectedAfterMutationIndex = updatedPlans.findIndex(
        (plan) => plan?.isSelected && !esPlanCliente(plan),
      );

      if (selectedAfterMutationIndex >= 0) {
        const selectedAfterMutation = updatedPlans[selectedAfterMutationIndex];
        selectedPlanKeyRef.current = getPlanKey(selectedAfterMutation);
        selectedPlanVentaIdRef.current = String(
          (selectedMailDataRef.current || selectedMailData || {})?.id || "",
        );
        setSelectedPlan(selectedAfterMutation);
        setSelectedPlanFinal(selectedAfterMutationIndex);
        setSelectedPlanIndex(selectedAfterMutationIndex);
      }

      const ventaActualParaPatch =
        selectedMailDataRef.current || selectedMailData || {};
      if (ventaActualParaPatch?.id) {
        selectedMailDataRef.current = {
          ...ventaActualParaPatch,
          planes_financiamiento: updatedPlans,
        };
      }

      Promise.resolve().then(() => {
        syncFinancingAfterPlanMutation(updatedPlans, "removeAccessoryFromPlan");
      });

      return updatedPlans;
    });
  }

  const generarPDFEntrevistaCliente = async () => {
    try {
      const e = formData?.entrevista_nissan || {};

      const nombreCliente =
        formData?.nombre ||
        selectedMailData?.nombre ||
        selectedMailData?.nombre_cliente ||
        "Cliente";

      const asesor = formData?.asesor || selectedMailData?.asesor || "N/A";

      const folio =
        selectedMailData?.folio_venta ||
        selectedMailData?.folio ||
        formData?.venta_id ||
        "S/F";

      const fecha = new Date().toLocaleDateString("es-MX");

      const doc = new jsPDF("p", "mm", "a4");
      const pageW = doc.internal.pageSize.getWidth();
      const pageH = doc.internal.pageSize.getHeight();

      const drawLine = (y, x1 = 14, x2 = 196) => {
        doc.setDrawColor(90, 90, 90);
        doc.setLineWidth(0.25);
        doc.line(x1, y, x2, y);
      };

      const drawMutedText = (text, x, y, maxW = 170) => {
        doc.setFont("helvetica", "italic");
        doc.setFontSize(8.2);
        doc.setTextColor(120, 120, 120);
        const lines = doc.splitTextToSize(String(text), maxW);
        doc.text(lines, x, y);
        doc.setTextColor(0, 0, 0);
        return lines.length;
      };

      const drawBoldResponse = (text, x, y, maxW = 170) => {
        const value =
          text && String(text).trim() ? String(text) : "Sin respuesta";
        const isEmpty = !text || !String(text).trim();

        if (isEmpty) {
          return drawMutedText("Sin respuesta", x, y, maxW);
        }

        doc.setFont("helvetica", "bold");
        doc.setFontSize(8.8);
        const lines = doc.splitTextToSize(value, maxW);
        doc.text(lines, x, y);
        return lines.length;
      };

      // Encabezado dinámico con nombre completo de agencia
      const agenciaPdf = String(
        selectedMailData?.agencia ||
          formData?.agencia ||
          agenciaActual?.nombre ||
          "Agencia",
      ).trim();

      doc.setFont("helvetica", "bold");
      doc.setFontSize(15);
      doc.text(agenciaPdf.toUpperCase(), 105, 15, { align: "center" });

      // Datos superiores
      doc.setFont("helvetica", "normal");
      doc.setFontSize(8.2);
      doc.text(`Cliente: ${nombreCliente}`, 14, 22);
      doc.text(`Asesor: ${asesor}`, 78, 22);
      doc.text(`Folio: ${folio}`, 145, 22);
      doc.text(`Fecha: ${fecha}`, 14, 26);

      // Preguntas
      let y = 34;

      const preguntas = [
        {
          q: "1.- ¿Tiene vehículo actualmente? SI/NO ¿Lo dejaría a cuenta?",
          r: `${e.tiene_vehiculo_actual || ""}${e.tiene_vehiculo_actual === "Si" ? ` / ${e.deja_a_cuenta || ""}` : ""}`,
        },
        { q: "2.- ¿Qué busca en su vehículo?", r: e.busca_en_vehiculo || "" },
        { q: "3.- ¿Quién manejaría el vehículo?", r: e.quien_manejara || "" },
        { q: "4.- ¿Qué uso le dará a su vehículo?", r: e.uso_vehiculo || "" },
        {
          q: "5.- ¿Qué factor considera importante para la compra del vehículo?",
          r: e.factor_importante_compra || "",
        },
        {
          q: "6.- ¿Viaja en carretera regularmente?",
          r: e.viaja_carretera || "",
        },
        {
          q: "7.- ¿Para cuándo quiere realizar la compra del vehículo?",
          r: e.cuando_compra || "",
        },
        {
          q: "8.- ¿Usted tomaría la decisión de compra?",
          r: e.toma_decision_compra || "",
        },
      ];

      preguntas.forEach((item) => {
        doc.setFont("helvetica", "normal");
        doc.setFontSize(9.2);
        const qLines = doc.splitTextToSize(item.q, 180);
        doc.text(qLines, 14, y);

        const yRespuesta = y + qLines.length * 4.2 + 0.8;
        const rLinesCount = drawBoldResponse(item.r, 16, yRespuesta, 175);

        const yLine = yRespuesta + rLinesCount * 3.8 + 1.2;
        drawLine(yLine);

        y = yLine + 5.3;
      });

      // Motivantes
      y += 7;

      doc.setFont("helvetica", "normal");
      doc.setFontSize(9.2);
      doc.text(
        "Tacha en los motivantes de compra de tu cliente y menciona porque en la línea:",
        14,
        y,
      );

      y += 8;

      const motivantesCatalogo = [
        "Seguridad",
        "Afecto",
        "Bienestar",
        "Compra personal",
        "Novedad",
        "Economía",
      ];

      const seleccionados = Array.isArray(e.motivantes_compra)
        ? e.motivantes_compra
        : [];

      motivantesCatalogo.forEach((mot) => {
        const marcado = seleccionados.includes(mot);

        doc.setDrawColor(60, 60, 60);
        doc.rect(14, y - 3.5, 4.2, 4.2);

        if (marcado) {
          doc.setFont("helvetica", "bold");
          doc.setFontSize(9);
          doc.text("X", 15.3, y - 0.2);
        }

        doc.setFont("helvetica", "normal");
        doc.setFontSize(9.2);
        doc.text(mot, 22, y);

        drawLine(y + 0.6, 46, 132);

        if (marcado) {
          doc.setFont("helvetica", "italic");
          doc.setFontSize(8);
          doc.setTextColor(90, 90, 90);
          doc.text("Seleccionado", 48, y - 0.4);
          doc.setTextColor(0, 0, 0);
        }

        y += 6.8;
      });

      // Recuerda
      y += 6;

      doc.setFont("helvetica", "bold");
      doc.setFontSize(9.5);
      doc.text("Recuerda:", pageW / 2, y, { align: "center" });

      y += 7;

      const bullets = [
        "En cada paso del proceso pregunta si tiene alguna duda.",
        "Vende la prueba de manejo.",
        "Recuerda crear valor en tu demostración estética y aclara tus dudas.",
        "Si está cotizando en otra parte, haz que tu cotización sea la mejor.",
        "Ofrece accesorios.",
      ];

      doc.setFont("helvetica", "normal");
      doc.setFontSize(8.8);

      bullets.forEach((b) => {
        doc.text("•", 30, y);
        const lines = doc.splitTextToSize(b, 130);
        doc.text(lines, 34, y);
        y += Math.max(4.8, lines.length * 4.0);
      });

      // Footer
      doc.setFont("helvetica", "italic");
      doc.setFontSize(7.3);
      doc.setTextColor(100, 100, 100);
      doc.text(
        "Documento generado automáticamente desde Babilonia",
        14,
        pageH - 8,
      );
      doc.setTextColor(0, 0, 0);

      // Archivo (sin abrir)
      const blob = doc.output("blob");
      const fileName = `Entrevista_Nissan_${String(nombreCliente).replace(/\s+/g, "_")}.pdf`;
      const pdfFile = new File([blob], fileName, { type: "application/pdf" });

      return { file: pdfFile };
    } catch (error) {
      console.error("Error generando PDF de entrevista:", error);
      return null;
    }
  };

  const quitarAcentos = (texto = "") =>
    texto.normalize("NFD").replace(/[\u0300-\u036f]/g, "");

  const limpiarNumero = (valor) => {
    if (valor === null || valor === undefined) return "";
    return String(valor).replace(/[^0-9.]/g, "");
  };

  const formatearMiles = (valor) => {
    const limpio = limpiarNumero(valor);
    if (!limpio) return "";

    const partes = limpio.split(".");
    partes[0] = Number(partes[0] || 0).toLocaleString("es-MX");

    return partes.length > 1 ? `${partes[0]}.${partes[1]}` : partes[0];
  };

  const dispararChange = (handler, value) => {
    if (typeof handler !== "function") return;

    handler({
      target: {
        value,
      },
    });
  };

  const enviarSaboneYPdf = async () => {
    try {
      const correoAsesor = localStorage.getItem("userEmail") ?? "";
      const correoCliente = formData?.correo_electronico || "";
      const cliente = formData?.nombre || selectedMailData?.nombre || "Cliente";

      const tipoAuto = selectedMailData?.tipo_auto?.toLowerCase() || "";
      const agIdVenta = selectedMailData?.ag_id || agenciaActual?.ag_id || "";

      let pdfGenerado = null;

      try {
        pdfGenerado = await generarPDFEntrevistaCliente();
      } catch (e) {
        console.warn(
          "No se pudo generar PDF Sabone, se enviará sin ese PDF.",
          e,
        );
      }

      const fd = new FormData();

      fd.append(
        "access_token",
        "1MhYphhrGUbgbdRy7cyYFGQlXS7tAi6ooUoptkHQbOm9GcsKiZM7uMF1MERxwMWq30I7Y3",
      );

      fd.append("cliente", cliente);
      fd.append("correoCliente", correoCliente || "");
      fd.append("correoAsesor", correoAsesor || "");
      fd.append("tipo_auto", tipoAuto);
      fd.append("ag_id", agIdVenta);

      if (pruebaManejoData.realizo_prueba_manejo === "Si") {
        fd.append("prueba_manejo", "Si");
        fd.append("encuesta_prueba_manejo", JSON.stringify(pruebaManejoData));

        if (licenciaManejoFrente) {
          fd.append("licencia_manejo_frente", licenciaManejoFrente);
        }
      } else {
        fd.append("prueba_manejo", "No");
      }

      if (pdfGenerado?.file) {
        fd.append("archivo_sabone", pdfGenerado.file);
      }

      if (pdfAdjunto) {
        fd.append("archivo_adjunto", pdfAdjunto);
      }

      const resp = await fetch("https://api.checkmark.mx/enviar/sabone-pdf", {
        method: "POST",
        body: fd,
      });

      let result = {};

      try {
        result = await resp.json();
      } catch (e) {
        console.warn("Respuesta sin JSON", e);
      }

      if (result?.statusCode === 200) return { ok: true };

      return {
        ok: false,
        message: result?.message || "No se pudo enviar el correo.",
      };
    } catch (err) {
      console.error(err);
      return { ok: false, message: "Ocurrió un error al enviar correos." };
    }
  };

  const subirPdfAdjuntoABD = async (file) => {
    try {
      const folio =
        selectedMailData?.folio_venta ||
        selectedMailData?.folio ||
        formData?.venta_id ||
        "S/F";

      const fd = new FormData();

      fd.append(
        "access_token",
        "1MhYphhrGUbgbdRy7cyYFGQlXS7tAi6ooUoptkHQbOm9GcsKiZM7uMF1MERxwMWq30I7Y3",
      );
      fd.append("folio_venta", folio);
      fd.append("pdf", file);

      const resp = await fetch(
        "https://api.checkmark.mx/ventas/guardar-pdf-adjunto",
        {
          method: "POST",
          body: fd,
        },
      );

      let result = {};
      try {
        result = await resp.json();
      } catch (e) {}

      if (result?.statusCode !== 200) {
        console.error("No se pudo guardar el PDF:", result);
        return false;
      }

      return true;
    } catch (error) {
      console.error("Error al subir PDF adjunto:", error);
      return false;
    }
  };

  const OCR_MODO_DEMO = true;

  const obtenerTokenOpenIA = async () => {
    const formData = new FormData();

    formData.append(
      "access_token",
      "1MhYphhrGUbgbdRy7cyYFGQlXS7tAi6ooUoptkHQbOm9GcsKiZM7uMF1MERxwMWq30I7Y3",
    );

    const res = await fetch("https://api.checkmark.mx/obtener/token/openia", {
      method: "POST",
      body: formData,
    });

    const data = await res.json();

    if (!res.ok || data.statusCode !== 200) {
      throw new Error(data.message || "No se pudo obtener el token de OpenIA");
    }

    const tokenOpenIA = data?.data?.token_openia?.access_token;

    if (!tokenOpenIA) {
      throw new Error("El servicio no devolvió access_token de OpenIA");
    }

    return tokenOpenIA;
  };

  const escanearPdfYAutollenar = async (file) => {
    const aplicarDatosDetectados = (datos = {}) => {
      // 1) Meses de financiamiento (como antes, directo)
      if (datos?.MesesDeFinanciamiento) {
        const meses = parseInt(
          String(datos.MesesDeFinanciamiento).replace(/\D/g, ""),
          10,
        );

        if (!isNaN(meses) && meses > 0) {
          setFinancingMonths(meses);
        }
      }

      // 2) Enganche
      if (datos?.Enganche) {
        const limpio = limpiarNumero(datos.Enganche);
        const formateado = formatearMiles(limpio);
        dispararChange(handleEngancheChangeC, formateado);
      }

      // 3) Tasa
      if (datos?.Tasa) {
        const tasa = limpiarNumero(datos.Tasa);
        if (tasa) {
          dispararChange(handleTasaChangeC, tasa);
        }
      }

      // 4) Aseguradora / financiera (como antes, directo)
      if (datos?.Aseguradora) {
        setAseguradora(String(datos.Aseguradora).trim());
      }

      // 5) Monto del seguro
      if (datos?.MontoDelSeguro) {
        const limpio = limpiarNumero(datos.MontoDelSeguro);
        const formateado = formatearMiles(limpio);
        dispararChange(handleMontoSeguroChangeC, formateado);
      }

      // 6) Mensualidad AL FINAL
      if (datos?.Mensualidad) {
        const limpio = limpiarNumero(datos.Mensualidad);
        const formateado = formatearMiles(limpio);

        setTimeout(() => {
          dispararChange(handleMensualidadChangeC, formateado);
        }, 300);
      }
    };

    const respuestaDemo = {
      datos: {
        Mensualidad: "8450",
        MesesDeFinanciamiento: "48",
        Enganche: "165000",
        Tasa: "13.99",
        Aseguradora: "Qualitas",
        MontoDelSeguro: "14500",
      },
    };

    const tokenOpenIA = await obtenerTokenOpenIA();

    try {
      if (OCR_MODO_DEMO) {
        aplicarDatosDetectados(respuestaDemo.datos);
        return true;
      }

      const formDataOCR = new FormData();
      formDataOCR.append("apikey", "DPD8VZYKE82MX");
      formDataOCR.append("file", file);
      formDataOCR.append("language", "spa");

      const ocrRes = await fetch("https://apipro1.ocr.space/parse/image", {
        method: "POST",
        body: formDataOCR,
      });

      const ocrJson = await ocrRes.json();

      const rawText = ocrJson?.ParsedResults?.[0]?.ParsedText || "";
      if (!rawText.trim()) {
        aplicarDatosDetectados(respuestaDemo.datos);
        return true;
      }

      const textFormateado = quitarAcentos(rawText);
      const t = textFormateado.replace(/(\r\n|\n|\r)/g, " ").trim();

      const openaiRes = await fetch(
        "https://api.openai.com/v1/chat/completions",
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${tokenOpenIA}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            model: "gpt-4o-mini",
            max_tokens: 500,
            temperature: 0.1,
            messages: [
              {
                role: "user",
                content:
                  "Genera SOLO un JSON válido con un objeto 'datos' que contenga: Mensualidad, MesesDeFinanciamiento, Enganche, Tasa, Aseguradora, MontoDelSeguro. Texto: " +
                  t,
              },
            ],
          }),
        },
      );

      const openaiData = await openaiRes.json();
      const contenidoModelo = openaiData?.choices?.[0]?.message?.content || "";

      if (!contenidoModelo) {
        aplicarDatosDetectados(respuestaDemo.datos);
        return true;
      }

      let parsed = {};
      try {
        const match = contenidoModelo.match(/\{[\s\S]*\}/);
        parsed = JSON.parse(match ? match[0] : contenidoModelo);
      } catch {
        aplicarDatosDetectados(respuestaDemo.datos);
        return true;
      }

      const datos = parsed?.datos || {};
      aplicarDatosDetectados(
        Object.keys(datos).length ? datos : respuestaDemo.datos,
      );

      return true;
    } catch (error) {
      console.error("OCR/OpenAI demo fallback:", error);
      aplicarDatosDetectados(respuestaDemo.datos);
      return true;
    }
  };

  const accessoryRender = useCallback(
    ({ accessory, type, provided, snapshot, uniqueId }) => {
      const isGarantia = type?.toLowerCase().trim() === "garantias";
      const accessoryTitle =
        typeof accessory === "object" ? accessory.title : accessory;

      let normalColor = isGarantia ? "rgb(255, 167, 38)" : "rgb(0, 196, 159)";

      let draggingColor = isGarantia
        ? "rgb(255, 138, 101)"
        : "rgb(0, 150, 130)";

      return (
        <span
          ref={provided.innerRef}
          {...provided.draggableProps}
          {...provided.dragHandleProps}
          style={{
            position: "relative",
            display: "inline-block",
            padding: "5px 10px",
            margin: "5px",
            userSelect: "none",
            backgroundColor: snapshot.isDragging ? draggingColor : normalColor,
            color: "white",
            borderRadius: "8px",
            boxShadow: snapshot.isDragging
              ? "0 4px 12px rgba(0, 0, 0, 0.2)"
              : "0 2px 6px rgba(0, 0, 0, 0.1)",
            ...provided.draggableProps.style,
          }}
        >
          {toTitleCase(accessoryTitle.split(" - ")[0])}
        </span>
      );
    },
    [],
  );

  const accessoryRender2 = useCallback(
    ({ accessory, type, provided, snapshot, uniqueId }) => {
      const isTypeMissing = !type || type.trim() === "";
      const accessoryTitle =
        typeof accessory === "object" ? accessory.title : accessory;

      let normalColor = "rgb(0, 196, 159)";
      let draggingColor = "rgb(0, 150, 130)";

      // Si no viene el tipo, usar azul para indicar seleccionado
      if (isTypeMissing) {
        normalColor = "rgb(3, 169, 244)";
        draggingColor = "rgb(2, 136, 209)";
      }

      return (
        <span
          ref={provided.innerRef}
          {...provided.draggableProps}
          {...provided.dragHandleProps}
          style={{
            position: "relative",
            display: "inline-block",
            padding: "5px 10px",
            margin: "5px",
            userSelect: "none",
            backgroundColor: snapshot.isDragging ? draggingColor : normalColor,
            color: "white",
            borderRadius: "8px",
            boxShadow: snapshot.isDragging
              ? "0 4px 12px rgba(0, 0, 0, 0.2)"
              : "0 2px 6px rgba(0, 0, 0, 0.1)",
            ...provided.draggableProps.style,
          }}
        >
          {toTitleCase(accessoryTitle.split(" - ")[0])}
        </span>
      );
    },
    [],
  );

  const renderAccessoryWithRemove = ({
    accessory,
    type,
    provided,
    snapshot,
    uniqueId,
    selectedPlan,
    selectedPlanIndex,
    removeAccessoryFromPlan,
    isElite,
  }) => {
    const accessoryTitle =
      typeof accessory === "object" ? accessory.title : accessory;

    const isTypeMissing = !type || type.trim() === "";
    const normalColor = isTypeMissing ? "rgb(3, 169, 244)" : "rgb(0, 196, 159)";
    const draggingColor = isTypeMissing
      ? "rgb(2, 136, 209)"
      : "rgb(0, 150, 130)";

    const style = {
      position: "relative",
      display: "inline-flex",
      alignItems: "center",
      opacity: isElite ? 0.7 : 1,
      cursor: isElite ? "not-allowed" : "pointer",
      justifyContent: "space-between",
      padding: "5px 10px",
      margin: "5px",
      userSelect: "none",
      backgroundColor: snapshot?.isDragging ? draggingColor : normalColor,
      color: "white",
      borderRadius: "8px",
      boxShadow: snapshot?.isDragging
        ? "0 4px 12px rgba(0, 0, 0, 0.2)"
        : "0 2px 6px rgba(0, 0, 0, 0.1)",
      minWidth: "180px",
      ...provided?.draggableProps?.style,
    };

    const buttonStyle = {
      cursor: "pointer",
      backgroundColor: "white",
      border: "none",
      color: normalColor,
      fontWeight: "bold",
      fontSize: "17px",
      lineHeight: 1,
      padding: "2px 8px",
      borderRadius: "4px",
      marginLeft: "8px",
      transition: "all 0.2s ease",
    };

    return (
      <span
        ref={provided?.innerRef}
        {...provided?.draggableProps}
        {...provided?.dragHandleProps}
        style={style}
        className="accessory-item"
      >
        <span>{toTitleCase(accessoryTitle.split(" - ")[0])}</span>
        <button
          type="button"
          className="remove-accessory-btn"
          disabled={isElite}
          onMouseDown={(event) => {
            event.stopPropagation();
          }}
          onPointerDown={(event) => {
            event.stopPropagation();
          }}
          onClick={(event) => {
            event.preventDefault();
            event.stopPropagation();
            if (typeof removeAccessoryFromPlan === "function") {
              removeAccessoryFromPlan(accessoryTitle, selectedPlanIndex);
            }
          }}
          title="Quitar accesorio"
        >
          &minus;
        </button>
      </span>
    );
  };

  const planRender = useCallback(
    ({ plan, planIndex, isElite }) => (
      <Droppable
        droppableId={String(planIndex)}
        key={planIndex}
        isDropDisabled={isElite}
      >
        {(provided) => (
          <div
            ref={provided.innerRef}
            {...provided.droppableProps}
            className="accessories-container"
            style={{
              minHeight: "50px",
              padding: "10px",
              border: "1px dashed #ccc",
            }}
          >
            {plan.accessories.length === 0 ? (
              <h6 className="card-price">No hay accesorios</h6>
            ) : (
              plan.accessories.map((accessory, accessoryIndex) => (
                <Draggable
                  key={`plan-${planIndex}-${
                    typeof accessory === "object" ? accessory.title : accessory
                  }-${accessoryIndex}`}
                  draggableId={`plan-${planIndex}-${
                    typeof accessory === "object" ? accessory.title : accessory
                  }-${accessoryIndex}`}
                  index={accessoryIndex}
                  isDragDisabled={isElite}
                >
                  {(provided, snapshot) =>
                    renderAccessoryWithRemove({
                      accessory,
                      provided,
                      snapshot,
                      uniqueId: `${planIndex}-${
                        typeof accessory === "object"
                          ? accessory.title
                          : accessory
                      }-${accessoryIndex}`,
                      selectedPlanIndex: planIndex,
                      removeAccessoryFromPlan,
                      isElite,
                    })
                  }
                </Draggable>
              ))
            )}
            {provided.placeholder}
          </div>
        )}
      </Droppable>
    ),
    [renderAccessoryWithRemove],
  );

  const handleDragEnd = useCallback(
    async (result) => {
      if (!result || !result.destination || result.reason === "CANCEL") {
        return;
      }

      const sourceId = result.source.droppableId;
      const destId = result.destination.droppableId;
      let planUpdated = false;
      let updatedPlan = null;

      // CREAR POOL COMPLETO que incluya accesorios automáticos
      const getAllAvailableAccessories = () => {
        const manualAccessories = [
          ...filteredAccessoriesAndWarranties.filter(
            (item) =>
              !eliminatedAccessories.some((el) => el.title === item.title),
          ),
          ...eliminatedAccessories,
        ];

        const autoAccessories = Object.values(ACCESORIOS_MAP).filter(
          (autoAcc) =>
            !manualAccessories.some((manual) => manual.title === autoAcc.title),
        );

        return [...manualAccessories, ...autoAccessories];
      };

      const combinedPool = getAllAvailableAccessories();

      try {
        // ===== CASO 1: AGREGAR DESDE ACCESSORIES-POOL A UN PLAN =====
        if (sourceId === "accessories-pool" && !isNaN(parseInt(destId))) {
          const destPlanIndex = parseInt(destId);
          const sourceIndex = result.source.index;

          // Obtener el pool completo (disponibles + eliminados)
          const fullPool = [
            ...filteredAccessoriesAndWarranties.filter(
              (item) =>
                !eliminatedAccessories.some((el) => el.title === item.title),
            ),
            ...eliminatedAccessories,
          ];

          const draggedAccessory = fullPool[sourceIndex];
          if (!draggedAccessory) {
            console.error("Accesorio no encontrado en pool:", sourceIndex);
            return;
          }

          setPlansState((prevPlans) => {
            if (destPlanIndex < 0 || destPlanIndex >= prevPlans.length) {
              console.error("Índice de plan inválido:", destPlanIndex);
              return prevPlans;
            }

            const updatedPlans = [...prevPlans];
            const destPlan = updatedPlans[destPlanIndex];

            // Evitar duplicados
            if (
              destPlan.accessories.some(
                (acc) =>
                  (typeof acc === "object" ? acc.title : acc) ===
                  draggedAccessory.title,
              )
            ) {
              console.warn("Accesorio ya existe en el plan");
              return prevPlans;
            }

            const accessoryPrice = parseFloat(
              (draggedAccessory.price || 0)
                .toString()
                .replace("$", "")
                .replace(",", ""),
            );

            const accessoryToAdd = {
              title: draggedAccessory.title,
              description: draggedAccessory.description || "",
              price: accessoryPrice,
            };

            // Agregar al plan
            destPlan.accessories.splice(
              result.destination.index,
              0,
              accessoryToAdd,
            );
            destPlan.totalPrice =
              parseFloat(destPlan.totalPrice || 0) + accessoryPrice;

            // Remover de eliminados si estaba ahí
            setEliminatedAccessories((prev) =>
              prev.filter((acc) => acc.title !== draggedAccessory.title),
            );

            // Actualizar plan seleccionado si es necesario
            if (destPlan.isSelected) {
              planUpdated = true;
              updatedPlan = destPlan;
              const newPrecioTotal = Math.round(
                parseFloat(selectedMailData?.precio_vehiculo || 0) +
                  parseFloat(destPlan.totalPrice || 0),
              );
              setPrecioTotal(newPrecioTotal);
              setSelectedPlan(destPlan);
            }

            return updatedPlans;
          });
        }

        // ===== CASO 2: AGREGAR DESDE PRODUCTS-POOL A UN PLAN =====
        else if (sourceId === "products-pool" && !isNaN(parseInt(destId))) {
          const destPlanIndex = parseInt(destId);
          const sourceIndex = result.source.index;

          const draggedProduct = plans[sourceIndex];
          if (!draggedProduct) {
            console.error("Producto no encontrado:", sourceIndex);
            return;
          }

          setPlansState((prevPlans) => {
            if (destPlanIndex < 0 || destPlanIndex >= prevPlans.length) {
              console.error("Índice de plan inválido:", destPlanIndex);
              return prevPlans;
            }

            const updatedPlans = [...prevPlans];
            const destPlan = updatedPlans[destPlanIndex];

            // Evitar duplicados
            if (
              destPlan.accessories.some(
                (acc) =>
                  (typeof acc === "object" ? acc.title : acc) ===
                  draggedProduct.title,
              )
            ) {
              console.warn("Producto ya existe en el plan");
              return prevPlans;
            }

            const productPrice = parseFloat(
              (draggedProduct.price || 0)
                .toString()
                .replace("$", "")
                .replace(",", ""),
            );

            const productToAdd = {
              title: draggedProduct.title,
              description: draggedProduct.description || "",
              price: productPrice,
            };

            // Agregar al plan
            destPlan.accessories.splice(
              result.destination.index,
              0,
              productToAdd,
            );
            destPlan.totalPrice =
              parseFloat(destPlan.totalPrice || 0) + productPrice;

            // Actualizar plan seleccionado si es necesario
            if (destPlan.isSelected) {
              planUpdated = true;
              updatedPlan = destPlan;
              const newPrecioTotal = Math.round(
                parseFloat(selectedMailData?.precio_vehiculo || 0) +
                  parseFloat(destPlan.totalPrice || 0),
              );
              setPrecioTotal(newPrecioTotal);
              setSelectedPlan(destPlan);
            }

            return updatedPlans;
          });
        }

        // ===== CASO 3: MOVER ENTRE PLANES O DEVOLVER AL POOL =====
        else if (!isNaN(parseInt(sourceId))) {
          const sourceIndex = parseInt(sourceId);
          const destIndex = parseInt(destId);
          const isReturningToPool =
            destId === "accessories-pool" || destId === "products-pool";

          setPlansState((prevPlans) => {
            if (sourceIndex < 0 || sourceIndex >= prevPlans.length) {
              console.error("Invalid source plan index", sourceIndex);
              return prevPlans;
            }

            const updatedPlans = [...prevPlans];
            const sourcePlan = updatedPlans[sourceIndex];

            if (
              result.source.index < 0 ||
              result.source.index >= sourcePlan.accessories.length
            ) {
              console.error("Invalid accessory index", result.source.index);
              return prevPlans;
            }

            const draggedAccessory =
              sourcePlan.accessories[result.source.index];
            const draggedAccessoryTitle =
              typeof draggedAccessory === "object"
                ? draggedAccessory.title
                : draggedAccessory;

            // BUSCAR en el pool combinado (incluyendo automáticos)
            const movedAccessory = combinedPool.find(
              (acc) => acc.title === draggedAccessoryTitle,
            );

            if (!movedAccessory) {
              console.error("Accesorio no encontrado:", draggedAccessoryTitle);
              return prevPlans;
            }

            // Quitar del plan origen
            sourcePlan.accessories.splice(result.source.index, 1);

            const accessoryPrice = parseFloat(
              (movedAccessory.price || draggedAccessory.price || 0)
                .toString()
                .replace("$", "")
                .replace(",", ""),
            );

            sourcePlan.totalPrice = Math.max(
              0,
              parseFloat(sourcePlan.totalPrice || 0) - accessoryPrice,
            );

            // Si el destino es el pool, agregar a eliminados
            if (isReturningToPool) {
              const accessoryToAdd = {
                title: movedAccessory.title,
                description: movedAccessory.description || "",
                price: accessoryPrice,
                type: movedAccessory.type || "accesorios",
              };

              // Solo agregar si no existe ya en eliminados
              if (
                !eliminatedAccessories.some(
                  (acc) => acc.title === accessoryToAdd.title,
                )
              ) {
                setEliminatedAccessories((prev) => [...prev, accessoryToAdd]);
              }
            }

            // Actualizar plan seleccionado si es necesario
            if (sourcePlan.isSelected) {
              planUpdated = true;
              updatedPlan = sourcePlan;
              const newPrecioTotal = Math.round(
                parseFloat(selectedMailData?.precio_vehiculo || 0) +
                  parseFloat(sourcePlan.totalPrice || 0),
              );
              setPrecioTotal(newPrecioTotal);
              setSelectedPlan(sourcePlan);
            }

            // Si es mover entre planes (no devolver al pool)
            if (!isReturningToPool) {
              if (
                isNaN(destIndex) ||
                destIndex < 0 ||
                destIndex >= updatedPlans.length
              ) {
                console.error("Invalid destination plan index", destIndex);
                return prevPlans;
              }

              const destPlan = updatedPlans[destIndex];

              // Evitar duplicados
              if (
                destPlan.accessories.some(
                  (acc) =>
                    (typeof acc === "object" ? acc.title : acc) ===
                    draggedAccessoryTitle,
                )
              ) {
                console.warn("Accesorio ya existe en plan destino");
                return prevPlans;
              }

              const accessoryToMove = {
                title: movedAccessory.title,
                description: movedAccessory.description || "",
                price: accessoryPrice,
              };

              destPlan.accessories.splice(
                result.destination.index,
                0,
                accessoryToMove,
              );

              // Remover de eliminados si estaba ahí
              setEliminatedAccessories((prev) =>
                prev.filter((acc) => acc.title !== movedAccessory.title),
              );

              destPlan.totalPrice =
                parseFloat(destPlan.totalPrice || 0) + accessoryPrice;

              // Actualizar plan seleccionado si es necesario
              if (destPlan.isSelected) {
                planUpdated = true;
                updatedPlan = destPlan;
                const newPrecioTotal = Math.round(
                  parseFloat(selectedMailData?.precio_vehiculo || 0) +
                    parseFloat(destPlan.totalPrice || 0),
                );
                setPrecioTotal(newPrecioTotal);
                selectedPlanVentaIdRef.current = String(
                  selectedMailData?.id || "",
                );
                setSelectedPlan(destPlan);
              }
            }

            return updatedPlans;
          });
        }

        // Actualizar financiamiento si es necesario
        if (planUpdated && updatedPlan) {
          const vehiclePrice = parseFloat(
            selectedMailData?.precio_vehiculo || 0,
          );
          const totalPrice = Math.round(
            vehiclePrice + parseFloat(updatedPlan.totalPrice || 0),
          );

          const mensualidadObjetivo = toNumber(
            formDataRef.current?.mensualidad_buscada || mensualidadC || 0,
          );
          let values;
          if (formData.pago_contado === "Si") {
            values = calculateFinancingValues({
              basePrice: totalPrice,
              downPaymentAmount: vehiclePrice,
              financingMonths: financingMonths,
            });
          } else {
            values = calculateFinancingValues({
              basePrice: totalPrice,
              downPaymentAmount: getEngancheActual(totalPrice),
              financingMonths: financingMonths,
            });
          }

          updateAllFinancingStates(values, { force: true });

          setTimeout(() => {
            updateFinancingData({
              precioTotal: totalPrice,
              mensualidad: values.monthlyPayment,
              accessories: updatedPlan.accessories,
            });
          }, 100);
        }
      } catch (error) {
        console.error("Error in handleDragEnd:", error);
      }
    },
    [
      plansState,
      filteredAccessoriesAndWarranties,
      eliminatedAccessories,
      selectedMailData,
      updateFinancingData,
      ACCESORIOS_MAP,
      plans,
      formData.pago_contado,
      downPaymentPercentage,
      financingMonths,
      manualMonthlyOverride,
      mensualidadC,
      updateAllFinancingStates,
      calculateFinancingValues,
      getEngancheActual,
      markPlanObjectAsManual,
    ],
  );

  // Agregar accesorio a un plan
  function addAccessoryToPlan(accessory, planIndex) {
    const accessoryTitle =
      typeof accessory === "object"
        ? accessory?.title || ""
        : String(accessory || "");
    const initialPlanIndex = resolveSelectedPlanMutationIndex(planIndex);

    activatePlanMutationGuard();

    if (!accessoryTitle || initialPlanIndex < 0) {
      console.warn("No se pudo resolver el plan/accesorio a agregar", {
        accessory,
        planIndex,
        initialPlanIndex,
      });
      return;
    }

    if (esPlanNoEditable(plansState?.[initialPlanIndex])) {
      return;
    }

    setPlansState((prevPlans) => {
      const targetPlanIndex = resolveSelectedPlanMutationIndex(
        initialPlanIndex,
        prevPlans,
      );

      if (
        targetPlanIndex < 0 ||
        esPlanNoEditable(prevPlans?.[targetPlanIndex])
      ) {
        return prevPlans;
      }

      markPlanAsManuallyEdited(prevPlans?.[targetPlanIndex]);

      const updatedPlans = [...prevPlans];
      const originalPlan = prevPlans[targetPlanIndex];

      if (!originalPlan) return prevPlans;

      const destPlan = {
        ...originalPlan,
        accessories: Array.isArray(originalPlan.accessories)
          ? [...originalPlan.accessories]
          : [],
      };

      if (
        destPlan.accessories.some((acc) => {
          const currentTitle =
            typeof acc === "object" ? acc?.title || "" : String(acc || "");

          return currentTitle === accessoryTitle;
        })
      ) {
        console.warn("Accesorio ya existe en el plan");
        return prevPlans;
      }

      let accessoryOriginal = basePlansState
        .flatMap((plan) => plan.accessories || [])
        .find((acc) => acc?.title === accessoryTitle);

      if (!accessoryOriginal) {
        accessoryOriginal =
          typeof accessory === "object" ? accessory : { title: accessoryTitle };
      }

      const priceBase = toNumber(
        accessoryOriginal.price_base ?? accessoryOriginal.price ?? 0,
      );
      const pricePromo = toNumber(
        accessoryOriginal.price_promo ??
          accessoryOriginal.promoPrice ??
          priceBase,
      );

      const accessoryToAdd = {
        title: accessoryTitle,
        description:
          accessoryOriginal.description || accessory?.description || "",
        price_base: priceBase,
        price_promo: pricePromo,
        price: priceBase,
        type: accessoryOriginal.type || accessory?.type || "accesorios",
      };

      destPlan.accessories.push(accessoryToAdd);
      destPlan.totalPrice_base = toNumber(destPlan.totalPrice_base) + priceBase;
      destPlan.totalPrice_promo =
        toNumber(destPlan.totalPrice_promo) + pricePromo;
      destPlan.totalPrice = toNumber(destPlan.totalPrice) + priceBase;

      updatedPlans[targetPlanIndex] = markPlanObjectAsManual(destPlan);

      setEliminatedAccessories((prev) =>
        prev.filter((acc) => acc.title !== accessoryTitle),
      );

      try {
        const promo = obtenerPromocion(destPlan, selectedVehicleName);
        actualizarCampoPlan(destPlan.title.toLowerCase(), promo);
      } catch (error) {
        console.error("Error recalculando promoción:", error);
      }

      const selectedAfterMutationIndex = updatedPlans.findIndex(
        (plan) => plan?.isSelected && !esPlanCliente(plan),
      );

      if (selectedAfterMutationIndex >= 0) {
        const selectedAfterMutation = updatedPlans[selectedAfterMutationIndex];
        selectedPlanKeyRef.current = getPlanKey(selectedAfterMutation);
        selectedPlanVentaIdRef.current = String(
          (selectedMailDataRef.current || selectedMailData || {})?.id || "",
        );
        setSelectedPlan(selectedAfterMutation);
        setSelectedPlanFinal(selectedAfterMutationIndex);
        setSelectedPlanIndex(selectedAfterMutationIndex);
      }

      const ventaActualParaPatch =
        selectedMailDataRef.current || selectedMailData || {};
      if (ventaActualParaPatch?.id) {
        selectedMailDataRef.current = {
          ...ventaActualParaPatch,
          planes_financiamiento: updatedPlans,
        };
      }

      Promise.resolve().then(() => {
        syncFinancingAfterPlanMutation(updatedPlans, "addAccessoryToPlan");
      });

      return updatedPlans;
    });
  }

  const renderAccessoryWithButtons = ({
    accessory,
    onAdd,
    onRemove,
    key,
    selectedPlan,
    disabled = false,
  }) => {
    const accessoryTitleForCompare =
      typeof accessory === "object"
        ? accessory?.title || ""
        : String(accessory || "");
    const isInPlan = selectedPlan?.accessories?.some((acc) => {
      const currentTitle =
        typeof acc === "object" ? acc?.title || "" : String(acc || "");

      return currentTitle === accessoryTitleForCompare;
    });

    const type = accessory.type || "";
    const isGarantia = type.toLowerCase().trim() === "garantias";
    const accessoryTitle =
      typeof accessory === "object" ? accessory.title : accessory;

    const normalColor = isGarantia ? "rgb(255, 167, 38)" : "rgb(0, 196, 159)";
    const addedColor = "#4091e2";
    const textColor = "white";

    const style = {
      position: "relative",
      display: "inline-flex",
      alignItems: "center",
      padding: "5px 10px",
      margin: "5px",
      userSelect: "none",
      backgroundColor: isInPlan ? addedColor : normalColor,
      color: textColor,
      borderRadius: "8px",
      //border: isInPlan ? "2px solid #00366f" : "none",
      boxShadow: "0 2px 6px rgba(0, 0, 0, 0.1)",
      minWidth: "200px",
      justifyContent: "space-between",
      transition: "all 0.3s ease",
      opacity: disabled ? 0.72 : 1,
      cursor: disabled ? "default" : "pointer",
    };

    const buttonStyle = {
      cursor: "pointer",
      background: "transparent",
      border: "none",
      color: textColor,
      fontWeight: "bold",
      fontSize: "18px",
      padding: "0 8px",
      margin: "0 4px",
      borderRadius: "4px",
    };

    return (
      <div key={key} style={style}>
        <div className="me-2">
          <p className="mb-1 fw-bold text-whitee d-flex align-items-center gap-1">
            {toTitleCase(accessoryTitle.split(" - ")[0])}
            {isInPlan && (
              <svg
                width="18"
                height="18"
                viewBox="0 0 24 24"
                style={{ marginLeft: 4 }}
              >
                <circle cx="12" cy="12" r="12" fill="#ffffff" />
                <path
                  fill="#4091e2"
                  d="M20.285 6.709a1 1 0 0 0-1.414-1.418l-9.2 9.25-4.1-4.1a1 1 0 1 0-1.414 1.414l4.8 4.8a1 1 0 0 0 1.414 0l9.8-9.946z"
                />
              </svg>
            )}
          </p>
        </div>

        {!disabled &&
          (isInPlan ? (
            <button
              type="button"
              style={buttonStyle}
              onMouseDown={(event) => {
                event.stopPropagation();
              }}
              onPointerDown={(event) => {
                event.stopPropagation();
              }}
              onClick={(event) => {
                event.preventDefault();
                event.stopPropagation();
                onRemove?.(event);
              }}
            >
              −
            </button>
          ) : (
            <button
              type="button"
              style={buttonStyle}
              onMouseDown={(event) => {
                event.stopPropagation();
              }}
              onPointerDown={(event) => {
                event.stopPropagation();
              }}
              onClick={(event) => {
                event.preventDefault();
                event.stopPropagation();
                onAdd?.(event);
              }}
            >
              +
            </button>
          ))}
      </div>
    );
  };

  const handleFinalDragEnd = useCallback(
    (result) => {
      if (!result || !result.destination || !selectedPlan) return;

      const { droppableId: sourceId } = result.source;
      const { droppableId: destId } = result.destination;

      if (sourceId === "accessories-pool" && destId === "selected-plan") {
        const accIndex = result.source.index;
        const draggedAcc = filteredAccessoriesAndWarranties[accIndex];
        if (!draggedAcc)
          return console.error("Accesorio no encontrado:", accIndex);

        const cleanPrice =
          parseFloat(
            draggedAcc.price?.toString().replace(/\$/g, "").replace(/,/g, ""),
          ) || 0;

        const accObj = {
          title: draggedAcc.title,
          description: draggedAcc.description ?? "",
          price: cleanPrice,
        };

        setPlansState((prevPlans) => {
          const idx = prevPlans.findIndex((p) => p.isSelected);
          if (idx === -1) return prevPlans;

          const plan = prevPlans[idx];
          if (plan.accessories.some((a) => a.title === accObj.title))
            return prevPlans;

          // CREA EL OBJETO actualizado
          const updatedAccessories = [...plan.accessories, accObj];
          const updatedTotal = (plan.totalPrice || 0) + accObj.price;

          const updatedPlan = markPlanObjectAsManual({
            ...plan,
            accessories: updatedAccessories,
            totalPrice: updatedTotal,
          });

          const copy = [...prevPlans];
          copy[idx] = updatedPlan;

          try {
            const promo = obtenerPromocion(updatedPlan, selectedVehicleName);
            actualizarCampoPlan(updatedPlan.title.toLowerCase(), promo);
          } catch (error) {
            console.error("Error recalculando promoción:", error);
          }

          // === AQUÍ: CÁLCULO Y API CON EL OBJETO ACTUALIZADO ===
          const vehiclePrice = parseFloat(
            selectedMailData?.precio_vehiculo || 0,
          );
          const totalPrice = Math.round(vehiclePrice + updatedTotal);
          const mensualidadObjetivo = toNumber(
            formDataRef.current?.mensualidad_buscada || mensualidadC || 0,
          );
          let values;
          if (formData.pago_contado === "Si") {
            values = calculateFinancingValues({
              basePrice: totalPrice,
              downPaymentAmount: vehiclePrice,
              financingMonths: financingMonths,
            });
          } else {
            values = calculateFinancingValues({
              basePrice: totalPrice,
              downPaymentAmount: getEngancheActual(totalPrice),
              financingMonths: financingMonths,
            });
          }

          // ACTUALIZA ESTADOS Y ENVÍA API **AQUÍ MISMO**
          updateAllFinancingStates(values, { force: true });

          setTimeout(() => {
            updateFinancingData({
              precioTotal: totalPrice,
              mensualidad: values.monthlyPayment,
              accessories: updatedAccessories,
            });
          }, 100);

          // Puedes también actualizar selectedPlan aquí si lo deseas:
          selectedPlanVentaIdRef.current = String(selectedMailData?.id || "");
          selectedPlanVentaIdRef.current = String(selectedMailData?.id || "");
          setSelectedPlan(updatedPlan);
          setPrecioTotal(totalPrice);
          persistPlanesFinanciamientoSnapshot(copy, totalPrice);

          return copy;
        });
      }

      // --- Quitar accesorio del plan seleccionado ---
      else if (sourceId === "selected-plan" && destId === "accessories-pool") {
        const accIndex = result.source.index;

        setPlansState((prevPlans) => {
          const idx = prevPlans.findIndex((p) => p.isSelected);
          if (idx === -1) return prevPlans;

          const plan = prevPlans[idx];
          const removedObj = plan.accessories[accIndex];
          if (!removedObj) return prevPlans;

          const updatedAccessories = plan.accessories.filter(
            (_, i) => i !== accIndex,
          );
          const updatedTotal = Math.max(
            0,
            (plan.totalPrice || 0) - (removedObj.price ?? 0),
          );

          const updatedPlan = markPlanObjectAsManual({
            ...plan,
            accessories: updatedAccessories,
            totalPrice: updatedTotal,
          });

          const copy = [...prevPlans];
          copy[idx] = updatedPlan;

          try {
            const promo = obtenerPromocion(updatedPlan, selectedVehicleName);
            actualizarCampoPlan(updatedPlan.title.toLowerCase(), promo);
          } catch (error) {
            console.error("Error recalculando promoción:", error);
          }

          // === IGUAL QUE ARRIBA, CÁLCULO Y API CON EL OBJETO NUEVO ===
          const vehiclePrice = parseFloat(
            selectedMailData?.precio_vehiculo || 0,
          );
          const totalPrice = Math.round(vehiclePrice + updatedTotal);
          const mensualidadObjetivo = toNumber(
            formDataRef.current?.mensualidad_buscada || mensualidadC || 0,
          );
          let values;
          if (formData.pago_contado === "Si") {
            values = calculateFinancingValues({
              basePrice: totalPrice,
              downPaymentAmount: vehiclePrice,
              financingMonths: financingMonths,
            });
          } else {
            values = calculateFinancingValues({
              basePrice: totalPrice,
              downPaymentAmount: getEngancheActual(totalPrice),
              financingMonths: financingMonths,
            });
          }

          updateAllFinancingStates(values, { force: true });

          setTimeout(() => {
            updateFinancingData({
              precioTotal: totalPrice,
              mensualidad: values.monthlyPayment,
              accessories: updatedAccessories,
            });
          }, 100);

          selectedPlanVentaIdRef.current = String(selectedMailData?.id || "");
          setSelectedPlan(updatedPlan);
          setPrecioTotal(totalPrice);
          persistPlanesFinanciamientoSnapshot(copy, totalPrice);

          return copy;
        });
      }
    },
    [
      filteredAccessoriesAndWarranties,
      selectedPlan,
      selectedMailData,
      formData.pago_contado,
      downPaymentPercentage,
      financingMonths,
      manualMonthlyOverride,
      mensualidadC,
      updateFinancingData,
      calculateFinancingValues,
      updateAllFinancingStates,
      getEngancheActual,
      markPlanObjectAsManual,
    ],
  );

  useEffect(() => {
    if (isUserEditing.current) return;
    if (activeFinancingEditRef.current) return;
    if (!selectedPlanForFinancing || !selectedPlanForFinancing.accessories)
      return;

    const ventaActual = selectedMailDataRef.current || selectedMailData;
    const ventaIdForAutoSync = String(ventaActual?.id || "");

    if (!ventaIdForAutoSync) return;

    if (
      selectedPlanVentaIdRef.current &&
      String(selectedPlanVentaIdRef.current) !== ventaIdForAutoSync
    ) {
      return;
    }

    const financiamientoManualActivo =
      Number(
        selectedMailDataRef.current?.financiamiento_modal ??
          selectedMailData?.financiamiento_modal ??
          0,
      ) === 1;

    // Si ya se guardó una cotización manual desde el modal, este efecto no debe
    // volver a calcular ni a mandar mensualidades automáticas.
    if (
      isManualFinancingModalSavedActive(ventaIdForAutoSync) ||
      isManualFinancingModalGuardActive(ventaIdForAutoSync) ||
      financiamientoManualActivo
    ) {
      return;
    }

    const vehiclePrice = toNumber(ventaActual?.precio_vehiculo || 0);
    const accesoriosTotal = getPlanAccessoriesTotalForFinancing(
      selectedPlanForFinancing,
    );
    const totalPrice = Math.round(vehiclePrice + accesoriosTotal);

    let values;
    if (formData.pago_contado === "Si") {
      values = calculateFinancingValues({
        basePrice: totalPrice,
        downPaymentAmount: vehiclePrice,
        financingMonths,
        origin: "Pago contado",
      });
    } else {
      values = calculateFinancingValues({
        basePrice: totalPrice,
        downPaymentAmount: getEngancheActual(totalPrice),
        financingMonths,
        origin: "autoPlanVisualSync",
      });
    }

    const planAccessoriesSignature = JSON.stringify(
      (selectedPlanForFinancing?.accessories || []).map((acc) => ({
        title: acc?.title || "",
        price: getUnitPrice(acc),
        qty: acc?.qty ?? 1,
      })),
    );

    const visualSignature = JSON.stringify({
      venta_id: ventaIdForAutoSync,
      plan: normalizarNombrePlan(selectedPlanForFinancing),
      accessories: planAccessoriesSignature,
      totalPrice,
      financingMonths,
      downPaymentAmount: values.downPaymentAmount,
      downPaymentPercentage: values.downPaymentPercentage,
      monthlyPayment: values.monthlyPayment,
      pago_contado: formData.pago_contado || "",
    });

    if (lastAutoPlanVisualSyncSignatureRef.current === visualSignature) return;
    lastAutoPlanVisualSyncSignatureRef.current = visualSignature;

    // Este efecto sólo sincroniza el estado visual. El guardado real del plan
    // ya ocurre en acciones explícitas como seleccionar plan, cambiar versión o
    // agregar/quitar accesorios mediante persistPlanesFinanciamientoSnapshot.
    // No se llama /actualizar/plan/financiamiento aquí para evitar saturar Network.
    updateAllFinancingStates(values);
  }, [
    selectedPlanForFinancing,
    selectedMailData?.id,
    selectedMailData?.precio_vehiculo,
    financingMonths,
    formData.pago_contado,
    getEngancheActual,
    calculateFinancingValues,
    updateAllFinancingStates,
    isManualFinancingModalGuardActive,
    isManualFinancingModalSavedActive,
  ]);

  useEffect(() => {
    // El ingreso mensual ya se guarda dentro del JSON entrevista con debounce.
    // No lo enviamos a /actualizar/estado/financiamiento en cada tecla porque
    // esa carrera provocaba que el input se rebotara mientras el asesor escribía.
  }, [formData.ingreso_mensual]);

  const handleConfirmPlease = async () => {
    setIsConfirming(true);

    const requestData = {
      access_token: accessToken,
      venta_id: selectedMailData.id,
      terminos_modal: 1,
      nombre: formData.nombre,
      telefono: formData.telefono,
      correo_electronico: formData.correo_electronico,
    };

    try {
      const response = await fetch(apiUpdateEstadoUrl, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(requestData),
      });

      const data = await response.json();

      if (data.statusCode === 200) {
        const ventaId = selectedMailData?.id;

        if (ventaId) {
          patchSelectedVentaPersonalLocal(ventaId, {
            nombre: formData.nombre,
            telefono: formData.telefono,
            correo_electronico: formData.correo_electronico,
          });

          setConfirmedVentas((prev) => ({
            ...prev,
            [ventaId]: true,
          }));
        }
      }
    } catch (error) {
      console.error("Error al confirmar:", error);
    } finally {
      // Siempre desactivamos el estado de 'enviando' sin importar el resultado
      setIsConfirming(false);
    }
  };

  const handleCalcularRfc = async () => {
    const resultado = calcularRfcYHomoclave({
      nombre: formData.nombre,
      apellidoPaterno: formData.apellido_paterno,
      apellidoMaterno: formData.apellido_materno,
      fechaNacimiento: formData.fecha_nacimiento,
    });

    if (!resultado.valido) {
      Swal.fire({
        icon: "warning",
        title: "Faltan datos para calcular el RFC",
        text: "Captura nombre, apellido paterno (o materno) y fecha de nacimiento.",
        confirmButtonText: "Aceptar",
      });
      return;
    }

    setFormData((prev) => ({
      ...prev,
      rfc: resultado.rfc,
      homoclave: resultado.homoclave,
    }));

    keepUserEditingBriefly(10000);

    const ventaIdInmediato = selectedMailDataRef.current?.id || selectedMailData?.id;
    if (ventaIdInmediato) {
      patchSelectedVentaPersonalLocal(ventaIdInmediato, {
        rfc: resultado.rfc,
        homoclave: resultado.homoclave,
      });
    }

    const requestData = {
      access_token: accessToken,
      venta_id: selectedMailData?.id,
      apellido_paterno: formData.apellido_paterno,
      apellido_materno: formData.apellido_materno,
      fecha_nacimiento: formData.fecha_nacimiento,
      rfc: resultado.rfc,
      homoclave: resultado.homoclave,
    };

    try {
      const response = await fetch(apiUpdateEstadoUrl, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(requestData),
      });

      const data = await response.json();

      if (data.statusCode === 200) {
        const ventaId = selectedMailData?.id;

        if (ventaId) {
          patchSelectedVentaPersonalLocal(ventaId, {
            apellido_paterno: formData.apellido_paterno,
            apellido_materno: formData.apellido_materno,
            fecha_nacimiento: formData.fecha_nacimiento,
            rfc: resultado.rfc,
            homoclave: resultado.homoclave,
          });
        }
      }
    } catch (error) {
      console.error("Error al guardar RFC:", error);
    }
  };

  const handleMostrarAccesorios = async () => {
    const requestData = {
      access_token: accessToken,
      venta_id: selectedMailData.id,
      accesorios_modal: 1,
    };

    try {
      const response = await fetch(apiUpdateEstadoUrl, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(requestData),
      });

      const data = await response.json();

      if (data.statusCode === 200) {
        // Aquí puedes agregar lógica si necesitas abrir un modal o dar feedback
      }
    } catch (error) {
      console.error("Error al mostrar accesorios:", error);
    }
  };

  // El guardado automático por cada cambio de plansState queda desactivado.
  // Los planes se guardan sólo desde acciones explícitas mediante
  // persistPlanesFinanciamientoSnapshot, con debounce y firma.
  useEffect(() => {
    return () => {
      if (plansPersistTimeoutRef.current) {
        clearTimeout(plansPersistTimeoutRef.current);
        plansPersistTimeoutRef.current = null;
      }
    };
  }, []);

  useEffect(() => {
    const firstModalEl = document.getElementById("accessoryModal");

    if (selectedMailData?.firma_modal === "1") {
      setMostrarModalInfo(true);
      setGarantiaExtendida("Si");

      // Bloquear scroll del primer modal mientras el segundo está abierto
      if (firstModalEl) {
        firstModalEl.style.pointerEvents = "none";
        firstModalEl.style.overflow = "hidden";
      }
    } else if (selectedMailData?.firma_modal === "0") {
      setGarantiaExtendida("No");
      setMostrarModalInfo(false);
      // Restaurar scroll e interacción del primer modal
      if (firstModalEl) {
        firstModalEl.style.pointerEvents = "auto";
        firstModalEl.style.overflow = "auto";
      }
    } else if (selectedMailData?.firma_modal === "10") {
      // Aceptó términos - cerrar modal
      setMostrarModalInfo(false);
      setGarantiaExtendida("Si");
      // Restaurar scroll e interacción del primer modal
      if (firstModalEl) {
        firstModalEl.style.pointerEvents = "auto";
        firstModalEl.style.overflow = "auto";
      }
    } else if (selectedMailData?.firma_modal === "00") {
      // No aceptó términos - cerrar modal
      setMostrarModalInfo(false);
      setGarantiaExtendida("No");
      // Restaurar scroll e interacción del primer modal
      if (firstModalEl) {
        firstModalEl.style.pointerEvents = "auto";
        firstModalEl.style.overflow = "auto";
      }
    }
  }, [selectedMailData]);

  useEffect(() => {
    const checkFullscreen = () => {
      const isExpanded = document.querySelector(".card-expand");
      if (isExpanded) {
        document.body.style.overflow = "hidden"; // bloquear scroll
      } else {
        document.body.style.overflow = ""; // desbloquear scroll
      }
    };

    checkFullscreen(); // revisa al montar

    const observer = new MutationObserver(checkFullscreen);
    observer.observe(document.body, {
      subtree: true,
      attributes: true,
      attributeFilter: ["class"],
    });

    return () => {
      document.body.style.overflow = ""; // limpieza
      observer.disconnect();
    };
  }, []);

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 1024); //movil
  const [isTablet, setIsTablet] = useState(
    window.innerWidth > 1024 && window.innerWidth <= 1200,
  ); //tablet
  const [engancheDraft, setEngancheDraft] = useState("");

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 1024);
      setIsTablet(window.innerWidth > 1024 && window.innerWidth <= 1200);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const [activeCard, setActiveCard] = useState(
    window.innerWidth <= 1024 ||
      (window.innerWidth > 1024 && window.innerWidth <= 1200)
      ? "asesor"
      : "both", // 'both' será para desktop
  );

  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      const mobile = width <= 1024;
      const tablet = width > 1024 && width <= 1200;
      setIsMobile(mobile);
      setIsTablet(tablet);

      // Forzar activeCard correcto al cambiar orientación
      if (mobile || tablet) {
        setActiveCard("asesor");
      } else {
        setActiveCard("both");
      }
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Evita que PerfectScrollbar interfiera con los sliders sin registrar listeners en cada render.
  useEffect(() => {
    const rangeInputs = Array.from(
      document.querySelectorAll('input[type="range"]'),
    );
    const stopPropagation = (e) => e.stopPropagation();

    rangeInputs.forEach((rangeInput) => {
      rangeInput.addEventListener("touchstart", stopPropagation, {
        passive: false,
      });
      rangeInput.addEventListener("touchmove", stopPropagation, {
        passive: false,
      });
      rangeInput.addEventListener("touchend", stopPropagation, {
        passive: false,
      });
      rangeInput.addEventListener("mousedown", stopPropagation);
      rangeInput.addEventListener("mousemove", stopPropagation);
    });

    return () => {
      rangeInputs.forEach((rangeInput) => {
        rangeInput.removeEventListener("touchstart", stopPropagation);
        rangeInput.removeEventListener("touchmove", stopPropagation);
        rangeInput.removeEventListener("touchend", stopPropagation);
        rangeInput.removeEventListener("mousedown", stopPropagation);
        rangeInput.removeEventListener("mousemove", stopPropagation);
      });
    };
  }, [step, selectedMailData?.id]);

  const handleTouchStart = (e) => {
    e.stopPropagation();
  };

  const handleTouchMove = (e) => {
    e.stopPropagation();
  };

  const handleTouchEnd = (e) => {
    e.stopPropagation();
  };

  const handleMontoSeguroChangeC = (e) => {
    let rawValue = e.target.value.replace(/[$,]/g, "");
    rawValue = rawValue.replace(/[^0-9.]/g, "");
    const parts = rawValue.split(".");

    if (parts.length > 2) return;
    setMontoSeguro(rawValue);
    setMontoSeguroDisplay(formatInputCurrency(rawValue));
  };

  const formatInputCurrency = (value) => {
    if (!value && value !== 0) return "";

    // Si el usuario acaba de poner un punto, lo mantenemos visualmente
    const stringValue = value.toString();
    const hasDotAtEnd = stringValue.endsWith(".");

    // Separamos parte entera de decimales
    const [entero, decimal] = stringValue.split(".");

    // Formateamos solo la parte entera con comas
    const enteroFormateado = Number(entero).toLocaleString("es-MX");

    // Si tiene punto al final, devolvemos "1,200."
    if (hasDotAtEnd) {
      return `$${enteroFormateado}.`;
    }

    // Si tiene decimales, devolvemos "1,200.50"
    if (decimal !== undefined) {
      return `$${enteroFormateado}.${decimal}`;
    }

    // Si es un número entero normal
    return `$${enteroFormateado}`;
  };

  const formatModalMoneyInput = (value = "") => {
    const originalValue = String(value ?? "");
    const cleaned = originalValue
      .replace(/[$,\s]/g, "")
      .replace(/[^0-9.]/g, "");

    if (!cleaned) return "";

    const parts = cleaned.split(".");
    if (parts.length > 2) return null;

    const integerPartRaw = parts[0] || "";
    const decimalPart = parts[1];
    const endsWithDot = cleaned.endsWith(".");
    const integerPart = integerPartRaw.replace(/^0+(?=\d)/, "");
    const formattedInteger = integerPart
      ? Number(integerPart).toLocaleString("es-MX")
      : "0";

    if (endsWithDot) return `${formattedInteger}.`;
    if (decimalPart !== undefined) return `${formattedInteger}.${decimalPart}`;

    return formattedInteger;
  };

  const formatModalMoneyValue = (value = "") => {
    const numericValue = toNumber(value);
    if (!numericValue) return "";

    const decimalText = String(numericValue).split(".")[1] || "";
    const formattedInteger = Math.trunc(numericValue).toLocaleString("es-MX");

    return decimalText
      ? `${formattedInteger}.${decimalText}`
      : formattedInteger;
  };

  const getCurrentCotizadorSnapshot = useCallback(() => {
    const ventaActual = selectedMailDataRef.current || selectedMailData || {};
    const fd = formDataRef.current || {};

    const mesesBd = getMesesFromVentaBD(ventaActual);
    const mesesForm = Number(String(fd?.plazo_meses || "").replace(/\D/g, ""));
    const mesesState = Number(financingMonths || 0);

    return {
      mensualidad: toNumber(
        ventaActual?.mensualidad_estimacion ??
          mensualidadC ??
          fd?.mensualidad_buscada ??
          monthlyPayment ??
          "",
      ),
      enganche: toNumber(
        ventaActual?.enganche ??
          ventaActual?.engancheEditable ??
          engancheC ??
          fd?.engancheEditable ??
          fd?.enganche ??
          "",
      ),
      tasa:
        tasaC ||
        ventaActual?.perdio_llaves ||
        TASA_FINANCIAMIENTO_PORCENTAJE ||
        "",
      meses: mesesBd || mesesForm || mesesState || "",
    };
  }, [
    selectedMailData,
    getMesesFromVentaBD,
    mensualidadC,
    engancheC,
    tasaC,
    financingMonths,
    monthlyPayment,
  ]);

  useEffect(() => {
    const ventaId = String(
      selectedMailDataRef.current?.id || formDataRef.current?.venta_id || "",
    );

    if (isEditingFinancingModalRef.current) return;
    if (isManualFinancingModalGuardActive(ventaId)) return;
    // Si el modal está abierto, sus campos son captura manual temporal.
    // No se deben rehidratar desde BD hasta cerrar el modal.
    if (isCotizadorModalOpen()) return;

    const snapshot = getCurrentCotizadorSnapshot();

    setModalMensualidadInput(formatModalMoneyValue(snapshot.mensualidad));
    setModalEngancheInput(formatModalMoneyValue(snapshot.enganche));
    setModalTasaInput(String(snapshot.tasa || ""));
    setModalFinancingMonthsManual(snapshot.meses || "", { dirty: false });
  }, [
    selectedMailData?.id,
    selectedMailData?.mensualidad_estimacion,
    selectedMailData?.enganche,
    selectedMailData?.engancheEditable,
    selectedMailData?.perdio_llaves,
    selectedMailData?.meses_financiamiento,
    mensualidadC,
    engancheC,
    tasaC,
    financingMonths,
    monthlyPayment,
    getCurrentCotizadorSnapshot,
    isManualFinancingModalGuardActive,
    isCotizadorModalOpen,
    setModalFinancingMonthsManual,
  ]);

  const persistModalCotizadorDraft = useCallback(
    (patch = {}) => {
      const ventaActual = selectedMailDataRef.current || selectedMailData;
      const ventaId = String(
        ventaActual?.id || formDataRef.current?.venta_id || "",
      );

      if (!ventaId) return;

      mergeAsesorDraft(ventaId, {
        mensualidadC,
        mensualidadDisplay,
        engancheC,
        engancheDisplay,
        tasaC,
        financingMonths,
        manualMonthlyOverride: true,
        ...patch,
      });
    },
    [
      selectedMailData,
      mergeAsesorDraft,
      mensualidadC,
      mensualidadDisplay,
      engancheC,
      engancheDisplay,
      tasaC,
      financingMonths,
    ],
  );

  const persistCotizadorFieldDebounced = useCallback(
    (requestPatch = {}) => {
      const ventaActual = selectedMailDataRef.current || selectedMailData;
      const ventaIdSnapshot = String(
        ventaActual?.id || formDataRef.current?.venta_id || "",
      );

      if (!ventaIdSnapshot) return;

      if (cotizadorMensualidadTimerRef.current) {
        clearTimeout(cotizadorMensualidadTimerRef.current);
      }

      cotizadorMensualidadTimerRef.current = setTimeout(async () => {
        const ventaActualTimer =
          selectedMailDataRef.current || selectedMailData;

        if (String(ventaActualTimer?.id || "") !== ventaIdSnapshot) return;

        try {
          await fetch(apiUpdateEstadoUrl, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              access_token: accessToken,
              venta_id: ventaIdSnapshot,
              ...requestPatch,
            }),
          });
        } catch (error) {
          console.error("Error guardando campo manual de cotizador:", error);
        }
      }, 500);
    },
    [selectedMailData],
  );

  const handleMensualidadChangeC = (e) => {
    // Modal de financiamiento: captura manual.
    // Sólo se formatea visualmente; no calcula y no manda a BD hasta Guardar.
    isEditingFinancingModalRef.current = true;
    isUserEditing.current = true;
    setManualMonthlyOverride(true);

    const formattedValue = formatModalMoneyInput(e.target.value);
    if (formattedValue === null) return;

    setModalMensualidadInput(formattedValue);
  };

  const [validationMessageC, setValidationMessageC] = useState("");

  const handleEngancheChangeC = (e) => {
    // Modal de financiamiento: captura manual.
    // Sólo se formatea visualmente; no valida mínimo, no calcula y no manda a BD hasta Guardar.
    isEditingFinancingModalRef.current = true;
    isUserEditing.current = true;
    setUserEditedEnganche(true);
    setManualMonthlyOverride(true);
    setValidationMessageC("");

    const formattedValue = formatModalMoneyInput(e.target.value);
    if (formattedValue === null) return;

    setModalEngancheInput(formattedValue);
  };

  const handleEngancheBlurC = () => {
    // En el modal de cotizador NR el enganche es manual.
    // No se recalcula ni se fuerza mínimo al salir del campo.
  };

  // Handler para Monto Comisión
  const handleMontoComisionChange = (e) => {
    let rawValue = e.target.value.replace(/[$,]/g, "");
    rawValue = rawValue.replace(/[^0-9.]/g, "");

    const parts = rawValue.split(".");
    if (parts.length > 2) return;

    // Actualizamos ambos estados
    setMontoComision(rawValue);
    setMontoComisionDisplay(formatInputCurrency(rawValue));
  };

  // Handler para Monto Seguro
  const handleMontoSeguroChange = (e) => {
    let rawValue = e.target.value.replace(/[$,]/g, "");
    rawValue = rawValue.replace(/[^0-9.]/g, "");

    const parts = rawValue.split(".");
    if (parts.length > 2) return;

    setMontoSeguro(rawValue);
    setMontoSeguroDisplay(formatInputCurrency(rawValue));
  };

  const handlePlacasChange = (e) => {
    const value = e.target.value;

    setIncluyePlacas(value);

    // Si selecciona NO, limpiar monto
    if (value === "No") {
      setMontoPlacas("");
    }
  };

  const handlePriceUpdate = async () => {
    // Si borran todo, regresar al valor original
    if (!tempPrice) {
      setTempPrice(originalPrice);

      setIsEditingPrice(false);

      return;
    }

    const numericValue = Number(tempPrice) || 0;

    try {
      const requestData = {
        access_token: accessToken,
        venta_id: formData.venta_id,
        precio_vehiculo: numericValue,
      };

      const response = await fetch(apiUpdateEstadoUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestData),
      });

      const data = await response.json();

      setSelectedMailData((prev) => ({
        ...prev,
        precio_vehiculo: numericValue,
      }));
    } catch (error) {
      console.error("Error actualizando precio:", error);
    }

    setIsEditingPrice(false);
  };

  const handleGuardarDatosFinancieros = async () => {
    try {
      const ventaId = String(
        selectedMailDataRef.current?.id || formData.venta_id || "",
      );

      isSavingFinancingModalRef.current = true;
      manualFinancingModalGuardRef.current = {
        ventaId,
        until: Date.now() + 60000,
      };
      markManualFinancingModalSaved(ventaId);

      if (debounceTimer.current) {
        clearTimeout(debounceTimer.current);
        debounceTimer.current = null;
      }
      if (cotizadorMensualidadTimerRef.current) {
        clearTimeout(cotizadorMensualidadTimerRef.current);
        cotizadorMensualidadTimerRef.current = null;
      }
      if (cotizadorEngancheTimerRef.current) {
        clearTimeout(cotizadorEngancheTimerRef.current);
        cotizadorEngancheTimerRef.current = null;
      }

      const snapshot = getCurrentCotizadorSnapshot();
      const modalMensualidadTexto = String(modalMensualidadInput ?? "").trim();
      const modalEngancheTexto = String(modalEngancheInput ?? "").trim();
      const modalMesesTexto = getModalFinancingMonthsManualValue();
      const modalTasaTexto = String(modalTasaInput ?? "").trim();

      const mensualidadManual = modalMensualidadTexto
        ? toNumber(modalMensualidadTexto)
        : toNumber(snapshot.mensualidad || 0);
      const engancheManual = modalEngancheTexto
        ? toNumber(modalEngancheTexto)
        : toNumber(snapshot.enganche || 0);
      const mesesManual =
        Number(modalMesesTexto.replace(/\D/g, "")) ||
        Number(snapshot.meses) ||
        0;
      const tasaManual = modalTasaTexto
        ? toNumber(modalTasaTexto)
        : toNumber(snapshot.tasa) || TASA_FINANCIAMIENTO_PORCENTAJE;

      const requestData = {
        access_token: accessToken,
        venta_id: ventaId || formData.venta_id,

        // Datos manuales del cotizador NR.
        // Sólo mandamos columnas reales de venta_financiamiento.
        // La tasa se guarda en perdio_llaves.
        mensualidad_estimacion: mensualidadManual,
        meses_financiamiento: mesesManual,
        enganche: engancheManual,
        perdio_llaves: tasaManual,
        financiamiento_modal: 1,

        // Seguro
        aseguradora: aseguradora || null,
        monto_seguro: toNumber(montoSeguro) || 0,
        tipo_compra_seguro: tipoCompraSeguro || null,

        // Comisión
        monto_comision_apertura: toNumber(montoComision) || 0,
        tipo_comision: tipoComision || null,

        // Placas
        monto_placas: incluyePlacas === "Si" ? toNumber(montoPlacas) || 0 : 0,

        // Adicionales
        adicionales_contado: {
          total: adicionalesContado.reduce(
            (acc, item) => acc + Number(item.price || 0),
            0,
          ),
          items: adicionalesContado.map((item) => ({
            titulo: formatTitle(item.title),
            precio: Number(item.price) || 0,
          })),
        },
      };

      lastFinancingDataSignatureRef.current = "";
      const data = await guardarFinanciamientoSnapshotBD(requestData);

      if (ventaId) {
        markLocalFinancingPatch(ventaId, {
          mensualidad_estimacion: mensualidadManual,
          meses_financiamiento: mesesManual,
          plazo_meses: String(mesesManual),
          enganche: engancheManual,
          engancheEditable: engancheManual,
          perdio_llaves: tasaManual,
        });
      }

      selectedMailDataRef.current = {
        ...(selectedMailDataRef.current || {}),
        mensualidad_estimacion: mensualidadManual,
        meses_financiamiento: mesesManual,
        enganche: engancheManual,
        engancheEditable: engancheManual,
        perdio_llaves: tasaManual,
        financiamiento_modal: 1,
      };

      setMensualidadC(String(mensualidadManual || ""));
      setMensualidadDisplay(formatInputCurrency(mensualidadManual || ""));
      setEngancheC(String(engancheManual || ""));
      setEngancheDisplay(formatInputCurrency(engancheManual || ""));
      setTasaC(String(tasaManual || ""));
      setFinancingMonths(mesesManual);
      setModalMensualidadInput(formatModalMoneyValue(mensualidadManual));
      setModalEngancheInput(formatModalMoneyValue(engancheManual));
      setModalTasaInput(String(tasaManual || ""));
      setModalFinancingMonthsManual(mesesManual || "", {
        dirty: false,
        force: true,
      });
      setManualMonthlyOverride(true);

      const nextModalFormData = {
        ...(formDataRef.current || formData),
        mensualidad_buscada: formatNumber(String(mensualidadManual || "")),
        inversion_inicial: String(engancheManual || ""),
        enganche: formatNumber(String(engancheManual || "")),
        engancheEditable: formatNumber(String(engancheManual || "")),
        plazo_meses: String(mesesManual || ""),
        meses_financiamiento: String(mesesManual || ""),
      };

      setFormData(nextModalFormData);
      formDataRef.current = nextModalFormData;
      lastSavedRef.current = null;
      autoGuardar(nextModalFormData);

      setSelectedMailData((prev) =>
        prev && String(prev.id || "") === String(ventaId || "")
          ? {
              ...prev,
              mensualidad_estimacion: mensualidadManual,
              meses_financiamiento: mesesManual,
              plazo_meses: String(mesesManual),
              enganche: engancheManual,
              engancheEditable: engancheManual,
              perdio_llaves: tasaManual,
              financiamiento_modal: 1,
            }
          : prev,
      );

      isEditingFinancingModalRef.current = false;
      isUserEditing.current = false;

      setTimeout(() => {
        isSavingFinancingModalRef.current = false;
      }, 1200);
    } catch (error) {
      isSavingFinancingModalRef.current = false;
      console.error("Error guardando datos financieros:", error);
    }
  };

  const updateFinancingMonths = async (months) => {
    try {
      const ventaActual = selectedMailDataRef.current || selectedMailData;
      const ventaId = String(
        ventaActual?.id ||
          formDataRef.current?.venta_id ||
          formData.venta_id ||
          "",
      );
      if (!ventaId) return;

      const requestData = {
        access_token: accessToken,
        venta_id: ventaId,
        meses_financiamiento:
          Number(String(months || "").replace(/\D/g, "")) || null,
      };

      markLocalFinancingPatch(ventaId, {
        meses_financiamiento: months,
        plazo_meses: String(months),
      });

      const data = await guardarFinanciamientoSnapshotBD(requestData);

      setFormData((prev) => {
        const nextFormData = {
          ...prev,
          plazo_meses: String(months),
          meses_financiamiento: String(months),
        };

        formDataRef.current = nextFormData;
        return nextFormData;
      });

      setSelectedMailData((prev) =>
        prev && String(prev.id || "") === String(ventaId || "")
          ? {
              ...prev,
              meses_financiamiento: months,
              plazo_meses: String(months),
            }
          : prev,
      );
    } catch (error) {
      console.error(error);
    }
  };

  const handleTasaChangeC = (e) => {
    // Modal manual: se conserva lo que escriba el usuario y se limpia al guardar.
    isEditingFinancingModalRef.current = true;
    isUserEditing.current = true;
    setManualMonthlyOverride(true);
    setModalTasaInput(e.target.value);
  };

  //todos los campos están llenos?
  const isFormValid =
    mensualidadC &&
    tasaC &&
    montoSeguro &&
    aseguradora &&
    (formData.pago_contado === "Si" || engancheC);

  useEffect(() => {
    if (selectedMailData) {
    }
  }, [selectedMailData?.condiciones_calle]);

  // Ref para controlar los últimos valores enviados
  const lastValuesRef = useRef({
    elite: null, // último valor enviado para Condiciones Calle
    platinum: null, // último valor enviado para Edad
  });

  // Función para actualizar campo específico según plan
  const actualizarCampoPlan = (planName, promocion, force = false) => {
    let campo = null;
    let nuevoValor = 0;

    if (promocion) {
      nuevoValor =
        promocion.descuento > 0
          ? promocion.descuento * 100
          : promocion.faltante;
    }

    const mapaCampos = {
      elite: { campo: "condiciones_calle", refKey: "elite" },
      platinum: { campo: "edad", refKey: "platinum" },
      gold: { campo: "mstar", refKey: "gold" },
      "plan cliente": { campo: "nexu", refKey: "cliente" },
    };

    const config = mapaCampos[planName.toLowerCase()];
    if (!config) return;
    campo = config.campo;

    if (!force && lastValuesRef.current[config.refKey] === nuevoValor) {
      return;
    }

    // Guardamos el nuevo valor en la referencia
    lastValuesRef.current[config.refKey] = nuevoValor;

    const requestData = {
      access_token: accessToken,
      venta_id: formData.venta_id,
      [campo]: nuevoValor,
    };

    fetch(apiUpdateEstadoUrl, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(requestData),
    })
      .then((res) => {
        if (!res.ok) throw new Error("Error en respuesta");
      })
      .catch((err) => {
        lastValuesRef.current[config.refKey] = null;
        console.error(`Error sincronizando ${campo}:`, err);
      });
  };

  const PROMO_THRESHOLD = 15000;
  const PROMO_DISCOUNT_RATE = 0.1;

  const getPrecioBasePromocion = (item = {}) => {
    const candidatos = [
      item.price_base,
      item.precio_base,
      item.base_price,
      item.price_original,
      item.precio_original,
      item.price_promo,
      item.price,
      item.precio,
    ];

    for (const value of candidatos) {
      const parsed = toNumber(value);
      if (parsed > 0) return parsed;
    }

    return 0;
  };

  const getTotalBasePromocion = (plan = {}) => {
    const totalDirecto = [
      plan.totalExtrasBase,
      plan.total_base,
      plan.totalBase,
      plan.totalPriceOriginal,
      plan.totalOriginalPrice,
      plan.total_original,
      plan.precio_original,
      plan.precioSinDescuento,
      plan.precio_sin_descuento,
      plan.totalPrice_base,
    ]
      .map(toNumber)
      .find((value) => value > 0);

    const totalAccesoriosBase = Array.isArray(plan?.accessories)
      ? plan.accessories.reduce(
          (sum, item) => sum + getPrecioBasePromocion(item),
          0,
        )
      : 0;

    return Math.max(totalDirecto || 0, totalAccesoriosBase);
  };

  const obtenerPromocion = (plan) => {
    const nombreNormalizado = plan?.title
      ?.toLowerCase()
      ?.trim()
      ?.normalize("NFD")
      .replace(/[̀-ͯ]/g, "");

    if (!Array.isArray(plan?.accessories) || nombreNormalizado === "gold") {
      return {
        mensaje: "Paquete precargado",
        descuento: 0,
        faltante: 0,
      };
    }

    const totalExtrasBase = getTotalBasePromocion(plan);
    const aplicaDescuento = totalExtrasBase >= PROMO_THRESHOLD;

    plan.accessories = plan.accessories.map((acc) => {
      const precioBase = getPrecioBasePromocion(acc);

      if (aplicaDescuento) {
        const precioConDesc = precioBase * (1 - PROMO_DISCOUNT_RATE);

        return {
          ...acc,
          price_base: precioBase,
          price_promo: precioConDesc,
          price: precioConDesc,
        };
      }

      return {
        ...acc,
        price_base: precioBase,
        price_promo: precioBase,
        price: precioBase,
      };
    });

    const totalPromo = plan.accessories.reduce(
      (acc, item) => acc + toNumber(item.price),
      0,
    );

    if (aplicaDescuento) {
      plan.totalPrice_promo = totalPromo;
      plan.totalPrice = totalPromo;
    } else {
      plan.totalPrice_promo = totalExtrasBase;
      plan.totalPrice = totalExtrasBase;
      plan.totalPrice_base = totalExtrasBase;
    }

    if (aplicaDescuento) {
      return {
        mensaje:
          "¡Felicidades! Tienes un 10% de descuento por compra mayor a $15,000 en accesorios y garantías",
        descuento: PROMO_DISCOUNT_RATE,
        faltante: 0,
        totalBase: totalExtrasBase,
      };
    }

    const faltante = Math.max(PROMO_THRESHOLD - totalExtrasBase, 0);

    if (totalExtrasBase > 0 && faltante > 0) {
      return {
        mensaje: `Te faltan $${Math.round(faltante).toLocaleString("es-MX")} para obtener 10% de descuento`,
        descuento: 0,
        faltante: -faltante,
        totalBase: totalExtrasBase,
      };
    }

    return {
      mensaje: "",
      descuento: 0,
      faltante: 0,
      totalBase: totalExtrasBase,
    };
  };

  const [registroCambiado, setRegistroCambiado] = useState(false);

  useEffect(() => {
    if (registroCambiado && selectedMailData) {
      const lastStep = parseInt(selectedMailData.preocupacion_robo);
      if (!isNaN(lastStep) && lastStep >= 1 && lastStep <= 7) {
        setStep(lastStep);
      } else {
        setStep(1);
      }

      //resetear despues del cambio
      setRegistroCambiado(false);
    }
  }, [registroCambiado, selectedMailData]);

  const handleStepChange = async (newStep) => {
    if (typeof newStep !== "number" || newStep < 1 || newStep > 7) return;

    if (newStep > 1 && !datosPersonalesConfirmados) {
      Swal.fire({
        icon: "warning",
        title: "Confirma los datos",
        text: "Para avanzar primero debes presionar el botón de confirmar datos.",
        confirmButtonText: "Aceptar",
        willOpen: () => {
          const container = document.querySelector(".swal2-container");
          if (container) container.style.zIndex = "1000000";
        },
      });
      return;
    }

    if (newStep > 2 && !isSaboneCompleto) {
      Swal.fire({
        icon: "warning",
        title: "Sabone incompleto",
        text: "Para avanzar debes responder todas las preguntas del Sabone.",
        confirmButtonText: "Aceptar",
        willOpen: () => {
          const container = document.querySelector(".swal2-container");
          if (container) container.style.zIndex = "1000000";
        },
      });
      return;
    }

    if (newStep > 3 && !isPruebaManejoCompleta) {
      Swal.fire({
        icon: "warning",
        title: "Prueba de manejo incompleta",
        text: "Espera la respuesta del cliente. Si aceptó, revisa que la encuesta esté cargada y adjunta el frente de la licencia.",
        confirmButtonText: "Aceptar",
        willOpen: () => {
          const container = document.querySelector(".swal2-container");
          if (container) container.style.zIndex = "1000000";
        },
      });
      return;
    }

    if (step === 3 && newStep > 3) {
      await savePruebaManejo(pruebaManejoData);
    }

    setStep(newStep);

    try {
      const requestData = {
        access_token: accessToken,
        venta_id: formData.venta_id,
        preocupacion_robo: newStep,
      };

      const response = await fetch(apiUpdateEstadoUrl, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(requestData),
      });

      if (!response.ok) {
        throw new Error("Error al actualizar el paso en el backend");
      }

      await response.json();
    } catch (error) {
      console.error(error);
    }
  };

  // ====== FORMA DE PAGO Y MESES (GLOBAL) ======
  const isCash = formData.pago_contado === "Si";

  const cashMonths = CASH_MONTHS_BASE;
  const creditMonths = getAllowedCreditMonths(condicionesFinanciamientoCredito);

  const monthsOptions = isCash ? cashMonths : creditMonths;

  // Opciones del modal de cotización: captura manual.
  // No se limitan por las reglas automáticas del plan para que el asesor pueda
  // guardar exactamente los meses que vienen del cotizador externo (NR, banco, etc.).
  const modalMonthsOptions = useMemo(() => {
    const baseOptions = isCash ? CASH_MONTHS_BASE : CREDIT_MONTHS_BASE;
    const selectedModalMonth = Number(
      String(getModalFinancingMonthsManualValue() || "").replace(/\D/g, ""),
    );

    return Array.from(
      new Set([
        ...baseOptions,
        ...(selectedModalMonth > 0 ? [selectedModalMonth] : []),
      ]),
    ).sort((a, b) => a - b);
  }, [isCash, modalFinancingMonths, getModalFinancingMonthsManualValue]);

  // Nota: usa UN SOLO state como fuente de verdad (financingMonths)
  const parseMonthsValue = (value) => {
    const parsed = Number(String(value ?? "").replace(/\D/g, ""));
    return Number.isFinite(parsed) && parsed > 0 ? parsed : 0;
  };

  const mesesBdActuales = getMesesFromVentaBD(selectedMailData);
  const currentSelectedVentaIdForMonths = String(selectedMailData?.id || "");
  const formVentaIdForMonths = String(
    formData?.venta_id || formDataRef.current?.venta_id || "",
  );
  const formMonthsBelongToSelectedVenta =
    !currentSelectedVentaIdForMonths ||
    !formVentaIdForMonths ||
    currentSelectedVentaIdForMonths === formVentaIdForMonths;
  const mesesFormActuales = formMonthsBelongToSelectedVenta
    ? parseMonthsValue(formData?.meses_financiamiento || formData?.plazo_meses)
    : 0;
  const mesesStateActuales = currentSelectedVentaIdForMonths
    ? 0
    : parseMonthsValue(financingMonths);
  const defaultAvailableMonth = monthsOptions.length
    ? Number(monthsOptions[monthsOptions.length - 1])
    : 0;

  const effectiveMonths = monthsOptions.includes(mesesBdActuales)
    ? mesesBdActuales
    : monthsOptions.includes(mesesFormActuales)
      ? mesesFormActuales
      : monthsOptions.includes(mesesStateActuales)
        ? mesesStateActuales
        : defaultAvailableMonth || monthsOptions[0];

  const modalFinancingMonthsSelectValue =
    getModalFinancingMonthsManualValue() || String(effectiveMonths || "");

  useEffect(() => {
    const ventaActual = selectedMailData || selectedMailDataRef.current || {};
    const ventaId = String(
      ventaActual?.id || formDataRef.current?.venta_id || "",
    );

    if (!ventaId || !defaultAvailableMonth) return;
    // No arrastramos isUserEditing de otra venta; sólo frenamos si realmente
    // hay un campo financiero activo o el modal de cotización abierto.
    if (activeFinancingEditRef.current) return;
    if (isCotizadorModalOpen()) return;

    const mesesDesdeBD = getMesesFromVentaBD(ventaActual);

    // Si la venta ya trae meses guardados en BD/entrevista, se respeta ese valor.
    if (mesesDesdeBD > 0) {
      return;
    }

    const signature = `${ventaId}|default|${defaultAvailableMonth}`;
    if (autoAppliedSingleMonthsRef.current === signature) return;
    autoAppliedSingleMonthsRef.current = signature;

    const nextFormData = {
      ...(formDataRef.current || {}),
      venta_id: ventaId,
      plazo_meses: String(defaultAvailableMonth),
      meses_financiamiento: String(defaultAvailableMonth),
    };

    const ventaConMeses = {
      ...(ventaActual || {}),
      plazo_meses: String(defaultAvailableMonth),
      meses_financiamiento: defaultAvailableMonth,
    };

    markLocalFinancingPatch(ventaId, {
      plazo_meses: String(defaultAvailableMonth),
      meses_financiamiento: defaultAvailableMonth,
    });

    selectedMailDataRef.current = ventaConMeses;
    setSelectedMailData((prev) =>
      prev && String(prev.id || "") === ventaId
        ? {
            ...prev,
            plazo_meses: String(defaultAvailableMonth),
            meses_financiamiento: defaultAvailableMonth,
          }
        : prev,
    );
    setMailData((prev) =>
      Array.isArray(prev)
        ? prev.map((item) =>
            String(item?.id || "") === ventaId
              ? {
                  ...item,
                  plazo_meses: String(defaultAvailableMonth),
                  meses_financiamiento: defaultAvailableMonth,
                }
              : item,
          )
        : prev,
    );

    setFinancingMonths(defaultAvailableMonth);
    setFormData(nextFormData);
    formDataRef.current = nextFormData;

    patchSelectedVentaInterviewLocal(ventaId, {
      entrevista: nextFormData,
    });
    queueAutoGuardarEntrevista(nextFormData, 250);

    guardarFinanciamientoSnapshotBD({
      venta_id: ventaId,
      plazo_meses: String(defaultAvailableMonth),
      meses_financiamiento: defaultAvailableMonth,
    }).catch((error) => {
      console.error("Error guardando meses por defecto:", error);
    });
  }, [
    selectedMailData?.id,
    defaultAvailableMonth,
    selectedMailData?.meses_financiamiento,
    selectedMailData?.plazo_meses,
    selectedMailData?.entrevista,
    getMesesFromVentaBD,
    markLocalFinancingPatch,
    patchSelectedVentaInterviewLocal,
    queueAutoGuardarEntrevista,
    isCotizadorModalOpen,
  ]);

  const selectedPlanForModal = useMemo(() => {
    if (selectedPlanForFinancing && !esPlanCliente(selectedPlanForFinancing)) {
      return selectedPlanForFinancing;
    }

    const selectedFromState = Array.isArray(plansState)
      ? plansState.find((plan) => plan?.isSelected && !esPlanCliente(plan))
      : null;

    return selectedFromState || selectedPlan || null;
  }, [selectedPlanForFinancing, plansState, selectedPlan]);
  const selectedPlanUi =
    selectedPlanForModal || selectedPlanForFinancing || selectedPlan || null;
  const selectedPlanUiLocked = Boolean(
    selectedPlanUi && esPlanNoEditable(selectedPlanUi),
  );

  const accessoryModalPlanIndexResolved = useMemo(() => {
    if (!Array.isArray(plansState)) return -1;

    const targetKey =
      accessoryModalPlanKey || accessoryModalPlanTargetRef.current?.key || "";
    const targetIndex =
      accessoryModalPlanIndex ??
      accessoryModalPlanTargetRef.current?.index ??
      null;

    if (targetKey) {
      const byKeyIndex = plansState.findIndex(
        (plan) => getPlanKey(plan) === targetKey,
      );

      if (byKeyIndex >= 0) {
        accessoryModalPlanTargetRef.current = {
          index: byKeyIndex,
          key: targetKey,
        };
        return byKeyIndex;
      }
    }

    const index = Number(targetIndex);

    if (
      Number.isInteger(index) &&
      index >= 0 &&
      index < plansState.length &&
      plansState[index]
    ) {
      accessoryModalPlanTargetRef.current = {
        index,
        key: getPlanKey(plansState[index]),
      };
      return index;
    }

    return -1;
  }, [plansState, accessoryModalPlanKey, accessoryModalPlanIndex, getPlanKey]);

  const accessoryModalPlan =
    accessoryModalPlanIndexResolved >= 0
      ? plansState[accessoryModalPlanIndexResolved]
      : accessoryModalPlanSnapshot;
  const accessoryModalPlanLocked = Boolean(
    accessoryModalPlan && esPlanNoEditable(accessoryModalPlan),
  );

  const precioPaqueteModalExacto =
    getPlanAccessoriesTotalExactForDisplay(selectedPlanForModal);
  const precioVehiculoModal = toNumber(
    precioVehiculo || selectedMailData?.precio_vehiculo || 0,
  );
  const precioTotalModalExacto = precioVehiculoModal + precioPaqueteModalExacto;

  // calcula total de accesorios/garantías de un plan
  const getAccTotalFromPlan = (plan) =>
    getPlanAccessoriesTotalForFinancing(plan);

  // calcula mensualidad “con adicionales” para un plan (MISMA lógica siempre)
  const getMonthlyWithAdicionales = (plan) => {
    const vehiclePrice = toNumber(selectedMailData?.precio_vehiculo);
    const accesoriosTotal = getAccTotalFromPlan(plan);
    const planTotal = Math.round(vehiclePrice + accesoriosTotal);

    // CONTADO => MSI 0% solo accesorios/garantías
    if (isCash) {
      return effectiveMonths
        ? Math.round(accesoriosTotal / effectiveMonths)
        : 0;
    }

    // CRÉDITO => PMT auto+adicionales - enganche actual.
    // Si el usuario cambió mensualidad, primero se recalcula el enganche;
    // después cualquier cambio de meses o accesorios debe recalcular la mensualidad
    // con ese enganche, no dejar pegada la mensualidad anterior.
    return calculateMonthlyPaymentBabilonia({
      total: planTotal,
      months: effectiveMonths,
      downPaymentAmount: getEngancheActual(planTotal),
      isCashMSI: false,
    });
  };

  const mensualConAdicionales = selectedPlanForFinancing
    ? getMonthlyWithAdicionales(selectedPlanForFinancing)
    : 0;

  const mensualidadPanelDerecho = isCash
    ? mensualConAdicionales
    : mensualConAdicionales || monthlyPayment || 0;

  useEffect(() => {
    const allowed = isCash ? cashMonths : creditMonths;
    const mesesDesdeBD = getMesesFromVentaBD(selectedMailData);
    const mesesDesdeForm = Number(
      String(
        formDataRef.current?.meses_financiamiento ||
          formDataRef.current?.plazo_meses ||
          "",
      ).replace(/\D/g, ""),
    );
    const mesesGuardados = mesesDesdeBD || mesesDesdeForm;

    // Si la venta trae meses en BD/entrevista, ese valor manda. No lo reemplazamos por 60.
    if (mesesGuardados > 0) {
      if (Number(financingMonths) !== mesesGuardados) {
        setFinancingMonths(mesesGuardados);
        setFormData((prev) => {
          const nextFormData = {
            ...prev,
            plazo_meses: String(mesesGuardados),
            meses_financiamiento: String(mesesGuardados),
          };

          formDataRef.current = nextFormData;
          return nextFormData;
        });
      }
      return;
    }

    // Si no hay meses guardados para una venta seleccionada, no imponemos 60
    // durante la restauración. Imponerlo aquí hacía que el select se mostrara en
    // 60 y luego se guardara en BD/entrevista antes de cargar el valor real.
    if (selectedMailData?.id) {
      return;
    }

    const desired = isCash
      ? cashMonths[cashMonths.length - 1] || 3
      : creditMonths[creditMonths.length - 1] || 12;

    const nextMonths = allowed.includes(Number(financingMonths))
      ? Number(financingMonths)
      : desired;

    if (nextMonths !== Number(financingMonths)) {
      setFinancingMonths(nextMonths);
      setFormData((prev) => {
        const nextFormData = {
          ...prev,
          plazo_meses: String(nextMonths),
          meses_financiamiento: String(nextMonths),
        };

        formDataRef.current = nextFormData;
        return nextFormData;
      });
    }

    // No enviamos nada a BD desde este efecto.
    // Los meses sólo se guardan cuando el usuario cambia el select o guarda el modal.
    // Esto evita que el valor default/local sobrescriba los meses reales al seleccionar una venta.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    isCash,
    condicionesFinanciamientoCredito.maxMonths,
    condicionesFinanciamientoCredito.minDownPaymentPercentage,
    selectedMailData?.id,
    selectedMailData?.meses_financiamiento,
    getMesesFromVentaBD,
  ]);

  const getAccTitle = (acc) =>
    typeof acc === "string" ? acc : (acc?.title ?? "");

  const hasAccessory = (plan, title) => {
    const t = norm(title);
    return (plan?.accessories ?? []).some((a) => norm(getAccTitle(a)) === t);
  };

  // ====== VENTAS ADICIONALES DE CONTADO ======
  // En el modal de adicionales de contado se descartan los accesorios/garantías
  // que ya vienen dentro del plan o paquete seleccionado, para evitar duplicarlos.
  const normalizeAdicionalTitle = (value = "") =>
    String(value || "")
      .toLowerCase()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .replace(/\s+/g, " ")
      .trim();

  const getAdicionalTitleVariants = (item) => {
    const rawTitle = getAccTitle(item);
    const baseTitle = rawTitle.split(" - ")[0];

    return [rawTitle, baseTitle].map(normalizeAdicionalTitle).filter(Boolean);
  };

  const selectedPlanAccessoryTitleSet = useMemo(() => {
    const set = new Set();

    (selectedPlan?.accessories || []).forEach((acc) => {
      getAdicionalTitleVariants(acc).forEach((title) => set.add(title));
    });

    return set;
  }, [selectedPlan]);

  const isAdicionalAlreadyInSelectedPlan = useCallback(
    (item) => {
      if (!selectedPlanAccessoryTitleSet.size) return false;

      return getAdicionalTitleVariants(item).some((title) =>
        selectedPlanAccessoryTitleSet.has(title),
      );
    },
    [selectedPlanAccessoryTitleSet],
  );

  const accesoriosContadoDisponibles = useMemo(() => {
    return (filteredAccessoriesAndWarranties || []).filter(
      (item) => !isAdicionalAlreadyInSelectedPlan(item),
    );
  }, [filteredAccessoriesAndWarranties, isAdicionalAlreadyInSelectedPlan]);

  useEffect(() => {
    // Si cambia el plan seleccionado, quitamos de contado cualquier accesorio
    // que ahora ya venga incluido en el paquete.
    setAdicionalesContado((prev) =>
      prev.filter((item) => !isAdicionalAlreadyInSelectedPlan(item)),
    );
  }, [isAdicionalAlreadyInSelectedPlan]);

  useEffect(() => {
    // Si cambia contado/crédito cerramos la edición inline, pero NO borramos
    // la mensualidad del modal. El modal representa una cotización NR manual
    // y debe conservar exactamente lo que el asesor capturó.
    setIsEditingMonthly(false);
    setMonthlyPaymentDraft("");
  }, [formData.pago_contado]);

  useEffect(() => {
    if (!selectedMailData?.versiones) return;

    try {
      const versionesParsed = JSON.parse(selectedMailData.versiones).size || [];

      if (!versionesParsed.length) return;

      const versionDeBaseDatos = String(
        selectedMailData.version_vehiculo || "",
      ).trim();

      if (!versionDeBaseDatos) {
        const primeraVersion = versionesParsed[0];
        const signature = `${selectedMailData?.id || ""}|default-version|${primeraVersion?.text || ""}|${primeraVersion?.price || ""}`;

        if (
          primeraVersion?.text &&
          autoSelectedSingleVersionRef.current !== signature
        ) {
          autoSelectedSingleVersionRef.current = signature;
          handleVersionSelect(primeraVersion);
          return;
        }
      }

      const versionEstadoEsValida = versionesParsed.some((v) =>
        coincideTextoPaquete(selectedVersion, v.text),
      );

      if (versionEstadoEsValida) return;
      const versionGuardada = versionesParsed.find((v) =>
        coincideTextoPaquete(versionDeBaseDatos, v.text),
      );
      const versionParaMostrar = versionGuardada || versionesParsed[0];

      if (!versionParaMostrar) return;

      // Si ya existe una versión guardada, sólo sincronizamos la UI.
      // Si no existe, arriba se selecciona y guarda la primera versión disponible.
      setSelectedVersion(versionParaMostrar.text || "");
      setPrecioVehiculo(
        Number(
          versionParaMostrar.price || selectedMailData.precio_vehiculo || 0,
        ),
      );
    } catch (error) {
      console.error("Error en sincronización de versiones:", error);
    }
  }, [
    selectedMailData?.id,
    selectedMailData?.versiones,
    selectedMailData?.version_vehiculo,
    selectedVersion,
    coincideTextoPaquete,
  ]);

  const CHASIS_IMG =
    "https://www.nissanframework.com/resourcefiles/g-vehicle-detail-versions-images/versiones-np300-chasis-tm-ac-nissan-np300-nissan-np300.jpg";

  const getVersionImage = (selectedVersion, selectedMailData) => {
    const text = (selectedVersion || "").toString().trim().toUpperCase();
    const isChasis = text.includes("CHASIS TM AC VDC '26");
    if (isChasis) return CHASIS_IMG;
    return selectedMailData?.url_img || "/assets/img/product/noimage.png";
  };

  useEffect(() => {
    //optimizacion de actualizacion
    plansState.forEach((plan) => {
      const promo = obtenerPromocion(plan, selectedVehicleName);

      if (
        ["elite", "platinum", "gold", "plan cliente"].includes(
          plan.title.toLowerCase(),
        )
      ) {
        actualizarCampoPlan(plan.title.toLowerCase(), promo, true);
      }
    });
  }, [selectedVehicleName]);

  //para modal
  const [tieneGarantiaExtendida, setTieneGarantiaExtendida] = useState(false);
  const [verAccesorios, setVerAccesorios] = useState(false);

  const limpiarEstadosCotizacionVenta = ({
    resetVentaSeleccionada = false,
    limpiarDraft = false,
    ventaIdDraft = "",
    nuevoVentaId = "",
    conservarMailData = true,
    conservarAgencias = true,
    conservarCardActiva = true,
  } = {}) => {
    const ventaIdActual =
      ventaIdDraft ||
      selectedMailDataRef.current?.id ||
      selectedMailData?.id ||
      formDataRef.current?.venta_id ||
      formData?.venta_id ||
      "";

    if (limpiarDraft && ventaIdActual) {
      clearAsesorDraft(ventaIdActual);
    }

    if (limpiarDraft) {
      forgetSelectedVenta();
    }

    ["cotizadorModal", "accessoryModal"].forEach((modalId) => {
      const modalElement = document.getElementById(modalId);

      if (!modalElement) return;

      try {
        const modalInstance =
          Modal.getInstance(modalElement) ||
          Modal.getOrCreateInstance(modalElement);

        modalInstance?.hide?.();
      } catch {
        modalElement.classList.remove("show");
        modalElement.style.display = "none";
        modalElement.setAttribute("aria-hidden", "true");
      }
    });

    document.querySelectorAll(".modal-backdrop").forEach((backdrop) => {
      backdrop.remove();
    });
    document.body.classList.remove("modal-open");
    document.body.style.removeProperty("padding-right");
    document.body.style.removeProperty("overflow");

    if (debounceTimer.current) {
      clearTimeout(debounceTimer.current);
      debounceTimer.current = null;
    }

    if (monthlyTimeoutRef.current) {
      clearTimeout(monthlyTimeoutRef.current);
      monthlyTimeoutRef.current = null;
    }

    if (engancheTimeoutRef.current) {
      clearTimeout(engancheTimeoutRef.current);
      engancheTimeoutRef.current = null;
    }

    if (autoGuardarTimeout.current) {
      clearTimeout(autoGuardarTimeout.current);
      autoGuardarTimeout.current = null;
    }

    if (cotizadorMensualidadTimerRef.current) {
      clearTimeout(cotizadorMensualidadTimerRef.current);
      cotizadorMensualidadTimerRef.current = null;
    }

    if (cotizadorEngancheTimerRef.current) {
      clearTimeout(cotizadorEngancheTimerRef.current);
      cotizadorEngancheTimerRef.current = null;
    }

    const emptyFormData = {
      ...buildEmptyFormData(),
      venta_id: nuevoVentaId || "",
    };

    setFormData(emptyFormData);
    formDataRef.current = emptyFormData;

    setPlans([]);
    setSelectedAgencia("");
    setGarantiaExtendida("");
    setContado("");
    setMostrarModalInfo(false);
    setPrecioVehiculo(0);
    setEliminatedAccessories([]);
    setSwapOptionsOpen({});
    setModalOpen(false);
    setAccessoryModalPlanIndex(null);
    setAccessoryModalPlanKey("");
    setSelectedPlanIndex(null);
    setManualMonthlyOverride(false);

    setMensualidadC("");
    setEngancheC("");
    setTasaC("");
    setAseguradora("");
    setMontoSeguro("");
    setMensualidadDisplay("");
    setEngancheDisplay("");
    setTasaDisplay("");
    setMontoSeguroDisplay("");

    setTipoCompraSeguro("");
    setTipoComision("");
    setIncluyePlacas("");
    setMontoComision("");
    setMontoComisionDisplay("");
    setMontoAdicionales("0");
    setMontoAdicionalesDisplay("");
    setMontoPlacas("");
    setShowModalAdicionales(false);
    setAdicionalesContado([]);
    setNrCatalogos({
      clasificaciones: [],
      estados: [],
      marcas: [],
      modelos: [],
      anios: [],
      versiones: [],
      estrategias: [],
      productos: [],
      productoFiltrado: [],
      planes: [],
      paquetes: [],
      plazos: [],
      subsidios: [],
      tiposSeguro: [],
      segurosVida: [],
      anzen: {},
    });
    setNrCotizacion(null);
    setNrAnzenCotizacion(null);
    setNrAnzenError(null);
    setNrAnzenLoading(false);
    setNrCotizacionGuardadaId("");
    setNrPdfBase64("");
    setShowNrPdfViewer(false);
    setNrLastError("");
    setNrLastCotizaRequest(null);
    setNrLastCotizaSignature("");
    setNrLastSavedSignature("");
    setNrHomologacion(null);
    setNrSelectedProduct(null);
    setNrProductCandidates([]);
    setShowNrProductModal(false);

    setIsEditingPrice(false);
    setTempPrice("");
    setOriginalPrice("");

    setSelectedPlanFinal(null);
    setSelectedPlan(null);
    setPrecioTotal(0);
    setSelectedVersion("");
    setMonthlyPaymentDraft("");
    setIsEditingMonthly(false);
    setMonthlyPayment(0);
    setDownPaymentPercentage(15);
    setFinancingMonths(60);
    setSelectedVehicleName("");
    setPlansLoaded(false);
    setPlansState(initialPlans);
    setBasePlansState(JSON.parse(JSON.stringify(initialPlans)));

    setValidationMessage("");
    setValidationMessageC("");
    setPdfAdjunto(null);
    setUserEditedEnganche(false);
    setEngancheDraft("");

    setPruebaManejoData({ ...pruebaManejoInicial });
    setLicenciaManejoFrente(null);

    setOpenFicha(false);
    setOpenGaleriaSeminuevo(false);
    setGaleriaSeminuevoImages([]);
    setGaleriaSeminuevoIndex(0);
    setFichaURL("");
    setShowFloatingActions(false);
    setRegistroCambiado(false);
    setTieneGarantiaExtendida(false);
    setVerAccesorios(false);
    setIsConfirming(false);
    setIsSubmitted(false);
    setIsSubmitting(false);
    setConfirmedVentas({});
    // No limpiamos tableData: se reutiliza para que el catálogo siga disponible al cambiar de venta.

    if (!conservarCardActiva) {
      setActiveCard(
        window.innerWidth <= 1024 ||
          (window.innerWidth > 1024 && window.innerWidth <= 1200)
          ? null
          : "cliente",
      );
    }

    if (!conservarMailData) {
      setMailData([]);
    }

    if (!conservarAgencias) {
      setAgencias([]);
    }

    if (resetVentaSeleccionada) {
      setSelectedMailData(null);
      selectedMailDataRef.current = null;
    }

    datosPersonalesYaCargados.current = false;
    isUserEditing.current = false;
    lastSavedRef.current = null;
    hasInitializedRef.current = false;
    selectedPlanVentaIdRef.current = "";
    selectedPlanKeyRef.current = "";
    engancheCVentaIdRef.current = "";
    manualEngancheVentaIdRef.current = "";
    manualEngancheValueRef.current = "";
    plansLoadedVentaIdRef.current = "";
  };

  const obtenerDatosCobertura = (tipo) => {
    const base = {
      // pFabrica: % que ocupa la de fábrica (verde)
      // pExtendida: % que se añade con el switch (amarillo)
      Motor: {
        pFabrica: 45,
        pExtendida: 40,
        texto: "3 AÑOS / 60,000 KM",
        extendido: "Hasta 3 AÑOS / 125,000 KM",
      },
      Transmisión: {
        pFabrica: 45,
        pExtendida: 40,
        texto: "3 AÑOS / 60,000 KM",
        extendido: "Hasta 3 AÑOS / 125,000 KM",
      },
      Dirección: {
        pFabrica: 45,
        pExtendida: 40,
        texto: "3 AÑOS / 60,000 KM",
        extendido: "Hasta 3 AÑOS / 125,000 KM",
      },
      Frenos: {
        pFabrica: 45,
        pExtendida: 40,
        texto: "3 AÑOS / 60,000 KM",
        extendido: "Hasta 3 AÑOS / 125,000 KM",
      },
      Suspensión: {
        pFabrica: 45,
        pExtendida: 40,
        texto: "3 AÑOS / 60,000 KM",
        extendido: "Hasta 3 AÑOS / 125,000 KM",
      },
      "Sistema Eléctrico": {
        pFabrica: 45,
        pExtendida: 40,
        texto: "3 AÑOS / 60,000 KM",
        extendido: "Hasta 3 AÑOS / 125,000 KM",
      },
      "Sistema de Enfriamiento": {
        pFabrica: 45,
        pExtendida: 40,
        texto: "3 AÑOS / 60,000 KM",
        extendido: "Hasta 3 AÑOS / 125,000 KM",
      },
      "Sistema de Combustible": {
        pFabrica: 45,
        pExtendida: 40,
        texto: "3 AÑOS / 60,000 KM",
        extendido: "Hasta 3 AÑOS / 125,000 KM",
      },
      "Aire Acondicionado": {
        pFabrica: 45,
        pExtendida: 30,
        texto: "3 AÑOS / 60,000 KM",
        extendido: "Según Plan",
      },
      "Sistema Multimedia": {
        pFabrica: 0,
        pExtendida: 80,
        texto: "No incluido",
        extendido: "¡Protegido!",
      },
      "Asistencia Vial": {
        pFabrica: 0,
        pExtendida: 100,
        texto: "No incluida",
        extendido: "24/7 Activado",
      },
    };
    return (
      base[tipo] || { pFabrica: 0, pExtendida: 0, texto: "", extendido: "" }
    );
  };

  const formatTitle = (title = "") => {
    const cleanTitle = title.split("-")[0].trim().toLowerCase();

    return cleanTitle.charAt(0).toUpperCase() + cleanTitle.slice(1);
  };

  const WarrantyItem = ({
    icon,
    titulo,
    descripcion,
    tieneGarantiaExtendida,
  }) => {
    const data = obtenerDatosCobertura(titulo);

    // Colores personalizados
    const verdeVivo = "#2ecc71"; // Un verde más vibrante
    const rojoSuave = "#e74c3c"; // Un rojo que indica "pendiente" o "riesgo"

    return (
      <div className="row align-items-center mb-4 gy-2">
        <div className="col-md-6 d-flex">
          <span
            className="warranty-icon me-3"
            style={{ fontSize: "1.4rem", color: "#fff" }}
          >
            <i className={icon}></i>
          </span>
          <div>
            <h5 className="fw-bold mb-0" style={{ fontSize: "1.05rem" }}>
              {titulo}
            </h5>
            <p className="mb-0 text-muted" style={{ fontSize: "0.85rem" }}>
              {descripcion}
            </p>
          </div>
        </div>

        <div className="col-md-6">
          <div
            className="progress"
            style={{
              height: "32px", // Barra más gruesa
              backgroundColor: "#f0f0f0",
              borderRadius: "8px", // Bordes un poco más redondeados para look moderno
              overflow: "hidden",
              boxShadow: "inset 0 1px 3px rgba(0,0,0,0.1)",
            }}
          >
            {/* SECCIÓN 1: FÁBRICA (Siempre verde vivo) */}
            {data.pFabrica > 0 && (
              <div
                className="progress-bar"
                style={{
                  color: "#FFF",
                  width: `${data.pFabrica}%`,
                  backgroundColor: verdeVivo,
                  borderRight: "2px solid rgba(255,255,255,0.3)",
                  transition: "0.5s ease",
                }}
              >
                <small className="fw-bold">Fábrica</small>
              </div>
            )}

            {/* SECCIÓN 2: EL RESTO (Cambia de Rojo a Verde según el switch) */}
            <div
              className="progress-bar"
              style={{
                // Calculamos el resto para que siempre llene la barra (100 - pFabrica)
                width: `${100 - data.pFabrica}%`,
                backgroundColor: tieneGarantiaExtendida ? verdeVivo : rojoSuave,
                color: "#fff",
                transition: "all 0.6s cubic-bezier(0.4, 0, 0.2, 1)", // Animación más fluida
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <small
                className="fw-bold text-uppercase"
                style={{ letterSpacing: "1px" }}
              >
                {tieneGarantiaExtendida ? "Protección Total" : "Sin Cobertura"}
              </small>
            </div>
          </div>

          {/* Texto informativo debajo de la barra */}
          <div
            className="d-flex justify-content-between mt-2"
            style={{ fontSize: "0.75rem" }}
          >
            <span className="fw-bold text-success">
              {data.pFabrica > 0 ? `INICIAL: ${data.texto}` : "SIN BASE"}
            </span>
            <span
              className={`fw-bold transition-all ${
                tieneGarantiaExtendida ? "text-success" : "text-danger"
              }`}
            >
              {tieneGarantiaExtendida
                ? `COMPLETA: ${data.extendido}`
                : "REQUIERE ACTIVACIÓN"}
            </span>
          </div>
        </div>
      </div>
    );
  };

  const tipoAutoParaModal = selectedMailData?.tipo_auto?.toLowerCase() || "";
  const esSeminuevoParaModal = tipoAutoParaModal.includes("seminuevo");

  const ventasSidebarData = useMemo(() => {
    const ventasConNombre = Array.isArray(mailData)
      ? mailData.filter(
          (registro) =>
            registro?.nombre &&
            String(registro.nombre || "").trim().length > 0,
        )
      : [];

    if (!ventasConNombre.length) return [];

    const usuarioActualId = String(
      userId || localStorage.getItem("userId") || "",
    ).trim();

    if (!usuarioActualId) return ventasConNombre;

    const ventasDelUsuario = ventasConNombre.filter(
      (registro) =>
        String(
          registro?.id_usuario ||
            registro?.user_id ||
            registro?.usuario_id ||
            "",
        ).trim() === usuarioActualId,
    );

    // Si la API ya regresó ventas pero el id del usuario local no coincide
    // con id_usuario, no dejamos el listado vacío; mostramos lo recibido.
    return ventasDelUsuario.length ? ventasDelUsuario : ventasConNombre;
  }, [mailData, userId]);

  return (
    <div className="create-venta-page">
      <style>{`
        .create-venta-page .nr-resultado-card {
          transition: box-shadow 0.15s ease-in-out;
        }

        .create-venta-page .nr-resultado-card:hover {
          box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.1) !important;
        }

        .create-venta-page .nr-resultado-card .card-footer {
          border-top: 1px solid rgba(0, 0, 0, 0.08);
        }

        .create-venta-page .nr-seguro-box {
          border-width: 1px;
        }

        /* El toolbar de Cotizar/Guardar/PDF y la calculadora de RFC usan
           botones "sm" normales de Bootstrap, pero en este proyecto hay
           reglas globales de .btn pensadas para tiles grandes en otras
           pantallas. Se blindan aquí para que se vean como botones
           compactos de verdad, sin importar el orden de carga del CSS. */
        .create-venta-page .nr-toolbar,
        .create-venta-page .nr-rfc-card {
          --nr-btn-min-width: auto;
        }

        .create-venta-page .nr-toolbar .btn,
        .create-venta-page .nr-rfc-card .btn {
          display: inline-flex !important;
          flex-direction: row !important;
          align-items: center !important;
          justify-content: center !important;
          width: auto !important;
          min-width: 0 !important;
          height: auto !important;
          min-height: 0 !important;
          padding: 0.35rem 0.75rem !important;
          font-size: 0.85rem !important;
          line-height: 1.2 !important;
          white-space: nowrap;
        }

        .create-venta-page .nr-toolbar .btn i,
        .create-venta-page .nr-rfc-card .btn i {
          font-size: 0.85rem !important;
          margin-bottom: 0 !important;
        }

        .create-venta-page .nr-toolbar {
          row-gap: 0.5rem;
        }

        .create-venta-page .nr-toolbar .nr-toolbar-btn.btn-primary {
          background-color: #0d6efd !important;
          border-color: #0d6efd !important;
          color: #ffffff !important;
          opacity: 1;
        }

        .create-venta-page .nr-toolbar .nr-toolbar-btn.btn-primary:hover:not(:disabled) {
          background-color: #0b5ed7 !important;
          border-color: #0a58ca !important;
          color: #ffffff !important;
        }

        .create-venta-page .nr-toolbar .nr-toolbar-btn:disabled {
          background-color: #6c757d !important;
          border-color: #6c757d !important;
          color: #ffffff !important;
          opacity: 0.72 !important;
          cursor: not-allowed;
        }

        .create-venta-page .nr-rfc-card .form-control {
          font-size: 0.9rem;
        }

        .create-venta-page .nr-resultado-card .card-body .border.rounded.bg-light {
          border-color: rgba(0, 0, 0, 0.08) !important;
          transition: background-color 0.15s ease-in-out;
        }

        .create-venta-page .nr-resultado-card .card-body .border.rounded.bg-light:hover {
          background-color: #eef3fb !important;
        }

        /* Íconos de los encabezados de las tarjetas NR: había reglas
           globales de otras pantallas que los inflaban a íconos enormes.
           Se fuerza aquí un tamaño de ícono normal, en línea con el texto. */
        .create-venta-page .nr-resultado-card .card-header i,
        .create-venta-page .nr-seguro-box i,
        .create-venta-page .nr-seguro-box h6 i,
        .create-venta-page .nr-rfc-card .card-header i {
          font-size: 1rem !important;
          width: auto !important;
          height: auto !important;
          line-height: inherit !important;
          display: inline !important;
          vertical-align: -1px;
        }

        .create-venta-page {
          padding-bottom: 74px;
        }

        .create-venta-page .mailbox-body,
        .create-venta-page .card-content,
        .create-venta-page .card-content .card-body {
          scroll-padding-bottom: 82px;
        }

        .create-venta-page .floating-action-spacer {
          height: 58px;
          flex: 0 0 58px;
        }

        .create-venta-page .fixed-buttons.floating-action-dock {
          position: fixed !important;
          top: auto !important;
          left: 50% !important;
          right: auto !important;
          bottom: calc(14px + env(safe-area-inset-bottom)) !important;
          transform: translateX(-50%) !important;
          width: min(1180px, calc(100vw - 32px)) !important;
          margin: 0 !important;
          padding: 10px 12px;
          border: 1px solid rgba(0, 0, 0, 0.08);
          border-radius: 18px;
          background: rgba(255, 255, 255, 0.96);
          box-shadow: 0 10px 28px rgba(0, 0, 0, 0.18);
          backdrop-filter: blur(10px);
          z-index: 1025;
        }

        .create-venta-page .floating-primary-actions {
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 10px;
          flex-wrap: wrap;
        }

        .create-venta-page .floating-nav-actions,
        .create-venta-page .floating-extra-toggle-wrap {
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 8px;
          flex-wrap: wrap;
        }

        .create-venta-page .floating-action-dock .btn {
          white-space: nowrap;
          border-radius: 10px;
        }

        .create-venta-page .floating-extra-panel {
          position: absolute;
          left: 50%;
          right: auto;
          bottom: calc(100% + 10px);
          transform: translateX(-50%);
          width: min(560px, calc(100vw - 42px));
          padding: 10px;
          border: 1px solid rgba(0, 0, 0, 0.1);
          border-radius: 16px;
          background: rgba(255, 255, 255, 0.98);
          box-shadow: 0 12px 30px rgba(0, 0, 0, 0.2);
          display: grid;
          grid-template-columns: repeat(2, minmax(0, 1fr));
          gap: 8px;
        }

        .create-venta-page .floating-extra-panel .btn {
          width: 100%;
          min-height: 40px;
          font-weight: 700;
        }

        @media (max-width: 1366px) {
          .create-venta-page {
            padding-bottom: 70px;
          }

          .create-venta-page .mailbox-body,
          .create-venta-page .card-content,
          .create-venta-page .card-content .card-body {
            scroll-padding-bottom: 78px;
          }

          .create-venta-page .floating-action-spacer {
            height: 56px;
            flex-basis: 56px;
          }

          .create-venta-page .fixed-buttons.floating-action-dock {
            width: min(760px, calc(100vw - 28px)) !important;
            padding: 8px 10px;
            border-radius: 16px;
          }

          .create-venta-page .floating-primary-actions {
            gap: 8px;
          }

          .create-venta-page .floating-action-dock .btn {
            min-height: 36px;
            padding: 0.45rem 0.8rem !important;
            font-size: 0.82rem;
          }

        }

        @media (max-width: 991.98px) {
          .create-venta-page .fixed-buttons.floating-action-dock {
            left: 12px !important;
            right: 12px !important;
            width: auto !important;
            transform: none !important;
          }

          .create-venta-page .floating-primary-actions {
            flex-direction: column;
            align-items: stretch;
          }

          .create-venta-page .floating-nav-actions,
          .create-venta-page .floating-extra-toggle-wrap {
            justify-content: center;
          }

          .create-venta-page .floating-extra-panel {
            right: 0;
            left: 0;
            width: auto;
            transform: none;
          }
        }

        @media (max-width: 575.98px) {
          .create-venta-page {
            padding-bottom: 125px;
          }

          .create-venta-page .floating-extra-panel {
            grid-template-columns: 1fr;
          }

          .create-venta-page .floating-action-spacer {
            height: 125px;
            flex-basis: 125px;
          }

          .create-venta-page .floating-nav-actions .btn,
          .create-venta-page .floating-extra-toggle-wrap .btn {
            flex: 1 1 auto;
          }
        }
        .create-venta-page .fixed-buttons.floating-action-dock {
  position: fixed !important;
  left: 50% !important;
  right: auto !important;
  bottom: 16px !important;
  transform: translateX(-50%) !important;

  width: fit-content !important;
  max-width: calc(100vw - 32px) !important;

  display: flex !important;
  flex-direction: column !important;
  align-items: center !important;
  justify-content: center !important;

  margin: 0 auto !important;
  z-index: 9999;
}

.create-venta-page .floating-action-dock .floating-main-actions,
.create-venta-page .floating-action-dock .floating-client-actions,
.create-venta-page .floating-action-dock .floating-extra-actions {
  width: 100% !important;
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
  flex-wrap: wrap !important;
  gap: 8px !important;
}

@media (max-width: 1366px) {
  .create-venta-page .fixed-buttons.floating-action-dock {
    left: 50% !important;
    right: auto !important;
    transform: translateX(-50%) !important;
    width: fit-content !important;
    max-width: calc(100vw - 24px) !important;
  }
}

.create-venta-page .plans-step-scroll-area {
  max-height: min(72vh, calc(100vh - 250px));
  overflow-y: auto;
  overflow-x: hidden;
  overscroll-behavior: contain;
  -webkit-overflow-scrolling: touch;
  touch-action: pan-y;
  padding-right: 8px;
  padding-bottom: 64px;
  scroll-padding-bottom: 72px;
}

.create-venta-page .plans-step-scroll-area > .row {
  margin-right: 0;
}

.create-venta-page .plans-step-scroll-area::-webkit-scrollbar {
  width: 8px;
}

.create-venta-page .plans-step-scroll-area::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.28);
  border-radius: 999px;
}

@media (max-width: 991.98px) {
  .create-venta-page .plans-step-scroll-area {
    max-height: calc(100vh - 230px);
    padding-bottom: 86px;
  }
}
      `}</style>
      {openFicha && (
        <VisorFichaTecnica
          url={fichaURL}
          onClose={() => setOpenFicha(false)}
          selectedMailData={selectedMailData}
          showFotosButton={Boolean(
            selectedMailData &&
            getTipoAutoFromVenta(selectedMailData).includes("seminuevo"),
          )}
          onOpenFotos={abrirGaleriaFotosSeminuevo}
          loadingFotos={loadingGaleriaSeminuevo}
        />
      )}
      {openGaleriaSeminuevo && (
        <GaleriaFotosSeminuevo
          images={galeriaSeminuevoImages}
          initialIndex={galeriaSeminuevoIndex}
          title={
            `Fotos ${selectedMailData?.marca_vehiculo || ""} ${
              selectedMailData?.modelo_vehiculo || ""
            }`.trim() || "Fotos del seminuevo"
          }
          onClose={() => setOpenGaleriaSeminuevo(false)}
        />
      )}
      {loading ? (
        <div className="loader-data">
          <Circles height="80" width="80" color="#4fa94d" />
        </div>
      ) : (
        <div>
          <div className="mailbox">
            <div className="mailbox-toolbar">
              {tabs.map((tab) =>
                modules.includes(tab.module) ? (
                  <div className="mailbox-toolbar-item" key={tab.name}>
                    <Link
                      to={tab.to}
                      className={`mailbox-toolbar-link ${
                        location.pathname === tab.to ? "active" : ""
                      }`}
                    >
                      {tab.name}
                    </Link>
                  </div>
                ) : null,
              )}
            </div>
            <div className="d-flex align-items-center mb-3 mt-3">
              <DateRangePicker
                startDate={filters.startDate}
                endDate={filters.endDate}
                onApply={handleDateApplyEvent}
              >
                <a
                  href="#/"
                  className="btn btn-secondary btn-sm d-inline-flex align-items-center"
                >
                  <span>
                    {filters.startDate && filters.endDate
                      ? `${filters.startDate} - ${filters.endDate}`
                      : "Selecciona un rango"}
                  </span>
                  <i className="fa fa-chevron-down ms-2 fs-8px"></i>
                </a>
              </DateRangePicker>
            </div>

            <div className="row">
              <div className="col-6 col-md-2 mb-3">
                <Select
                  options={[
                    { label: "Seleccionar estado", value: "" },
                    ...filterOptions.activo.map((activo) => ({
                      label: activo,
                      value: activo,
                    })),
                  ]}
                  value={
                    filters.activo
                      ? { label: filters.activo, value: filters.activo }
                      : { label: "Seleccionar estado", value: "" }
                  }
                  onChange={(selectedOption) =>
                    setFilters({
                      ...filters,
                      activo: selectedOption?.value || "",
                    })
                  }
                  styles={customStyles}
                  placeholder="Seleccionar estado"
                />
              </div>
            </div>

            <div className="mailbox-body" style={{ display: "block" }}>
              <div className="row">
                <div className="col-2">
                  <div
                    className="mailbox-sidebar"
                    style={{ height: "600px", maxWidth: "100%" }}
                  >
                    <PerfectScrollbar className="h-100">
                      <div className="mailbox-list">
                        {ventasSidebarData.length ? (
                          ventasSidebarData.map((registro, index) => {
                              const isVentaActiva =
                                String(selectedMailData?.id || "") ===
                                String(registro.id || "");

                              return (
                                <div
                                  key={registro.id || index}
                                  className={`mailbox-list-item venta-list-item ${
                                    isVentaActiva
                                      ? "venta-list-item-active active"
                                      : ""
                                  }`}
                                  onClick={() => {
                                    const ventaAnteriorId =
                                      selectedMailDataRef.current?.id ||
                                      selectedMailData?.id ||
                                      formDataRef.current?.venta_id ||
                                      formData?.venta_id ||
                                      "";

                                    if (
                                      String(ventaAnteriorId || "") !==
                                      String(registro.id || "")
                                    ) {
                                      limpiarEstadosCotizacionVenta({
                                        nuevoVentaId: registro.id || "",
                                        conservarMailData: true,
                                        conservarAgencias: true,
                                        conservarCardActiva: true,
                                      });
                                    }

                                    rememberSelectedVenta(registro.id);

                                    const respuestaSeleccionada =
                                      normalizeRespuestaPruebaManejo(
                                        registro?.respuesta_prueba_manejo_cliente ||
                                          "",
                                      );

                                    if (respuestaSeleccionada) {
                                      const notificationKeySeleccion = [
                                        registro?.id || "",
                                        respuestaSeleccionada,
                                        registro?.respuesta_prueba_manejo_fecha ||
                                          registro?.solicitar_prueba_manejo_fecha ||
                                          "sin-fecha",
                                      ].join("|");

                                      notifiedClientPruebaResponsesRef.current[
                                        notificationKeySeleccion
                                      ] = true;
                                    }

                                    datosPersonalesYaCargados.current = false;
                                    hasInitializedRef.current = false;
                                    lastSavedRef.current = null;

                                    setSelectedMailData(registro);
                                    selectedMailDataRef.current = registro;
                                    setRegistroCambiado(true);

                                    const planesRegistro =
                                      preparePlansState(registro);
                                    const selectedPlanRegistroIndex =
                                      planesRegistro.findIndex(
                                        (plan) =>
                                          plan?.isSelected &&
                                          !esPlanCliente(plan),
                                      );

                                    setPlansState(planesRegistro);
                                    setBasePlansState(
                                      JSON.parse(
                                        JSON.stringify(planesRegistro),
                                      ),
                                    );
                                    plansLoadedVentaIdRef.current = String(
                                      registro.id || "",
                                    );
                                    setPlansLoaded(true);

                                    if (selectedPlanRegistroIndex >= 0) {
                                      const selectedPlanRegistro =
                                        planesRegistro[
                                          selectedPlanRegistroIndex
                                        ];
                                      selectedPlanVentaIdRef.current = String(
                                        registro.id || "",
                                      );
                                      setSelectedPlan(selectedPlanRegistro);
                                      setSelectedPlanFinal(
                                        selectedPlanRegistroIndex,
                                      );
                                      setSelectedPlanIndex(
                                        selectedPlanRegistroIndex,
                                      );
                                      setPrecioTotal(
                                        getPlanTotalPriceForFinancing(
                                          selectedPlanRegistro,
                                          registro?.precio_vehiculo,
                                        ),
                                      );
                                    } else {
                                      setSelectedPlan(null);
                                      setSelectedPlanFinal(null);
                                      setSelectedPlanIndex(null);
                                      setPrecioTotal(
                                        toNumber(
                                          registro?.precio_vehiculo || 0,
                                        ),
                                      );
                                    }

                                    setSelectedVersion(
                                      registro?.version_vehiculo || "",
                                    );
                                    setPrecioVehiculo(
                                      toNumber(registro?.precio_vehiculo || 0),
                                    );

                                    const mesesRegistroSeleccionado =
                                      getMesesFromVentaBD(registro);
                                    const emptyForSelectedVenta = {
                                      ...buildEmptyFormData(),
                                      venta_id: registro.id || "",
                                      ...(mesesRegistroSeleccionado > 0
                                        ? {
                                            plazo_meses: String(
                                              mesesRegistroSeleccionado,
                                            ),
                                            meses_financiamiento: String(
                                              mesesRegistroSeleccionado,
                                            ),
                                          }
                                        : {}),
                                    };

                                    if (mesesRegistroSeleccionado > 0) {
                                      setFinancingMonths(
                                        mesesRegistroSeleccionado,
                                      );
                                      setModalFinancingMonthsManual(
                                        mesesRegistroSeleccionado,
                                        { dirty: false },
                                      );
                                    }

                                    setFormData(emptyForSelectedVenta);
                                    formDataRef.current = emptyForSelectedVenta;

                                    const isTouchDevice =
                                      "ontouchstart" in window ||
                                      navigator.maxTouchPoints > 0;

                                    if (
                                      isTouchDevice &&
                                      window.innerWidth <= 1366
                                    ) {
                                      setActiveCard(null);
                                      setTimeout(
                                        () => setActiveCard("asesor"),
                                        10,
                                      );
                                    }
                                  }}
                                  style={{ cursor: "pointer" }}
                                >
                                  {isVentaActiva ? (
                                    <span className="venta-list-active-badge">
                                      Seleccionada
                                    </span>
                                  ) : null}

                                  <div className="mailbox-message">
                                    <div className="mailbox-sender">
                                      <span className="mailbox-sender-name">
                                        {[
                                          registro.nombre,
                                          registro.apellido_paterno,
                                        ]
                                          .filter(Boolean)
                                          .join(" ")}
                                      </span>
                                    </div>

                                    <div className="mailbox-sender">
                                      <span className="mailbox-sender-name">
                                        {registro.folio_venta}
                                      </span>
                                    </div>

                                    <span className="mailbox-time">
                                      {registro.fecha_creacion}
                                    </span>

                                    <div className="mailbox-title">
                                      {registro.activo}
                                    </div>
                                  </div>
                                </div>
                              );
                            })
                        ) : (
                          <div
                            className="mailbox-list-item"
                            style={{ minWidth: "360px" }}
                          >
                            No hay ventas
                          </div>
                        )}
                      </div>
                    </PerfectScrollbar>
                  </div>
                </div>

                <div className="col-10">
                  <div className="mailbox-content" style={{ height: "600px" }}>
                    <PerfectScrollbar className="h-100">
                      {selectedMailData ? (
                        <div className="mailbox-detail">
                          <div className="container">
                            <div className="row justify-content-center">
                              <div className="col-xl-8">
                                <div className="row">
                                  <div className="col-xl-12">
                                    <div id="wizardLayout1" className="mb-5">
                                      <Card
                                        className={`card-initial card-content ${
                                          isMobile || isTablet
                                            ? activeCard === "asesor"
                                              ? "card-expand"
                                              : "d-none"
                                            : "card-desktop" // siempre se muestra en desktop
                                        }`}
                                      >
                                        <CardHeader className="with-btn new-font">
                                          Asesor
                                          <CardHeaderBtn
                                            activeCard={activeCard}
                                            onLeftClick={() =>
                                              setActiveCard("asesor")
                                            }
                                            onRightClick={() =>
                                              setActiveCard("cliente")
                                            }
                                          />
                                        </CardHeader>
                                        {canDeleteLead && selectedMailData && (
                                          <div className="mb-3 d-flex justify-content-end">
                                            <button
                                              type="button"
                                              className="btn btn-danger new-font"
                                              onClick={
                                                handleMarkLeadAsIncomplete
                                              }
                                              disabled={
                                                isDeletingLead ||
                                                selectedMailData?.activo ===
                                                  "Incompleto"
                                              }
                                            >
                                              {isDeletingLead
                                                ? "Actualizando..."
                                                : selectedMailData?.activo ===
                                                    "Incompleto"
                                                  ? "Lead incompleto"
                                                  : "Eliminar lead"}
                                            </button>
                                          </div>
                                        )}
                                        <CardBody>
                                          <style>{`
  .venta-process-owner-row {
    display: grid;
    grid-template-columns: 1fr 1.4fr 2fr;
    gap: 10px;
  }

  .process-owner-card {
    border-radius: 12px;
    padding: 10px 12px;
    color: #fff;
    min-height: 58px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.12);
  }

  .process-owner-card span {
    font-weight: 700;
    font-size: 12px;
    letter-spacing: 0.5px;
  }

  .process-owner-card small {
    font-size: 11px;
    opacity: 0.95;
    margin-top: 3px;
  }

  .process-hostess {
    background: #7b61ff !important;
  }

  .process-asesor {
    background: #0d6efd !important;
  }

  .process-business {
    background: #198754 !important;
  }

  .venta-process-wizard {
    position: relative;
  }

  .venta-process-wizard .nav-item {
    position: relative;
  }

  .venta-process-wizard .nav-link {
    position: relative;
    background: transparent !important;
    color: inherit !important;
    border-radius: 12px;
    text-align: center;
    overflow: visible !important;
  }

  .venta-process-wizard .nav-link.active,
  .venta-process-wizard .nav-link.completed {
    background: transparent !important;
    color: inherit !important;
  }

  .nav.nav-wizards-3.venta-process-wizard .nav-item .nav-link:before,
  .nav.nav-wizards-3.venta-process-wizard .nav-item .nav-link:after {
    z-index: 1 !important;
  }

  .nav.nav-wizards-3.venta-process-wizard .nav-item .nav-link .nav-dot {
    position: relative !important;
    z-index: 50 !important;
    background-color: #ffffff !important;
    border: 2px solid #3a75b0 !important;
    box-shadow: 0 0 0 3px #ffffff !important;
  }

  .nav.nav-wizards-3.venta-process-wizard .nav-item .nav-link.active .nav-dot,
  .nav.nav-wizards-3.venta-process-wizard .nav-item .nav-link.completed .nav-dot {
    background-color: #ffffff !important;
    border-color: #3a75b0 !important;
  }

  .venta-process-wizard .nav-link .nav-title {
    width: 34px;
    height: 34px;
    min-width: 34px;
    border-radius: 50%;
    color: #fff !important;
    font-weight: 700;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto 6px auto;
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.22);
    position: relative !important;
    z-index: 20 !important;
  }

  .venta-process-wizard .process-step-hostess .nav-title {
    background: #7b61ff !important;
  }

  .venta-process-wizard .process-step-asesor .nav-title {
    background: #0d6efd !important;
  }

  .venta-process-wizard .process-step-business .nav-title {
    background: #198754 !important;
  }

  .venta-process-wizard .nav-link.active .nav-title {
    transform: scale(1.08);
    outline: 3px solid rgba(255, 255, 255, 0.35);
  }

  .venta-process-wizard .nav-link.completed .nav-title {
    opacity: 1;
  }

  .venta-process-wizard .nav-text {
    color: var(--bs-body-color);
    font-size: 12px;
    font-weight: 600;
  }

  @media (max-width: 768px) {
    .venta-process-owner-row {
      grid-template-columns: 1fr;
    }

    .venta-process-wizard .nav-link .nav-title {
      width: 32px;
      height: 32px;
      min-width: 32px;
      font-size: 13px;
    }

    .venta-process-wizard .nav-text {
      font-size: 11px;
    }
  }
  .nav.nav-wizards-3.venta-process-wizard .nav-item .nav-link.completed.process-step-hostess .nav-dot,
.nav.nav-wizards-3.venta-process-wizard .nav-item .nav-link.active.process-step-hostess .nav-dot {
  background-color: #7b61ff !important;
  border-color: #7b61ff !important;
  box-shadow: 0 0 0 3px #ffffff !important;
}

.nav.nav-wizards-3.venta-process-wizard .nav-item .nav-link.completed.process-step-asesor .nav-dot,
.nav.nav-wizards-3.venta-process-wizard .nav-item .nav-link.active.process-step-asesor .nav-dot {
  background-color: #0d6efd !important;
  border-color: #0d6efd !important;
  box-shadow: 0 0 0 3px #ffffff !important;
}

.nav.nav-wizards-3.venta-process-wizard .nav-item .nav-link.completed.process-step-business .nav-dot,
.nav.nav-wizards-3.venta-process-wizard .nav-item .nav-link.active.process-step-business .nav-dot {
  background-color: #198754 !important;
  border-color: #198754 !important;
  box-shadow: 0 0 0 3px #ffffff !important;
}
`}</style>

                                          <div className="nav-wizards-container">
                                            <div className="venta-process-owner-row mb-2">
                                              <div className="process-owner-card process-hostess">
                                                <span>HOSTESS</span>
                                                <small>
                                                  1. Información personal
                                                </small>
                                              </div>

                                              <div className="process-owner-card process-asesor">
                                                <span>ASESOR</span>
                                                <small>
                                                  2. Sabone · 3. Prueba Manejo
                                                </small>
                                              </div>

                                              <div className="process-owner-card process-business">
                                                <span>BUSINESS MANAGER</span>
                                                <small>
                                                  4. Consulta · 5. Accesorios ·
                                                  6. Planes · 7. Financiamiento
                                                </small>
                                              </div>
                                            </div>

                                            <nav className="nav nav-wizards-3 mb-2 venta-process-wizard">
                                              {[
                                                {
                                                  number: 1,
                                                  label: "Información personal",
                                                  owner: "hostess",
                                                },
                                                {
                                                  number: 2,
                                                  label: "Sabone",
                                                  owner: "asesor",
                                                },
                                                {
                                                  number: 3,
                                                  label: "Prueba Manejo",
                                                  owner: "asesor",
                                                },
                                                {
                                                  number: 4,
                                                  label: "Consulta",
                                                  owner: "business",
                                                },
                                                {
                                                  number: 5,
                                                  label: "Accesorios",
                                                  owner: "business",
                                                },
                                                {
                                                  number: 6,
                                                  label: "Planes",
                                                  owner: "business",
                                                },
                                                {
                                                  number: 7,
                                                  label: "Financiamiento",
                                                  owner: "business",
                                                },
                                              ].map((item) => (
                                                <div
                                                  className="nav-item col"
                                                  key={item.number}
                                                >
                                                  <a
                                                    className={`nav-link process-step-${item.owner} ${
                                                      step > item.number
                                                        ? "completed"
                                                        : ""
                                                    } ${step === item.number ? "active" : ""}`}
                                                    href="#/"
                                                    onClick={(e) => {
                                                      e.preventDefault();
                                                      handleStepChange(
                                                        item.number,
                                                      );
                                                    }}
                                                  >
                                                    <div className="nav-dot"></div>
                                                    <div className="nav-title">
                                                      {item.number}
                                                    </div>
                                                    <div className="nav-text">
                                                      {item.label}
                                                    </div>
                                                  </a>
                                                </div>
                                              ))}
                                            </nav>
                                          </div>
                                          <Card>
                                            <CardBody>
                                              {step === 1 && (
                                                <div>
                                                  <h5 className="black-text new-font">
                                                    Información personal
                                                  </h5>
                                                  {isConfirmed && (
                                                    <small className="text-muted d-block mb-2">
                                                      <i className="fas fa-lock me-1"></i>
                                                      Datos confirmados. Si
                                                      necesitas corregir algo,
                                                      contacta a soporte.
                                                    </small>
                                                  )}
                                                  {/* Primera fila: Nombre */}
                                                  <div className="row mb-3">
                                                    <div className="col-lg-12">
                                                      <label className="black-text new-font">
                                                        Nombre
                                                      </label>
                                                      <input
                                                        type="text"
                                                        className="form-control new-font"
                                                        placeholder="Nombre"
                                                        name="nombre"
                                                        value={formData.nombre}
                                                        onChange={
                                                          handleInputChange
                                                        }
                                                        disabled={isConfirmed}
                                                      />
                                                    </div>
                                                  </div>

                                                  <div className="row mb-3">
                                                    <div className="col-lg-6">
                                                      <label className="black-text new-font">
                                                        Apellido paterno
                                                      </label>
                                                      <input
                                                        type="text"
                                                        className="form-control new-font"
                                                        placeholder="Apellido paterno"
                                                        name="apellido_paterno"
                                                        value={
                                                          formData.apellido_paterno ||
                                                          ""
                                                        }
                                                        onChange={
                                                          handleInputChange
                                                        }
                                                        disabled={isConfirmed}
                                                      />
                                                    </div>
                                                    <div className="col-lg-6">
                                                      <label className="black-text new-font">
                                                        Apellido materno
                                                      </label>
                                                      <input
                                                        type="text"
                                                        className="form-control new-font"
                                                        placeholder="Apellido materno"
                                                        name="apellido_materno"
                                                        value={
                                                          formData.apellido_materno ||
                                                          ""
                                                        }
                                                        onChange={
                                                          handleInputChange
                                                        }
                                                        disabled={isConfirmed}
                                                      />
                                                    </div>
                                                  </div>

                                                  {/* Segunda fila: Número de Teléfono y Correo Electrónico */}
                                                  <div className="row mb-3">
                                                    <div className="col-lg-6">
                                                      <label className="black-text new-font">
                                                        Número de teléfono
                                                      </label>
                                                      <input
                                                        type="number"
                                                        className="form-control new-font"
                                                        placeholder="Teléfono"
                                                        name="telefono"
                                                        value={
                                                          formData.telefono
                                                        }
                                                        onChange={
                                                          handleInputChange
                                                        }
                                                        disabled={isConfirmed}
                                                      />
                                                    </div>
                                                    <div className="col-lg-6">
                                                      <label className="black-text new-font">
                                                        Correo electrónico
                                                      </label>
                                                      <input
                                                        type="email"
                                                        className="form-control new-font"
                                                        placeholder="Correo"
                                                        name="correo_electronico"
                                                        value={
                                                          formData.correo_electronico
                                                        }
                                                        onChange={
                                                          handleInputChange
                                                        }
                                                        disabled={isConfirmed}
                                                      />
                                                    </div>
                                                    <input
                                                      id="asesor"
                                                      type="hidden"
                                                      className="form-control"
                                                      placeholder="Asesor"
                                                      value={formData.asesor}
                                                      onChange={
                                                        handleInputChange
                                                      }
                                                      name="asesor"
                                                      readOnly
                                                    />
                                                    <input
                                                      id="user_id"
                                                      type="hidden"
                                                      className="form-control"
                                                      placeholder="User ID"
                                                      value={formData.user_id}
                                                      onChange={
                                                        handleInputChange
                                                      }
                                                      name="user_id"
                                                      readOnly
                                                    />
                                                    <input
                                                      id="venta_id"
                                                      type="hidden"
                                                      className="form-control"
                                                      placeholder="Venta ID"
                                                      value={
                                                        formData.venta_id || ""
                                                      }
                                                      name="venta_id"
                                                      readOnly
                                                    />
                                                  </div>

                                                  {/* Fila para el checkbox */}
                                                  {/* <div className="form-check mb-3">
                                                    <input
                                                      type="checkbox"
                                                      className="form-check-input"
                                                      id="privacyCheck"
                                                      name="acepta_aviso_privacidad"
                                                      checked={
                                                        formData.acepta_aviso_privacidad
                                                      }
                                                      onChange={
                                                        handleCheckboxChange
                                                      }
                                                    />
                                                    <label
                                                      className="form-check-label"
                                                      htmlFor="privacyCheck"
                                                    >
                                                      Acepto el aviso de
                                                      privacidad
                                                    </label>
                                                  </div> */}
                                                </div>
                                              )}
                                              {step === 2 && (
                                                <div>
                                                  <h5 className="black-text new-font">
                                                    Sabone
                                                  </h5>

                                                  {/* Pregunta 1 */}
                                                  <div className="row mb-3">
                                                    <div className="col-md-6">
                                                      <label className="black-text new-font">
                                                        ¿Tiene vehículo
                                                        actualmente?
                                                      </label>
                                                      <select
                                                        className="form-control new-font"
                                                        value={
                                                          formData
                                                            .entrevista_nissan
                                                            ?.tiene_vehiculo_actual ||
                                                          ""
                                                        }
                                                        onChange={(e) =>
                                                          updateNissanEntrevistaField(
                                                            "tiene_vehiculo_actual",
                                                            e.target.value,
                                                          )
                                                        }
                                                      >
                                                        <option value="">
                                                          Seleccione
                                                        </option>
                                                        <option value="Si">
                                                          Sí
                                                        </option>
                                                        <option value="No">
                                                          No
                                                        </option>
                                                      </select>
                                                    </div>

                                                    {formData.entrevista_nissan
                                                      ?.tiene_vehiculo_actual ===
                                                      "Si" && (
                                                      <div className="col-md-6">
                                                        <label className="black-text new-font">
                                                          ¿Lo dejaría a cuenta?
                                                        </label>
                                                        <select
                                                          className="form-control new-font"
                                                          value={
                                                            formData
                                                              .entrevista_nissan
                                                              ?.deja_a_cuenta ||
                                                            ""
                                                          }
                                                          onChange={(e) =>
                                                            updateNissanEntrevistaField(
                                                              "deja_a_cuenta",
                                                              e.target.value,
                                                            )
                                                          }
                                                        >
                                                          <option value="">
                                                            Seleccione
                                                          </option>
                                                          <option value="Si">
                                                            Sí
                                                          </option>
                                                          <option value="No">
                                                            No
                                                          </option>
                                                        </select>
                                                      </div>
                                                    )}
                                                  </div>

                                                  {/* Pregunta 2 y 3 */}
                                                  <div className="row mb-3">
                                                    <div className="col-md-6">
                                                      <label className="black-text new-font">
                                                        ¿Qué busca en su
                                                        vehículo?
                                                      </label>
                                                      <select
                                                        className="form-control new-font"
                                                        value={
                                                          formData
                                                            .entrevista_nissan
                                                            ?.busca_en_vehiculo ||
                                                          ""
                                                        }
                                                        onChange={(e) =>
                                                          updateNissanEntrevistaField(
                                                            "busca_en_vehiculo",
                                                            e.target.value,
                                                          )
                                                        }
                                                      >
                                                        <option value="">
                                                          Seleccione
                                                        </option>
                                                        <option value="Seguridad">
                                                          Seguridad
                                                        </option>
                                                        <option value="Ahorro">
                                                          Ahorro
                                                        </option>
                                                        <option value="Espacio">
                                                          Espacio
                                                        </option>
                                                        <option value="Comodidad">
                                                          Comodidad
                                                        </option>
                                                        <option value="Imagen">
                                                          Imagen
                                                        </option>
                                                        <option value="Tecnología">
                                                          Tecnología
                                                        </option>
                                                        <option value="Rendimiento">
                                                          Rendimiento
                                                        </option>
                                                      </select>
                                                    </div>

                                                    <div className="col-md-6">
                                                      <label className="black-text new-font">
                                                        ¿Quién manejaría el
                                                        vehículo?
                                                      </label>
                                                      <select
                                                        className="form-control new-font"
                                                        value={
                                                          formData
                                                            .entrevista_nissan
                                                            ?.quien_manejara ||
                                                          ""
                                                        }
                                                        onChange={(e) =>
                                                          updateNissanEntrevistaField(
                                                            "quien_manejara",
                                                            e.target.value,
                                                          )
                                                        }
                                                      >
                                                        <option value="">
                                                          Seleccione
                                                        </option>
                                                        <option value="Yo">
                                                          Yo
                                                        </option>
                                                        <option value="Mi pareja">
                                                          Mi pareja
                                                        </option>
                                                        <option value="Familiar">
                                                          Familiar
                                                        </option>
                                                        <option value="Compartido">
                                                          Compartido
                                                        </option>
                                                        <option value="Empresa">
                                                          Empresa
                                                        </option>
                                                      </select>
                                                    </div>
                                                  </div>

                                                  {/* Pregunta 4 y 5 */}
                                                  <div className="row mb-3">
                                                    <div className="col-md-6">
                                                      <label className="black-text new-font">
                                                        ¿Qué uso le dará a su
                                                        vehículo?
                                                      </label>
                                                      <select
                                                        className="form-control new-font"
                                                        value={
                                                          formData
                                                            .entrevista_nissan
                                                            ?.uso_vehiculo || ""
                                                        }
                                                        onChange={(e) =>
                                                          updateNissanEntrevistaField(
                                                            "uso_vehiculo",
                                                            e.target.value,
                                                          )
                                                        }
                                                      >
                                                        <option value="">
                                                          Seleccione
                                                        </option>
                                                        <option value="Personal">
                                                          Personal
                                                        </option>
                                                        <option value="Familiar">
                                                          Familiar
                                                        </option>
                                                        <option value="Trabajo">
                                                          Trabajo
                                                        </option>
                                                        <option value="Mixto">
                                                          Mixto
                                                        </option>
                                                        <option value="Viajes">
                                                          Viajes
                                                        </option>
                                                      </select>
                                                    </div>

                                                    <div className="col-md-6">
                                                      <label className="black-text new-font">
                                                        ¿Qué factor considera
                                                        importante para la
                                                        compra del vehículo?
                                                      </label>
                                                      <select
                                                        className="form-control new-font"
                                                        value={
                                                          formData
                                                            .entrevista_nissan
                                                            ?.factor_importante_compra ||
                                                          ""
                                                        }
                                                        onChange={(e) =>
                                                          updateNissanEntrevistaField(
                                                            "factor_importante_compra",
                                                            e.target.value,
                                                          )
                                                        }
                                                      >
                                                        <option value="">
                                                          Seleccione
                                                        </option>
                                                        <option value="Precio">
                                                          Precio
                                                        </option>
                                                        <option value="Seguridad">
                                                          Seguridad
                                                        </option>
                                                        <option value="Rendimiento">
                                                          Rendimiento
                                                        </option>
                                                        <option value="Espacio">
                                                          Espacio
                                                        </option>
                                                        <option value="Consumo">
                                                          Consumo
                                                        </option>
                                                        <option value="Marca">
                                                          Marca
                                                        </option>
                                                        <option value="Tecnología">
                                                          Tecnología
                                                        </option>
                                                      </select>
                                                    </div>
                                                  </div>

                                                  {/* Pregunta 6 y 7 */}
                                                  <div className="row mb-3">
                                                    <div className="col-md-6">
                                                      <label className="black-text new-font">
                                                        ¿Viaja en carretera
                                                        regularmente?
                                                      </label>
                                                      <select
                                                        className="form-control new-font"
                                                        value={
                                                          formData
                                                            .entrevista_nissan
                                                            ?.viaja_carretera ||
                                                          ""
                                                        }
                                                        onChange={(e) =>
                                                          updateNissanEntrevistaField(
                                                            "viaja_carretera",
                                                            e.target.value,
                                                          )
                                                        }
                                                      >
                                                        <option value="">
                                                          Seleccione
                                                        </option>
                                                        <option value="Si">
                                                          Sí
                                                        </option>
                                                        <option value="No">
                                                          No
                                                        </option>
                                                        <option value="Ocasionalmente">
                                                          Ocasionalmente
                                                        </option>
                                                      </select>
                                                    </div>

                                                    <div className="col-md-6">
                                                      <label className="black-text new-font">
                                                        ¿Para cuándo quiere
                                                        realizar la compra del
                                                        vehículo?
                                                      </label>
                                                      <select
                                                        className="form-control new-font"
                                                        value={
                                                          formData
                                                            .entrevista_nissan
                                                            ?.cuando_compra ||
                                                          ""
                                                        }
                                                        onChange={(e) =>
                                                          updateNissanEntrevistaField(
                                                            "cuando_compra",
                                                            e.target.value,
                                                          )
                                                        }
                                                      >
                                                        <option value="">
                                                          Seleccione
                                                        </option>
                                                        <option value="Inmediata">
                                                          Inmediata
                                                        </option>
                                                        <option value="1 mes">
                                                          1 mes
                                                        </option>
                                                        <option value="1 a 3 meses">
                                                          1 a 3 meses
                                                        </option>
                                                        <option value="3 a 6 meses">
                                                          3 a 6 meses
                                                        </option>
                                                        <option value="Solo cotizando">
                                                          Solo cotizando
                                                        </option>
                                                      </select>
                                                    </div>
                                                  </div>

                                                  {/* Pregunta 8 */}
                                                  <div className="row mb-3">
                                                    <div className="col-md-6">
                                                      <label className="black-text new-font">
                                                        ¿Usted tomaría la
                                                        decisión de compra?
                                                      </label>
                                                      <select
                                                        className="form-control new-font"
                                                        value={
                                                          formData
                                                            .entrevista_nissan
                                                            ?.toma_decision_compra ||
                                                          ""
                                                        }
                                                        onChange={(e) =>
                                                          updateNissanEntrevistaField(
                                                            "toma_decision_compra",
                                                            e.target.value,
                                                          )
                                                        }
                                                      >
                                                        <option value="">
                                                          Seleccione
                                                        </option>
                                                        <option value="Si">
                                                          Sí
                                                        </option>
                                                        <option value="No">
                                                          No
                                                        </option>
                                                        <option value="Compartida">
                                                          Compartida
                                                        </option>
                                                      </select>
                                                    </div>
                                                  </div>

                                                  {/* Motivantes de compra (checkbox múltiple) */}
                                                  <div className="mt-4">
                                                    <h6 className="black-text new-font">
                                                      Motivantes de compra
                                                      (puede seleccionar varios)
                                                    </h6>

                                                    <div className="row">
                                                      {[
                                                        "Seguridad",
                                                        "Afecto",
                                                        "Bienestar",
                                                        "Compra personal",
                                                        "Novedad",
                                                        "Economía",
                                                      ].map((item) => {
                                                        const selected =
                                                          formData.entrevista_nissan?.motivantes_compra?.includes(
                                                            item,
                                                          );

                                                        return (
                                                          <div
                                                            className="col-md-4 mb-2"
                                                            key={item}
                                                          >
                                                            <div className="form-check">
                                                              <input
                                                                className="form-check-input"
                                                                type="checkbox"
                                                                id={`motivante_${item}`}
                                                                checked={
                                                                  !!selected
                                                                }
                                                                onChange={(e) =>
                                                                  toggleNissanMotivante(
                                                                    item,
                                                                    e.target
                                                                      .checked,
                                                                  )
                                                                }
                                                              />
                                                              <label
                                                                className="form-check-label new-font"
                                                                htmlFor={`motivante_${item}`}
                                                              >
                                                                {item}
                                                              </label>
                                                            </div>
                                                          </div>
                                                        );
                                                      })}
                                                    </div>
                                                  </div>
                                                </div>
                                              )}
                                              {step === 3 && (
                                                <div>
                                                  <h5 className="black-text new-font">
                                                    Prueba de manejo
                                                  </h5>

                                                  {selectedMailData?.respuesta_prueba_manejo_cliente && (
                                                    <div
                                                      className={`alert py-2 new-font ${
                                                        pruebaManejoData.realizo_prueba_manejo ===
                                                        "Si"
                                                          ? "alert-success"
                                                          : "alert-warning"
                                                      }`}
                                                    >
                                                      <strong>
                                                        Respuesta del cliente:
                                                      </strong>{" "}
                                                      {pruebaManejoData.realizo_prueba_manejo ===
                                                      "Si"
                                                        ? "Aceptó la prueba de manejo."
                                                        : pruebaManejoData.realizo_prueba_manejo ===
                                                            "No"
                                                          ? "Rechazó la prueba de manejo."
                                                          : String(
                                                              selectedMailData.respuesta_prueba_manejo_cliente,
                                                            )}
                                                    </div>
                                                  )}

                                                  <div className="row mb-3">
                                                    <div className="col-md-12">
                                                      <label className="black-text new-font fw-bold">
                                                        ¿Se realizó prueba de
                                                        manejo?
                                                      </label>

                                                      <div className="d-flex gap-3 flex-wrap mt-2">
                                                        <label className="form-check new-font">
                                                          <input
                                                            type="radio"
                                                            className="form-check-input"
                                                            name="realizo_prueba_manejo"
                                                            value="Si"
                                                            checked={
                                                              pruebaManejoData.realizo_prueba_manejo ===
                                                              "Si"
                                                            }
                                                            disabled={true}
                                                            title="Esta respuesta la captura el cliente desde su pantalla"
                                                          />
                                                          <span className="form-check-label black-text">
                                                            Sí
                                                          </span>
                                                        </label>

                                                        <label className="form-check new-font">
                                                          <input
                                                            type="radio"
                                                            className="form-check-input"
                                                            name="realizo_prueba_manejo"
                                                            value="No"
                                                            checked={
                                                              pruebaManejoData.realizo_prueba_manejo ===
                                                              "No"
                                                            }
                                                            disabled={true}
                                                            title="Esta respuesta la captura el cliente desde su pantalla"
                                                          />
                                                          <span className="form-check-label black-text">
                                                            No
                                                          </span>
                                                        </label>
                                                      </div>
                                                    </div>
                                                  </div>

                                                  {!pruebaManejoData.realizo_prueba_manejo && (
                                                    <div className="alert alert-light border mt-3 new-font">
                                                      <strong className="black-text">
                                                        Pendiente de respuesta
                                                        del cliente.
                                                      </strong>{" "}
                                                      <span className="black-text">
                                                        Desde asesor ya no se
                                                        selecciona si realizó o
                                                        no la prueba. Usa el
                                                        botón{" "}
                                                        <strong>
                                                          Solicitar prueba
                                                          manejo
                                                        </strong>{" "}
                                                        para que el cliente
                                                        acepte/rechace y
                                                        conteste la encuesta.
                                                      </span>
                                                    </div>
                                                  )}

                                                  {pruebaManejoData.realizo_prueba_manejo ===
                                                    "Si" && (
                                                    <>
                                                      <div className="alert alert-info py-2 new-font">
                                                        Habilita cámara o
                                                        adjunta imagen para
                                                        escanear por un lado el
                                                        frente de la licencia de
                                                        manejo del cliente.
                                                      </div>

                                                      <div className="row mb-4">
                                                        <div className="col-md-12">
                                                          <label className="black-text new-font fw-bold">
                                                            Frente de licencia
                                                            de manejo
                                                          </label>
                                                          <input
                                                            id="licenciaManejoFrente"
                                                            type="file"
                                                            className="form-control new-font"
                                                            accept="image/*,.pdf"
                                                            capture="environment"
                                                            onChange={
                                                              handleLicenciaManejoChange
                                                            }
                                                          />
                                                          {pruebaManejoData.licencia_manejo_frente_nombre && (
                                                            <small className="d-block mt-1 text-success new-font">
                                                              Archivo
                                                              seleccionado:{" "}
                                                              {
                                                                pruebaManejoData.licencia_manejo_frente_nombre
                                                              }
                                                            </small>
                                                          )}
                                                        </div>
                                                      </div>

                                                      <div className="alert alert-secondary py-2 new-font black-text">
                                                        Las respuestas de la
                                                        encuesta las captura el
                                                        cliente desde su
                                                        pantalla. En asesor se
                                                        muestran solo como
                                                        lectura.
                                                      </div>

                                                      <div className="table-responsive">
                                                        <table className="table table-bordered align-middle new-font">
                                                          <tbody>
                                                            {preguntasPruebaManejo.map(
                                                              (item, index) => (
                                                                <tr
                                                                  key={item.key}
                                                                >
                                                                  <td
                                                                    style={{
                                                                      width:
                                                                        "55px",
                                                                      textAlign:
                                                                        "center",
                                                                      fontWeight:
                                                                        "bold",
                                                                    }}
                                                                  >
                                                                    {index + 2}
                                                                  </td>

                                                                  <td>
                                                                    <div className="mb-2 black-text">
                                                                      En una
                                                                      escala del{" "}
                                                                      {item.escala ===
                                                                      10
                                                                        ? "1 al 10"
                                                                        : "1 al 5"}{" "}
                                                                      donde 1 es{" "}
                                                                      {item.escala ===
                                                                      10
                                                                        ? "totalmente insatisfecho"
                                                                        : "totalmente en desacuerdo"}{" "}
                                                                      y{" "}
                                                                      {
                                                                        item.escala
                                                                      }{" "}
                                                                      es{" "}
                                                                      {item.escala ===
                                                                      10
                                                                        ? "totalmente satisfecho"
                                                                        : "totalmente de acuerdo"}
                                                                      :{" "}
                                                                      {
                                                                        item.pregunta
                                                                      }
                                                                    </div>

                                                                    <div className="d-flex flex-wrap gap-2">
                                                                      {Array.from(
                                                                        {
                                                                          length:
                                                                            item.escala,
                                                                        },
                                                                        (
                                                                          _,
                                                                          i,
                                                                        ) => {
                                                                          const valor =
                                                                            String(
                                                                              i +
                                                                                1,
                                                                            );
                                                                          const seleccionado =
                                                                            pruebaManejoData
                                                                              .respuestas?.[
                                                                              item
                                                                                .key
                                                                            ] ===
                                                                            valor;

                                                                          return (
                                                                            <button
                                                                              key={
                                                                                valor
                                                                              }
                                                                              type="button"
                                                                              className={`btn btn-sm ${
                                                                                seleccionado
                                                                                  ? "btn-primary"
                                                                                  : "btn-outline-primary"
                                                                              }`}
                                                                              style={{
                                                                                minWidth:
                                                                                  "42px",
                                                                              }}
                                                                              disabled={
                                                                                true
                                                                              }
                                                                              title="Esta respuesta la contesta el cliente desde su pantalla"
                                                                            >
                                                                              {
                                                                                valor
                                                                              }
                                                                            </button>
                                                                          );
                                                                        },
                                                                      )}
                                                                    </div>
                                                                  </td>
                                                                </tr>
                                                              ),
                                                            )}
                                                          </tbody>
                                                        </table>
                                                      </div>
                                                    </>
                                                  )}

                                                  {pruebaManejoData.realizo_prueba_manejo ===
                                                    "No" && (
                                                    <div className="alert alert-warning mt-3 new-font">
                                                      Se registró que no se
                                                      realizó prueba de manejo.
                                                      Puedes avanzar a Consulta.
                                                    </div>
                                                  )}
                                                </div>
                                              )}
                                              {step === 4 && (
                                                <div>
                                                  <h5 className="black-text new-font">
                                                    Entrevista
                                                  </h5>

                                                  {(() => {
                                                    const isLessThanOneYear = (
                                                      dateStr,
                                                    ) => {
                                                      if (!dateStr)
                                                        return false;

                                                      let y, m, d;

                                                      // Formato YYYY-MM-DD
                                                      if (
                                                        dateStr.includes("-")
                                                      ) {
                                                        [y, m, d] = dateStr
                                                          .split("-")
                                                          .map(Number);
                                                      }

                                                      // Formato DD/MM/YYYY
                                                      if (
                                                        (!y || !m || !d) &&
                                                        dateStr.includes("/")
                                                      ) {
                                                        const parts = dateStr
                                                          .split("/")
                                                          .map(Number);
                                                        d = parts[0];
                                                        m = parts[1];
                                                        y = parts[2];
                                                      }

                                                      if (!y || !m || !d)
                                                        return false;

                                                      const start = new Date(
                                                        y,
                                                        m - 1,
                                                        d,
                                                      );
                                                      const now = new Date();

                                                      const startDay = new Date(
                                                        start.getFullYear(),
                                                        start.getMonth(),
                                                        start.getDate(),
                                                      ).getTime();

                                                      const nowDay = new Date(
                                                        now.getFullYear(),
                                                        now.getMonth(),
                                                        now.getDate(),
                                                      ).getTime();

                                                      const diffDays =
                                                        (nowDay - startDay) /
                                                        (1000 * 60 * 60 * 24);
                                                      return diffDays < 365;
                                                    };

                                                    const tipoAuto = (
                                                      selectedMailData?.tipo_auto ||
                                                      ""
                                                    ).toLowerCase();
                                                    const esSeminuevo =
                                                      tipoAuto.includes(
                                                        "seminuevo",
                                                      );
                                                    const esNuevo =
                                                      tipoAuto.includes(
                                                        "nuevo",
                                                      ) &&
                                                      !tipoAuto.includes(
                                                        "seminuevo",
                                                      );

                                                    const showNoteComprobable =
                                                      formData.comprueba_ingresos ===
                                                        "Si" &&
                                                      isLessThanOneYear(
                                                        formData.fecha_inicio_actividades,
                                                      );

                                                    const showNoteNoComprobable =
                                                      formData.comprueba_ingresos ===
                                                        "No" &&
                                                      isLessThanOneYear(
                                                        formData.fecha_inicio_actividades_no_comprobable,
                                                      );

                                                    return (
                                                      <>
                                                        {/* ¿La compra de su nuevo vehículo sería contado o crédito? */}
                                                        <div className="row mb-3">
                                                          <div className="col-md-6">
                                                            <label className="black-text new-font">
                                                              ¿La compra de su
                                                              nuevo vehículo
                                                              sería contado o
                                                              crédito?
                                                            </label>
                                                            <select
                                                              name="pago_contado"
                                                              className="form-control new-font"
                                                              value={
                                                                formData.pago_contado
                                                              }
                                                              onChange={
                                                                handleInputChange
                                                              }
                                                            >
                                                              <option value="">
                                                                Seleccione
                                                              </option>
                                                              <option value="Si">
                                                                Contado
                                                              </option>
                                                              <option value="No">
                                                                Crédito
                                                              </option>
                                                            </select>
                                                          </div>
                                                        </div>

                                                        {/* DATOS DE COTIZACIÓN NR - INTEGRADOS AL FLUJO */}
                                                        {agenciaUsaCotizadorNR && (
                                                        <div className="row mb-3 g-3">
                                                          <div className="col-md-4">
                                                            <label className="black-text new-font">
                                                              Personalidad jurídica
                                                            </label>
                                                            <select
                                                              name="nr_personalidad_juridica"
                                                              className="form-control new-font"
                                                              value={formData.nr_personalidad_juridica}
                                                              onChange={handleNrSimpleInputChange}
                                                            >
                                                              <option value="">Seleccione</option>
                                                              <option value="1">Persona Física</option>
                                                              <option value="2">Persona Moral</option>
                                                            </select>
                                                          </div>

                                                          <div className="col-md-4">
                                                            <label className="black-text new-font">
                                                              Tipo de precio
                                                            </label>
                                                            <select
                                                              name="nr_estrategia_id"
                                                              className="form-control new-font"
                                                              value={formData.nr_estrategia_id || ""}
                                                              onChange={handleNrEstrategiaChange}
                                                              disabled={
                                                                nrCatalogosLoading ||
                                                                !(Array.isArray(nrCatalogos.estrategias) && nrCatalogos.estrategias.length)
                                                              }
                                                            >
                                                              <option value="">
                                                                {nrCatalogosLoading
                                                                  ? "Cargando estrategia..."
                                                                  : nrCatalogos.estrategias?.length
                                                                    ? "Seleccione estrategia"
                                                                    : "Prepare datos NR primero"}
                                                              </option>
                                                              {(Array.isArray(nrCatalogos.estrategias)
                                                                ? nrCatalogos.estrategias
                                                                : []
                                                              ).map((item) => (
                                                                <option key={`nr-estrategia-${item.id}`} value={item.id}>
                                                                  {item.nombre || `Estrategia ${item.id}`}
                                                                </option>
                                                              ))}
                                                            </select>
                                                          </div>

                                                          <div className="col-md-4">
                                                            <label className="black-text new-font">
                                                              Plan 
                                                            </label>
                                                            <select
                                                              name="nr_plan_id"
                                                              className="form-control new-font"
                                                              value={formData.nr_plan_id || ""}
                                                              onChange={handleNrPlanChange}
                                                              disabled={
                                                                nrCatalogosLoading ||
                                                                !formData.nr_producto_id ||
                                                                !(
                                                                  (Array.isArray(nrCatalogos.paquetes) && nrCatalogos.paquetes.length) ||
                                                                  (Array.isArray(nrCatalogos.planes) && nrCatalogos.planes.length)
                                                                )
                                                              }
                                                            >
                                                              <option value="">
                                                                {nrCatalogosLoading
                                                                  ? "Cargando plan/paquete..."
                                                                  : formData.nr_producto_id
                                                                    ? "Seleccione plan / paquete"
                                                                    : "Producto NR primero"}
                                                              </option>
                                                              {(Array.isArray(nrCatalogos.paquetes)
                                                                ? nrCatalogos.paquetes
                                                                : []
                                                              )
                                                                .filter((item) => {
                                                                  const id = String(item?.idPaquete ?? "");
                                                                  return id && (
                                                                    !Array.isArray(nrCatalogos.planes) ||
                                                                    !nrCatalogos.planes.length ||
                                                                    nrCatalogos.planes.some((plan) => String(plan?.id ?? "") === id)
                                                                  );
                                                                })
                                                                .map((item) => (
                                                                  <option key={`nr-paquete-${item.idPaquete}`} value={item.idPaquete}>
                                                                    {item.nombre || item.nombreCebip || `Paquete ${item.idPaquete}`}
                                                                  </option>
                                                                ))}
                                                              {!(Array.isArray(nrCatalogos.paquetes) && nrCatalogos.paquetes.length) &&
                                                                (Array.isArray(nrCatalogos.planes) ? nrCatalogos.planes : []).map((item) => (
                                                                  <option key={`nr-plan-${item.id}`} value={item.id}>
                                                                    {item.nombre || `Plan ${item.id}`}
                                                                  </option>
                                                                ))}
                                                            </select>
                                                          </div>

                                                          <div className="col-md-3">
                                                            <label className="black-text new-font">
                                                              Estado
                                                            </label>
                                                            <select
                                                              name="nr_estado_id"
                                                              className="form-control new-font"
                                                              value={formData.nr_estado_id}
                                                              onChange={handleNrSimpleInputChange}
                                                              disabled={
                                                                nrCatalogosLoading ||
                                                                !formData.nr_estrategia_id ||
                                                                !formData.nr_producto_id ||
                                                                !formData.nr_plan_id
                                                              }
                                                            >
                                                              <option value="">
                                                                {!formData.nr_plan_id
                                                                  ? "Complete estrategia, producto y plan"
                                                                  : "Seleccione estado"}
                                                              </option>
                                                              {(Array.isArray(nrCatalogos.estados)
                                                                ? nrCatalogos.estados
                                                                : []
                                                              ).map((item) => (
                                                                <option key={`nr-estado-${item.id}`} value={item.id}>
                                                                  {item.nombre}
                                                                </option>
                                                              ))}
                                                            </select>
                                                          </div>

                                                          <div className="col-md-3">
                                                            <label className="black-text new-font">
                                                              Municipio
                                                            </label>
                                                            <select
                                                              name="nr_municipio_id"
                                                              className="form-control new-font"
                                                              value={formData.nr_municipio_id}
                                                              onChange={handleNrSimpleInputChange}
                                                              disabled={
                                                                !formData.nr_estado_id ||
                                                                !nrMunicipiosOptions.length
                                                              }
                                                            >
                                                              <option value="">
                                                                {nrCatalogosLoading
                                                                  ? "Cargando municipios..."
                                                                  : formData.nr_estado_id
                                                                    ? nrMunicipiosOptions.length
                                                                      ? "Seleccione municipio"
                                                                      : "Sin municipios disponibles"
                                                                    : "Seleccione estado primero"}
                                                              </option>
                                                              {nrMunicipiosOptions.map((item) => (
                                                                <option
                                                                  key={`nr-municipio-${item.MunicipalityId}`}
                                                                  value={item.MunicipalityId}
                                                                >
                                                                  {item.Description}
                                                                </option>
                                                              ))}
                                                            </select>
                                                          </div>

                                                          <div className="col-md-6 d-flex align-items-end">
                                                            <div className="w-100">
                                                              <div className="d-flex align-items-start justify-content-between gap-2 flex-wrap">
                                                                <small className="text-muted new-font-14 flex-grow-1">
                                                                  Orden NR: estrategia → producto → plan/paquete → estado → municipio.
                                                                  Tipo de operación: {nrGetTipoOperacionLabelFromEntrevista(formData, selectedMailData)}.
                                                                  {formData.nr_producto_id
                                                                    ? ` Producto enviado: ${formData.nr_producto_id}.`
                                                                    : ""}
                                                                  {formData.nr_plan_id
                                                                    ? ` Plan/paquete: ${formData.nr_plan_id}.`
                                                                    : ""}
                                                                </small>

                                                                <button
                                                                  type="button"
                                                                  className="btn btn-sm btn-outline-primary"
                                                                  onClick={handlePrepararDatosNR}
                                                                  disabled={
                                                                    nrCatalogosLoading ||
                                                                    !formData.nr_personalidad_juridica
                                                                  }
                                                                >
                                                                  {nrCatalogosLoading
                                                                    ? "Preparando NR..."
                                                                    : formData.nr_plan_id
                                                                      ? "Actualizar datos NR"
                                                                      : "Preparar datos NR"}
                                                                </button>
                                                              </div>

                                                              {nrLastError && (
                                                                <small className="text-danger d-block mt-1">
                                                                  {nrLastError}
                                                                </small>
                                                              )}
                                                            </div>
                                                          </div>
                                                        </div>
                                                        )}
                                                        {/* CONTADO */}
                                                        {formData.pago_contado ===
                                                          "Si" && (
                                                          <>
                                                            <div className="row mb-3">
                                                              <div className="col-md-6">
                                                                <label className="black-text new-font">
                                                                  ¿Acepta el
                                                                  seguro de auto
                                                                  dentro del
                                                                  proceso de
                                                                  cotización?
                                                                </label>
                                                                <select
                                                                  name="acepta_seguro_auto"
                                                                  className="form-control new-font"
                                                                  value={
                                                                    formData.acepta_seguro_auto
                                                                  }
                                                                  onChange={
                                                                    handleInputChange
                                                                  }
                                                                >
                                                                  <option value="">
                                                                    Seleccione
                                                                  </option>
                                                                  <option value="Si">
                                                                    Sí
                                                                  </option>
                                                                  <option value="No">
                                                                    No
                                                                  </option>
                                                                </select>
                                                              </div>
                                                              <div className="col-md-6">
                                                                <label className="black-text new-font">
                                                                  ¿Tiene
                                                                  definido el
                                                                  presupuesto
                                                                  que desea
                                                                  invertir?
                                                                </label>
                                                                <select
                                                                  name="presupuesto_definido"
                                                                  className="form-control new-font"
                                                                  value={
                                                                    formData.presupuesto_definido
                                                                  }
                                                                  onChange={
                                                                    handleInputChange
                                                                  }
                                                                >
                                                                  <option value="">
                                                                    Seleccione
                                                                  </option>
                                                                  <option value="Si">
                                                                    Sí
                                                                  </option>
                                                                  <option value="No">
                                                                    No
                                                                  </option>
                                                                </select>
                                                              </div>

                                                              <div className="col-md-6">
                                                                <label className="black-text new-font">
                                                                  ¿Está
                                                                  interesado en
                                                                  conocer
                                                                  opciones de
                                                                  protección o
                                                                  valor agregado
                                                                  para su
                                                                  vehículo?
                                                                </label>
                                                                <select
                                                                  name="interes_proteccion"
                                                                  className="form-control new-font"
                                                                  value={
                                                                    formData.interes_proteccion
                                                                  }
                                                                  onChange={
                                                                    handleInputChange
                                                                  }
                                                                >
                                                                  <option value="">
                                                                    Seleccione
                                                                  </option>
                                                                  <option value="Si">
                                                                    Sí
                                                                  </option>
                                                                  <option value="No">
                                                                    No
                                                                  </option>
                                                                </select>
                                                              </div>
                                                            </div>
                                                          </>
                                                        )}

                                                        {/* CRÉDITO */}
                                                        {formData.pago_contado ===
                                                          "No" && (
                                                          <>
                                                            <div className="row mb-3">
                                                              <div className="col-md-6">
                                                                <label className="black-text new-font">
                                                                  ¿Cuenta con
                                                                  historial de
                                                                  crédito?
                                                                </label>
                                                                <select
                                                                  name="historial_credito"
                                                                  className="form-control new-font"
                                                                  value={
                                                                    formData.historial_credito
                                                                  }
                                                                  onChange={
                                                                    handleInputChange
                                                                  }
                                                                >
                                                                  <option value="">
                                                                    Seleccione
                                                                  </option>
                                                                  <option value="Si">
                                                                    Sí
                                                                  </option>
                                                                  <option value="No">
                                                                    No
                                                                  </option>
                                                                </select>
                                                              </div>

                                                              <div className="col-md-6">
                                                                <label className="black-text new-font">
                                                                  ¿Cuánto de
                                                                  inversión
                                                                  inicial
                                                                  contempla?
                                                                </label>
                                                                <input
                                                                  type="text"
                                                                  inputMode="numeric"
                                                                  pattern="[0-9,]*"
                                                                  name="enganche"
                                                                  className="form-control new-font"
                                                                  value={
                                                                    activeFinancingEdit ===
                                                                    "enganche"
                                                                      ? engancheDraftInput
                                                                      : formData.enganche
                                                                  }
                                                                  onFocus={
                                                                    handleEngancheFocus
                                                                  }
                                                                  onChange={
                                                                    handleEngancheChange
                                                                  }
                                                                  onBlur={
                                                                    handleEngancheBlur
                                                                  }
                                                                />
                                                                {validationMessage && (
                                                                  <small
                                                                    style={{
                                                                      color:
                                                                        "red",
                                                                      marginTop:
                                                                        "5px",
                                                                      display:
                                                                        "block",
                                                                    }}
                                                                  >
                                                                    {
                                                                      validationMessage
                                                                    }
                                                                  </small>
                                                                )}
                                                              </div>
                                                            </div>

                                                            <div className="row mb-3">
                                                              <div className="col-md-6">
                                                                <label className="black-text new-font">
                                                                  ¿Qué
                                                                  mensualidad
                                                                  está buscando?
                                                                </label>
                                                                <input
                                                                  type="text"
                                                                  inputMode="numeric"
                                                                  pattern="[0-9,]*"
                                                                  name="mensualidad_buscada"
                                                                  className="form-control new-font"
                                                                  value={
                                                                    activeFinancingEdit ===
                                                                    "mensualidad_buscada"
                                                                      ? mensualidadDraftInput
                                                                      : formData.mensualidad_buscada
                                                                  }
                                                                  onFocus={
                                                                    handleMensualidadBuscadaFocus
                                                                  }
                                                                  onMouseUp={(
                                                                    e,
                                                                  ) =>
                                                                    e.preventDefault()
                                                                  }
                                                                  onChange={
                                                                    handleFormattedInputChange
                                                                  }
                                                                  onBlur={
                                                                    handleMensualidadBuscadaBlur
                                                                  }
                                                                />
                                                              </div>

                                                              <div className="col-md-6">
                                                                <label className="black-text new-font">
                                                                  ¿A qué plazo
                                                                  de meses busca
                                                                  financiar?
                                                                </label>
                                                                <select
                                                                  name="plazo_meses"
                                                                  className="form-control new-font"
                                                                  value={Number(
                                                                    effectiveMonths,
                                                                  )}
                                                                  onChange={
                                                                    handleFinancingMonthsChange
                                                                  }
                                                                >
                                                                  {creditMonths.map(
                                                                    (month) => (
                                                                      <option
                                                                        key={
                                                                          month
                                                                        }
                                                                        value={
                                                                          month
                                                                        }
                                                                      >
                                                                        {month}{" "}
                                                                        meses
                                                                      </option>
                                                                    ),
                                                                  )}
                                                                </select>
                                                                <small className="text-muted black-text new-font-14 d-block mt-1">
                                                                  Condición:{" "}
                                                                  {condicionesFinanciamientoCredito.tipoAuto ||
                                                                    "AUTO"}{" "}
                                                                  {condicionesFinanciamientoCredito.anio ||
                                                                    ""}{" "}
                                                                  · Plazo{" "}
                                                                  {
                                                                    condicionesFinanciamientoCredito.minMonths
                                                                  }
                                                                  -
                                                                  {
                                                                    condicionesFinanciamientoCredito.maxMonths
                                                                  }{" "}
                                                                  meses ·
                                                                  Enganche
                                                                  mínimo{" "}
                                                                  {
                                                                    condicionesFinanciamientoCredito.minDownPaymentPercentage
                                                                  }
                                                                  %
                                                                </small>
                                                              </div>
                                                            </div>

                                                            <div className="row mb-3">
                                                              <div className="col-md-6">
                                                                <label className="black-text new-font">
                                                                  ¿Comprueba
                                                                  ingresos?
                                                                </label>
                                                                <select
                                                                  name="comprueba_ingresos"
                                                                  className="form-control new-font"
                                                                  value={
                                                                    formData.comprueba_ingresos
                                                                  }
                                                                  onChange={
                                                                    handleInputChange
                                                                  }
                                                                >
                                                                  <option value="">
                                                                    Seleccione
                                                                  </option>
                                                                  <option value="Si">
                                                                    Sí
                                                                  </option>
                                                                  <option value="No">
                                                                    No
                                                                  </option>
                                                                </select>
                                                              </div>
                                                            </div>

                                                            {/* CRÉDITO - SI COMPRUEBA */}
                                                            {formData.comprueba_ingresos ===
                                                              "Si" && (
                                                              <>
                                                                <div className="row mb-3">
                                                                  <div className="col-md-6">
                                                                    <label className="black-text new-font">
                                                                      ¿Su
                                                                      actividad
                                                                      es
                                                                      asalariado
                                                                      o
                                                                      independiente?
                                                                    </label>
                                                                    <select
                                                                      name="tipo_actividad"
                                                                      className="form-control new-font"
                                                                      value={
                                                                        formData.tipo_actividad
                                                                      }
                                                                      onChange={
                                                                        handleInputChange
                                                                      }
                                                                    >
                                                                      <option value="">
                                                                        Seleccione
                                                                      </option>
                                                                      <option value="Asalariado">
                                                                        Asalariado
                                                                      </option>
                                                                      <option value="Independiente">
                                                                        Independiente
                                                                      </option>
                                                                    </select>
                                                                  </div>

                                                                  <div className="col-md-6">
                                                                    <label className="black-text new-font">
                                                                      Actividad
                                                                      de la
                                                                      empresa
                                                                    </label>
                                                                    <input
                                                                      type="text"
                                                                      name="actividad_empresa"
                                                                      className="form-control new-font"
                                                                      value={
                                                                        formData.actividad_empresa
                                                                      }
                                                                      onChange={
                                                                        handleInputChange
                                                                      }
                                                                    />
                                                                  </div>
                                                                </div>

                                                                <div className="row mb-2">
                                                                  <div className="col-md-6">
                                                                    <label className="black-text new-font">
                                                                      Fecha de
                                                                      Ingreso o
                                                                      Inicio de
                                                                      actividades
                                                                    </label>
                                                                    <input
                                                                      type="date"
                                                                      name="fecha_inicio_actividades"
                                                                      className="form-control new-font"
                                                                      value={
                                                                        formData.fecha_inicio_actividades
                                                                      }
                                                                      onChange={
                                                                        handleInputChange
                                                                      }
                                                                    />
                                                                    {showNoteComprobable && (
                                                                      <div
                                                                        className="new-font mt-2"
                                                                        style={{
                                                                          fontWeight: 700,
                                                                          color:
                                                                            "red",
                                                                        }}
                                                                      >
                                                                        NOTA: LA
                                                                        ANTIGÜEDAD
                                                                        MINIMA
                                                                        DE SU
                                                                        ACTIVIDAD
                                                                        ES DE 1
                                                                        AÑO
                                                                      </div>
                                                                    )}
                                                                  </div>

                                                                  <div className="col-md-6">
                                                                    <label className="black-text new-font">
                                                                      Nombre
                                                                      empresa o
                                                                      negocio
                                                                    </label>
                                                                    <input
                                                                      type="text"
                                                                      name="nombre_empresa_negocio"
                                                                      className="form-control new-font"
                                                                      value={
                                                                        formData.nombre_empresa_negocio
                                                                      }
                                                                      onChange={
                                                                        handleInputChange
                                                                      }
                                                                    />
                                                                  </div>
                                                                </div>

                                                                <div className="row mb-3">
                                                                  <div className="col-md-6">
                                                                    <label className="black-text new-font">
                                                                      ¿Cuál es
                                                                      su ingreso
                                                                      mensual?
                                                                    </label>
                                                                    <input
                                                                      type="text"
                                                                      name="ingreso_mensual"
                                                                      className="form-control new-font"
                                                                      value={
                                                                        formData.ingreso_mensual
                                                                      }
                                                                      onChange={
                                                                        handleFormattedInputChange
                                                                      }
                                                                    />
                                                                  </div>
                                                                  <div className="col-md-6"></div>
                                                                </div>
                                                              </>
                                                            )}

                                                            {/* CRÉDITO - NO COMPRUEBA */}
                                                            {formData.comprueba_ingresos ===
                                                              "No" && (
                                                              <>
                                                                <div className="row mb-2">
                                                                  <div className="col-md-6">
                                                                    <label className="black-text new-font">
                                                                      ¿Cuál es
                                                                      su
                                                                      actividad?
                                                                    </label>
                                                                    <input
                                                                      type="text"
                                                                      name="actividad_no_comprobable"
                                                                      className="form-control new-font"
                                                                      value={
                                                                        formData.actividad_no_comprobable
                                                                      }
                                                                      onChange={
                                                                        handleInputChange
                                                                      }
                                                                    />
                                                                  </div>

                                                                  <div className="col-md-6">
                                                                    <label className="black-text new-font">
                                                                      Fecha de
                                                                      Inicio de
                                                                      actividades
                                                                    </label>
                                                                    <input
                                                                      type="date"
                                                                      name="fecha_inicio_actividades_no_comprobable"
                                                                      className="form-control new-font"
                                                                      value={
                                                                        formData.fecha_inicio_actividades_no_comprobable
                                                                      }
                                                                      onChange={
                                                                        handleInputChange
                                                                      }
                                                                    />
                                                                    {showNoteNoComprobable && (
                                                                      <div
                                                                        className="new-font mt-2"
                                                                        style={{
                                                                          fontWeight: 700,
                                                                          color:
                                                                            "red",
                                                                        }}
                                                                      >
                                                                        NOTA: LA
                                                                        ANTIGÜEDAD
                                                                        MINIMA
                                                                        DE SU
                                                                        ACTIVIDAD
                                                                        ES DE 1
                                                                        AÑO
                                                                      </div>
                                                                    )}
                                                                  </div>
                                                                </div>

                                                                <div className="row mb-3">
                                                                  <div className="col-md-6">
                                                                    <label className="black-text new-font">
                                                                      ¿Cuál es
                                                                      su ingreso
                                                                      mensual no
                                                                      comprobable?
                                                                    </label>
                                                                    <input
                                                                      type="text"
                                                                      name="ingreso_mensual_no_comprobable"
                                                                      className="form-control new-font"
                                                                      value={
                                                                        formData.ingreso_mensual_no_comprobable
                                                                      }
                                                                      onChange={
                                                                        handleFormattedInputChange
                                                                      }
                                                                    />
                                                                  </div>
                                                                  <div className="col-md-6"></div>
                                                                </div>
                                                              </>
                                                            )}
                                                          </>
                                                        )}

                                                        {/* Identificación de necesidades de garantías */}
                                                        <div className="mt-4">
                                                          <h5 className="black-text new-font">
                                                            Identificación de
                                                            necesidades de
                                                            garantías
                                                          </h5>

                                                          <div className="row mb-3">
                                                            <div className="col-md-6">
                                                              <label className="black-text new-font">
                                                                ¿Cómo son
                                                                generalmente las
                                                                calles por las
                                                                que suele
                                                                manejar?
                                                              </label>
                                                              <select
                                                                name="condiciones_calle_extra"
                                                                className="form-control new-font"
                                                                value={
                                                                  formData.condiciones_calle_extra
                                                                }
                                                                onChange={
                                                                  handleInputChange
                                                                }
                                                              >
                                                                <option value="">
                                                                  Seleccione
                                                                </option>
                                                                <option value="Buenas">
                                                                  Buenas
                                                                </option>
                                                                <option value="Malas">
                                                                  Malas
                                                                </option>
                                                                <option value="Regulares">
                                                                  Regulares
                                                                </option>
                                                              </select>
                                                            </div>

                                                            {esNuevo && (
                                                              <div className="col-md-6">
                                                                <label className="black-text new-font">
                                                                  ¿Ha extraviado
                                                                  alguna vez una
                                                                  llave de su
                                                                  auto o le
                                                                  preocupa el
                                                                  costo de una
                                                                  reposición?
                                                                </label>
                                                                <select
                                                                  name="interes_llaves"
                                                                  className="form-control new-font"
                                                                  value={
                                                                    formData.interes_llaves
                                                                  }
                                                                  onChange={
                                                                    handleInputChange
                                                                  }
                                                                >
                                                                  <option value="">
                                                                    Seleccione
                                                                  </option>
                                                                  <option value="Si">
                                                                    Sí
                                                                  </option>
                                                                  <option value="No">
                                                                    No
                                                                  </option>
                                                                </select>
                                                              </div>
                                                            )}
                                                          </div>

                                                          <div className="row mb-3">
                                                            <div className="col-md-6">
                                                              <label className="black-text new-font">
                                                                ¿Ha tenido que
                                                                dejar su auto en
                                                                el taller por
                                                                unos días tras
                                                                un siniestro o
                                                                reparación?
                                                              </label>
                                                              <select
                                                                name="ha_dejado_taller"
                                                                className="form-control new-font"
                                                                value={
                                                                  formData.ha_dejado_taller
                                                                }
                                                                onChange={
                                                                  handleInputChange
                                                                }
                                                              >
                                                                <option value="">
                                                                  Seleccione
                                                                </option>
                                                                <option value="Si">
                                                                  Sí
                                                                </option>
                                                                <option value="No">
                                                                  No
                                                                </option>
                                                              </select>
                                                            </div>

                                                            {esSeminuevo && (
                                                              <div className="col-md-6">
                                                                <label className="black-text new-font">
                                                                  Al adquirir un
                                                                  auto
                                                                  seminuevo, ¿le
                                                                  interesaría
                                                                  tener la
                                                                  tranquilidad
                                                                  de una
                                                                  garantía
                                                                  similar a la
                                                                  de un auto
                                                                  nuevo?
                                                                </label>
                                                                <select
                                                                  name="garantia_seminuevo"
                                                                  className="form-control new-font"
                                                                  value={
                                                                    formData.garantia_seminuevo
                                                                  }
                                                                  onChange={
                                                                    handleInputChange
                                                                  }
                                                                >
                                                                  <option value="">
                                                                    Seleccione
                                                                  </option>
                                                                  <option value="1 año">
                                                                    1 año
                                                                  </option>
                                                                  <option value="2 años">
                                                                    2 años
                                                                  </option>
                                                                  <option value="3 años">
                                                                    3 años
                                                                  </option>
                                                                </select>
                                                              </div>
                                                            )}
                                                          </div>

                                                          <div className="row mb-3">
                                                            <div className="col-md-6">
                                                              <label className="black-text new-font">
                                                                Para mayor
                                                                privacidad y
                                                                discreción al
                                                                conducir, ¿le
                                                                interesaría que
                                                                su vehículo
                                                                incluya
                                                                polarizado que
                                                                limite la
                                                                visibilidad
                                                                hacia el
                                                                interior?
                                                              </label>
                                                              <select
                                                                name="desea_polarizado"
                                                                className="form-control new-font"
                                                                value={
                                                                  formData.desea_polarizado
                                                                }
                                                                onChange={
                                                                  handleInputChange
                                                                }
                                                              >
                                                                <option value="">
                                                                  Seleccione
                                                                </option>
                                                                <option value="Si">
                                                                  Sí
                                                                </option>
                                                                <option value="No">
                                                                  No
                                                                </option>
                                                              </select>
                                                            </div>

                                                            <div className="col-md-6">
                                                              <label className="black-text new-font">
                                                                Para mayor
                                                                tranquilidad
                                                                ante cualquier
                                                                eventualidad,
                                                                ¿le interesaría
                                                                que su vehículo
                                                                incluya un Kit
                                                                de Emergencia
                                                                completo desde
                                                                la entrega?
                                                              </label>
                                                              <select
                                                                name="desea_kit_emergencia"
                                                                className="form-control new-font"
                                                                value={
                                                                  formData.desea_kit_emergencia
                                                                }
                                                                onChange={
                                                                  handleInputChange
                                                                }
                                                              >
                                                                <option value="">
                                                                  Seleccione
                                                                </option>
                                                                <option value="Si">
                                                                  Sí
                                                                </option>
                                                                <option value="No">
                                                                  No
                                                                </option>
                                                              </select>
                                                            </div>
                                                          </div>

                                                          <div className="row mb-3">
                                                            <div className="col-md-6">
                                                              <label className="black-text new-font">
                                                                ¿Le gustaría
                                                                saber en tiempo
                                                                real dónde se
                                                                encuentra su
                                                                auto todo el
                                                                tiempo?
                                                              </label>
                                                              <select
                                                                name="tiempo_real"
                                                                className="form-control new-font"
                                                                value={
                                                                  formData.tiempo_real
                                                                }
                                                                onChange={
                                                                  handleInputChange
                                                                }
                                                              >
                                                                <option value="">
                                                                  Seleccione
                                                                </option>
                                                                <option value="Si">
                                                                  Sí
                                                                </option>
                                                                <option value="No">
                                                                  No
                                                                </option>
                                                              </select>
                                                            </div>

                                                            <div className="col-md-6">
                                                              <label className="black-text new-font">
                                                                ¿Es importante
                                                                para usted un
                                                                respaldo que
                                                                ayude a
                                                                recuperar el
                                                                auto en caso de
                                                                robo?
                                                              </label>
                                                              <select
                                                                name="respaldo_auto"
                                                                className="form-control new-font"
                                                                value={
                                                                  formData.respaldo_auto
                                                                }
                                                                onChange={
                                                                  handleInputChange
                                                                }
                                                              >
                                                                <option value="">
                                                                  Seleccione
                                                                </option>
                                                                <option value="Si">
                                                                  Sí
                                                                </option>
                                                                <option value="No">
                                                                  No
                                                                </option>
                                                              </select>
                                                            </div>
                                                          </div>
                                                        </div>
                                                      </>
                                                    );
                                                  })()}
                                                </div>
                                              )}
                                              {step === 5 && ( //aqui
                                                <div>
                                                  <h5 className="black-text new-font">
                                                    Accesorios
                                                  </h5>
                                                  <div className="row">
                                                    {plans.map(
                                                      (plan, index) => (
                                                        <div
                                                          className="col-md-4 mb-4"
                                                          key={index}
                                                        >
                                                          <div
                                                            className="card"
                                                            style={{
                                                              cursor: "pointer",
                                                            }}
                                                          >
                                                            <div className="card-body text-center">
                                                              <h5 className="card-title">
                                                                {
                                                                  plan.title.split(
                                                                    " - ",
                                                                  )[0]
                                                                }
                                                              </h5>

                                                              <h6 className="card-price">
                                                                $
                                                                {new Intl.NumberFormat(
                                                                  "es-MX",
                                                                  {
                                                                    style:
                                                                      "decimal",
                                                                    minimumFractionDigits: 0,
                                                                    maximumFractionDigits: 0,
                                                                  },
                                                                ).format(
                                                                  Number(
                                                                    plan.price.replace(
                                                                      /[^0-9.-]+/g,
                                                                      "",
                                                                    ),
                                                                  ),
                                                                )}
                                                              </h6>

                                                              <div>
                                                                <div>
                                                                  {[
                                                                    0, 1, 2,
                                                                  ].map(
                                                                    (
                                                                      offerIndex,
                                                                    ) => {
                                                                      const planReal =
                                                                        plansState[
                                                                          offerIndex
                                                                        ];
                                                                      const tituloBuscado =
                                                                        plan.title
                                                                          .trim()
                                                                          .toLowerCase();

                                                                      const esActivo =
                                                                        planReal?.accessories?.some(
                                                                          (
                                                                            acc,
                                                                          ) =>
                                                                            acc.title
                                                                              .trim()
                                                                              .toLowerCase() ===
                                                                            tituloBuscado,
                                                                        );

                                                                      const estaBloqueado =
                                                                        esPlanNoEditable(
                                                                          planReal,
                                                                        );

                                                                      return (
                                                                        <span
                                                                          key={
                                                                            offerIndex
                                                                          }
                                                                          className={`badge border me-2 ${
                                                                            esActivo
                                                                              ? "estado-activo"
                                                                              : "estado-inactivo"
                                                                          } ${estaBloqueado ? "opacity-50" : ""}`}
                                                                          style={{
                                                                            cursor:
                                                                              estaBloqueado
                                                                                ? "not-allowed"
                                                                                : "pointer",
                                                                            pointerEvents:
                                                                              estaBloqueado
                                                                                ? "none"
                                                                                : "auto",
                                                                          }}
                                                                          onClick={() => {
                                                                            if (
                                                                              estaBloqueado
                                                                            )
                                                                              return;
                                                                            assignAccessoryToPlan(
                                                                              index,
                                                                              offerIndex,
                                                                            );
                                                                          }}
                                                                        >
                                                                          Plan{" "}
                                                                          {offerIndex +
                                                                            1}{" "}
                                                                          {esActivo
                                                                            ? "✓"
                                                                            : ""}
                                                                        </span>
                                                                      );
                                                                    },
                                                                  )}
                                                                </div>
                                                              </div>
                                                            </div>
                                                          </div>
                                                        </div>
                                                      ),
                                                    )}
                                                  </div>
                                                </div>
                                              )}

                                              {step === 6 && (
                                                <div
                                                  className="drag-scroll-container plans-step-scroll-area"
                                                  onWheelCapture={
                                                    handleNestedScrollWheel
                                                  }
                                                  onTouchStart={
                                                    handleNestedScrollTouchStart
                                                  }
                                                  onTouchMove={
                                                    handleNestedScrollTouchMove
                                                  }
                                                >
                                                  <h5 className="black-text text-center">
                                                    Planes
                                                  </h5>

                                                  <DragDropContext
                                                    onBeforeDragStart={() => {
                                                      document.body.style.cursor =
                                                        "grabbing";
                                                    }}
                                                    onDragStart={() => {
                                                      document.body.style.cursor =
                                                        "grabbing";
                                                    }}
                                                    onDragEnd={(result) => {
                                                      document.body.style.cursor =
                                                        "default";

                                                      const {
                                                        source,
                                                        destination,
                                                      } = result;

                                                      if (!destination) return;

                                                      const sourcePlan =
                                                        plansState[
                                                          source.droppableId
                                                        ];
                                                      const destPlan =
                                                        plansState[
                                                          destination
                                                            .droppableId
                                                        ];

                                                      const isSourceGold =
                                                        esPlanNoEditable(
                                                          sourcePlan,
                                                        );
                                                      const isDestGold =
                                                        esPlanNoEditable(
                                                          destPlan,
                                                        );

                                                      if (
                                                        isSourceGold ||
                                                        isDestGold
                                                      ) {
                                                        return; // bloquea cualquier drag hacia o desde paquetes no editables
                                                      }

                                                      handleDragEnd(result);
                                                    }}
                                                    onError={onDragError}
                                                  >
                                                    <div className="row new-font-14">
                                                      {/* Controles de Planes trabajandoo*/}
                                                      <PlanControlsSection />

                                                      {/* Planes individuales */}
                                                      {ordenarPlanesPorOrdenFijo(
                                                        plansState,
                                                      ).map((plan) => {
                                                        const planIndex =
                                                          Math.max(
                                                            plansState.indexOf(
                                                              plan,
                                                            ),
                                                            0,
                                                          );
                                                        // identificar paquete precargado y plan cliente
                                                        const isElite =
                                                          esPlanNoEditable(
                                                            plan,
                                                          );
                                                        const isPlanCliente =
                                                          esPlanCliente(plan);
                                                        // Promo
                                                        const promo =
                                                          obtenerPromocion(
                                                            plan,
                                                            selectedVehicleName,
                                                          );

                                                        const vehiclePrice =
                                                          toNumber(
                                                            selectedMailData?.precio_vehiculo,
                                                          );

                                                        // ====== ACCESORIOS (por tarjeta) ======
                                                        const normalizedAccessories =
                                                          (
                                                            plan?.accessories ??
                                                            []
                                                          ).map((acc) => {
                                                            const mapHit =
                                                              ACC_INDEX[
                                                                norm(acc.title)
                                                              ];
                                                            const fallback =
                                                              mapHit
                                                                ? (mapHit.price ??
                                                                  mapHit.price_promo ??
                                                                  mapHit.price_base)
                                                                : 0;

                                                            const unit =
                                                              toNumber(
                                                                acc.price ??
                                                                  acc.price_promo ??
                                                                  acc.price_base ??
                                                                  fallback,
                                                              );

                                                            const qty =
                                                              toNumber(
                                                                acc.qty ?? 1,
                                                              );

                                                            return {
                                                              ...acc,
                                                              price: unit,
                                                              qty,
                                                            };
                                                          });

                                                        const accesoriosSubtotal =
                                                          normalizedAccessories.reduce(
                                                            (sum, acc) =>
                                                              sum +
                                                              toNumber(
                                                                acc.price,
                                                              ) *
                                                                toNumber(
                                                                  acc.qty,
                                                                ),
                                                            0,
                                                          );

                                                        const accesoriosTotal =
                                                          Math.round(
                                                            accesoriosSubtotal,
                                                          );

                                                        // Total informativo (auto + accesorios)
                                                        const planTotalPrice =
                                                          Math.round(
                                                            vehiclePrice +
                                                              accesoriosTotal,
                                                          );

                                                        // ====== MENSUALIDADES (por tarjeta) ======
                                                        // Contado: MSI 0% solo accesorios/garantías
                                                        const msiMensual =
                                                          effectiveMonths
                                                            ? Math.round(
                                                                accesoriosTotal /
                                                                  effectiveMonths,
                                                              )
                                                            : 0;

                                                        // Crédito: PMT (auto + accesorios - enganche)
                                                        let monthly36 = 0;
                                                        let monthly48 = 0;

                                                        if (!isCash) {
                                                          const mensualidadObjetivo =
                                                            toNumber(
                                                              mensualidadC ||
                                                                formDataRef
                                                                  .current
                                                                  ?.mensualidad_buscada ||
                                                                monthlyPaymentDraft ||
                                                                0,
                                                            );

                                                          const esPlanSeleccionadoActual =
                                                            Boolean(
                                                              plan?.isSelected,
                                                            ) ||
                                                            (selectedPlan &&
                                                              normalizarNombrePlan(
                                                                plan,
                                                              ) ===
                                                                normalizarNombrePlan(
                                                                  selectedPlan,
                                                                ));

                                                          let downPayment =
                                                            getEngancheActual(
                                                              vehiclePrice,
                                                            );

                                                          if (
                                                            manualMonthlyOverride &&
                                                            mensualidadObjetivo >
                                                              0 &&
                                                            esPlanSeleccionadoActual &&
                                                            effectiveMonths
                                                          ) {
                                                            const valuesForTarget =
                                                              calculateFinancingValues(
                                                                {
                                                                  basePrice:
                                                                    planTotalPrice,
                                                                  monthlyPayment:
                                                                    mensualidadObjetivo,
                                                                  financingMonths:
                                                                    effectiveMonths,
                                                                  origin:
                                                                    "plan-card-mensualidad-objetivo",
                                                                },
                                                              );

                                                            downPayment =
                                                              valuesForTarget.downPaymentAmount;
                                                          }

                                                          const calcPMT = (
                                                            n,
                                                          ) => {
                                                            if (
                                                              manualMonthlyOverride &&
                                                              mensualidadObjetivo >
                                                                0 &&
                                                              esPlanSeleccionadoActual &&
                                                              Number(
                                                                effectiveMonths,
                                                              ) === Number(n)
                                                            ) {
                                                              return Math.round(
                                                                mensualidadObjetivo,
                                                              );
                                                            }

                                                            return calculateMonthlyPaymentBabilonia(
                                                              {
                                                                total:
                                                                  planTotalPrice,
                                                                months: n,
                                                                downPaymentAmount:
                                                                  downPayment,
                                                                isCashMSI: false,
                                                              },
                                                            );
                                                          };

                                                          monthly36 =
                                                            calcPMT(36);
                                                          monthly48 =
                                                            calcPMT(48);
                                                        }

                                                        return (
                                                          <div
                                                            className="col-md-6 mb-4 new-font-14"
                                                            key={planIndex}
                                                          >
                                                            <div className="card new-font-14">
                                                              <div className="card-body text-center new-font-14">
                                                                {/* Botones de intercambio */}
                                                                <PlanSwapButtons
                                                                  currentPlan={
                                                                    plan
                                                                  }
                                                                  planIndex={
                                                                    planIndex
                                                                  }
                                                                  isLocked={
                                                                    isElite
                                                                  }
                                                                />

                                                                {/* Render del plan */}
                                                                {planRender({
                                                                  plan,
                                                                  planIndex,
                                                                  isElite,
                                                                })}

                                                                {/* Mensaje de promoción */}
                                                                {promo ? (
                                                                  <div className="mt-3">
                                                                    <div className="promotion-box new-font-14">
                                                                      {
                                                                        promo.mensaje
                                                                      }
                                                                    </div>
                                                                  </div>
                                                                ) : (
                                                                  <div className="mt-2">
                                                                    <small className="text-muted">
                                                                      No aplica
                                                                      promoción
                                                                    </small>
                                                                  </div>
                                                                )}

                                                                <div className="mt-3 row text-start text-md-center g-3">
                                                                  <div className="col-12 col-md-4">
                                                                    <h6 className="black-text mb-1 new-font-14">
                                                                      Precio
                                                                      Total:
                                                                    </h6>
                                                                    <p className="mb-0 black-text fw-bold new-font-14">
                                                                      ${" "}
                                                                      {new Intl.NumberFormat(
                                                                        "es-MX",
                                                                      ).format(
                                                                        planTotalPrice,
                                                                      )}
                                                                    </p>
                                                                  </div>

                                                                  {isCash ? (
                                                                    <div className="col-12 col-md-8">
                                                                      <small className="text-muted black-text d-block mb-1 new-font-14">
                                                                        MSI
                                                                        accesorios/garantías
                                                                        a{" "}
                                                                        {
                                                                          effectiveMonths
                                                                        }{" "}
                                                                        meses:
                                                                      </small>
                                                                      <p className="mb-0 black-text fw-bold new-font-14">
                                                                        ${" "}
                                                                        {new Intl.NumberFormat(
                                                                          "es-MX",
                                                                        ).format(
                                                                          msiMensual,
                                                                        )}
                                                                      </p>
                                                                    </div>
                                                                  ) : (
                                                                    <>
                                                                      <div className="col-12 col-md-4">
                                                                        <small className="text-muted black-text d-block mb-1 new-font-14">
                                                                          Mens.
                                                                          a 36
                                                                          meses:
                                                                        </small>
                                                                        <p className="mb-0 black-text fw-bold new-font-14">
                                                                          ${" "}
                                                                          {new Intl.NumberFormat(
                                                                            "es-MX",
                                                                          ).format(
                                                                            monthly36,
                                                                          )}
                                                                        </p>
                                                                      </div>

                                                                      <div className="col-12 col-md-4">
                                                                        <small className="text-muted black-text d-block mb-1 new-font-14">
                                                                          Mens.
                                                                          a 48
                                                                          meses:
                                                                        </small>
                                                                        <p className="mb-0 black-text fw-bold new-font-14">
                                                                          ${" "}
                                                                          {new Intl.NumberFormat(
                                                                            "es-MX",
                                                                          ).format(
                                                                            monthly48,
                                                                          )}
                                                                        </p>
                                                                      </div>
                                                                    </>
                                                                  )}

                                                                  <button
                                                                    className={`new-font-14 btn ${
                                                                      plan.isSelected
                                                                        ? "btn-success"
                                                                        : "btn-primary"
                                                                    } w-100`}
                                                                    onClick={() =>
                                                                      handlePlanSelect(
                                                                        plan,
                                                                        planIndex,
                                                                      )
                                                                    }
                                                                    disabled={
                                                                      isSubmitted ||
                                                                      isPlanCliente
                                                                    }
                                                                  >
                                                                    {isPlanCliente
                                                                      ? "Plan cliente no seleccionable"
                                                                      : plan.isSelected
                                                                        ? "Plan Seleccionado"
                                                                        : "Seleccionar Plan"}
                                                                  </button>
                                                                </div>
                                                              </div>
                                                            </div>
                                                          </div>
                                                        );
                                                      })}
                                                    </div>
                                                  </DragDropContext>
                                                </div>
                                              )}

                                              {step === 7 &&
                                                (() => {
                                                  // OBTENER PROMO DEL PLAN SELECCIONADO
                                                  const planResumenSeleccionado =
                                                    selectedPlanUi ||
                                                    selectedPlanForFinancing ||
                                                    selectedPlan ||
                                                    null;
                                                  const promoSelected =
                                                    planResumenSeleccionado
                                                      ? obtenerPromocion(
                                                          planResumenSeleccionado,
                                                          selectedVehicleName,
                                                        )
                                                      : null;
                                                  const isElite =
                                                    esPlanNoEditable(
                                                      planResumenSeleccionado,
                                                    );

                                                  return (
                                                    <div
                                                      id="wizardLayout1"
                                                      className="mb-5"
                                                    >
                                                      <h4 className="black-text">
                                                        Financiamiento
                                                      </h4>
                                                      <DragDropContext
                                                        onBeforeDragStart={() => {
                                                          document.body.style.cursor =
                                                            "grabbing";
                                                        }}
                                                        onDragStart={() => {
                                                          document.body.style.cursor =
                                                            "grabbing";
                                                        }}
                                                        onDragEnd={(result) => {
                                                          document.body.style.cursor =
                                                            "default";
                                                          handleFinalDragEnd(
                                                            result,
                                                          );
                                                        }}
                                                        onError={onDragError}
                                                      >
                                                        <Card>
                                                          <CardBody>
                                                            <div className="row">
                                                              {/* Marca y Modelo del Vehículo */}
                                                              <div className="col-md-6 mb-3">
                                                                <label className="black-text new-font">
                                                                  Marca del
                                                                  Vehículo:
                                                                </label>
                                                                <input
                                                                  type="text"
                                                                  className="form-control new-font"
                                                                  value={
                                                                    selectedMailData?.marca_vehiculo ||
                                                                    ""
                                                                  }
                                                                  readOnly
                                                                />
                                                              </div>
                                                              <div className="col-md-6 mb-3">
                                                                <label className="black-text new-font">
                                                                  Modelo del
                                                                  Vehículo:
                                                                </label>
                                                                <input
                                                                  type="text"
                                                                  className="form-control new-font"
                                                                  value={
                                                                    selectedMailData?.modelo_vehiculo ||
                                                                    ""
                                                                  }
                                                                  readOnly
                                                                />
                                                              </div>
                                                            </div>

                                                            {/* Plan Seleccionado con Droppable */}
                                                            <div className="row mb-4">
                                                              <div className="col-12">
                                                                <h5 className="black-text new-font">
                                                                  Plan
                                                                  Seleccionado
                                                                </h5>
                                                                {selectedPlanUi && (
                                                                  <div className="card">
                                                                    <div className="card-body">
                                                                      <h5 className="card-title">
                                                                        {
                                                                          selectedPlanUi.title
                                                                        }
                                                                      </h5>

                                                                      <Droppable
                                                                        droppableId="selected-plan"
                                                                        isDropDisabled={
                                                                          isElite
                                                                        }
                                                                      >
                                                                        {(
                                                                          provided,
                                                                        ) => (
                                                                          <div
                                                                            ref={
                                                                              provided.innerRef
                                                                            }
                                                                            {...provided.droppableProps}
                                                                            className="accessories-container new-font"
                                                                            style={{
                                                                              backgroundColor:
                                                                                isElite
                                                                                  ? "#f8f9fa"
                                                                                  : "transparent",
                                                                              border:
                                                                                isElite
                                                                                  ? "1px solid #ddd"
                                                                                  : "1px dashed #ccc",
                                                                              opacity:
                                                                                isElite
                                                                                  ? 0.8
                                                                                  : 1,
                                                                              pointerEvents:
                                                                                isElite
                                                                                  ? "none"
                                                                                  : "auto",
                                                                              minHeight:
                                                                                "50px",
                                                                              padding:
                                                                                "10px",
                                                                              marginBottom:
                                                                                "10px",
                                                                            }}
                                                                          >
                                                                            {(
                                                                              selectedPlanUi.accessories ||
                                                                              []
                                                                            ).map(
                                                                              (
                                                                                accessory,
                                                                                index,
                                                                              ) => (
                                                                                <Draggable
                                                                                  key={`selected-${accessory.title}-${index}`}
                                                                                  draggableId={`selected-${accessory.title}-${index}`}
                                                                                  index={
                                                                                    index
                                                                                  }
                                                                                  isDragDisabled={
                                                                                    isElite
                                                                                  }
                                                                                >
                                                                                  {(
                                                                                    provided,
                                                                                    snapshot,
                                                                                  ) =>
                                                                                    renderAccessoryWithRemove(
                                                                                      {
                                                                                        accessory, // es un objeto { title, description }
                                                                                        provided,
                                                                                        snapshot,
                                                                                        uniqueId: `selected-${accessory.title}-${index}`,
                                                                                        selectedPlanIndex:
                                                                                          selectedPlanFinal,
                                                                                        removeAccessoryFromPlan:
                                                                                          isElite
                                                                                            ? null
                                                                                            : removeAccessoryFromPlan,
                                                                                      },
                                                                                    )
                                                                                  }
                                                                                </Draggable>
                                                                              ),
                                                                            )}
                                                                            {
                                                                              provided.placeholder
                                                                            }
                                                                          </div>
                                                                        )}
                                                                      </Droppable>
                                                                      {promoSelected ? ( //mostrar mensaje de promoción
                                                                        <div
                                                                          className="mt-2"
                                                                          style={{
                                                                            textAlign:
                                                                              "left",
                                                                          }}
                                                                        >
                                                                          <div className="promotion-box new-font-14">
                                                                            {
                                                                              promoSelected.mensaje
                                                                            }
                                                                          </div>
                                                                        </div>
                                                                      ) : (
                                                                        <div
                                                                          className="mt-2"
                                                                          style={{
                                                                            textAlign:
                                                                              "left",
                                                                          }}
                                                                        >
                                                                          <small className="text-muted">
                                                                            No
                                                                            aplica
                                                                            promoción
                                                                          </small>
                                                                        </div>
                                                                      )}
                                                                      <div className="text-end">
                                                                        <h6 className="black-text">
                                                                          Precio
                                                                          Total:
                                                                          $
                                                                          {new Intl.NumberFormat(
                                                                            "es-MX",
                                                                          ).format(
                                                                            Math.round(
                                                                              precioTotal,
                                                                            ),
                                                                          )}
                                                                        </h6>
                                                                      </div>
                                                                    </div>
                                                                  </div>
                                                                )}
                                                              </div>
                                                            </div>

                                                            {/* Accesorios Disponibles */}
                                                            {!isElite && (
                                                              <div className="row mb-4">
                                                                <div className="col-12">
                                                                  <h5 className="black-text new-font">
                                                                    Accesorios
                                                                    Disponibles
                                                                  </h5>
                                                                  <div className="card">
                                                                    <div className="card-body">
                                                                      <Droppable droppableId="accessories-pool">
                                                                        {(
                                                                          provided,
                                                                        ) => (
                                                                          <div
                                                                            ref={
                                                                              provided.innerRef
                                                                            }
                                                                            {...provided.droppableProps}
                                                                            className="accessories-container new-font"
                                                                            style={{
                                                                              minHeight:
                                                                                "50px",
                                                                              padding:
                                                                                "10px",
                                                                              border:
                                                                                "1px dashed #ccc",
                                                                              display:
                                                                                "flex",
                                                                              flexWrap:
                                                                                "wrap",
                                                                              justifyContent:
                                                                                "center",
                                                                              gap: "8px",
                                                                            }}
                                                                          >
                                                                            {filteredAccessoriesAndWarranties.length ===
                                                                            0 ? (
                                                                              <p>
                                                                                No
                                                                                hay
                                                                                accesorios
                                                                                ni
                                                                                garantías
                                                                                disponibles
                                                                                para
                                                                                esta
                                                                                marca.
                                                                              </p>
                                                                            ) : (
                                                                              filteredAccessoriesAndWarranties.map(
                                                                                (
                                                                                  item,
                                                                                  index,
                                                                                ) => (
                                                                                  <Draggable
                                                                                    key={`pool-${item.title}-${index}`}
                                                                                    draggableId={`pool-${item.title}-${index}`}
                                                                                    index={
                                                                                      index
                                                                                    }
                                                                                  >
                                                                                    {(
                                                                                      provided,
                                                                                    ) => (
                                                                                      <div
                                                                                        ref={
                                                                                          provided.innerRef
                                                                                        }
                                                                                        {...provided.draggableProps}
                                                                                        {...provided.dragHandleProps}
                                                                                      >
                                                                                        {renderAccessoryWithButtons(
                                                                                          {
                                                                                            accessory:
                                                                                              item,
                                                                                            key: `pool-${item.title}-${index}`,
                                                                                            selectedPlan:
                                                                                              selectedPlanUi ||
                                                                                                selectedPlanForFinancing ||
                                                                                                selectedPlan || {
                                                                                                  accessories:
                                                                                                    [],
                                                                                                },
                                                                                            onAdd:
                                                                                              () => {
                                                                                                const planIndexToUpdate =
                                                                                                  resolveSelectedPlanMutationIndex(
                                                                                                    selectedPlanFinal,
                                                                                                  );
                                                                                                if (
                                                                                                  planIndexToUpdate >=
                                                                                                  0
                                                                                                ) {
                                                                                                  addAccessoryToPlan(
                                                                                                    item,
                                                                                                    planIndexToUpdate,
                                                                                                  );
                                                                                                } else {
                                                                                                  console.warn(
                                                                                                    "No hay plan seleccionado, no se puede agregar",
                                                                                                  );
                                                                                                }
                                                                                              },
                                                                                            onRemove:
                                                                                              () => {
                                                                                                const planIndexToUpdate =
                                                                                                  resolveSelectedPlanMutationIndex(
                                                                                                    selectedPlanFinal,
                                                                                                  );
                                                                                                if (
                                                                                                  planIndexToUpdate >=
                                                                                                  0
                                                                                                ) {
                                                                                                  removeAccessoryFromPlan(
                                                                                                    item.title,
                                                                                                    planIndexToUpdate,
                                                                                                  );
                                                                                                } else {
                                                                                                  console.warn(
                                                                                                    "No hay plan seleccionado, no se puede remover",
                                                                                                  );
                                                                                                }
                                                                                              },
                                                                                          },
                                                                                        )}
                                                                                      </div>
                                                                                    )}
                                                                                  </Draggable>
                                                                                ),
                                                                              )
                                                                            )}
                                                                            {
                                                                              provided.placeholder
                                                                            }
                                                                          </div>
                                                                        )}
                                                                      </Droppable>
                                                                    </div>
                                                                  </div>
                                                                </div>
                                                              </div>
                                                            )}

                                                            {/* Resto de los campos */}
                                                            <div className="row">
                                                              {/*<div className="col-lg-6 mb-3">
                                                            <label>
                                                              Agencia
                                                            </label>
                                                            <select
                                                              id="agenciaVehiculo"
                                                              className="form-control custom-select"
                                                              onChange={
                                                                handleChange
                                                              }
                                                              value={
                                                                selectedAgencia
                                                              }
                                                            >
                                                              <option value="">
                                                                Seleccione
                                                                agencia
                                                              </option>
                                                              {agencias.map(
                                                                (agencia) => (
                                                                  <option
                                                                    key={
                                                                      agencia.ag_id
                                                                    }
                                                                    value={
                                                                      agencia.ag_id
                                                                    }
                                                                  >
                                                                    {
                                                                      agencia.nombre
                                                                    }
                                                                  </option>
                                                                )
                                                              )}
                                                            </select>
                                                          </div>*/}
                                                              <div className="col-12">
                                                                <h5 className="black-text">
                                                                  Mensualidad
                                                                  Estimada: $
                                                                  {mensualidadC
                                                                    ? new Intl.NumberFormat(
                                                                        "es-MX",
                                                                      ).format(
                                                                        Number(
                                                                          mensualidadC,
                                                                        ),
                                                                      )
                                                                    : new Intl.NumberFormat(
                                                                        "es-MX",
                                                                      ).format(
                                                                        monthlyPayment ||
                                                                          0,
                                                                      )}
                                                                </h5>
                                                              </div>
                                                            </div>
                                                          </CardBody>
                                                        </Card>
                                                      </DragDropContext>
                                                    </div>
                                                  );
                                                })()}
                                              <div
                                                className="floating-action-spacer"
                                                aria-hidden="true"
                                              />

                                              <div
                                                className="fixed-buttons floating-action-dock"
                                                ref={floatingActionsRef}
                                              >
                                                {showFloatingActions && (
                                                  <div className="floating-extra-panel">
                                                    <button
                                                      className="btn btn-info text-white px-3"
                                                      onClick={() => {
                                                        setShowFloatingActions(
                                                          false,
                                                        );
                                                        handleMostrarAccesorios();
                                                      }}
                                                    >
                                                      Accesorios y garantías
                                                    </button>

                                                    <button
                                                      className="btn btn-success px-3"
                                                      onClick={() => {
                                                        setShowFloatingActions(
                                                          false,
                                                        );
                                                        abrirFichaTecnica();
                                                      }}
                                                      disabled={
                                                        !selectedMailData ||
                                                        openFicha
                                                      }
                                                    >
                                                      Abrir PDF
                                                    </button>

                                                    <button
                                                      className="btn btn-primary px-3"
                                                      onClick={() => {
                                                        setShowFloatingActions(
                                                          false,
                                                        );
                                                        handleSimularVolverInventarioCliente();
                                                      }}
                                                      disabled={
                                                        !selectedMailData ||
                                                        isSendingClientAction
                                                      }
                                                    >
                                                      {isSendingClientAction
                                                        ? "Enviando..."
                                                        : "Volver inventario cliente"}
                                                    </button>

                                                    <button
                                                      className="btn btn-warning px-3"
                                                      onClick={() => {
                                                        setShowFloatingActions(
                                                          false,
                                                        );
                                                        handleSolicitarPruebaManejoCliente();
                                                      }}
                                                      disabled={
                                                        !selectedMailData ||
                                                        isSendingClientAction
                                                      }
                                                    >
                                                      {isSendingClientAction
                                                        ? "Enviando..."
                                                        : "Solicitar prueba manejo"}
                                                    </button>
                                                  </div>
                                                )}

                                                <div className="floating-primary-actions">
                                                  <div className="floating-nav-actions">
                                                    {step > 1 && (
                                                      <button
                                                        type="button"
                                                        className="btn btn-lg btn-secondary px-4"
                                                        onClick={
                                                          handlePreviousStep
                                                        }
                                                      >
                                                        ← Anterior
                                                      </button>
                                                    )}

                                                    {step === 1 && (
                                                      <button
                                                        type="button"
                                                        className="btn btn-lg btn-warning px-4"
                                                        onClick={
                                                          handleConfirmPlease
                                                        }
                                                        disabled={
                                                          isConfirming ||
                                                          isConfirmed
                                                        }
                                                      >
                                                        {isConfirming
                                                          ? "Enviando..."
                                                          : isConfirmed
                                                            ? "Confirmado"
                                                            : "Confirmar"}
                                                      </button>
                                                    )}

                                                    {step < 7 && (
                                                      <button
                                                        type="button"
                                                        className="btn btn-lg btn-primary px-4"
                                                        onClick={handleNextStep}
                                                        disabled={
                                                          (step === 1 &&
                                                            !datosPersonalesConfirmados) ||
                                                          (step === 2 &&
                                                            !isSaboneCompleto) ||
                                                          (step === 3 &&
                                                            !isPruebaManejoCompleta)
                                                        }
                                                      >
                                                        Siguiente →
                                                      </button>
                                                    )}

                                                    {step === 7 && (
                                                      <button
                                                        type="button"
                                                        className="btn btn-lg btn-success px-4"
                                                        onClick={
                                                          handleShowModalCotizador
                                                        }
                                                        disabled={
                                                          isSubmitting ||
                                                          isSubmitted
                                                        }
                                                      >
                                                        {isSubmitting
                                                          ? "Cotizando..."
                                                          : isSubmitted
                                                            ? "Cotizado"
                                                            : "Cotizar"}
                                                      </button>
                                                    )}
                                                  </div>

                                                  <div className="floating-extra-toggle-wrap">
                                                    <button
                                                      type="button"
                                                      className={`btn btn-lg px-4 ${
                                                        showFloatingActions
                                                          ? "btn-dark"
                                                          : "btn-outline-dark"
                                                      }`}
                                                      onClick={() =>
                                                        setShowFloatingActions(
                                                          (prev) => !prev,
                                                        )
                                                      }
                                                    >
                                                      {showFloatingActions
                                                        ? "Cerrar acciones"
                                                        : "Acciones rápidas"}
                                                    </button>
                                                  </div>
                                                </div>
                                              </div>
                                            </CardBody>
                                          </Card>
                                        </CardBody>
                                      </Card>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="col-xl-4 modal.modal-pos modal-pos-product-info">
                                <Card
                                  className={`card-content ${
                                    isMobile || isTablet
                                      ? activeCard === "cliente"
                                        ? "card-expand"
                                        : "d-none"
                                      : "card-desktop"
                                  }`}
                                >
                                  <CardHeader className="with-btn new-font">
                                    Cliente
                                    <CardHeaderBtn
                                      activeCard={activeCard}
                                      onLeftClick={() =>
                                        setActiveCard("asesor")
                                      }
                                      onRightClick={() =>
                                        setActiveCard("cliente")
                                      }
                                    />
                                  </CardHeader>
                                  <CardBody>
                                    <CardGroup className="m-n1">
                                      <Card className="m-1">
                                        <CardBody>
                                          <h5 className="card-title">
                                            <i className="fas fa-lg fa-fw me-2 fa-car"></i>
                                            Vehículo
                                          </h5>
                                          <table className="table table-striped mb-0">
                                            <tbody>
                                              <tr>
                                                <td className="black-text new-font">
                                                  Folio de Venta
                                                </td>
                                                <td className="black-text new-font folio-qr">
                                                  {selectedMailData.folio_venta}
                                                  <img
                                                    src={
                                                      selectedMailData.qr_venta
                                                    }
                                                    alt="QR Venta"
                                                    style={{
                                                      width: "50px",
                                                      height: "50px",
                                                    }}
                                                  />
                                                </td>
                                              </tr>

                                              <tr>
                                                <td className="black-text new-font">
                                                  Marca
                                                </td>
                                                <td className="black-text new-font">
                                                  {
                                                    selectedMailData.marca_vehiculo
                                                  }
                                                </td>
                                              </tr>
                                              <tr>
                                                <td className="black-text new-font">
                                                  Modelo
                                                </td>
                                                <td className="black-text new-font">
                                                  {
                                                    selectedMailData.modelo_vehiculo
                                                  }
                                                </td>
                                              </tr>
                                              <tr>
                                                <td className="black-text new-font">
                                                  Imagen
                                                </td>
                                                <td>
                                                  <img
                                                    src={getVersionImage(
                                                      selectedVersion,
                                                      selectedMailData,
                                                    )}
                                                    alt={`${selectedMailData.marca_vehiculo} ${selectedMailData.modelo_vehiculo}`}
                                                    style={{
                                                      maxWidth: "100%",
                                                      height: "auto",
                                                    }}
                                                  />
                                                </td>
                                              </tr>
                                              <tr>
                                                <td className="black-text new-font">
                                                  Año
                                                </td>
                                                <td className="black-text new-font">
                                                  {
                                                    selectedMailData.ano_vehiculo
                                                  }
                                                </td>
                                              </tr>
                                              <tr>
                                                <td className="black-text new-font">
                                                  Versión
                                                </td>
                                                <td>
                                                  <div className="option-versions new-font">
                                                    {selectedMailData?.versiones
                                                      ? JSON.parse(
                                                          selectedMailData.versiones,
                                                        ).size.map(
                                                          (version, index) => (
                                                            <div
                                                              className="option"
                                                              key={index}
                                                            >
                                                              <input
                                                                type="radio"
                                                                id={
                                                                  "version" +
                                                                  index
                                                                }
                                                                name="versionVehiculo"
                                                                className="option-input"
                                                                value={
                                                                  version.text
                                                                }
                                                                onChange={() =>
                                                                  handleVersionSelect(
                                                                    version,
                                                                  )
                                                                }
                                                                checked={coincideTextoPaquete(
                                                                  selectedVersion ||
                                                                    selectedMailData?.version_vehiculo ||
                                                                    "",
                                                                  version.text,
                                                                )}
                                                              />
                                                              <label
                                                                className="option-label"
                                                                htmlFor={
                                                                  "version" +
                                                                  index
                                                                }
                                                              >
                                                                <span className="option-text">
                                                                  {version.text}
                                                                </span>
                                                                <span className="option-price">
                                                                  $
                                                                  {Number(
                                                                    version.price,
                                                                  ).toLocaleString(
                                                                    "en-MX",
                                                                    {
                                                                      maximumFractionDigits: 0,
                                                                    },
                                                                  )}
                                                                </span>
                                                              </label>
                                                            </div>
                                                          ),
                                                        )
                                                      : null}
                                                    {/* Mensaje de recordatorio */}
                                                    {!selectedVersion && (
                                                      <div className="version-tooltip">
                                                        ⚠️ Selecciona la versión
                                                        de tu preferencia
                                                      </div>
                                                    )}
                                                  </div>
                                                </td>
                                              </tr>
                                              <tr>
                                                <td>Agencia</td>
                                                <td>
                                                  {selectedMailData.agencia}
                                                </td>
                                              </tr>
                                              <tr>
                                                <td>Condición</td>
                                                <td>
                                                  {homologarTipoAuto(
                                                    selectedMailData?.tipo_auto,
                                                  )}
                                                </td>
                                              </tr>
                                              {agenciaUsaCotizadorNR && (
                                                <tr>
                                                  <td>Producto NR</td>
                                                  <td>
                                                    {formData.nr_producto_descripcion
                                                      ? `${formData.nr_producto_descripcion} (${formData.nr_producto_id})`
                                                      : formData.nr_producto_id
                                                        ? `Producto ${formData.nr_producto_id}`
                                                        : "Pendiente"}
                                                  </td>
                                                </tr>
                                              )}
                                              <tr>
                                                <td className="black-text new-font">
                                                  Precio Vehículo
                                                </td>
                                                <td className="black-text new-font">
                                                  $
                                                  {new Intl.NumberFormat(
                                                    "es-MX",
                                                    {
                                                      style: "decimal",
                                                      minimumFractionDigits: 0,
                                                      maximumFractionDigits: 0,
                                                    },
                                                  ).format(
                                                    selectedMailData.precio_vehiculo,
                                                  )}
                                                </td>
                                              </tr>
                                              <tr>
                                                <td className="black-text new-font">
                                                  Precio Total
                                                </td>
                                                <td className="black-text new-font">
                                                  $
                                                  {new Intl.NumberFormat(
                                                    "es-MX",
                                                    {
                                                      style: "decimal",
                                                      minimumFractionDigits: 0,
                                                      maximumFractionDigits: 0,
                                                    },
                                                  ).format(
                                                    precioTotalPanelDerecho,
                                                  )}
                                                </td>
                                              </tr>
                                              <tr>
                                                <td className="black-text new-font">
                                                  {selectedMailData?.depende_auto ===
                                                  "No"
                                                    ? "Mens. con adicionales"
                                                    : "Mens. de adicionales"}
                                                </td>
                                                <td className="black-text new-font">
                                                  $
                                                  {new Intl.NumberFormat(
                                                    "es-MX",
                                                  ).format(
                                                    isCash
                                                      ? mensualConAdicionales
                                                      : mensualidadPanelDerecho,
                                                  )}
                                                </td>
                                              </tr>
                                              {selectedMailData?.depende_auto ===
                                                "No" && (
                                                <tr>
                                                  <td className="black-text new-font">
                                                    Mens. sin adicionales
                                                  </td>
                                                  <td className="black-text new-font">
                                                    {(() => {
                                                      const meses =
                                                        effectiveMonths;
                                                      const precioBase =
                                                        selectedMailData?.precio_vehiculo ??
                                                        0;
                                                      const pmt =
                                                        calculateMonthlyPaymentBabilonia(
                                                          {
                                                            total: precioBase,
                                                            months: meses,
                                                            downPaymentAmount:
                                                              getEngancheActual(
                                                                precioBase,
                                                              ),
                                                            isCashMSI: false,
                                                          },
                                                        );

                                                      return `$${new Intl.NumberFormat(
                                                        "es-MX",
                                                        {
                                                          style: "decimal",
                                                          minimumFractionDigits: 0,
                                                          maximumFractionDigits: 0,
                                                        },
                                                      ).format(pmt)}`;
                                                    })()}
                                                  </td>
                                                </tr>
                                              )}
                                            </tbody>
                                          </table>
                                          <div className="row mb-4 mt-4">
                                            <div className="col-md-6 mb-3">
                                              <label className="black-text new-font">
                                                Meses de Financiamiento:
                                              </label>
                                              <select
                                                className="form-control custom-select new-font"
                                                value={Number(effectiveMonths)}
                                                onChange={
                                                  handleFinancingMonthsChange
                                                }
                                              >
                                                {monthsOptions.map((m) => (
                                                  <option key={m} value={m}>
                                                    {m} meses
                                                  </option>
                                                ))}
                                              </select>
                                            </div>

                                            <div
                                              className="col-md-6 mb-3"
                                              style={{
                                                display:
                                                  formData.pago_contado === "Si"
                                                    ? "none"
                                                    : "block",
                                              }}
                                            >
                                              <label className="black-text new-font">
                                                Porcentaje de Enganche:
                                              </label>
                                              <input
                                                type="range"
                                                className="form-range"
                                                min={getMinDownPaymentPercentage()}
                                                max="100"
                                                value={getVisibleDownPaymentPercentage()}
                                                onChange={
                                                  handleDownPaymentChange
                                                }
                                                onTouchStart={(e) => {
                                                  handleTouchStart(e);
                                                  isDownPaymentDraggingRef.current = true;
                                                }}
                                                onTouchMove={handleTouchMove}
                                                onTouchEnd={(e) => {
                                                  handleTouchEnd(e);
                                                  handleDownPaymentCommit();
                                                }}
                                                onMouseDown={(e) => {
                                                  e.stopPropagation();
                                                  isDownPaymentDraggingRef.current = true;
                                                }}
                                                onMouseUp={
                                                  handleDownPaymentCommit
                                                }
                                                onBlur={handleDownPaymentCommit}
                                              />
                                              <span className="black-text new-font">
                                                {Math.round(
                                                  getVisibleDownPaymentPercentage(),
                                                )}
                                                %
                                              </span>
                                            </div>

                                            <div
                                              className="col-md-12 mb-3"
                                              style={{
                                                display:
                                                  formData.pago_contado === "Si"
                                                    ? "none"
                                                    : "block",
                                              }}
                                            >
                                              <label className="black-text new-font">
                                                Enganche:
                                              </label>
                                              <input
                                                type="text"
                                                inputMode="numeric"
                                                pattern="[0-9,]*"
                                                name="engancheEditable"
                                                value={
                                                  activeFinancingEdit ===
                                                  "enganche"
                                                    ? engancheDraftInput
                                                    : formData.engancheEditable ||
                                                      ""
                                                }
                                                onFocus={handleEngancheFocus}
                                                onMouseUp={(e) =>
                                                  e.preventDefault()
                                                }
                                                onChange={handleEngancheChange}
                                                onBlur={handleEngancheBlur}
                                                className="form-control new-font"
                                                placeholder="0"
                                              />
                                              {validationMessage && (
                                                <small className="text-danger">
                                                  {validationMessage}
                                                </small>
                                              )}
                                            </div>
                                          </div>
                                        </CardBody>
                                      </Card>
                                    </CardGroup>
                                  </CardBody>
                                </Card>
                              </div>
                            </div>
                          </div>
                        </div>
                      ) : (
                        <div
                          className="mailbox-detail-placeholder new-font"
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            height: "100%",
                            textAlign: "center",
                          }}
                        >
                          Seleccione un cliente para empezar venta
                        </div>
                      )}
                    </PerfectScrollbar>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div
            className="modal fade modal-fullscreen-custom"
            id="accessoryModal"
            tabIndex="-1"
            aria-labelledby="accessoryModalLabel"
            aria-hidden="true"
            data-bs-backdrop="static"
            data-bs-keyboard="false"
          >
            <div className="modal-dialog modal-fullscreen">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title" id="accessoryModalLabel">
                    Comparación de Accesorios
                  </h5>
                  <button
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                    onClick={() => {
                      isCotizadorModalOpenRef.current = false;
                      modalFinancingMonthsDirtyRef.current = false;
                      isEditingFinancingModalRef.current = false;
                      isUserEditing.current = false;
                    }}
                  ></button>
                </div>
                <DragDropContext
                  //onDragEnd={handleDragEndModal}
                  onDragStart={() => {
                    document.body.style.cursor = "grabbing";
                  }}
                  onDragUpdate={() => {
                    document.body.style.cursor = "grabbing";
                  }}
                >
                  <div className="modal-body">
                    <div className="row">
                      {/* Accesorios No Incluidos */}
                      <div className="col-md-6">
                        <h6>Accesorios No Incluidos</h6>
                        {selectedPlanUi ? (
                          <>
                            <Droppable
                              droppableId="excluded-accessories"
                              isDropDisabled={selectedPlanUiLocked}
                            >
                              {(provided) => (
                                <ul
                                  className="list-group min-h-[100px]"
                                  ref={provided.innerRef}
                                  {...provided.droppableProps}
                                  style={{ minHeight: "100px" }}
                                >
                                  {plans.filter(
                                    (plan) =>
                                      !hasAccessory(
                                        selectedPlanUi,
                                        plan.title.split(" - ")[0],
                                      ),
                                  ).length > 0 ? (
                                    plans
                                      .filter(
                                        (plan) =>
                                          !(
                                            selectedPlanUi.accessories || []
                                          ).some((acc) =>
                                            normalizarTexto(
                                              getAccTitle(acc),
                                            ).includes(
                                              normalizarTexto(
                                                plan.title.split(" - ")[0],
                                              ),
                                            ),
                                          ),
                                      )
                                      .map((plan, index) => {
                                        const accTitle = toTitleCase(
                                          plan.title.split(" - ")[0],
                                        );
                                        return (
                                          <Draggable
                                            key={`${accTitle}-${index}`}
                                            draggableId={accTitle}
                                            index={index}
                                            isDragDisabled={true}
                                          >
                                            {(provided) => (
                                              <li
                                                className="list-group-item d-flex justify-content-between align-items-center text-danger"
                                                ref={provided.innerRef}
                                                {...provided.draggableProps}
                                                {...provided.dragHandleProps}
                                              >
                                                <span>{accTitle}</span>
                                                <button
                                                  type="button"
                                                  className="btn btn-sm add-btn"
                                                  onMouseDown={(event) => {
                                                    event.stopPropagation();
                                                  }}
                                                  onPointerDown={(event) => {
                                                    event.stopPropagation();
                                                  }}
                                                  onClick={(event) => {
                                                    event.preventDefault();
                                                    event.stopPropagation();
                                                    if (selectedPlanUiLocked)
                                                      return;
                                                    addAccessoryToPlan(
                                                      plan,
                                                      resolveSelectedPlanMutationIndex(
                                                        selectedPlanFinal,
                                                      ),
                                                    );
                                                  }}
                                                  disabled={
                                                    selectedPlanUiLocked
                                                  }
                                                  title={
                                                    selectedPlanUiLocked
                                                      ? "El paquete precargado no se puede modificar"
                                                      : "Agregar al plan"
                                                  }
                                                >
                                                  +
                                                </button>
                                              </li>
                                            )}
                                          </Draggable>
                                        );
                                      })
                                  ) : (
                                    <li className="list-group-item text-muted fst-italic">
                                      Arrastra accesorios aquí para quitarlos
                                      del plan
                                    </li>
                                  )}
                                  {provided.placeholder}
                                </ul>
                              )}
                            </Droppable>
                            <h6 className="mt-3 text-end text-danger">
                              <strong>Total no incluido:</strong> $
                              {new Intl.NumberFormat("es-MX").format(
                                Math.round(
                                  parseFloat(
                                    selectedMailData?.precio_vehiculo || 0,
                                  ) +
                                    plans
                                      .filter(
                                        (plan) =>
                                          !(
                                            selectedPlanUi.accessories || []
                                          ).some(
                                            (acc) =>
                                              normalizarTexto(
                                                getAccTitle(acc),
                                              ) === normalizarTexto(plan.title),
                                          ),
                                      )
                                      .reduce(
                                        (sum, plan) =>
                                          sum +
                                          (parseFloat(
                                            plan.price.replace("$", ""),
                                          ) || 0),
                                        0,
                                      ),
                                ),
                              )}
                            </h6>
                          </>
                        ) : (
                          <p>No se ha seleccionado un plan</p>
                        )}
                      </div>

                      {/* Plan Seleccionado */}
                      <div className="col-md-6">
                        <h6>Plan Seleccionado</h6>
                        {selectedPlanUiLocked && (
                          <div className="alert alert-info py-2 mb-2">
                            Este paquete es precargado y no se puede modificar.
                          </div>
                        )}
                        {selectedPlanUi ? (
                          <>
                            <Droppable
                              droppableId="selected-plan"
                              isDropDisabled={selectedPlanUiLocked}
                            >
                              {(provided) => (
                                <ul
                                  className="list-group"
                                  ref={provided.innerRef}
                                  {...provided.droppableProps}
                                  style={{ minHeight: "100px" }}
                                >
                                  {selectedPlanUi?.accessories?.length > 0 ? (
                                    selectedPlanUi.accessories.map(
                                      (acc, index) => {
                                        const accTitleRaw =
                                          typeof acc === "object" &&
                                          acc !== null
                                            ? acc.title
                                            : acc;
                                        const accTitle = toTitleCase(
                                          accTitleRaw.split(" - ")[0],
                                        );

                                        const accData = plans.find(
                                          (p) =>
                                            toTitleCase(
                                              p.title.split(" - ")[0],
                                            ) === accTitle,
                                        );

                                        return (
                                          <Draggable
                                            key={`${accTitle}-${index}`}
                                            draggableId={accTitle}
                                            index={index}
                                            isDragDisabled={true}
                                          >
                                            {(provided) => (
                                              <li
                                                className="list-group-item d-flex justify-content-between align-items-center"
                                                ref={provided.innerRef}
                                                {...provided.draggableProps}
                                                {...provided.dragHandleProps}
                                              >
                                                <span>{accTitle}</span>
                                                <button
                                                  type="button"
                                                  className="btn btn-sm remove-btn"
                                                  onMouseDown={(event) => {
                                                    event.stopPropagation();
                                                  }}
                                                  onPointerDown={(event) => {
                                                    event.stopPropagation();
                                                  }}
                                                  onClick={(event) => {
                                                    event.preventDefault();
                                                    event.stopPropagation();
                                                    if (selectedPlanUiLocked)
                                                      return;
                                                    removeAccessoryFromPlan(
                                                      getAccTitle(acc),
                                                      resolveSelectedPlanMutationIndex(
                                                        selectedPlanFinal,
                                                      ),
                                                    );
                                                  }}
                                                  disabled={
                                                    selectedPlanUiLocked
                                                  }
                                                  title={
                                                    selectedPlanUiLocked
                                                      ? "El paquete precargado no se puede modificar"
                                                      : "Quitar del plan"
                                                  }
                                                >
                                                  −
                                                </button>
                                              </li>
                                            )}
                                          </Draggable>
                                        );
                                      },
                                    )
                                  ) : (
                                    <li className="list-group-item text-muted fst-italic">
                                      Arrastra accesorios aquí para agregarlos
                                      al plan
                                    </li>
                                  )}
                                  {provided.placeholder}
                                </ul>
                              )}
                            </Droppable>
                          </>
                        ) : (
                          <p>No se ha seleccionado un plan</p>
                        )}
                      </div>
                    </div>

                    {!esSeminuevoParaModal && (
                      <div className="row mt-4">
                        <div className="col-12">
                          <h6 className="mb-3">Garantía Extendida</h6>
                          <div
                            className={`custom-switch ${tieneGarantiaExtendida ? "active" : ""}`}
                            onClick={() =>
                              setTieneGarantiaExtendida(!tieneGarantiaExtendida)
                            }
                          >
                            <div className="switch-circle"></div>
                          </div>
                          <br />

                          <WarrantyItem
                            icon="fa-solid fa-screwdriver-wrench"
                            titulo="Motor"
                            descripcion="Cubre componentes internos del bloque, culata, sistema de lubricación y sincronización."
                            tieneGarantiaExtendida={tieneGarantiaExtendida}
                          />

                          <WarrantyItem
                            icon="fa-solid fa-gears"
                            titulo="Transmisión"
                            descripcion="Protege la caja de cambios, convertidor de par y componentes internos de tracción."
                            tieneGarantiaExtendida={tieneGarantiaExtendida}
                          />

                          <WarrantyItem
                            icon="fa-solid fa-circle-dot"
                            titulo="Dirección"
                            descripcion="Cubre la caja de dirección, bomba de asistencia y terminales de dirección."
                            tieneGarantiaExtendida={tieneGarantiaExtendida}
                          />

                          <WarrantyItem
                            icon="fa-solid fa-life-ring"
                            titulo="Frenos"
                            descripcion="Protege el servofreno, cilindro maestro, bomba de vacío y módulos de ABS."
                            tieneGarantiaExtendida={tieneGarantiaExtendida}
                          />

                          <WarrantyItem
                            icon="fa-solid fa-truck-monster"
                            titulo="Suspensión"
                            descripcion="Cubre amortiguadores, brazos de control, rótulas y resortes de suspensión."
                            tieneGarantiaExtendida={tieneGarantiaExtendida}
                          />

                          <WarrantyItem
                            icon="fa-solid fa-bolt"
                            titulo="Sistema Eléctrico"
                            descripcion="Cubre alternador, motor de arranque y el cableado principal del vehículo."
                            tieneGarantiaExtendida={tieneGarantiaExtendida}
                          />

                          <WarrantyItem
                            icon="fa-solid fa-temperature-half"
                            titulo="Sistema de Enfriamiento"
                            descripcion="Cubre radiador, bomba de agua, termostato y ventiladores del motor."
                            tieneGarantiaExtendida={tieneGarantiaExtendida}
                          />

                          <WarrantyItem
                            icon="fa-solid fa-gas-pump"
                            titulo="Sistema de Combustible"
                            descripcion="Cubre la bomba de combustible, inyectores y líneas de presión rígidas."
                            tieneGarantiaExtendida={tieneGarantiaExtendida}
                          />

                          <WarrantyItem
                            icon="fa-solid fa-snowflake"
                            titulo="Aire Acondicionado"
                            descripcion="Cubre compresor, evaporador y condensador del sistema de climatización."
                            tieneGarantiaExtendida={tieneGarantiaExtendida}
                          />

                          <WarrantyItem
                            icon="fa-solid fa-display"
                            titulo="Sistema Multimedia"
                            descripcion="Pantalla, módulo de audio y componentes electrónicos del sistema de entretenimiento."
                            tieneGarantiaExtendida={tieneGarantiaExtendida}
                          />

                          <WarrantyItem
                            icon="fa-solid fa-truck-pickup"
                            titulo="Asistencia Vial"
                            descripcion="Servicio de grúa, paso de corriente, asistencia en ruta y soporte 24/7."
                            tieneGarantiaExtendida={tieneGarantiaExtendida}
                          />

                          <p className="small fw-bold text-center warranty-disclaimer mt-4">
                            LA GARANTÍA DE MARCA NO APLICA PARA VEHÍCULOS DE USO
                            ESPECIAL, MODIFICADOS, AUTOS DE RENTA Y USO
                            COMERCIAL
                          </p>
                        </div>
                      </div>
                    )}
                  </div>
                </DragDropContext>
                <div className="modal-footer">
                  <button
                    className="btn btn-primary"
                    onClick={handleSubmit}
                    disabled={isSubmitting}
                  >
                    {isSubmitting ? "Enviando..." : "Confirmar y Enviar"}
                  </button>
                  {/* <button
                    type="button"
                    className="btn btn-primary"
                    onClick={enviarSaboneYPdf}
                  >
                    Enviar Sabone + PDF
                  </button>
                  <button
                    type="button"
                    className="btn btn-primary"
                    onClick={generarPDFEntrevistaCliente}
                  >
                    Generar PDF entrevista
                  </button> */}
                </div>
              </div>

              {mostrarModalInfo && (
                <div
                  className="modal fade show d-block modal-fullscreen-custom"
                  tabIndex="-1"
                  role="dialog"
                  style={{
                    backgroundColor: "rgba(0,0,0,0.1)",
                    backdropFilter: "blur(4px)",
                  }}
                  onClick={(e) => {
                    e.stopPropagation();
                  }}
                >
                  <div
                    className="modal-dialog modal-fullscreen"
                    role="document"
                    onClick={(e) => {
                      e.stopPropagation();
                    }}
                  >
                    <div
                      className="modal-content"
                      style={{
                        backgroundColor: "rgba(34, 56, 64)",
                      }}
                    >
                      <div className="modal-header" style={{ color: "white" }}>
                        <h5 className="modal-title">
                          Antes de rechazar la garantía...
                        </h5>
                      </div>
                      <div className="modal-body" style={{ color: "white" }}>
                        <div
                          className="p-3 rounded mt-4 modal-info"
                          style={{ backgroundColor: "#1f2e35" }}
                        >
                          <h5 className="text-warning text-center mb-3">
                            ¡Garantiza hoy, maneja tranquilo mañana!
                          </h5>
                          <br></br>
                          <div className="row">
                            <div className="col-md-6">
                              <ul className="text-light text-base list-unstyled">
                                <li className="card-hover d-flex align-items-start">
                                  <i className="fa-solid fa-circle-dot text-success me-2 mt-1 icon-sm"></i>
                                  <span>
                                    <strong>Rines:</strong> La reparación puede
                                    costarte al menos $3,500.00, pero reemplazar
                                    un rin nuevo de 16” puede ir de $4,800 hasta
                                    $5,000*. ¿Vas a correr ese riesgo?
                                    ¡Protégete ahora con los planes 5000 y
                                    12000!
                                    <sup>¹</sup>
                                  </span>
                                </li>

                                <li className="card-hover d-flex align-items-start mb-3">
                                  <i className="fa-solid fa-car-side text-success me-2 mt-1 icon-sm"></i>
                                  <span>
                                    <strong>Movilidad:</strong> Rentar un auto
                                    subcompacto por 30 días cuesta desde
                                    $27,000. La cobertura garantiza movilidad
                                    continua.
                                    <sup>²</sup>
                                  </span>
                                </li>

                                <li className="card-hover d-flex align-items-start mb-3">
                                  <i className="fa-solid fa-screwdriver-wrench text-success me-2 mt-1 icon-sm"></i>
                                  <span>
                                    <strong>Reparaciones mayores:</strong>{" "}
                                    Reparar un motor puede costar entre $68,000
                                    y $119,000.<sup>³</sup>
                                  </span>
                                </li>
                              </ul>
                            </div>
                            <div className="col-md-6">
                              <ul className="text-light text-base list-unstyled">
                                <li className="card-hover d-flex align-items-start mb-3">
                                  <i className="fa-solid fa-circle-exclamation text-success me-2 mt-1 icon-sm"></i>
                                  <span>
                                    <strong>Neumáticos:</strong> Reventar 2
                                    puede costarte al menos $6,800.00. Con
                                    cobertura, no pagas nada.
                                  </span>
                                </li>

                                <li className="card-hover d-flex align-items-start mb-3">
                                  <i className="fa-solid fa-triangle-exclamation text-success me-2 mt-1 icon-sm"></i>
                                  <span>
                                    <strong>Averías mecánicas:</strong> En
                                    promedio se pagan más de $38,000 por
                                    siniestro. Con garantía, ese monto no saldrá
                                    de tu bolsillo.
                                  </span>
                                </li>

                                <li className="card-hover d-flex align-items-start mb-3">
                                  <i className="fa-solid fa-key text-success me-2 mt-1 icon-sm"></i>
                                  <span>
                                    <strong>Llaves perdidas:</strong> Reponerlas
                                    puede costarte hasta $6,000.00. Con
                                    cobertura, no pagas nada.
                                  </span>
                                </li>
                              </ul>
                            </div>
                          </div>
                          <p>
                            <sup>¹</sup> Precio promedio para sedanes como
                            Versa, MG5, Virtus, Aveo, etc.
                            <br />
                            <sup>²</sup> Precio promedio por día de $900.00 para
                            renta de un subcompacto de 4 puertas.
                            <br />
                            <sup>³</sup> Por reparación de vehículos de uso
                            común, el precio de reemplazo de motor puede ser
                            significativamente mayor.
                          </p>
                        </div>

                        <div>
                          <div className="row mt-4">
                            <h5 className="text-warning text-center mb-5">
                              ¿Cuánto podrías perder sin una garantía?
                            </h5>
                            <div className="col-md-6">
                              <h6>(%) Siniestralidad de Llantas por Año</h6>
                              <ResponsiveContainer width="100%" height={300}>
                                <LineChart
                                  data={llantasData}
                                  margin={{
                                    top: 10,
                                    right: 20,
                                    left: 20,
                                    bottom: 10,
                                  }}
                                >
                                  <CartesianGrid strokeDasharray="3 3" />
                                  <XAxis
                                    dataKey="year"
                                    stroke="var(--axis-stroke)"
                                  />
                                  <YAxis unit="%" stroke="var(--axis-stroke)" />
                                  <Tooltip formatter={(value) => `${value}%`} />
                                  <Legend />
                                  <Line
                                    type="monotone"
                                    dataKey="siniestralidad"
                                    stroke="#dc3545"
                                    name="Siniestralidad"
                                    label={renderLineLabel}
                                  />
                                </LineChart>
                              </ResponsiveContainer>
                              <p className="text-light text-center mt-2 text-base">
                                En promedio, más del 57% de los autos con
                                cobertura de llantas presentan un siniestro cada
                                año.
                              </p>
                            </div>

                            <div className="col-md-6">
                              <h6>Costo Promedio por Siniestro (Llantas)</h6>
                              <ResponsiveContainer width="100%" height={300}>
                                <BarChart data={llantasData}>
                                  <CartesianGrid strokeDasharray="3 3" />
                                  <XAxis
                                    dataKey="year"
                                    stroke="var(--axis-stroke)"
                                  />
                                  <YAxis
                                    stroke="var(--axis-stroke)"
                                    tickFormatter={formatCurrency}
                                  />
                                  <Tooltip
                                    formatter={(value) => formatCurrency(value)}
                                  />
                                  <Legend />
                                  <Bar
                                    dataKey="costo"
                                    fill="#28a745"
                                    name="Costo Promedio"
                                    label={renderBarLabel}
                                  />
                                </BarChart>
                              </ResponsiveContainer>
                              <p className="text-light text-center mt-2 text-base">
                                Reparar dos llantas puede costarte más de
                                $3,000. Con garantía, tú pagas $0.
                              </p>
                            </div>

                            <div className="col-md-6 mt-4">
                              <h6>(%) Siniestralidad Cobertura Mecánica</h6>
                              <ResponsiveContainer width="100%" height={300}>
                                <LineChart
                                  data={mecanicaData}
                                  margin={{
                                    top: 10,
                                    right: 20,
                                    left: 20,
                                    bottom: 10,
                                  }}
                                >
                                  <CartesianGrid strokeDasharray="3 3" />
                                  <XAxis
                                    dataKey="year"
                                    stroke="var(--axis-stroke)"
                                  />
                                  <YAxis unit="%" stroke="var(--axis-stroke)" />
                                  <Tooltip formatter={(value) => `${value}%`} />
                                  <Legend />
                                  <Line
                                    type="monotone"
                                    dataKey="siniestralidad"
                                    stroke="#007bff"
                                    name="Siniestralidad"
                                    label={renderLineLabel}
                                  />
                                </LineChart>
                              </ResponsiveContainer>
                              <p className="text-light text-center mt-2 text-base">
                                La siniestralidad mecánica alcanzó el 79% en
                                2024. Eso significa que 8 de cada 10 autos
                                necesitaron reparación.
                              </p>
                            </div>

                            <div className="col-md-6 mt-4">
                              <h6>Costo Promedio por Siniestro (Mecánica)</h6>
                              <ResponsiveContainer width="100%" height={300}>
                                <BarChart data={mecanicaData}>
                                  <CartesianGrid strokeDasharray="3 3" />
                                  <XAxis
                                    dataKey="year"
                                    stroke="var(--axis-stroke)"
                                  />
                                  <YAxis
                                    stroke="var(--axis-stroke)"
                                    tickFormatter={formatCurrency}
                                  />
                                  <Tooltip
                                    formatter={(value) => formatCurrency(value)}
                                  />
                                  <Legend />
                                  <Bar
                                    dataKey="costo"
                                    fill="#ffc107"
                                    name="Costo Promedio"
                                    label={renderBarLabel}
                                  />
                                </BarChart>
                              </ResponsiveContainer>
                              <p className="text-light text-center mt-2 text-base">
                                El costo promedio de una reparación mecánica en
                                2024 fue de $38,575. Con garantía, tú no pagas
                                nada.
                              </p>
                            </div>

                            <div className="col-md-6 mt-4">
                              <h6>Evolución del costo de reparaciones</h6>
                              <ResponsiveContainer width="100%" height={350}>
                                <BarChart
                                  data={reparacionesData}
                                  margin={{
                                    top: 20,
                                    right: 30,
                                    left: 20,
                                    bottom: 10,
                                  }}
                                >
                                  <CartesianGrid
                                    strokeDasharray="3 3"
                                    stroke="#444"
                                  />
                                  <XAxis
                                    dataKey="year"
                                    stroke="var(--axis-stroke)"
                                  />
                                  <YAxis
                                    stroke="var(--axis-stroke)"
                                    tickFormatter={formatCurrency}
                                  />
                                  <Tooltip
                                    formatter={(value) => formatCurrency(value)}
                                  />
                                  <Legend />
                                  <Bar
                                    dataKey="costo"
                                    name="Costo de Reparaciones"
                                    label={renderBarLabel}
                                  >
                                    {reparacionesData.map((entry, index) => (
                                      <Cell
                                        key={`bar-${index}`}
                                        fill={entry.color}
                                      />
                                    ))}
                                  </Bar>
                                </BarChart>
                              </ResponsiveContainer>
                              <p className="text-light text-center mt-2 text-base">
                                En los últimos 3 años, el costo de reparación ha
                                aumentado hasta 2.4 veces. La cobertura evita
                                que estos aumentos afecten tu bolsillo.
                              </p>
                            </div>

                            <div className="col-md-6 mt-4">
                              <h6>Evolución de Siniestralidad</h6>
                              <ResponsiveContainer width="100%" height={350}>
                                <PieChart>
                                  <Tooltip formatter={(value) => `${value}%`} />
                                  <Legend />
                                  <Pie
                                    data={siniestralidadData}
                                    dataKey="value"
                                    nameKey="name"
                                    cx="50%"
                                    cy="50%"
                                    outerRadius={120}
                                    label={({ value }) => `${value}%`}
                                  >
                                    {siniestralidadData.map((entry, index) => (
                                      <Cell
                                        key={`cell-${index}`}
                                        fill={entry.color}
                                      />
                                    ))}
                                  </Pie>
                                </PieChart>
                              </ResponsiveContainer>
                              <p className="text-light text-center mt-2 text-base">
                                La siniestralidad global ha ido en aumento. No
                                es una posibilidad remota: es una realidad cada
                                vez más común.
                              </p>
                            </div>
                          </div>
                        </div>

                        <div className="alert alert-warning text-center mt-4">
                          <strong>
                            ¿Estás completamente seguro de rechazar la garantía?
                          </strong>
                        </div>
                      </div>
                      {/* <div className="modal-footer">
              <button
                className="btn btn-primary"
                onClick={handleSubmit} 
                disabled={isSubmitting}
              >
                {isSubmitting ? "Enviando..." : "Finalizar venta"}
              </button>
            </div> */}
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>

          {modalOpen &&
            (() => {
              const selectedPlan = accessoryModalPlan ||
                accessoryModalPlanSnapshot ||
                selectedPlanForModal ||
                selectedPlanForFinancing ||
                selectedPlan || { title: "Plan seleccionado", accessories: [] };

              const modalPlanIndexForMutation =
                accessoryModalPlanIndexResolved >= 0
                  ? accessoryModalPlanIndexResolved
                  : resolveSelectedPlanMutationIndex();
              const promo = selectedPlan
                ? obtenerPromocion(selectedPlan, selectedVehicleName)
                : null;

              const vehiclePrice = toNumber(selectedMailData?.precio_vehiculo);

              // normaliza cada accesorio del plan abierto en modal
              const normalizedAccs = (selectedPlan?.accessories ?? []).map(
                (acc) => ({
                  ...acc,
                  price: getUnitPrice(acc),
                  qty: toNumber(acc.qty ?? 1),
                }),
              );

              const accesoriosSubtotal = normalizedAccs.reduce(
                (sum, a) => sum + toNumber(a.price) * toNumber(a.qty),
                0,
              );

              // ====== NUEVO: contado = MSI solo accesorios/garantías (3/6/9) ======

              // total accesorios + garantías (solo esto se va a MSI si es contado)
              const accesoriosTotal = Math.round(accesoriosSubtotal);

              // total informativo (auto + accesorios)
              const planTotalPrice = Math.round(vehiclePrice + accesoriosTotal);

              // si cambia a contado y traía 36/48/etc, aquí se ajusta a 3 para el cálculo
              const currentMonths = monthsOptions.includes(financingMonths)
                ? financingMonths
                : monthsOptions[0];

              // mensualidad final a mostrar en este modal
              let monthlySelected = 0;

              let monthly36 = 0;
              let monthly48 = 0;

              if (isCash) {
                // MSI: 0% interés solo accesorios/garantías
                monthlySelected = Math.round(accesoriosTotal / currentMonths);
              } else {
                // Crédito: PMT con enganche fijo de la venta.
                const downPayment = getEngancheActual(vehiclePrice);

                const calcPMT = (n) =>
                  calculateMonthlyPaymentBabilonia({
                    total: planTotalPrice,
                    months: n,
                    downPaymentAmount: downPayment,
                    isCashMSI: false,
                  });

                monthly36 = calcPMT(36);
                monthly48 = calcPMT(48);

                // el que realmente usarías si conectas el select a monthsOptions
                monthlySelected = calcPMT(currentMonths);
              }

              const accessoryModalMarkup = (
                <div
                  key={`accessory-modal-${accessoryModalPlanKey || modalPlanIndexForMutation}-${modalPlanIndexForMutation}`}
                  className="modal fade show d-block"
                  tabIndex="-1"
                  role="dialog"
                  style={{
                    position: "fixed",
                    inset: 0,
                    display: "block",
                    overflowX: "hidden",
                    overflowY: "auto",
                    backgroundColor: "rgba(0, 0, 0, 0.5)",
                    zIndex: 1000600,
                  }}
                  onMouseDown={(event) => {
                    event.stopPropagation();
                  }}
                >
                  <div
                    className="modal-dialog modal-fullscreen"
                    role="document"
                  >
                    <div className="modal-content modal-accessory">
                      <div className="modal-header">
                        <h5 className="modal-title">Accesorios del Plan</h5>
                        <button
                          type="button"
                          className="btn-close"
                          onClick={(event) => {
                            event.preventDefault();
                            event.stopPropagation();
                            closeAccessoryModal();
                          }}
                        ></button>
                      </div>

                      <div className="modal-body">
                        <div className="row">
                          {/* Accesorios: productos de interés y disponibles */}
                          <div className="col-md-9">
                            {/* Productos de Interés */}
                            <div className="col-md-12 mb-4">
                              <div className="card">
                                <div className="card-body text-center">
                                  <h5 className="card-title">
                                    Productos de Interés
                                  </h5>
                                  <div
                                    className="accessories-container"
                                    style={{
                                      minHeight: "50px",
                                      padding: "10px",
                                      border: "1px dashed #ccc",
                                      display: "flex",
                                      flexWrap: "wrap",
                                      justifyContent: "center",
                                      gap: "8px",
                                    }}
                                  >
                                    {plans.length === 0 ? (
                                      <p>No hay productos de interés.</p>
                                    ) : (
                                      plans.map((plan, index) => {
                                        return renderAccessoryWithButtons({
                                          accessory: plan,
                                          key: `plan-${plan.title}-${index}`,
                                          onRemove: () =>
                                            removeAccessoryFromPlan(
                                              plan.title,
                                              modalPlanIndexForMutation,
                                            ),
                                          onAdd: () =>
                                            addAccessoryToPlan(
                                              plan,
                                              modalPlanIndexForMutation,
                                            ),
                                          selectedPlan,
                                          disabled: accessoryModalPlanLocked,
                                        });
                                      })
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>

                            {/* Accesorios Disponibles trabajandooo */}
                            <div className="col-md-12 mb-4">
                              <div className="card">
                                <div className="card-body text-center">
                                  <h5 className="card-title">
                                    Accesorios Disponibles
                                  </h5>
                                  <div
                                    className="accessories-container"
                                    style={{
                                      minHeight: "50px",
                                      padding: "10px",
                                      border: "1px dashed #ccc",
                                      display: "flex",
                                      flexWrap: "wrap",
                                      justifyContent: "center",
                                      gap: "8px",
                                    }}
                                  >
                                    {[
                                      ...filteredAccessoriesAndWarranties.filter(
                                        (item) =>
                                          !eliminatedAccessories.some(
                                            (el) => el.title === item.title,
                                          ),
                                      ),
                                      ...eliminatedAccessories,
                                    ].length === 0 ? (
                                      <p>
                                        No hay accesorios ni garantías
                                        disponibles para esta marca.
                                      </p>
                                    ) : (
                                      [
                                        ...filteredAccessoriesAndWarranties.filter(
                                          (item) =>
                                            !eliminatedAccessories.some(
                                              (el) => el.title === item.title,
                                            ),
                                        ),
                                        ...eliminatedAccessories,
                                      ].map((item, index) =>
                                        renderAccessoryWithButtons({
                                          accessory: item,
                                          type: item.type,
                                          uniqueId: `accessory-${item.title}-${index}`,
                                          onRemove: () =>
                                            removeAccessoryFromPlan(
                                              item.title,
                                              modalPlanIndexForMutation,
                                            ),
                                          onAdd: () =>
                                            addAccessoryToPlan(
                                              item,
                                              modalPlanIndexForMutation,
                                            ),
                                          provided: {},
                                          snapshot: {},
                                          selectedPlan,
                                          disabled: accessoryModalPlanLocked,
                                        }),
                                      )
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          {/* Resumen del Plan */}
                          <div className="col-md-3">
                            <div className="card h-100">
                              <div
                                className="card-header text-center fw-bold"
                                style={{ fontSize: "15px" }}
                              >
                                Plan Modificado
                              </div>
                              <div className="card-body d-flex flex-column">
                                <h5 className="text-center mb-3">
                                  {selectedPlan?.title || "Sin título"}
                                </h5>

                                {selectedPlan?.accessories?.length > 0 ? (
                                  <ul className="list-group mb-3">
                                    {selectedPlan.accessories.map((acc, i) => (
                                      <li
                                        key={i}
                                        className="list-group-item d-flex justify-content-between"
                                      >
                                        <span>
                                          {toTitleCase(
                                            acc.title.split(" - ")[0],
                                          )}
                                        </span>
                                        <button
                                          type="button"
                                          className="btn btn-sm remove-btn ms-2"
                                          disabled={accessoryModalPlanLocked}
                                          style={{
                                            display: accessoryModalPlanLocked
                                              ? "none"
                                              : undefined,
                                          }}
                                          onClick={() =>
                                            removeAccessoryFromPlan(
                                              typeof acc === "object" && acc
                                                ? acc.title
                                                : acc,
                                              modalPlanIndexForMutation,
                                            )
                                          }
                                          title="Quitar accesorio" //aqui
                                        >
                                          −
                                        </button>
                                      </li>
                                    ))}
                                  </ul>
                                ) : (
                                  <p className="text-muted text-center">
                                    Sin accesorios
                                  </p>
                                )}

                                {/* Mensaje de promoción */}
                                {promo ? (
                                  <div className="mt-2">
                                    <div className="promotion-box new-font-14 text-center">
                                      {promo.mensaje}
                                    </div>
                                  </div>
                                ) : (
                                  <div className="mt-2 text-center">
                                    <small className="text-muted">
                                      No aplica promoción
                                    </small>
                                  </div>
                                )}

                                <hr />
                                <div className="row text-start text-md-center g-3">
                                  <div className="col-12 col-md-4">
                                    <h6 className="black-text mb-1">
                                      Precio Total:
                                    </h6>
                                    <p className="mb-0 black-text fw-bold">
                                      ${" "}
                                      {new Intl.NumberFormat("es-MX").format(
                                        planTotalPrice,
                                      )}
                                    </p>
                                  </div>

                                  {isCash ? (
                                    <div className="col-12 col-md-8">
                                      <small className="text-muted black-text d-block mb-1">
                                        MSI accesorios/garantías a{" "}
                                        {currentMonths} meses:
                                      </small>
                                      <p className="mb-0 black-text fw-bold">
                                        ${" "}
                                        {new Intl.NumberFormat("es-MX").format(
                                          Math.round(
                                            accesoriosTotal / currentMonths,
                                          ),
                                        )}
                                      </p>
                                    </div>
                                  ) : (
                                    <>
                                      <div className="col-12 col-md-4">
                                        <small className="text-muted black-text d-block mb-1">
                                          Mens. a 36 meses:
                                        </small>
                                        <p className="mb-0 black-text fw-bold">
                                          ${" "}
                                          {new Intl.NumberFormat(
                                            "es-MX",
                                          ).format(monthly36)}
                                        </p>
                                      </div>

                                      <div className="col-12 col-md-4">
                                        <small className="text-muted black-text d-block mb-1">
                                          Mens. a 48 meses:
                                        </small>
                                        <p className="mb-0 black-text fw-bold">
                                          ${" "}
                                          {new Intl.NumberFormat(
                                            "es-MX",
                                          ).format(monthly48)}
                                        </p>
                                      </div>
                                    </>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              );

              return typeof document === "undefined"
                ? accessoryModalMarkup
                : createPortal(accessoryModalMarkup, document.body);
            })()}

          {/* Modal Resumen venta e inputs de cotización */}
          <div
            className="modal fade modal-blur"
            id="cotizadorModal"
            tabIndex="-1"
            aria-hidden="true"
            data-bs-backdrop="static"
            data-bs-keyboard="false"
          >
            <div className="modal-dialog modal-xl modal-dialog-centered">
              <div className="modal-content">
                <div className="modal-header modal-cot">
                  <h5 className="modal-title tittle-cot">
                    Resumen de la Cotización
                  </h5>
                  <button
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                    onClick={() => {
                      isCotizadorModalOpenRef.current = false;
                      modalFinancingMonthsDirtyRef.current = false;
                      isEditingFinancingModalRef.current = false;
                      isUserEditing.current = false;
                    }}
                  ></button>
                </div>

                <div className="modal-body">
                  <div className="row">
                    {/* Columna izquierda: Resumen trabajando hoy*/}
                    <div className="col-md-6 border-end pe-3">
                      <h5>
                        Datos del Vehículo
                        <i className="fas fa-car fa-lg fa-fw ms-2 icon-cot"></i>
                      </h5>
                      <ul className="list-group">
                        <li className="list-group-item">
                          <strong>Marca / Modelo:</strong>{" "}
                          {selectedMailData?.marca_vehiculo}{" "}
                          {selectedMailData?.modelo_vehiculo}
                        </li>
                        <li className="list-group-item">
                          <strong>Año:</strong> {selectedMailData?.ano_vehiculo}
                        </li>
                        <li className="list-group-item">
                          <strong>Versión:</strong>{" "}
                          {selectedMailData?.version_vehiculo}
                        </li>
                        <li className="list-group-item">
                          <strong>Precio Vehículo:</strong>{" "}
                          {!isEditingPrice ? (
                            <span
                              onClick={() => {
                                const currentPrice =
                                  selectedMailData?.precio_vehiculo?.toString() ||
                                  "";

                                setOriginalPrice(currentPrice);

                                setTempPrice(currentPrice);

                                setIsEditingPrice(true);
                              }}
                              style={{
                                cursor: "pointer",
                                borderBottom: "1px dashed #999",
                              }}
                              title="Click para editar"
                            >
                              {formatCurrency(
                                selectedMailData?.precio_vehiculo,
                              )}
                            </span>
                          ) : (
                            <input
                              type="text"
                              autoFocus
                              inputMode="decimal"
                              className="form-control mt-2"
                              value={formatInputCurrency(tempPrice)}
                              placeholder="$ 0.00"
                              onChange={(e) => {
                                let rawValue = e.target.value.replace(
                                  /[$,]/g,
                                  "",
                                );

                                rawValue = rawValue.replace(/[^0-9.]/g, "");

                                const parts = rawValue.split(".");

                                if (parts.length > 2) return;

                                setTempPrice(rawValue);
                              }}
                              onBlur={handlePriceUpdate}
                              onKeyDown={(e) => {
                                if (e.key === "Enter") {
                                  handlePriceUpdate();
                                }

                                if (e.key === "Escape") {
                                  setIsEditingPrice(false);
                                }
                              }}
                            />
                          )}
                        </li>
                        <li className="list-group-item">
                          <strong>Enganche:</strong>{" "}
                          {formatCurrency(
                            modalEngancheInput !== null &&
                              modalEngancheInput !== ""
                              ? toNumber(modalEngancheInput)
                              : engancheC !== null && engancheC !== ""
                                ? toNumber(engancheC)
                                : toNumber(formData.enganche || 0),
                          )}
                        </li>
                        <li className="list-group-item">
                          <strong>Mensualidad:</strong>{" "}
                          {formatCurrency(
                            modalMensualidadInput !== null &&
                              modalMensualidadInput !== ""
                              ? toNumber(modalMensualidadInput)
                              : mensualidadC !== null && mensualidadC !== ""
                                ? toNumber(mensualidadC)
                                : toNumber(monthlyPayment || 0),
                          )}
                        </li>
                        <li className="list-group-item p-0">
                          <div
                            className="d-flex justify-content-between align-items-center p-3"
                            style={{ cursor: "pointer" }}
                            onClick={() => setVerAccesorios(!verAccesorios)}
                          >
                            <div>
                              <strong>Precio Paquete: </strong>{" "}
                              {formatCurrencyExact(precioPaqueteModalExacto)}
                            </div>
                            <div
                              style={{
                                color: "#000",
                                fontWeight: "bold",
                                fontSize: "1.2rem",
                                width: "20px",
                                textAlign: "center",
                              }}
                            >
                              {verAccesorios ? "−" : "+"}
                            </div>
                          </div>

                          {/* Contenido Desplegable con Scroll */}
                          {verAccesorios && (
                            <div className="border-top animate__animated animate__fadeIn">
                              {/* Plan */}
                              <div className="px-4 pt-3 pb-2">
                                <span
                                  className="badge rounded-pill"
                                  style={{
                                    fontSize: "0.65rem",
                                    letterSpacing: "1px",
                                    backgroundColor: "#00366f",
                                  }}
                                >
                                  {selectedPlanForModal?.title?.toUpperCase()}
                                </span>
                              </div>

                              {/* Contenedor del Scroll */}
                              <div
                                style={{
                                  maxHeight: "200px",
                                  overflowY: "auto",
                                  overflowX: "hidden",
                                }}
                              >
                                <ul className="list-group list-group-flush bg-transparent">
                                  {selectedPlanForModal?.accessories?.length >
                                  0 ? (
                                    selectedPlanForModal.accessories.map(
                                      (item, index) => (
                                        <li
                                          key={index}
                                          className="list-group-item d-flex justify-content-between border-0 py-2 px-4 bg-transparent"
                                        >
                                          <div style={{ flex: 1 }}>
                                            <small
                                              className="text-dark d-block fw-semibold"
                                              style={{ lineHeight: "1.2" }}
                                            >
                                              {item.title.split(" - ")[0]}
                                            </small>
                                          </div>
                                          <div className="ms-3 text-end">
                                            <small className="fw-bold text-dark">
                                              {formatCurrency(item.price)}
                                            </small>
                                          </div>
                                        </li>
                                      ),
                                    )
                                  ) : (
                                    <li className="list-group-item border-0 py-3 text-center text-muted small italic bg-transparent">
                                      No hay elementos en este paquete.
                                    </li>
                                  )}
                                </ul>
                              </div>
                              <div
                                className="border-bottom"
                                style={{
                                  height: "10px",
                                  background:
                                    "linear-gradient(to bottom, rgba(0,0,0,0.02), transparent)",
                                }}
                              ></div>
                            </div>
                          )}
                        </li>
                        <li className="list-group-item">
                          <strong>Precio Total:</strong>{" "}
                          {formatCurrencyExact(
                            precioTotalModalExacto ||
                              selectedMailData?.precio_total,
                          )}
                        </li>
                        <li className="list-group-item">
                          <strong>
                            {isCash
                              ? "Meses MSI (adicionales):"
                              : "Meses de Financiamiento:"}
                          </strong>{" "}
                          {modalFinancingMonthsSelectValue} meses
                        </li>

                        <li className="list-group-item">
                          <strong>Forma de Pago:</strong>{" "}
                          {formData.pago_contado === "Si"
                            ? "Contado"
                            : formData.pago_contado === "No"
                              ? "Crédito"
                              : "N/A"}
                        </li>
                      </ul>

                      {agenciaUsaCotizadorNR && (
                      <div className="card border-primary mt-3 shadow-sm nr-resultado-card">
                        <div className="card-header py-2 bg-primary text-white d-flex justify-content-between align-items-center flex-wrap gap-2">
                          <strong>
                            <i className="fas fa-calculator me-2"></i>
                            Resultado Procotiza NR
                          </strong>
                          <div className="d-flex flex-column align-items-end gap-1">
                            <span className="badge bg-light text-primary">
                              {isNrCurrentQuoteSaved
                                ? nrCotizacionPortalId
                                  ? `Guardada · Portal ${nrCotizacionPortalId}`
                                  : `Guardada · ID ${nrCotizacionGuardadaId}`
                                : nrCotizacion
                                  ? "Cotizada · pendiente de guardar"
                                  : nrCotizacionGuardadaId
                                    ? "Datos modificados"
                                    : "Pendiente"}
                            </span>
                            {isNrCurrentQuoteSaved && nrCotizacionPortalId && (
                              <span
                                className="badge bg-light text-muted"
                                style={{ fontWeight: 400 }}
                              >
                                ID interno NR: {nrCotizacionGuardadaId}
                              </span>
                            )}
                          </div>
                        </div>

                        <div className="card-body py-3">
                          <div className="row g-2">
                            <div className="col-6 col-lg-4">
                              <div className="border rounded p-2 h-100 bg-light">
                                <small className="text-muted d-block">
                                  Pre mensualidad Babilonia
                                </small>
                                <strong>
                                  {formatCurrencyExact(
                                    toNumber(
                                      modalMensualidadInput ||
                                        mensualidadC ||
                                        formData.mensualidad_buscada ||
                                        getCurrentMonthlyPayment(),
                                    ),
                                  )}
                                </strong>
                              </div>
                            </div>

                            <div className="col-6 col-lg-4">
                              <div className="border border-primary rounded p-2 h-100 bg-white">
                                <small className="text-primary d-block">
                                  Mensualidad total NR
                                </small>
                                <strong className="text-primary">
                                  {nrCotizacion
                                    ? formatCurrencyExact(
                                        nrMensualidadOficial,
                                      )
                                    : "Pendiente"}
                                </strong>
                              </div>
                            </div>

                            <div className="col-6 col-lg-4">
                              <div className="border rounded p-2 h-100">
                                <small className="text-muted d-block">
                                  Pago inicial NR
                                </small>
                                <strong>
                                  {nrCotizacion
                                    ? formatCurrencyExact(
                                        nrPagoInicialOficial,
                                      )
                                    : "Pendiente"}
                                </strong>
                              </div>
                            </div>

                            <div className="col-6 col-lg-4">
                              <div className="border rounded p-2 h-100">
                                <small className="text-muted d-block">
                                  Monto a financiar NR
                                </small>
                                <strong>
                                  {nrCotizacion
                                    ? formatCurrencyExact(
                                        nrMontoFinanciarOficial,
                                      )
                                    : "Pendiente"}
                                </strong>
                              </div>
                            </div>

                            <div className="col-6 col-lg-4">
                              <div className="border rounded p-2 h-100">
                                <small className="text-muted d-block">
                                  Tasa oficial NR
                                </small>
                                <strong>
                                  {nrTasaPaqueteReal != null
                                    ? `${Number(nrTasaPaqueteReal.toFixed(2))}%`
                                    : nrCotizacion && nrTasaOficial > 0
                                      ? `${Number(
                                          nrTasaOficial.toFixed(2),
                                        )}%`
                                      : "Pendiente"}
                                </strong>
                              </div>
                            </div>

                            <div className="col-6 col-lg-4">
                              <div className="border rounded p-2 h-100">
                                <small className="text-muted d-block">
                                  Comisión de apertura
                                </small>
                                <strong>
                                  {nrCotizacion
                                    ? formatCurrencyExact(
                                        nrMontoComisionApertura,
                                      )
                                    : "Pendiente"}
                                </strong>
                              </div>
                            </div>

                            <div className="col-6 col-lg-4">
                              <div className="border rounded p-2 h-100">
                                <small className="text-muted d-block">
                                  Pago de la unidad
                                </small>
                                <strong>
                                  {nrCotizacion
                                    ? formatCurrencyExact(
                                        nrPagoUnidadOficial,
                                      )
                                    : "Pendiente"}
                                </strong>
                              </div>
                            </div>

                            <div className="col-6 col-lg-4">
                              <div className="border rounded p-2 h-100">
                                <small className="text-muted d-block">
                                  Seguro de vida mensual
                                </small>
                                <strong>
                                  {nrCotizacion
                                    ? formatCurrencyExact(
                                        nrPagoSeguroVida,
                                      )
                                    : "Pendiente"}
                                </strong>
                              </div>
                            </div>

                            <div className="col-6 col-lg-4">
                              <div className="border rounded p-2 h-100">
                                <small className="text-muted d-block">
                                  Seguro del vehículo
                                </small>
                                <strong>
                                  {nrCotizacion
                                    ? formatCurrencyExact(
                                        nrPagoSeguroVehiculo,
                                      )
                                    : "Pendiente"}
                                </strong>
                              </div>
                            </div>

                            <div className="col-6 col-lg-4">
                              <div className="border rounded p-2 h-100">
                                <small className="text-muted d-block">
                                  Pago mensual de CxA
                                </small>
                                <strong>
                                  {nrCotizacion
                                    ? formatCurrencyExact(
                                        nrPagoComisionApertura,
                                      )
                                    : "Pendiente"}
                                </strong>
                              </div>
                            </div>

                            <div className="col-6 col-lg-4">
                              <div className="border rounded p-2 h-100">
                                <small className="text-muted d-block">
                                  Seguro anual NR
                                </small>
                                <strong>
                                  {nrCotizacion
                                    ? formatCurrencyExact(
                                        nrSeguroAnual,
                                      )
                                    : "Pendiente"}
                                </strong>
                              </div>
                            </div>

                            <div className="col-12">
                              <div className="border rounded p-2">
                                <small className="text-muted d-block">
                                  Homologación NR
                                </small>
                                <strong>
                                  {[
                                    formData.nr_marca_nombre,
                                    formData.nr_modelo_nombre,
                                    formData.nr_version_nombre,
                                    nrHomologacion?.anio,
                                  ]
                                    .filter(Boolean)
                                    .join(" · ") || "Pendiente"}
                                </strong>
                                <div className="small text-muted mt-1">
                                  Producto:{" "}
                                  {formData.nr_producto_descripcion ||
                                    nrHomologacion?.productoId ||
                                    "Pendiente"}
                                  {" · "}
                                  Plan:{" "}
                                  {formData.nr_plan_nombre ||
                                    (nrHomologacion?.paqueteId
                                      ? `ID ${nrHomologacion.paqueteId}`
                                      : "Pendiente")}
                                </div>
                              </div>
                            </div>

                            {nrHasDownPaymentMismatch && (
                              <div className="col-12">
                                <div className="alert alert-warning py-2 mb-0 small">
                                  NR devolvió un enganche distinto: se enviaron{" "}
                                  <strong>
                                    {formatCurrencyExact(
                                      nrFinancialValues.enganche,
                                    )}
                                  </strong>{" "}
                                  y respondió{" "}
                                  <strong>
                                    {formatCurrencyExact(
                                      nrEngancheReportado,
                                    )}
                                  </strong>
                                  .
                                </div>
                              </div>
                            )}

                            {nrAnzenError && (
                              <div className="col-12">
                                <div className="alert alert-warning py-2 mb-0 small">
                                  <strong>Seguro Anzen no disponible.</strong>{" "}
                                  {nrAnzenError.message}
                                  {nrAnzenError.code
                                    ? ` (${nrAnzenError.code})`
                                    : ""}
                                  . La cotización principal puede continuar con
                                  monto de seguro en $0.
                                </div>
                              </div>
                            )}

                            {nrLastError && (
                              <div className="col-12">
                                <div className="text-danger small">
                                  {nrLastError}
                                </div>
                              </div>
                            )}
                          </div>
                        </div>

                        <div className="card-footer bg-light d-flex flex-wrap gap-2 py-2 nr-toolbar">
                          <button
                            type="button"
                            className="btn btn-primary btn-sm nr-toolbar-btn"
                            onClick={() => handleCotizarConNR()}
                            disabled={nrCotizacionLoading || nrCatalogosLoading}
                          >
                            <i className="fas fa-calculator me-1"></i>
                            {nrCotizacionLoading ? "Cotizando NR..." : "Cotizar NR"}
                          </button>
                          <button
                            type="button"
                            className="btn btn-outline-primary btn-sm nr-toolbar-btn"
                            onClick={() => handleGuardarCotizacionNR()}
                            disabled={
                              nrGuardarLoading ||
                              nrCotizacionLoading ||
                              nrCatalogosLoading
                            }
                          >
                            <i className="fas fa-save me-1"></i>
                            {nrGuardarLoading
                              ? "Guardando NR..."
                              : isNrCurrentQuoteSaved
                                ? "Guardar cambios NR"
                                : "Guardar NR"}
                          </button>
                          <button
                            type="button"
                            className="btn btn-outline-primary btn-sm nr-toolbar-btn"
                            onClick={() => handleGenerarPdfNR()}
                            disabled={nrPdfLoading || nrGuardarLoading}
                          >
                            <i className="fas fa-file-pdf me-1"></i>
                            {nrPdfLoading ? "Generando PDF..." : "Generar PDF NR"}
                          </button>
                          <button
                            type="button"
                            className="btn btn-primary btn-sm nr-toolbar-btn"
                            onClick={handleOpenPdfNR}
                            disabled={!nrPdfDataUrl}
                          >
                            <i className="fas fa-eye me-1"></i>
                            Ver PDF NR
                          </button>
                          <button
                            type="button"
                            className="btn btn-primary btn-sm nr-toolbar-btn"
                            onClick={handleDownloadPdfNR}
                            disabled={!nrPdfDataUrl}
                          >
                            <i className="fas fa-download me-1"></i>
                            Descargar PDF NR
                          </button>
                          {!nrPdfDataUrl && (
                            <small className="text-muted align-self-center">
                              Genera el PDF para poder verlo o descargarlo.
                            </small>
                          )}
                        </div>
                      </div>
                      )}

                      {/* Calculadora de RFC */}
                      <div className="card border-0 shadow-sm mt-3 nr-rfc-card">
                        <div className="card-header py-2 bg-dark text-white d-flex align-items-center gap-2">
                          <i className="fas fa-id-card"></i>
                          <strong>Calculadora de RFC</strong>
                        </div>
                        <div className="card-body py-3">
                          <div className="row g-2 mb-3">
                            <div className="col-12 col-md-4">
                              <label className="form-label label-custom small mb-1">
                                Nombre(s)
                              </label>
                              <input
                                type="text"
                                name="nombre"
                                className="form-control form-control-sm"
                                value={formData.nombre || ""}
                                onChange={handleInputChange}
                              />
                            </div>
                            <div className="col-6 col-md-4">
                              <label className="form-label label-custom small mb-1">
                                Apellido paterno
                              </label>
                              <input
                                type="text"
                                name="apellido_paterno"
                                className="form-control form-control-sm"
                                value={formData.apellido_paterno || ""}
                                onChange={handleInputChange}
                              />
                            </div>
                            <div className="col-6 col-md-4">
                              <label className="form-label label-custom small mb-1">
                                Apellido materno
                              </label>
                              <input
                                type="text"
                                name="apellido_materno"
                                className="form-control form-control-sm"
                                value={formData.apellido_materno || ""}
                                onChange={handleInputChange}
                              />
                            </div>
                          </div>
                          <div className="row g-2 align-items-end">
                            <div className="col-6 col-md-4">
                              <label className="form-label label-custom small mb-1">
                                Fecha de nacimiento
                              </label>
                              <input
                                type="date"
                                name="fecha_nacimiento"
                                className="form-control form-control-sm"
                                value={formData.fecha_nacimiento || ""}
                                onChange={handleInputChange}
                              />
                            </div>
                            <div className="col-6 col-md-4">
                              <label className="form-label label-custom small mb-1">
                                Correo
                              </label>
                              <input
                                type="email"
                                className="form-control form-control-sm bg-light"
                                value={formData.correo_electronico || ""}
                                readOnly
                              />
                            </div>
                            <div className="col-12 col-md-4">
                              <button
                                type="button"
                                className="btn btn-dark btn-sm w-100"
                                onClick={handleCalcularRfc}
                              >
                                <i className="fas fa-calculator me-1"></i>
                                Calcular RFC
                              </button>
                            </div>
                            <div className="col-6 col-md-4">
                              <label className="form-label label-custom small mb-1">
                                RFC
                              </label>
                              <input
                                type="text"
                                name="rfc"
                                className="form-control form-control-sm text-uppercase"
                                value={formData.rfc || ""}
                                onChange={handleInputChange}
                                maxLength={10}
                              />
                            </div>
                            <div className="col-6 col-md-4">
                              <label className="form-label label-custom small mb-1">
                                Homoclave
                              </label>
                              <input
                                type="text"
                                name="homoclave"
                                className="form-control form-control-sm text-uppercase"
                                value={formData.homoclave || ""}
                                onChange={handleInputChange}
                                maxLength={3}
                              />
                            </div>
                            <div className="col-12 col-md-4">
                              <label className="form-label label-custom small mb-1">
                                RFC completo
                              </label>
                              <input
                                type="text"
                                className="form-control form-control-sm bg-light"
                                value={`${formData.rfc || ""}${formData.homoclave || ""}`}
                                readOnly
                              />
                            </div>
                            <div className="col-12">
                              <small className="text-muted d-block mt-1">
                                El RFC y la homoclave se calculan con un
                                algoritmo estándar; también puedes editarlos
                                a mano si el cliente ya trae su RFC real.
                                Verifícalos contra el SAT o su
                                identificación antes de usarlos en un
                                trámite oficial.
                              </small>
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* Nota informativa */}
                      {agenciaUsaCotizadorNR && (
                      <div className="col-12 mt-3">
                        <div className="info-box">
                          <i className="fas fa-info-circle me-2"></i>
                          <span>
                            Revisa la pre mensualidad de Babilonia y usa Cotizar NR
                            para obtener la mensualidad oficial.
                          </span>
                        </div>
                      </div>
                      )}
                    </div>

                    {/* Columna derecha: Inputs */}
                    <div className="col-md-6 ps-3">
                      <h5>
                        Datos de Financiamiento
                        <i className="fas fa-credit-card fa-lg fa-fw ms-2 icon-cot"></i>
                      </h5>
                      <form>
                        <div className="mb-3">
                          <label className="form-label label-custom">
                            Mensualidad
                          </label>
                          <input
                            type="text"
                            inputMode="decimal" // Permite el punto decimal
                            pattern="[0-9,.$]*"
                            className="form-control"
                            placeholder="$ 0.00"
                            value={modalMensualidadInput}
                            onFocus={() => {
                              isEditingFinancingModalRef.current = true;
                            }}
                            onChange={handleMensualidadChangeC}
                          />
                        </div>
                        <div className="mb-3">
                          <label className="form-label label-custom">
                            Meses de Financiamiento:
                          </label>
                          <select
                            className="form-control custom-select new-font"
                            value={modalFinancingMonthsSelectValue}
                            onChange={handleFinancingMonthsChangeC}
                          >
                            {modalMonthsOptions.map((m) => (
                              <option key={m} value={m}>
                                {m} meses
                              </option>
                            ))}
                          </select>
                        </div>
                        {formData.pago_contado !== "Si" && ( //si es contado no muestra enganche
                          <>
                            <div className="mb-3">
                              <label className="form-label label-custom">
                                Enganche
                              </label>
                              <input
                                type="text"
                                inputMode="decimal" // Permite el punto decimal
                                pattern="[0-9,.$]*"
                                className="form-control"
                                placeholder="$ 0.00"
                                value={modalEngancheInput}
                                onFocus={() => {
                                  isEditingFinancingModalRef.current = true;
                                }}
                                onChange={handleEngancheChangeC} //este es para último modal
                                onBlur={handleEngancheBlurC}
                              />
                              {validationMessageC && (
                                <small className="text-danger">
                                  {validationMessageC}
                                </small>
                              )}
                            </div>
                            <div className="mb-3">
                              <label className="form-label label-custom">
                                Tasa (%)
                              </label>
                              <div className="input-with-symbol">
                                <input
                                  type="text"
                                  step="0.01"
                                  className="form-control"
                                  value={modalTasaInput}
                                  onFocus={() => {
                                    isEditingFinancingModalRef.current = true;
                                  }}
                                  onChange={handleTasaChangeC}
                                />
                                <span className="input-symbol">%</span>
                              </div>
                            </div>
                          </>
                        )}
                        <div className="mb-3">
                          <label className="form-label label-custom">
                            Tipo de compra del seguro
                          </label>
                          <select
                            className="form-select"
                            value={tipoCompraSeguro || ""}
                            onChange={handleTipoCompraSeguroChange}
                          >
                            <option value="">Seleccione</option>
                            <option value="Contado">Contado</option>
                            <option value="Financiado">Financiado</option>
                          </select>
                        </div>

                        <div className="mb-3">
                          <label className="form-label label-custom">
                            Monto del seguro
                          </label>
                          <input
                            type="text"
                            inputMode="decimal"
                            pattern="[0-9,.$]*"
                            placeholder="$ 0.00"
                            className="form-control"
                            value={montoSeguroDisplay}
                            onChange={handleMontoSeguroChangeC}
                            onFocus={() => {
                              isEditingMontoSeguroRef.current = true;
                            }}
                            onBlur={() => {
                              isEditingMontoSeguroRef.current = false;
                            }}
                          />
                        </div>
                        {agenciaUsaCotizadorNR && (
                        <div className="mb-3">
                          <div className="border rounded p-3 bg-light border-primary-subtle nr-seguro-box">
                            <div className="d-flex justify-content-between align-items-center flex-wrap gap-2 mb-3">
                              <div>
                                <h6 className="mb-0">
                                  <i className="fas fa-shield-alt me-2 text-primary"></i>
                                  Seguro y comisión Procotiza NR
                                </h6>
                                <small className="text-muted">
                                  Los valores se toman de la selección real y
                                  de los catálogos oficiales de NR.
                                </small>
                                {!formData.nr_anzen_id && (
                                  <small className="text-warning d-block mt-1">
                                    Falta configurar el AnzenId real; no se
                                    consultarán municipios ni seguros Anzen.
                                  </small>
                                )}
                              </div>

                              <button
                                type="button"
                                className="btn btn-sm btn-outline-primary"
                                onClick={() =>
                                  handleConsultarSegurosAnzenNR({
                                    silent: false,
                                  })
                                }
                                disabled={
                                  nrAnzenLoading ||
                                  !formData.nr_estado_id ||
                                  !formData.nr_municipio_id
                                }
                              >
                                {nrAnzenLoading
                                  ? "Consultando seguro..."
                                  : "Actualizar seguro Anzen"}
                              </button>
                            </div>

                            <div className="row g-3">
                              <div className="col-md-12">
                                <label className="form-label label-custom">
                                  Tipo de seguro
                                </label>
                                <select
                                  name="nr_tipo_seguro_id"
                                  className="form-select"
                                  value={formData.nr_tipo_seguro_id || ""}
                                  onChange={handleNrSimpleInputChange}
                                >
                                  <option value="">
                                    Seleccione tipo de seguro
                                  </option>
                                  {(Array.isArray(nrCatalogos.tiposSeguro)
                                    ? nrCatalogos.tiposSeguro
                                    : []
                                  ).map((item) => (
                                    <option
                                      key={`nr-tipo-seguro-${item.id}`}
                                      value={item.id}
                                    >
                                      {item.nombre}
                                    </option>
                                  ))}
                                </select>
                              </div>

                              <div className="col-md-6">
                                <label className="form-label label-custom">
                                  Seguro de vida
                                </label>
                                <select
                                  name="nr_seguro_vida_id"
                                  className="form-select"
                                  value={formData.nr_seguro_vida_id || ""}
                                  onChange={handleNrSimpleInputChange}
                                >
                                  <option value="">
                                    Seleccione seguro de vida
                                  </option>
                                  {(Array.isArray(nrCatalogos.segurosVida)
                                    ? nrCatalogos.segurosVida
                                    : []
                                  ).map((item) => (
                                    <option
                                      key={`nr-seguro-vida-${item.id}`}
                                      value={item.id}
                                    >
                                      {item.tipoSeguroVida}
                                    </option>
                                  ))}
                                </select>
                              </div>

                              <div className="col-md-6">
                                <label className="form-label label-custom">
                                  Aseguradora
                                </label>
                                <select
                                  name="nr_aseguradora_id"
                                  className="form-select"
                                  value={formData.nr_aseguradora_id}
                                  onChange={handleNrSimpleInputChange}
                                  disabled={!nrAseguradorasOptions.length}
                                >
                                  <option value="">
                                    {nrAseguradorasOptions.length
                                      ? "Seleccione aseguradora"
                                      : "Pendiente de catálogo NR"}
                                  </option>
                                  {nrAseguradorasOptions.map((item) => (
                                    <option
                                      key={`nr-aseguradora-${item.InsuranceId}`}
                                      value={item.InsuranceId}
                                    >
                                      {item.Description}
                                    </option>
                                  ))}
                                </select>
                              </div>

                              <div className="col-md-6">
                                <label className="form-label label-custom">
                                  Cobertura
                                </label>
                                <select
                                  name="nr_cobertura_id"
                                  className="form-select"
                                  value={formData.nr_cobertura_id}
                                  onChange={handleNrSimpleInputChange}
                                  disabled={!nrCoberturasOptions.length}
                                >
                                  <option value="">
                                    {nrCoberturasOptions.length
                                      ? "Seleccione cobertura"
                                      : "Pendiente de catálogo NR"}
                                  </option>
                                  {nrCoberturasOptions.map((item) => (
                                    <option
                                      key={`nr-cobertura-${item.TypeOfCoverageId}`}
                                      value={item.TypeOfCoverageId}
                                    >
                                      {item.Description}
                                    </option>
                                  ))}
                                </select>
                              </div>

                              <div className="col-md-6">
                                <label className="form-label label-custom">
                                  Uso NR
                                </label>
                                <select
                                  name="nr_uso_id"
                                  className="form-select"
                                  value={formData.nr_uso_id || ""}
                                  onChange={handleNrSimpleInputChange}
                                  disabled={!nrUsosOptions.length}
                                >
                                  <option value="">
                                    {nrUsosOptions.length
                                      ? "Seleccione uso"
                                      : "Pendiente de catálogo NR"}
                                  </option>
                                  {nrUsosOptions.map((item) => (
                                    <option
                                      key={`nr-uso-${item.TypeOfUsesId}`}
                                      value={item.TypeOfUsesId}
                                    >
                                      {item.Description}
                                    </option>
                                  ))}
                                </select>
                              </div>

                              <div className="col-md-6">
                                <label className="form-label label-custom">
                                  Nivel UDI
                                </label>
                                <select
                                  name="nr_udi_id"
                                  className="form-select"
                                  value={formData.nr_udi_id || ""}
                                  onChange={handleNrSimpleInputChange}
                                  disabled={!nrUdiOptions.length}
                                >
                                  <option value="">
                                    {nrUdiOptions.length
                                      ? "Seleccione nivel UDI"
                                      : "Pendiente de catálogo NR"}
                                  </option>
                                  {nrUdiOptions.map((item) => (
                                    <option
                                      key={`nr-udi-${item.UdiLevelId}`}
                                      value={item.UdiLevelId}
                                    >
                                      {item.Description}
                                    </option>
                                  ))}
                                </select>
                              </div>

                              <div className="col-md-6">
                                <label className="form-label label-custom">
                                  Cotización de seguro Anzen
                                </label>
                                <select
                                  className="form-select"
                                  value={
                                    formData.nr_seguro_anzen_key || ""
                                  }
                                  onChange={
                                    handleNrInsuranceOptionChange
                                  }
                                  disabled={
                                    nrAnzenLoading ||
                                    !nrInsuranceOptions.length
                                  }
                                >
                                  <option value="">
                                    {nrAnzenLoading
                                      ? "Consultando opciones..."
                                      : nrInsuranceOptions.length
                                        ? "Seleccione una opción"
                                        : "Sin opción validada por Anzen"}
                                  </option>
                                  {nrInsuranceOptions.map(
                                    (item, index) => (
                                      <option
                                        key={`nr-anzen-${item.__key}-${index}`}
                                        value={item.__key}
                                      >
                                        {item.__label}
                                      </option>
                                    ),
                                  )}
                                </select>
                              </div>

                              <div className="col-md-6">
                                <label className="form-label label-custom">
                                  Monto del seguro (Anzen)
                                </label>
                                <input
                                  type="text"
                                  className="form-control"
                                  value={formatCurrencyExact(
                                    toNumber(
                                      nrSelectedInsurance?.__totalAmount ??
                                        formData.nr_seguro_anzen_total_amount,
                                    ),
                                  )}
                                  readOnly
                                />
                                <small className="text-muted">
                                  Calculado por Anzen; independiente del
                                  "Monto del seguro" manual de arriba.
                                </small>
                              </div>

                              <div className="col-md-6">
                                <label className="form-label label-custom">
                                  Comisión de apertura NR
                                </label>
                                <input
                                  type="text"
                                  className="form-control"
                                  value={
                                    nrCotizacion
                                      ? formatCurrencyExact(
                                          nrMontoComisionApertura,
                                        )
                                      : "Pendiente de cotizar"
                                  }
                                  readOnly
                                />
                              </div>
                            </div>

                            {nrAnzenError && (
                              <div className="alert alert-warning py-2 px-3 mt-3 mb-0 small">
                                <strong>
                                  No fue posible validar el seguro con Anzen.
                                </strong>{" "}
                                {nrAnzenError.message}
                                {nrAnzenError.code
                                  ? ` (${nrAnzenError.code})`
                                  : ""}
                                . La cotización NR puede continuar con monto de
                                seguro en $0 o con captura manual.
                              </div>
                            )}

                            {!nrAnzenError &&
                              formData.nr_estado_id &&
                              !formData.nr_municipio_id && (
                                <div className="alert alert-info py-2 px-3 mt-3 mb-0 small">
                                  Selecciona el municipio para consultar las
                                  opciones de seguro.
                                </div>
                              )}
                          </div>
                        </div>
                        )}

                        <div className="mb-3">
                          <label className="form-label label-custom">
                            ¿Incluir Placas?
                          </label>
                          <select
                            className="form-select"
                            value={incluyePlacas}
                            onChange={handlePlacasChange}
                          >
                            <option value="" disabled>
                              Selecciona una opción
                            </option>
                            <option value="No">No</option>
                            <option value="Si">Sí</option>
                          </select>
                          {incluyePlacas === "Si" && (
                            <div className="mb-3">
                              <label className="form-label label-custom">
                                Monto de placas
                              </label>

                              <input
                                type="text"
                                inputMode="decimal"
                                className="form-control"
                                placeholder="$ 0.00"
                                value={formatInputCurrency(montoPlacas)}
                                onChange={(e) => {
                                  let rawValue = e.target.value.replace(
                                    /[$,]/g,
                                    "",
                                  );

                                  rawValue = rawValue.replace(/[^0-9.]/g, "");

                                  const parts = rawValue.split(".");

                                  if (parts.length > 2) return;

                                  setMontoPlacas(rawValue);
                                }}
                              />
                            </div>
                          )}
                        </div>

                        <div className="mb-3">
                          <label className="form-label label-custom">
                            Ventas Adicionales Contado
                          </label>
                          <div className="row g-2 align-items-center">
                            <div className="col-7">
                              <div className="input-group">
                                <input
                                  type="text"
                                  className="form-control"
                                  value={montoAdicionalesDisplay}
                                  placeholder="$ 0.00"
                                  readOnly
                                />
                              </div>
                            </div>
                            <div className="col-5">
                              <button
                                className="btn btn-primary w-100 text-truncate"
                                type="button"
                                onClick={handleAbrirModalAdicionales}
                              >
                                Seleccionar
                              </button>
                            </div>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>

                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-secondary"
                    data-bs-dismiss="modal"
                    onClick={async () => {
                      await handleGuardarDatosFinancieros();
                      handleShowModal();
                    }}
                  >
                    Guardar
                  </button>
                  <input
                    type="file"
                    id="pdfSaboneAdjunto"
                    accept="application/pdf"
                    style={{ display: "none" }}
                    onChange={async (e) => {
                      const file = e.target.files?.[0];
                      if (!file) return;

                      if (file.type !== "application/pdf") {
                        e.target.value = "";
                        return;
                      }

                      setPdfAdjunto(file);

                      // Proceso silencioso
                      await subirPdfAdjuntoABD(file);
                    }}
                  />

                  <button
                    type="button"
                    className="btn btn-outline-dark"
                    onClick={() =>
                      document.getElementById("pdfSaboneAdjunto")?.click()
                    }
                  >
                    {pdfAdjunto ? "Cambiar PDF manual" : "Adjuntar PDF manual"}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {showNrPdfViewer && nrPdfDataUrl && (
        <div
          className="modal fade show d-block"
          tabIndex="-1"
          role="dialog"
          aria-modal="true"
          style={{
            zIndex: 1090,
            backgroundColor: "rgba(15, 23, 42, 0.78)",
            backdropFilter: "blur(4px)",
          }}
          onMouseDown={(event) => {
            if (event.target === event.currentTarget) {
              setShowNrPdfViewer(false);
            }
          }}
        >
          <div
            className="modal-dialog modal-xl modal-dialog-centered"
            style={{ maxWidth: "1180px", height: "92vh" }}
          >
            <div
              className="modal-content border-0 shadow-lg overflow-hidden"
              style={{ height: "100%", borderRadius: "18px" }}
            >
              <div className="modal-header py-2 px-3">
                <div>
                  <small className="text-primary fw-bold">
                    DOCUMENTO NR
                  </small>
                  <h5 className="modal-title mb-0">
                    Cotización{" "}
                    {nrCotizacionGuardadaId
                      ? `#${nrCotizacionGuardadaId}`
                      : ""}
                  </h5>
                </div>

                <div className="d-flex align-items-center gap-2 ms-auto flex-wrap">
                  <a
                    href={nrPdfDataUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="btn btn-sm btn-outline-primary"
                  >
                    Abrir en pestaña
                  </a>
                  <button
                    type="button"
                    className="btn btn-sm btn-outline-success"
                    onClick={handleDownloadPdfNR}
                  >
                    Descargar
                  </button>
                  <button
                    type="button"
                    className="btn btn-sm btn-primary"
                    onClick={() => setShowNrPdfViewer(false)}
                  >
                    Cerrar
                  </button>
                </div>
              </div>

              <div
                className="modal-body p-0"
                style={{ minHeight: 0, background: "#2b2b2b" }}
              >
                <iframe
                  src={`${nrPdfDataUrl}#toolbar=1&navpanes=1&scrollbar=1`}
                  title={`Cotización NR ${nrCotizacionGuardadaId || ""}`}
                  style={{
                    width: "100%",
                    height: "100%",
                    minHeight: "calc(92vh - 64px)",
                    border: 0,
                    display: "block",
                    background: "#2b2b2b",
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      )}

      {showNrProductModal && (
        <>
          <div
            className="modal fade show d-block"
            tabIndex="-1"
            role="dialog"
            style={{
              zIndex: 1080,
              backgroundColor: "rgba(0,0,0,0.45)",
              backdropFilter: "blur(4px)",
            }}
          >
            <div className="modal-dialog modal-dialog-centered modal-lg">
              <div className="modal-content border-0 shadow-lg">
                <div className="modal-header bg-primary text-white">
                  <div>
                    <h5 className="modal-title mb-0">
                      Seleccionar producto NR
                    </h5>
                    <small>
                      No se encontró una coincidencia única. Selecciona el
                      producto correcto para continuar con Procotiza.
                    </small>
                  </div>
                  <button
                    type="button"
                    className="btn-close btn-close-white"
                    onClick={() => setShowNrProductModal(false)}
                  />
                </div>
                <div className="modal-body">
                  {nrProductCandidates.length ? (
                    <div className="list-group">
                      {nrProductCandidates.map((producto, index) => {
                        const id = Number(producto?.idProducto || 0);
                        const title =
                          String(producto?.descripcion || "").trim() ||
                          `Producto ${id || index + 1}`;
                        const subtitle = [
                          producto?.descripcionMarca,
                          producto?.descripcionSubmarca,
                          producto?.descripcionVersion,
                          producto?.anioCatalogo,
                        ]
                          .filter(Boolean)
                          .join(" · ");

                        return (
                          <button
                            key={`nr-producto-candidato-${id}-${index}`}
                            type="button"
                            className="list-group-item list-group-item-action"
                            onClick={() => handleSelectNrProductCandidate(producto)}
                          >
                            <div className="d-flex justify-content-between gap-2">
                              <strong>{title}</strong>
                              <span className="badge bg-primary">ID {id}</span>
                            </div>
                            {subtitle && (
                              <small className="text-muted">{subtitle}</small>
                            )}
                          </button>
                        );
                      })}
                    </div>
                  ) : (
                    <div className="alert alert-warning mb-0">
                      No hay productos candidatos para mostrar.
                    </div>
                  )}
                </div>
                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={() => setShowNrProductModal(false)}
                  >
                    Cerrar
                  </button>
                </div>
              </div>
            </div>
          </div>
        </>
      )}

      {showModalAdicionales && (
        <>
          <div
            className="modal fade show d-block"
            tabIndex="-1"
            role="dialog"
            style={{
              zIndex: 1070,
              backgroundColor: "rgba(0,0,0,0.45)",
              backdropFilter: "blur(4px)",
            }}
          >
            <div className="modal-dialog modal-dialog-centered modal-addons-dialog">
              <div
                className="modal-content border-0 shadow-lg overflow-hidden"
                style={{ borderRadius: "24px" }}
              >
                {/* HEADER */}
                <div className="modal-header border-0 px-4 pt-4 pb-2 bg-white">
                  <div>
                    <h4 className="fw-bold mb-1">Ventas Adicionales</h4>
                    <p
                      className="mb-0 text-primary"
                      style={{ fontSize: "14px" }}
                    >
                      Elige accesorios de contado. Los que ya están incluidos en
                      el paquete seleccionado se ocultan automáticamente.
                    </p>
                  </div>

                  <button
                    type="button"
                    className="btn-close"
                    onClick={() => setShowModalAdicionales(false)}
                  ></button>
                </div>

                {/* CHIPS */}
                {adicionalesContado.length > 0 && (
                  <div className="px-4 pb-3 bg-white">
                    <div className="d-flex flex-wrap gap-2">
                      {adicionalesContado.map((item, idx) => (
                        <div className="selected-chip" key={idx}>
                          <span>{formatTitle(item.title)}</span>

                          <button
                            onClick={() =>
                              setAdicionalesContado((prev) =>
                                prev.filter((acc) => acc.title !== item.title),
                              )
                            }
                          >
                            ✕
                          </button>
                        </div>
                      ))}
                    </div>
                  </div>
                )}

                {/* BODY */}
                <div className="modal-body modal-addons p-4">
                  <div
                    className="d-flex flex-wrap justify-content-start gap-3 custom-scroll"
                    style={{
                      maxHeight: "58vh",
                      overflowY: "auto",
                      paddingRight: "6px",
                    }}
                  >
                    {accesoriosContadoDisponibles.length === 0 ? (
                      <div className="w-100 text-center text-muted py-5">
                        <div className="fw-bold mb-1">
                          No hay adicionales disponibles
                        </div>
                        <div style={{ fontSize: "13px" }}>
                          Los accesorios y garantías disponibles ya están
                          incluidos en el plan seleccionado.
                        </div>
                      </div>
                    ) : (
                      accesoriosContadoDisponibles.map((item, index) => {
                        const isSelected = adicionalesContado.some(
                          (acc) => acc.title === item.title,
                        );

                        return (
                          <div
                            key={`${item.title}-${index}`}
                            className={`rounded-4 card-accesorio ${
                              isSelected ? "card-selected" : ""
                            }`}
                            onClick={() => {
                              if (isSelected) {
                                setAdicionalesContado((prev) =>
                                  prev.filter(
                                    (acc) => acc.title !== item.title,
                                  ),
                                );
                              } else {
                                setAdicionalesContado((prev) => [
                                  ...prev,
                                  item,
                                ]);
                              }
                            }}
                          >
                            {isSelected && (
                              <div className="badge-selected">✓</div>
                            )}

                            {/* IMAGE */}
                            <div className="accesorio-image">
                              {item.image ? (
                                <img
                                  src={item.image}
                                  alt={formatTitle(item.title)}
                                />
                              ) : (
                                <div className="placeholder-icon">🛠️</div>
                              )}
                            </div>

                            {/* CONTENT */}
                            <div className="p-3 d-flex flex-column flex-grow-1">
                              <span
                                className="text-uppercase fw-bold"
                                style={{
                                  fontSize: "10px",
                                  letterSpacing: "1px",
                                }}
                              >
                                Accesorio
                              </span>

                              <h6
                                className="fw-bold mt-2 mb-3"
                                style={{
                                  fontSize: "14px",
                                  lineHeight: "1.4",
                                  minHeight: "42px",
                                }}
                              >
                                {formatTitle(item.title)}
                              </h6>

                              <div className="card-footer-price d-flex align-items-center justify-content-between">
                                <div>
                                  <span
                                    className="fw-bold text-primary"
                                    style={{ fontSize: "24px" }}
                                  >
                                    {formatCurrency(item.price || 0)}
                                  </span>
                                </div>

                                <div
                                  className={`btn-add-custom ${
                                    isSelected ? "selected" : ""
                                  }`}
                                >
                                  {isSelected ? "✕" : "+"}
                                </div>
                              </div>
                            </div>
                          </div>
                        );
                      })
                    )}
                  </div>
                </div>

                {/* FOOTER */}
                <div className="modal-footer border-0 bg-white px-4 py-3">
                  <div className="d-flex w-100 justify-content-between align-items-center">
                    <div>
                      <div
                        className="text-primary"
                        style={{ fontSize: "13px" }}
                      >
                        Total seleccionado:
                      </div>

                      <div className="fw-bold text-dark fs-3">
                        {formatCurrency(
                          adicionalesContado.reduce(
                            (acc, item) => acc + Number(item.price || 0),
                            0,
                          ),
                        )}
                      </div>
                    </div>

                    <div className="d-flex gap-2">
                      <button
                        className="btn btn-light px-4 py-2"
                        onClick={() => setShowModalAdicionales(false)}
                      >
                        Cancelar
                      </button>

                      <button
                        className="btn btn-primary px-4 py-2 fw-bold"
                        style={{
                          backgroundColor: "#003366",
                          borderColor: "#003366",
                          borderRadius: "12px",
                        }}
                        onClick={() => {
                          const total = adicionalesContado.reduce(
                            (acc, item) => acc + Number(item.price || 0),
                            0,
                          );

                          setMontoAdicionales(total);
                          setMontoAdicionalesDisplay(
                            formatInputCurrency(total),
                          );

                          setShowModalAdicionales(false);
                        }}
                      >
                        Confirmar
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
}

export default CreateVenta;
